import * as we from "react";
import M, { createContext as Vt, useContext as Ht, createElement as Uy, isValidElement as Vy, PureComponent as wi, Component as da, useState as $e, useEffect as xe, forwardRef as hr, useMemo as gt, useCallback as oe, useRef as de, useReducer as qy, useLayoutEffect as rv, memo as Gy } from "react";
import { useEditor as Le, useNode as me, Element as Wr, ROOT_NODE as Yy, Editor as Ky } from "@craftjs/core";
import { WppTypography as _e, WppSelect as Ns, WppListItem as ra, WppTextareaInput as Xy, WppInput as yu, WppSlider as Zy, WppRadioGroup as Jy, WppCheckbox as ii, WppTooltip as Gr, WppIconMove as Qy, WppIconArrow as nv, WppIconRemoveCircle as bu, WppIconCopy as eb, WppModal as tb, WppIconApp as rb, WppFullScreenModal as nb, WppActionButton as Dr, WppIconCross as ab, WppSpinner as av, WppCardGroup as iv, WppCard as ps, WppButton as si, WppIconForward as Df, WppDivider as We, WppIconEyeOn as ib, WppIconEyeOff as sb, WppFileUpload as ob, WppIconImage as sv, WppIconClose as ov, WppPopover as lv, WppSegmentedControl as wu, WppSegmentedControlItem as oi, WppToggle as lb, WppIconLink as xu, WppSkeleton as xi, WppIconText as uv, WppIconUser as ub, WppIconError as cb, WppIconRemove as fb, WppIconWrapOn as db, WppIconOrderedList as pb, WppIconUnorderedList as hb, WppIconTextAlignmentLeft as gb, WppIconTextAlignmentCenter as vb, WppIconTextAlignmentRight as mb, WppIconTextAlignmentJustify as yb, WppIconButton as ji, WppIconAddCircle as cv, WppIconChevron as Sf, WppIconNavigationMenu as Eu, WppTabs as bb, WppTab as wb, WppAccordion as xb, WppIconVideoClip as Eb, WppIconCodeView as fv, WppIconAdd as Cb, WppIconGallery as Db } from "@platform-ui-kit/components-library-react";
import { useTranslation as Sb } from "react-i18next";
import { useSetState as dv, useEvent as li, usePrevious as Rl, useEffectOnce as Ob } from "react-use";
import ee from "prop-types";
import ke, { clsx as Pb } from "clsx";
import { getRandomId as _b, ROOT_NODE as Ab } from "@craftjs/utils";
import pv from "axios";
import Tb, { createPortal as Bb, flushSync as Rb } from "react-dom";
import { mergeRefs as Cu } from "react-merge-refs";
import { z as $b } from "zod";
import { useFormContext as Mb, useController as Fb, appendErrors as Ib, useForm as jb, FormProvider as Lb } from "react-hook-form";
import { validateFieldsNatively as kb, toNestErrors as Nb } from "@hookform/resolvers";
var tt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ei(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function zb(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), r;
}
var $l = { exports: {} }, _a = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Of;
function Wb() {
  if (Of)
    return _a;
  Of = 1;
  var t = M, e = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, o, u) {
    var c, f = {}, p = null, g = null;
    u !== void 0 && (p = "" + u), o.key !== void 0 && (p = "" + o.key), o.ref !== void 0 && (g = o.ref);
    for (c in o)
      n.call(o, c) && !i.hasOwnProperty(c) && (f[c] = o[c]);
    if (l && l.defaultProps)
      for (c in o = l.defaultProps, o)
        f[c] === void 0 && (f[c] = o[c]);
    return { $$typeof: e, type: l, key: p, ref: g, props: f, _owner: a.current };
  }
  return _a.Fragment = r, _a.jsx = s, _a.jsxs = s, _a;
}
var Aa = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pf;
function Hb() {
  return Pf || (Pf = 1, process.env.NODE_ENV !== "production" && function() {
    var t = M, e = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), o = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), m = Symbol.iterator, d = "@@iterator";
    function w(z) {
      if (z === null || typeof z != "object")
        return null;
      var J = m && z[m] || z[d];
      return typeof J == "function" ? J : null;
    }
    var b = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function O(z) {
      {
        for (var J = arguments.length, ne = new Array(J > 1 ? J - 1 : 0), he = 1; he < J; he++)
          ne[he - 1] = arguments[he];
        S("error", z, ne);
      }
    }
    function S(z, J, ne) {
      {
        var he = b.ReactDebugCurrentFrame, Fe = he.getStackAddendum();
        Fe !== "" && (J += "%s", ne = ne.concat([Fe]));
        var ze = ne.map(function(Te) {
          return String(Te);
        });
        ze.unshift("Warning: " + J), Function.prototype.apply.call(console[z], console, ze);
      }
    }
    var B = !1, T = !1, A = !1, D = !1, h = !1, y;
    y = Symbol.for("react.module.reference");
    function v(z) {
      return !!(typeof z == "string" || typeof z == "function" || z === n || z === i || h || z === a || z === u || z === c || D || z === g || B || T || A || typeof z == "object" && z !== null && (z.$$typeof === p || z.$$typeof === f || z.$$typeof === s || z.$$typeof === l || z.$$typeof === o || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      z.$$typeof === y || z.getModuleId !== void 0));
    }
    function E(z, J, ne) {
      var he = z.displayName;
      if (he)
        return he;
      var Fe = J.displayName || J.name || "";
      return Fe !== "" ? ne + "(" + Fe + ")" : ne;
    }
    function _(z) {
      return z.displayName || "Context";
    }
    function C(z) {
      if (z == null)
        return null;
      if (typeof z.tag == "number" && O("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof z == "function")
        return z.displayName || z.name || null;
      if (typeof z == "string")
        return z;
      switch (z) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case u:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof z == "object")
        switch (z.$$typeof) {
          case l:
            var J = z;
            return _(J) + ".Consumer";
          case s:
            var ne = z;
            return _(ne._context) + ".Provider";
          case o:
            return E(z, z.render, "ForwardRef");
          case f:
            var he = z.displayName || null;
            return he !== null ? he : C(z.type) || "Memo";
          case p: {
            var Fe = z, ze = Fe._payload, Te = Fe._init;
            try {
              return C(Te(ze));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var P = Object.assign, $ = 0, W, j, I, F, k, N, U;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function L() {
      {
        if ($ === 0) {
          W = console.log, j = console.info, I = console.warn, F = console.error, k = console.group, N = console.groupCollapsed, U = console.groupEnd;
          var z = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: z,
            log: z,
            warn: z,
            error: z,
            group: z,
            groupCollapsed: z,
            groupEnd: z
          });
        }
        $++;
      }
    }
    function q() {
      {
        if ($--, $ === 0) {
          var z = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: P({}, z, {
              value: W
            }),
            info: P({}, z, {
              value: j
            }),
            warn: P({}, z, {
              value: I
            }),
            error: P({}, z, {
              value: F
            }),
            group: P({}, z, {
              value: k
            }),
            groupCollapsed: P({}, z, {
              value: N
            }),
            groupEnd: P({}, z, {
              value: U
            })
          });
        }
        $ < 0 && O("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var V = b.ReactCurrentDispatcher, X;
    function te(z, J, ne) {
      {
        if (X === void 0)
          try {
            throw Error();
          } catch (Fe) {
            var he = Fe.stack.trim().match(/\n( *(at )?)/);
            X = he && he[1] || "";
          }
        return `
` + X + z;
      }
    }
    var re = !1, ue;
    {
      var pe = typeof WeakMap == "function" ? WeakMap : Map;
      ue = new pe();
    }
    function ye(z, J) {
      if (!z || re)
        return "";
      {
        var ne = ue.get(z);
        if (ne !== void 0)
          return ne;
      }
      var he;
      re = !0;
      var Fe = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ze;
      ze = V.current, V.current = null, L();
      try {
        if (J) {
          var Te = function() {
            throw Error();
          };
          if (Object.defineProperty(Te.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Te, []);
            } catch (vr) {
              he = vr;
            }
            Reflect.construct(z, [], Te);
          } else {
            try {
              Te.call();
            } catch (vr) {
              he = vr;
            }
            z.call(Te.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (vr) {
            he = vr;
          }
          z();
        }
      } catch (vr) {
        if (vr && he && typeof vr.stack == "string") {
          for (var De = vr.stack.split(`
`), mt = he.stack.split(`
`), et = De.length - 1, rt = mt.length - 1; et >= 1 && rt >= 0 && De[et] !== mt[rt]; )
            rt--;
          for (; et >= 1 && rt >= 0; et--, rt--)
            if (De[et] !== mt[rt]) {
              if (et !== 1 || rt !== 1)
                do
                  if (et--, rt--, rt < 0 || De[et] !== mt[rt]) {
                    var jt = `
` + De[et].replace(" at new ", " at ");
                    return z.displayName && jt.includes("<anonymous>") && (jt = jt.replace("<anonymous>", z.displayName)), typeof z == "function" && ue.set(z, jt), jt;
                  }
                while (et >= 1 && rt >= 0);
              break;
            }
        }
      } finally {
        re = !1, V.current = ze, q(), Error.prepareStackTrace = Fe;
      }
      var Pn = z ? z.displayName || z.name : "", Cf = Pn ? te(Pn) : "";
      return typeof z == "function" && ue.set(z, Cf), Cf;
    }
    function Ce(z, J, ne) {
      return ye(z, !1);
    }
    function be(z) {
      var J = z.prototype;
      return !!(J && J.isReactComponent);
    }
    function Ie(z, J, ne) {
      if (z == null)
        return "";
      if (typeof z == "function")
        return ye(z, be(z));
      if (typeof z == "string")
        return te(z);
      switch (z) {
        case u:
          return te("Suspense");
        case c:
          return te("SuspenseList");
      }
      if (typeof z == "object")
        switch (z.$$typeof) {
          case o:
            return Ce(z.render);
          case f:
            return Ie(z.type, J, ne);
          case p: {
            var he = z, Fe = he._payload, ze = he._init;
            try {
              return Ie(ze(Fe), J, ne);
            } catch {
            }
          }
        }
      return "";
    }
    var Me = Object.prototype.hasOwnProperty, Ae = {}, Be = b.ReactDebugCurrentFrame;
    function Ke(z) {
      if (z) {
        var J = z._owner, ne = Ie(z.type, z._source, J ? J.type : null);
        Be.setExtraStackFrame(ne);
      } else
        Be.setExtraStackFrame(null);
    }
    function st(z, J, ne, he, Fe) {
      {
        var ze = Function.call.bind(Me);
        for (var Te in z)
          if (ze(z, Te)) {
            var De = void 0;
            try {
              if (typeof z[Te] != "function") {
                var mt = Error((he || "React class") + ": " + ne + " type `" + Te + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof z[Te] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw mt.name = "Invariant Violation", mt;
              }
              De = z[Te](J, Te, he, ne, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (et) {
              De = et;
            }
            De && !(De instanceof Error) && (Ke(Fe), O("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", he || "React class", ne, Te, typeof De), Ke(null)), De instanceof Error && !(De.message in Ae) && (Ae[De.message] = !0, Ke(Fe), O("Failed %s type: %s", ne, De.message), Ke(null));
          }
      }
    }
    var vt = Array.isArray;
    function je(z) {
      return vt(z);
    }
    function lt(z) {
      {
        var J = typeof Symbol == "function" && Symbol.toStringTag, ne = J && z[Symbol.toStringTag] || z.constructor.name || "Object";
        return ne;
      }
    }
    function Dt(z) {
      try {
        return Se(z), !1;
      } catch {
        return !0;
      }
    }
    function Se(z) {
      return "" + z;
    }
    function St(z) {
      if (Dt(z))
        return O("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", lt(z)), Se(z);
    }
    var nr = b.ReactCurrentOwner, Tt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ar, Jr, Gt;
    Gt = {};
    function yo(z) {
      if (Me.call(z, "ref")) {
        var J = Object.getOwnPropertyDescriptor(z, "ref").get;
        if (J && J.isReactWarning)
          return !1;
      }
      return z.ref !== void 0;
    }
    function bo(z) {
      if (Me.call(z, "key")) {
        var J = Object.getOwnPropertyDescriptor(z, "key").get;
        if (J && J.isReactWarning)
          return !1;
      }
      return z.key !== void 0;
    }
    function Oa(z, J) {
      if (typeof z.ref == "string" && nr.current && J && nr.current.stateNode !== J) {
        var ne = C(nr.current.type);
        Gt[ne] || (O('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', C(nr.current.type), z.ref), Gt[ne] = !0);
      }
    }
    function wo(z, J) {
      {
        var ne = function() {
          ar || (ar = !0, O("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", J));
        };
        ne.isReactWarning = !0, Object.defineProperty(z, "key", {
          get: ne,
          configurable: !0
        });
      }
    }
    function xo(z, J) {
      {
        var ne = function() {
          Jr || (Jr = !0, O("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", J));
        };
        ne.isReactWarning = !0, Object.defineProperty(z, "ref", {
          get: ne,
          configurable: !0
        });
      }
    }
    var Eo = function(z, J, ne, he, Fe, ze, Te) {
      var De = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: z,
        key: J,
        ref: ne,
        props: Te,
        // Record the component responsible for creating this element.
        _owner: ze
      };
      return De._store = {}, Object.defineProperty(De._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(De, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: he
      }), Object.defineProperty(De, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Fe
      }), Object.freeze && (Object.freeze(De.props), Object.freeze(De)), De;
    };
    function Co(z, J, ne, he, Fe) {
      {
        var ze, Te = {}, De = null, mt = null;
        ne !== void 0 && (St(ne), De = "" + ne), bo(J) && (St(J.key), De = "" + J.key), yo(J) && (mt = J.ref, Oa(J, Fe));
        for (ze in J)
          Me.call(J, ze) && !Tt.hasOwnProperty(ze) && (Te[ze] = J[ze]);
        if (z && z.defaultProps) {
          var et = z.defaultProps;
          for (ze in et)
            Te[ze] === void 0 && (Te[ze] = et[ze]);
        }
        if (De || mt) {
          var rt = typeof z == "function" ? z.displayName || z.name || "Unknown" : z;
          De && wo(Te, rt), mt && xo(Te, rt);
        }
        return Eo(z, De, mt, Fe, he, nr.current, Te);
      }
    }
    var Pa = b.ReactCurrentOwner, Ii = b.ReactDebugCurrentFrame;
    function On(z) {
      if (z) {
        var J = z._owner, ne = Ie(z.type, z._source, J ? J.type : null);
        Ii.setExtraStackFrame(ne);
      } else
        Ii.setExtraStackFrame(null);
    }
    var Do;
    Do = !1;
    function So(z) {
      return typeof z == "object" && z !== null && z.$$typeof === e;
    }
    function yf() {
      {
        if (Pa.current) {
          var z = C(Pa.current.type);
          if (z)
            return `

Check the render method of \`` + z + "`.";
        }
        return "";
      }
    }
    function Iy(z) {
      {
        if (z !== void 0) {
          var J = z.fileName.replace(/^.*[\\\/]/, ""), ne = z.lineNumber;
          return `

Check your code at ` + J + ":" + ne + ".";
        }
        return "";
      }
    }
    var bf = {};
    function jy(z) {
      {
        var J = yf();
        if (!J) {
          var ne = typeof z == "string" ? z : z.displayName || z.name;
          ne && (J = `

Check the top-level render call using <` + ne + ">.");
        }
        return J;
      }
    }
    function wf(z, J) {
      {
        if (!z._store || z._store.validated || z.key != null)
          return;
        z._store.validated = !0;
        var ne = jy(J);
        if (bf[ne])
          return;
        bf[ne] = !0;
        var he = "";
        z && z._owner && z._owner !== Pa.current && (he = " It was passed a child from " + C(z._owner.type) + "."), On(z), O('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ne, he), On(null);
      }
    }
    function xf(z, J) {
      {
        if (typeof z != "object")
          return;
        if (je(z))
          for (var ne = 0; ne < z.length; ne++) {
            var he = z[ne];
            So(he) && wf(he, J);
          }
        else if (So(z))
          z._store && (z._store.validated = !0);
        else if (z) {
          var Fe = w(z);
          if (typeof Fe == "function" && Fe !== z.entries)
            for (var ze = Fe.call(z), Te; !(Te = ze.next()).done; )
              So(Te.value) && wf(Te.value, J);
        }
      }
    }
    function Ly(z) {
      {
        var J = z.type;
        if (J == null || typeof J == "string")
          return;
        var ne;
        if (typeof J == "function")
          ne = J.propTypes;
        else if (typeof J == "object" && (J.$$typeof === o || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        J.$$typeof === f))
          ne = J.propTypes;
        else
          return;
        if (ne) {
          var he = C(J);
          st(ne, z.props, "prop", he, z);
        } else if (J.PropTypes !== void 0 && !Do) {
          Do = !0;
          var Fe = C(J);
          O("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Fe || "Unknown");
        }
        typeof J.getDefaultProps == "function" && !J.getDefaultProps.isReactClassApproved && O("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ky(z) {
      {
        for (var J = Object.keys(z.props), ne = 0; ne < J.length; ne++) {
          var he = J[ne];
          if (he !== "children" && he !== "key") {
            On(z), O("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", he), On(null);
            break;
          }
        }
        z.ref !== null && (On(z), O("Invalid attribute `ref` supplied to `React.Fragment`."), On(null));
      }
    }
    function Ef(z, J, ne, he, Fe, ze) {
      {
        var Te = v(z);
        if (!Te) {
          var De = "";
          (z === void 0 || typeof z == "object" && z !== null && Object.keys(z).length === 0) && (De += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var mt = Iy(Fe);
          mt ? De += mt : De += yf();
          var et;
          z === null ? et = "null" : je(z) ? et = "array" : z !== void 0 && z.$$typeof === e ? (et = "<" + (C(z.type) || "Unknown") + " />", De = " Did you accidentally export a JSX literal instead of a component?") : et = typeof z, O("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", et, De);
        }
        var rt = Co(z, J, ne, Fe, ze);
        if (rt == null)
          return rt;
        if (Te) {
          var jt = J.children;
          if (jt !== void 0)
            if (he)
              if (je(jt)) {
                for (var Pn = 0; Pn < jt.length; Pn++)
                  xf(jt[Pn], z);
                Object.freeze && Object.freeze(jt);
              } else
                O("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xf(jt, z);
        }
        return z === n ? ky(rt) : Ly(rt), rt;
      }
    }
    function Ny(z, J, ne) {
      return Ef(z, J, ne, !0);
    }
    function zy(z, J, ne) {
      return Ef(z, J, ne, !1);
    }
    var Wy = zy, Hy = Ny;
    Aa.Fragment = n, Aa.jsx = Wy, Aa.jsxs = Hy;
  }()), Aa;
}
process.env.NODE_ENV === "production" ? $l.exports = Wb() : $l.exports = Hb();
var x = $l.exports;
const hv = [
  "primary",
  "secondary",
  "destructive",
  "destructive-secondary"
], gv = ["m", "s"], vv = Vt({
  locales: {},
  internals: {
    loading: !1,
    sessionUID: null
  },
  setInternals: void 0,
  dependencies: {
    showTemplates: !1,
    loadTemplates: null,
    loadAsset: null,
    uploadAsset: null,
    enqueueToast: null,
    theme: null,
    user: null
  }
});
function Ub(t, e) {
  if (e) {
    const r = /{{\s*([^{}]+)\s*}}/g;
    return t.replace(r, (n, a) => Object.prototype.hasOwnProperty.call(e, a) ? String(e[a]) : n);
  }
  return t;
}
const se = () => {
  const { locales: t, dependencies: e, internals: r, setInternals: n } = Ht(vv), { t: a } = Sb();
  return {
    loc: (i, s) => Ub(t[i], s) || a(i),
    dependencies: e,
    internals: r,
    setInternals: n
  };
}, Vb = ({ children: t, locales: e, dependencies: r, readOnly: n = !1 }) => {
  const [a, i] = dv({ loading: !1, sessionUID: crypto.randomUUID() });
  return /* @__PURE__ */ x.jsx(
    vv.Provider,
    {
      value: {
        locales: e,
        internals: {
          ...a,
          readOnly: n
        },
        setInternals: i,
        dependencies: r
      },
      children: t
    }
  );
}, qb = () => {
  const { loc: t } = se(), { active: e, related: r } = Le((n, a) => {
    const i = a.getEvent("selected").first();
    return {
      active: i,
      related: i && n.nodes[i].related
    };
  });
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    e && r.toolbar && Uy(r.toolbar),
    !e && /* @__PURE__ */ x.jsx(_e, { type: "l-strong", children: t("clickToEdit") })
  ] });
}, mv = ({
  label: t,
  value: e,
  onChange: r,
  children: n,
  "data-testid": a
}) => /* @__PURE__ */ x.jsx(
  Ns,
  {
    required: !0,
    size: "s",
    value: e,
    onWppChange: (i) => {
      r(i.detail.value);
    },
    ...!!t && { labelConfig: { text: t } },
    "data-testid": a,
    children: n
  }
), Qt = ({ label: t, value: e }) => /* @__PURE__ */ x.jsx(ra, { value: e, children: /* @__PURE__ */ x.jsx("p", { slot: "label", children: t }) });
var kt = {}, Ci = {}, Gb = typeof tt == "object" && tt && tt.Object === Object && tt, yv = Gb, Yb = yv, Kb = typeof self == "object" && self && self.Object === Object && self, Xb = Yb || Kb || Function("return this")(), er = Xb, Zb = er, Jb = Zb.Symbol, Di = Jb, _f = Di, bv = Object.prototype, Qb = bv.hasOwnProperty, ew = bv.toString, Ta = _f ? _f.toStringTag : void 0;
function tw(t) {
  var e = Qb.call(t, Ta), r = t[Ta];
  try {
    t[Ta] = void 0;
    var n = !0;
  } catch {
  }
  var a = ew.call(t);
  return n && (e ? t[Ta] = r : delete t[Ta]), a;
}
var rw = tw, nw = Object.prototype, aw = nw.toString;
function iw(t) {
  return aw.call(t);
}
var sw = iw, Af = Di, ow = rw, lw = sw, uw = "[object Null]", cw = "[object Undefined]", Tf = Af ? Af.toStringTag : void 0;
function fw(t) {
  return t == null ? t === void 0 ? cw : uw : Tf && Tf in Object(t) ? ow(t) : lw(t);
}
var mn = fw, dw = Array.isArray, tr = dw;
function pw(t) {
  return t != null && typeof t == "object";
}
var Pr = pw, hw = mn, gw = tr, vw = Pr, mw = "[object String]";
function yw(t) {
  return typeof t == "string" || !gw(t) && vw(t) && hw(t) == mw;
}
var bw = yw;
function ww(t) {
  return function(e, r, n) {
    for (var a = -1, i = Object(e), s = n(e), l = s.length; l--; ) {
      var o = s[t ? l : ++a];
      if (r(i[o], o, i) === !1)
        break;
    }
    return e;
  };
}
var xw = ww, Ew = xw, Cw = Ew(), Dw = Cw;
function Sw(t, e) {
  for (var r = -1, n = Array(t); ++r < t; )
    n[r] = e(r);
  return n;
}
var Ow = Sw, Pw = mn, _w = Pr, Aw = "[object Arguments]";
function Tw(t) {
  return _w(t) && Pw(t) == Aw;
}
var Bw = Tw, Bf = Bw, Rw = Pr, wv = Object.prototype, $w = wv.hasOwnProperty, Mw = wv.propertyIsEnumerable, Fw = Bf(function() {
  return arguments;
}()) ? Bf : function(t) {
  return Rw(t) && $w.call(t, "callee") && !Mw.call(t, "callee");
}, xv = Fw, hs = { exports: {} };
function Iw() {
  return !1;
}
var jw = Iw;
hs.exports;
(function(t, e) {
  var r = er, n = jw, a = e && !e.nodeType && e, i = a && !0 && t && !t.nodeType && t, s = i && i.exports === a, l = s ? r.Buffer : void 0, o = l ? l.isBuffer : void 0, u = o || n;
  t.exports = u;
})(hs, hs.exports);
var Du = hs.exports, Lw = 9007199254740991, kw = /^(?:0|[1-9]\d*)$/;
function Nw(t, e) {
  var r = typeof t;
  return e = e ?? Lw, !!e && (r == "number" || r != "symbol" && kw.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var Ev = Nw, zw = 9007199254740991;
function Ww(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= zw;
}
var Su = Ww, Hw = mn, Uw = Su, Vw = Pr, qw = "[object Arguments]", Gw = "[object Array]", Yw = "[object Boolean]", Kw = "[object Date]", Xw = "[object Error]", Zw = "[object Function]", Jw = "[object Map]", Qw = "[object Number]", e1 = "[object Object]", t1 = "[object RegExp]", r1 = "[object Set]", n1 = "[object String]", a1 = "[object WeakMap]", i1 = "[object ArrayBuffer]", s1 = "[object DataView]", o1 = "[object Float32Array]", l1 = "[object Float64Array]", u1 = "[object Int8Array]", c1 = "[object Int16Array]", f1 = "[object Int32Array]", d1 = "[object Uint8Array]", p1 = "[object Uint8ClampedArray]", h1 = "[object Uint16Array]", g1 = "[object Uint32Array]", Ue = {};
Ue[o1] = Ue[l1] = Ue[u1] = Ue[c1] = Ue[f1] = Ue[d1] = Ue[p1] = Ue[h1] = Ue[g1] = !0;
Ue[qw] = Ue[Gw] = Ue[i1] = Ue[Yw] = Ue[s1] = Ue[Kw] = Ue[Xw] = Ue[Zw] = Ue[Jw] = Ue[Qw] = Ue[e1] = Ue[t1] = Ue[r1] = Ue[n1] = Ue[a1] = !1;
function v1(t) {
  return Vw(t) && Uw(t.length) && !!Ue[Hw(t)];
}
var m1 = v1;
function y1(t) {
  return function(e) {
    return t(e);
  };
}
var Ou = y1, gs = { exports: {} };
gs.exports;
(function(t, e) {
  var r = yv, n = e && !e.nodeType && e, a = n && !0 && t && !t.nodeType && t, i = a && a.exports === n, s = i && r.process, l = function() {
    try {
      var o = a && a.require && a.require("util").types;
      return o || s && s.binding && s.binding("util");
    } catch {
    }
  }();
  t.exports = l;
})(gs, gs.exports);
var Pu = gs.exports, b1 = m1, w1 = Ou, Rf = Pu, $f = Rf && Rf.isTypedArray, x1 = $f ? w1($f) : b1, Cv = x1, E1 = Ow, C1 = xv, D1 = tr, S1 = Du, O1 = Ev, P1 = Cv, _1 = Object.prototype, A1 = _1.hasOwnProperty;
function T1(t, e) {
  var r = D1(t), n = !r && C1(t), a = !r && !n && S1(t), i = !r && !n && !a && P1(t), s = r || n || a || i, l = s ? E1(t.length, String) : [], o = l.length;
  for (var u in t)
    (e || A1.call(t, u)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    O1(u, o))) && l.push(u);
  return l;
}
var Dv = T1, B1 = Object.prototype;
function R1(t) {
  var e = t && t.constructor, r = typeof e == "function" && e.prototype || B1;
  return t === r;
}
var _u = R1;
function $1(t, e) {
  return function(r) {
    return t(e(r));
  };
}
var Sv = $1, M1 = Sv, F1 = M1(Object.keys, Object), I1 = F1, j1 = _u, L1 = I1, k1 = Object.prototype, N1 = k1.hasOwnProperty;
function z1(t) {
  if (!j1(t))
    return L1(t);
  var e = [];
  for (var r in Object(t))
    N1.call(t, r) && r != "constructor" && e.push(r);
  return e;
}
var W1 = z1;
function H1(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var _r = H1, U1 = mn, V1 = _r, q1 = "[object AsyncFunction]", G1 = "[object Function]", Y1 = "[object GeneratorFunction]", K1 = "[object Proxy]";
function X1(t) {
  if (!V1(t))
    return !1;
  var e = U1(t);
  return e == G1 || e == Y1 || e == q1 || e == K1;
}
var Ov = X1, Z1 = Ov, J1 = Su;
function Q1(t) {
  return t != null && J1(t.length) && !Z1(t);
}
var zs = Q1, ex = Dv, tx = W1, rx = zs;
function nx(t) {
  return rx(t) ? ex(t) : tx(t);
}
var Si = nx, ax = Dw, ix = Si;
function sx(t, e) {
  return t && ax(t, e, ix);
}
var Pv = sx;
function ox(t) {
  return t;
}
var _v = ox, lx = _v;
function ux(t) {
  return typeof t == "function" ? t : lx;
}
var cx = ux, fx = Pv, dx = cx;
function px(t, e) {
  return t && fx(t, dx(e));
}
var Au = px, hx = Sv, gx = hx(Object.getPrototypeOf, Object), Tu = gx, vx = mn, mx = Tu, yx = Pr, bx = "[object Object]", wx = Function.prototype, xx = Object.prototype, Av = wx.toString, Ex = xx.hasOwnProperty, Cx = Av.call(Object);
function Dx(t) {
  if (!yx(t) || vx(t) != bx)
    return !1;
  var e = mx(t);
  if (e === null)
    return !0;
  var r = Ex.call(e, "constructor") && e.constructor;
  return typeof r == "function" && r instanceof r && Av.call(r) == Cx;
}
var Sx = Dx;
function Ox(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, a = Array(n); ++r < n; )
    a[r] = e(t[r], r, t);
  return a;
}
var Tv = Ox;
function Px() {
  this.__data__ = [], this.size = 0;
}
var _x = Px;
function Ax(t, e) {
  return t === e || t !== t && e !== e;
}
var Bu = Ax, Tx = Bu;
function Bx(t, e) {
  for (var r = t.length; r--; )
    if (Tx(t[r][0], e))
      return r;
  return -1;
}
var Ws = Bx, Rx = Ws, $x = Array.prototype, Mx = $x.splice;
function Fx(t) {
  var e = this.__data__, r = Rx(e, t);
  if (r < 0)
    return !1;
  var n = e.length - 1;
  return r == n ? e.pop() : Mx.call(e, r, 1), --this.size, !0;
}
var Ix = Fx, jx = Ws;
function Lx(t) {
  var e = this.__data__, r = jx(e, t);
  return r < 0 ? void 0 : e[r][1];
}
var kx = Lx, Nx = Ws;
function zx(t) {
  return Nx(this.__data__, t) > -1;
}
var Wx = zx, Hx = Ws;
function Ux(t, e) {
  var r = this.__data__, n = Hx(r, t);
  return n < 0 ? (++this.size, r.push([t, e])) : r[n][1] = e, this;
}
var Vx = Ux, qx = _x, Gx = Ix, Yx = kx, Kx = Wx, Xx = Vx;
function pa(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
pa.prototype.clear = qx;
pa.prototype.delete = Gx;
pa.prototype.get = Yx;
pa.prototype.has = Kx;
pa.prototype.set = Xx;
var Hs = pa, Zx = Hs;
function Jx() {
  this.__data__ = new Zx(), this.size = 0;
}
var Qx = Jx;
function eE(t) {
  var e = this.__data__, r = e.delete(t);
  return this.size = e.size, r;
}
var tE = eE;
function rE(t) {
  return this.__data__.get(t);
}
var nE = rE;
function aE(t) {
  return this.__data__.has(t);
}
var iE = aE, sE = er, oE = sE["__core-js_shared__"], lE = oE, Oo = lE, Mf = function() {
  var t = /[^.]+$/.exec(Oo && Oo.keys && Oo.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function uE(t) {
  return !!Mf && Mf in t;
}
var cE = uE, fE = Function.prototype, dE = fE.toString;
function pE(t) {
  if (t != null) {
    try {
      return dE.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var Bv = pE, hE = Ov, gE = cE, vE = _r, mE = Bv, yE = /[\\^$.*+?()[\]{}|]/g, bE = /^\[object .+?Constructor\]$/, wE = Function.prototype, xE = Object.prototype, EE = wE.toString, CE = xE.hasOwnProperty, DE = RegExp(
  "^" + EE.call(CE).replace(yE, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function SE(t) {
  if (!vE(t) || gE(t))
    return !1;
  var e = hE(t) ? DE : bE;
  return e.test(mE(t));
}
var OE = SE;
function PE(t, e) {
  return t == null ? void 0 : t[e];
}
var _E = PE, AE = OE, TE = _E;
function BE(t, e) {
  var r = TE(t, e);
  return AE(r) ? r : void 0;
}
var yn = BE, RE = yn, $E = er, ME = RE($E, "Map"), Ru = ME, FE = yn, IE = FE(Object, "create"), Us = IE, Ff = Us;
function jE() {
  this.__data__ = Ff ? Ff(null) : {}, this.size = 0;
}
var LE = jE;
function kE(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var NE = kE, zE = Us, WE = "__lodash_hash_undefined__", HE = Object.prototype, UE = HE.hasOwnProperty;
function VE(t) {
  var e = this.__data__;
  if (zE) {
    var r = e[t];
    return r === WE ? void 0 : r;
  }
  return UE.call(e, t) ? e[t] : void 0;
}
var qE = VE, GE = Us, YE = Object.prototype, KE = YE.hasOwnProperty;
function XE(t) {
  var e = this.__data__;
  return GE ? e[t] !== void 0 : KE.call(e, t);
}
var ZE = XE, JE = Us, QE = "__lodash_hash_undefined__";
function eC(t, e) {
  var r = this.__data__;
  return this.size += this.has(t) ? 0 : 1, r[t] = JE && e === void 0 ? QE : e, this;
}
var tC = eC, rC = LE, nC = NE, aC = qE, iC = ZE, sC = tC;
function ha(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
ha.prototype.clear = rC;
ha.prototype.delete = nC;
ha.prototype.get = aC;
ha.prototype.has = iC;
ha.prototype.set = sC;
var oC = ha, If = oC, lC = Hs, uC = Ru;
function cC() {
  this.size = 0, this.__data__ = {
    hash: new If(),
    map: new (uC || lC)(),
    string: new If()
  };
}
var fC = cC;
function dC(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var pC = dC, hC = pC;
function gC(t, e) {
  var r = t.__data__;
  return hC(e) ? r[typeof e == "string" ? "string" : "hash"] : r.map;
}
var Vs = gC, vC = Vs;
function mC(t) {
  var e = vC(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var yC = mC, bC = Vs;
function wC(t) {
  return bC(this, t).get(t);
}
var xC = wC, EC = Vs;
function CC(t) {
  return EC(this, t).has(t);
}
var DC = CC, SC = Vs;
function OC(t, e) {
  var r = SC(this, t), n = r.size;
  return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
}
var PC = OC, _C = fC, AC = yC, TC = xC, BC = DC, RC = PC;
function ga(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
ga.prototype.clear = _C;
ga.prototype.delete = AC;
ga.prototype.get = TC;
ga.prototype.has = BC;
ga.prototype.set = RC;
var $u = ga, $C = Hs, MC = Ru, FC = $u, IC = 200;
function jC(t, e) {
  var r = this.__data__;
  if (r instanceof $C) {
    var n = r.__data__;
    if (!MC || n.length < IC - 1)
      return n.push([t, e]), this.size = ++r.size, this;
    r = this.__data__ = new FC(n);
  }
  return r.set(t, e), this.size = r.size, this;
}
var LC = jC, kC = Hs, NC = Qx, zC = tE, WC = nE, HC = iE, UC = LC;
function va(t) {
  var e = this.__data__ = new kC(t);
  this.size = e.size;
}
va.prototype.clear = NC;
va.prototype.delete = zC;
va.prototype.get = WC;
va.prototype.has = HC;
va.prototype.set = UC;
var Mu = va, VC = "__lodash_hash_undefined__";
function qC(t) {
  return this.__data__.set(t, VC), this;
}
var GC = qC;
function YC(t) {
  return this.__data__.has(t);
}
var KC = YC, XC = $u, ZC = GC, JC = KC;
function vs(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.__data__ = new XC(); ++e < r; )
    this.add(t[e]);
}
vs.prototype.add = vs.prototype.push = ZC;
vs.prototype.has = JC;
var QC = vs;
function eD(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length; ++r < n; )
    if (e(t[r], r, t))
      return !0;
  return !1;
}
var tD = eD;
function rD(t, e) {
  return t.has(e);
}
var nD = rD, aD = QC, iD = tD, sD = nD, oD = 1, lD = 2;
function uD(t, e, r, n, a, i) {
  var s = r & oD, l = t.length, o = e.length;
  if (l != o && !(s && o > l))
    return !1;
  var u = i.get(t), c = i.get(e);
  if (u && c)
    return u == e && c == t;
  var f = -1, p = !0, g = r & lD ? new aD() : void 0;
  for (i.set(t, e), i.set(e, t); ++f < l; ) {
    var m = t[f], d = e[f];
    if (n)
      var w = s ? n(d, m, f, e, t, i) : n(m, d, f, t, e, i);
    if (w !== void 0) {
      if (w)
        continue;
      p = !1;
      break;
    }
    if (g) {
      if (!iD(e, function(b, O) {
        if (!sD(g, O) && (m === b || a(m, b, r, n, i)))
          return g.push(O);
      })) {
        p = !1;
        break;
      }
    } else if (!(m === d || a(m, d, r, n, i))) {
      p = !1;
      break;
    }
  }
  return i.delete(t), i.delete(e), p;
}
var Rv = uD, cD = er, fD = cD.Uint8Array, $v = fD;
function dD(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(n, a) {
    r[++e] = [a, n];
  }), r;
}
var pD = dD;
function hD(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(n) {
    r[++e] = n;
  }), r;
}
var gD = hD, jf = Di, Lf = $v, vD = Bu, mD = Rv, yD = pD, bD = gD, wD = 1, xD = 2, ED = "[object Boolean]", CD = "[object Date]", DD = "[object Error]", SD = "[object Map]", OD = "[object Number]", PD = "[object RegExp]", _D = "[object Set]", AD = "[object String]", TD = "[object Symbol]", BD = "[object ArrayBuffer]", RD = "[object DataView]", kf = jf ? jf.prototype : void 0, Po = kf ? kf.valueOf : void 0;
function $D(t, e, r, n, a, i, s) {
  switch (r) {
    case RD:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case BD:
      return !(t.byteLength != e.byteLength || !i(new Lf(t), new Lf(e)));
    case ED:
    case CD:
    case OD:
      return vD(+t, +e);
    case DD:
      return t.name == e.name && t.message == e.message;
    case PD:
    case AD:
      return t == e + "";
    case SD:
      var l = yD;
    case _D:
      var o = n & wD;
      if (l || (l = bD), t.size != e.size && !o)
        return !1;
      var u = s.get(t);
      if (u)
        return u == e;
      n |= xD, s.set(t, e);
      var c = mD(l(t), l(e), n, a, i, s);
      return s.delete(t), c;
    case TD:
      if (Po)
        return Po.call(t) == Po.call(e);
  }
  return !1;
}
var MD = $D;
function FD(t, e) {
  for (var r = -1, n = e.length, a = t.length; ++r < n; )
    t[a + r] = e[r];
  return t;
}
var Mv = FD, ID = Mv, jD = tr;
function LD(t, e, r) {
  var n = e(t);
  return jD(t) ? n : ID(n, r(t));
}
var Fv = LD;
function kD(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, a = 0, i = []; ++r < n; ) {
    var s = t[r];
    e(s, r, t) && (i[a++] = s);
  }
  return i;
}
var ND = kD;
function zD() {
  return [];
}
var Iv = zD, WD = ND, HD = Iv, UD = Object.prototype, VD = UD.propertyIsEnumerable, Nf = Object.getOwnPropertySymbols, qD = Nf ? function(t) {
  return t == null ? [] : (t = Object(t), WD(Nf(t), function(e) {
    return VD.call(t, e);
  }));
} : HD, Fu = qD, GD = Fv, YD = Fu, KD = Si;
function XD(t) {
  return GD(t, KD, YD);
}
var jv = XD, zf = jv, ZD = 1, JD = Object.prototype, QD = JD.hasOwnProperty;
function eS(t, e, r, n, a, i) {
  var s = r & ZD, l = zf(t), o = l.length, u = zf(e), c = u.length;
  if (o != c && !s)
    return !1;
  for (var f = o; f--; ) {
    var p = l[f];
    if (!(s ? p in e : QD.call(e, p)))
      return !1;
  }
  var g = i.get(t), m = i.get(e);
  if (g && m)
    return g == e && m == t;
  var d = !0;
  i.set(t, e), i.set(e, t);
  for (var w = s; ++f < o; ) {
    p = l[f];
    var b = t[p], O = e[p];
    if (n)
      var S = s ? n(O, b, p, e, t, i) : n(b, O, p, t, e, i);
    if (!(S === void 0 ? b === O || a(b, O, r, n, i) : S)) {
      d = !1;
      break;
    }
    w || (w = p == "constructor");
  }
  if (d && !w) {
    var B = t.constructor, T = e.constructor;
    B != T && "constructor" in t && "constructor" in e && !(typeof B == "function" && B instanceof B && typeof T == "function" && T instanceof T) && (d = !1);
  }
  return i.delete(t), i.delete(e), d;
}
var tS = eS, rS = yn, nS = er, aS = rS(nS, "DataView"), iS = aS, sS = yn, oS = er, lS = sS(oS, "Promise"), uS = lS, cS = yn, fS = er, dS = cS(fS, "Set"), pS = dS, hS = yn, gS = er, vS = hS(gS, "WeakMap"), mS = vS, Ml = iS, Fl = Ru, Il = uS, jl = pS, Ll = mS, Lv = mn, ma = Bv, Wf = "[object Map]", yS = "[object Object]", Hf = "[object Promise]", Uf = "[object Set]", Vf = "[object WeakMap]", qf = "[object DataView]", bS = ma(Ml), wS = ma(Fl), xS = ma(Il), ES = ma(jl), CS = ma(Ll), Qr = Lv;
(Ml && Qr(new Ml(new ArrayBuffer(1))) != qf || Fl && Qr(new Fl()) != Wf || Il && Qr(Il.resolve()) != Hf || jl && Qr(new jl()) != Uf || Ll && Qr(new Ll()) != Vf) && (Qr = function(t) {
  var e = Lv(t), r = e == yS ? t.constructor : void 0, n = r ? ma(r) : "";
  if (n)
    switch (n) {
      case bS:
        return qf;
      case wS:
        return Wf;
      case xS:
        return Hf;
      case ES:
        return Uf;
      case CS:
        return Vf;
    }
  return e;
});
var qs = Qr, _o = Mu, DS = Rv, SS = MD, OS = tS, Gf = qs, Yf = tr, Kf = Du, PS = Cv, _S = 1, Xf = "[object Arguments]", Zf = "[object Array]", Li = "[object Object]", AS = Object.prototype, Jf = AS.hasOwnProperty;
function TS(t, e, r, n, a, i) {
  var s = Yf(t), l = Yf(e), o = s ? Zf : Gf(t), u = l ? Zf : Gf(e);
  o = o == Xf ? Li : o, u = u == Xf ? Li : u;
  var c = o == Li, f = u == Li, p = o == u;
  if (p && Kf(t)) {
    if (!Kf(e))
      return !1;
    s = !0, c = !1;
  }
  if (p && !c)
    return i || (i = new _o()), s || PS(t) ? DS(t, e, r, n, a, i) : SS(t, e, o, r, n, a, i);
  if (!(r & _S)) {
    var g = c && Jf.call(t, "__wrapped__"), m = f && Jf.call(e, "__wrapped__");
    if (g || m) {
      var d = g ? t.value() : t, w = m ? e.value() : e;
      return i || (i = new _o()), a(d, w, r, n, i);
    }
  }
  return p ? (i || (i = new _o()), OS(t, e, r, n, a, i)) : !1;
}
var BS = TS, RS = BS, Qf = Pr;
function kv(t, e, r, n, a) {
  return t === e ? !0 : t == null || e == null || !Qf(t) && !Qf(e) ? t !== t && e !== e : RS(t, e, r, n, kv, a);
}
var Nv = kv, $S = Mu, MS = Nv, FS = 1, IS = 2;
function jS(t, e, r, n) {
  var a = r.length, i = a, s = !n;
  if (t == null)
    return !i;
  for (t = Object(t); a--; ) {
    var l = r[a];
    if (s && l[2] ? l[1] !== t[l[0]] : !(l[0] in t))
      return !1;
  }
  for (; ++a < i; ) {
    l = r[a];
    var o = l[0], u = t[o], c = l[1];
    if (s && l[2]) {
      if (u === void 0 && !(o in t))
        return !1;
    } else {
      var f = new $S();
      if (n)
        var p = n(u, c, o, t, e, f);
      if (!(p === void 0 ? MS(c, u, FS | IS, n, f) : p))
        return !1;
    }
  }
  return !0;
}
var LS = jS, kS = _r;
function NS(t) {
  return t === t && !kS(t);
}
var zv = NS, zS = zv, WS = Si;
function HS(t) {
  for (var e = WS(t), r = e.length; r--; ) {
    var n = e[r], a = t[n];
    e[r] = [n, a, zS(a)];
  }
  return e;
}
var US = HS;
function VS(t, e) {
  return function(r) {
    return r == null ? !1 : r[t] === e && (e !== void 0 || t in Object(r));
  };
}
var Wv = VS, qS = LS, GS = US, YS = Wv;
function KS(t) {
  var e = GS(t);
  return e.length == 1 && e[0][2] ? YS(e[0][0], e[0][1]) : function(r) {
    return r === t || qS(r, t, e);
  };
}
var XS = KS, ZS = mn, JS = Pr, QS = "[object Symbol]";
function eO(t) {
  return typeof t == "symbol" || JS(t) && ZS(t) == QS;
}
var Gs = eO, tO = tr, rO = Gs, nO = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, aO = /^\w*$/;
function iO(t, e) {
  if (tO(t))
    return !1;
  var r = typeof t;
  return r == "number" || r == "symbol" || r == "boolean" || t == null || rO(t) ? !0 : aO.test(t) || !nO.test(t) || e != null && t in Object(e);
}
var Iu = iO, Hv = $u, sO = "Expected a function";
function ju(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(sO);
  var r = function() {
    var n = arguments, a = e ? e.apply(this, n) : n[0], i = r.cache;
    if (i.has(a))
      return i.get(a);
    var s = t.apply(this, n);
    return r.cache = i.set(a, s) || i, s;
  };
  return r.cache = new (ju.Cache || Hv)(), r;
}
ju.Cache = Hv;
var oO = ju, lO = oO, uO = 500;
function cO(t) {
  var e = lO(t, function(n) {
    return r.size === uO && r.clear(), n;
  }), r = e.cache;
  return e;
}
var fO = cO, dO = fO, pO = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, hO = /\\(\\)?/g, gO = dO(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(pO, function(r, n, a, i) {
    e.push(a ? i.replace(hO, "$1") : n || r);
  }), e;
}), vO = gO, ed = Di, mO = Tv, yO = tr, bO = Gs, wO = 1 / 0, td = ed ? ed.prototype : void 0, rd = td ? td.toString : void 0;
function Uv(t) {
  if (typeof t == "string")
    return t;
  if (yO(t))
    return mO(t, Uv) + "";
  if (bO(t))
    return rd ? rd.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -wO ? "-0" : e;
}
var xO = Uv, EO = xO;
function CO(t) {
  return t == null ? "" : EO(t);
}
var DO = CO, SO = tr, OO = Iu, PO = vO, _O = DO;
function AO(t, e) {
  return SO(t) ? t : OO(t, e) ? [t] : PO(_O(t));
}
var Vv = AO, TO = Gs, BO = 1 / 0;
function RO(t) {
  if (typeof t == "string" || TO(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -BO ? "-0" : e;
}
var Ys = RO, $O = Vv, MO = Ys;
function FO(t, e) {
  e = $O(e, t);
  for (var r = 0, n = e.length; t != null && r < n; )
    t = t[MO(e[r++])];
  return r && r == n ? t : void 0;
}
var qv = FO, IO = qv;
function jO(t, e, r) {
  var n = t == null ? void 0 : IO(t, e);
  return n === void 0 ? r : n;
}
var LO = jO;
function kO(t, e) {
  return t != null && e in Object(t);
}
var NO = kO, zO = Vv, WO = xv, HO = tr, UO = Ev, VO = Su, qO = Ys;
function GO(t, e, r) {
  e = zO(e, t);
  for (var n = -1, a = e.length, i = !1; ++n < a; ) {
    var s = qO(e[n]);
    if (!(i = t != null && r(t, s)))
      break;
    t = t[s];
  }
  return i || ++n != a ? i : (a = t == null ? 0 : t.length, !!a && VO(a) && UO(s, a) && (HO(t) || WO(t)));
}
var YO = GO, KO = NO, XO = YO;
function ZO(t, e) {
  return t != null && XO(t, e, KO);
}
var JO = ZO, QO = Nv, eP = LO, tP = JO, rP = Iu, nP = zv, aP = Wv, iP = Ys, sP = 1, oP = 2;
function lP(t, e) {
  return rP(t) && nP(e) ? aP(iP(t), e) : function(r) {
    var n = eP(r, t);
    return n === void 0 && n === e ? tP(r, t) : QO(e, n, sP | oP);
  };
}
var uP = lP;
function cP(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
var fP = cP, dP = qv;
function pP(t) {
  return function(e) {
    return dP(e, t);
  };
}
var hP = pP, gP = fP, vP = hP, mP = Iu, yP = Ys;
function bP(t) {
  return mP(t) ? gP(yP(t)) : vP(t);
}
var wP = bP, xP = XS, EP = uP, CP = _v, DP = tr, SP = wP;
function OP(t) {
  return typeof t == "function" ? t : t == null ? CP : typeof t == "object" ? DP(t) ? EP(t[0], t[1]) : xP(t) : SP(t);
}
var PP = OP, _P = zs;
function AP(t, e) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!_P(r))
      return t(r, n);
    for (var a = r.length, i = e ? a : -1, s = Object(r); (e ? i-- : ++i < a) && n(s[i], i, s) !== !1; )
      ;
    return r;
  };
}
var TP = AP, BP = Pv, RP = TP, $P = RP(BP), MP = $P, FP = MP, IP = zs;
function jP(t, e) {
  var r = -1, n = IP(t) ? Array(t.length) : [];
  return FP(t, function(a, i, s) {
    n[++r] = e(a, i, s);
  }), n;
}
var LP = jP, kP = Tv, NP = PP, zP = LP, WP = tr;
function HP(t, e) {
  var r = WP(t) ? kP : zP;
  return r(t, NP(e));
}
var UP = HP;
Object.defineProperty(Ci, "__esModule", {
  value: !0
});
Ci.flattenNames = void 0;
var VP = bw, qP = Ks(VP), GP = Au, YP = Ks(GP), KP = Sx, XP = Ks(KP), ZP = UP, JP = Ks(ZP);
function Ks(t) {
  return t && t.__esModule ? t : { default: t };
}
var QP = Ci.flattenNames = function t() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = [];
  return (0, JP.default)(e, function(n) {
    Array.isArray(n) ? t(n).map(function(a) {
      return r.push(a);
    }) : (0, XP.default)(n) ? (0, YP.default)(n, function(a, i) {
      a === !0 && r.push(i), r.push(i + "-" + a);
    }) : (0, qP.default)(n) && r.push(n);
  }), r;
};
Ci.default = QP;
var Oi = {};
function e_(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length; ++r < n && e(t[r], r, t) !== !1; )
    ;
  return t;
}
var t_ = e_, r_ = yn, n_ = function() {
  try {
    var t = r_(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), a_ = n_, nd = a_;
function i_(t, e, r) {
  e == "__proto__" && nd ? nd(t, e, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : t[e] = r;
}
var Gv = i_, s_ = Gv, o_ = Bu, l_ = Object.prototype, u_ = l_.hasOwnProperty;
function c_(t, e, r) {
  var n = t[e];
  (!(u_.call(t, e) && o_(n, r)) || r === void 0 && !(e in t)) && s_(t, e, r);
}
var Yv = c_, f_ = Yv, d_ = Gv;
function p_(t, e, r, n) {
  var a = !r;
  r || (r = {});
  for (var i = -1, s = e.length; ++i < s; ) {
    var l = e[i], o = n ? n(r[l], t[l], l, r, t) : void 0;
    o === void 0 && (o = t[l]), a ? d_(r, l, o) : f_(r, l, o);
  }
  return r;
}
var Xs = p_, h_ = Xs, g_ = Si;
function v_(t, e) {
  return t && h_(e, g_(e), t);
}
var m_ = v_;
function y_(t) {
  var e = [];
  if (t != null)
    for (var r in Object(t))
      e.push(r);
  return e;
}
var b_ = y_, w_ = _r, x_ = _u, E_ = b_, C_ = Object.prototype, D_ = C_.hasOwnProperty;
function S_(t) {
  if (!w_(t))
    return E_(t);
  var e = x_(t), r = [];
  for (var n in t)
    n == "constructor" && (e || !D_.call(t, n)) || r.push(n);
  return r;
}
var O_ = S_, P_ = Dv, __ = O_, A_ = zs;
function T_(t) {
  return A_(t) ? P_(t, !0) : __(t);
}
var Lu = T_, B_ = Xs, R_ = Lu;
function $_(t, e) {
  return t && B_(e, R_(e), t);
}
var M_ = $_, ms = { exports: {} };
ms.exports;
(function(t, e) {
  var r = er, n = e && !e.nodeType && e, a = n && !0 && t && !t.nodeType && t, i = a && a.exports === n, s = i ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
  function o(u, c) {
    if (c)
      return u.slice();
    var f = u.length, p = l ? l(f) : new u.constructor(f);
    return u.copy(p), p;
  }
  t.exports = o;
})(ms, ms.exports);
var F_ = ms.exports;
function I_(t, e) {
  var r = -1, n = t.length;
  for (e || (e = Array(n)); ++r < n; )
    e[r] = t[r];
  return e;
}
var j_ = I_, L_ = Xs, k_ = Fu;
function N_(t, e) {
  return L_(t, k_(t), e);
}
var z_ = N_, W_ = Mv, H_ = Tu, U_ = Fu, V_ = Iv, q_ = Object.getOwnPropertySymbols, G_ = q_ ? function(t) {
  for (var e = []; t; )
    W_(e, U_(t)), t = H_(t);
  return e;
} : V_, Kv = G_, Y_ = Xs, K_ = Kv;
function X_(t, e) {
  return Y_(t, K_(t), e);
}
var Z_ = X_, J_ = Fv, Q_ = Kv, eA = Lu;
function tA(t) {
  return J_(t, eA, Q_);
}
var rA = tA, nA = Object.prototype, aA = nA.hasOwnProperty;
function iA(t) {
  var e = t.length, r = new t.constructor(e);
  return e && typeof t[0] == "string" && aA.call(t, "index") && (r.index = t.index, r.input = t.input), r;
}
var sA = iA, ad = $v;
function oA(t) {
  var e = new t.constructor(t.byteLength);
  return new ad(e).set(new ad(t)), e;
}
var ku = oA, lA = ku;
function uA(t, e) {
  var r = e ? lA(t.buffer) : t.buffer;
  return new t.constructor(r, t.byteOffset, t.byteLength);
}
var cA = uA, fA = /\w*$/;
function dA(t) {
  var e = new t.constructor(t.source, fA.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
var pA = dA, id = Di, sd = id ? id.prototype : void 0, od = sd ? sd.valueOf : void 0;
function hA(t) {
  return od ? Object(od.call(t)) : {};
}
var gA = hA, vA = ku;
function mA(t, e) {
  var r = e ? vA(t.buffer) : t.buffer;
  return new t.constructor(r, t.byteOffset, t.length);
}
var yA = mA, bA = ku, wA = cA, xA = pA, EA = gA, CA = yA, DA = "[object Boolean]", SA = "[object Date]", OA = "[object Map]", PA = "[object Number]", _A = "[object RegExp]", AA = "[object Set]", TA = "[object String]", BA = "[object Symbol]", RA = "[object ArrayBuffer]", $A = "[object DataView]", MA = "[object Float32Array]", FA = "[object Float64Array]", IA = "[object Int8Array]", jA = "[object Int16Array]", LA = "[object Int32Array]", kA = "[object Uint8Array]", NA = "[object Uint8ClampedArray]", zA = "[object Uint16Array]", WA = "[object Uint32Array]";
function HA(t, e, r) {
  var n = t.constructor;
  switch (e) {
    case RA:
      return bA(t);
    case DA:
    case SA:
      return new n(+t);
    case $A:
      return wA(t, r);
    case MA:
    case FA:
    case IA:
    case jA:
    case LA:
    case kA:
    case NA:
    case zA:
    case WA:
      return CA(t, r);
    case OA:
      return new n();
    case PA:
    case TA:
      return new n(t);
    case _A:
      return xA(t);
    case AA:
      return new n();
    case BA:
      return EA(t);
  }
}
var UA = HA, VA = _r, ld = Object.create, qA = function() {
  function t() {
  }
  return function(e) {
    if (!VA(e))
      return {};
    if (ld)
      return ld(e);
    t.prototype = e;
    var r = new t();
    return t.prototype = void 0, r;
  };
}(), GA = qA, YA = GA, KA = Tu, XA = _u;
function ZA(t) {
  return typeof t.constructor == "function" && !XA(t) ? YA(KA(t)) : {};
}
var JA = ZA, QA = qs, eT = Pr, tT = "[object Map]";
function rT(t) {
  return eT(t) && QA(t) == tT;
}
var nT = rT, aT = nT, iT = Ou, ud = Pu, cd = ud && ud.isMap, sT = cd ? iT(cd) : aT, oT = sT, lT = qs, uT = Pr, cT = "[object Set]";
function fT(t) {
  return uT(t) && lT(t) == cT;
}
var dT = fT, pT = dT, hT = Ou, fd = Pu, dd = fd && fd.isSet, gT = dd ? hT(dd) : pT, vT = gT, mT = Mu, yT = t_, bT = Yv, wT = m_, xT = M_, ET = F_, CT = j_, DT = z_, ST = Z_, OT = jv, PT = rA, _T = qs, AT = sA, TT = UA, BT = JA, RT = tr, $T = Du, MT = oT, FT = _r, IT = vT, jT = Si, LT = Lu, kT = 1, NT = 2, zT = 4, Xv = "[object Arguments]", WT = "[object Array]", HT = "[object Boolean]", UT = "[object Date]", VT = "[object Error]", Zv = "[object Function]", qT = "[object GeneratorFunction]", GT = "[object Map]", YT = "[object Number]", Jv = "[object Object]", KT = "[object RegExp]", XT = "[object Set]", ZT = "[object String]", JT = "[object Symbol]", QT = "[object WeakMap]", e2 = "[object ArrayBuffer]", t2 = "[object DataView]", r2 = "[object Float32Array]", n2 = "[object Float64Array]", a2 = "[object Int8Array]", i2 = "[object Int16Array]", s2 = "[object Int32Array]", o2 = "[object Uint8Array]", l2 = "[object Uint8ClampedArray]", u2 = "[object Uint16Array]", c2 = "[object Uint32Array]", He = {};
He[Xv] = He[WT] = He[e2] = He[t2] = He[HT] = He[UT] = He[r2] = He[n2] = He[a2] = He[i2] = He[s2] = He[GT] = He[YT] = He[Jv] = He[KT] = He[XT] = He[ZT] = He[JT] = He[o2] = He[l2] = He[u2] = He[c2] = !0;
He[VT] = He[Zv] = He[QT] = !1;
function ns(t, e, r, n, a, i) {
  var s, l = e & kT, o = e & NT, u = e & zT;
  if (r && (s = a ? r(t, n, a, i) : r(t)), s !== void 0)
    return s;
  if (!FT(t))
    return t;
  var c = RT(t);
  if (c) {
    if (s = AT(t), !l)
      return CT(t, s);
  } else {
    var f = _T(t), p = f == Zv || f == qT;
    if ($T(t))
      return ET(t, l);
    if (f == Jv || f == Xv || p && !a) {
      if (s = o || p ? {} : BT(t), !l)
        return o ? ST(t, xT(s, t)) : DT(t, wT(s, t));
    } else {
      if (!He[f])
        return a ? t : {};
      s = TT(t, f, l);
    }
  }
  i || (i = new mT());
  var g = i.get(t);
  if (g)
    return g;
  i.set(t, s), IT(t) ? t.forEach(function(w) {
    s.add(ns(w, e, r, w, t, i));
  }) : MT(t) && t.forEach(function(w, b) {
    s.set(b, ns(w, e, r, b, t, i));
  });
  var m = u ? o ? PT : OT : o ? LT : jT, d = c ? void 0 : m(t);
  return yT(d || t, function(w, b) {
    d && (b = w, w = t[b]), bT(s, b, ns(w, e, r, b, t, i));
  }), s;
}
var f2 = ns, d2 = f2, p2 = 1, h2 = 4;
function g2(t) {
  return d2(t, p2 | h2);
}
var v2 = g2;
Object.defineProperty(Oi, "__esModule", {
  value: !0
});
Oi.mergeClasses = void 0;
var m2 = Au, y2 = Qv(m2), b2 = v2, w2 = Qv(b2), x2 = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  }
  return t;
};
function Qv(t) {
  return t && t.__esModule ? t : { default: t };
}
var E2 = Oi.mergeClasses = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = e.default && (0, w2.default)(e.default) || {};
  return r.map(function(a) {
    var i = e[a];
    return i && (0, y2.default)(i, function(s, l) {
      n[l] || (n[l] = {}), n[l] = x2({}, n[l], i[l]);
    }), a;
  }), n;
};
Oi.default = E2;
var Pi = {};
Object.defineProperty(Pi, "__esModule", {
  value: !0
});
Pi.autoprefix = void 0;
var C2 = Au, pd = S2(C2), D2 = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  }
  return t;
};
function S2(t) {
  return t && t.__esModule ? t : { default: t };
}
var O2 = {
  borderRadius: function(e) {
    return {
      msBorderRadius: e,
      MozBorderRadius: e,
      OBorderRadius: e,
      WebkitBorderRadius: e,
      borderRadius: e
    };
  },
  boxShadow: function(e) {
    return {
      msBoxShadow: e,
      MozBoxShadow: e,
      OBoxShadow: e,
      WebkitBoxShadow: e,
      boxShadow: e
    };
  },
  userSelect: function(e) {
    return {
      WebkitTouchCallout: e,
      KhtmlUserSelect: e,
      MozUserSelect: e,
      msUserSelect: e,
      WebkitUserSelect: e,
      userSelect: e
    };
  },
  flex: function(e) {
    return {
      WebkitBoxFlex: e,
      MozBoxFlex: e,
      WebkitFlex: e,
      msFlex: e,
      flex: e
    };
  },
  flexBasis: function(e) {
    return {
      WebkitFlexBasis: e,
      flexBasis: e
    };
  },
  justifyContent: function(e) {
    return {
      WebkitJustifyContent: e,
      justifyContent: e
    };
  },
  transition: function(e) {
    return {
      msTransition: e,
      MozTransition: e,
      OTransition: e,
      WebkitTransition: e,
      transition: e
    };
  },
  transform: function(e) {
    return {
      msTransform: e,
      MozTransform: e,
      OTransform: e,
      WebkitTransform: e,
      transform: e
    };
  },
  absolute: function(e) {
    var r = e && e.split(" ");
    return {
      position: "absolute",
      top: r && r[0],
      right: r && r[1],
      bottom: r && r[2],
      left: r && r[3]
    };
  },
  extend: function(e, r) {
    var n = r[e];
    return n || {
      extend: e
    };
  }
}, P2 = Pi.autoprefix = function(e) {
  var r = {};
  return (0, pd.default)(e, function(n, a) {
    var i = {};
    (0, pd.default)(n, function(s, l) {
      var o = O2[l];
      o ? i = D2({}, i, o(s)) : i[l] = s;
    }), r[a] = i;
  }), r;
};
Pi.default = P2;
var _i = {};
Object.defineProperty(_i, "__esModule", {
  value: !0
});
_i.hover = void 0;
var _2 = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  }
  return t;
}, A2 = M, Ao = T2(A2);
function T2(t) {
  return t && t.__esModule ? t : { default: t };
}
function B2(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function hd(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function R2(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var $2 = _i.hover = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(n) {
    R2(a, n);
    function a() {
      var i, s, l, o;
      B2(this, a);
      for (var u = arguments.length, c = Array(u), f = 0; f < u; f++)
        c[f] = arguments[f];
      return o = (s = (l = hd(this, (i = a.__proto__ || Object.getPrototypeOf(a)).call.apply(i, [this].concat(c))), l), l.state = { hover: !1 }, l.handleMouseOver = function() {
        return l.setState({ hover: !0 });
      }, l.handleMouseOut = function() {
        return l.setState({ hover: !1 });
      }, l.render = function() {
        return Ao.default.createElement(
          r,
          { onMouseOver: l.handleMouseOver, onMouseOut: l.handleMouseOut },
          Ao.default.createElement(e, _2({}, l.props, l.state))
        );
      }, s), hd(l, o);
    }
    return a;
  }(Ao.default.Component);
};
_i.default = $2;
var Ai = {};
Object.defineProperty(Ai, "__esModule", {
  value: !0
});
Ai.active = void 0;
var M2 = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  }
  return t;
}, F2 = M, To = I2(F2);
function I2(t) {
  return t && t.__esModule ? t : { default: t };
}
function j2(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function gd(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function L2(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var k2 = Ai.active = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(n) {
    L2(a, n);
    function a() {
      var i, s, l, o;
      j2(this, a);
      for (var u = arguments.length, c = Array(u), f = 0; f < u; f++)
        c[f] = arguments[f];
      return o = (s = (l = gd(this, (i = a.__proto__ || Object.getPrototypeOf(a)).call.apply(i, [this].concat(c))), l), l.state = { active: !1 }, l.handleMouseDown = function() {
        return l.setState({ active: !0 });
      }, l.handleMouseUp = function() {
        return l.setState({ active: !1 });
      }, l.render = function() {
        return To.default.createElement(
          r,
          { onMouseDown: l.handleMouseDown, onMouseUp: l.handleMouseUp },
          To.default.createElement(e, M2({}, l.props, l.state))
        );
      }, s), gd(l, o);
    }
    return a;
  }(To.default.Component);
};
Ai.default = k2;
var Nu = {};
Object.defineProperty(Nu, "__esModule", {
  value: !0
});
var N2 = function(e, r) {
  var n = {}, a = function(s) {
    var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    n[s] = l;
  };
  return e === 0 && a("first-child"), e === r - 1 && a("last-child"), (e === 0 || e % 2 === 0) && a("even"), Math.abs(e % 2) === 1 && a("odd"), a("nth-child", e), n;
};
Nu.default = N2;
Object.defineProperty(kt, "__esModule", {
  value: !0
});
kt.ReactCSS = kt.loop = kt.handleActive = zu = kt.handleHover = kt.hover = void 0;
var z2 = Ci, W2 = ya(z2), H2 = Oi, U2 = ya(H2), V2 = Pi, q2 = ya(V2), G2 = _i, em = ya(G2), Y2 = Ai, K2 = ya(Y2), X2 = Nu, Z2 = ya(X2);
function ya(t) {
  return t && t.__esModule ? t : { default: t };
}
kt.hover = em.default;
var zu = kt.handleHover = em.default;
kt.handleActive = K2.default;
kt.loop = Z2.default;
var J2 = kt.ReactCSS = function(e) {
  for (var r = arguments.length, n = Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
    n[a - 1] = arguments[a];
  var i = (0, W2.default)(n), s = (0, U2.default)(e, i);
  return (0, q2.default)(s);
}, ge = kt.default = J2, Q2 = function(e, r, n, a, i) {
  var s = i.clientWidth, l = i.clientHeight, o = typeof e.pageX == "number" ? e.pageX : e.touches[0].pageX, u = typeof e.pageY == "number" ? e.pageY : e.touches[0].pageY, c = o - (i.getBoundingClientRect().left + window.pageXOffset), f = u - (i.getBoundingClientRect().top + window.pageYOffset);
  if (n === "vertical") {
    var p = void 0;
    if (f < 0 ? p = 0 : f > l ? p = 1 : p = Math.round(f * 100 / l) / 100, r.a !== p)
      return {
        h: r.h,
        s: r.s,
        l: r.l,
        a: p,
        source: "rgb"
      };
  } else {
    var g = void 0;
    if (c < 0 ? g = 0 : c > s ? g = 1 : g = Math.round(c * 100 / s) / 100, a !== g)
      return {
        h: r.h,
        s: r.s,
        l: r.l,
        a: g,
        source: "rgb"
      };
  }
  return null;
}, Bo = {}, eB = function(e, r, n, a) {
  if (typeof document > "u" && !a)
    return null;
  var i = a ? new a() : document.createElement("canvas");
  i.width = n * 2, i.height = n * 2;
  var s = i.getContext("2d");
  return s ? (s.fillStyle = e, s.fillRect(0, 0, i.width, i.height), s.fillStyle = r, s.fillRect(0, 0, n, n), s.translate(n, n), s.fillRect(0, 0, n, n), i.toDataURL()) : null;
}, tB = function(e, r, n, a) {
  var i = e + "-" + r + "-" + n + (a ? "-server" : "");
  if (Bo[i])
    return Bo[i];
  var s = eB(e, r, n, a);
  return Bo[i] = s, s;
}, vd = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  }
  return t;
}, ba = function(e) {
  var r = e.white, n = e.grey, a = e.size, i = e.renderers, s = e.borderRadius, l = e.boxShadow, o = e.children, u = ge({
    default: {
      grid: {
        borderRadius: s,
        boxShadow: l,
        absolute: "0px 0px 0px 0px",
        background: "url(" + tB(r, n, a, i.canvas) + ") center left"
      }
    }
  });
  return Vy(o) ? M.cloneElement(o, vd({}, o.props, { style: vd({}, o.props.style, u.grid) })) : M.createElement("div", { style: u.grid });
};
ba.defaultProps = {
  size: 8,
  white: "transparent",
  grey: "rgba(0,0,0,.08)",
  renderers: {}
};
var rB = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  }
  return t;
}, nB = function() {
  function t(e, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, r, n) {
    return r && t(e.prototype, r), n && t(e, n), e;
  };
}();
function aB(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function md(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function iB(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var Wu = function(t) {
  iB(e, t);
  function e() {
    var r, n, a, i;
    aB(this, e);
    for (var s = arguments.length, l = Array(s), o = 0; o < s; o++)
      l[o] = arguments[o];
    return i = (n = (a = md(this, (r = e.__proto__ || Object.getPrototypeOf(e)).call.apply(r, [this].concat(l))), a), a.handleChange = function(u) {
      var c = Q2(u, a.props.hsl, a.props.direction, a.props.a, a.container);
      c && typeof a.props.onChange == "function" && a.props.onChange(c, u);
    }, a.handleMouseDown = function(u) {
      a.handleChange(u), window.addEventListener("mousemove", a.handleChange), window.addEventListener("mouseup", a.handleMouseUp);
    }, a.handleMouseUp = function() {
      a.unbindEventListeners();
    }, a.unbindEventListeners = function() {
      window.removeEventListener("mousemove", a.handleChange), window.removeEventListener("mouseup", a.handleMouseUp);
    }, n), md(a, i);
  }
  return nB(e, [{
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props.rgb, i = ge({
        default: {
          alpha: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: "0px 0px 0px 0px",
            overflow: "hidden",
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: "0px 0px 0px 0px",
            background: "linear-gradient(to right, rgba(" + a.r + "," + a.g + "," + a.b + `, 0) 0%,
           rgba(` + a.r + "," + a.g + "," + a.b + ", 1) 100%)",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: "relative",
            height: "100%",
            margin: "0 3px"
          },
          pointer: {
            position: "absolute",
            left: a.a * 100 + "%"
          },
          slider: {
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            marginTop: "1px",
            transform: "translateX(-2px)"
          }
        },
        vertical: {
          gradient: {
            background: "linear-gradient(to bottom, rgba(" + a.r + "," + a.g + "," + a.b + `, 0) 0%,
           rgba(` + a.r + "," + a.g + "," + a.b + ", 1) 100%)"
          },
          pointer: {
            left: 0,
            top: a.a * 100 + "%"
          }
        },
        overwrite: rB({}, this.props.style)
      }, {
        vertical: this.props.direction === "vertical",
        overwrite: !0
      });
      return M.createElement(
        "div",
        { style: i.alpha },
        M.createElement(
          "div",
          { style: i.checkboard },
          M.createElement(ba, { renderers: this.props.renderers })
        ),
        M.createElement("div", { style: i.gradient }),
        M.createElement(
          "div",
          {
            style: i.container,
            ref: function(l) {
              return n.container = l;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          M.createElement(
            "div",
            { style: i.pointer },
            this.props.pointer ? M.createElement(this.props.pointer, this.props) : M.createElement("div", { style: i.slider })
          )
        )
      );
    }
  }]), e;
}(wi || da), sB = function() {
  function t(e, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, r, n) {
    return r && t(e.prototype, r), n && t(e, n), e;
  };
}();
function oB(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function lB(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function uB(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function cB(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var fB = 1, tm = 38, dB = 40, pB = [tm, dB], hB = function(e) {
  return pB.indexOf(e) > -1;
}, gB = function(e) {
  return Number(String(e).replace(/%/g, ""));
}, vB = 1, Pe = function(t) {
  cB(e, t);
  function e(r) {
    lB(this, e);
    var n = uB(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
    return n.handleBlur = function() {
      n.state.blurValue && n.setState({ value: n.state.blurValue, blurValue: null });
    }, n.handleChange = function(a) {
      n.setUpdatedValue(a.target.value, a);
    }, n.handleKeyDown = function(a) {
      var i = gB(a.target.value);
      if (!isNaN(i) && hB(a.keyCode)) {
        var s = n.getArrowOffset(), l = a.keyCode === tm ? i + s : i - s;
        n.setUpdatedValue(l, a);
      }
    }, n.handleDrag = function(a) {
      if (n.props.dragLabel) {
        var i = Math.round(n.props.value + a.movementX);
        i >= 0 && i <= n.props.dragMax && n.props.onChange && n.props.onChange(n.getValueObjectWithLabel(i), a);
      }
    }, n.handleMouseDown = function(a) {
      n.props.dragLabel && (a.preventDefault(), n.handleDrag(a), window.addEventListener("mousemove", n.handleDrag), window.addEventListener("mouseup", n.handleMouseUp));
    }, n.handleMouseUp = function() {
      n.unbindEventListeners();
    }, n.unbindEventListeners = function() {
      window.removeEventListener("mousemove", n.handleDrag), window.removeEventListener("mouseup", n.handleMouseUp);
    }, n.state = {
      value: String(r.value).toUpperCase(),
      blurValue: String(r.value).toUpperCase()
    }, n.inputId = "rc-editable-input-" + vB++, n;
  }
  return sB(e, [{
    key: "componentDidUpdate",
    value: function(n, a) {
      this.props.value !== this.state.value && (n.value !== this.props.value || a.value !== this.state.value) && (this.input === document.activeElement ? this.setState({ blurValue: String(this.props.value).toUpperCase() }) : this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "getValueObjectWithLabel",
    value: function(n) {
      return oB({}, this.props.label, n);
    }
  }, {
    key: "getArrowOffset",
    value: function() {
      return this.props.arrowOffset || fB;
    }
  }, {
    key: "setUpdatedValue",
    value: function(n, a) {
      var i = this.props.label ? this.getValueObjectWithLabel(n) : n;
      this.props.onChange && this.props.onChange(i, a), this.setState({ value: n });
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = ge({
        default: {
          wrap: {
            position: "relative"
          }
        },
        "user-override": {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        "dragLabel-true": {
          label: {
            cursor: "ew-resize"
          }
        }
      }, {
        "user-override": !0
      }, this.props);
      return M.createElement(
        "div",
        { style: a.wrap },
        M.createElement("input", {
          id: this.inputId,
          style: a.input,
          ref: function(s) {
            return n.input = s;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: "false"
        }),
        this.props.label && !this.props.hideLabel ? M.createElement(
          "label",
          {
            htmlFor: this.inputId,
            style: a.label,
            onMouseDown: this.handleMouseDown
          },
          this.props.label
        ) : null
      );
    }
  }]), e;
}(wi || da), mB = function(e, r, n, a) {
  var i = a.clientWidth, s = a.clientHeight, l = typeof e.pageX == "number" ? e.pageX : e.touches[0].pageX, o = typeof e.pageY == "number" ? e.pageY : e.touches[0].pageY, u = l - (a.getBoundingClientRect().left + window.pageXOffset), c = o - (a.getBoundingClientRect().top + window.pageYOffset);
  if (r === "vertical") {
    var f = void 0;
    if (c < 0)
      f = 359;
    else if (c > s)
      f = 0;
    else {
      var p = -(c * 100 / s) + 100;
      f = 360 * p / 100;
    }
    if (n.h !== f)
      return {
        h: f,
        s: n.s,
        l: n.l,
        a: n.a,
        source: "hsl"
      };
  } else {
    var g = void 0;
    if (u < 0)
      g = 0;
    else if (u > i)
      g = 359;
    else {
      var m = u * 100 / i;
      g = 360 * m / 100;
    }
    if (n.h !== g)
      return {
        h: g,
        s: n.s,
        l: n.l,
        a: n.a,
        source: "hsl"
      };
  }
  return null;
}, yB = function() {
  function t(e, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, r, n) {
    return r && t(e.prototype, r), n && t(e, n), e;
  };
}();
function bB(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function yd(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function wB(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var wa = function(t) {
  wB(e, t);
  function e() {
    var r, n, a, i;
    bB(this, e);
    for (var s = arguments.length, l = Array(s), o = 0; o < s; o++)
      l[o] = arguments[o];
    return i = (n = (a = yd(this, (r = e.__proto__ || Object.getPrototypeOf(e)).call.apply(r, [this].concat(l))), a), a.handleChange = function(u) {
      var c = mB(u, a.props.direction, a.props.hsl, a.container);
      c && typeof a.props.onChange == "function" && a.props.onChange(c, u);
    }, a.handleMouseDown = function(u) {
      a.handleChange(u), window.addEventListener("mousemove", a.handleChange), window.addEventListener("mouseup", a.handleMouseUp);
    }, a.handleMouseUp = function() {
      a.unbindEventListeners();
    }, n), yd(a, i);
  }
  return yB(e, [{
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "unbindEventListeners",
    value: function() {
      window.removeEventListener("mousemove", this.handleChange), window.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props.direction, i = a === void 0 ? "horizontal" : a, s = ge({
        default: {
          hue: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: "0 2px",
            position: "relative",
            height: "100%",
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            left: this.props.hsl.h * 100 / 360 + "%"
          },
          slider: {
            marginTop: "1px",
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            transform: "translateX(-2px)"
          }
        },
        vertical: {
          pointer: {
            left: "0px",
            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
          }
        }
      }, { vertical: i === "vertical" });
      return M.createElement(
        "div",
        { style: s.hue },
        M.createElement(
          "div",
          {
            className: "hue-" + i,
            style: s.container,
            ref: function(o) {
              return n.container = o;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          M.createElement(
            "style",
            null,
            `
            .hue-horizontal {
              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0
                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
              background: -webkit-linear-gradient(to right, #f00 0%, #ff0
                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
            }

            .hue-vertical {
              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,
                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,
                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
            }
          `
          ),
          M.createElement(
            "div",
            { style: s.pointer },
            this.props.pointer ? M.createElement(this.props.pointer, this.props) : M.createElement("div", { style: s.slider })
          )
        )
      );
    }
  }]), e;
}(wi || da);
function xB() {
  this.__data__ = [], this.size = 0;
}
function Ti(t, e) {
  return t === e || t !== t && e !== e;
}
function Zs(t, e) {
  for (var r = t.length; r--; )
    if (Ti(t[r][0], e))
      return r;
  return -1;
}
var EB = Array.prototype, CB = EB.splice;
function DB(t) {
  var e = this.__data__, r = Zs(e, t);
  if (r < 0)
    return !1;
  var n = e.length - 1;
  return r == n ? e.pop() : CB.call(e, r, 1), --this.size, !0;
}
function SB(t) {
  var e = this.__data__, r = Zs(e, t);
  return r < 0 ? void 0 : e[r][1];
}
function OB(t) {
  return Zs(this.__data__, t) > -1;
}
function PB(t, e) {
  var r = this.__data__, n = Zs(r, t);
  return n < 0 ? (++this.size, r.push([t, e])) : r[n][1] = e, this;
}
function Ar(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
Ar.prototype.clear = xB;
Ar.prototype.delete = DB;
Ar.prototype.get = SB;
Ar.prototype.has = OB;
Ar.prototype.set = PB;
function _B() {
  this.__data__ = new Ar(), this.size = 0;
}
function AB(t) {
  var e = this.__data__, r = e.delete(t);
  return this.size = e.size, r;
}
function TB(t) {
  return this.__data__.get(t);
}
function BB(t) {
  return this.__data__.has(t);
}
var RB = typeof global == "object" && global && global.Object === Object && global;
const rm = RB;
var $B = typeof self == "object" && self && self.Object === Object && self, MB = rm || $B || Function("return this")();
const rr = MB;
var FB = rr.Symbol;
const Ur = FB;
var nm = Object.prototype, IB = nm.hasOwnProperty, jB = nm.toString, Ba = Ur ? Ur.toStringTag : void 0;
function LB(t) {
  var e = IB.call(t, Ba), r = t[Ba];
  try {
    t[Ba] = void 0;
    var n = !0;
  } catch {
  }
  var a = jB.call(t);
  return n && (e ? t[Ba] = r : delete t[Ba]), a;
}
var kB = Object.prototype, NB = kB.toString;
function zB(t) {
  return NB.call(t);
}
var WB = "[object Null]", HB = "[object Undefined]", bd = Ur ? Ur.toStringTag : void 0;
function bn(t) {
  return t == null ? t === void 0 ? HB : WB : bd && bd in Object(t) ? LB(t) : zB(t);
}
function Ut(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var UB = "[object AsyncFunction]", VB = "[object Function]", qB = "[object GeneratorFunction]", GB = "[object Proxy]";
function Hu(t) {
  if (!Ut(t))
    return !1;
  var e = bn(t);
  return e == VB || e == qB || e == UB || e == GB;
}
var YB = rr["__core-js_shared__"];
const Ro = YB;
var wd = function() {
  var t = /[^.]+$/.exec(Ro && Ro.keys && Ro.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function KB(t) {
  return !!wd && wd in t;
}
var XB = Function.prototype, ZB = XB.toString;
function wn(t) {
  if (t != null) {
    try {
      return ZB.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var JB = /[\\^$.*+?()[\]{}|]/g, QB = /^\[object .+?Constructor\]$/, eR = Function.prototype, tR = Object.prototype, rR = eR.toString, nR = tR.hasOwnProperty, aR = RegExp(
  "^" + rR.call(nR).replace(JB, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function iR(t) {
  if (!Ut(t) || KB(t))
    return !1;
  var e = Hu(t) ? aR : QB;
  return e.test(wn(t));
}
function sR(t, e) {
  return t == null ? void 0 : t[e];
}
function xn(t, e) {
  var r = sR(t, e);
  return iR(r) ? r : void 0;
}
var oR = xn(rr, "Map");
const ui = oR;
var lR = xn(Object, "create");
const ci = lR;
function uR() {
  this.__data__ = ci ? ci(null) : {}, this.size = 0;
}
function cR(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var fR = "__lodash_hash_undefined__", dR = Object.prototype, pR = dR.hasOwnProperty;
function hR(t) {
  var e = this.__data__;
  if (ci) {
    var r = e[t];
    return r === fR ? void 0 : r;
  }
  return pR.call(e, t) ? e[t] : void 0;
}
var gR = Object.prototype, vR = gR.hasOwnProperty;
function mR(t) {
  var e = this.__data__;
  return ci ? e[t] !== void 0 : vR.call(e, t);
}
var yR = "__lodash_hash_undefined__";
function bR(t, e) {
  var r = this.__data__;
  return this.size += this.has(t) ? 0 : 1, r[t] = ci && e === void 0 ? yR : e, this;
}
function fn(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
fn.prototype.clear = uR;
fn.prototype.delete = cR;
fn.prototype.get = hR;
fn.prototype.has = mR;
fn.prototype.set = bR;
function wR() {
  this.size = 0, this.__data__ = {
    hash: new fn(),
    map: new (ui || Ar)(),
    string: new fn()
  };
}
function xR(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function Js(t, e) {
  var r = t.__data__;
  return xR(e) ? r[typeof e == "string" ? "string" : "hash"] : r.map;
}
function ER(t) {
  var e = Js(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
function CR(t) {
  return Js(this, t).get(t);
}
function DR(t) {
  return Js(this, t).has(t);
}
function SR(t, e) {
  var r = Js(this, t), n = r.size;
  return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
}
function Tr(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
Tr.prototype.clear = wR;
Tr.prototype.delete = ER;
Tr.prototype.get = CR;
Tr.prototype.has = DR;
Tr.prototype.set = SR;
var OR = 200;
function PR(t, e) {
  var r = this.__data__;
  if (r instanceof Ar) {
    var n = r.__data__;
    if (!ui || n.length < OR - 1)
      return n.push([t, e]), this.size = ++r.size, this;
    r = this.__data__ = new Tr(n);
  }
  return r.set(t, e), this.size = r.size, this;
}
function ur(t) {
  var e = this.__data__ = new Ar(t);
  this.size = e.size;
}
ur.prototype.clear = _B;
ur.prototype.delete = AB;
ur.prototype.get = TB;
ur.prototype.has = BB;
ur.prototype.set = PR;
var _R = function() {
  try {
    var t = xn(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}();
const ys = _R;
function Uu(t, e, r) {
  e == "__proto__" && ys ? ys(t, e, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : t[e] = r;
}
function kl(t, e, r) {
  (r !== void 0 && !Ti(t[e], r) || r === void 0 && !(e in t)) && Uu(t, e, r);
}
function AR(t) {
  return function(e, r, n) {
    for (var a = -1, i = Object(e), s = n(e), l = s.length; l--; ) {
      var o = s[t ? l : ++a];
      if (r(i[o], o, i) === !1)
        break;
    }
    return e;
  };
}
var TR = AR();
const am = TR;
var im = typeof exports == "object" && exports && !exports.nodeType && exports, xd = im && typeof module == "object" && module && !module.nodeType && module, BR = xd && xd.exports === im, Ed = BR ? rr.Buffer : void 0, Cd = Ed ? Ed.allocUnsafe : void 0;
function RR(t, e) {
  if (e)
    return t.slice();
  var r = t.length, n = Cd ? Cd(r) : new t.constructor(r);
  return t.copy(n), n;
}
var $R = rr.Uint8Array;
const bs = $R;
function MR(t) {
  var e = new t.constructor(t.byteLength);
  return new bs(e).set(new bs(t)), e;
}
function FR(t, e) {
  var r = e ? MR(t.buffer) : t.buffer;
  return new t.constructor(r, t.byteOffset, t.length);
}
function IR(t, e) {
  var r = -1, n = t.length;
  for (e || (e = Array(n)); ++r < n; )
    e[r] = t[r];
  return e;
}
var Dd = Object.create, jR = function() {
  function t() {
  }
  return function(e) {
    if (!Ut(e))
      return {};
    if (Dd)
      return Dd(e);
    t.prototype = e;
    var r = new t();
    return t.prototype = void 0, r;
  };
}();
const LR = jR;
function sm(t, e) {
  return function(r) {
    return t(e(r));
  };
}
var kR = sm(Object.getPrototypeOf, Object);
const om = kR;
var NR = Object.prototype;
function Vu(t) {
  var e = t && t.constructor, r = typeof e == "function" && e.prototype || NR;
  return t === r;
}
function zR(t) {
  return typeof t.constructor == "function" && !Vu(t) ? LR(om(t)) : {};
}
function Vr(t) {
  return t != null && typeof t == "object";
}
var WR = "[object Arguments]";
function Sd(t) {
  return Vr(t) && bn(t) == WR;
}
var lm = Object.prototype, HR = lm.hasOwnProperty, UR = lm.propertyIsEnumerable, VR = Sd(function() {
  return arguments;
}()) ? Sd : function(t) {
  return Vr(t) && HR.call(t, "callee") && !UR.call(t, "callee");
};
const ws = VR;
var qR = Array.isArray;
const Mt = qR;
var GR = 9007199254740991;
function qu(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= GR;
}
function xa(t) {
  return t != null && qu(t.length) && !Hu(t);
}
function YR(t) {
  return Vr(t) && xa(t);
}
function KR() {
  return !1;
}
var um = typeof exports == "object" && exports && !exports.nodeType && exports, Od = um && typeof module == "object" && module && !module.nodeType && module, XR = Od && Od.exports === um, Pd = XR ? rr.Buffer : void 0, ZR = Pd ? Pd.isBuffer : void 0, JR = ZR || KR;
const xs = JR;
var QR = "[object Object]", e3 = Function.prototype, t3 = Object.prototype, cm = e3.toString, r3 = t3.hasOwnProperty, n3 = cm.call(Object);
function a3(t) {
  if (!Vr(t) || bn(t) != QR)
    return !1;
  var e = om(t);
  if (e === null)
    return !0;
  var r = r3.call(e, "constructor") && e.constructor;
  return typeof r == "function" && r instanceof r && cm.call(r) == n3;
}
var i3 = "[object Arguments]", s3 = "[object Array]", o3 = "[object Boolean]", l3 = "[object Date]", u3 = "[object Error]", c3 = "[object Function]", f3 = "[object Map]", d3 = "[object Number]", p3 = "[object Object]", h3 = "[object RegExp]", g3 = "[object Set]", v3 = "[object String]", m3 = "[object WeakMap]", y3 = "[object ArrayBuffer]", b3 = "[object DataView]", w3 = "[object Float32Array]", x3 = "[object Float64Array]", E3 = "[object Int8Array]", C3 = "[object Int16Array]", D3 = "[object Int32Array]", S3 = "[object Uint8Array]", O3 = "[object Uint8ClampedArray]", P3 = "[object Uint16Array]", _3 = "[object Uint32Array]", Ve = {};
Ve[w3] = Ve[x3] = Ve[E3] = Ve[C3] = Ve[D3] = Ve[S3] = Ve[O3] = Ve[P3] = Ve[_3] = !0;
Ve[i3] = Ve[s3] = Ve[y3] = Ve[o3] = Ve[b3] = Ve[l3] = Ve[u3] = Ve[c3] = Ve[f3] = Ve[d3] = Ve[p3] = Ve[h3] = Ve[g3] = Ve[v3] = Ve[m3] = !1;
function A3(t) {
  return Vr(t) && qu(t.length) && !!Ve[bn(t)];
}
function T3(t) {
  return function(e) {
    return t(e);
  };
}
var fm = typeof exports == "object" && exports && !exports.nodeType && exports, Xa = fm && typeof module == "object" && module && !module.nodeType && module, B3 = Xa && Xa.exports === fm, $o = B3 && rm.process, R3 = function() {
  try {
    var t = Xa && Xa.require && Xa.require("util").types;
    return t || $o && $o.binding && $o.binding("util");
  } catch {
  }
}();
const _d = R3;
var Ad = _d && _d.isTypedArray, $3 = Ad ? T3(Ad) : A3;
const Gu = $3;
function Nl(t, e) {
  if (!(e === "constructor" && typeof t[e] == "function") && e != "__proto__")
    return t[e];
}
var M3 = Object.prototype, F3 = M3.hasOwnProperty;
function I3(t, e, r) {
  var n = t[e];
  (!(F3.call(t, e) && Ti(n, r)) || r === void 0 && !(e in t)) && Uu(t, e, r);
}
function j3(t, e, r, n) {
  var a = !r;
  r || (r = {});
  for (var i = -1, s = e.length; ++i < s; ) {
    var l = e[i], o = n ? n(r[l], t[l], l, r, t) : void 0;
    o === void 0 && (o = t[l]), a ? Uu(r, l, o) : I3(r, l, o);
  }
  return r;
}
function L3(t, e) {
  for (var r = -1, n = Array(t); ++r < t; )
    n[r] = e(r);
  return n;
}
var k3 = 9007199254740991, N3 = /^(?:0|[1-9]\d*)$/;
function Yu(t, e) {
  var r = typeof t;
  return e = e ?? k3, !!e && (r == "number" || r != "symbol" && N3.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var z3 = Object.prototype, W3 = z3.hasOwnProperty;
function dm(t, e) {
  var r = Mt(t), n = !r && ws(t), a = !r && !n && xs(t), i = !r && !n && !a && Gu(t), s = r || n || a || i, l = s ? L3(t.length, String) : [], o = l.length;
  for (var u in t)
    (e || W3.call(t, u)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    Yu(u, o))) && l.push(u);
  return l;
}
function H3(t) {
  var e = [];
  if (t != null)
    for (var r in Object(t))
      e.push(r);
  return e;
}
var U3 = Object.prototype, V3 = U3.hasOwnProperty;
function q3(t) {
  if (!Ut(t))
    return H3(t);
  var e = Vu(t), r = [];
  for (var n in t)
    n == "constructor" && (e || !V3.call(t, n)) || r.push(n);
  return r;
}
function pm(t) {
  return xa(t) ? dm(t, !0) : q3(t);
}
function G3(t) {
  return j3(t, pm(t));
}
function Y3(t, e, r, n, a, i, s) {
  var l = Nl(t, r), o = Nl(e, r), u = s.get(o);
  if (u) {
    kl(t, r, u);
    return;
  }
  var c = i ? i(l, o, r + "", t, e, s) : void 0, f = c === void 0;
  if (f) {
    var p = Mt(o), g = !p && xs(o), m = !p && !g && Gu(o);
    c = o, p || g || m ? Mt(l) ? c = l : YR(l) ? c = IR(l) : g ? (f = !1, c = RR(o, !0)) : m ? (f = !1, c = FR(o, !0)) : c = [] : a3(o) || ws(o) ? (c = l, ws(l) ? c = G3(l) : (!Ut(l) || Hu(l)) && (c = zR(o))) : f = !1;
  }
  f && (s.set(o, c), a(c, o, n, i, s), s.delete(o)), kl(t, r, c);
}
function hm(t, e, r, n, a) {
  t !== e && am(e, function(i, s) {
    if (a || (a = new ur()), Ut(i))
      Y3(t, e, s, r, hm, n, a);
    else {
      var l = n ? n(Nl(t, s), i, s + "", t, e, a) : void 0;
      l === void 0 && (l = i), kl(t, s, l);
    }
  }, pm);
}
function Qs(t) {
  return t;
}
function K3(t, e, r) {
  switch (r.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, r[0]);
    case 2:
      return t.call(e, r[0], r[1]);
    case 3:
      return t.call(e, r[0], r[1], r[2]);
  }
  return t.apply(e, r);
}
var Td = Math.max;
function X3(t, e, r) {
  return e = Td(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var n = arguments, a = -1, i = Td(n.length - e, 0), s = Array(i); ++a < i; )
      s[a] = n[e + a];
    a = -1;
    for (var l = Array(e + 1); ++a < e; )
      l[a] = n[a];
    return l[e] = r(s), K3(t, this, l);
  };
}
function Z3(t) {
  return function() {
    return t;
  };
}
var J3 = ys ? function(t, e) {
  return ys(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Z3(e),
    writable: !0
  });
} : Qs;
const Q3 = J3;
var e$ = 800, t$ = 16, r$ = Date.now;
function n$(t) {
  var e = 0, r = 0;
  return function() {
    var n = r$(), a = t$ - (n - r);
    if (r = n, a > 0) {
      if (++e >= e$)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
var a$ = n$(Q3);
const i$ = a$;
function s$(t, e) {
  return i$(X3(t, e, Qs), t + "");
}
function o$(t, e, r) {
  if (!Ut(r))
    return !1;
  var n = typeof e;
  return (n == "number" ? xa(r) && Yu(e, r.length) : n == "string" && e in r) ? Ti(r[e], t) : !1;
}
function l$(t) {
  return s$(function(e, r) {
    var n = -1, a = r.length, i = a > 1 ? r[a - 1] : void 0, s = a > 2 ? r[2] : void 0;
    for (i = t.length > 3 && typeof i == "function" ? (a--, i) : void 0, s && o$(r[0], r[1], s) && (i = a < 3 ? void 0 : i, a = 1), e = Object(e); ++n < a; ) {
      var l = r[n];
      l && t(e, l, n, i);
    }
    return e;
  });
}
var u$ = l$(function(t, e, r) {
  hm(t, e, r);
});
const _t = u$;
var Bi = function(e) {
  var r = e.zDepth, n = e.radius, a = e.background, i = e.children, s = e.styles, l = s === void 0 ? {} : s, o = ge(_t({
    default: {
      wrap: {
        position: "relative",
        display: "inline-block"
      },
      content: {
        position: "relative"
      },
      bg: {
        absolute: "0px 0px 0px 0px",
        boxShadow: "0 " + r + "px " + r * 4 + "px rgba(0,0,0,.24)",
        borderRadius: n,
        background: a
      }
    },
    "zDepth-0": {
      bg: {
        boxShadow: "none"
      }
    },
    "zDepth-1": {
      bg: {
        boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
      }
    },
    "zDepth-2": {
      bg: {
        boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
      }
    },
    "zDepth-3": {
      bg: {
        boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
      }
    },
    "zDepth-4": {
      bg: {
        boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
      }
    },
    "zDepth-5": {
      bg: {
        boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
      }
    },
    square: {
      bg: {
        borderRadius: "0"
      }
    },
    circle: {
      bg: {
        borderRadius: "50%"
      }
    }
  }, l), { "zDepth-1": r === 1 });
  return M.createElement(
    "div",
    { style: o.wrap },
    M.createElement("div", { style: o.bg }),
    M.createElement(
      "div",
      { style: o.content },
      i
    )
  );
};
Bi.propTypes = {
  background: ee.string,
  zDepth: ee.oneOf([0, 1, 2, 3, 4, 5]),
  radius: ee.number,
  styles: ee.object
};
Bi.defaultProps = {
  background: "#fff",
  zDepth: 1,
  radius: 2,
  styles: {}
};
var c$ = function() {
  return rr.Date.now();
};
const Mo = c$;
var f$ = /\s/;
function d$(t) {
  for (var e = t.length; e-- && f$.test(t.charAt(e)); )
    ;
  return e;
}
var p$ = /^\s+/;
function h$(t) {
  return t && t.slice(0, d$(t) + 1).replace(p$, "");
}
var g$ = "[object Symbol]";
function eo(t) {
  return typeof t == "symbol" || Vr(t) && bn(t) == g$;
}
var Bd = 0 / 0, v$ = /^[-+]0x[0-9a-f]+$/i, m$ = /^0b[01]+$/i, y$ = /^0o[0-7]+$/i, b$ = parseInt;
function Rd(t) {
  if (typeof t == "number")
    return t;
  if (eo(t))
    return Bd;
  if (Ut(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = Ut(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = h$(t);
  var r = m$.test(t);
  return r || y$.test(t) ? b$(t.slice(2), r ? 2 : 8) : v$.test(t) ? Bd : +t;
}
var w$ = "Expected a function", x$ = Math.max, E$ = Math.min;
function gm(t, e, r) {
  var n, a, i, s, l, o, u = 0, c = !1, f = !1, p = !0;
  if (typeof t != "function")
    throw new TypeError(w$);
  e = Rd(e) || 0, Ut(r) && (c = !!r.leading, f = "maxWait" in r, i = f ? x$(Rd(r.maxWait) || 0, e) : i, p = "trailing" in r ? !!r.trailing : p);
  function g(A) {
    var D = n, h = a;
    return n = a = void 0, u = A, s = t.apply(h, D), s;
  }
  function m(A) {
    return u = A, l = setTimeout(b, e), c ? g(A) : s;
  }
  function d(A) {
    var D = A - o, h = A - u, y = e - D;
    return f ? E$(y, i - h) : y;
  }
  function w(A) {
    var D = A - o, h = A - u;
    return o === void 0 || D >= e || D < 0 || f && h >= i;
  }
  function b() {
    var A = Mo();
    if (w(A))
      return O(A);
    l = setTimeout(b, d(A));
  }
  function O(A) {
    return l = void 0, p && n ? g(A) : (n = a = void 0, s);
  }
  function S() {
    l !== void 0 && clearTimeout(l), u = 0, n = o = a = l = void 0;
  }
  function B() {
    return l === void 0 ? s : O(Mo());
  }
  function T() {
    var A = Mo(), D = w(A);
    if (n = arguments, a = this, o = A, D) {
      if (l === void 0)
        return m(o);
      if (f)
        return clearTimeout(l), l = setTimeout(b, e), g(o);
    }
    return l === void 0 && (l = setTimeout(b, e)), s;
  }
  return T.cancel = S, T.flush = B, T;
}
var C$ = "Expected a function";
function D$(t, e, r) {
  var n = !0, a = !0;
  if (typeof t != "function")
    throw new TypeError(C$);
  return Ut(r) && (n = "leading" in r ? !!r.leading : n, a = "trailing" in r ? !!r.trailing : a), gm(t, e, {
    leading: n,
    maxWait: e,
    trailing: a
  });
}
var S$ = function(e, r, n) {
  var a = n.getBoundingClientRect(), i = a.width, s = a.height, l = typeof e.pageX == "number" ? e.pageX : e.touches[0].pageX, o = typeof e.pageY == "number" ? e.pageY : e.touches[0].pageY, u = l - (n.getBoundingClientRect().left + window.pageXOffset), c = o - (n.getBoundingClientRect().top + window.pageYOffset);
  u < 0 ? u = 0 : u > i && (u = i), c < 0 ? c = 0 : c > s && (c = s);
  var f = u / i, p = 1 - c / s;
  return {
    h: r.h,
    s: f,
    v: p,
    a: r.a,
    source: "hsv"
  };
}, O$ = function() {
  function t(e, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, r, n) {
    return r && t(e.prototype, r), n && t(e, n), e;
  };
}();
function P$(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function _$(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function A$(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var to = function(t) {
  A$(e, t);
  function e(r) {
    P$(this, e);
    var n = _$(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, r));
    return n.handleChange = function(a) {
      typeof n.props.onChange == "function" && n.throttle(n.props.onChange, S$(a, n.props.hsl, n.container), a);
    }, n.handleMouseDown = function(a) {
      n.handleChange(a);
      var i = n.getContainerRenderWindow();
      i.addEventListener("mousemove", n.handleChange), i.addEventListener("mouseup", n.handleMouseUp);
    }, n.handleMouseUp = function() {
      n.unbindEventListeners();
    }, n.throttle = D$(function(a, i, s) {
      a(i, s);
    }, 50), n;
  }
  return O$(e, [{
    key: "componentWillUnmount",
    value: function() {
      this.throttle.cancel(), this.unbindEventListeners();
    }
  }, {
    key: "getContainerRenderWindow",
    value: function() {
      for (var n = this.container, a = window; !a.document.contains(n) && a.parent !== a; )
        a = a.parent;
      return a;
    }
  }, {
    key: "unbindEventListeners",
    value: function() {
      var n = this.getContainerRenderWindow();
      n.removeEventListener("mousemove", this.handleChange), n.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props.style || {}, i = a.color, s = a.white, l = a.black, o = a.pointer, u = a.circle, c = ge({
        default: {
          color: {
            absolute: "0px 0px 0px 0px",
            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
            borderRadius: this.props.radius
          },
          white: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          black: {
            absolute: "0px 0px 0px 0px",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            top: -(this.props.hsv.v * 100) + 100 + "%",
            left: this.props.hsv.s * 100 + "%",
            cursor: "default"
          },
          circle: {
            width: "4px",
            height: "4px",
            boxShadow: `0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),
            0 0 1px 2px rgba(0,0,0,.4)`,
            borderRadius: "50%",
            cursor: "hand",
            transform: "translate(-2px, -2px)"
          }
        },
        custom: {
          color: i,
          white: s,
          black: l,
          pointer: o,
          circle: u
        }
      }, { custom: !!this.props.style });
      return M.createElement(
        "div",
        {
          style: c.color,
          ref: function(p) {
            return n.container = p;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        M.createElement(
          "style",
          null,
          `
          .saturation-white {
            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));
            background: linear-gradient(to right, #fff, rgba(255,255,255,0));
          }
          .saturation-black {
            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));
            background: linear-gradient(to top, #000, rgba(0,0,0,0));
          }
        `
        ),
        M.createElement(
          "div",
          { style: c.white, className: "saturation-white" },
          M.createElement("div", { style: c.black, className: "saturation-black" }),
          M.createElement(
            "div",
            { style: c.pointer },
            this.props.pointer ? M.createElement(this.props.pointer, this.props) : M.createElement("div", { style: c.circle })
          )
        )
      );
    }
  }]), e;
}(wi || da);
function T$(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length; ++r < n && e(t[r], r, t) !== !1; )
    ;
  return t;
}
var B$ = sm(Object.keys, Object);
const R$ = B$;
var $$ = Object.prototype, M$ = $$.hasOwnProperty;
function F$(t) {
  if (!Vu(t))
    return R$(t);
  var e = [];
  for (var r in Object(t))
    M$.call(t, r) && r != "constructor" && e.push(r);
  return e;
}
function Ku(t) {
  return xa(t) ? dm(t) : F$(t);
}
function I$(t, e) {
  return t && am(t, e, Ku);
}
function j$(t, e) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!xa(r))
      return t(r, n);
    for (var a = r.length, i = e ? a : -1, s = Object(r); (e ? i-- : ++i < a) && n(s[i], i, s) !== !1; )
      ;
    return r;
  };
}
var L$ = j$(I$);
const vm = L$;
function k$(t) {
  return typeof t == "function" ? t : Qs;
}
function N$(t, e) {
  var r = Mt(t) ? T$ : vm;
  return r(t, k$(e));
}
function Es(t) {
  "@babel/helpers - typeof";
  return Es = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Es(t);
}
var z$ = /^\s+/, W$ = /\s+$/;
function le(t, e) {
  if (t = t || "", e = e || {}, t instanceof le)
    return t;
  if (!(this instanceof le))
    return new le(t, e);
  var r = H$(t);
  this._originalInput = t, this._r = r.r, this._g = r.g, this._b = r.b, this._a = r.a, this._roundA = Math.round(100 * this._a) / 100, this._format = e.format || r.format, this._gradientType = e.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = r.ok;
}
le.prototype = {
  isDark: function() {
    return this.getBrightness() < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  isValid: function() {
    return this._ok;
  },
  getOriginalInput: function() {
    return this._originalInput;
  },
  getFormat: function() {
    return this._format;
  },
  getAlpha: function() {
    return this._a;
  },
  getBrightness: function() {
    var e = this.toRgb();
    return (e.r * 299 + e.g * 587 + e.b * 114) / 1e3;
  },
  getLuminance: function() {
    var e = this.toRgb(), r, n, a, i, s, l;
    return r = e.r / 255, n = e.g / 255, a = e.b / 255, r <= 0.03928 ? i = r / 12.92 : i = Math.pow((r + 0.055) / 1.055, 2.4), n <= 0.03928 ? s = n / 12.92 : s = Math.pow((n + 0.055) / 1.055, 2.4), a <= 0.03928 ? l = a / 12.92 : l = Math.pow((a + 0.055) / 1.055, 2.4), 0.2126 * i + 0.7152 * s + 0.0722 * l;
  },
  setAlpha: function(e) {
    return this._a = mm(e), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function() {
    var e = Md(this._r, this._g, this._b);
    return {
      h: e.h * 360,
      s: e.s,
      v: e.v,
      a: this._a
    };
  },
  toHsvString: function() {
    var e = Md(this._r, this._g, this._b), r = Math.round(e.h * 360), n = Math.round(e.s * 100), a = Math.round(e.v * 100);
    return this._a == 1 ? "hsv(" + r + ", " + n + "%, " + a + "%)" : "hsva(" + r + ", " + n + "%, " + a + "%, " + this._roundA + ")";
  },
  toHsl: function() {
    var e = $d(this._r, this._g, this._b);
    return {
      h: e.h * 360,
      s: e.s,
      l: e.l,
      a: this._a
    };
  },
  toHslString: function() {
    var e = $d(this._r, this._g, this._b), r = Math.round(e.h * 360), n = Math.round(e.s * 100), a = Math.round(e.l * 100);
    return this._a == 1 ? "hsl(" + r + ", " + n + "%, " + a + "%)" : "hsla(" + r + ", " + n + "%, " + a + "%, " + this._roundA + ")";
  },
  toHex: function(e) {
    return Fd(this._r, this._g, this._b, e);
  },
  toHexString: function(e) {
    return "#" + this.toHex(e);
  },
  toHex8: function(e) {
    return G$(this._r, this._g, this._b, this._a, e);
  },
  toHex8String: function(e) {
    return "#" + this.toHex8(e);
  },
  toRgb: function() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function() {
    return {
      r: Math.round(Ye(this._r, 255) * 100) + "%",
      g: Math.round(Ye(this._g, 255) * 100) + "%",
      b: Math.round(Ye(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(Ye(this._r, 255) * 100) + "%, " + Math.round(Ye(this._g, 255) * 100) + "%, " + Math.round(Ye(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(Ye(this._r, 255) * 100) + "%, " + Math.round(Ye(this._g, 255) * 100) + "%, " + Math.round(Ye(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function() {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : iM[Fd(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function(e) {
    var r = "#" + Id(this._r, this._g, this._b, this._a), n = r, a = this._gradientType ? "GradientType = 1, " : "";
    if (e) {
      var i = le(e);
      n = "#" + Id(i._r, i._g, i._b, i._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + a + "startColorstr=" + r + ",endColorstr=" + n + ")";
  },
  toString: function(e) {
    var r = !!e;
    e = e || this._format;
    var n = !1, a = this._a < 1 && this._a >= 0, i = !r && a && (e === "hex" || e === "hex6" || e === "hex3" || e === "hex4" || e === "hex8" || e === "name");
    return i ? e === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (e === "rgb" && (n = this.toRgbString()), e === "prgb" && (n = this.toPercentageRgbString()), (e === "hex" || e === "hex6") && (n = this.toHexString()), e === "hex3" && (n = this.toHexString(!0)), e === "hex4" && (n = this.toHex8String(!0)), e === "hex8" && (n = this.toHex8String()), e === "name" && (n = this.toName()), e === "hsl" && (n = this.toHslString()), e === "hsv" && (n = this.toHsvString()), n || this.toHexString());
  },
  clone: function() {
    return le(this.toString());
  },
  _applyModification: function(e, r) {
    var n = e.apply(null, [this].concat([].slice.call(r)));
    return this._r = n._r, this._g = n._g, this._b = n._b, this.setAlpha(n._a), this;
  },
  lighten: function() {
    return this._applyModification(Z$, arguments);
  },
  brighten: function() {
    return this._applyModification(J$, arguments);
  },
  darken: function() {
    return this._applyModification(Q$, arguments);
  },
  desaturate: function() {
    return this._applyModification(Y$, arguments);
  },
  saturate: function() {
    return this._applyModification(K$, arguments);
  },
  greyscale: function() {
    return this._applyModification(X$, arguments);
  },
  spin: function() {
    return this._applyModification(eM, arguments);
  },
  _applyCombination: function(e, r) {
    return e.apply(null, [this].concat([].slice.call(r)));
  },
  analogous: function() {
    return this._applyCombination(nM, arguments);
  },
  complement: function() {
    return this._applyCombination(tM, arguments);
  },
  monochromatic: function() {
    return this._applyCombination(aM, arguments);
  },
  splitcomplement: function() {
    return this._applyCombination(rM, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function() {
    return this._applyCombination(jd, [3]);
  },
  tetrad: function() {
    return this._applyCombination(jd, [4]);
  }
};
le.fromRatio = function(t, e) {
  if (Es(t) == "object") {
    var r = {};
    for (var n in t)
      t.hasOwnProperty(n) && (n === "a" ? r[n] = t[n] : r[n] = za(t[n]));
    t = r;
  }
  return le(t, e);
};
function H$(t) {
  var e = {
    r: 0,
    g: 0,
    b: 0
  }, r = 1, n = null, a = null, i = null, s = !1, l = !1;
  return typeof t == "string" && (t = uM(t)), Es(t) == "object" && (mr(t.r) && mr(t.g) && mr(t.b) ? (e = U$(t.r, t.g, t.b), s = !0, l = String(t.r).substr(-1) === "%" ? "prgb" : "rgb") : mr(t.h) && mr(t.s) && mr(t.v) ? (n = za(t.s), a = za(t.v), e = q$(t.h, n, a), s = !0, l = "hsv") : mr(t.h) && mr(t.s) && mr(t.l) && (n = za(t.s), i = za(t.l), e = V$(t.h, n, i), s = !0, l = "hsl"), t.hasOwnProperty("a") && (r = t.a)), r = mm(r), {
    ok: s,
    format: t.format || l,
    r: Math.min(255, Math.max(e.r, 0)),
    g: Math.min(255, Math.max(e.g, 0)),
    b: Math.min(255, Math.max(e.b, 0)),
    a: r
  };
}
function U$(t, e, r) {
  return {
    r: Ye(t, 255) * 255,
    g: Ye(e, 255) * 255,
    b: Ye(r, 255) * 255
  };
}
function $d(t, e, r) {
  t = Ye(t, 255), e = Ye(e, 255), r = Ye(r, 255);
  var n = Math.max(t, e, r), a = Math.min(t, e, r), i, s, l = (n + a) / 2;
  if (n == a)
    i = s = 0;
  else {
    var o = n - a;
    switch (s = l > 0.5 ? o / (2 - n - a) : o / (n + a), n) {
      case t:
        i = (e - r) / o + (e < r ? 6 : 0);
        break;
      case e:
        i = (r - t) / o + 2;
        break;
      case r:
        i = (t - e) / o + 4;
        break;
    }
    i /= 6;
  }
  return {
    h: i,
    s,
    l
  };
}
function V$(t, e, r) {
  var n, a, i;
  t = Ye(t, 360), e = Ye(e, 100), r = Ye(r, 100);
  function s(u, c, f) {
    return f < 0 && (f += 1), f > 1 && (f -= 1), f < 1 / 6 ? u + (c - u) * 6 * f : f < 1 / 2 ? c : f < 2 / 3 ? u + (c - u) * (2 / 3 - f) * 6 : u;
  }
  if (e === 0)
    n = a = i = r;
  else {
    var l = r < 0.5 ? r * (1 + e) : r + e - r * e, o = 2 * r - l;
    n = s(o, l, t + 1 / 3), a = s(o, l, t), i = s(o, l, t - 1 / 3);
  }
  return {
    r: n * 255,
    g: a * 255,
    b: i * 255
  };
}
function Md(t, e, r) {
  t = Ye(t, 255), e = Ye(e, 255), r = Ye(r, 255);
  var n = Math.max(t, e, r), a = Math.min(t, e, r), i, s, l = n, o = n - a;
  if (s = n === 0 ? 0 : o / n, n == a)
    i = 0;
  else {
    switch (n) {
      case t:
        i = (e - r) / o + (e < r ? 6 : 0);
        break;
      case e:
        i = (r - t) / o + 2;
        break;
      case r:
        i = (t - e) / o + 4;
        break;
    }
    i /= 6;
  }
  return {
    h: i,
    s,
    v: l
  };
}
function q$(t, e, r) {
  t = Ye(t, 360) * 6, e = Ye(e, 100), r = Ye(r, 100);
  var n = Math.floor(t), a = t - n, i = r * (1 - e), s = r * (1 - a * e), l = r * (1 - (1 - a) * e), o = n % 6, u = [r, s, i, i, l, r][o], c = [l, r, r, s, i, i][o], f = [i, i, l, r, r, s][o];
  return {
    r: u * 255,
    g: c * 255,
    b: f * 255
  };
}
function Fd(t, e, r, n) {
  var a = [Xt(Math.round(t).toString(16)), Xt(Math.round(e).toString(16)), Xt(Math.round(r).toString(16))];
  return n && a[0].charAt(0) == a[0].charAt(1) && a[1].charAt(0) == a[1].charAt(1) && a[2].charAt(0) == a[2].charAt(1) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) : a.join("");
}
function G$(t, e, r, n, a) {
  var i = [Xt(Math.round(t).toString(16)), Xt(Math.round(e).toString(16)), Xt(Math.round(r).toString(16)), Xt(ym(n))];
  return a && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) && i[3].charAt(0) == i[3].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) + i[3].charAt(0) : i.join("");
}
function Id(t, e, r, n) {
  var a = [Xt(ym(n)), Xt(Math.round(t).toString(16)), Xt(Math.round(e).toString(16)), Xt(Math.round(r).toString(16))];
  return a.join("");
}
le.equals = function(t, e) {
  return !t || !e ? !1 : le(t).toRgbString() == le(e).toRgbString();
};
le.random = function() {
  return le.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function Y$(t, e) {
  e = e === 0 ? 0 : e || 10;
  var r = le(t).toHsl();
  return r.s -= e / 100, r.s = ro(r.s), le(r);
}
function K$(t, e) {
  e = e === 0 ? 0 : e || 10;
  var r = le(t).toHsl();
  return r.s += e / 100, r.s = ro(r.s), le(r);
}
function X$(t) {
  return le(t).desaturate(100);
}
function Z$(t, e) {
  e = e === 0 ? 0 : e || 10;
  var r = le(t).toHsl();
  return r.l += e / 100, r.l = ro(r.l), le(r);
}
function J$(t, e) {
  e = e === 0 ? 0 : e || 10;
  var r = le(t).toRgb();
  return r.r = Math.max(0, Math.min(255, r.r - Math.round(255 * -(e / 100)))), r.g = Math.max(0, Math.min(255, r.g - Math.round(255 * -(e / 100)))), r.b = Math.max(0, Math.min(255, r.b - Math.round(255 * -(e / 100)))), le(r);
}
function Q$(t, e) {
  e = e === 0 ? 0 : e || 10;
  var r = le(t).toHsl();
  return r.l -= e / 100, r.l = ro(r.l), le(r);
}
function eM(t, e) {
  var r = le(t).toHsl(), n = (r.h + e) % 360;
  return r.h = n < 0 ? 360 + n : n, le(r);
}
function tM(t) {
  var e = le(t).toHsl();
  return e.h = (e.h + 180) % 360, le(e);
}
function jd(t, e) {
  if (isNaN(e) || e <= 0)
    throw new Error("Argument to polyad must be a positive number");
  for (var r = le(t).toHsl(), n = [le(t)], a = 360 / e, i = 1; i < e; i++)
    n.push(le({
      h: (r.h + i * a) % 360,
      s: r.s,
      l: r.l
    }));
  return n;
}
function rM(t) {
  var e = le(t).toHsl(), r = e.h;
  return [le(t), le({
    h: (r + 72) % 360,
    s: e.s,
    l: e.l
  }), le({
    h: (r + 216) % 360,
    s: e.s,
    l: e.l
  })];
}
function nM(t, e, r) {
  e = e || 6, r = r || 30;
  var n = le(t).toHsl(), a = 360 / r, i = [le(t)];
  for (n.h = (n.h - (a * e >> 1) + 720) % 360; --e; )
    n.h = (n.h + a) % 360, i.push(le(n));
  return i;
}
function aM(t, e) {
  e = e || 6;
  for (var r = le(t).toHsv(), n = r.h, a = r.s, i = r.v, s = [], l = 1 / e; e--; )
    s.push(le({
      h: n,
      s: a,
      v: i
    })), i = (i + l) % 1;
  return s;
}
le.mix = function(t, e, r) {
  r = r === 0 ? 0 : r || 50;
  var n = le(t).toRgb(), a = le(e).toRgb(), i = r / 100, s = {
    r: (a.r - n.r) * i + n.r,
    g: (a.g - n.g) * i + n.g,
    b: (a.b - n.b) * i + n.b,
    a: (a.a - n.a) * i + n.a
  };
  return le(s);
};
le.readability = function(t, e) {
  var r = le(t), n = le(e);
  return (Math.max(r.getLuminance(), n.getLuminance()) + 0.05) / (Math.min(r.getLuminance(), n.getLuminance()) + 0.05);
};
le.isReadable = function(t, e, r) {
  var n = le.readability(t, e), a, i;
  switch (i = !1, a = cM(r), a.level + a.size) {
    case "AAsmall":
    case "AAAlarge":
      i = n >= 4.5;
      break;
    case "AAlarge":
      i = n >= 3;
      break;
    case "AAAsmall":
      i = n >= 7;
      break;
  }
  return i;
};
le.mostReadable = function(t, e, r) {
  var n = null, a = 0, i, s, l, o;
  r = r || {}, s = r.includeFallbackColors, l = r.level, o = r.size;
  for (var u = 0; u < e.length; u++)
    i = le.readability(t, e[u]), i > a && (a = i, n = le(e[u]));
  return le.isReadable(t, n, {
    level: l,
    size: o
  }) || !s ? n : (r.includeFallbackColors = !1, le.mostReadable(t, ["#fff", "#000"], r));
};
var zl = le.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, iM = le.hexNames = sM(zl);
function sM(t) {
  var e = {};
  for (var r in t)
    t.hasOwnProperty(r) && (e[t[r]] = r);
  return e;
}
function mm(t) {
  return t = parseFloat(t), (isNaN(t) || t < 0 || t > 1) && (t = 1), t;
}
function Ye(t, e) {
  oM(t) && (t = "100%");
  var r = lM(t);
  return t = Math.min(e, Math.max(0, parseFloat(t))), r && (t = parseInt(t * e, 10) / 100), Math.abs(t - e) < 1e-6 ? 1 : t % e / parseFloat(e);
}
function ro(t) {
  return Math.min(1, Math.max(0, t));
}
function Bt(t) {
  return parseInt(t, 16);
}
function oM(t) {
  return typeof t == "string" && t.indexOf(".") != -1 && parseFloat(t) === 1;
}
function lM(t) {
  return typeof t == "string" && t.indexOf("%") != -1;
}
function Xt(t) {
  return t.length == 1 ? "0" + t : "" + t;
}
function za(t) {
  return t <= 1 && (t = t * 100 + "%"), t;
}
function ym(t) {
  return Math.round(parseFloat(t) * 255).toString(16);
}
function Ld(t) {
  return Bt(t) / 255;
}
var Kt = function() {
  var t = "[-\\+]?\\d+%?", e = "[-\\+]?\\d*\\.\\d+%?", r = "(?:" + e + ")|(?:" + t + ")", n = "[\\s|\\(]+(" + r + ")[,|\\s]+(" + r + ")[,|\\s]+(" + r + ")\\s*\\)?", a = "[\\s|\\(]+(" + r + ")[,|\\s]+(" + r + ")[,|\\s]+(" + r + ")[,|\\s]+(" + r + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(r),
    rgb: new RegExp("rgb" + n),
    rgba: new RegExp("rgba" + a),
    hsl: new RegExp("hsl" + n),
    hsla: new RegExp("hsla" + a),
    hsv: new RegExp("hsv" + n),
    hsva: new RegExp("hsva" + a),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function mr(t) {
  return !!Kt.CSS_UNIT.exec(t);
}
function uM(t) {
  t = t.replace(z$, "").replace(W$, "").toLowerCase();
  var e = !1;
  if (zl[t])
    t = zl[t], e = !0;
  else if (t == "transparent")
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  var r;
  return (r = Kt.rgb.exec(t)) ? {
    r: r[1],
    g: r[2],
    b: r[3]
  } : (r = Kt.rgba.exec(t)) ? {
    r: r[1],
    g: r[2],
    b: r[3],
    a: r[4]
  } : (r = Kt.hsl.exec(t)) ? {
    h: r[1],
    s: r[2],
    l: r[3]
  } : (r = Kt.hsla.exec(t)) ? {
    h: r[1],
    s: r[2],
    l: r[3],
    a: r[4]
  } : (r = Kt.hsv.exec(t)) ? {
    h: r[1],
    s: r[2],
    v: r[3]
  } : (r = Kt.hsva.exec(t)) ? {
    h: r[1],
    s: r[2],
    v: r[3],
    a: r[4]
  } : (r = Kt.hex8.exec(t)) ? {
    r: Bt(r[1]),
    g: Bt(r[2]),
    b: Bt(r[3]),
    a: Ld(r[4]),
    format: e ? "name" : "hex8"
  } : (r = Kt.hex6.exec(t)) ? {
    r: Bt(r[1]),
    g: Bt(r[2]),
    b: Bt(r[3]),
    format: e ? "name" : "hex"
  } : (r = Kt.hex4.exec(t)) ? {
    r: Bt(r[1] + "" + r[1]),
    g: Bt(r[2] + "" + r[2]),
    b: Bt(r[3] + "" + r[3]),
    a: Ld(r[4] + "" + r[4]),
    format: e ? "name" : "hex8"
  } : (r = Kt.hex3.exec(t)) ? {
    r: Bt(r[1] + "" + r[1]),
    g: Bt(r[2] + "" + r[2]),
    b: Bt(r[3] + "" + r[3]),
    format: e ? "name" : "hex"
  } : !1;
}
function cM(t) {
  var e, r;
  return t = t || {
    level: "AA",
    size: "small"
  }, e = (t.level || "AA").toUpperCase(), r = (t.size || "small").toLowerCase(), e !== "AA" && e !== "AAA" && (e = "AA"), r !== "small" && r !== "large" && (r = "small"), {
    level: e,
    size: r
  };
}
var kd = function(e) {
  var r = ["r", "g", "b", "a", "h", "s", "l", "v"], n = 0, a = 0;
  return N$(r, function(i) {
    if (e[i] && (n += 1, isNaN(e[i]) || (a += 1), i === "s" || i === "l")) {
      var s = /^\d+%$/;
      s.test(e[i]) && (a += 1);
    }
  }), n === a ? e : !1;
}, Wa = function(e, r) {
  var n = e.hex ? le(e.hex) : le(e), a = n.toHsl(), i = n.toHsv(), s = n.toRgb(), l = n.toHex();
  a.s === 0 && (a.h = r || 0, i.h = r || 0);
  var o = l === "000000" && s.a === 0;
  return {
    hsl: a,
    hex: o ? "transparent" : "#" + l,
    rgb: s,
    hsv: i,
    oldHue: e.h || r || a.h,
    source: e.source
  };
}, Yr = function(e) {
  if (e === "transparent")
    return !0;
  var r = String(e).charAt(0) === "#" ? 1 : 0;
  return e.length !== 4 + r && e.length < 7 + r && le(e).isValid();
}, Xu = function(e) {
  if (!e)
    return "#fff";
  var r = Wa(e);
  if (r.hex === "transparent")
    return "rgba(0,0,0,0.4)";
  var n = (r.rgb.r * 299 + r.rgb.g * 587 + r.rgb.b * 114) / 1e3;
  return n >= 128 ? "#000" : "#fff";
}, Fo = function(e, r) {
  var n = e.replace("°", "");
  return le(r + " (" + n + ")")._ok;
}, Ra = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  }
  return t;
}, fM = function() {
  function t(e, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, r, n) {
    return r && t(e.prototype, r), n && t(e, n), e;
  };
}();
function dM(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function pM(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function hM(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var At = function(e) {
  var r = function(n) {
    hM(a, n);
    function a(i) {
      dM(this, a);
      var s = pM(this, (a.__proto__ || Object.getPrototypeOf(a)).call(this));
      return s.handleChange = function(l, o) {
        var u = kd(l);
        if (u) {
          var c = Wa(l, l.h || s.state.oldHue);
          s.setState(c), s.props.onChangeComplete && s.debounce(s.props.onChangeComplete, c, o), s.props.onChange && s.props.onChange(c, o);
        }
      }, s.handleSwatchHover = function(l, o) {
        var u = kd(l);
        if (u) {
          var c = Wa(l, l.h || s.state.oldHue);
          s.props.onSwatchHover && s.props.onSwatchHover(c, o);
        }
      }, s.state = Ra({}, Wa(i.color, 0)), s.debounce = gm(function(l, o, u) {
        l(o, u);
      }, 100), s;
    }
    return fM(a, [{
      key: "render",
      value: function() {
        var s = {};
        return this.props.onSwatchHover && (s.onSwatchHover = this.handleSwatchHover), M.createElement(e, Ra({}, this.props, this.state, {
          onChange: this.handleChange
        }, s));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(s, l) {
        return Ra({}, Wa(s.color, l.oldHue));
      }
    }]), a;
  }(wi || da);
  return r.propTypes = Ra({}, e.propTypes), r.defaultProps = Ra({}, e.defaultProps, {
    color: {
      h: 250,
      s: 0.5,
      l: 0.2,
      a: 1
    }
  }), r;
}, gM = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  }
  return t;
}, vM = function() {
  function t(e, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, r, n) {
    return r && t(e.prototype, r), n && t(e, n), e;
  };
}();
function mM(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Nd(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function yM(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var bM = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(n) {
    yM(a, n);
    function a() {
      var i, s, l, o;
      mM(this, a);
      for (var u = arguments.length, c = Array(u), f = 0; f < u; f++)
        c[f] = arguments[f];
      return o = (s = (l = Nd(this, (i = a.__proto__ || Object.getPrototypeOf(a)).call.apply(i, [this].concat(c))), l), l.state = { focus: !1 }, l.handleFocus = function() {
        return l.setState({ focus: !0 });
      }, l.handleBlur = function() {
        return l.setState({ focus: !1 });
      }, s), Nd(l, o);
    }
    return vM(a, [{
      key: "render",
      value: function() {
        return M.createElement(
          r,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          M.createElement(e, gM({}, this.props, this.state))
        );
      }
    }]), a;
  }(M.Component);
}, zd = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  }
  return t;
}, wM = 13, xM = function(e) {
  var r = e.color, n = e.style, a = e.onClick, i = a === void 0 ? function() {
  } : a, s = e.onHover, l = e.title, o = l === void 0 ? r : l, u = e.children, c = e.focus, f = e.focusStyle, p = f === void 0 ? {} : f, g = r === "transparent", m = ge({
    default: {
      swatch: zd({
        background: r,
        height: "100%",
        width: "100%",
        cursor: "pointer",
        position: "relative",
        outline: "none"
      }, n, c ? p : {})
    }
  }), d = function(B) {
    return i(r, B);
  }, w = function(B) {
    return B.keyCode === wM && i(r, B);
  }, b = function(B) {
    return s(r, B);
  }, O = {};
  return s && (O.onMouseOver = b), M.createElement(
    "div",
    zd({
      style: m.swatch,
      onClick: d,
      title: o,
      tabIndex: 0,
      onKeyDown: w
    }, O),
    u,
    g && M.createElement(ba, {
      borderRadius: m.swatch.borderRadius,
      boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    })
  );
};
const En = bM(xM);
var EM = function(e) {
  var r = e.direction, n = ge({
    default: {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    vertical: {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: r === "vertical" });
  return M.createElement("div", { style: n.picker });
}, CM = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  }
  return t;
}, bm = function(e) {
  var r = e.rgb, n = e.hsl, a = e.width, i = e.height, s = e.onChange, l = e.direction, o = e.style, u = e.renderers, c = e.pointer, f = e.className, p = f === void 0 ? "" : f, g = ge({
    default: {
      picker: {
        position: "relative",
        width: a,
        height: i
      },
      alpha: {
        radius: "2px",
        style: o
      }
    }
  });
  return M.createElement(
    "div",
    { style: g.picker, className: "alpha-picker " + p },
    M.createElement(Wu, CM({}, g.alpha, {
      rgb: r,
      hsl: n,
      pointer: c,
      renderers: u,
      onChange: s,
      direction: l
    }))
  );
};
bm.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: EM
};
At(bm);
function wm(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, a = Array(n); ++r < n; )
    a[r] = e(t[r], r, t);
  return a;
}
var DM = "__lodash_hash_undefined__";
function SM(t) {
  return this.__data__.set(t, DM), this;
}
function OM(t) {
  return this.__data__.has(t);
}
function Cs(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.__data__ = new Tr(); ++e < r; )
    this.add(t[e]);
}
Cs.prototype.add = Cs.prototype.push = SM;
Cs.prototype.has = OM;
function PM(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length; ++r < n; )
    if (e(t[r], r, t))
      return !0;
  return !1;
}
function _M(t, e) {
  return t.has(e);
}
var AM = 1, TM = 2;
function xm(t, e, r, n, a, i) {
  var s = r & AM, l = t.length, o = e.length;
  if (l != o && !(s && o > l))
    return !1;
  var u = i.get(t), c = i.get(e);
  if (u && c)
    return u == e && c == t;
  var f = -1, p = !0, g = r & TM ? new Cs() : void 0;
  for (i.set(t, e), i.set(e, t); ++f < l; ) {
    var m = t[f], d = e[f];
    if (n)
      var w = s ? n(d, m, f, e, t, i) : n(m, d, f, t, e, i);
    if (w !== void 0) {
      if (w)
        continue;
      p = !1;
      break;
    }
    if (g) {
      if (!PM(e, function(b, O) {
        if (!_M(g, O) && (m === b || a(m, b, r, n, i)))
          return g.push(O);
      })) {
        p = !1;
        break;
      }
    } else if (!(m === d || a(m, d, r, n, i))) {
      p = !1;
      break;
    }
  }
  return i.delete(t), i.delete(e), p;
}
function BM(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(n, a) {
    r[++e] = [a, n];
  }), r;
}
function RM(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(n) {
    r[++e] = n;
  }), r;
}
var $M = 1, MM = 2, FM = "[object Boolean]", IM = "[object Date]", jM = "[object Error]", LM = "[object Map]", kM = "[object Number]", NM = "[object RegExp]", zM = "[object Set]", WM = "[object String]", HM = "[object Symbol]", UM = "[object ArrayBuffer]", VM = "[object DataView]", Wd = Ur ? Ur.prototype : void 0, Io = Wd ? Wd.valueOf : void 0;
function qM(t, e, r, n, a, i, s) {
  switch (r) {
    case VM:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case UM:
      return !(t.byteLength != e.byteLength || !i(new bs(t), new bs(e)));
    case FM:
    case IM:
    case kM:
      return Ti(+t, +e);
    case jM:
      return t.name == e.name && t.message == e.message;
    case NM:
    case WM:
      return t == e + "";
    case LM:
      var l = BM;
    case zM:
      var o = n & $M;
      if (l || (l = RM), t.size != e.size && !o)
        return !1;
      var u = s.get(t);
      if (u)
        return u == e;
      n |= MM, s.set(t, e);
      var c = xm(l(t), l(e), n, a, i, s);
      return s.delete(t), c;
    case HM:
      if (Io)
        return Io.call(t) == Io.call(e);
  }
  return !1;
}
function GM(t, e) {
  for (var r = -1, n = e.length, a = t.length; ++r < n; )
    t[a + r] = e[r];
  return t;
}
function YM(t, e, r) {
  var n = e(t);
  return Mt(t) ? n : GM(n, r(t));
}
function KM(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, a = 0, i = []; ++r < n; ) {
    var s = t[r];
    e(s, r, t) && (i[a++] = s);
  }
  return i;
}
function XM() {
  return [];
}
var ZM = Object.prototype, JM = ZM.propertyIsEnumerable, Hd = Object.getOwnPropertySymbols, QM = Hd ? function(t) {
  return t == null ? [] : (t = Object(t), KM(Hd(t), function(e) {
    return JM.call(t, e);
  }));
} : XM;
const eF = QM;
function Ud(t) {
  return YM(t, Ku, eF);
}
var tF = 1, rF = Object.prototype, nF = rF.hasOwnProperty;
function aF(t, e, r, n, a, i) {
  var s = r & tF, l = Ud(t), o = l.length, u = Ud(e), c = u.length;
  if (o != c && !s)
    return !1;
  for (var f = o; f--; ) {
    var p = l[f];
    if (!(s ? p in e : nF.call(e, p)))
      return !1;
  }
  var g = i.get(t), m = i.get(e);
  if (g && m)
    return g == e && m == t;
  var d = !0;
  i.set(t, e), i.set(e, t);
  for (var w = s; ++f < o; ) {
    p = l[f];
    var b = t[p], O = e[p];
    if (n)
      var S = s ? n(O, b, p, e, t, i) : n(b, O, p, t, e, i);
    if (!(S === void 0 ? b === O || a(b, O, r, n, i) : S)) {
      d = !1;
      break;
    }
    w || (w = p == "constructor");
  }
  if (d && !w) {
    var B = t.constructor, T = e.constructor;
    B != T && "constructor" in t && "constructor" in e && !(typeof B == "function" && B instanceof B && typeof T == "function" && T instanceof T) && (d = !1);
  }
  return i.delete(t), i.delete(e), d;
}
var iF = xn(rr, "DataView");
const Wl = iF;
var sF = xn(rr, "Promise");
const Hl = sF;
var oF = xn(rr, "Set");
const Ul = oF;
var lF = xn(rr, "WeakMap");
const Vl = lF;
var Vd = "[object Map]", uF = "[object Object]", qd = "[object Promise]", Gd = "[object Set]", Yd = "[object WeakMap]", Kd = "[object DataView]", cF = wn(Wl), fF = wn(ui), dF = wn(Hl), pF = wn(Ul), hF = wn(Vl), en = bn;
(Wl && en(new Wl(new ArrayBuffer(1))) != Kd || ui && en(new ui()) != Vd || Hl && en(Hl.resolve()) != qd || Ul && en(new Ul()) != Gd || Vl && en(new Vl()) != Yd) && (en = function(t) {
  var e = bn(t), r = e == uF ? t.constructor : void 0, n = r ? wn(r) : "";
  if (n)
    switch (n) {
      case cF:
        return Kd;
      case fF:
        return Vd;
      case dF:
        return qd;
      case pF:
        return Gd;
      case hF:
        return Yd;
    }
  return e;
});
const Xd = en;
var gF = 1, Zd = "[object Arguments]", Jd = "[object Array]", ki = "[object Object]", vF = Object.prototype, Qd = vF.hasOwnProperty;
function mF(t, e, r, n, a, i) {
  var s = Mt(t), l = Mt(e), o = s ? Jd : Xd(t), u = l ? Jd : Xd(e);
  o = o == Zd ? ki : o, u = u == Zd ? ki : u;
  var c = o == ki, f = u == ki, p = o == u;
  if (p && xs(t)) {
    if (!xs(e))
      return !1;
    s = !0, c = !1;
  }
  if (p && !c)
    return i || (i = new ur()), s || Gu(t) ? xm(t, e, r, n, a, i) : qM(t, e, o, r, n, a, i);
  if (!(r & gF)) {
    var g = c && Qd.call(t, "__wrapped__"), m = f && Qd.call(e, "__wrapped__");
    if (g || m) {
      var d = g ? t.value() : t, w = m ? e.value() : e;
      return i || (i = new ur()), a(d, w, r, n, i);
    }
  }
  return p ? (i || (i = new ur()), aF(t, e, r, n, a, i)) : !1;
}
function Zu(t, e, r, n, a) {
  return t === e ? !0 : t == null || e == null || !Vr(t) && !Vr(e) ? t !== t && e !== e : mF(t, e, r, n, Zu, a);
}
var yF = 1, bF = 2;
function wF(t, e, r, n) {
  var a = r.length, i = a, s = !n;
  if (t == null)
    return !i;
  for (t = Object(t); a--; ) {
    var l = r[a];
    if (s && l[2] ? l[1] !== t[l[0]] : !(l[0] in t))
      return !1;
  }
  for (; ++a < i; ) {
    l = r[a];
    var o = l[0], u = t[o], c = l[1];
    if (s && l[2]) {
      if (u === void 0 && !(o in t))
        return !1;
    } else {
      var f = new ur();
      if (n)
        var p = n(u, c, o, t, e, f);
      if (!(p === void 0 ? Zu(c, u, yF | bF, n, f) : p))
        return !1;
    }
  }
  return !0;
}
function Em(t) {
  return t === t && !Ut(t);
}
function xF(t) {
  for (var e = Ku(t), r = e.length; r--; ) {
    var n = e[r], a = t[n];
    e[r] = [n, a, Em(a)];
  }
  return e;
}
function Cm(t, e) {
  return function(r) {
    return r == null ? !1 : r[t] === e && (e !== void 0 || t in Object(r));
  };
}
function EF(t) {
  var e = xF(t);
  return e.length == 1 && e[0][2] ? Cm(e[0][0], e[0][1]) : function(r) {
    return r === t || wF(r, t, e);
  };
}
var CF = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, DF = /^\w*$/;
function Ju(t, e) {
  if (Mt(t))
    return !1;
  var r = typeof t;
  return r == "number" || r == "symbol" || r == "boolean" || t == null || eo(t) ? !0 : DF.test(t) || !CF.test(t) || e != null && t in Object(e);
}
var SF = "Expected a function";
function Qu(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(SF);
  var r = function() {
    var n = arguments, a = e ? e.apply(this, n) : n[0], i = r.cache;
    if (i.has(a))
      return i.get(a);
    var s = t.apply(this, n);
    return r.cache = i.set(a, s) || i, s;
  };
  return r.cache = new (Qu.Cache || Tr)(), r;
}
Qu.Cache = Tr;
var OF = 500;
function PF(t) {
  var e = Qu(t, function(n) {
    return r.size === OF && r.clear(), n;
  }), r = e.cache;
  return e;
}
var _F = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, AF = /\\(\\)?/g, TF = PF(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(_F, function(r, n, a, i) {
    e.push(a ? i.replace(AF, "$1") : n || r);
  }), e;
});
const BF = TF;
var RF = 1 / 0, ep = Ur ? Ur.prototype : void 0, tp = ep ? ep.toString : void 0;
function Dm(t) {
  if (typeof t == "string")
    return t;
  if (Mt(t))
    return wm(t, Dm) + "";
  if (eo(t))
    return tp ? tp.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -RF ? "-0" : e;
}
function $F(t) {
  return t == null ? "" : Dm(t);
}
function Sm(t, e) {
  return Mt(t) ? t : Ju(t, e) ? [t] : BF($F(t));
}
var MF = 1 / 0;
function no(t) {
  if (typeof t == "string" || eo(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -MF ? "-0" : e;
}
function Om(t, e) {
  e = Sm(e, t);
  for (var r = 0, n = e.length; t != null && r < n; )
    t = t[no(e[r++])];
  return r && r == n ? t : void 0;
}
function FF(t, e, r) {
  var n = t == null ? void 0 : Om(t, e);
  return n === void 0 ? r : n;
}
function IF(t, e) {
  return t != null && e in Object(t);
}
function jF(t, e, r) {
  e = Sm(e, t);
  for (var n = -1, a = e.length, i = !1; ++n < a; ) {
    var s = no(e[n]);
    if (!(i = t != null && r(t, s)))
      break;
    t = t[s];
  }
  return i || ++n != a ? i : (a = t == null ? 0 : t.length, !!a && qu(a) && Yu(s, a) && (Mt(t) || ws(t)));
}
function LF(t, e) {
  return t != null && jF(t, e, IF);
}
var kF = 1, NF = 2;
function zF(t, e) {
  return Ju(t) && Em(e) ? Cm(no(t), e) : function(r) {
    var n = FF(r, t);
    return n === void 0 && n === e ? LF(r, t) : Zu(e, n, kF | NF);
  };
}
function WF(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
function HF(t) {
  return function(e) {
    return Om(e, t);
  };
}
function UF(t) {
  return Ju(t) ? WF(no(t)) : HF(t);
}
function VF(t) {
  return typeof t == "function" ? t : t == null ? Qs : typeof t == "object" ? Mt(t) ? zF(t[0], t[1]) : EF(t) : UF(t);
}
function qF(t, e) {
  var r = -1, n = xa(t) ? Array(t.length) : [];
  return vm(t, function(a, i, s) {
    n[++r] = e(a, i, s);
  }), n;
}
function Cn(t, e) {
  var r = Mt(t) ? wm : qF;
  return r(t, VF(e));
}
var GF = function(e) {
  var r = e.colors, n = e.onClick, a = e.onSwatchHover, i = ge({
    default: {
      swatches: {
        marginRight: "-10px"
      },
      swatch: {
        width: "22px",
        height: "22px",
        float: "left",
        marginRight: "10px",
        marginBottom: "10px",
        borderRadius: "4px"
      },
      clear: {
        clear: "both"
      }
    }
  });
  return M.createElement(
    "div",
    { style: i.swatches },
    Cn(r, function(s) {
      return M.createElement(En, {
        key: s,
        color: s,
        style: i.swatch,
        onClick: n,
        onHover: a,
        focusStyle: {
          boxShadow: "0 0 4px " + s
        }
      });
    }),
    M.createElement("div", { style: i.clear })
  );
}, ec = function(e) {
  var r = e.onChange, n = e.onSwatchHover, a = e.hex, i = e.colors, s = e.width, l = e.triangle, o = e.styles, u = o === void 0 ? {} : o, c = e.className, f = c === void 0 ? "" : c, p = a === "transparent", g = function(w, b) {
    Yr(w) && r({
      hex: w,
      source: "hex"
    }, b);
  }, m = ge(_t({
    default: {
      card: {
        width: s,
        background: "#fff",
        boxShadow: "0 1px rgba(0,0,0,.1)",
        borderRadius: "6px",
        position: "relative"
      },
      head: {
        height: "110px",
        background: a,
        borderRadius: "6px 6px 0 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative"
      },
      body: {
        padding: "10px"
      },
      label: {
        fontSize: "18px",
        color: Xu(a),
        position: "relative"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 10px 10px 10px",
        borderColor: "transparent transparent " + a + " transparent",
        position: "absolute",
        top: "-10px",
        left: "50%",
        marginLeft: "-10px"
      },
      input: {
        width: "100%",
        fontSize: "12px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "22px",
        boxShadow: "inset 0 0 0 1px #ddd",
        borderRadius: "4px",
        padding: "0 7px",
        boxSizing: "border-box"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      }
    }
  }, u), { "hide-triangle": l === "hide" });
  return M.createElement(
    "div",
    { style: m.card, className: "block-picker " + f },
    M.createElement("div", { style: m.triangle }),
    M.createElement(
      "div",
      { style: m.head },
      p && M.createElement(ba, { borderRadius: "6px 6px 0 0" }),
      M.createElement(
        "div",
        { style: m.label },
        a
      )
    ),
    M.createElement(
      "div",
      { style: m.body },
      M.createElement(GF, { colors: i, onClick: g, onSwatchHover: n }),
      M.createElement(Pe, {
        style: { input: m.input },
        value: a,
        onChange: g
      })
    )
  );
};
ec.propTypes = {
  width: ee.oneOfType([ee.string, ee.number]),
  colors: ee.arrayOf(ee.string),
  triangle: ee.oneOf(["top", "hide"]),
  styles: ee.object
};
ec.defaultProps = {
  width: 170,
  colors: ["#D9E3F0", "#F47373", "#697689", "#37D67A", "#2CCCE4", "#555555", "#dce775", "#ff8a65", "#ba68c8"],
  triangle: "top",
  styles: {}
};
At(ec);
var Fn = { 50: "#ffebee", 100: "#ffcdd2", 200: "#ef9a9a", 300: "#e57373", 400: "#ef5350", 500: "#f44336", 600: "#e53935", 700: "#d32f2f", 800: "#c62828", 900: "#b71c1c", a100: "#ff8a80", a200: "#ff5252", a400: "#ff1744", a700: "#d50000" }, In = { 50: "#fce4ec", 100: "#f8bbd0", 200: "#f48fb1", 300: "#f06292", 400: "#ec407a", 500: "#e91e63", 600: "#d81b60", 700: "#c2185b", 800: "#ad1457", 900: "#880e4f", a100: "#ff80ab", a200: "#ff4081", a400: "#f50057", a700: "#c51162" }, jn = { 50: "#f3e5f5", 100: "#e1bee7", 200: "#ce93d8", 300: "#ba68c8", 400: "#ab47bc", 500: "#9c27b0", 600: "#8e24aa", 700: "#7b1fa2", 800: "#6a1b9a", 900: "#4a148c", a100: "#ea80fc", a200: "#e040fb", a400: "#d500f9", a700: "#aa00ff" }, Ln = { 50: "#ede7f6", 100: "#d1c4e9", 200: "#b39ddb", 300: "#9575cd", 400: "#7e57c2", 500: "#673ab7", 600: "#5e35b1", 700: "#512da8", 800: "#4527a0", 900: "#311b92", a100: "#b388ff", a200: "#7c4dff", a400: "#651fff", a700: "#6200ea" }, kn = { 50: "#e8eaf6", 100: "#c5cae9", 200: "#9fa8da", 300: "#7986cb", 400: "#5c6bc0", 500: "#3f51b5", 600: "#3949ab", 700: "#303f9f", 800: "#283593", 900: "#1a237e", a100: "#8c9eff", a200: "#536dfe", a400: "#3d5afe", a700: "#304ffe" }, Nn = { 50: "#e3f2fd", 100: "#bbdefb", 200: "#90caf9", 300: "#64b5f6", 400: "#42a5f5", 500: "#2196f3", 600: "#1e88e5", 700: "#1976d2", 800: "#1565c0", 900: "#0d47a1", a100: "#82b1ff", a200: "#448aff", a400: "#2979ff", a700: "#2962ff" }, zn = { 50: "#e1f5fe", 100: "#b3e5fc", 200: "#81d4fa", 300: "#4fc3f7", 400: "#29b6f6", 500: "#03a9f4", 600: "#039be5", 700: "#0288d1", 800: "#0277bd", 900: "#01579b", a100: "#80d8ff", a200: "#40c4ff", a400: "#00b0ff", a700: "#0091ea" }, Wn = { 50: "#e0f7fa", 100: "#b2ebf2", 200: "#80deea", 300: "#4dd0e1", 400: "#26c6da", 500: "#00bcd4", 600: "#00acc1", 700: "#0097a7", 800: "#00838f", 900: "#006064", a100: "#84ffff", a200: "#18ffff", a400: "#00e5ff", a700: "#00b8d4" }, Hn = { 50: "#e0f2f1", 100: "#b2dfdb", 200: "#80cbc4", 300: "#4db6ac", 400: "#26a69a", 500: "#009688", 600: "#00897b", 700: "#00796b", 800: "#00695c", 900: "#004d40", a100: "#a7ffeb", a200: "#64ffda", a400: "#1de9b6", a700: "#00bfa5" }, Ha = { 50: "#e8f5e9", 100: "#c8e6c9", 200: "#a5d6a7", 300: "#81c784", 400: "#66bb6a", 500: "#4caf50", 600: "#43a047", 700: "#388e3c", 800: "#2e7d32", 900: "#1b5e20", a100: "#b9f6ca", a200: "#69f0ae", a400: "#00e676", a700: "#00c853" }, Un = { 50: "#f1f8e9", 100: "#dcedc8", 200: "#c5e1a5", 300: "#aed581", 400: "#9ccc65", 500: "#8bc34a", 600: "#7cb342", 700: "#689f38", 800: "#558b2f", 900: "#33691e", a100: "#ccff90", a200: "#b2ff59", a400: "#76ff03", a700: "#64dd17" }, Vn = { 50: "#f9fbe7", 100: "#f0f4c3", 200: "#e6ee9c", 300: "#dce775", 400: "#d4e157", 500: "#cddc39", 600: "#c0ca33", 700: "#afb42b", 800: "#9e9d24", 900: "#827717", a100: "#f4ff81", a200: "#eeff41", a400: "#c6ff00", a700: "#aeea00" }, qn = { 50: "#fffde7", 100: "#fff9c4", 200: "#fff59d", 300: "#fff176", 400: "#ffee58", 500: "#ffeb3b", 600: "#fdd835", 700: "#fbc02d", 800: "#f9a825", 900: "#f57f17", a100: "#ffff8d", a200: "#ffff00", a400: "#ffea00", a700: "#ffd600" }, Gn = { 50: "#fff8e1", 100: "#ffecb3", 200: "#ffe082", 300: "#ffd54f", 400: "#ffca28", 500: "#ffc107", 600: "#ffb300", 700: "#ffa000", 800: "#ff8f00", 900: "#ff6f00", a100: "#ffe57f", a200: "#ffd740", a400: "#ffc400", a700: "#ffab00" }, Yn = { 50: "#fff3e0", 100: "#ffe0b2", 200: "#ffcc80", 300: "#ffb74d", 400: "#ffa726", 500: "#ff9800", 600: "#fb8c00", 700: "#f57c00", 800: "#ef6c00", 900: "#e65100", a100: "#ffd180", a200: "#ffab40", a400: "#ff9100", a700: "#ff6d00" }, Kn = { 50: "#fbe9e7", 100: "#ffccbc", 200: "#ffab91", 300: "#ff8a65", 400: "#ff7043", 500: "#ff5722", 600: "#f4511e", 700: "#e64a19", 800: "#d84315", 900: "#bf360c", a100: "#ff9e80", a200: "#ff6e40", a400: "#ff3d00", a700: "#dd2c00" }, Xn = { 50: "#efebe9", 100: "#d7ccc8", 200: "#bcaaa4", 300: "#a1887f", 400: "#8d6e63", 500: "#795548", 600: "#6d4c41", 700: "#5d4037", 800: "#4e342e", 900: "#3e2723" }, Zn = { 50: "#eceff1", 100: "#cfd8dc", 200: "#b0bec5", 300: "#90a4ae", 400: "#78909c", 500: "#607d8b", 600: "#546e7a", 700: "#455a64", 800: "#37474f", 900: "#263238" }, Pm = function(e) {
  var r = e.color, n = e.onClick, a = e.onSwatchHover, i = e.hover, s = e.active, l = e.circleSize, o = e.circleSpacing, u = ge({
    default: {
      swatch: {
        width: l,
        height: l,
        marginRight: o,
        marginBottom: o,
        transform: "scale(1)",
        transition: "100ms transform ease"
      },
      Swatch: {
        borderRadius: "50%",
        background: "transparent",
        boxShadow: "inset 0 0 0 " + (l / 2 + 1) + "px " + r,
        transition: "100ms box-shadow ease"
      }
    },
    hover: {
      swatch: {
        transform: "scale(1.2)"
      }
    },
    active: {
      Swatch: {
        boxShadow: "inset 0 0 0 3px " + r
      }
    }
  }, { hover: i, active: s });
  return M.createElement(
    "div",
    { style: u.swatch },
    M.createElement(En, {
      style: u.Swatch,
      color: r,
      onClick: n,
      onHover: a,
      focusStyle: { boxShadow: u.Swatch.boxShadow + ", 0 0 5px " + r }
    })
  );
};
Pm.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};
const YF = zu(Pm);
var tc = function(e) {
  var r = e.width, n = e.onChange, a = e.onSwatchHover, i = e.colors, s = e.hex, l = e.circleSize, o = e.styles, u = o === void 0 ? {} : o, c = e.circleSpacing, f = e.className, p = f === void 0 ? "" : f, g = ge(_t({
    default: {
      card: {
        width: r,
        display: "flex",
        flexWrap: "wrap",
        marginRight: -c,
        marginBottom: -c
      }
    }
  }, u)), m = function(w, b) {
    return n({ hex: w, source: "hex" }, b);
  };
  return M.createElement(
    "div",
    { style: g.card, className: "circle-picker " + p },
    Cn(i, function(d) {
      return M.createElement(YF, {
        key: d,
        color: d,
        onClick: m,
        onSwatchHover: a,
        active: s === d.toLowerCase(),
        circleSize: l,
        circleSpacing: c
      });
    })
  );
};
tc.propTypes = {
  width: ee.oneOfType([ee.string, ee.number]),
  circleSize: ee.number,
  circleSpacing: ee.number,
  styles: ee.object
};
tc.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [Fn[500], In[500], jn[500], Ln[500], kn[500], Nn[500], zn[500], Wn[500], Hn[500], Ha[500], Un[500], Vn[500], qn[500], Gn[500], Yn[500], Kn[500], Xn[500], Zn[500]],
  styles: {}
};
At(tc);
function rp(t) {
  return t === void 0;
}
var _m = {};
Object.defineProperty(_m, "__esModule", {
  value: !0
});
var np = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  }
  return t;
}, KF = M, ap = XF(KF);
function XF(t) {
  return t && t.__esModule ? t : { default: t };
}
function ZF(t, e) {
  var r = {};
  for (var n in t)
    e.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
  return r;
}
var Ni = 24, JF = _m.default = function(t) {
  var e = t.fill, r = e === void 0 ? "currentColor" : e, n = t.width, a = n === void 0 ? Ni : n, i = t.height, s = i === void 0 ? Ni : i, l = t.style, o = l === void 0 ? {} : l, u = ZF(t, ["fill", "width", "height", "style"]);
  return ap.default.createElement(
    "svg",
    np({
      viewBox: "0 0 " + Ni + " " + Ni,
      style: np({ fill: r, width: a, height: s }, o)
    }, u),
    ap.default.createElement("path", { d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z" })
  );
}, QF = function() {
  function t(e, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, r, n) {
    return r && t(e.prototype, r), n && t(e, n), e;
  };
}();
function eI(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function tI(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function rI(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var Am = function(t) {
  rI(e, t);
  function e(r) {
    eI(this, e);
    var n = tI(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
    return n.toggleViews = function() {
      n.state.view === "hex" ? n.setState({ view: "rgb" }) : n.state.view === "rgb" ? n.setState({ view: "hsl" }) : n.state.view === "hsl" && (n.props.hsl.a === 1 ? n.setState({ view: "hex" }) : n.setState({ view: "rgb" }));
    }, n.handleChange = function(a, i) {
      a.hex ? Yr(a.hex) && n.props.onChange({
        hex: a.hex,
        source: "hex"
      }, i) : a.r || a.g || a.b ? n.props.onChange({
        r: a.r || n.props.rgb.r,
        g: a.g || n.props.rgb.g,
        b: a.b || n.props.rgb.b,
        source: "rgb"
      }, i) : a.a ? (a.a < 0 ? a.a = 0 : a.a > 1 && (a.a = 1), n.props.onChange({
        h: n.props.hsl.h,
        s: n.props.hsl.s,
        l: n.props.hsl.l,
        a: Math.round(a.a * 100) / 100,
        source: "rgb"
      }, i)) : (a.h || a.s || a.l) && (typeof a.s == "string" && a.s.includes("%") && (a.s = a.s.replace("%", "")), typeof a.l == "string" && a.l.includes("%") && (a.l = a.l.replace("%", "")), a.s == 1 ? a.s = 0.01 : a.l == 1 && (a.l = 0.01), n.props.onChange({
        h: a.h || n.props.hsl.h,
        s: Number(rp(a.s) ? n.props.hsl.s : a.s),
        l: Number(rp(a.l) ? n.props.hsl.l : a.l),
        source: "hsl"
      }, i));
    }, n.showHighlight = function(a) {
      a.currentTarget.style.background = "#eee";
    }, n.hideHighlight = function(a) {
      a.currentTarget.style.background = "transparent";
    }, r.hsl.a !== 1 && r.view === "hex" ? n.state = {
      view: "rgb"
    } : n.state = {
      view: r.view
    }, n;
  }
  return QF(e, [{
    key: "render",
    value: function() {
      var n = this, a = ge({
        default: {
          wrap: {
            paddingTop: "16px",
            display: "flex"
          },
          fields: {
            flex: "1",
            display: "flex",
            marginLeft: "-6px"
          },
          field: {
            paddingLeft: "6px",
            width: "100%"
          },
          alpha: {
            paddingLeft: "6px",
            width: "100%"
          },
          toggle: {
            width: "32px",
            textAlign: "right",
            position: "relative"
          },
          icon: {
            marginRight: "-4px",
            marginTop: "12px",
            cursor: "pointer",
            position: "relative"
          },
          iconHighlight: {
            position: "absolute",
            width: "24px",
            height: "28px",
            background: "#eee",
            borderRadius: "4px",
            top: "10px",
            left: "12px",
            display: "none"
          },
          input: {
            fontSize: "11px",
            color: "#333",
            width: "100%",
            borderRadius: "2px",
            border: "none",
            boxShadow: "inset 0 0 0 1px #dadada",
            height: "21px",
            textAlign: "center"
          },
          label: {
            textTransform: "uppercase",
            fontSize: "11px",
            lineHeight: "11px",
            color: "#969696",
            textAlign: "center",
            display: "block",
            marginTop: "12px"
          },
          svg: {
            fill: "#333",
            width: "24px",
            height: "24px",
            border: "1px transparent solid",
            borderRadius: "5px"
          }
        },
        disableAlpha: {
          alpha: {
            display: "none"
          }
        }
      }, this.props, this.state), i = void 0;
      return this.state.view === "hex" ? i = M.createElement(
        "div",
        { style: a.fields, className: "flexbox-fix" },
        M.createElement(
          "div",
          { style: a.field },
          M.createElement(Pe, {
            style: { input: a.input, label: a.label },
            label: "hex",
            value: this.props.hex,
            onChange: this.handleChange
          })
        )
      ) : this.state.view === "rgb" ? i = M.createElement(
        "div",
        { style: a.fields, className: "flexbox-fix" },
        M.createElement(
          "div",
          { style: a.field },
          M.createElement(Pe, {
            style: { input: a.input, label: a.label },
            label: "r",
            value: this.props.rgb.r,
            onChange: this.handleChange
          })
        ),
        M.createElement(
          "div",
          { style: a.field },
          M.createElement(Pe, {
            style: { input: a.input, label: a.label },
            label: "g",
            value: this.props.rgb.g,
            onChange: this.handleChange
          })
        ),
        M.createElement(
          "div",
          { style: a.field },
          M.createElement(Pe, {
            style: { input: a.input, label: a.label },
            label: "b",
            value: this.props.rgb.b,
            onChange: this.handleChange
          })
        ),
        M.createElement(
          "div",
          { style: a.alpha },
          M.createElement(Pe, {
            style: { input: a.input, label: a.label },
            label: "a",
            value: this.props.rgb.a,
            arrowOffset: 0.01,
            onChange: this.handleChange
          })
        )
      ) : this.state.view === "hsl" && (i = M.createElement(
        "div",
        { style: a.fields, className: "flexbox-fix" },
        M.createElement(
          "div",
          { style: a.field },
          M.createElement(Pe, {
            style: { input: a.input, label: a.label },
            label: "h",
            value: Math.round(this.props.hsl.h),
            onChange: this.handleChange
          })
        ),
        M.createElement(
          "div",
          { style: a.field },
          M.createElement(Pe, {
            style: { input: a.input, label: a.label },
            label: "s",
            value: Math.round(this.props.hsl.s * 100) + "%",
            onChange: this.handleChange
          })
        ),
        M.createElement(
          "div",
          { style: a.field },
          M.createElement(Pe, {
            style: { input: a.input, label: a.label },
            label: "l",
            value: Math.round(this.props.hsl.l * 100) + "%",
            onChange: this.handleChange
          })
        ),
        M.createElement(
          "div",
          { style: a.alpha },
          M.createElement(Pe, {
            style: { input: a.input, label: a.label },
            label: "a",
            value: this.props.hsl.a,
            arrowOffset: 0.01,
            onChange: this.handleChange
          })
        )
      )), M.createElement(
        "div",
        { style: a.wrap, className: "flexbox-fix" },
        i,
        M.createElement(
          "div",
          { style: a.toggle },
          M.createElement(
            "div",
            { style: a.icon, onClick: this.toggleViews, ref: function(l) {
              return n.icon = l;
            } },
            M.createElement(JF, {
              style: a.svg,
              onMouseOver: this.showHighlight,
              onMouseEnter: this.showHighlight,
              onMouseOut: this.hideHighlight
            })
          )
        )
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.hsl.a !== 1 && a.view === "hex" ? { view: "rgb" } : null;
    }
  }]), e;
}(M.Component);
Am.defaultProps = {
  view: "hex"
};
var ip = function() {
  var e = ge({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        transform: "translate(-6px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return M.createElement("div", { style: e.picker });
}, nI = function() {
  var e = ge({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    }
  });
  return M.createElement("div", { style: e.picker });
}, rc = function(e) {
  var r = e.width, n = e.onChange, a = e.disableAlpha, i = e.rgb, s = e.hsl, l = e.hsv, o = e.hex, u = e.renderers, c = e.styles, f = c === void 0 ? {} : c, p = e.className, g = p === void 0 ? "" : p, m = e.defaultView, d = ge(_t({
    default: {
      picker: {
        width: r,
        background: "#fff",
        borderRadius: "2px",
        boxShadow: "0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)",
        boxSizing: "initial",
        fontFamily: "Menlo"
      },
      saturation: {
        width: "100%",
        paddingBottom: "55%",
        position: "relative",
        borderRadius: "2px 2px 0 0",
        overflow: "hidden"
      },
      Saturation: {
        radius: "2px 2px 0 0"
      },
      body: {
        padding: "16px 16px 12px"
      },
      controls: {
        display: "flex"
      },
      color: {
        width: "32px"
      },
      swatch: {
        marginTop: "6px",
        width: "16px",
        height: "16px",
        borderRadius: "8px",
        position: "relative",
        overflow: "hidden"
      },
      active: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "8px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.1)",
        background: "rgba(" + i.r + ", " + i.g + ", " + i.b + ", " + i.a + ")",
        zIndex: "2"
      },
      toggles: {
        flex: "1"
      },
      hue: {
        height: "10px",
        position: "relative",
        marginBottom: "8px"
      },
      Hue: {
        radius: "2px"
      },
      alpha: {
        height: "10px",
        position: "relative"
      },
      Alpha: {
        radius: "2px"
      }
    },
    disableAlpha: {
      color: {
        width: "22px"
      },
      alpha: {
        display: "none"
      },
      hue: {
        marginBottom: "0px"
      },
      swatch: {
        width: "10px",
        height: "10px",
        marginTop: "0px"
      }
    }
  }, f), { disableAlpha: a });
  return M.createElement(
    "div",
    { style: d.picker, className: "chrome-picker " + g },
    M.createElement(
      "div",
      { style: d.saturation },
      M.createElement(to, {
        style: d.Saturation,
        hsl: s,
        hsv: l,
        pointer: nI,
        onChange: n
      })
    ),
    M.createElement(
      "div",
      { style: d.body },
      M.createElement(
        "div",
        { style: d.controls, className: "flexbox-fix" },
        M.createElement(
          "div",
          { style: d.color },
          M.createElement(
            "div",
            { style: d.swatch },
            M.createElement("div", { style: d.active }),
            M.createElement(ba, { renderers: u })
          )
        ),
        M.createElement(
          "div",
          { style: d.toggles },
          M.createElement(
            "div",
            { style: d.hue },
            M.createElement(wa, {
              style: d.Hue,
              hsl: s,
              pointer: ip,
              onChange: n
            })
          ),
          M.createElement(
            "div",
            { style: d.alpha },
            M.createElement(Wu, {
              style: d.Alpha,
              rgb: i,
              hsl: s,
              pointer: ip,
              renderers: u,
              onChange: n
            })
          )
        )
      ),
      M.createElement(Am, {
        rgb: i,
        hsl: s,
        hex: o,
        view: m,
        onChange: n,
        disableAlpha: a
      })
    )
  );
};
rc.propTypes = {
  width: ee.oneOfType([ee.string, ee.number]),
  disableAlpha: ee.bool,
  styles: ee.object,
  defaultView: ee.oneOf(["hex", "rgb", "hsl"])
};
rc.defaultProps = {
  width: 225,
  disableAlpha: !1,
  styles: {}
};
const aI = At(rc);
var iI = function(e) {
  var r = e.color, n = e.onClick, a = n === void 0 ? function() {
  } : n, i = e.onSwatchHover, s = e.active, l = ge({
    default: {
      color: {
        background: r,
        width: "15px",
        height: "15px",
        float: "left",
        marginRight: "5px",
        marginBottom: "5px",
        position: "relative",
        cursor: "pointer"
      },
      dot: {
        absolute: "5px 5px 5px 5px",
        background: Xu(r),
        borderRadius: "50%",
        opacity: "0"
      }
    },
    active: {
      dot: {
        opacity: "1"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      dot: {
        background: "#000"
      }
    },
    transparent: {
      dot: {
        background: "#000"
      }
    }
  }, { active: s, "color-#FFFFFF": r === "#FFFFFF", transparent: r === "transparent" });
  return M.createElement(
    En,
    {
      style: l.color,
      color: r,
      onClick: a,
      onHover: i,
      focusStyle: { boxShadow: "0 0 4px " + r }
    },
    M.createElement("div", { style: l.dot })
  );
}, sI = function(e) {
  var r = e.hex, n = e.rgb, a = e.onChange, i = ge({
    default: {
      fields: {
        display: "flex",
        paddingBottom: "6px",
        paddingRight: "5px",
        position: "relative"
      },
      active: {
        position: "absolute",
        top: "6px",
        left: "5px",
        height: "9px",
        width: "9px",
        background: r
      },
      HEXwrap: {
        flex: "6",
        position: "relative"
      },
      HEXinput: {
        width: "80%",
        padding: "0px",
        paddingLeft: "20%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      HEXlabel: {
        display: "none"
      },
      RGBwrap: {
        flex: "3",
        position: "relative"
      },
      RGBinput: {
        width: "70%",
        padding: "0px",
        paddingLeft: "30%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      RGBlabel: {
        position: "absolute",
        top: "3px",
        left: "0px",
        lineHeight: "16px",
        textTransform: "uppercase",
        fontSize: "12px",
        color: "#999"
      }
    }
  }), s = function(o, u) {
    o.r || o.g || o.b ? a({
      r: o.r || n.r,
      g: o.g || n.g,
      b: o.b || n.b,
      source: "rgb"
    }, u) : a({
      hex: o.hex,
      source: "hex"
    }, u);
  };
  return M.createElement(
    "div",
    { style: i.fields, className: "flexbox-fix" },
    M.createElement("div", { style: i.active }),
    M.createElement(Pe, {
      style: { wrap: i.HEXwrap, input: i.HEXinput, label: i.HEXlabel },
      label: "hex",
      value: r,
      onChange: s
    }),
    M.createElement(Pe, {
      style: { wrap: i.RGBwrap, input: i.RGBinput, label: i.RGBlabel },
      label: "r",
      value: n.r,
      onChange: s
    }),
    M.createElement(Pe, {
      style: { wrap: i.RGBwrap, input: i.RGBinput, label: i.RGBlabel },
      label: "g",
      value: n.g,
      onChange: s
    }),
    M.createElement(Pe, {
      style: { wrap: i.RGBwrap, input: i.RGBinput, label: i.RGBlabel },
      label: "b",
      value: n.b,
      onChange: s
    })
  );
}, nc = function(e) {
  var r = e.onChange, n = e.onSwatchHover, a = e.colors, i = e.hex, s = e.rgb, l = e.styles, o = l === void 0 ? {} : l, u = e.className, c = u === void 0 ? "" : u, f = ge(_t({
    default: {
      Compact: {
        background: "#f6f6f6",
        radius: "4px"
      },
      compact: {
        paddingTop: "5px",
        paddingLeft: "5px",
        boxSizing: "initial",
        width: "240px"
      },
      clear: {
        clear: "both"
      }
    }
  }, o)), p = function(m, d) {
    m.hex ? Yr(m.hex) && r({
      hex: m.hex,
      source: "hex"
    }, d) : r(m, d);
  };
  return M.createElement(
    Bi,
    { style: f.Compact, styles: o },
    M.createElement(
      "div",
      { style: f.compact, className: "compact-picker " + c },
      M.createElement(
        "div",
        null,
        Cn(a, function(g) {
          return M.createElement(iI, {
            key: g,
            color: g,
            active: g.toLowerCase() === i,
            onClick: p,
            onSwatchHover: n
          });
        }),
        M.createElement("div", { style: f.clear })
      ),
      M.createElement(sI, { hex: i, rgb: s, onChange: p })
    )
  );
};
nc.propTypes = {
  colors: ee.arrayOf(ee.string),
  styles: ee.object
};
nc.defaultProps = {
  colors: ["#4D4D4D", "#999999", "#FFFFFF", "#F44E3B", "#FE9200", "#FCDC00", "#DBDF00", "#A4DD00", "#68CCCA", "#73D8FF", "#AEA1FF", "#FDA1FF", "#333333", "#808080", "#cccccc", "#D33115", "#E27300", "#FCC400", "#B0BC00", "#68BC00", "#16A5A5", "#009CE0", "#7B64FF", "#FA28FF", "#000000", "#666666", "#B3B3B3", "#9F0500", "#C45100", "#FB9E00", "#808900", "#194D33", "#0C797D", "#0062B1", "#653294", "#AB149E"],
  styles: {}
};
At(nc);
var oI = function(e) {
  var r = e.hover, n = e.color, a = e.onClick, i = e.onSwatchHover, s = {
    position: "relative",
    zIndex: "2",
    outline: "2px solid #fff",
    boxShadow: "0 0 5px 2px rgba(0,0,0,0.25)"
  }, l = ge({
    default: {
      swatch: {
        width: "25px",
        height: "25px",
        fontSize: "0"
      }
    },
    hover: {
      swatch: s
    }
  }, { hover: r });
  return M.createElement(
    "div",
    { style: l.swatch },
    M.createElement(En, {
      color: n,
      onClick: a,
      onHover: i,
      focusStyle: s
    })
  );
};
const lI = zu(oI);
var ac = function(e) {
  var r = e.width, n = e.colors, a = e.onChange, i = e.onSwatchHover, s = e.triangle, l = e.styles, o = l === void 0 ? {} : l, u = e.className, c = u === void 0 ? "" : u, f = ge(_t({
    default: {
      card: {
        width: r,
        background: "#fff",
        border: "1px solid rgba(0,0,0,0.2)",
        boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
        borderRadius: "4px",
        position: "relative",
        padding: "5px",
        display: "flex",
        flexWrap: "wrap"
      },
      triangle: {
        position: "absolute",
        border: "7px solid transparent",
        borderBottomColor: "#fff"
      },
      triangleShadow: {
        position: "absolute",
        border: "8px solid transparent",
        borderBottomColor: "rgba(0,0,0,0.15)"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-14px",
        left: "10px"
      },
      triangleShadow: {
        top: "-16px",
        left: "9px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-14px",
        right: "10px"
      },
      triangleShadow: {
        top: "-16px",
        right: "9px"
      }
    },
    "bottom-left-triangle": {
      triangle: {
        top: "35px",
        left: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        left: "9px",
        transform: "rotate(180deg)"
      }
    },
    "bottom-right-triangle": {
      triangle: {
        top: "35px",
        right: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        right: "9px",
        transform: "rotate(180deg)"
      }
    }
  }, o), {
    "hide-triangle": s === "hide",
    "top-left-triangle": s === "top-left",
    "top-right-triangle": s === "top-right",
    "bottom-left-triangle": s === "bottom-left",
    "bottom-right-triangle": s === "bottom-right"
  }), p = function(m, d) {
    return a({ hex: m, source: "hex" }, d);
  };
  return M.createElement(
    "div",
    { style: f.card, className: "github-picker " + c },
    M.createElement("div", { style: f.triangleShadow }),
    M.createElement("div", { style: f.triangle }),
    Cn(n, function(g) {
      return M.createElement(lI, {
        color: g,
        key: g,
        onClick: p,
        onSwatchHover: i
      });
    })
  );
};
ac.propTypes = {
  width: ee.oneOfType([ee.string, ee.number]),
  colors: ee.arrayOf(ee.string),
  triangle: ee.oneOf(["hide", "top-left", "top-right", "bottom-left", "bottom-right"]),
  styles: ee.object
};
ac.defaultProps = {
  width: 200,
  colors: ["#B80000", "#DB3E00", "#FCCB00", "#008B02", "#006B76", "#1273DE", "#004DCF", "#5300EB", "#EB9694", "#FAD0C3", "#FEF3BD", "#C1E1C5", "#BEDADC", "#C4DEF6", "#BED3F3", "#D4C4FB"],
  triangle: "top-left",
  styles: {}
};
At(ac);
var uI = function(e) {
  var r = e.direction, n = ge({
    default: {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    vertical: {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: r === "vertical" });
  return M.createElement("div", { style: n.picker });
}, cI = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  }
  return t;
}, ic = function(e) {
  var r = e.width, n = e.height, a = e.onChange, i = e.hsl, s = e.direction, l = e.pointer, o = e.styles, u = o === void 0 ? {} : o, c = e.className, f = c === void 0 ? "" : c, p = ge(_t({
    default: {
      picker: {
        position: "relative",
        width: r,
        height: n
      },
      hue: {
        radius: "2px"
      }
    }
  }, u)), g = function(d) {
    return a({ a: 1, h: d.h, l: 0.5, s: 1 });
  };
  return M.createElement(
    "div",
    { style: p.picker, className: "hue-picker " + f },
    M.createElement(wa, cI({}, p.hue, {
      hsl: i,
      pointer: l,
      onChange: g,
      direction: s
    }))
  );
};
ic.propTypes = {
  styles: ee.object
};
ic.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: uI,
  styles: {}
};
At(ic);
var fI = function(e) {
  var r = e.onChange, n = e.hex, a = e.rgb, i = e.styles, s = i === void 0 ? {} : i, l = e.className, o = l === void 0 ? "" : l, u = ge(_t({
    default: {
      material: {
        width: "98px",
        height: "98px",
        padding: "16px",
        fontFamily: "Roboto"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "2px solid " + n,
        outline: "none",
        height: "30px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "1px solid #eee",
        outline: "none",
        height: "30px"
      },
      RGBlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      split: {
        display: "flex",
        marginRight: "-10px",
        paddingTop: "11px"
      },
      third: {
        flex: "1",
        paddingRight: "10px"
      }
    }
  }, s)), c = function(p, g) {
    p.hex ? Yr(p.hex) && r({
      hex: p.hex,
      source: "hex"
    }, g) : (p.r || p.g || p.b) && r({
      r: p.r || a.r,
      g: p.g || a.g,
      b: p.b || a.b,
      source: "rgb"
    }, g);
  };
  return M.createElement(
    Bi,
    { styles: s },
    M.createElement(
      "div",
      { style: u.material, className: "material-picker " + o },
      M.createElement(Pe, {
        style: { wrap: u.HEXwrap, input: u.HEXinput, label: u.HEXlabel },
        label: "hex",
        value: n,
        onChange: c
      }),
      M.createElement(
        "div",
        { style: u.split, className: "flexbox-fix" },
        M.createElement(
          "div",
          { style: u.third },
          M.createElement(Pe, {
            style: { wrap: u.RGBwrap, input: u.RGBinput, label: u.RGBlabel },
            label: "r",
            value: a.r,
            onChange: c
          })
        ),
        M.createElement(
          "div",
          { style: u.third },
          M.createElement(Pe, {
            style: { wrap: u.RGBwrap, input: u.RGBinput, label: u.RGBlabel },
            label: "g",
            value: a.g,
            onChange: c
          })
        ),
        M.createElement(
          "div",
          { style: u.third },
          M.createElement(Pe, {
            style: { wrap: u.RGBwrap, input: u.RGBinput, label: u.RGBlabel },
            label: "b",
            value: a.b,
            onChange: c
          })
        )
      )
    )
  );
};
At(fI);
var dI = function(e) {
  var r = e.onChange, n = e.rgb, a = e.hsv, i = e.hex, s = ge({
    default: {
      fields: {
        paddingTop: "5px",
        paddingBottom: "9px",
        width: "80px",
        position: "relative"
      },
      divider: {
        height: "5px"
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        marginLeft: "40%",
        width: "40%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "5px",
        fontSize: "13px",
        paddingLeft: "3px",
        marginRight: "10px"
      },
      RGBlabel: {
        left: "0px",
        top: "0px",
        width: "34px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px",
        position: "absolute"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        marginLeft: "20%",
        width: "80%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "6px",
        fontSize: "13px",
        paddingLeft: "3px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        width: "14px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px"
      },
      fieldSymbols: {
        position: "absolute",
        top: "5px",
        right: "-7px",
        fontSize: "13px"
      },
      symbol: {
        height: "20px",
        lineHeight: "22px",
        paddingBottom: "7px"
      }
    }
  }), l = function(u, c) {
    u["#"] ? Yr(u["#"]) && r({
      hex: u["#"],
      source: "hex"
    }, c) : u.r || u.g || u.b ? r({
      r: u.r || n.r,
      g: u.g || n.g,
      b: u.b || n.b,
      source: "rgb"
    }, c) : (u.h || u.s || u.v) && r({
      h: u.h || a.h,
      s: u.s || a.s,
      v: u.v || a.v,
      source: "hsv"
    }, c);
  };
  return M.createElement(
    "div",
    { style: s.fields },
    M.createElement(Pe, {
      style: { wrap: s.RGBwrap, input: s.RGBinput, label: s.RGBlabel },
      label: "h",
      value: Math.round(a.h),
      onChange: l
    }),
    M.createElement(Pe, {
      style: { wrap: s.RGBwrap, input: s.RGBinput, label: s.RGBlabel },
      label: "s",
      value: Math.round(a.s * 100),
      onChange: l
    }),
    M.createElement(Pe, {
      style: { wrap: s.RGBwrap, input: s.RGBinput, label: s.RGBlabel },
      label: "v",
      value: Math.round(a.v * 100),
      onChange: l
    }),
    M.createElement("div", { style: s.divider }),
    M.createElement(Pe, {
      style: { wrap: s.RGBwrap, input: s.RGBinput, label: s.RGBlabel },
      label: "r",
      value: n.r,
      onChange: l
    }),
    M.createElement(Pe, {
      style: { wrap: s.RGBwrap, input: s.RGBinput, label: s.RGBlabel },
      label: "g",
      value: n.g,
      onChange: l
    }),
    M.createElement(Pe, {
      style: { wrap: s.RGBwrap, input: s.RGBinput, label: s.RGBlabel },
      label: "b",
      value: n.b,
      onChange: l
    }),
    M.createElement("div", { style: s.divider }),
    M.createElement(Pe, {
      style: { wrap: s.HEXwrap, input: s.HEXinput, label: s.HEXlabel },
      label: "#",
      value: i.replace("#", ""),
      onChange: l
    }),
    M.createElement(
      "div",
      { style: s.fieldSymbols },
      M.createElement(
        "div",
        { style: s.symbol },
        "°"
      ),
      M.createElement(
        "div",
        { style: s.symbol },
        "%"
      ),
      M.createElement(
        "div",
        { style: s.symbol },
        "%"
      )
    )
  );
}, pI = function(e) {
  var r = e.hsl, n = ge({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    },
    "black-outline": {
      picker: {
        boxShadow: "inset 0 0 0 1px #000"
      }
    }
  }, { "black-outline": r.l > 0.5 });
  return M.createElement("div", { style: n.picker });
}, hI = function() {
  var e = ge({
    default: {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "4px 0 4px 6px",
        borderColor: "transparent transparent transparent #fff",
        position: "absolute",
        top: "1px",
        left: "1px"
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "5px 0 5px 8px",
        borderColor: "transparent transparent transparent #555"
      },
      left: {
        Extend: "triangleBorder",
        transform: "translate(-13px, -4px)"
      },
      leftInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      },
      right: {
        Extend: "triangleBorder",
        transform: "translate(20px, -14px) rotate(180deg)"
      },
      rightInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      }
    }
  });
  return M.createElement(
    "div",
    { style: e.pointer },
    M.createElement(
      "div",
      { style: e.left },
      M.createElement("div", { style: e.leftInside })
    ),
    M.createElement(
      "div",
      { style: e.right },
      M.createElement("div", { style: e.rightInside })
    )
  );
}, sp = function(e) {
  var r = e.onClick, n = e.label, a = e.children, i = e.active, s = ge({
    default: {
      button: {
        backgroundImage: "linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)",
        border: "1px solid #878787",
        borderRadius: "2px",
        height: "20px",
        boxShadow: "0 1px 0 0 #EAEAEA",
        fontSize: "14px",
        color: "#000",
        lineHeight: "20px",
        textAlign: "center",
        marginBottom: "10px",
        cursor: "pointer"
      }
    },
    active: {
      button: {
        boxShadow: "0 0 0 1px #878787"
      }
    }
  }, { active: i });
  return M.createElement(
    "div",
    { style: s.button, onClick: r },
    n || a
  );
}, gI = function(e) {
  var r = e.rgb, n = e.currentColor, a = ge({
    default: {
      swatches: {
        border: "1px solid #B3B3B3",
        borderBottom: "1px solid #F0F0F0",
        marginBottom: "2px",
        marginTop: "1px"
      },
      new: {
        height: "34px",
        background: "rgb(" + r.r + "," + r.g + ", " + r.b + ")",
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000"
      },
      current: {
        height: "34px",
        background: n,
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000"
      },
      label: {
        fontSize: "14px",
        color: "#000",
        textAlign: "center"
      }
    }
  });
  return M.createElement(
    "div",
    null,
    M.createElement(
      "div",
      { style: a.label },
      "new"
    ),
    M.createElement(
      "div",
      { style: a.swatches },
      M.createElement("div", { style: a.new }),
      M.createElement("div", { style: a.current })
    ),
    M.createElement(
      "div",
      { style: a.label },
      "current"
    )
  );
}, vI = function() {
  function t(e, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, r, n) {
    return r && t(e.prototype, r), n && t(e, n), e;
  };
}();
function mI(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function yI(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function bI(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var sc = function(t) {
  bI(e, t);
  function e(r) {
    mI(this, e);
    var n = yI(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
    return n.state = {
      currentColor: r.hex
    }, n;
  }
  return vI(e, [{
    key: "render",
    value: function() {
      var n = this.props, a = n.styles, i = a === void 0 ? {} : a, s = n.className, l = s === void 0 ? "" : s, o = ge(_t({
        default: {
          picker: {
            background: "#DCDCDC",
            borderRadius: "4px",
            boxShadow: "0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)",
            boxSizing: "initial",
            width: "513px"
          },
          head: {
            backgroundImage: "linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)",
            borderBottom: "1px solid #B1B1B1",
            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)",
            height: "23px",
            lineHeight: "24px",
            borderRadius: "4px 4px 0 0",
            fontSize: "13px",
            color: "#4D4D4D",
            textAlign: "center"
          },
          body: {
            padding: "15px 15px 0",
            display: "flex"
          },
          saturation: {
            width: "256px",
            height: "256px",
            position: "relative",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0",
            overflow: "hidden"
          },
          hue: {
            position: "relative",
            height: "256px",
            width: "19px",
            marginLeft: "10px",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0"
          },
          controls: {
            width: "180px",
            marginLeft: "10px"
          },
          top: {
            display: "flex"
          },
          previews: {
            width: "60px"
          },
          actions: {
            flex: "1",
            marginLeft: "20px"
          }
        }
      }, i));
      return M.createElement(
        "div",
        { style: o.picker, className: "photoshop-picker " + l },
        M.createElement(
          "div",
          { style: o.head },
          this.props.header
        ),
        M.createElement(
          "div",
          { style: o.body, className: "flexbox-fix" },
          M.createElement(
            "div",
            { style: o.saturation },
            M.createElement(to, {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: pI,
              onChange: this.props.onChange
            })
          ),
          M.createElement(
            "div",
            { style: o.hue },
            M.createElement(wa, {
              direction: "vertical",
              hsl: this.props.hsl,
              pointer: hI,
              onChange: this.props.onChange
            })
          ),
          M.createElement(
            "div",
            { style: o.controls },
            M.createElement(
              "div",
              { style: o.top, className: "flexbox-fix" },
              M.createElement(
                "div",
                { style: o.previews },
                M.createElement(gI, {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              M.createElement(
                "div",
                { style: o.actions },
                M.createElement(sp, { label: "OK", onClick: this.props.onAccept, active: !0 }),
                M.createElement(sp, { label: "Cancel", onClick: this.props.onCancel }),
                M.createElement(dI, {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]), e;
}(M.Component);
sc.propTypes = {
  header: ee.string,
  styles: ee.object
};
sc.defaultProps = {
  header: "Color Picker",
  styles: {}
};
At(sc);
var wI = function(e) {
  var r = e.onChange, n = e.rgb, a = e.hsl, i = e.hex, s = e.disableAlpha, l = ge({
    default: {
      fields: {
        display: "flex",
        paddingTop: "4px"
      },
      single: {
        flex: "1",
        paddingLeft: "6px"
      },
      alpha: {
        flex: "1",
        paddingLeft: "6px"
      },
      double: {
        flex: "2"
      },
      input: {
        width: "80%",
        padding: "4px 10% 3px",
        border: "none",
        boxShadow: "inset 0 0 0 1px #ccc",
        fontSize: "11px"
      },
      label: {
        display: "block",
        textAlign: "center",
        fontSize: "11px",
        color: "#222",
        paddingTop: "3px",
        paddingBottom: "4px",
        textTransform: "capitalize"
      }
    },
    disableAlpha: {
      alpha: {
        display: "none"
      }
    }
  }, { disableAlpha: s }), o = function(c, f) {
    c.hex ? Yr(c.hex) && r({
      hex: c.hex,
      source: "hex"
    }, f) : c.r || c.g || c.b ? r({
      r: c.r || n.r,
      g: c.g || n.g,
      b: c.b || n.b,
      a: n.a,
      source: "rgb"
    }, f) : c.a && (c.a < 0 ? c.a = 0 : c.a > 100 && (c.a = 100), c.a /= 100, r({
      h: a.h,
      s: a.s,
      l: a.l,
      a: c.a,
      source: "rgb"
    }, f));
  };
  return M.createElement(
    "div",
    { style: l.fields, className: "flexbox-fix" },
    M.createElement(
      "div",
      { style: l.double },
      M.createElement(Pe, {
        style: { input: l.input, label: l.label },
        label: "hex",
        value: i.replace("#", ""),
        onChange: o
      })
    ),
    M.createElement(
      "div",
      { style: l.single },
      M.createElement(Pe, {
        style: { input: l.input, label: l.label },
        label: "r",
        value: n.r,
        onChange: o,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    M.createElement(
      "div",
      { style: l.single },
      M.createElement(Pe, {
        style: { input: l.input, label: l.label },
        label: "g",
        value: n.g,
        onChange: o,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    M.createElement(
      "div",
      { style: l.single },
      M.createElement(Pe, {
        style: { input: l.input, label: l.label },
        label: "b",
        value: n.b,
        onChange: o,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    M.createElement(
      "div",
      { style: l.alpha },
      M.createElement(Pe, {
        style: { input: l.input, label: l.label },
        label: "a",
        value: Math.round(n.a * 100),
        onChange: o,
        dragLabel: "true",
        dragMax: "100"
      })
    )
  );
}, xI = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  }
  return t;
}, Tm = function(e) {
  var r = e.colors, n = e.onClick, a = n === void 0 ? function() {
  } : n, i = e.onSwatchHover, s = ge({
    default: {
      colors: {
        margin: "0 -10px",
        padding: "10px 0 0 10px",
        borderTop: "1px solid #eee",
        display: "flex",
        flexWrap: "wrap",
        position: "relative"
      },
      swatchWrap: {
        width: "16px",
        height: "16px",
        margin: "0 10px 10px 0"
      },
      swatch: {
        borderRadius: "3px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
      }
    },
    "no-presets": {
      colors: {
        display: "none"
      }
    }
  }, {
    "no-presets": !r || !r.length
  }), l = function(u, c) {
    a({
      hex: u,
      source: "hex"
    }, c);
  };
  return M.createElement(
    "div",
    { style: s.colors, className: "flexbox-fix" },
    r.map(function(o) {
      var u = typeof o == "string" ? { color: o } : o, c = "" + u.color + (u.title || "");
      return M.createElement(
        "div",
        { key: c, style: s.swatchWrap },
        M.createElement(En, xI({}, u, {
          style: s.swatch,
          onClick: l,
          onHover: i,
          focusStyle: {
            boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + u.color
          }
        }))
      );
    })
  );
};
Tm.propTypes = {
  colors: ee.arrayOf(ee.oneOfType([ee.string, ee.shape({
    color: ee.string,
    title: ee.string
  })])).isRequired
};
var EI = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  }
  return t;
}, oc = function(e) {
  var r = e.width, n = e.rgb, a = e.hex, i = e.hsv, s = e.hsl, l = e.onChange, o = e.onSwatchHover, u = e.disableAlpha, c = e.presetColors, f = e.renderers, p = e.styles, g = p === void 0 ? {} : p, m = e.className, d = m === void 0 ? "" : m, w = ge(_t({
    default: EI({
      picker: {
        width: r,
        padding: "10px 10px 0",
        boxSizing: "initial",
        background: "#fff",
        borderRadius: "4px",
        boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
      },
      saturation: {
        width: "100%",
        paddingBottom: "75%",
        position: "relative",
        overflow: "hidden"
      },
      Saturation: {
        radius: "3px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      controls: {
        display: "flex"
      },
      sliders: {
        padding: "4px 0",
        flex: "1"
      },
      color: {
        width: "24px",
        height: "24px",
        position: "relative",
        marginTop: "4px",
        marginLeft: "4px",
        borderRadius: "3px"
      },
      activeColor: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "2px",
        background: "rgba(" + n.r + "," + n.g + "," + n.b + "," + n.a + ")",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      hue: {
        position: "relative",
        height: "10px",
        overflow: "hidden"
      },
      Hue: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      alpha: {
        position: "relative",
        height: "10px",
        marginTop: "4px",
        overflow: "hidden"
      },
      Alpha: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      }
    }, g),
    disableAlpha: {
      color: {
        height: "10px"
      },
      hue: {
        height: "10px"
      },
      alpha: {
        display: "none"
      }
    }
  }, g), { disableAlpha: u });
  return M.createElement(
    "div",
    { style: w.picker, className: "sketch-picker " + d },
    M.createElement(
      "div",
      { style: w.saturation },
      M.createElement(to, {
        style: w.Saturation,
        hsl: s,
        hsv: i,
        onChange: l
      })
    ),
    M.createElement(
      "div",
      { style: w.controls, className: "flexbox-fix" },
      M.createElement(
        "div",
        { style: w.sliders },
        M.createElement(
          "div",
          { style: w.hue },
          M.createElement(wa, {
            style: w.Hue,
            hsl: s,
            onChange: l
          })
        ),
        M.createElement(
          "div",
          { style: w.alpha },
          M.createElement(Wu, {
            style: w.Alpha,
            rgb: n,
            hsl: s,
            renderers: f,
            onChange: l
          })
        )
      ),
      M.createElement(
        "div",
        { style: w.color },
        M.createElement(ba, null),
        M.createElement("div", { style: w.activeColor })
      )
    ),
    M.createElement(wI, {
      rgb: n,
      hsl: s,
      hex: a,
      onChange: l,
      disableAlpha: u
    }),
    M.createElement(Tm, {
      colors: c,
      onClick: l,
      onSwatchHover: o
    })
  );
};
oc.propTypes = {
  disableAlpha: ee.bool,
  width: ee.oneOfType([ee.string, ee.number]),
  styles: ee.object
};
oc.defaultProps = {
  disableAlpha: !1,
  width: 200,
  styles: {},
  presetColors: ["#D0021B", "#F5A623", "#F8E71C", "#8B572A", "#7ED321", "#417505", "#BD10E0", "#9013FE", "#4A90E2", "#50E3C2", "#B8E986", "#000000", "#4A4A4A", "#9B9B9B", "#FFFFFF"]
};
At(oc);
var $a = function(e) {
  var r = e.hsl, n = e.offset, a = e.onClick, i = a === void 0 ? function() {
  } : a, s = e.active, l = e.first, o = e.last, u = ge({
    default: {
      swatch: {
        height: "12px",
        background: "hsl(" + r.h + ", 50%, " + n * 100 + "%)",
        cursor: "pointer"
      }
    },
    first: {
      swatch: {
        borderRadius: "2px 0 0 2px"
      }
    },
    last: {
      swatch: {
        borderRadius: "0 2px 2px 0"
      }
    },
    active: {
      swatch: {
        transform: "scaleY(1.8)",
        borderRadius: "3.6px/2px"
      }
    }
  }, { active: s, first: l, last: o }), c = function(p) {
    return i({
      h: r.h,
      s: 0.5,
      l: n,
      source: "hsl"
    }, p);
  };
  return M.createElement("div", { style: u.swatch, onClick: c });
}, CI = function(e) {
  var r = e.onClick, n = e.hsl, a = ge({
    default: {
      swatches: {
        marginTop: "20px"
      },
      swatch: {
        boxSizing: "border-box",
        width: "20%",
        paddingRight: "1px",
        float: "left"
      },
      clear: {
        clear: "both"
      }
    }
  }), i = 0.1;
  return M.createElement(
    "div",
    { style: a.swatches },
    M.createElement(
      "div",
      { style: a.swatch },
      M.createElement($a, {
        hsl: n,
        offset: ".80",
        active: Math.abs(n.l - 0.8) < i && Math.abs(n.s - 0.5) < i,
        onClick: r,
        first: !0
      })
    ),
    M.createElement(
      "div",
      { style: a.swatch },
      M.createElement($a, {
        hsl: n,
        offset: ".65",
        active: Math.abs(n.l - 0.65) < i && Math.abs(n.s - 0.5) < i,
        onClick: r
      })
    ),
    M.createElement(
      "div",
      { style: a.swatch },
      M.createElement($a, {
        hsl: n,
        offset: ".50",
        active: Math.abs(n.l - 0.5) < i && Math.abs(n.s - 0.5) < i,
        onClick: r
      })
    ),
    M.createElement(
      "div",
      { style: a.swatch },
      M.createElement($a, {
        hsl: n,
        offset: ".35",
        active: Math.abs(n.l - 0.35) < i && Math.abs(n.s - 0.5) < i,
        onClick: r
      })
    ),
    M.createElement(
      "div",
      { style: a.swatch },
      M.createElement($a, {
        hsl: n,
        offset: ".20",
        active: Math.abs(n.l - 0.2) < i && Math.abs(n.s - 0.5) < i,
        onClick: r,
        last: !0
      })
    ),
    M.createElement("div", { style: a.clear })
  );
}, DI = function() {
  var e = ge({
    default: {
      picker: {
        width: "14px",
        height: "14px",
        borderRadius: "6px",
        transform: "translate(-7px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return M.createElement("div", { style: e.picker });
}, lc = function(e) {
  var r = e.hsl, n = e.onChange, a = e.pointer, i = e.styles, s = i === void 0 ? {} : i, l = e.className, o = l === void 0 ? "" : l, u = ge(_t({
    default: {
      hue: {
        height: "12px",
        position: "relative"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, s));
  return M.createElement(
    "div",
    { style: u.wrap || {}, className: "slider-picker " + o },
    M.createElement(
      "div",
      { style: u.hue },
      M.createElement(wa, {
        style: u.Hue,
        hsl: r,
        pointer: a,
        onChange: n
      })
    ),
    M.createElement(
      "div",
      { style: u.swatches },
      M.createElement(CI, { hsl: r, onClick: n })
    )
  );
};
lc.propTypes = {
  styles: ee.object
};
lc.defaultProps = {
  pointer: DI,
  styles: {}
};
At(lc);
var Bm = {};
Object.defineProperty(Bm, "__esModule", {
  value: !0
});
var op = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  }
  return t;
}, SI = M, lp = OI(SI);
function OI(t) {
  return t && t.__esModule ? t : { default: t };
}
function PI(t, e) {
  var r = {};
  for (var n in t)
    e.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
  return r;
}
var zi = 24, _I = Bm.default = function(t) {
  var e = t.fill, r = e === void 0 ? "currentColor" : e, n = t.width, a = n === void 0 ? zi : n, i = t.height, s = i === void 0 ? zi : i, l = t.style, o = l === void 0 ? {} : l, u = PI(t, ["fill", "width", "height", "style"]);
  return lp.default.createElement(
    "svg",
    op({
      viewBox: "0 0 " + zi + " " + zi,
      style: op({ fill: r, width: a, height: s }, o)
    }, u),
    lp.default.createElement("path", { d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" })
  );
}, AI = function(e) {
  var r = e.color, n = e.onClick, a = n === void 0 ? function() {
  } : n, i = e.onSwatchHover, s = e.first, l = e.last, o = e.active, u = ge({
    default: {
      color: {
        width: "40px",
        height: "24px",
        cursor: "pointer",
        background: r,
        marginBottom: "1px"
      },
      check: {
        color: Xu(r),
        marginLeft: "8px",
        display: "none"
      }
    },
    first: {
      color: {
        overflow: "hidden",
        borderRadius: "2px 2px 0 0"
      }
    },
    last: {
      color: {
        overflow: "hidden",
        borderRadius: "0 0 2px 2px"
      }
    },
    active: {
      check: {
        display: "block"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      check: {
        color: "#333"
      }
    },
    transparent: {
      check: {
        color: "#333"
      }
    }
  }, {
    first: s,
    last: l,
    active: o,
    "color-#FFFFFF": r === "#FFFFFF",
    transparent: r === "transparent"
  });
  return M.createElement(
    En,
    {
      color: r,
      style: u.color,
      onClick: a,
      onHover: i,
      focusStyle: { boxShadow: "0 0 4px " + r }
    },
    M.createElement(
      "div",
      { style: u.check },
      M.createElement(_I, null)
    )
  );
}, TI = function(e) {
  var r = e.onClick, n = e.onSwatchHover, a = e.group, i = e.active, s = ge({
    default: {
      group: {
        paddingBottom: "10px",
        width: "40px",
        float: "left",
        marginRight: "10px"
      }
    }
  });
  return M.createElement(
    "div",
    { style: s.group },
    Cn(a, function(l, o) {
      return M.createElement(AI, {
        key: l,
        color: l,
        active: l.toLowerCase() === i,
        first: o === 0,
        last: o === a.length - 1,
        onClick: r,
        onSwatchHover: n
      });
    })
  );
}, uc = function(e) {
  var r = e.width, n = e.height, a = e.onChange, i = e.onSwatchHover, s = e.colors, l = e.hex, o = e.styles, u = o === void 0 ? {} : o, c = e.className, f = c === void 0 ? "" : c, p = ge(_t({
    default: {
      picker: {
        width: r,
        height: n
      },
      overflow: {
        height: n,
        overflowY: "scroll"
      },
      body: {
        padding: "16px 0 6px 16px"
      },
      clear: {
        clear: "both"
      }
    }
  }, u)), g = function(d, w) {
    return a({ hex: d, source: "hex" }, w);
  };
  return M.createElement(
    "div",
    { style: p.picker, className: "swatches-picker " + f },
    M.createElement(
      Bi,
      null,
      M.createElement(
        "div",
        { style: p.overflow },
        M.createElement(
          "div",
          { style: p.body },
          Cn(s, function(m) {
            return M.createElement(TI, {
              key: m.toString(),
              group: m,
              active: l,
              onClick: g,
              onSwatchHover: i
            });
          }),
          M.createElement("div", { style: p.clear })
        )
      )
    )
  );
};
uc.propTypes = {
  width: ee.oneOfType([ee.string, ee.number]),
  height: ee.oneOfType([ee.string, ee.number]),
  colors: ee.arrayOf(ee.arrayOf(ee.string)),
  styles: ee.object
  /* eslint-disable max-len */
};
uc.defaultProps = {
  width: 320,
  height: 240,
  colors: [[Fn[900], Fn[700], Fn[500], Fn[300], Fn[100]], [In[900], In[700], In[500], In[300], In[100]], [jn[900], jn[700], jn[500], jn[300], jn[100]], [Ln[900], Ln[700], Ln[500], Ln[300], Ln[100]], [kn[900], kn[700], kn[500], kn[300], kn[100]], [Nn[900], Nn[700], Nn[500], Nn[300], Nn[100]], [zn[900], zn[700], zn[500], zn[300], zn[100]], [Wn[900], Wn[700], Wn[500], Wn[300], Wn[100]], [Hn[900], Hn[700], Hn[500], Hn[300], Hn[100]], ["#194D33", Ha[700], Ha[500], Ha[300], Ha[100]], [Un[900], Un[700], Un[500], Un[300], Un[100]], [Vn[900], Vn[700], Vn[500], Vn[300], Vn[100]], [qn[900], qn[700], qn[500], qn[300], qn[100]], [Gn[900], Gn[700], Gn[500], Gn[300], Gn[100]], [Yn[900], Yn[700], Yn[500], Yn[300], Yn[100]], [Kn[900], Kn[700], Kn[500], Kn[300], Kn[100]], [Xn[900], Xn[700], Xn[500], Xn[300], Xn[100]], [Zn[900], Zn[700], Zn[500], Zn[300], Zn[100]], ["#000000", "#525252", "#969696", "#D9D9D9", "#FFFFFF"]],
  styles: {}
};
At(uc);
var cc = function(e) {
  var r = e.onChange, n = e.onSwatchHover, a = e.hex, i = e.colors, s = e.width, l = e.triangle, o = e.styles, u = o === void 0 ? {} : o, c = e.className, f = c === void 0 ? "" : c, p = ge(_t({
    default: {
      card: {
        width: s,
        background: "#fff",
        border: "0 solid rgba(0,0,0,0.25)",
        boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
        borderRadius: "4px",
        position: "relative"
      },
      body: {
        padding: "15px 9px 9px 15px"
      },
      label: {
        fontSize: "18px",
        color: "#fff"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent #fff transparent",
        position: "absolute"
      },
      triangleShadow: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
        position: "absolute"
      },
      hash: {
        background: "#F0F0F0",
        height: "30px",
        width: "30px",
        borderRadius: "4px 0 0 4px",
        float: "left",
        color: "#98A1A4",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      input: {
        width: "100px",
        fontSize: "14px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "28px",
        boxShadow: "inset 0 0 0 1px #F0F0F0",
        boxSizing: "content-box",
        borderRadius: "0 4px 4px 0",
        float: "left",
        paddingLeft: "8px"
      },
      swatch: {
        width: "30px",
        height: "30px",
        float: "left",
        borderRadius: "4px",
        margin: "0 6px 6px 0"
      },
      clear: {
        clear: "both"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-10px",
        left: "12px"
      },
      triangleShadow: {
        top: "-11px",
        left: "12px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-10px",
        right: "12px"
      },
      triangleShadow: {
        top: "-11px",
        right: "12px"
      }
    }
  }, u), {
    "hide-triangle": l === "hide",
    "top-left-triangle": l === "top-left",
    "top-right-triangle": l === "top-right"
  }), g = function(d, w) {
    Yr(d) && r({
      hex: d,
      source: "hex"
    }, w);
  };
  return M.createElement(
    "div",
    { style: p.card, className: "twitter-picker " + f },
    M.createElement("div", { style: p.triangleShadow }),
    M.createElement("div", { style: p.triangle }),
    M.createElement(
      "div",
      { style: p.body },
      Cn(i, function(m, d) {
        return M.createElement(En, {
          key: d,
          color: m,
          hex: m,
          style: p.swatch,
          onClick: g,
          onHover: n,
          focusStyle: {
            boxShadow: "0 0 4px " + m
          }
        });
      }),
      M.createElement(
        "div",
        { style: p.hash },
        "#"
      ),
      M.createElement(Pe, {
        label: null,
        style: { input: p.input },
        value: a.replace("#", ""),
        onChange: g
      }),
      M.createElement("div", { style: p.clear })
    )
  );
};
cc.propTypes = {
  width: ee.oneOfType([ee.string, ee.number]),
  triangle: ee.oneOf(["hide", "top-left", "top-right"]),
  colors: ee.arrayOf(ee.string),
  styles: ee.object
};
cc.defaultProps = {
  width: 276,
  colors: ["#FF6900", "#FCB900", "#7BDCB5", "#00D084", "#8ED1FC", "#0693E3", "#ABB8C3", "#EB144C", "#F78DA7", "#9900EF"],
  triangle: "top-left",
  styles: {}
};
At(cc);
var fc = function(e) {
  var r = ge({
    default: {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        border: "2px #fff solid",
        transform: "translate(-12px, -13px)",
        background: "hsl(" + Math.round(e.hsl.h) + ", " + Math.round(e.hsl.s * 100) + "%, " + Math.round(e.hsl.l * 100) + "%)"
      }
    }
  });
  return M.createElement("div", { style: r.picker });
};
fc.propTypes = {
  hsl: ee.shape({
    h: ee.number,
    s: ee.number,
    l: ee.number,
    a: ee.number
  })
};
fc.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.5 }
};
var dc = function(e) {
  var r = ge({
    default: {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        transform: "translate(-10px, -7px)",
        background: "hsl(" + Math.round(e.hsl.h) + ", 100%, 50%)",
        border: "2px white solid"
      }
    }
  });
  return M.createElement("div", { style: r.picker });
};
dc.propTypes = {
  hsl: ee.shape({
    h: ee.number,
    s: ee.number,
    l: ee.number,
    a: ee.number
  })
};
dc.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.5 }
};
var BI = function(e) {
  var r = e.onChange, n = e.rgb, a = e.hsl, i = e.hex, s = e.hsv, l = function(g, m) {
    if (g.hex)
      Yr(g.hex) && r({
        hex: g.hex,
        source: "hex"
      }, m);
    else if (g.rgb) {
      var d = g.rgb.split(",");
      Fo(g.rgb, "rgb") && r({
        r: d[0],
        g: d[1],
        b: d[2],
        a: 1,
        source: "rgb"
      }, m);
    } else if (g.hsv) {
      var w = g.hsv.split(",");
      Fo(g.hsv, "hsv") && (w[2] = w[2].replace("%", ""), w[1] = w[1].replace("%", ""), w[0] = w[0].replace("°", ""), w[1] == 1 ? w[1] = 0.01 : w[2] == 1 && (w[2] = 0.01), r({
        h: Number(w[0]),
        s: Number(w[1]),
        v: Number(w[2]),
        source: "hsv"
      }, m));
    } else if (g.hsl) {
      var b = g.hsl.split(",");
      Fo(g.hsl, "hsl") && (b[2] = b[2].replace("%", ""), b[1] = b[1].replace("%", ""), b[0] = b[0].replace("°", ""), f[1] == 1 ? f[1] = 0.01 : f[2] == 1 && (f[2] = 0.01), r({
        h: Number(b[0]),
        s: Number(b[1]),
        v: Number(b[2]),
        source: "hsl"
      }, m));
    }
  }, o = ge({
    default: {
      wrap: {
        display: "flex",
        height: "100px",
        marginTop: "4px"
      },
      fields: {
        width: "100%"
      },
      column: {
        paddingTop: "10px",
        display: "flex",
        justifyContent: "space-between"
      },
      double: {
        padding: "0px 4.4px",
        boxSizing: "border-box"
      },
      input: {
        width: "100%",
        height: "38px",
        boxSizing: "border-box",
        padding: "4px 10% 3px",
        textAlign: "center",
        border: "1px solid #dadce0",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      input2: {
        height: "38px",
        width: "100%",
        border: "1px solid #dadce0",
        boxSizing: "border-box",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        paddingLeft: "10px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label: {
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "35px",
        top: "-6px",
        left: "0",
        right: "0",
        marginLeft: "auto",
        marginRight: "auto",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label2: {
        left: "10px",
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "32px",
        top: "-6px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      single: {
        flexGrow: "1",
        margin: "0px 4.4px"
      }
    }
  }), u = n.r + ", " + n.g + ", " + n.b, c = Math.round(a.h) + "°, " + Math.round(a.s * 100) + "%, " + Math.round(a.l * 100) + "%", f = Math.round(s.h) + "°, " + Math.round(s.s * 100) + "%, " + Math.round(s.v * 100) + "%";
  return M.createElement(
    "div",
    { style: o.wrap, className: "flexbox-fix" },
    M.createElement(
      "div",
      { style: o.fields },
      M.createElement(
        "div",
        { style: o.double },
        M.createElement(Pe, {
          style: { input: o.input, label: o.label },
          label: "hex",
          value: i,
          onChange: l
        })
      ),
      M.createElement(
        "div",
        { style: o.column },
        M.createElement(
          "div",
          { style: o.single },
          M.createElement(Pe, {
            style: { input: o.input2, label: o.label2 },
            label: "rgb",
            value: u,
            onChange: l
          })
        ),
        M.createElement(
          "div",
          { style: o.single },
          M.createElement(Pe, {
            style: { input: o.input2, label: o.label2 },
            label: "hsv",
            value: f,
            onChange: l
          })
        ),
        M.createElement(
          "div",
          { style: o.single },
          M.createElement(Pe, {
            style: { input: o.input2, label: o.label2 },
            label: "hsl",
            value: c,
            onChange: l
          })
        )
      )
    )
  );
}, pc = function(e) {
  var r = e.width, n = e.onChange, a = e.rgb, i = e.hsl, s = e.hsv, l = e.hex, o = e.header, u = e.styles, c = u === void 0 ? {} : u, f = e.className, p = f === void 0 ? "" : f, g = ge(_t({
    default: {
      picker: {
        width: r,
        background: "#fff",
        border: "1px solid #dfe1e5",
        boxSizing: "initial",
        display: "flex",
        flexWrap: "wrap",
        borderRadius: "8px 8px 0px 0px"
      },
      head: {
        height: "57px",
        width: "100%",
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingLeft: "16px",
        fontSize: "20px",
        boxSizing: "border-box",
        fontFamily: "Roboto-Regular,HelveticaNeue,Arial,sans-serif"
      },
      saturation: {
        width: "70%",
        padding: "0px",
        position: "relative",
        overflow: "hidden"
      },
      swatch: {
        width: "30%",
        height: "228px",
        padding: "0px",
        background: "rgba(" + a.r + ", " + a.g + ", " + a.b + ", 1)",
        position: "relative",
        overflow: "hidden"
      },
      body: {
        margin: "auto",
        width: "95%"
      },
      controls: {
        display: "flex",
        boxSizing: "border-box",
        height: "52px",
        paddingTop: "22px"
      },
      color: {
        width: "32px"
      },
      hue: {
        height: "8px",
        position: "relative",
        margin: "0px 16px 0px 16px",
        width: "100%"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, c));
  return M.createElement(
    "div",
    { style: g.picker, className: "google-picker " + p },
    M.createElement(
      "div",
      { style: g.head },
      o
    ),
    M.createElement("div", { style: g.swatch }),
    M.createElement(
      "div",
      { style: g.saturation },
      M.createElement(to, {
        hsl: i,
        hsv: s,
        pointer: fc,
        onChange: n
      })
    ),
    M.createElement(
      "div",
      { style: g.body },
      M.createElement(
        "div",
        { style: g.controls, className: "flexbox-fix" },
        M.createElement(
          "div",
          { style: g.hue },
          M.createElement(wa, {
            style: g.Hue,
            hsl: i,
            radius: "4px",
            pointer: dc,
            onChange: n
          })
        )
      ),
      M.createElement(BI, {
        rgb: a,
        hsl: i,
        hex: l,
        hsv: s,
        onChange: n
      })
    )
  );
};
pc.propTypes = {
  width: ee.oneOfType([ee.string, ee.number]),
  styles: ee.object,
  header: ee.string
};
pc.defaultProps = {
  width: 652,
  styles: {},
  header: "Color picker"
};
At(pc);
const RI = "_container_1mcba_1", $I = "_button_1mcba_6", up = {
  container: RI,
  button: $I
}, Rm = ({ onChange: t, value: e, label: r, type: n, ...a }) => {
  const [i, s] = $e(e), [l, o] = $e(!1);
  return xe(() => {
    s(n === "color" || n === "bg" ? `rgba(${Object.values(e)})` : e);
  }, [e, n]), /* @__PURE__ */ x.jsxs(
    "div",
    {
      className: up.container,
      onClick: () => {
        o(!0);
      },
      children: [
        (n === "color" || n === "bg") && l ? /* @__PURE__ */ x.jsxs("div", { className: up.button, children: [
          /* @__PURE__ */ x.jsx(
            "button",
            {
              onClick: (u) => {
                u.preventDefault(), u.stopPropagation(), o(!1);
              }
            }
          ),
          /* @__PURE__ */ x.jsx(aI, { color: e, onChange: (u) => t == null ? void 0 : t(u.rgb) })
        ] }) : null,
        n === "textarea" && /* @__PURE__ */ x.jsx(
          Xy,
          {
            ...a,
            required: !0,
            labelConfig: { text: r || "" },
            onKeyUp: (u) => t == null ? void 0 : t(u.target.value),
            onWppChange: (u) => s(u.detail.value),
            value: i
          }
        ) || /* @__PURE__ */ x.jsx(
          yu,
          {
            ...a,
            ...n === "number" && { type: n },
            required: !0,
            labelConfig: { text: r || "" },
            onWppChange: (u) => {
              s(u.detail.value), t == null || t(u.target.value);
            },
            value: i,
            size: "s"
          }
        )
      ]
    }
  );
}, MI = "_root_td118_1", FI = "_inline_td118_5", II = "_column_td118_9", jI = "_nowrap_td118_45", LI = "_wrap_td118_49", _n = {
  root: MI,
  inline: FI,
  column: II,
  "align-start": "_align-start_td118_13",
  "align-center": "_align-center_td118_17",
  "align-end": "_align-end_td118_21",
  "justify-start": "_justify-start_td118_25",
  "justify-center": "_justify-center_td118_29",
  "justify-end": "_justify-end_td118_33",
  "justify-between": "_justify-between_td118_37",
  "justify-around": "_justify-around_td118_41",
  nowrap: jI,
  wrap: LI
}, fe = hr(function(e, r) {
  const {
    as: n = "div",
    inline: a = !1,
    direction: i = "row",
    wrap: s,
    align: l,
    justify: o,
    gap: u,
    className: c,
    style: f,
    ...p
  } = e;
  return /* @__PURE__ */ x.jsx(
    n,
    {
      ref: r,
      ...p,
      style: { ...f, ...!!u && { gap: `${u}px` } },
      className: ke(
        _n.root,
        {
          [_n.inline]: a,
          [_n[`${s}`]]: !!s,
          [_n.column]: i === "column",
          [_n[`align-${l}`]]: !!l,
          [_n[`justify-${o}`]]: !!o
        },
        c
      )
    }
  );
}), kI = 0.299, NI = 0.587, zI = 0.114, WI = 127.5, hc = (t) => ({
  color: t != null && t.color ? t.color : getComputedStyle(document.documentElement).getPropertyValue("--wpp-grey-color-000")
}), ao = {
  color: ""
}, HI = {
  VALIDATE_HEX_COLOR: /^#([a-f0-9]{3}){1,2}\b$/i,
  VALIDATE_RGB_RGBA_COLOR: /^rgb\(\d{1,3}%?(,\s?\d{1,3}%?){2}\)|rgba\((\d{1,3}%?,\s?){3}(1|0?\.\d+)\)$/i
}, UI = {
  MATCH_RGB_RGBA_COLOR: /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/i
};
function VI(t) {
  if (t.length === 3) {
    const [e, r, n] = t.split("");
    return `${e + e}${r + r}${n + n}`;
  }
  return t;
}
function qI(t) {
  const e = t.slice(1), r = VI(e), n = parseInt(r, 16), a = n >> 16 & 255, i = n >> 8 & 255, s = n & 255;
  return {
    r: a,
    g: i,
    b: s
  };
}
function cp({ r: t, g: e, b: r }) {
  return Math.sqrt(kI * t * t + NI * e * e + zI * r * r);
}
function GI(t, e, r, n) {
  const l = 1 - n;
  return {
    r: Math.round(l * 255 + n * t),
    g: Math.round(l * 255 + n * e),
    b: Math.round(l * 255 + n * r)
  };
}
function YI(t) {
  const { MATCH_RGB_RGBA_COLOR: e } = UI, r = t.match(e);
  if (r) {
    const [, n, a, i, s] = r, l = parseInt(n, 10), o = parseInt(a, 10), u = parseInt(i, 10);
    if (s) {
      const c = parseFloat(s);
      return GI(l, o, u, c);
    }
    return {
      r: l,
      g: o,
      b: u
    };
  }
}
function KI(t, e = WI) {
  const { VALIDATE_HEX_COLOR: r, VALIDATE_RGB_RGBA_COLOR: n } = HI;
  if (r.test(t))
    return cp(qI(t)) > e ? "light" : "dark";
  if (n.test(t)) {
    const a = YI(t);
    return a ? cp(a) > e ? "light" : "dark" : null;
  }
  return null;
}
const Ds = ({ direction: t, start: e, end: r }) => `linear-gradient(to ${t}, ${e}, ${r})`, gc = (t) => ({
  start: t != null && t.start ? t.start : getComputedStyle(document.documentElement).getPropertyValue("--wpp-primary-color-600"),
  end: t != null && t.end ? t.end : getComputedStyle(document.documentElement).getPropertyValue("--wpp-primary-color-400"),
  direction: t != null && t.direction ? t.direction : "right"
}), io = {
  start: "",
  end: "",
  direction: "right"
}, XI = (t) => t == null, $m = ({
  backgroundData: t,
  imageUrl: e
}) => {
  var c;
  const r = (c = t == null ? void 0 : t.image) == null ? void 0 : c.properties, n = t == null ? void 0 : t.color, a = t == null ? void 0 : t.gradient, i = hc(t == null ? void 0 : t.color), s = gc(t == null ? void 0 : t.gradient), l = (t == null ? void 0 : t.type) === "color" && !!n, o = (t == null ? void 0 : t.type) === "gradient" && !!a, u = !XI(t == null ? void 0 : t.opacity);
  return {
    ...!!e && {
      backgroundImage: o ? `url( ${e} ), ${Ds(s)}` : `url( ${e} )`,
      ...!!(r != null && r.size) && { backgroundSize: r.size },
      ...!!(r != null && r.position) && {
        backgroundPosition: r.position
      },
      ...!!(r != null && r.repeat) && {
        backgroundRepeat: r.repeat
      }
    },
    ...l && { backgroundColor: i.color },
    ...u && { opacity: (t == null ? void 0 : t.opacity) && (t == null ? void 0 : t.opacity) / 100 },
    ...!e && o && {
      background: Ds(s)
    }
  };
}, vc = {
  image: { imageMetaData: null, imageSize: {} },
  properties: {
    size: "cover",
    position: "center center",
    repeat: "no-repeat",
    scale: "cover"
  }
}, ZI = () => {
  const { loc: t } = se();
  return gt(
    () => ({
      noScale: {
        value: "unset",
        label: t("noScale")
      },
      fill: {
        value: "cover",
        label: t("fill")
      },
      fit: {
        value: "contain",
        label: t("fit")
      },
      tile: {
        value: "repeat",
        label: t("tile")
      }
    }),
    [t]
  );
}, JI = () => {
  const { loc: t } = se();
  return gt(
    () => ({
      leftTop: {
        value: "left top",
        label: t("leftTop")
      },
      centerTop: {
        value: "center top",
        label: t("centerTop")
      },
      rightTop: {
        value: "right top",
        label: t("rightTop")
      },
      leftCenter: {
        value: "left center",
        label: t("leftCenter")
      },
      centerCenter: {
        value: "center center",
        label: t("centerCenter")
      },
      rightCenter: {
        value: "right center",
        label: t("rightCenter")
      },
      leftBottom: {
        value: "left bottom",
        label: t("leftBottom")
      },
      centerBottom: {
        value: "center bottom",
        label: t("centerBottom")
      },
      rightBottom: {
        value: "right bottom",
        label: t("rightBottom")
      }
    }),
    [t]
  );
}, so = Vt({
  isDragging: !1
}), oo = Vt({}), Oq = {
  error: "var(--wpp-danger-color-400)",
  success: "var(--wpp-brand-color)"
}, dr = 10, Mm = "customLayoutChange", Lr = (t) => t.indexOf("%") > -1, fp = (t) => `${t}px`, Ss = (t, e) => t.indexOf("px") > -1 || t === "auto" || !e ? t : parseInt(t) / 100 * e + "px", Os = (t, e) => {
  const r = Number(t), n = Math.abs(Number(r)) / e * 100;
  return r < 0 ? -1 * n : Math.round(n);
}, na = (t) => {
  const e = getComputedStyle(t);
  let r = t.clientHeight, n = t.clientWidth;
  return r -= parseFloat(e.paddingTop) + parseFloat(e.paddingBottom), n -= parseFloat(e.paddingLeft) + parseFloat(e.paddingRight), {
    width: n,
    height: r
  };
}, QI = 2, ql = (t = 0) => {
  const { isDragging: e } = Ht(so);
  return e ? Math.max(t, QI) : t;
}, gr = (t) => {
  const e = ql(t == null ? void 0 : t[2]);
  return t && [t[0], t[1], e, t[3]];
}, ej = (t) => {
  const e = ql(t == null ? void 0 : t[0]), r = ql(t == null ? void 0 : t[2]);
  return t && [e, t[1], r, t[3]];
}, Fm = () => {
  const [t, e] = $e(!1), r = oe(() => e(!0), []), n = oe(() => e(!1), []);
  return li("dragstart", r), li("dragend", n), t;
}, mc = () => {
  const { viewportRef: t } = Ht(so);
  return oe(() => {
    var e;
    (e = t == null ? void 0 : t.current) == null || e.dispatchEvent(new Event(Mm));
  }, [t]);
}, pr = (t) => /^\d+$/.test(t) ? Number(t) : t, Ze = (t) => t != null && t.map ? t.map((e) => (e || 0) + "px").join(" ") : "";
function Im(t) {
  return !!t;
}
const tj = (t, e) => t.filter((r) => r !== 0 && Im(r)).join(e);
function rj(t, e) {
  return t.reduce((r, n) => (r.length === 0 || r[r.length - 1].length === e ? r.push([n]) : r[r.length - 1].push(n), r), []);
}
const nj = () => /Macintosh|Mac OS X/.test(navigator.userAgent), aj = (t) => {
  if (typeof t != "string")
    return !1;
  try {
    const e = JSON.parse(t);
    return typeof e != "object" ? !1 : !Array.isArray(e);
  } catch {
    return !1;
  }
}, ij = (t) => {
  let e = 0;
  for (let r = 0; r < t.length; r++) {
    const n = t.charCodeAt(r);
    e = (e << 5) - e + n, e |= 0;
  }
  return `key-${Math.abs(e)}`;
}, sj = 500, oj = 100, Re = ({
  propKey: t,
  type: e,
  index: r = 0,
  onSubmit: n,
  max: a,
  step: i,
  selector: s,
  ...l
}) => {
  const o = s || ((m) => m), {
    actions: { setProp: u },
    propValue: c
  } = me((m) => ({
    propValue: o(m.data.props)[t]
  })), f = Array.isArray(c), p = f ? c[r] : c, g = tj([t, f && r.toString(), e].filter(Im), "-");
  return /* @__PURE__ */ x.jsx(fe, { direction: "column", gap: 8, "data-testid": g, children: ["text", "color", "bg", "number", "textarea"].includes(e) ? /* @__PURE__ */ x.jsx(
    Rm,
    {
      ...l,
      type: e,
      value: p,
      onChange: (m) => {
        u((d) => {
          Array.isArray(c) ? o(d[t])[r] = m : o(d)[t] = m;
        }, sj), n == null || n(m);
      }
    }
  ) : e === "slider" ? /* @__PURE__ */ x.jsx(
    Zy,
    {
      labelConfig: { text: l.label || "" },
      min: 0,
      max: a || 100,
      step: i || 1,
      value: parseInt(p),
      required: !0,
      onWppChange: (m) => {
        const d = m.detail.value;
        u((w) => {
          Array.isArray(c) ? o(w[t])[r] = d : o(w)[t] = d;
        }, oj);
      }
    }
  ) : e === "radio" ? /* @__PURE__ */ x.jsxs(fe, { direction: "column", gap: 8, children: [
    l.label ? /* @__PURE__ */ x.jsx(_e, { type: "s-strong", children: l.label }) : null,
    /* @__PURE__ */ x.jsx(
      Jy,
      {
        value: p,
        onWppChange: (m) => {
          const d = m.detail.value;
          u((w) => {
            o(w)[t] = d;
          });
        },
        children: /* @__PURE__ */ x.jsx(fe, { gap: 12, children: l.children })
      }
    )
  ] }) : e === "checkbox" ? /* @__PURE__ */ x.jsx(
    ii,
    {
      required: !0,
      checked: p,
      labelConfig: {
        text: l.label || ""
      },
      onWppChange: () => {
        u((m) => {
          o(m)[t] = !p;
        });
      }
    }
  ) : e === "select" ? /* @__PURE__ */ x.jsx(
    mv,
    {
      label: l.label || "",
      value: p || "",
      onChange: (m) => u((d) => o(d)[t] = m),
      ...l
    }
  ) : null });
}, lj = "_container_9szkn_1", uj = "_title_9szkn_5", dp = {
  container: lj,
  title: uj
}, at = ({ title: t, props: e, summary: r, withPaddings: n = !0, children: a }) => {
  const { nodeProps: i } = me((l) => ({
    nodeProps: e && (e == null ? void 0 : e.reduce((o, u) => (o[u] = l.data.props[u] || null, o), {}))
  })), s = r && e;
  return /* @__PURE__ */ x.jsxs(fe, { direction: "column", gap: 12, className: ke({ [dp.container]: n }), children: [
    t && /* @__PURE__ */ x.jsxs(fe, { children: [
      /* @__PURE__ */ x.jsx(_e, { type: "s-strong", className: dp.title, children: t }),
      s && /* @__PURE__ */ x.jsx(_e, { type: "xs-body", children: r(
        e.reduce((l, o) => (l[o] = i && i[o], l), {})
      ) })
    ] }),
    /* @__PURE__ */ x.jsx(fe, { direction: "column", gap: 16, children: a })
  ] });
}, cj = "_root_1bp29_1", fj = "_indicator_1bp29_8", dj = "_main_1bp29_15", pj = "_actions_1bp29_25", hj = "_btn_1bp29_31", gj = "_btnMove_1bp29_31", vj = "_btnPointer_1bp29_31", mj = "_nodeHighlighted_1bp29_52", yj = "_nodeLinked_1bp29_52", bj = "_nodeActive_1bp29_52", wj = "_nodeHover_1bp29_52", Zt = {
  root: cj,
  indicator: fj,
  main: dj,
  actions: pj,
  btn: hj,
  btnMove: gj,
  btnPointer: vj,
  nodeHighlighted: mj,
  nodeLinked: yj,
  nodeActive: bj,
  nodeHover: wj
};
var aa = "text/plain", xj = "text/html";
function Ej() {
  (console.warn || console.log).apply(console, arguments);
}
Ej.bind("[clipboard-polyfill]");
var yc = typeof window > "u" ? void 0 : window, Cj = typeof globalThis > "u" ? void 0 : globalThis, pp, hp, gp, vp = (gp = (pp = yc) == null ? void 0 : pp.Promise) != null ? gp : (hp = Cj) == null ? void 0 : hp.Promise;
function Dj() {
  if (!vp)
    throw new Error(
      "No `Promise` implementation available for `clipboard-polyfill`. Consider using: https://github.com/lgarron/clipboard-polyfill#flat-file-version-with-promise-included"
    );
  return vp;
}
var mp = typeof navigator > "u" ? void 0 : navigator, Wt = mp == null ? void 0 : mp.clipboard, yp;
(yp = Wt == null ? void 0 : Wt.read) == null || yp.bind(
  Wt
);
var bp;
(bp = Wt == null ? void 0 : Wt.readText) == null || bp.bind(
  Wt
);
var wp, xp = (wp = Wt == null ? void 0 : Wt.write) == null ? void 0 : wp.bind(
  Wt
), Ep;
(Ep = Wt == null ? void 0 : Wt.writeText) == null || Ep.bind(
  Wt
);
var Cp, Gl = (Cp = yc) == null ? void 0 : Cp.ClipboardItem, Kr = Dj(), Qn = yc;
function Sj() {
  return typeof ClipboardEvent > "u" && typeof (Qn == null ? void 0 : Qn.clipboardData) < "u" && typeof (Qn == null ? void 0 : Qn.clipboardData.setData) < "u";
}
function Oj(t) {
  if (!Qn.clipboardData)
    return !1;
  var e = Qn.clipboardData.setData("Text", t);
  return e;
}
function Pj(t, e, r) {
  t.success = !0;
  for (var n in e) {
    var a = e[n], i = r.clipboardData;
    i.setData(n, a), n === aa && i.getData(n) !== a && (t.success = !1);
  }
  r.preventDefault();
}
function jm(t) {
  var e = { success: !1 }, r = Pj.bind(this, e, t);
  document.addEventListener("copy", r);
  try {
    document.execCommand("copy");
  } finally {
    document.removeEventListener("copy", r);
  }
  return e.success;
}
function Lm(t, e) {
  km(t);
  var r = jm(e);
  return Nm(), r;
}
function _j(t) {
  var e = document.createElement("div");
  e.setAttribute("style", "-webkit-user-select: text !important"), e.textContent = "temporary element", document.body.appendChild(e);
  var r = Lm(e, t);
  return document.body.removeChild(e), r;
}
function Aj(t) {
  var e = document.createElement("div");
  e.setAttribute("style", "-webkit-user-select: text !important");
  var r = e;
  e.attachShadow && (r = e.attachShadow({ mode: "open" }));
  var n = document.createElement("span");
  n.innerText = t, r.appendChild(n), document.body.appendChild(e), km(n);
  var a = document.execCommand("copy");
  return Nm(), document.body.removeChild(e), a;
}
function km(t) {
  var e = document.getSelection();
  if (e) {
    var r = document.createRange();
    r.selectNodeContents(t), e.removeAllRanges(), e.addRange(r);
  }
}
function Nm() {
  var t = document.getSelection();
  t && t.removeAllRanges();
}
function Tj(t) {
  var e = aa in t;
  if (Sj()) {
    if (!e)
      throw new Error("No `text/plain` value was specified.");
    if (Oj(t[aa]))
      return !0;
    throw new Error("Copying failed, possibly because the user rejected it.");
  }
  return jm(t), !!(navigator.userAgent.indexOf("Edge") > -1 || Lm(document.body, t) || _j(t) || Aj(t[aa]));
}
function zm(t, e) {
  var r = [];
  for (var n in t) {
    var a = t[n];
    r.push(e(a));
  }
  return Kr.all(r).then((i) => {
    for (var s = {}, l = 0; l < t.length; l++)
      s[t[l]] = i[l];
    return s;
  });
}
var Bj = Kr.resolve(), Rj = () => Kr.resolve(!0), Dp = Kr.resolve(!1);
function $j(t) {
  return new Kr((e, r) => {
    try {
      e(t());
    } catch (n) {
      r(n);
    }
  });
}
function jo(t, e) {
  for (var r in t) {
    var n = t[r];
    if (n.types.indexOf(e) !== -1)
      return !0;
  }
  return !1;
}
function Mj(t, e) {
  var r, n = Object.keys(t), a = {};
  for (var i in t) {
    var s = t[i];
    typeof s == "string" ? a[i] = Ij(i, s) : a[i] = s;
  }
  var l = (r = e == null ? void 0 : e.presentationStyle) != null ? r : "unspecified";
  function o(u) {
    return Kr.resolve(a[u]);
  }
  return {
    types: n,
    presentationStyle: l,
    getType: o
  };
}
var Fj = Mj;
function Ij(t, e) {
  return new Blob([e], {
    type: t
  });
}
function jj(t) {
  return new Kr((e, r) => {
    var n = new FileReader();
    n.addEventListener("load", () => {
      var a = n.result;
      typeof a == "string" ? e(a) : r("could not convert blob to string");
    }), n.readAsText(t);
  });
}
function Lj(t) {
  return zm(t.types, function(e) {
    return t.getType(e);
  }).then((e) => new Promise((r, n) => {
    var a = {};
    t.presentationStyle && (a.presentationStyle = t.presentationStyle), Gl ? r(new Gl(e, a)) : n("window.ClipboardItem is not defined");
  }));
}
function kj(t, e) {
  return t.getType(e).then((r) => jj(r));
}
function Nj(t) {
  return zm(t.types, function(e) {
    return kj(t, e);
  });
}
function zj(t) {
  return $j(() => {
    if (xp && Gl) {
      var e = xp;
      return Kr.all(t.map(Lj)).then(
        (r) => e(r).then(Rj).catch((n) => {
          if (!jo(t, aa) && !jo(t, xj))
            throw n;
          return Dp;
        })
      );
    }
    return Dp;
  }).then((e) => e ? Bj : (jo(t, aa), Nj(t[0]).then((r) => {
    if (!Tj(r))
      throw new Error("write() failed");
  })));
}
const Wm = () => {
  const { query: t } = Le();
  return oe(
    (e) => {
      const r = {}, n = (i, s) => {
        var f;
        const l = _b(), o = i.data.nodes.map((p) => n(e.nodes[p], l)), u = Object.keys(i.data.linkedNodes).reduce((p, g) => {
          const m = n(e.nodes[i.data.linkedNodes[g]], l);
          return {
            ...p,
            [g]: m
          };
        }, {}), c = {
          ...i,
          id: l,
          data: {
            ...i.data,
            parent: s || ((f = i == null ? void 0 : i.data) == null ? void 0 : f.parent),
            nodes: o,
            linkedNodes: u
          }
        };
        return r[l] = t.parseFreshNode(c).toNode(), l;
      };
      return {
        rootNodeId: n(e.nodes[e.rootNodeId]),
        nodes: r
      };
    },
    [t]
  );
};
function Ps(t, e = []) {
  if (typeof t != "object" || t === null)
    return e;
  if (Array.isArray(t))
    for (let r = 0; r < t.length; r++)
      Ps(t[r], e);
  else {
    const r = t;
    for (const n in r)
      n === "assetId" ? e.push(t) : Ps(r[n], e);
  }
  return e;
}
function Wj(t) {
  return new Promise((e, r) => {
    const n = new FileReader();
    n.addEventListener("load", () => {
      const a = n.result;
      e(a);
    }), n.onerror = function(a) {
      r(a);
    }, n.readAsDataURL(t);
  });
}
const Hj = async (t, e) => {
  try {
    const r = "text/plain", n = new Blob([JSON.stringify({ builderContent: t, sessionUID: e })], { type: r }), a = [new Fj({ [r]: n })];
    await zj(a);
  } catch (r) {
    console.error(r);
  }
}, Uj = () => {
  const { query: t } = Le();
  return (e) => ({
    rootNodeId: e.rootNodeId,
    nodes: Object.keys(e.nodes).reduce((r, n) => ({
      [n]: JSON.parse(JSON.stringify(t.node(n).toSerializedNode())),
      ...r
    }), {})
  });
}, Hm = () => {
  const { query: t } = Le();
  return (e) => ({
    rootNodeId: e.rootNodeId,
    nodes: Object.keys(e.nodes).reduce((r, n) => ({
      [n]: t.parseSerializedNode(e.nodes[n]).toNode(),
      ...r
    }), {})
  });
};
function Vj(t) {
  return t.split(";")[0].split(":")[1];
}
function qj(t, e, r) {
  const n = t.split(","), a = atob(n[1]);
  let i = a.length;
  const s = new Uint8Array(i);
  for (; i--; )
    s[i] = a.charCodeAt(i);
  return new File([s], e, { type: r });
}
const Gj = () => {
  const {
    setInternals: t,
    loc: e,
    dependencies: { uploadAsset: r, enqueueToast: n }
  } = se();
  return async (a) => {
    const i = Ps(a);
    try {
      t({ loading: !0 }), n && n({
        message: e("insertingContent"),
        type: "information"
      });
      for await (const s of i)
        if (s.assetBase64) {
          const l = Vj(s.assetBase64), {
            data: [o]
          } = await r([{ name: s.name, contentType: l }]);
          await pv.put(
            o.uploadUrl,
            qj(s.assetBase64, s.name, l),
            {
              headers: { "Content-Type": l }
            }
          ), s.assetId = o.id || o.assetId, delete s.assetBase64;
        } else
          s.assetId = null;
    } finally {
      n && n({
        message: e("insertingContentDone"),
        type: "success"
      });
    }
    return a;
  };
}, bc = ({ target: t = document.body, children: e }) => Bb(e, t), Sp = (t, e, r) => Math.min(Math.max(t, e), r), Yj = () => {
}, lo = ({
  href: t,
  target: e
}) => {
  const r = document.createElement("a");
  r.href = t, e && (r.target = e), e === "_blank" && r.setAttribute("rel", "noreferrer"), r.click(), r.remove();
}, Kj = (t) => t !== void 0, wc = ({
  labelConfig: t,
  labelTooltipConfig: e
}) => {
  const { loc: r } = se(), n = gt(
    () => ({
      optional: r("optional")
    }),
    [r]
  );
  let a = t, i = e;
  if (a) {
    const { text: s, description: l, icon: o, locales: u = n } = a;
    if (a = {
      text: s,
      description: l,
      locales: u,
      icon: o,
      ...!o && !!l && { icon: "wpp-icon-info" }
    }, i) {
      const { placement: c, ...f } = i;
      i = {
        ...f,
        ...!!l && !c && { placement: "right" }
      };
    } else
      l && (i = { placement: "right" });
  }
  return {
    labelConfig: a,
    labelTooltipConfig: i
  };
}, Xj = 29, Zj = () => {
  const {
    loc: t,
    dependencies: { enqueueToast: e }
  } = se(), { nodeToolbarRef: r } = Ht(oo), { viewportRef: n, isDragging: a } = Ht(so), i = n.current, s = Rl(a), l = de(null), { actions: o, query: u, connectors: c, nodesCount: f } = Le((F) => ({
    nodesCount: Object.keys(F.nodes).length
  })), {
    connectors: { drag: p },
    node: g,
    name: m,
    marginTop: d,
    marginLeft: w,
    isActive: b,
    isHovered: O,
    isDraggable: S,
    isDeletable: B
  } = me((F) => {
    var k, N;
    return {
      node: F,
      name: F.data.custom.displayName || F.data.displayName,
      marginTop: (k = F.data.props.margin) == null ? void 0 : k[0],
      marginLeft: (N = F.data.props.margin) == null ? void 0 : N[3],
      isActive: F.events.selected,
      isHovered: F.events.hovered,
      isDraggable: u.node(F.id).isDraggable(),
      isDeletable: u.node(F.id).isDeletable()
    };
  }), { getParentComponent: T } = Um(), A = oe(
    (F) => {
      F && (l.current = F, c.hover(F, g.id));
    },
    [c, g.id, l]
  ), D = g.id !== Ab, h = S || D || B, y = oe(() => {
    const F = u.node(g.data.parent).get(), k = T(F);
    o.selectNode(k.id);
  }, [o, T, g.data.parent, u]), v = oe(() => o.delete(g.id), [o, g.id]), [E, _] = $e({ top: -1e3, left: 0 }), C = oe(() => {
    var F;
    if (b || O) {
      const k = i.getBoundingClientRect(), N = g.dom.getBoundingClientRect(), U = (F = l.current) == null ? void 0 : F.getBoundingClientRect(), Y = (U == null ? void 0 : U.width) || 0, L = (U == null ? void 0 : U.height) || Xj;
      _({
        top: Sp(N.top - L + 1, k.top, k.bottom - (L - 1)),
        left: Sp(N.left, k.left, k.right - Y)
      });
    }
  }, [b, O, g.dom, i]);
  li("scroll", C, i), li(Mm, C, i), xe(() => {
    const F = new ResizeObserver(C);
    return F.observe(l.current), () => {
      F.disconnect();
    };
  }, [i, C]), xe(() => {
    s !== a && C();
  }, [C, s, a]);
  const P = Rl(f);
  xe(() => {
    f !== P && C();
  }, [P, f, C]), xe(C, [C, d, w]);
  const $ = Uj(), {
    dependencies: { loadAsset: W }
  } = se(), {
    internals: { sessionUID: j }
  } = se(), I = async () => {
    const F = u.node(g.id).toNodeTree(), k = $(F), N = Ps(k);
    for await (const U of N)
      if (U.assetId && W) {
        const Y = await W({ assetId: U.assetId });
        U.assetBase64 = await Wj(Y);
      }
    await Hj(k, j), e && e({
      type: "success",
      header: t("copyWidgetTitle"),
      duration: 2e3,
      message: t("copyWidgetMessage", {
        pasteHotkey: nj() ? "CMD+V" : "CTRL+V"
      })
    });
  };
  return /* @__PURE__ */ x.jsx(bc, { target: i, children: /* @__PURE__ */ x.jsx("div", { className: Zt.root, ref: A, style: E, "data-testid": "editor-node-indicator", children: /* @__PURE__ */ x.jsxs("div", { className: Zt.indicator, children: [
    /* @__PURE__ */ x.jsxs("div", { className: Zt.main, children: [
      /* @__PURE__ */ x.jsx("span", { children: t(m) }),
      h && /* @__PURE__ */ x.jsxs("div", { className: Zt.actions, children: [
        /* @__PURE__ */ x.jsx(tL, { onClick: I }),
        S && /* @__PURE__ */ x.jsx(Jj, { ref: (F) => p(F) }),
        D && /* @__PURE__ */ x.jsx(Qj, { onClick: y }),
        B && /* @__PURE__ */ x.jsx(eL, { onClick: v })
      ] })
    ] }),
    /* @__PURE__ */ x.jsx("div", { ref: r })
  ] }) }) });
}, Um = () => {
  const { query: t } = Le();
  return { getParentComponent: oe(
    (r) => {
      let n = t.node(r.id);
      for (; n.isLinkedNode(); )
        n = t.node(n.get().data.parent);
      return n.get();
    },
    [t]
  ) };
}, Jj = hr((t, e) => {
  const { loc: r } = se();
  return /* @__PURE__ */ x.jsx("div", { className: Zt.btnMove, ...t, ref: e, children: /* @__PURE__ */ x.jsx(Gr, { text: r("move"), children: /* @__PURE__ */ x.jsx(Qy, { color: "" }) }) });
}), Qj = ({ onClick: t }) => {
  const { loc: e } = se();
  return /* @__PURE__ */ x.jsx("div", { className: Zt.btnPointer, onClick: t, children: /* @__PURE__ */ x.jsx(Gr, { text: e("selectParent"), children: /* @__PURE__ */ x.jsx(nv, { color: "", direction: "top" }) }) });
}, eL = ({ onClick: t }) => {
  const { loc: e } = se();
  return /* @__PURE__ */ x.jsx("div", { className: Zt.btnPointer, onClick: t, "data-testid": "indicator-delete-button", children: /* @__PURE__ */ x.jsx(Gr, { text: e("delete"), children: /* @__PURE__ */ x.jsx(bu, { color: "" }) }) });
}, tL = ({ onClick: t }) => {
  const { loc: e } = se();
  return /* @__PURE__ */ x.jsx("div", { className: Zt.btnPointer, onClick: t, "data-testid": "indicator-copy-button", children: /* @__PURE__ */ x.jsx(Gr, { text: e("copy"), children: /* @__PURE__ */ x.jsx(eb, { color: "" }) }) });
}, Pq = ({ render: t }) => {
  const e = de(null), { query: r, connectors: n, indicator: a } = Le((c) => ({
    indicator: c.indicator,
    state: c,
    enabled: c.options.enabled
  })), { node: i, isHover: s, isActive: l, isLinkedNode: o } = me((c) => {
    var f;
    return {
      node: c,
      isHover: c.events.hovered,
      isActive: c.events.selected,
      isLinkedNode: (f = r.node(c.id)) == null ? void 0 : f.isLinkedNode()
    };
  }), { getParentComponent: u } = Um();
  return xe(
    () => [i.id, ...r.node(i.id).descendants(!0, "linkedNodes")].forEach((c) => {
      var f;
      (f = r.node(c).get().dom) == null || f.classList[s ? "add" : "remove"](Zt.nodeHover);
    }),
    [i.id, s, r]
  ), xe(() => {
    var f, p;
    r.node(i.id).isLinkedNode() ? (f = i.dom) == null || f.classList[l ? "add" : "remove"](Zt.nodeLinked) : (p = i.dom) == null || p.classList[l ? "add" : "remove"](Zt.nodeActive);
  }, [i.dom, i.id, l, r]), xe(() => {
    if (o) {
      const c = u(r.node(i.id).get());
      n.hover(i.dom, c.id);
    }
  }, [i.id, i.dom, r, o, n, u]), xe(() => {
    var c;
    (c = a == null ? void 0 : a.placement.parent.dom) == null || c.dispatchEvent(new MouseEvent("mouseover"));
  }, [a]), /* @__PURE__ */ x.jsxs(oo.Provider, { value: { nodeToolbarRef: e }, children: [
    !o && (s || l) && /* @__PURE__ */ x.jsx(Zj, {}),
    t
  ] });
}, rL = "_sidebar_1c5pw_1", nL = "_disabled_1c5pw_7", aL = "_container_1c5pw_12", Lo = {
  sidebar: rL,
  disabled: nL,
  container: aL
}, iL = () => {
  const { enabled: t } = Le((e) => ({
    enabled: e.options.enabled
  }));
  return /* @__PURE__ */ x.jsx("div", { className: ke(Lo.sidebar, { [Lo.disabled]: !t }), "data-testid": "editor-sidebar", children: /* @__PURE__ */ x.jsx("div", { className: Lo.container, children: /* @__PURE__ */ x.jsx(qb, {}) }) });
}, sL = "_root_8snby_1", oL = "_editorContainer_8snby_10", lL = "_editorContainerDisabled_8snby_16", uL = "_viewport_8snby_20", cL = "_editor_8snby_10", Ma = {
  root: sL,
  editorContainer: oL,
  editorContainerDisabled: lL,
  viewport: uL,
  editor: cL
}, _q = ({ children: t, header: e, editorClassName: r, toolbox: n }) => {
  const { connectors: a, enabled: i } = Le((d) => ({
    enabled: d.options.enabled
  })), {
    internals: { sessionUID: s }
  } = se(), l = Fm(), o = de(null), u = oe(
    (d) => {
      d && (o && (o.current = d), a.hover(d, ""), a.select(d, ""));
    },
    [a, o]
  ), { query: c, actions: f } = Le(), p = Wm(), g = Hm(), m = Gj();
  return li("paste", async (d) => {
    var O;
    d.stopPropagation();
    const w = d, b = (O = w == null ? void 0 : w.clipboardData) == null ? void 0 : O.getData("text");
    if (aj(b))
      try {
        const S = c.getEvent("selected").first();
        if (b) {
          const { builderContent: B, sessionUID: T } = JSON.parse(
            b
          ), A = p(
            g(s === T ? B : await m(B))
          );
          f.addNodeTree(A, S);
        }
      } catch (S) {
        console.error(S);
      }
  }), /* @__PURE__ */ x.jsx(so.Provider, { value: { viewportRef: o, isDragging: i && l }, children: /* @__PURE__ */ x.jsxs("div", { className: Ma.root, "data-readonly": !i, "data-testid": "editor-layout", children: [
    e,
    /* @__PURE__ */ x.jsxs("div", { className: ke(Ma.editorContainer, { [Ma.editorContainerDisabled]: !i }), children: [
      n,
      /* @__PURE__ */ x.jsx("div", { className: Ma.viewport, ref: u, children: /* @__PURE__ */ x.jsx("div", { className: ke(Ma.editor, r), children: t }) }),
      /* @__PURE__ */ x.jsx(iL, {})
    ] })
  ] }) });
}, fL = "_toolboxItem_1vynt_1", dL = "_disabled_1vynt_13", pL = "_iconContainer_1vynt_20", hL = "_modal_1vynt_28", gL = "_modalBody_1vynt_42", vL = "_modalSpinner_1vynt_46", mL = "_templatesGroup_1vynt_50", yL = "_templateCard_1vynt_56", bL = "_templateImageWrapper_1vynt_62", wL = "_templateNameWrapper_1vynt_74", xL = "_templateName_1vynt_74", Yt = {
  toolboxItem: fL,
  disabled: dL,
  iconContainer: pL,
  modal: hL,
  modalBody: gL,
  modalSpinner: vL,
  templatesGroup: mL,
  templateCard: yL,
  templateImageWrapper: bL,
  templateNameWrapper: wL,
  templateName: xL
};
function EL() {
  const {
    dependencies: { loadTemplates: t, showTemplates: e }
  } = se(), [r, n] = $e(!0), [a, i] = $e([]);
  return xe(() => {
    if (!e)
      return;
    (async () => {
      try {
        if (t) {
          const l = await t();
          i(l.data), n(!1);
        } else
          i([]);
      } catch {
        process.env.DEV && console.error("Templates loading failed");
      }
    })();
  }, [t, e]), {
    isLoading: r,
    templates: a
  };
}
const CL = "_modal_8iun5_1", DL = {
  modal: CL
}, Vm = hr(({ formConfig: t, className: e, ...r }, n) => /* @__PURE__ */ x.jsx(bc, { children: /* @__PURE__ */ x.jsx(tb, { ref: n, ...r, formConfig: t, className: Pb(DL.modal, e) }) })), xc = () => {
  const [t, e] = $e(!1);
  return { isOpen: t, onClose: () => e(!1), onOpen: () => e(!0) };
}, SL = "ROOT", OL = () => {
  const {
    loc: t,
    dependencies: { showTemplates: e }
  } = se(), { actions: r, query: n } = Le((b) => ({
    enabled: b.options.enabled
  })), { isOpen: a, onOpen: i, onClose: s } = xc(), { templates: l, isLoading: o } = EL(), u = !l.length && !o, [c, f] = $e(null), p = Wm(), g = Hm(), m = n.getEvent("selected").first(), d = () => {
    f(null), s();
  }, w = () => {
    const b = p(g(c == null ? void 0 : c.config));
    r.addNodeTree(b, m || SL), f(null), s();
  };
  return e ? /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(
      Gr,
      {
        text: t("emptyTemplatesTooltip"),
        config: {
          placement: "right",
          onShow: () => {
            if (!u)
              return !1;
          }
        },
        children: /* @__PURE__ */ x.jsxs(
          "button",
          {
            className: ke(Yt.toolboxItem, { [Yt.disabled]: u }),
            disabled: u,
            onClick: i,
            children: [
              /* @__PURE__ */ x.jsx(fe, { className: Yt.iconContainer, justify: "center", align: "center", children: /* @__PURE__ */ x.jsx(rb, { color: "var(--wpp-primary-color-400)", width: 32, height: 32 }) }),
              /* @__PURE__ */ x.jsx(_e, { type: "xs-strong", children: t("templates") })
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ x.jsxs(
      nb,
      {
        className: Yt.modal,
        open: a,
        onWppFullScreenModalClose: s,
        "data-testid": "template-modal",
        children: [
          /* @__PURE__ */ x.jsxs(fe, { justify: "between", slot: "header", children: [
            /* @__PURE__ */ x.jsx(_e, { slot: "header", type: "2xl-heading", children: t("templates") }),
            /* @__PURE__ */ x.jsx(Dr, { onClick: d, variant: "secondary", children: /* @__PURE__ */ x.jsx(ab, { slot: "icon-start" }) })
          ] }),
          /* @__PURE__ */ x.jsxs(fe, { slot: "body", direction: "column", gap: 24, className: Yt.modalBody, children: [
            o && /* @__PURE__ */ x.jsx(av, { size: "m", className: Yt.modalSpinner }),
            !o && !!(l != null && l.length) && /* @__PURE__ */ x.jsx(iv, { withRadioOrCheckbox: !1, value: c == null ? void 0 : c.id, className: Yt.templatesGroup, children: l == null ? void 0 : l.map((b) => /* @__PURE__ */ x.jsxs(
              ps,
              {
                value: b.id,
                onClick: () => f(b),
                className: Yt.templateCard,
                children: [
                  /* @__PURE__ */ x.jsx("div", { className: Yt.templateImageWrapper, children: /* @__PURE__ */ x.jsx("img", { alt: "template image", src: b.imageUrl }) }),
                  /* @__PURE__ */ x.jsx("div", { className: Yt.templateNameWrapper, children: /* @__PURE__ */ x.jsx(_e, { type: "xs-body", className: Yt.templateName, children: b.name }) })
                ]
              },
              b.id
            )) })
          ] }),
          /* @__PURE__ */ x.jsxs(fe, { slot: "actions", gap: 12, justify: "end", children: [
            /* @__PURE__ */ x.jsx(si, { variant: "secondary", size: "m", onClick: d, "data-testid": "cancel", children: t("cancel") }),
            /* @__PURE__ */ x.jsx(
              si,
              {
                variant: "primary",
                size: "m",
                onClick: w,
                disabled: !c,
                "data-testid": "apply-template",
                children: t("addToPage")
              }
            )
          ] })
        ]
      }
    )
  ] }) : null;
}, PL = "_toolbox_htl8l_1", _L = "_toolContainer_htl8l_10", AL = "_disable_htl8l_19", TL = "_container_htl8l_24", BL = "_item_htl8l_29", RL = "_iconContainer_htl8l_42", Za = {
  toolbox: PL,
  toolContainer: _L,
  disable: AL,
  container: TL,
  item: BL,
  iconContainer: RL
}, $L = ({ children: t, label: e }) => {
  const { loc: r } = se();
  return /* @__PURE__ */ x.jsxs("div", { className: Za.item, children: [
    /* @__PURE__ */ x.jsx("div", { className: Za.iconContainer, children: t }),
    /* @__PURE__ */ x.jsx(_e, { type: "xs-strong", children: r(e) })
  ] });
}, Aq = ({ widgets: t }) => {
  const { enabled: e, connectors: r, actions: n } = Le((a) => ({
    enabled: a.options.enabled
  }));
  return /* @__PURE__ */ x.jsx("div", { className: ke(Za.toolbox, { [Za.disable]: !e }), "data-testid": "editor-toolbox", children: /* @__PURE__ */ x.jsxs("div", { className: Za.toolContainer, children: [
    /* @__PURE__ */ x.jsx(OL, {}),
    t.map((a, i) => {
      var l, o, u, c, f, p, g;
      const s = a;
      return /* @__PURE__ */ x.jsx(
        "div",
        {
          ref: (m) => r.create(m, /* @__PURE__ */ x.jsx(s, {}), {
            onCreate: (d) => {
              setTimeout(() => n.selectNode(d.rootNodeId), 0);
            }
          }),
          "data-testid": (u = (o = (l = a.craft) == null ? void 0 : l.custom) == null ? void 0 : o.toolbox) == null ? void 0 : u.dataTestId,
          children: /* @__PURE__ */ x.jsx($L, { label: (c = a.craft) == null ? void 0 : c.displayName, children: (g = (p = (f = a.craft) == null ? void 0 : f.custom) == null ? void 0 : p.toolbox) == null ? void 0 : g.icon })
        },
        i
      );
    })
  ] }) });
}, ML = "_controls_18s4w_1", FL = "_undoIcon_18s4w_5", Op = {
  controls: ML,
  undoIcon: FL
}, Tq = () => {
  const { enabled: t, canUndo: e, canRedo: r, actions: n } = Le((a, i) => ({
    enabled: a.options.enabled,
    canUndo: i.history.canUndo(),
    canRedo: i.history.canRedo()
  }));
  return /* @__PURE__ */ x.jsx(fe, { justify: "end", className: Op.controls, children: t && /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(Dr, { disabled: !e, onClick: () => n.history.undo(), variant: "primary", children: /* @__PURE__ */ x.jsx(Df, { className: Op.undoIcon }) }),
    /* @__PURE__ */ x.jsx(Dr, { disabled: !r, onClick: () => n.history.redo(), children: /* @__PURE__ */ x.jsx(Df, {}) })
  ] }) });
}, IL = "_header_14zku_1", jL = "_container_14zku_10", Pp = {
  header: IL,
  container: jL
}, Bq = ({ children: t }) => /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
  /* @__PURE__ */ x.jsx("div", { className: Pp.header, children: /* @__PURE__ */ x.jsx(fe, { className: Pp.container, children: t }) }),
  /* @__PURE__ */ x.jsx(We, {})
] }), Rq = () => {
  const { loc: t } = se(), { enabled: e, actions: r } = Le((a) => ({
    enabled: a.options.enabled
  })), n = e ? ib : sb;
  return /* @__PURE__ */ x.jsxs(
    Dr,
    {
      variant: "primary",
      onClick: () => r.setOptions((a) => a.enabled = !e),
      "data-testid": "editor-preview-button",
      children: [
        /* @__PURE__ */ x.jsx(n, { slot: "icon-start", color: "" }),
        t("preview")
      ]
    }
  );
}, LL = "_selectorType_1js8y_1", kL = "_input_1js8y_10", _p = {
  selectorType: LL,
  input: kL
}, Ap = (t, e) => t === "auto" ? "auto" : t === "px" ? `${e}px` : t === "%" ? `${e}%` : "";
function NL(t) {
  if (!t)
    return { type: "px", value: "100" };
  if (typeof t == "number")
    return { type: "px", value: String(t) };
  const e = /^(\d*)(px|%|auto)?$/, r = String(t).match(e);
  if (r) {
    const n = r[1], a = r[2] || "px";
    return { type: a, value: a === "auto" || n === "" ? "" : n };
  }
}
const fi = ({ value: t, onChange: e, label: r, disabled: n = !1, dataTestId: a }) => {
  const [i, s] = $e(
    "px"
    /* px */
  ), [l, o] = $e({
    auto: "",
    "%": "100",
    px: "100"
  });
  return xe(() => {
    const u = NL(t);
    if (u) {
      const { type: c, value: f } = u;
      s(c), o((p) => ({ ...p, [c]: f }));
    }
  }, [t]), /* @__PURE__ */ x.jsxs(fe, { align: "end", children: [
    /* @__PURE__ */ x.jsx(
      yu,
      {
        "data-testid": a,
        required: !0,
        labelConfig: { text: r || "" },
        disabled: i === "auto" || n,
        value: l[i],
        onWppChange: (u) => {
          const { value: c } = u.detail;
          o((f) => ({ ...f, [i]: c })), e && e(Ap(i, c));
        },
        size: "s",
        className: _p.input
      }
    ),
    /* @__PURE__ */ x.jsxs(
      Ns,
      {
        className: _p.selectorType,
        value: i,
        onWppChange: (u) => {
          const { value: c } = u.detail, f = c;
          s(f), e && e(Ap(f, l[f]));
        },
        size: "s",
        disabled: n,
        children: [
          /* @__PURE__ */ x.jsx(ra, { value: "px", children: /* @__PURE__ */ x.jsx("p", { slot: "label", children: "px" }) }),
          /* @__PURE__ */ x.jsx(ra, { value: "%", children: /* @__PURE__ */ x.jsx("p", { slot: "label", children: "%" }) }),
          /* @__PURE__ */ x.jsx(ra, { value: "auto", children: /* @__PURE__ */ x.jsx("p", { slot: "label", children: "Auto" }) })
        ]
      }
    )
  ] });
}, Tp = ({ propKey: t, selector: e, label: r }) => {
  const n = e || ((s) => s), { propValue: a, setProp: i } = me((s) => ({
    propValue: n(s.data.props)[t]
  }));
  return /* @__PURE__ */ x.jsx(
    fi,
    {
      value: a,
      label: r,
      onChange: (s) => i((l) => n(l)[t] = s)
    }
  );
}, Ec = ({ withTitle: t = !0, withSummary: e = !1, withPaddings: r }) => {
  const { loc: n } = se();
  return /* @__PURE__ */ x.jsx(
    at,
    {
      ...t && { title: n("dimensions") },
      ...e && {
        props: ["width", "height"],
        summary: ({ width: a, height: i }) => `${a || 0} x ${i || 0}`
      },
      withPaddings: r,
      children: /* @__PURE__ */ x.jsxs(fe, { gap: 24, children: [
        /* @__PURE__ */ x.jsx(Tp, { label: n("width"), propKey: "width" }),
        /* @__PURE__ */ x.jsx(Tp, { label: n("height"), propKey: "height" })
      ] })
    }
  );
}, qt = ({ withPaddings: t }) => {
  const { loc: e } = se();
  return /* @__PURE__ */ x.jsxs(
    at,
    {
      title: e("margin"),
      props: ["margin"],
      summary: ({ margin: r }) => Ze(r),
      withPaddings: t,
      children: [
        /* @__PURE__ */ x.jsx(Re, { propKey: "margin", index: 0, type: "slider", label: e("top") }),
        /* @__PURE__ */ x.jsx(Re, { propKey: "margin", index: 1, type: "slider", label: e("right") }),
        /* @__PURE__ */ x.jsx(Re, { propKey: "margin", index: 2, type: "slider", label: e("bottom") }),
        /* @__PURE__ */ x.jsx(Re, { propKey: "margin", index: 3, type: "slider", label: e("left") })
      ]
    }
  );
}, Xr = () => {
  const { loc: t } = se();
  return /* @__PURE__ */ x.jsxs(at, { title: t("padding"), props: ["padding"], summary: ({ padding: e }) => Ze(e), children: [
    /* @__PURE__ */ x.jsx(Re, { propKey: "padding", index: 0, type: "slider", label: t("top") }),
    /* @__PURE__ */ x.jsx(Re, { propKey: "padding", index: 1, type: "slider", label: t("right") }),
    /* @__PURE__ */ x.jsx(Re, { propKey: "padding", index: 2, type: "slider", label: t("bottom") }),
    /* @__PURE__ */ x.jsx(Re, { propKey: "padding", index: 3, type: "slider", label: t("left") })
  ] });
};
var zL = globalThis && globalThis.__extends || function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
      n.__proto__ = a;
    } || function(n, a) {
      for (var i in a)
        Object.prototype.hasOwnProperty.call(a, i) && (n[i] = a[i]);
    }, t(e, r);
  };
  return function(e, r) {
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), nt = globalThis && globalThis.__assign || function() {
  return nt = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var a in e)
        Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t;
  }, nt.apply(this, arguments);
}, Bp = {
  width: "100%",
  height: "10px",
  top: "0px",
  left: "0px",
  cursor: "row-resize"
}, Rp = {
  width: "10px",
  height: "100%",
  top: "0px",
  left: "0px",
  cursor: "col-resize"
}, Wi = {
  width: "20px",
  height: "20px",
  position: "absolute"
}, WL = {
  top: nt(nt({}, Bp), { top: "-5px" }),
  right: nt(nt({}, Rp), { left: void 0, right: "-5px" }),
  bottom: nt(nt({}, Bp), { top: void 0, bottom: "-5px" }),
  left: nt(nt({}, Rp), { left: "-5px" }),
  topRight: nt(nt({}, Wi), { right: "-10px", top: "-10px", cursor: "ne-resize" }),
  bottomRight: nt(nt({}, Wi), { right: "-10px", bottom: "-10px", cursor: "se-resize" }),
  bottomLeft: nt(nt({}, Wi), { left: "-10px", bottom: "-10px", cursor: "sw-resize" }),
  topLeft: nt(nt({}, Wi), { left: "-10px", top: "-10px", cursor: "nw-resize" })
}, HL = (
  /** @class */
  function(t) {
    zL(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.onMouseDown = function(n) {
        r.props.onResizeStart(n, r.props.direction);
      }, r.onTouchStart = function(n) {
        r.props.onResizeStart(n, r.props.direction);
      }, r;
    }
    return e.prototype.render = function() {
      return we.createElement("div", { className: this.props.className || "", style: nt(nt({ position: "absolute", userSelect: "none" }, WL[this.props.direction]), this.props.replaceStyles || {}), onMouseDown: this.onMouseDown, onTouchStart: this.onTouchStart }, this.props.children);
    }, e;
  }(we.PureComponent)
), UL = globalThis && globalThis.__extends || function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
      n.__proto__ = a;
    } || function(n, a) {
      for (var i in a)
        Object.prototype.hasOwnProperty.call(a, i) && (n[i] = a[i]);
    }, t(e, r);
  };
  return function(e, r) {
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), sr = globalThis && globalThis.__assign || function() {
  return sr = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var a in e)
        Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t;
  }, sr.apply(this, arguments);
}, VL = {
  width: "auto",
  height: "auto"
}, Hi = function(t, e, r) {
  return Math.max(Math.min(t, r), e);
}, $p = function(t, e) {
  return Math.round(t / e) * e;
}, An = function(t, e) {
  return new RegExp(t, "i").test(e);
}, Ui = function(t) {
  return !!(t.touches && t.touches.length);
}, qL = function(t) {
  return !!((t.clientX || t.clientX === 0) && (t.clientY || t.clientY === 0));
}, Mp = function(t, e, r) {
  r === void 0 && (r = 0);
  var n = e.reduce(function(i, s, l) {
    return Math.abs(s - t) < Math.abs(e[i] - t) ? l : i;
  }, 0), a = Math.abs(e[n] - t);
  return r === 0 || a < r ? e[n] : t;
}, ko = function(t) {
  return t = t.toString(), t === "auto" || t.endsWith("px") || t.endsWith("%") || t.endsWith("vh") || t.endsWith("vw") || t.endsWith("vmax") || t.endsWith("vmin") ? t : t + "px";
}, Vi = function(t, e, r, n) {
  if (t && typeof t == "string") {
    if (t.endsWith("px"))
      return Number(t.replace("px", ""));
    if (t.endsWith("%")) {
      var a = Number(t.replace("%", "")) / 100;
      return e * a;
    }
    if (t.endsWith("vw")) {
      var a = Number(t.replace("vw", "")) / 100;
      return r * a;
    }
    if (t.endsWith("vh")) {
      var a = Number(t.replace("vh", "")) / 100;
      return n * a;
    }
  }
  return t;
}, GL = function(t, e, r, n, a, i, s) {
  return n = Vi(n, t.width, e, r), a = Vi(a, t.height, e, r), i = Vi(i, t.width, e, r), s = Vi(s, t.height, e, r), {
    maxWidth: typeof n > "u" ? void 0 : Number(n),
    maxHeight: typeof a > "u" ? void 0 : Number(a),
    minWidth: typeof i > "u" ? void 0 : Number(i),
    minHeight: typeof s > "u" ? void 0 : Number(s)
  };
}, YL = [
  "as",
  "style",
  "className",
  "grid",
  "snap",
  "bounds",
  "boundsByDirection",
  "size",
  "defaultSize",
  "minWidth",
  "minHeight",
  "maxWidth",
  "maxHeight",
  "lockAspectRatio",
  "lockAspectRatioExtraWidth",
  "lockAspectRatioExtraHeight",
  "enable",
  "handleStyles",
  "handleClasses",
  "handleWrapperStyle",
  "handleWrapperClass",
  "children",
  "onResizeStart",
  "onResize",
  "onResizeStop",
  "handleComponent",
  "scale",
  "resizeRatio",
  "snapGap"
], Fp = "__resizable_base__", qm = (
  /** @class */
  function(t) {
    UL(e, t);
    function e(r) {
      var n = t.call(this, r) || this;
      return n.ratio = 1, n.resizable = null, n.parentLeft = 0, n.parentTop = 0, n.resizableLeft = 0, n.resizableRight = 0, n.resizableTop = 0, n.resizableBottom = 0, n.targetLeft = 0, n.targetTop = 0, n.appendBase = function() {
        if (!n.resizable || !n.window)
          return null;
        var a = n.parentNode;
        if (!a)
          return null;
        var i = n.window.document.createElement("div");
        return i.style.width = "100%", i.style.height = "100%", i.style.position = "absolute", i.style.transform = "scale(0, 0)", i.style.left = "0", i.style.flex = "0 0 100%", i.classList ? i.classList.add(Fp) : i.className += Fp, a.appendChild(i), i;
      }, n.removeBase = function(a) {
        var i = n.parentNode;
        i && i.removeChild(a);
      }, n.ref = function(a) {
        a && (n.resizable = a);
      }, n.state = {
        isResizing: !1,
        width: typeof (n.propsSize && n.propsSize.width) > "u" ? "auto" : n.propsSize && n.propsSize.width,
        height: typeof (n.propsSize && n.propsSize.height) > "u" ? "auto" : n.propsSize && n.propsSize.height,
        direction: "right",
        original: {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        },
        backgroundStyle: {
          height: "100%",
          width: "100%",
          backgroundColor: "rgba(0,0,0,0)",
          cursor: "auto",
          opacity: 0,
          position: "fixed",
          zIndex: 9999,
          top: "0",
          left: "0",
          bottom: "0",
          right: "0"
        },
        flexBasis: void 0
      }, n.onResizeStart = n.onResizeStart.bind(n), n.onMouseMove = n.onMouseMove.bind(n), n.onMouseUp = n.onMouseUp.bind(n), n;
    }
    return Object.defineProperty(e.prototype, "parentNode", {
      get: function() {
        return this.resizable ? this.resizable.parentNode : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "window", {
      get: function() {
        return !this.resizable || !this.resizable.ownerDocument ? null : this.resizable.ownerDocument.defaultView;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "propsSize", {
      get: function() {
        return this.props.size || this.props.defaultSize || VL;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "size", {
      get: function() {
        var r = 0, n = 0;
        if (this.resizable && this.window) {
          var a = this.resizable.offsetWidth, i = this.resizable.offsetHeight, s = this.resizable.style.position;
          s !== "relative" && (this.resizable.style.position = "relative"), r = this.resizable.style.width !== "auto" ? this.resizable.offsetWidth : a, n = this.resizable.style.height !== "auto" ? this.resizable.offsetHeight : i, this.resizable.style.position = s;
        }
        return { width: r, height: n };
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "sizeStyle", {
      get: function() {
        var r = this, n = this.props.size, a = function(l) {
          if (typeof r.state[l] > "u" || r.state[l] === "auto")
            return "auto";
          if (r.propsSize && r.propsSize[l] && r.propsSize[l].toString().endsWith("%")) {
            if (r.state[l].toString().endsWith("%"))
              return r.state[l].toString();
            var o = r.getParentSize(), u = Number(r.state[l].toString().replace("px", "")), c = u / o[l] * 100;
            return c + "%";
          }
          return ko(r.state[l]);
        }, i = n && typeof n.width < "u" && !this.state.isResizing ? ko(n.width) : a("width"), s = n && typeof n.height < "u" && !this.state.isResizing ? ko(n.height) : a("height");
        return { width: i, height: s };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getParentSize = function() {
      if (!this.parentNode)
        return this.window ? { width: this.window.innerWidth, height: this.window.innerHeight } : { width: 0, height: 0 };
      var r = this.appendBase();
      if (!r)
        return { width: 0, height: 0 };
      var n = !1, a = this.parentNode.style.flexWrap;
      a !== "wrap" && (n = !0, this.parentNode.style.flexWrap = "wrap"), r.style.position = "relative", r.style.minWidth = "100%", r.style.minHeight = "100%";
      var i = {
        width: r.offsetWidth,
        height: r.offsetHeight
      };
      return n && (this.parentNode.style.flexWrap = a), this.removeBase(r), i;
    }, e.prototype.bindEvents = function() {
      this.window && (this.window.addEventListener("mouseup", this.onMouseUp), this.window.addEventListener("mousemove", this.onMouseMove), this.window.addEventListener("mouseleave", this.onMouseUp), this.window.addEventListener("touchmove", this.onMouseMove, {
        capture: !0,
        passive: !1
      }), this.window.addEventListener("touchend", this.onMouseUp));
    }, e.prototype.unbindEvents = function() {
      this.window && (this.window.removeEventListener("mouseup", this.onMouseUp), this.window.removeEventListener("mousemove", this.onMouseMove), this.window.removeEventListener("mouseleave", this.onMouseUp), this.window.removeEventListener("touchmove", this.onMouseMove, !0), this.window.removeEventListener("touchend", this.onMouseUp));
    }, e.prototype.componentDidMount = function() {
      if (!(!this.resizable || !this.window)) {
        var r = this.window.getComputedStyle(this.resizable);
        this.setState({
          width: this.state.width || this.size.width,
          height: this.state.height || this.size.height,
          flexBasis: r.flexBasis !== "auto" ? r.flexBasis : void 0
        });
      }
    }, e.prototype.componentWillUnmount = function() {
      this.window && this.unbindEvents();
    }, e.prototype.createSizeForCssProperty = function(r, n) {
      var a = this.propsSize && this.propsSize[n];
      return this.state[n] === "auto" && this.state.original[n] === r && (typeof a > "u" || a === "auto") ? "auto" : r;
    }, e.prototype.calculateNewMaxFromBoundary = function(r, n) {
      var a = this.props.boundsByDirection, i = this.state.direction, s = a && An("left", i), l = a && An("top", i), o, u;
      if (this.props.bounds === "parent") {
        var c = this.parentNode;
        c && (o = s ? this.resizableRight - this.parentLeft : c.offsetWidth + (this.parentLeft - this.resizableLeft), u = l ? this.resizableBottom - this.parentTop : c.offsetHeight + (this.parentTop - this.resizableTop));
      } else
        this.props.bounds === "window" ? this.window && (o = s ? this.resizableRight : this.window.innerWidth - this.resizableLeft, u = l ? this.resizableBottom : this.window.innerHeight - this.resizableTop) : this.props.bounds && (o = s ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft), u = l ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop));
      return o && Number.isFinite(o) && (r = r && r < o ? r : o), u && Number.isFinite(u) && (n = n && n < u ? n : u), { maxWidth: r, maxHeight: n };
    }, e.prototype.calculateNewSizeFromDirection = function(r, n) {
      var a = this.props.scale || 1, i = this.props.resizeRatio || 1, s = this.state, l = s.direction, o = s.original, u = this.props, c = u.lockAspectRatio, f = u.lockAspectRatioExtraHeight, p = u.lockAspectRatioExtraWidth, g = o.width, m = o.height, d = f || 0, w = p || 0;
      return An("right", l) && (g = o.width + (r - o.x) * i / a, c && (m = (g - w) / this.ratio + d)), An("left", l) && (g = o.width - (r - o.x) * i / a, c && (m = (g - w) / this.ratio + d)), An("bottom", l) && (m = o.height + (n - o.y) * i / a, c && (g = (m - d) * this.ratio + w)), An("top", l) && (m = o.height - (n - o.y) * i / a, c && (g = (m - d) * this.ratio + w)), { newWidth: g, newHeight: m };
    }, e.prototype.calculateNewSizeFromAspectRatio = function(r, n, a, i) {
      var s = this.props, l = s.lockAspectRatio, o = s.lockAspectRatioExtraHeight, u = s.lockAspectRatioExtraWidth, c = typeof i.width > "u" ? 10 : i.width, f = typeof a.width > "u" || a.width < 0 ? r : a.width, p = typeof i.height > "u" ? 10 : i.height, g = typeof a.height > "u" || a.height < 0 ? n : a.height, m = o || 0, d = u || 0;
      if (l) {
        var w = (p - m) * this.ratio + d, b = (g - m) * this.ratio + d, O = (c - d) / this.ratio + m, S = (f - d) / this.ratio + m, B = Math.max(c, w), T = Math.min(f, b), A = Math.max(p, O), D = Math.min(g, S);
        r = Hi(r, B, T), n = Hi(n, A, D);
      } else
        r = Hi(r, c, f), n = Hi(n, p, g);
      return { newWidth: r, newHeight: n };
    }, e.prototype.setBoundingClientRect = function() {
      if (this.props.bounds === "parent") {
        var r = this.parentNode;
        if (r) {
          var n = r.getBoundingClientRect();
          this.parentLeft = n.left, this.parentTop = n.top;
        }
      }
      if (this.props.bounds && typeof this.props.bounds != "string") {
        var a = this.props.bounds.getBoundingClientRect();
        this.targetLeft = a.left, this.targetTop = a.top;
      }
      if (this.resizable) {
        var i = this.resizable.getBoundingClientRect(), s = i.left, l = i.top, o = i.right, u = i.bottom;
        this.resizableLeft = s, this.resizableRight = o, this.resizableTop = l, this.resizableBottom = u;
      }
    }, e.prototype.onResizeStart = function(r, n) {
      if (!(!this.resizable || !this.window)) {
        var a = 0, i = 0;
        if (r.nativeEvent && qL(r.nativeEvent) ? (a = r.nativeEvent.clientX, i = r.nativeEvent.clientY) : r.nativeEvent && Ui(r.nativeEvent) && (a = r.nativeEvent.touches[0].clientX, i = r.nativeEvent.touches[0].clientY), this.props.onResizeStart && this.resizable) {
          var s = this.props.onResizeStart(r, n, this.resizable);
          if (s === !1)
            return;
        }
        this.props.size && (typeof this.props.size.height < "u" && this.props.size.height !== this.state.height && this.setState({ height: this.props.size.height }), typeof this.props.size.width < "u" && this.props.size.width !== this.state.width && this.setState({ width: this.props.size.width })), this.ratio = typeof this.props.lockAspectRatio == "number" ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var l, o = this.window.getComputedStyle(this.resizable);
        if (o.flexBasis !== "auto") {
          var u = this.parentNode;
          if (u) {
            var c = this.window.getComputedStyle(u).flexDirection;
            this.flexDir = c.startsWith("row") ? "row" : "column", l = o.flexBasis;
          }
        }
        this.setBoundingClientRect(), this.bindEvents();
        var f = {
          original: {
            x: a,
            y: i,
            width: this.size.width,
            height: this.size.height
          },
          isResizing: !0,
          backgroundStyle: sr(sr({}, this.state.backgroundStyle), { cursor: this.window.getComputedStyle(r.target).cursor || "auto" }),
          direction: n,
          flexBasis: l
        };
        this.setState(f);
      }
    }, e.prototype.onMouseMove = function(r) {
      var n = this;
      if (!(!this.state.isResizing || !this.resizable || !this.window)) {
        if (this.window.TouchEvent && Ui(r))
          try {
            r.preventDefault(), r.stopPropagation();
          } catch {
          }
        var a = this.props, i = a.maxWidth, s = a.maxHeight, l = a.minWidth, o = a.minHeight, u = Ui(r) ? r.touches[0].clientX : r.clientX, c = Ui(r) ? r.touches[0].clientY : r.clientY, f = this.state, p = f.direction, g = f.original, m = f.width, d = f.height, w = this.getParentSize(), b = GL(w, this.window.innerWidth, this.window.innerHeight, i, s, l, o);
        i = b.maxWidth, s = b.maxHeight, l = b.minWidth, o = b.minHeight;
        var O = this.calculateNewSizeFromDirection(u, c), S = O.newHeight, B = O.newWidth, T = this.calculateNewMaxFromBoundary(i, s);
        this.props.snap && this.props.snap.x && (B = Mp(B, this.props.snap.x, this.props.snapGap)), this.props.snap && this.props.snap.y && (S = Mp(S, this.props.snap.y, this.props.snapGap));
        var A = this.calculateNewSizeFromAspectRatio(B, S, { width: T.maxWidth, height: T.maxHeight }, { width: l, height: o });
        if (B = A.newWidth, S = A.newHeight, this.props.grid) {
          var D = $p(B, this.props.grid[0]), h = $p(S, this.props.grid[1]), y = this.props.snapGap || 0;
          B = y === 0 || Math.abs(D - B) <= y ? D : B, S = y === 0 || Math.abs(h - S) <= y ? h : S;
        }
        var v = {
          width: B - g.width,
          height: S - g.height
        };
        if (m && typeof m == "string") {
          if (m.endsWith("%")) {
            var E = B / w.width * 100;
            B = E + "%";
          } else if (m.endsWith("vw")) {
            var _ = B / this.window.innerWidth * 100;
            B = _ + "vw";
          } else if (m.endsWith("vh")) {
            var C = B / this.window.innerHeight * 100;
            B = C + "vh";
          }
        }
        if (d && typeof d == "string") {
          if (d.endsWith("%")) {
            var E = S / w.height * 100;
            S = E + "%";
          } else if (d.endsWith("vw")) {
            var _ = S / this.window.innerWidth * 100;
            S = _ + "vw";
          } else if (d.endsWith("vh")) {
            var C = S / this.window.innerHeight * 100;
            S = C + "vh";
          }
        }
        var P = {
          width: this.createSizeForCssProperty(B, "width"),
          height: this.createSizeForCssProperty(S, "height")
        };
        this.flexDir === "row" ? P.flexBasis = P.width : this.flexDir === "column" && (P.flexBasis = P.height), Rb(function() {
          n.setState(P);
        }), this.props.onResize && this.props.onResize(r, p, this.resizable, v);
      }
    }, e.prototype.onMouseUp = function(r) {
      var n = this.state, a = n.isResizing, i = n.direction, s = n.original;
      if (!(!a || !this.resizable)) {
        var l = {
          width: this.size.width - s.width,
          height: this.size.height - s.height
        };
        this.props.onResizeStop && this.props.onResizeStop(r, i, this.resizable, l), this.props.size && this.setState(this.props.size), this.unbindEvents(), this.setState({
          isResizing: !1,
          backgroundStyle: sr(sr({}, this.state.backgroundStyle), { cursor: "auto" })
        });
      }
    }, e.prototype.updateSize = function(r) {
      this.setState({ width: r.width, height: r.height });
    }, e.prototype.renderResizer = function() {
      var r = this, n = this.props, a = n.enable, i = n.handleStyles, s = n.handleClasses, l = n.handleWrapperStyle, o = n.handleWrapperClass, u = n.handleComponent;
      if (!a)
        return null;
      var c = Object.keys(a).map(function(f) {
        return a[f] !== !1 ? we.createElement(HL, { key: f, direction: f, onResizeStart: r.onResizeStart, replaceStyles: i && i[f], className: s && s[f] }, u && u[f] ? u[f] : null) : null;
      });
      return we.createElement("div", { className: o, style: l }, c);
    }, e.prototype.render = function() {
      var r = this, n = Object.keys(this.props).reduce(function(s, l) {
        return YL.indexOf(l) !== -1 || (s[l] = r.props[l]), s;
      }, {}), a = sr(sr(sr({ position: "relative", userSelect: this.state.isResizing ? "none" : "auto" }, this.props.style), this.sizeStyle), { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight, minWidth: this.props.minWidth, minHeight: this.props.minHeight, boxSizing: "border-box", flexShrink: 0 });
      this.state.flexBasis && (a.flexBasis = this.state.flexBasis);
      var i = this.props.as || "div";
      return we.createElement(
        i,
        sr({ ref: this.ref, style: a, className: this.props.className }, n),
        this.state.isResizing && we.createElement("div", { style: this.state.backgroundStyle }),
        this.props.children,
        this.renderResizer()
      );
    }, e.defaultProps = {
      as: "div",
      onResizeStart: function() {
      },
      onResize: function() {
      },
      onResizeStop: function() {
      },
      enable: {
        top: !0,
        right: !0,
        bottom: !0,
        left: !0,
        topRight: !0,
        bottomRight: !0,
        bottomLeft: !0,
        topLeft: !0
      },
      style: {},
      grid: [1, 1],
      lockAspectRatio: !1,
      lockAspectRatioExtraWidth: 0,
      lockAspectRatioExtraHeight: 0,
      scale: 1,
      resizeRatio: 1,
      snapGap: 0
    }, e;
  }(we.PureComponent)
);
const KL = "_topRight_1pye4_1", XL = "_bottomRight_1pye4_7", ZL = "_bottomLeft_1pye4_13", JL = "_topLeft_1pye4_19", QL = "_top_1pye4_1", e5 = "_bottom_1pye4_7", t5 = "_left_1pye4_33", r5 = "_right_1pye4_37", n5 = "_Indicators_1pye4_41", yr = {
  topRight: KL,
  bottomRight: XL,
  bottomLeft: ZL,
  topLeft: JL,
  top: QL,
  bottom: e5,
  left: t5,
  right: r5,
  Indicators: n5
};
function Gm(t, e) {
  const r = de(void 0), n = de(null);
  return xe(() => (n.current = t, () => {
    n.current = null;
  }), [t]), xe(
    () => () => {
      clearTimeout(r.current);
    },
    []
  ), gt(
    () => (...a) => {
      clearTimeout(r.current), r.current = window.setTimeout(() => {
        var i;
        return (i = n.current) == null ? void 0 : i.call(n, ...a);
      }, e);
    },
    [e]
  );
}
const Ip = {
  width: 40,
  height: 40
}, Ri = hr(
  ({
    width: t,
    height: e,
    onResize: r,
    children: n,
    lockAspectRatio: a,
    resizeRatio: i,
    className: s,
    style: l,
    disableResizing: o = !1
  }, u) => {
    const { active: c } = me((A) => ({
      active: A.events.selected
    })), f = mc(), p = de(null), g = de(!1), m = de(null), d = de(null);
    d.current = { width: t, height: e };
    const [w, b] = $e({
      width: t,
      height: e
    }), O = oe(() => {
      var E, _;
      const { width: A, height: D } = d.current, h = na((_ = (E = p.current) == null ? void 0 : E.resizable) == null ? void 0 : _.parentElement), y = Ss(A, h.width), v = Ss(D, h.height);
      b({
        width: y,
        height: v
      });
    }, []), S = oe(() => {
      const { width: A, height: D } = d.current;
      b({
        width: A,
        height: D
      });
    }, []), B = (A, D) => {
      var E;
      if (!((E = p.current) == null ? void 0 : E.resizable))
        return;
      const y = parseInt(m.current.width), v = parseInt(m.current.height);
      return {
        width: y + parseInt(String(A)),
        height: v + parseInt(String(D))
      };
    };
    xe(() => {
      g.current || S();
    }, [t, e, S]);
    const T = Gm(S, 20);
    return xe(() => (window.addEventListener("resize", T), () => {
      window.removeEventListener("resize", T);
    }), [S, T]), /* @__PURE__ */ x.jsxs(
      qm,
      {
        style: l,
        className: s,
        ref: Cu([u, p]),
        resizeRatio: i,
        lockAspectRatio: a,
        size: w,
        minWidth: Ip.width,
        minHeight: Ip.height,
        ...o && { enable: !1 },
        onResizeStart: (A) => {
          var h;
          O(), A.preventDefault(), A.stopPropagation();
          const D = (h = p == null ? void 0 : p.current) == null ? void 0 : h.resizable;
          D && (m.current = {
            width: D.getBoundingClientRect().width,
            height: D.getBoundingClientRect().height
          }, g.current = !0);
        },
        onResize: (A, D, h, y) => {
          var C, P, $;
          const v = (C = p == null ? void 0 : p.current) == null ? void 0 : C.resizable;
          let { width: E, height: _ } = B(y.width, y.height);
          Lr(t) ? E = Os(E, na(v == null ? void 0 : v.parentElement).width) + "%" : E = `${E}px`, Lr(e) ? _ = Os(_, na(v == null ? void 0 : v.parentElement).height) + "%" : _ = `${_}px`, Lr(E) && ((P = v == null ? void 0 : v.parentElement) == null ? void 0 : P.style.width) === "auto" && (E = m.current.width + y.width + "px"), Lr(_) && (($ = v == null ? void 0 : v.parentElement) == null ? void 0 : $.style.height) === "auto" && (_ = m.current.height + y.height + "px"), r({ width: E, height: _ }), f();
        },
        handleClasses: {
          top: yr.top,
          bottom: yr.bottom,
          right: yr.right,
          left: yr.left,
          topRight: yr.topRight,
          bottomRight: yr.bottomRight,
          bottomLeft: yr.bottomLeft,
          topLeft: yr.topLeft
        },
        onResizeStop: () => {
          g.current = !1, S();
        },
        children: [
          n,
          c && /* @__PURE__ */ x.jsxs("div", { className: ke(yr.Indicators), children: [
            /* @__PURE__ */ x.jsx("span", {}),
            /* @__PURE__ */ x.jsx("span", {}),
            /* @__PURE__ */ x.jsx("span", {}),
            /* @__PURE__ */ x.jsx("span", {})
          ] })
        ]
      }
    );
  }
), a5 = "_gapTitle_a3krv_1", i5 = {
  gapTitle: a5
}, Ym = {
  gap: 0,
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start"
}, jp = {
  row: "row",
  column: "column"
}, Lp = {
  "flex-start": "start",
  center: "center",
  "flex-end": "end"
}, kp = {
  "flex-start": "start",
  center: "center",
  "flex-end": "end",
  "space-between": "spaceBetween",
  "space-around": "spaceAround"
}, Km = () => {
  const { loc: t } = se(), { gapValue: e } = me((r) => ({
    gapValue: r.data.props.gap
  }));
  return /* @__PURE__ */ x.jsxs(at, { title: t("alignment"), children: [
    /* @__PURE__ */ x.jsxs(fe, { direction: "row", justify: "start", align: "center", children: [
      /* @__PURE__ */ x.jsx(_e, { className: i5.gapTitle, type: "s-strong", children: t("gap") }),
      /* @__PURE__ */ x.jsx(_e, { type: "xs-body", children: `${e}px` })
    ] }),
    /* @__PURE__ */ x.jsx(Re, { propKey: "gap", type: "slider" }),
    /* @__PURE__ */ x.jsx(Re, { full: !0, propKey: "flexDirection", type: "select", label: t("flexDirection"), children: Object.keys(jp).map((r) => /* @__PURE__ */ x.jsx(
      Qt,
      {
        value: r,
        label: t(jp[r])
      },
      r
    )) }),
    /* @__PURE__ */ x.jsx(Re, { full: !0, propKey: "alignItems", type: "select", label: t("alignItems"), children: Object.keys(Lp).map((r) => /* @__PURE__ */ x.jsx(Qt, { value: r, label: t(Lp[r]) }, r)) }),
    /* @__PURE__ */ x.jsx(Re, { full: !0, propKey: "justifyContent", type: "select", label: t("justifyContent"), children: Object.keys(kp).map((r) => /* @__PURE__ */ x.jsx(
      Qt,
      {
        value: r,
        label: t(kp[r])
      },
      r
    )) })
  ] });
};
var s5 = function t(e, r) {
  if (e === r)
    return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    if (e.constructor !== r.constructor)
      return !1;
    var n, a, i;
    if (Array.isArray(e)) {
      if (n = e.length, n != r.length)
        return !1;
      for (a = n; a-- !== 0; )
        if (!t(e[a], r[a]))
          return !1;
      return !0;
    }
    if (e instanceof Map && r instanceof Map) {
      if (e.size !== r.size)
        return !1;
      for (a of e.entries())
        if (!r.has(a[0]))
          return !1;
      for (a of e.entries())
        if (!t(a[1], r.get(a[0])))
          return !1;
      return !0;
    }
    if (e instanceof Set && r instanceof Set) {
      if (e.size !== r.size)
        return !1;
      for (a of e.entries())
        if (!r.has(a[0]))
          return !1;
      return !0;
    }
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(r)) {
      if (n = e.length, n != r.length)
        return !1;
      for (a = n; a-- !== 0; )
        if (e[a] !== r[a])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === r.source && e.flags === r.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === r.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === r.toString();
    if (i = Object.keys(e), n = i.length, n !== Object.keys(r).length)
      return !1;
    for (a = n; a-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, i[a]))
        return !1;
    for (a = n; a-- !== 0; ) {
      var s = i[a];
      if (!t(e[s], r[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && r !== r;
};
const Xm = /* @__PURE__ */ Ei(s5), o5 = (t) => Xm(t, {}), l5 = (t) => {
  const e = gt(() => {
    if (t && !o5(t))
      return URL.createObjectURL(t);
  }, [t]);
  return xe(
    () => () => {
      e && URL.revokeObjectURL(e);
    },
    [e]
  ), e;
};
function uo(t) {
  const {
    dependencies: { loadAsset: e }
  } = se(), [r, n] = $e(), [a, i] = $e(null);
  return xe(() => {
    (async () => {
      try {
        if (t && e) {
          n(!0);
          const l = await e({ assetId: t });
          i(l), n(!1);
        } else
          i(null);
      } catch {
        process.env.DEV && console.error("Assets loading failed");
      }
    })();
  }, [e, t]), {
    isLoading: r,
    imageUrl: l5(r ? null : a)
  };
}
const u5 = ({ selector: t }) => {
  var i;
  const { loc: e } = se(), {
    actions: { setProp: r },
    image: n
  } = me((s) => ({
    image: t(s.data.props)
  })), a = n.imageSize;
  return /* @__PURE__ */ x.jsx(
    Dr,
    {
      disabled: !n.imageMetaData || ((i = n.lockedImageSize) == null ? void 0 : i.isLockedImageSize),
      onClick: () => {
        r((s) => {
          var o, u;
          const l = t(s);
          l && (l.imageSize = {
            ...a,
            width: (o = a.original) == null ? void 0 : o.width,
            height: (u = a.original) == null ? void 0 : u.height,
            lockedRatio: !0
          });
        }, 200);
      },
      children: e("original")
    }
  );
}, c5 = "_inputWrapper_17734_1", Np = {
  inputWrapper: c5
}, Yl = hr(function({
  options: e,
  dropdownPosition: r = "fixed",
  getOptionValue: n = (p) => p.value,
  getOptionLabel: a = (p) => p.label,
  renderOptionContent: i,
  isOptionDisabled: s = () => !1,
  "data-testid": l,
  labelConfig: o,
  labelTooltipConfig: u,
  ...c
}, f) {
  const p = wc({ labelConfig: o, labelTooltipConfig: u });
  return /* @__PURE__ */ x.jsx(Ns, { ref: f, ...c, ...p, dropdownPosition: r, "data-testid": l, children: e.map((g) => {
    const m = n(g);
    return /* @__PURE__ */ x.jsx(ra, { value: m, disabled: s(g), children: i ? i == null ? void 0 : i(g) : /* @__PURE__ */ x.jsx("span", { slot: "label", children: a(g) }) }, m);
  }) });
}), f5 = ({ selector: t }) => {
  const { loc: e } = se(), r = ZI(), n = JI(), {
    actions: { setProp: a },
    backgroundImageProperties: i
  } = me((o) => ({
    backgroundImageProperties: t(o.data.props)
  })), s = (o) => {
    a((u) => {
      const c = t(u);
      c && Object.assign(c, o);
    });
  }, l = (o) => {
    const u = r.tile.value === o;
    s({
      size: u ? "unset" : o,
      repeat: u ? o : "no-repeat",
      scale: o
    });
  };
  return /* @__PURE__ */ x.jsxs(fe, { direction: "row", gap: 16, justify: "between", children: [
    /* @__PURE__ */ x.jsx(
      Yl,
      {
        required: !0,
        labelConfig: { text: e("scale") },
        value: i == null ? void 0 : i.scale,
        options: Object.values(r),
        onWppChange: (o) => l(o.detail.value),
        className: Np.inputWrapper,
        size: "s"
      }
    ),
    /* @__PURE__ */ x.jsx(
      Yl,
      {
        required: !0,
        onWppChange: (o) => s({ position: o.detail.value }),
        labelConfig: { text: e("position") },
        value: i == null ? void 0 : i.position,
        options: Object.values(n),
        className: Np.inputWrapper,
        size: "s"
      }
    )
  ] });
}, d5 = "_list_exszy_1", p5 = "_uploadImage_exszy_5", h5 = "_fileNameWrapper_exszy_13", g5 = "_fileInfoWrapper_exszy_17", v5 = "_fileInfo_exszy_17", m5 = "_imageName_exszy_29", y5 = "_imageSize_exszy_36", b5 = "_imageLoadedPercent_exszy_37", w5 = "_imageRemove_exszy_41", $r = {
  list: d5,
  uploadImage: p5,
  fileNameWrapper: h5,
  fileInfoWrapper: g5,
  fileInfo: v5,
  imageName: m5,
  imageSize: y5,
  imageLoadedPercent: b5,
  imageRemove: w5
};
/**
 * filesize
 *
 * @copyright 2023 Jason Mulligan <jason.mulligan@avoidwork.com>
 * @license BSD-3-Clause
 * @version 10.0.12
 */
const x5 = "array", E5 = "bit", zp = "bits", C5 = "byte", Wp = "bytes", Tn = "", D5 = "exponent", S5 = "function", qi = "iec", O5 = "Invalid number", P5 = "Invalid rounding method", Fa = "jedec", _5 = "object", Hp = ".", A5 = "round", T5 = "s", B5 = "kbit", R5 = "kB", $5 = " ", M5 = "string", F5 = "0", No = {
  symbol: {
    iec: {
      bits: ["bit", "Kibit", "Mibit", "Gibit", "Tibit", "Pibit", "Eibit", "Zibit", "Yibit"],
      bytes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
    },
    jedec: {
      bits: ["bit", "Kbit", "Mbit", "Gbit", "Tbit", "Pbit", "Ebit", "Zbit", "Ybit"],
      bytes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    }
  },
  fullform: {
    iec: ["", "kibi", "mebi", "gibi", "tebi", "pebi", "exbi", "zebi", "yobi"],
    jedec: ["", "kilo", "mega", "giga", "tera", "peta", "exa", "zetta", "yotta"]
  }
};
function I5(t, {
  bits: e = !1,
  pad: r = !1,
  base: n = -1,
  round: a = 2,
  locale: i = Tn,
  localeOptions: s = {},
  separator: l = Tn,
  spacer: o = $5,
  symbols: u = {},
  standard: c = Tn,
  output: f = M5,
  fullform: p = !1,
  fullforms: g = [],
  exponent: m = -1,
  roundingMethod: d = A5,
  precision: w = 0
} = {}) {
  let b = m, O = Number(t), S = [], B = 0, T = Tn;
  n === -1 && c.length === 0 ? (n = 10, c = Fa) : n === -1 && c.length > 0 ? (c = c === qi ? qi : Fa, n = c === qi ? 2 : 10) : (n = n === 2 ? 2 : 10, c = n === 10 || c === Fa ? Fa : qi);
  const A = n === 10 ? 1e3 : 1024, D = p === !0, h = O < 0, y = Math[d];
  if (typeof t != "bigint" && isNaN(t))
    throw new TypeError(O5);
  if (typeof y !== S5)
    throw new TypeError(P5);
  if (h && (O = -O), (b === -1 || isNaN(b)) && (b = Math.floor(Math.log(O) / Math.log(A)), b < 0 && (b = 0)), b > 8 && (w > 0 && (w += 8 - b), b = 8), f === D5)
    return b;
  if (O === 0)
    S[0] = 0, T = S[1] = No.symbol[c][e ? zp : Wp][b];
  else {
    B = O / (n === 2 ? Math.pow(2, b * 10) : Math.pow(1e3, b)), e && (B = B * 8, B >= A && b < 8 && (B = B / A, b++));
    const v = Math.pow(10, b > 0 ? a : 0);
    S[0] = y(B * v) / v, S[0] === A && b < 8 && m === -1 && (S[0] = 1, b++), T = S[1] = n === 10 && b === 1 ? e ? B5 : R5 : No.symbol[c][e ? zp : Wp][b];
  }
  if (h && (S[0] = -S[0]), w > 0 && (S[0] = S[0].toPrecision(w)), S[1] = u[S[1]] || S[1], i === !0 ? S[0] = S[0].toLocaleString() : i.length > 0 ? S[0] = S[0].toLocaleString(i, s) : l.length > 0 && (S[0] = S[0].toString().replace(Hp, l)), r && Number.isInteger(S[0]) === !1 && a > 0) {
    const v = l || Hp, E = S[0].toString().split(v), _ = E[1] || Tn, C = _.length, P = a - C;
    S[0] = `${E[0]}${v}${_.padEnd(C + P, F5)}`;
  }
  return D && (S[1] = g[b] ? g[b] : No.fullform[c][b] + (e ? E5 : C5) + (S[0] === 1 ? Tn : T5)), f === x5 ? S : f === _5 ? {
    value: S[0],
    symbol: S[1],
    exponent: b,
    unit: T
  } : S.join(o);
}
async function j5(t) {
  const e = new Image(), r = URL.createObjectURL(t);
  e.src = r, await e.decode();
  const n = {
    width: e.width,
    height: e.height
  };
  return URL.revokeObjectURL(r), n;
}
const zo = (t) => I5(t, { base: 2, standard: "jedec" }), Wo = 5, L5 = {
  "image/jpeg": [".jpeg", ".jpg"],
  "image/png": [".png"],
  "image/webp": [".webp"],
  "image/gif": [".gif"]
}, Cc = ({ selector: t }) => {
  const {
    loc: e,
    dependencies: { uploadAsset: r, enqueueToast: n }
  } = se(), a = de(null), {
    actions: { setProp: i },
    node: s,
    image: l
  } = me((m) => {
    var d;
    return {
      image: (d = t(m.data.props)) == null ? void 0 : d.imageMetaData,
      node: m
    };
  }), [{ loadingInfo: o, isError: u }, c] = dv({
    loadingInfo: l ? {
      name: l.name,
      size: l != null && l.size ? zo(l == null ? void 0 : l.size) : null
    } : null,
    isError: !1
  }), f = gt(
    () => ({
      label: e("fileUploadLabel"),
      text: e("fileUploadText"),
      info: (m, d) => e("fileUploadInfo", { accept: m, size: d }),
      sizeError: e("uploadSizeError", { fileSize: Wo }),
      formatError: e("uploadFormatError")
    }),
    [e]
  ), p = async () => {
    var d, w;
    await ((d = a == null ? void 0 : a.current) == null ? void 0 : d.reset());
    const m = (w = s == null ? void 0 : s.dom) == null ? void 0 : w.getBoundingClientRect();
    i((b) => {
      const O = t(b);
      O.imageMetaData = null, O.imageSize = {
        original: null,
        height: m == null ? void 0 : m.height,
        width: m == null ? void 0 : m.width
      };
    }), c({ loadingInfo: null });
  }, g = async ({ name: m, imageFile: d, contentType: w }) => {
    var b;
    await ((b = a == null ? void 0 : a.current) == null ? void 0 : b.reset());
    try {
      const {
        data: [O]
      } = await r([{ name: m, contentType: w }]);
      await pv.put(O.uploadUrl, d, {
        headers: { "Content-Type": w },
        onUploadProgress: ({ loaded: T, total: A }) => {
          const D = Math.round(T * 100 / (A || 1));
          c({
            loadingInfo: {
              name: d.name,
              size: zo(d.size),
              loaded: zo(T),
              loadedPercent: `${D}%`
            }
          });
        }
      });
      const { width: S, height: B } = await j5(d);
      i((T) => {
        const A = fp(S), D = fp(B), h = t(T);
        h.imageMetaData = {
          assetId: O.id || O.assetId,
          name: O.name || O.assetName,
          size: d.size
        }, h.imageSize = {
          width: A,
          height: D,
          ratio: S / B,
          lockedRatio: !0,
          original: { width: A, height: D }
        };
      });
    } catch {
      n == null || n({ message: e("generalError"), type: "error" });
    }
  };
  return /* @__PURE__ */ x.jsxs(fe, { justify: "center", direction: "column", className: $r.fileNameWrapper, children: [
    /* @__PURE__ */ x.jsx(
      ob,
      {
        ref: a,
        size: Wo,
        maxFiles: 2,
        format: "arrayBuffer",
        acceptConfig: L5,
        className: $r.list,
        locales: f,
        ...u && {
          messageType: "error",
          message: e("uploadSizeError", { fileSize: Wo })
        },
        onWppChange: (m) => {
          var O;
          const d = !!((O = m.detail.errorFiles) != null && O.length), w = m.detail.value, b = w != null && w.length ? w[0] : null;
          c({ isError: d }), b && !d ? g({
            imageFile: b,
            name: b.name,
            contentType: b.type
          }) : p();
        }
      }
    ),
    !!o && /* @__PURE__ */ x.jsxs(fe, { className: $r.fileInfoWrapper, justify: "between", align: "center", gap: 8, children: [
      /* @__PURE__ */ x.jsxs(fe, { className: $r.fileInfo, align: "center", gap: 8, children: [
        !o.loaded || o.loaded === o.size ? /* @__PURE__ */ x.jsx(sv, {}) : /* @__PURE__ */ x.jsx(av, { "data-testid": "loading-page-spinner", size: "s" }),
        /* @__PURE__ */ x.jsx(_e, { type: "s-body", tag: "p", className: $r.imageName, children: o.name }),
        !!o.size && /* @__PURE__ */ x.jsxs(_e, { type: "s-body", className: $r.imageSize, children: [
          o.loaded && `${o == null ? void 0 : o.loaded}/`,
          o.size
        ] }),
        !!o.loadedPercent && /* @__PURE__ */ x.jsx(_e, { type: "s-body", className: $r.imageLoadedPercent, children: o.loadedPercent })
      ] }),
      !!l && /* @__PURE__ */ x.jsx(ov, { className: $r.imageRemove, onClick: p })
    ] })
  ] });
}, k5 = () => {
  const { loc: t } = se();
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(Re, { propKey: "linkUrl", type: "text", label: t("linkUrl") }),
    /* @__PURE__ */ x.jsx(Re, { propKey: "newTab", type: "checkbox", label: t("buttonNewTab") })
  ] });
}, N5 = "_segment_1uuqe_1", z5 = "_toolbarSection_1uuqe_5", Kl = {
  segment: N5,
  toolbarSection: z5
};
var Ua = /* @__PURE__ */ ((t) => (t.color = "color", t.gradient = "gradient", t))(Ua || {});
const W5 = "_colorInput_yow3f_1", H5 = {
  colorInput: W5
}, U5 = "_container_1evok_1", V5 = "_colorTag_1evok_5", q5 = "_isLight_1evok_15", G5 = "_sectionTitle_1evok_19", as = {
  container: U5,
  colorTag: V5,
  isLight: q5,
  sectionTitle: G5
}, Ho = (t, e, r = 10) => t.reduce((n, a) => e[a] ? [...n, ...rj(Object.values(e[a]), r)] : n, []), Uo = ({
  title: t,
  rows: e,
  onClick: r
}) => /* @__PURE__ */ x.jsxs(fe, { as: "li", direction: "column", gap: 4, children: [
  /* @__PURE__ */ x.jsx(_e, { type: "2xs-strong", className: as.sectionTitle, children: t }),
  /* @__PURE__ */ x.jsx(fe, { gap: 12, direction: "column", children: e.map((n, a) => /* @__PURE__ */ x.jsx(fe, { as: "ul", gap: 4, children: n.map((i) => {
    const s = KI(i, 200) === "light";
    return /* @__PURE__ */ x.jsx("li", { onClick: () => r(i), children: /* @__PURE__ */ x.jsx(
      "div",
      {
        className: ke(as.colorTag, { [as.isLight]: s }),
        style: { backgroundColor: i }
      }
    ) }, i);
  }) }, t + a)) })
] }), Y5 = ({ onChange: t }) => {
  const {
    dependencies: { theme: e }
  } = se(), { loc: r } = se(), n = gt(() => {
    const { color: a } = e, { primary: i, grey: s, dataviz: l } = a, { seq: o, cat: u } = l;
    return {
      brand: Ho(["primary", "grey"], { primary: i, grey: s }),
      categorical: Ho(["dark", "neutral", "light"], u),
      sequential: Ho(["brand", "grey", "negative", "warning", "positive"], o)
    };
  }, [e]);
  return /* @__PURE__ */ x.jsx(fe, { className: as.container, direction: "column", gap: 12, children: /* @__PURE__ */ x.jsxs(fe, { as: "ul", direction: "column", gap: 4, children: [
    /* @__PURE__ */ x.jsx(Uo, { onClick: t, title: r("brandPalette"), rows: n.brand }),
    /* @__PURE__ */ x.jsx(Uo, { onClick: t, title: r("categoricalPalette"), rows: n.categorical }),
    /* @__PURE__ */ x.jsx(Uo, { onClick: t, title: r("sequentialPalette"), rows: n.sequential })
  ] }) });
}, Zm = (t) => {
  const e = de(t);
  return e.current = t, oe((...r) => e.current.apply(null, r), []);
}, K5 = "_tag_dmazu_1", X5 = "_button_dmazu_8", Z5 = "_popover_dmazu_18", Vo = {
  tag: K5,
  button: X5,
  popover: Z5
}, Xl = ({ color: t, className: e, onChange: r }) => {
  const n = de(null), a = Zm((i) => {
    var s;
    r(i), (s = n.current) == null || s.closePopover();
  });
  return /* @__PURE__ */ x.jsxs(
    lv,
    {
      className: ke(Vo.popover, e),
      ref: n,
      shouldCloseOnOutsideClick: () => !0,
      config: {
        appendTo: () => document.querySelector("#root"),
        zIndex: 1e4
      },
      children: [
        /* @__PURE__ */ x.jsxs(
          Dr,
          {
            type: "button",
            variant: "secondary",
            slot: "trigger-element",
            className: Vo.button,
            onClick: (i) => {
              i.stopPropagation(), i.preventDefault();
            },
            "data-testid": "hex-color-button",
            children: [
              /* @__PURE__ */ x.jsx("span", { slot: "icon-start", className: Vo.tag, style: { backgroundColor: t } }),
              /* @__PURE__ */ x.jsx(_e, { type: "s-body", children: t })
            ]
          }
        ),
        /* @__PURE__ */ x.jsx("div", { children: /* @__PURE__ */ x.jsx(Y5, { onChange: a }) })
      ]
    }
  );
}, J5 = ({ selector: t }) => {
  const {
    actions: { setProp: e },
    color: r
  } = me((a) => ({
    color: hc(t(a.data.props)).color
  })), n = (a) => {
    e((i) => {
      const s = t(i);
      s && (s.color = a);
    });
  };
  return /* @__PURE__ */ x.jsx(Xl, { className: H5.colorInput, color: r, onChange: n });
}, Q5 = "_preview_5gtoj_1", e4 = "_colorInput_5gtoj_6", qo = {
  preview: Q5,
  colorInput: e4
}, t4 = (t) => `${t}°`, r4 = [
  {
    label: "0",
    value: "right"
  },
  {
    label: "45",
    value: "top right"
  },
  {
    label: "90",
    value: "top"
  },
  {
    label: "135",
    value: "top left"
  },
  {
    label: "180",
    value: "left"
  },
  {
    label: "225",
    value: "bottom left"
  },
  {
    label: "270",
    value: "bottom"
  },
  {
    label: "315",
    value: "bottom right"
  }
], n4 = ({ selector: t }) => {
  const {
    actions: { setProp: e },
    gradient: r
  } = me((a) => ({
    gradient: gc(t(a.data.props))
  })), n = (a) => (i) => {
    e((s) => {
      const l = t(s);
      l && (l[a] = i);
    });
  };
  return /* @__PURE__ */ x.jsxs(fe, { gap: 40, children: [
    /* @__PURE__ */ x.jsxs(fe, { direction: "column", gap: 8, children: [
      /* @__PURE__ */ x.jsx(Xl, { className: qo.colorInput, color: r == null ? void 0 : r.start, onChange: n("start") }),
      /* @__PURE__ */ x.jsx(Xl, { className: qo.colorInput, color: r == null ? void 0 : r.end, onChange: n("end") }),
      /* @__PURE__ */ x.jsx(
        Yl,
        {
          value: r == null ? void 0 : r.direction,
          options: r4,
          onWppChange: ({ detail: a }) => {
            n("direction")(a.value);
          },
          renderOptionContent: ({ label: a }) => /* @__PURE__ */ x.jsx("span", { slot: "label", children: /* @__PURE__ */ x.jsxs(fe, { gap: 8, align: "center", children: [
            /* @__PURE__ */ x.jsx(nv, { style: { rotate: `-${a}deg` } }),
            t4(a)
          ] }) }),
          size: "s"
        }
      )
    ] }),
    /* @__PURE__ */ x.jsx(
      "div",
      {
        className: qo.preview,
        style: {
          background: Ds(r)
        }
      }
    )
  ] });
}, a4 = "_root_1778t_1", i4 = "_title_1778t_5", Up = {
  root: a4,
  title: i4
}, s4 = {
  opacity: 100
}, o4 = (t) => {
  const { selector: e = (a) => a } = t, { loc: r } = se(), { opacity: n } = me((a) => {
    const i = e(a.data.props);
    return {
      opacity: i == null ? void 0 : i.opacity
    };
  });
  return /* @__PURE__ */ x.jsxs(fe, { className: Up.root, gap: 8, direction: "column", children: [
    /* @__PURE__ */ x.jsxs(fe, { direction: "row", justify: "start", align: "center", children: [
      /* @__PURE__ */ x.jsx(_e, { className: Up.title, type: "s-strong", children: r("opacity") }),
      /* @__PURE__ */ x.jsx(_e, { type: "xs-body", children: `${n}%` })
    ] }),
    /* @__PURE__ */ x.jsx(Re, { propKey: "opacity", max: 100, selector: e, type: "slider" })
  ] });
}, Dc = ({
  backgroundSelector: t,
  withImage: e = !1,
  withOpacity: r = !1,
  withPaddings: n = !0
}) => {
  const {
    actions: { setProp: a },
    background: i
  } = me((l) => ({
    background: t(l.data.props)
  })), { loc: s } = se();
  return /* @__PURE__ */ x.jsxs(fe, { direction: "column", gap: 12, className: ke({ [Kl.toolbarSection]: n }), children: [
    /* @__PURE__ */ x.jsxs(fe, { justify: "between", align: "center", children: [
      /* @__PURE__ */ x.jsx(_e, { type: "s-strong", children: s("background") }),
      /* @__PURE__ */ x.jsx(
        Dr,
        {
          onClick: () => {
            a((l) => {
              const o = t(l);
              o && (o.type = "color", o.color = ao, o.gradient = io, e && (o.image = vc));
            });
          },
          children: s("reset")
        }
      )
    ] }),
    /* @__PURE__ */ x.jsxs(fe, { gap: 16, direction: "column", children: [
      /* @__PURE__ */ x.jsxs(
        wu,
        {
          hugContentOff: !0,
          width: "100%",
          className: Kl.segment,
          value: i == null ? void 0 : i.type,
          size: "s",
          onWppChange: ({ detail: l }) => {
            a((o) => {
              const u = t(o);
              u && (u.type = l.value);
            });
          },
          children: [
            /* @__PURE__ */ x.jsx(oi, { value: Ua.color, children: s("color") }),
            /* @__PURE__ */ x.jsx(oi, { value: Ua.gradient, children: s("gradient") })
          ]
        }
      ),
      (i == null ? void 0 : i.type) === Ua.color && /* @__PURE__ */ x.jsx(J5, { selector: (l) => {
        var o;
        return (o = l.background) == null ? void 0 : o.color;
      } }),
      (i == null ? void 0 : i.type) === Ua.gradient && /* @__PURE__ */ x.jsx(n4, { selector: (l) => {
        var o;
        return (o = l.background) == null ? void 0 : o.gradient;
      } }),
      r && i.image && /* @__PURE__ */ x.jsx(o4, { selector: (l) => l == null ? void 0 : l.background }),
      e && /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
        /* @__PURE__ */ x.jsx(Cc, { selector: (l) => {
          var o, u;
          return (u = (o = l.background) == null ? void 0 : o.image) == null ? void 0 : u.image;
        } }),
        /* @__PURE__ */ x.jsx(f5, { selector: (l) => {
          var o, u;
          return (u = (o = l.background) == null ? void 0 : o.image) == null ? void 0 : u.properties;
        } })
      ] })
    ] })
  ] });
}, l4 = "_controls_1fkuw_1", u4 = "_root_1fkuw_5", Vp = {
  controls: l4,
  root: u4
}, c4 = { url: "", newTab: !0, clickable: !1 }, f4 = ({ title: t }) => {
  const { loc: e } = se(), {
    clickable: r,
    actions: { setProp: n }
  } = me((a) => ({
    clickable: a.data.props.link.clickable
  }));
  return /* @__PURE__ */ x.jsxs("div", { className: Vp.root, children: [
    /* @__PURE__ */ x.jsxs(fe, { direction: "row", align: "center", justify: "between", children: [
      /* @__PURE__ */ x.jsx(_e, { type: "s-strong", children: t || e("clickable") }),
      /* @__PURE__ */ x.jsx(
        lb,
        {
          checked: r,
          onWppChange: ({ detail: { checked: a } }) => n((i) => {
            i.link.clickable = a;
          })
        }
      )
    ] }),
    r && /* @__PURE__ */ x.jsxs(fe, { className: Vp.controls, gap: 12, direction: "column", children: [
      /* @__PURE__ */ x.jsx(Re, { label: e("linkUrl"), selector: (a) => a.link, propKey: "url", type: "text" }),
      /* @__PURE__ */ x.jsx(Re, { selector: (a) => a.link, propKey: "newTab", type: "checkbox", label: e("buttonNewTab") })
    ] })
  ] });
}, d4 = () => {
  const { loc: t } = se();
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs(at, { children: [
      /* @__PURE__ */ x.jsx(Re, { propKey: "text", type: "text", label: t("buttonText") }),
      /* @__PURE__ */ x.jsx(Re, { propKey: "url", type: "text", label: t("buttonUrl") }),
      /* @__PURE__ */ x.jsx(Re, { propKey: "newTab", type: "checkbox", label: t("buttonNewTab") })
    ] }),
    /* @__PURE__ */ x.jsx(We, {}),
    /* @__PURE__ */ x.jsxs(at, { children: [
      /* @__PURE__ */ x.jsx(Re, { full: !0, propKey: "variant", type: "select", label: t("buttonVariant"), children: hv.map((e) => /* @__PURE__ */ x.jsx(Qt, { value: e, label: e }, e)) }),
      /* @__PURE__ */ x.jsx(Re, { full: !0, propKey: "size", type: "select", label: t("buttonSize"), children: gv.map((e) => /* @__PURE__ */ x.jsx(Qt, { value: e, label: e }, e)) })
    ] }),
    /* @__PURE__ */ x.jsx(We, {}),
    /* @__PURE__ */ x.jsx(qt, {})
  ] });
}, p4 = (t) => /* @__PURE__ */ we.createElement("svg", { width: 32, height: 20, viewBox: "0 0 64 41", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ we.createElement("path", { d: "M32.4938 12.071C32.287 11.3002 31.4946 10.8429 30.7238 11.0497C29.953 11.2564 29.4957 12.0489 29.7024 12.8197L30.8252 17.0058C31.0319 17.7767 31.8244 18.2339 32.5952 18.0272C33.366 17.8205 33.8233 17.028 33.6165 16.2572L32.4938 12.071Z", fill: "black" }), /* @__PURE__ */ we.createElement("path", { d: "M41.891 16.084C42.4553 15.5197 42.4553 14.6048 41.891 14.0405C41.3266 13.4762 40.4117 13.4762 39.8474 14.0405L36.7811 17.1068C36.2168 17.6711 36.2168 18.586 36.7811 19.1503C37.3454 19.7146 38.2604 19.7146 38.8247 19.1503L41.891 16.084Z", fill: "black" }), /* @__PURE__ */ we.createElement("path", { d: "M24.3196 18.201C23.5487 17.9943 22.7563 18.4516 22.5497 19.2224C22.343 19.9933 22.8003 20.7857 23.5711 20.9924L27.7588 22.1151C28.5296 22.3218 29.322 21.8645 29.5287 21.0936C29.7353 20.3228 29.278 19.5304 28.5072 19.3237L24.3196 18.201Z", fill: "black" }), /* @__PURE__ */ we.createElement("path", { d: "M30.6508 27.3227C31.2148 26.7582 31.2144 25.8432 30.6498 25.2792C30.0853 24.7152 29.1703 24.7156 28.6063 25.2802L25.5429 28.3464C24.9788 28.911 24.9793 29.8259 25.5439 30.39C26.1084 30.954 27.0233 30.9536 27.5874 30.389L30.6508 27.3227Z", fill: "black" }), /* @__PURE__ */ we.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32.6924 21.1934C33.1065 20.7794 33.7295 20.6562 34.27 20.8814L51.61 28.1064C52.1649 28.3376 52.5187 28.8882 52.4984 29.489C52.4781 30.0898 52.0879 30.6153 51.5187 30.8085L46.1668 32.6253L51.0837 37.5422C51.648 38.1065 51.648 39.0214 51.0837 39.5857C50.5194 40.15 49.6045 40.15 49.0402 39.5857L44.1238 34.6693L42.3075 40.0197C42.1143 40.5889 41.5888 40.9791 40.988 40.9994C40.3872 41.0197 39.8366 40.6659 39.6054 40.111L32.3804 22.771C32.1552 22.2305 32.2784 21.6075 32.6924 21.1934ZM36.3978 24.8988L40.8011 35.4667L42.1343 31.5392C42.2787 31.1138 42.6128 30.7797 43.0382 30.6353L46.9657 29.3021L36.3978 24.8988Z", fill: "black" }), /* @__PURE__ */ we.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 6C0 2.96243 2.46243 0.5 5.5 0.5H58.5C61.5376 0.5 64 2.96243 64 6V18C64 21.0376 61.5376 23.5 58.5 23.5H47.25C46.4216 23.5 45.75 22.8284 45.75 22C45.75 21.1716 46.4216 20.5 47.25 20.5H58.5C59.8807 20.5 61 19.3807 61 18V6C61 4.61929 59.8807 3.5 58.5 3.5H5.5C4.11929 3.5 3 4.61929 3 6V18C3 19.3807 4.11929 20.5 5.5 20.5H16.75C17.5784 20.5 18.25 21.1716 18.25 22C18.25 22.8284 17.5784 23.5 16.75 23.5H5.5C2.46243 23.5 0 21.0376 0 18V6Z", fill: "black" }));
var Jm = {}, h4 = function t(e, r) {
  if (e === r)
    return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    if (e.constructor !== r.constructor)
      return !1;
    var n, a, i;
    if (Array.isArray(e)) {
      if (n = e.length, n != r.length)
        return !1;
      for (a = n; a-- !== 0; )
        if (!t(e[a], r[a]))
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === r.source && e.flags === r.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === r.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === r.toString();
    if (i = Object.keys(e), n = i.length, n !== Object.keys(r).length)
      return !1;
    for (a = n; a-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, i[a]))
        return !1;
    for (a = n; a-- !== 0; ) {
      var s = i[a];
      if (!t(e[s], r[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && r !== r;
}, g4 = tt && tt.__extends || function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
      n.__proto__ = a;
    } || function(n, a) {
      for (var i in a)
        Object.prototype.hasOwnProperty.call(a, i) && (n[i] = a[i]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), _s = tt && tt.__assign || function() {
  return _s = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var a in e)
        Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t;
  }, _s.apply(this, arguments);
}, v4 = tt && tt.__createBinding || (Object.create ? function(t, e, r, n) {
  n === void 0 && (n = r);
  var a = Object.getOwnPropertyDescriptor(e, r);
  (!a || ("get" in a ? !e.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return e[r];
  } }), Object.defineProperty(t, n, a);
} : function(t, e, r, n) {
  n === void 0 && (n = r), t[n] = e[r];
}), m4 = tt && tt.__setModuleDefault || (Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
}), Qm = tt && tt.__importStar || function(t) {
  if (t && t.__esModule)
    return t;
  var e = {};
  if (t != null)
    for (var r in t)
      r !== "default" && Object.prototype.hasOwnProperty.call(t, r) && v4(e, t, r);
  return m4(e, t), e;
}, y4 = tt && tt.__rest || function(t, e) {
  var r = {};
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(t); a < n.length; a++)
      e.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[a]) && (r[n[a]] = t[n[a]]);
  return r;
}, b4 = tt && tt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Jm, "__esModule", { value: !0 });
var Go = Qm(M), w4 = b4(h4), br = Qm(ee);
function qp(t) {
  return t && t.replace(/&nbsp;|\u202F|\u00A0/g, " ").replace(/<br \/>/g, "<br>");
}
function x4(t) {
  var e = document.createTextNode("");
  t.appendChild(e);
  var r = document.activeElement === t;
  if (e !== null && e.nodeValue !== null && r) {
    var n = window.getSelection();
    if (n !== null) {
      var a = document.createRange();
      a.setStart(e, e.nodeValue.length), a.collapse(!0), n.removeAllRanges(), n.addRange(a);
    }
    t instanceof HTMLElement && t.focus();
  }
}
var E4 = (
  /** @class */
  function(t) {
    g4(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.lastHtml = r.props.html, r.el = typeof r.props.innerRef == "function" ? { current: null } : Go.createRef(), r.getEl = function() {
        return (r.props.innerRef && typeof r.props.innerRef != "function" ? r.props.innerRef : r.el).current;
      }, r.emitChange = function(n) {
        var a = r.getEl();
        if (a) {
          var i = a.innerHTML;
          if (r.props.onChange && i !== r.lastHtml) {
            var s = Object.assign({}, n, {
              target: {
                value: i
              }
            });
            r.props.onChange(s);
          }
          r.lastHtml = i;
        }
      }, r;
    }
    return e.prototype.render = function() {
      var r = this, n = this.props, a = n.tagName, i = n.html, s = n.innerRef, l = y4(n, ["tagName", "html", "innerRef"]);
      return Go.createElement(a || "div", _s(_s({}, l), { ref: typeof s == "function" ? function(o) {
        s(o), r.el.current = o;
      } : s || this.el, onInput: this.emitChange, onBlur: this.props.onBlur || this.emitChange, onKeyUp: this.props.onKeyUp || this.emitChange, onKeyDown: this.props.onKeyDown || this.emitChange, contentEditable: !this.props.disabled, dangerouslySetInnerHTML: { __html: i } }), this.props.children);
    }, e.prototype.shouldComponentUpdate = function(r) {
      var n = this.props, a = this.getEl();
      return !a || qp(r.html) !== qp(a.innerHTML) ? !0 : n.disabled !== r.disabled || n.tagName !== r.tagName || n.className !== r.className || n.innerRef !== r.innerRef || n.placeholder !== r.placeholder || !(0, w4.default)(n.style, r.style);
    }, e.prototype.componentDidUpdate = function() {
      var r = this.getEl();
      r && (this.props.html !== r.innerHTML && (r.innerHTML = this.props.html), this.lastHtml = this.props.html, x4(r));
    }, e.propTypes = {
      html: br.string.isRequired,
      onChange: br.func,
      disabled: br.bool,
      tagName: br.string,
      className: br.string,
      style: br.object,
      innerRef: br.oneOfType([
        br.object,
        br.func
      ])
    }, e;
  }(Go.Component)
), Sc = Jm.default = E4;
const C4 = "_contentEditable_1utzx_1", D4 = {
  contentEditable: C4
}, co = ({ text: t, onChange: e }) => {
  const {
    connectors: { connect: r },
    actions: { setProp: n }
  } = me(), { enabled: a } = Le((s) => ({
    enabled: s.options.enabled
  })), i = oe(
    (s) => {
      n((l) => l.text = s.target.value, 500), e == null || e(s);
    },
    [e, n]
  );
  return /* @__PURE__ */ x.jsx(
    Sc,
    {
      innerRef: r,
      html: t || "",
      disabled: !a,
      onChange: i,
      className: D4.contentEditable
    }
  );
};
co.craft = {
  props: {
    text: "text"
  }
};
const S4 = () => console.warn("No URL specified, please add set desired URL in the component settings!"), Oc = ({ variant: t, size: e, text: r, url: n, newTab: a, margin: i }) => {
  const {
    loc: s,
    internals: { readOnly: l }
  } = se(), {
    connectors: { connect: o },
    selected: u
  } = me((f) => ({
    selected: f.events.selected
  })), c = oe(
    () => n && lo({ href: n, target: a ? "_blank" : "_self" }),
    [n, a]
  );
  return /* @__PURE__ */ x.jsx(
    si,
    {
      variant: t,
      size: e,
      onClick: u || l ? Yj : n ? c : S4,
      style: { margin: Ze(gr(i)) },
      ref: (f) => o(f),
      children: /* @__PURE__ */ x.jsx(co, { text: r || s("button") })
    }
  );
};
Oc.craft = {
  displayName: "button",
  props: {
    variant: hv[0],
    size: gv[0],
    text: "",
    url: "",
    newTab: !0,
    margin: [0, dr, dr, 0]
  },
  related: {
    toolbar: d4
  },
  custom: {
    toolbox: {
      icon: /* @__PURE__ */ x.jsx(p4, {}),
      dataTestId: "button-thumbnail"
    }
  }
};
const O4 = () => /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
  /* @__PURE__ */ x.jsx(Dc, { backgroundSelector: (t) => t.background }),
  /* @__PURE__ */ x.jsx(We, {}),
  /* @__PURE__ */ x.jsx(qt, {}),
  /* @__PURE__ */ x.jsx(We, {}),
  /* @__PURE__ */ x.jsx(Km, {})
] }), P4 = (t) => {
  const e = t == null ? void 0 : t.color, r = t == null ? void 0 : t.gradient, n = hc(t == null ? void 0 : t.color), a = gc(t == null ? void 0 : t.gradient);
  return {
    ...(t == null ? void 0 : t.type) === "color" && !!e && {
      "--wpp-card-primary-bg-color": n.color
    },
    ...(t == null ? void 0 : t.type) === "gradient" && !!r && {
      "--wpp-card-primary-bg-color": Ds(a)
    }
  };
}, _4 = "_root_ifsqr_1", A4 = "_editable_ifsqr_5", T4 = "_content_ifsqr_10", Yo = {
  root: _4,
  editable: A4,
  content: T4
}, B4 = (t) => /* @__PURE__ */ we.createElement("svg", { width: 44, height: 36, viewBox: "0 0 44 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ we.createElement("rect", { x: 1.5, y: 1.5, width: 41, height: 33, rx: 2.5, stroke: "black", strokeWidth: 3 })), R4 = [
  "2xl-heading",
  "2xs-strong",
  "3xl-heading",
  "4xl-display",
  "5xl-display",
  "l-body",
  "l-midi",
  "l-strong",
  "m-body",
  "m-midi",
  "m-strong",
  "s-body",
  "s-midi",
  "s-strong",
  "xl-heading",
  "xs-body",
  "xs-midi",
  "xs-strong"
], $4 = () => {
  const { loc: t } = se();
  return /* @__PURE__ */ x.jsxs(M.Fragment, { children: [
    /* @__PURE__ */ x.jsx(
      at,
      {
        title: t("typography"),
        props: ["type"],
        summary: ({ type: e }) => `${e}`,
        children: /* @__PURE__ */ x.jsx(Re, { full: !0, propKey: "type", type: "select", label: "", children: R4.map((e) => /* @__PURE__ */ x.jsx(Qt, { value: e, label: e }, e)) })
      }
    ),
    /* @__PURE__ */ x.jsx(qt, {})
  ] });
}, Pc = ({ margin: t, type: e, text: r }) => {
  const {
    connectors: { connect: n }
  } = me();
  return /* @__PURE__ */ x.jsx(_e, { type: e, style: { margin: Ze(t) }, ref: (a) => n(a), children: /* @__PURE__ */ x.jsx(co, { text: r }) });
};
Pc.craft = {
  displayName: "typography",
  props: {
    type: "2xl-heading",
    margin: [0, 0, 0, 0],
    text: "Text"
  },
  related: {
    toolbar: $4
  }
};
const _c = ({
  children: t,
  margin: e,
  text: r,
  gap: n,
  flexDirection: a,
  alignItems: i,
  justifyContent: s,
  background: l
}) => {
  const { loc: o } = se(), {
    connectors: { connect: u }
  } = me(), { enabled: c } = Le((p) => ({
    enabled: p.options.enabled
  })), f = mc();
  return /* @__PURE__ */ x.jsxs(
    ps,
    {
      className: ke(Yo.root, { [Yo.editable]: c }),
      ref: (p) => u(p),
      style: {
        margin: Ze(gr(e)),
        ...P4(l)
      },
      children: [
        /* @__PURE__ */ x.jsx("div", { slot: "header", children: /* @__PURE__ */ x.jsx(Pc, { text: Kj(r) ? r : o("cardHeader"), type: "xl-heading" }) }),
        /* @__PURE__ */ x.jsx(
          "div",
          {
            className: Yo.content,
            style: {
              gap: n,
              flexDirection: a,
              alignItems: i,
              justifyContent: s
            },
            onScroll: f,
            "data-testid": "card-node-container",
            children: t
          }
        )
      ]
    }
  );
};
_c.craft = {
  isCanvas: !0,
  displayName: "card",
  props: {
    text: void 0,
    background: {
      type: "color",
      color: ao,
      gradient: io
    },
    margin: [0, 0, dr, 0],
    ...Ym
  },
  related: {
    toolbar: O4
  },
  custom: {
    toolbox: {
      icon: /* @__PURE__ */ x.jsx(B4, {}),
      dataTestId: "card-thumbnail"
    }
  }
};
const M4 = "_wrapper_19eiq_1", F4 = "_noPointerEvent_19eiq_6", I4 = "_cursor_19eiq_10", j4 = "_image_19eiq_14", L4 = "_skeleton_19eiq_20", k4 = "_label_19eiq_24", N4 = "_centerImage_19eiq_28", or = {
  wrapper: M4,
  noPointerEvent: F4,
  cursor: I4,
  image: j4,
  skeleton: L4,
  label: k4,
  centerImage: N4
}, z4 = ({ selector: t }) => {
  const { loc: e } = se(), {
    actions: { setProp: r },
    width: n,
    height: a,
    isLockedImageSize: i
  } = me((s) => {
    var o, u, c, f;
    const l = t(s.data.props);
    return {
      width: (o = l.imageSize) == null ? void 0 : o.width,
      height: (u = l.imageSize) == null ? void 0 : u.height,
      lockedRatio: (c = l.imageSize) == null ? void 0 : c.lockedRatio,
      isLockedImageSize: (f = l.lockedImageSize) == null ? void 0 : f.isLockedImageSize
    };
  });
  return /* @__PURE__ */ x.jsx(
    ii,
    {
      checked: i,
      labelConfig: { text: e("fixedSize") },
      name: "isLockedImageSize",
      onWppChange: ({ detail: { checked: s } }) => r((l) => {
        const o = t(l);
        o && (o.lockedImageSize.isLockedImageSize = s, o.lockedImageSize.width = n, o.lockedImageSize.height = a);
      }, 200)
    }
  );
}, W4 = "_lockItem_ikicb_1", H4 = "_lockItemLocked_ikicb_6", Gp = {
  lockItem: W4,
  lockItemLocked: H4
}, U4 = ({ selector: t }) => {
  const { loc: e } = se(), {
    actions: { setProp: r },
    width: n,
    height: a,
    lockedRatio: i,
    isLockedImageSize: s
  } = me((o) => {
    var c, f, p, g;
    const u = t(o.data.props);
    return {
      width: (c = u.imageSize) == null ? void 0 : c.width,
      height: (f = u.imageSize) == null ? void 0 : f.height,
      lockedRatio: (p = u.imageSize) == null ? void 0 : p.lockedRatio,
      isLockedImageSize: (g = u.lockedImageSize) == null ? void 0 : g.isLockedImageSize
    };
  }), l = (o, u) => {
    r((c) => {
      const f = t(c);
      f && (f.imageSize[o] = u);
    }, 200);
  };
  return /* @__PURE__ */ x.jsxs(fe, { gap: 0, align: "end", children: [
    /* @__PURE__ */ x.jsx(
      fi,
      {
        value: n,
        label: e("width"),
        onChange: (o) => {
          const u = (o || "").trim();
          u !== n && l("width", u);
        },
        disabled: s,
        dataTestId: "image-width"
      }
    ),
    /* @__PURE__ */ x.jsx(
      xu,
      {
        className: ke(Gp.lockItem, {
          [Gp.lockItemLocked]: i
        }),
        onClick: () => {
          r((o) => {
            const u = t(o);
            u && (u.imageSize.lockedRatio = !i);
          });
        }
      }
    ),
    /* @__PURE__ */ x.jsx(
      fi,
      {
        value: a,
        label: e("height"),
        onChange: (o) => {
          const u = (o || "").trim();
          u !== a && l("height", u);
        },
        disabled: s,
        dataTestId: "image-height"
      }
    )
  ] });
}, V4 = () => {
  const { loc: t } = se();
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(at, { children: /* @__PURE__ */ x.jsxs(fe, { gap: 16, direction: "column", children: [
      /* @__PURE__ */ x.jsx(U4, { selector: (e) => e.image }),
      /* @__PURE__ */ x.jsx(u5, { selector: (e) => e.image }),
      /* @__PURE__ */ x.jsx(z4, { selector: (e) => e.image })
    ] }) }),
    /* @__PURE__ */ x.jsx(at, { children: /* @__PURE__ */ x.jsxs(fe, { gap: 12, direction: "column", children: [
      /* @__PURE__ */ x.jsx(_e, { type: "s-strong", className: or.label, children: t("image") }),
      /* @__PURE__ */ x.jsx(Cc, { selector: (e) => e.image })
    ] }) }),
    /* @__PURE__ */ x.jsx(at, { children: /* @__PURE__ */ x.jsx(k5, {}) })
  ] });
}, q4 = ({ linkUrl: t, newTab: e, imageUrl: r, disabled: n, style: a, isLockedImageSize: i }) => r || t ? /* @__PURE__ */ x.jsx(
  "img",
  {
    alt: "",
    src: r,
    style: a,
    className: ke(or.image, {
      [or.noPointerEvent]: n,
      [or.cursor]: !!t,
      [or.centerImage]: i
    }),
    onClick: () => t && lo({
      href: t,
      target: e ? "_blank" : "_self"
    })
  }
) : /* @__PURE__ */ x.jsx(xi, { className: or.skeleton, width: "100%", height: "100%" }), Ac = ({ image: t, linkUrl: e, newTab: r }) => {
  var u, c, f, p, g, m, d, w, b, O, S, B, T, A, D, h, y, v;
  const { imageUrl: n } = uo((u = t == null ? void 0 : t.imageMetaData) == null ? void 0 : u.assetId), {
    internals: { readOnly: a }
  } = se(), {
    connectors: { connect: i },
    actions: { setProp: s }
  } = me((E) => ({ events: E })), { enabled: l } = Le((E) => ({
    enabled: E.options.enabled
  })), o = n || e ? /* @__PURE__ */ x.jsx(
    "img",
    {
      alt: "",
      src: n,
      className: ke(or.image, {
        [or.noPointerEvent]: l || a,
        [or.cursor]: !!e,
        [or.centerImage]: (c = t.lockedImageSize) == null ? void 0 : c.isLockedImageSize
      }),
      onClick: () => e && lo({
        href: e,
        target: r ? "_blank" : "_self"
      })
    }
  ) : /* @__PURE__ */ x.jsx(xi, { width: "100%", height: "100%" });
  return l ? /* @__PURE__ */ x.jsx(
    Ri,
    {
      ref: (E) => {
        E != null && E.resizable && i(E == null ? void 0 : E.resizable);
      },
      onResize: ({ height: E, width: _ }) => {
        s((C) => {
          C.image.imageSize.width = _, C.image.imageSize.height = E;
        }, 500);
      },
      width: (f = t == null ? void 0 : t.lockedImageSize) != null && f.isLockedImageSize ? (p = t == null ? void 0 : t.lockedImageSize) == null ? void 0 : p.width : (g = t == null ? void 0 : t.imageSize) == null ? void 0 : g.width,
      height: (m = t == null ? void 0 : t.lockedImageSize) != null && m.isLockedImageSize ? (d = t == null ? void 0 : t.lockedImageSize) == null ? void 0 : d.height : (w = t == null ? void 0 : t.imageSize) == null ? void 0 : w.height,
      lockAspectRatio: (b = t == null ? void 0 : t.imageSize) == null ? void 0 : b.lockedRatio,
      resizeRatio: (O = t == null ? void 0 : t.imageSize) == null ? void 0 : O.ratio,
      disableResizing: (S = t == null ? void 0 : t.lockedImageSize) == null ? void 0 : S.isLockedImageSize,
      children: o
    }
  ) : /* @__PURE__ */ x.jsx(
    "div",
    {
      style: {
        width: pr(
          (B = t == null ? void 0 : t.lockedImageSize) != null && B.isLockedImageSize ? (T = t == null ? void 0 : t.lockedImageSize) == null ? void 0 : T.width : (A = t == null ? void 0 : t.imageSize) == null ? void 0 : A.width
        ),
        height: pr(
          (D = t == null ? void 0 : t.lockedImageSize) != null && D.isLockedImageSize ? (h = t == null ? void 0 : t.lockedImageSize) == null ? void 0 : h.height : (y = t == null ? void 0 : t.imageSize) == null ? void 0 : y.height
        )
      },
      children: /* @__PURE__ */ x.jsx(
        q4,
        {
          newTab: r,
          imageUrl: n,
          linkUrl: e,
          disabled: l || !!a,
          isLockedImageSize: (v = t == null ? void 0 : t.lockedImageSize) == null ? void 0 : v.isLockedImageSize
        }
      )
    }
  );
};
Ac.craft = {
  displayName: "image",
  props: {
    image: {
      imageSize: {
        width: "260px",
        height: "200px",
        lockedRatio: !1
      },
      lockedImageSize: {
        isLockedImageSize: !1,
        width: "260px",
        height: "200px"
      }
    },
    linkUrl: "",
    newTab: !0
  },
  related: {
    toolbar: V4
  },
  custom: {
    toolbox: { icon: /* @__PURE__ */ x.jsx(sv, { width: 30, color: "black" }), dataTestId: "image-thumbnail" }
  }
};
const G4 = (t) => /* @__PURE__ */ we.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 29, height: 29, viewBox: "0 0 512.000000 512.000000", preserveAspectRatio: "xMidYMid meet", ...t }, /* @__PURE__ */ we.createElement("g", { transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)", fill: "#000000", stroke: "none" }, /* @__PURE__ */ we.createElement("path", { d: "M0 2560 l0 -2050 2560 0 2560 0 0 2050 0 2050 -2560 0 -2560 0 0 -2050z m4820 0 l0 -1750 -2260 0 -2260 0 0 1750 0 1750 2260 0 2260 0 0 -1750z" }), /* @__PURE__ */ we.createElement("path", { d: "M3320 3760 l0 -150 292 0 293 0 -465 -465 -465 -465 108 -107 107 -108 465 465 465 465 0 -293 0 -292 150 0 150 0 0 550 0 550 -550 0 -550 0 0 -150z" }), /* @__PURE__ */ we.createElement("path", { d: "M1462 2188 l-462 -463 0 293 0 292 -150 0 -150 0 0 -550 0 -550 550 0 550 0 0 150 0 150 -292 0 -293 0 465 465 465 465 -105 105 c-58 58 -107 105 -110 105 -3 0 -213 -208 -468 -462z" }))), Y4 = "_root_1ewgj_1", K4 = "_title_1ewgj_5", Yp = {
  root: Y4,
  title: K4
}, X4 = ({ propKey: t }) => {
  const { loc: e } = se(), { propValue: r } = me((n) => ({
    propValue: n.data.props[t]
  }));
  return /* @__PURE__ */ x.jsxs(fe, { className: Yp.root, gap: 17, direction: "column", children: [
    /* @__PURE__ */ x.jsxs(fe, { direction: "row", justify: "start", align: "center", children: [
      /* @__PURE__ */ x.jsx(_e, { className: Yp.title, type: "s-strong", children: e("borderRadius") }),
      /* @__PURE__ */ x.jsx(_e, { type: "xs-body", children: `${r}px` })
    ] }),
    /* @__PURE__ */ x.jsx(Re, { propKey: t, type: "slider" })
  ] });
}, Z4 = () => /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
  /* @__PURE__ */ x.jsx(Ec, {}),
  /* @__PURE__ */ x.jsx(We, {}),
  /* @__PURE__ */ x.jsx(Dc, { withImage: !0, withOpacity: !0, backgroundSelector: (t) => t == null ? void 0 : t.background }),
  /* @__PURE__ */ x.jsx(We, {}),
  /* @__PURE__ */ x.jsx(f4, {}),
  /* @__PURE__ */ x.jsx(We, {}),
  /* @__PURE__ */ x.jsx(X4, { propKey: "borderRadius" }),
  /* @__PURE__ */ x.jsx(We, {}),
  /* @__PURE__ */ x.jsx(qt, {}),
  /* @__PURE__ */ x.jsx(We, {}),
  /* @__PURE__ */ x.jsx(Xr, {}),
  /* @__PURE__ */ x.jsx(We, {}),
  /* @__PURE__ */ x.jsx(Km, {})
] }), J4 = "_content_124m5_1", Q4 = "_Indicators_124m5_28", e8 = "_bounded_124m5_70", t8 = "_row_124m5_96", r8 = "_column_124m5_113", n8 = "_backgroundWrapper_124m5_130", a8 = "_positionWrapper_124m5_140", i8 = "_withLink_124m5_147", s8 = "_noEvents_124m5_154", lr = {
  content: J4,
  Indicators: Q4,
  bounded: e8,
  row: t8,
  column: r8,
  backgroundWrapper: n8,
  positionWrapper: a8,
  withLink: i8,
  noEvents: s8
}, o8 = {
  top: { top: 0 },
  left: { left: 0 },
  bottom: { bottom: 0 },
  right: { right: 0 },
  topLeft: { top: 0, left: 0 },
  topRight: { top: 0, right: 0 },
  bottomLeft: { bottom: 0, left: 0 },
  bottomRight: { bottom: 0, right: 0 }
}, l8 = ({ propKey: t, children: e, ...r }) => {
  const {
    actions: { setProp: n },
    connectors: { connect: a },
    fillSpace: i,
    nodeWidth: s,
    nodeHeight: l,
    parent: o,
    active: u,
    inNodeContext: c
  } = me((D) => ({
    parent: D.data.parent,
    active: D.events.selected,
    nodeWidth: D.data.props[t.width],
    nodeHeight: D.data.props[t.height],
    fillSpace: D.data.props.fillSpace
  })), { parentDirection: f } = Le((D) => ({
    parentDirection: o && D.nodes[o] && D.nodes[o].data.props.flexDirection
  })), p = de(), g = de(!1), m = de(null), d = de(null);
  d.current = { width: s, height: l };
  const [w, b] = $e({
    width: s,
    height: l
  }), O = oe(() => {
    var _, C;
    const { width: D, height: h } = d.current, y = na((C = (_ = p.current) == null ? void 0 : _.resizable) == null ? void 0 : C.parentElement), v = Ss(D, y.width), E = Ss(h, y.height);
    b({
      width: v,
      height: E
    });
  }, []), S = oe(() => {
    const { width: D, height: h } = d.current;
    b({
      width: D,
      height: h
    });
  }, []), B = (D, h) => {
    var _;
    if (!((_ = p.current) == null ? void 0 : _.resizable))
      return;
    const v = parseInt(m.current.width), E = parseInt(m.current.height);
    return {
      width: v + parseInt(String(D)),
      height: E + parseInt(String(h))
    };
  };
  xe(() => {
    g.current || S();
  }, [s, l, S]);
  const T = Gm(S, 20);
  xe(() => (window.addEventListener("resize", T), () => {
    window.removeEventListener("resize", T);
  }), [S, T]);
  const A = i === "yes" ? f : !1;
  return /* @__PURE__ */ x.jsxs(
    qm,
    {
      enable: ["top", "left", "bottom", "right", "topLeft", "topRight", "bottomLeft", "bottomRight"].reduce(
        (D, h) => (D[h] = u && c, D),
        {}
      ),
      className: lr.resizable,
      ref: (D) => {
        var h;
        D && (p.current = D, a((h = p.current) == null ? void 0 : h.resizable));
      },
      size: w,
      onResizeStart: (D) => {
        var y;
        O(), D.preventDefault(), D.stopPropagation();
        const h = (y = p == null ? void 0 : p.current) == null ? void 0 : y.resizable;
        h && (m.current = {
          width: h.getBoundingClientRect().width,
          height: h.getBoundingClientRect().height
        }, g.current = !0);
      },
      onResize: (D, h, y, v) => {
        var P, $, W;
        const E = (P = p == null ? void 0 : p.current) == null ? void 0 : P.resizable;
        let { width: _, height: C } = B(v.width, v.height);
        Lr(s) ? _ = Os(_, na(E == null ? void 0 : E.parentElement).width) + "%" : _ = `${_}px`, Lr(l) ? C = Os(C, na(E == null ? void 0 : E.parentElement).height) + "%" : C = `${C}px`, Lr(_) && (($ = E == null ? void 0 : E.parentElement) == null ? void 0 : $.style.width) === "auto" && (_ = m.current.width + v.width + "px"), Lr(C) && ((W = E == null ? void 0 : E.parentElement) == null ? void 0 : W.style.height) === "auto" && (C = m.current.height + v.height + "px"), n((j) => {
          j[t.width] = _, j[t.height] = C;
        }, 500);
      },
      onResizeStop: () => {
        g.current = !1, S();
      },
      handleStyles: o8,
      ...r,
      children: [
        e,
        u && /* @__PURE__ */ x.jsxs(
          "div",
          {
            className: ke(lr.Indicators, {
              [lr.bounded]: A,
              [lr.row]: A === "rows",
              [lr.column]: A === "column"
            }),
            children: [
              /* @__PURE__ */ x.jsx("span", {}),
              /* @__PURE__ */ x.jsx("span", {}),
              /* @__PURE__ */ x.jsx("span", {}),
              /* @__PURE__ */ x.jsx("span", {})
            ]
          }
        )
      ]
    }
  );
}, Tc = ({
  gap: t,
  flexDirection: e,
  alignItems: r,
  justifyContent: n,
  padding: a,
  margin: i,
  shadow: s,
  background: l,
  borderRadius: o,
  opacity: u,
  children: c,
  link: f
}) => {
  var b, O, S;
  const p = mc(), { imageUrl: g } = uo((S = (O = (b = l == null ? void 0 : l.image) == null ? void 0 : b.image) == null ? void 0 : O.imageMetaData) == null ? void 0 : S.assetId), {
    internals: { readOnly: m }
  } = se(), { enabled: d } = Le((B) => ({
    enabled: B.options.enabled
  })), w = !d && !!(f != null && f.clickable);
  return /* @__PURE__ */ x.jsx(
    l8,
    {
      propKey: { width: "width", height: "height" },
      style: {
        margin: Ze(gr(i)),
        boxShadow: s === 0 ? "none" : `0px 3px 100px ${s}px rgba(0, 0, 0, 0.13)`
      },
      children: /* @__PURE__ */ x.jsxs(
        "div",
        {
          className: ke(lr.content, { [lr.withLink]: w, [lr.noEvents]: w && m }),
          style: {
            padding: Ze(ej(a)),
            borderRadius: `${o}px`
          },
          onScroll: p,
          onClick: () => w && lo({
            href: f == null ? void 0 : f.url,
            target: f != null && f.newTab ? "_blank" : "_self"
          }),
          "data-testid": "resizable-node-container",
          children: [
            /* @__PURE__ */ x.jsx(
              "div",
              {
                className: lr.backgroundWrapper,
                style: {
                  ...$m({ backgroundData: l, imageUrl: g, opacity: u })
                }
              }
            ),
            /* @__PURE__ */ x.jsx(
              "div",
              {
                className: lr.positionWrapper,
                style: {
                  gap: t,
                  flexDirection: e,
                  alignItems: r,
                  justifyContent: n
                },
                children: c
              }
            )
          ]
        }
      )
    }
  );
};
Tc.craft = {
  displayName: "resizable",
  isCanvas: !0,
  props: {
    fillSpace: "no",
    shadow: 0,
    borderRadius: 0,
    width: "100%",
    background: {
      type: "color",
      color: ao,
      image: vc,
      gradient: io,
      ...s4
    },
    height: "50px",
    margin: [0, 0, dr, 0],
    padding: [0, 0, 0, 0],
    link: c4,
    ...Ym
  },
  related: {
    toolbar: Z4
  },
  custom: {
    toolbox: {
      icon: /* @__PURE__ */ x.jsx(G4, {}),
      dataTestId: "resizable-thumbnail"
    }
  }
};
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function Kp(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function ct(t) {
  var e, r;
  return Kp(t) === !1 ? !1 : (e = t.constructor, e === void 0 ? !0 : (r = e.prototype, !(Kp(r) === !1 || r.hasOwnProperty("isPrototypeOf") === !1)));
}
function ft(t) {
  for (var e = arguments.length, r = Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)
    r[n - 1] = arguments[n];
  if (process.env.NODE_ENV !== "production") {
    var a = v8[t], i = a ? typeof a == "function" ? a.apply(null, r) : a : "unknown error nr: " + t;
    throw Error("[Immer] " + i);
  }
  throw Error("[Immer] minified error nr: " + t + (r.length ? " " + r.map(function(s) {
    return "'" + s + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function dn(t) {
  return !!t && !!t[Ft];
}
function pn(t) {
  var e;
  return !!t && (function(r) {
    if (!r || typeof r != "object")
      return !1;
    var n = Object.getPrototypeOf(r);
    if (n === null)
      return !0;
    var a = Object.hasOwnProperty.call(n, "constructor") && n.constructor;
    return a === Object || typeof a == "function" && Function.toString.call(a) === m8;
  }(t) || Array.isArray(t) || !!t[nh] || !!(!((e = t.constructor) === null || e === void 0) && e[nh]) || Bc(t) || Rc(t));
}
function di(t, e, r) {
  r === void 0 && (r = !1), Ea(t) === 0 ? (r ? Object.keys : jc)(t).forEach(function(n) {
    r && typeof n == "symbol" || e(n, t[n], t);
  }) : t.forEach(function(n, a) {
    return e(a, n, t);
  });
}
function Ea(t) {
  var e = t[Ft];
  return e ? e.i > 3 ? e.i - 4 : e.i : Array.isArray(t) ? 1 : Bc(t) ? 2 : Rc(t) ? 3 : 0;
}
function Zl(t, e) {
  return Ea(t) === 2 ? t.has(e) : Object.prototype.hasOwnProperty.call(t, e);
}
function u8(t, e) {
  return Ea(t) === 2 ? t.get(e) : t[e];
}
function e0(t, e, r) {
  var n = Ea(t);
  n === 2 ? t.set(e, r) : n === 3 ? t.add(r) : t[e] = r;
}
function c8(t, e) {
  return t === e ? t !== 0 || 1 / t == 1 / e : t != t && e != e;
}
function Bc(t) {
  return h8 && t instanceof Map;
}
function Rc(t) {
  return g8 && t instanceof Set;
}
function tn(t) {
  return t.o || t.t;
}
function $c(t) {
  if (Array.isArray(t))
    return Array.prototype.slice.call(t);
  var e = y8(t);
  delete e[Ft];
  for (var r = jc(e), n = 0; n < r.length; n++) {
    var a = r[n], i = e[a];
    i.writable === !1 && (i.writable = !0, i.configurable = !0), (i.get || i.set) && (e[a] = { configurable: !0, writable: !0, enumerable: i.enumerable, value: t[a] });
  }
  return Object.create(Object.getPrototypeOf(t), e);
}
function Mc(t, e) {
  return e === void 0 && (e = !1), Fc(t) || dn(t) || !pn(t) || (Ea(t) > 1 && (t.set = t.add = t.clear = t.delete = f8), Object.freeze(t), e && di(t, function(r, n) {
    return Mc(n, !0);
  }, !0)), t;
}
function f8() {
  ft(2);
}
function Fc(t) {
  return t == null || typeof t != "object" || Object.isFrozen(t);
}
function cr(t) {
  var e = b8[t];
  return e || ft(18, t), e;
}
function Xp() {
  return process.env.NODE_ENV === "production" || oa || ft(0), oa;
}
function Ko(t, e) {
  e && (cr("Patches"), t.u = [], t.s = [], t.v = e);
}
function As(t) {
  Jl(t), t.p.forEach(d8), t.p = null;
}
function Jl(t) {
  t === oa && (oa = t.l);
}
function Zp(t) {
  return oa = { p: [], l: oa, h: t, m: !0, _: 0 };
}
function d8(t) {
  var e = t[Ft];
  e.i === 0 || e.i === 1 ? e.j() : e.g = !0;
}
function Xo(t, e) {
  e._ = e.p.length;
  var r = e.p[0], n = t !== void 0 && t !== r;
  return e.h.O || cr("ES5").S(e, t, n), n ? (r[Ft].P && (As(e), ft(4)), pn(t) && (t = Ts(e, t), e.l || Bs(e, t)), e.u && cr("Patches").M(r[Ft].t, t, e.u, e.s)) : t = Ts(e, r, []), As(e), e.u && e.v(e.u, e.s), t !== t0 ? t : void 0;
}
function Ts(t, e, r) {
  if (Fc(e))
    return e;
  var n = e[Ft];
  if (!n)
    return di(e, function(l, o) {
      return Jp(t, n, e, l, o, r);
    }, !0), e;
  if (n.A !== t)
    return e;
  if (!n.P)
    return Bs(t, n.t, !0), n.t;
  if (!n.I) {
    n.I = !0, n.A._--;
    var a = n.i === 4 || n.i === 5 ? n.o = $c(n.k) : n.o, i = a, s = !1;
    n.i === 3 && (i = new Set(a), a.clear(), s = !0), di(i, function(l, o) {
      return Jp(t, n, a, l, o, r, s);
    }), Bs(t, a, !1), r && t.u && cr("Patches").N(n, r, t.u, t.s);
  }
  return n.o;
}
function Jp(t, e, r, n, a, i, s) {
  if (process.env.NODE_ENV !== "production" && a === r && ft(5), dn(a)) {
    var l = Ts(t, a, i && e && e.i !== 3 && !Zl(e.R, n) ? i.concat(n) : void 0);
    if (e0(r, n, l), !dn(l))
      return;
    t.m = !1;
  } else
    s && r.add(a);
  if (pn(a) && !Fc(a)) {
    if (!t.h.D && t._ < 1)
      return;
    Ts(t, a), e && e.A.l || Bs(t, a);
  }
}
function Bs(t, e, r) {
  r === void 0 && (r = !1), !t.l && t.h.D && t.m && Mc(e, r);
}
function Zo(t, e) {
  var r = t[Ft];
  return (r ? tn(r) : t)[e];
}
function Qp(t, e) {
  if (e in t)
    for (var r = Object.getPrototypeOf(t); r; ) {
      var n = Object.getOwnPropertyDescriptor(r, e);
      if (n)
        return n;
      r = Object.getPrototypeOf(r);
    }
}
function Ql(t) {
  t.P || (t.P = !0, t.l && Ql(t.l));
}
function Jo(t) {
  t.o || (t.o = $c(t.t));
}
function eu(t, e, r) {
  var n = Bc(e) ? cr("MapSet").F(e, r) : Rc(e) ? cr("MapSet").T(e, r) : t.O ? function(a, i) {
    var s = Array.isArray(a), l = { i: s ? 1 : 0, A: i ? i.A : Xp(), P: !1, I: !1, R: {}, l: i, t: a, k: null, o: null, j: null, C: !1 }, o = l, u = tu;
    s && (o = [l], u = Va);
    var c = Proxy.revocable(o, u), f = c.revoke, p = c.proxy;
    return l.k = p, l.j = f, p;
  }(e, r) : cr("ES5").J(e, r);
  return (r ? r.A : Xp()).p.push(n), n;
}
function p8(t) {
  return dn(t) || ft(22, t), function e(r) {
    if (!pn(r))
      return r;
    var n, a = r[Ft], i = Ea(r);
    if (a) {
      if (!a.P && (a.i < 4 || !cr("ES5").K(a)))
        return a.t;
      a.I = !0, n = eh(r, i), a.I = !1;
    } else
      n = eh(r, i);
    return di(n, function(s, l) {
      a && u8(a.t, s) === l || e0(n, s, e(l));
    }), i === 3 ? new Set(n) : n;
  }(t);
}
function eh(t, e) {
  switch (e) {
    case 2:
      return new Map(t);
    case 3:
      return Array.from(t);
  }
  return $c(t);
}
var th, oa, Ic = typeof Symbol < "u" && typeof Symbol("x") == "symbol", h8 = typeof Map < "u", g8 = typeof Set < "u", rh = typeof Proxy < "u" && Proxy.revocable !== void 0 && typeof Reflect < "u", t0 = Ic ? Symbol.for("immer-nothing") : ((th = {})["immer-nothing"] = !0, th), nh = Ic ? Symbol.for("immer-draftable") : "__$immer_draftable", Ft = Ic ? Symbol.for("immer-state") : "__$immer_state", v8 = { 0: "Illegal state", 1: "Immer drafts cannot have computed properties", 2: "This object has been frozen and should not be mutated", 3: function(t) {
  return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + t;
}, 4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", 5: "Immer forbids circular references", 6: "The first or second argument to `produce` must be a function", 7: "The third argument to `produce` must be a function or undefined", 8: "First argument to `createDraft` must be a plain object, an array, or an immerable object", 9: "First argument to `finishDraft` must be a draft returned by `createDraft`", 10: "The given draft is already finalized", 11: "Object.defineProperty() cannot be used on an Immer draft", 12: "Object.setPrototypeOf() cannot be used on an Immer draft", 13: "Immer only supports deleting array indices", 14: "Immer only supports setting array indices and the 'length' property", 15: function(t) {
  return "Cannot apply patch, path doesn't resolve: " + t;
}, 16: 'Sets cannot have "replace" patches.', 17: function(t) {
  return "Unsupported patch operation: " + t;
}, 18: function(t) {
  return "The plugin for '" + t + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + t + "()` when initializing your application.";
}, 20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available", 21: function(t) {
  return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + t + "'";
}, 22: function(t) {
  return "'current' expects a draft, got: " + t;
}, 23: function(t) {
  return "'original' expects a draft, got: " + t;
}, 24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed" }, m8 = "" + Object.prototype.constructor, jc = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(t) {
  return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
} : Object.getOwnPropertyNames, y8 = Object.getOwnPropertyDescriptors || function(t) {
  var e = {};
  return jc(t).forEach(function(r) {
    e[r] = Object.getOwnPropertyDescriptor(t, r);
  }), e;
}, b8 = {}, tu = { get: function(t, e) {
  if (e === Ft)
    return t;
  var r = tn(t);
  if (!Zl(r, e))
    return function(a, i, s) {
      var l, o = Qp(i, s);
      return o ? "value" in o ? o.value : (l = o.get) === null || l === void 0 ? void 0 : l.call(a.k) : void 0;
    }(t, r, e);
  var n = r[e];
  return t.I || !pn(n) ? n : n === Zo(t.t, e) ? (Jo(t), t.o[e] = eu(t.A.h, n, t)) : n;
}, has: function(t, e) {
  return e in tn(t);
}, ownKeys: function(t) {
  return Reflect.ownKeys(tn(t));
}, set: function(t, e, r) {
  var n = Qp(tn(t), e);
  if (n != null && n.set)
    return n.set.call(t.k, r), !0;
  if (!t.P) {
    var a = Zo(tn(t), e), i = a == null ? void 0 : a[Ft];
    if (i && i.t === r)
      return t.o[e] = r, t.R[e] = !1, !0;
    if (c8(r, a) && (r !== void 0 || Zl(t.t, e)))
      return !0;
    Jo(t), Ql(t);
  }
  return t.o[e] === r && (r !== void 0 || e in t.o) || Number.isNaN(r) && Number.isNaN(t.o[e]) || (t.o[e] = r, t.R[e] = !0), !0;
}, deleteProperty: function(t, e) {
  return Zo(t.t, e) !== void 0 || e in t.t ? (t.R[e] = !1, Jo(t), Ql(t)) : delete t.R[e], t.o && delete t.o[e], !0;
}, getOwnPropertyDescriptor: function(t, e) {
  var r = tn(t), n = Reflect.getOwnPropertyDescriptor(r, e);
  return n && { writable: !0, configurable: t.i !== 1 || e !== "length", enumerable: n.enumerable, value: r[e] };
}, defineProperty: function() {
  ft(11);
}, getPrototypeOf: function(t) {
  return Object.getPrototypeOf(t.t);
}, setPrototypeOf: function() {
  ft(12);
} }, Va = {};
di(tu, function(t, e) {
  Va[t] = function() {
    return arguments[0] = arguments[0][0], e.apply(this, arguments);
  };
}), Va.deleteProperty = function(t, e) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(e)) && ft(13), Va.set.call(this, t, e, void 0);
}, Va.set = function(t, e, r) {
  return process.env.NODE_ENV !== "production" && e !== "length" && isNaN(parseInt(e)) && ft(14), tu.set.call(this, t[0], e, r, t[0]);
};
var w8 = function() {
  function t(r) {
    var n = this;
    this.O = rh, this.D = !0, this.produce = function(a, i, s) {
      if (typeof a == "function" && typeof i != "function") {
        var l = i;
        i = a;
        var o = n;
        return function(d) {
          var w = this;
          d === void 0 && (d = l);
          for (var b = arguments.length, O = Array(b > 1 ? b - 1 : 0), S = 1; S < b; S++)
            O[S - 1] = arguments[S];
          return o.produce(d, function(B) {
            var T;
            return (T = i).call.apply(T, [w, B].concat(O));
          });
        };
      }
      var u;
      if (typeof i != "function" && ft(6), s !== void 0 && typeof s != "function" && ft(7), pn(a)) {
        var c = Zp(n), f = eu(n, a, void 0), p = !0;
        try {
          u = i(f), p = !1;
        } finally {
          p ? As(c) : Jl(c);
        }
        return typeof Promise < "u" && u instanceof Promise ? u.then(function(d) {
          return Ko(c, s), Xo(d, c);
        }, function(d) {
          throw As(c), d;
        }) : (Ko(c, s), Xo(u, c));
      }
      if (!a || typeof a != "object") {
        if ((u = i(a)) === void 0 && (u = a), u === t0 && (u = void 0), n.D && Mc(u, !0), s) {
          var g = [], m = [];
          cr("Patches").M(a, u, g, m), s(g, m);
        }
        return u;
      }
      ft(21, a);
    }, this.produceWithPatches = function(a, i) {
      if (typeof a == "function")
        return function(u) {
          for (var c = arguments.length, f = Array(c > 1 ? c - 1 : 0), p = 1; p < c; p++)
            f[p - 1] = arguments[p];
          return n.produceWithPatches(u, function(g) {
            return a.apply(void 0, [g].concat(f));
          });
        };
      var s, l, o = n.produce(a, i, function(u, c) {
        s = u, l = c;
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then(function(u) {
        return [u, s, l];
      }) : [o, s, l];
    }, typeof (r == null ? void 0 : r.useProxies) == "boolean" && this.setUseProxies(r.useProxies), typeof (r == null ? void 0 : r.autoFreeze) == "boolean" && this.setAutoFreeze(r.autoFreeze);
  }
  var e = t.prototype;
  return e.createDraft = function(r) {
    pn(r) || ft(8), dn(r) && (r = p8(r));
    var n = Zp(this), a = eu(this, r, void 0);
    return a[Ft].C = !0, Jl(n), a;
  }, e.finishDraft = function(r, n) {
    var a = r && r[Ft];
    process.env.NODE_ENV !== "production" && (a && a.C || ft(9), a.I && ft(10));
    var i = a.A;
    return Ko(i, n), Xo(void 0, i);
  }, e.setAutoFreeze = function(r) {
    this.D = r;
  }, e.setUseProxies = function(r) {
    r && !rh && ft(20), this.O = r;
  }, e.applyPatches = function(r, n) {
    var a;
    for (a = n.length - 1; a >= 0; a--) {
      var i = n[a];
      if (i.path.length === 0 && i.op === "replace") {
        r = i.value;
        break;
      }
    }
    a > -1 && (n = n.slice(a + 1));
    var s = cr("Patches").$;
    return dn(r) ? s(r, n) : this.produce(r, function(l) {
      return s(l, n);
    });
  }, t;
}(), It = new w8(), Lc = It.produce;
It.produceWithPatches.bind(It);
It.setAutoFreeze.bind(It);
It.setUseProxies.bind(It);
It.applyPatches.bind(It);
var ah = It.createDraft.bind(It), ih = It.finishDraft.bind(It), x8 = {
  transform(t, e) {
    var {
      current: r,
      affinity: n
    } = t;
    if (r != null) {
      var a = H.transform(r, e, {
        affinity: n
      });
      t.current = a, a == null && t.unref();
    }
  }
}, E8 = {
  transform(t, e) {
    var {
      current: r,
      affinity: n
    } = t;
    if (r != null) {
      var a = Ee.transform(r, e, {
        affinity: n
      });
      t.current = a, a == null && t.unref();
    }
  }
}, C8 = {
  transform(t, e) {
    var {
      current: r,
      affinity: n
    } = t;
    if (r != null) {
      var a = G.transform(r, e, {
        affinity: n
      });
      t.current = a, a == null && t.unref();
    }
  }
}, Rs = /* @__PURE__ */ new WeakMap(), $s = /* @__PURE__ */ new WeakMap(), Ja = /* @__PURE__ */ new WeakMap(), r0 = /* @__PURE__ */ new WeakMap(), sh = /* @__PURE__ */ new WeakMap(), oh = /* @__PURE__ */ new WeakMap(), lh = /* @__PURE__ */ new WeakMap(), H = {
  ancestors(t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      reverse: r = !1
    } = e, n = H.levels(t, e);
    return r ? n = n.slice(1) : n = n.slice(0, -1), n;
  },
  common(t, e) {
    for (var r = [], n = 0; n < t.length && n < e.length; n++) {
      var a = t[n], i = e[n];
      if (a !== i)
        break;
      r.push(a);
    }
    return r;
  },
  compare(t, e) {
    for (var r = Math.min(t.length, e.length), n = 0; n < r; n++) {
      if (t[n] < e[n])
        return -1;
      if (t[n] > e[n])
        return 1;
    }
    return 0;
  },
  endsAfter(t, e) {
    var r = t.length - 1, n = t.slice(0, r), a = e.slice(0, r), i = t[r], s = e[r];
    return H.equals(n, a) && i > s;
  },
  endsAt(t, e) {
    var r = t.length, n = t.slice(0, r), a = e.slice(0, r);
    return H.equals(n, a);
  },
  endsBefore(t, e) {
    var r = t.length - 1, n = t.slice(0, r), a = e.slice(0, r), i = t[r], s = e[r];
    return H.equals(n, a) && i < s;
  },
  equals(t, e) {
    return t.length === e.length && t.every((r, n) => r === e[n]);
  },
  hasPrevious(t) {
    return t[t.length - 1] > 0;
  },
  isAfter(t, e) {
    return H.compare(t, e) === 1;
  },
  isAncestor(t, e) {
    return t.length < e.length && H.compare(t, e) === 0;
  },
  isBefore(t, e) {
    return H.compare(t, e) === -1;
  },
  isChild(t, e) {
    return t.length === e.length + 1 && H.compare(t, e) === 0;
  },
  isCommon(t, e) {
    return t.length <= e.length && H.compare(t, e) === 0;
  },
  isDescendant(t, e) {
    return t.length > e.length && H.compare(t, e) === 0;
  },
  isParent(t, e) {
    return t.length + 1 === e.length && H.compare(t, e) === 0;
  },
  isPath(t) {
    return Array.isArray(t) && (t.length === 0 || typeof t[0] == "number");
  },
  isSibling(t, e) {
    if (t.length !== e.length)
      return !1;
    var r = t.slice(0, -1), n = e.slice(0, -1), a = t[t.length - 1], i = e[e.length - 1];
    return a !== i && H.equals(r, n);
  },
  levels(t) {
    for (var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      reverse: r = !1
    } = e, n = [], a = 0; a <= t.length; a++)
      n.push(t.slice(0, a));
    return r && n.reverse(), n;
  },
  next(t) {
    if (t.length === 0)
      throw new Error("Cannot get the next path of a root path [".concat(t, "], because it has no next index."));
    var e = t[t.length - 1];
    return t.slice(0, -1).concat(e + 1);
  },
  operationCanTransformPath(t) {
    switch (t.type) {
      case "insert_node":
      case "remove_node":
      case "merge_node":
      case "split_node":
      case "move_node":
        return !0;
      default:
        return !1;
    }
  },
  parent(t) {
    if (t.length === 0)
      throw new Error("Cannot get the parent path of the root path [".concat(t, "]."));
    return t.slice(0, -1);
  },
  previous(t) {
    if (t.length === 0)
      throw new Error("Cannot get the previous path of a root path [".concat(t, "], because it has no previous index."));
    var e = t[t.length - 1];
    if (e <= 0)
      throw new Error("Cannot get the previous path of a first child path [".concat(t, "] because it would result in a negative index."));
    return t.slice(0, -1).concat(e - 1);
  },
  relative(t, e) {
    if (!H.isAncestor(e, t) && !H.equals(t, e))
      throw new Error("Cannot get the relative path of [".concat(t, "] inside ancestor [").concat(e, "], because it is not above or equal to the path."));
    return t.slice(e.length);
  },
  transform(t, e) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!t)
      return null;
    var n = [...t], {
      affinity: a = "forward"
    } = r;
    if (t.length === 0)
      return n;
    switch (e.type) {
      case "insert_node": {
        var {
          path: i
        } = e;
        (H.equals(i, n) || H.endsBefore(i, n) || H.isAncestor(i, n)) && (n[i.length - 1] += 1);
        break;
      }
      case "remove_node": {
        var {
          path: s
        } = e;
        if (H.equals(s, n) || H.isAncestor(s, n))
          return null;
        H.endsBefore(s, n) && (n[s.length - 1] -= 1);
        break;
      }
      case "merge_node": {
        var {
          path: l,
          position: o
        } = e;
        H.equals(l, n) || H.endsBefore(l, n) ? n[l.length - 1] -= 1 : H.isAncestor(l, n) && (n[l.length - 1] -= 1, n[l.length] += o);
        break;
      }
      case "split_node": {
        var {
          path: u,
          position: c
        } = e;
        if (H.equals(u, n)) {
          if (a === "forward")
            n[n.length - 1] += 1;
          else if (a !== "backward")
            return null;
        } else
          H.endsBefore(u, n) ? n[u.length - 1] += 1 : H.isAncestor(u, n) && t[u.length] >= c && (n[u.length - 1] += 1, n[u.length] -= c);
        break;
      }
      case "move_node": {
        var {
          path: f,
          newPath: p
        } = e;
        if (H.equals(f, p))
          return n;
        if (H.isAncestor(f, n) || H.equals(f, n)) {
          var g = p.slice();
          return H.endsBefore(f, p) && f.length < p.length && (g[f.length - 1] -= 1), g.concat(n.slice(f.length));
        } else
          H.isSibling(f, p) && (H.isAncestor(p, n) || H.equals(p, n)) ? H.endsBefore(f, n) ? n[f.length - 1] -= 1 : n[f.length - 1] += 1 : H.endsBefore(p, n) || H.equals(p, n) || H.isAncestor(p, n) ? (H.endsBefore(f, n) && (n[f.length - 1] -= 1), n[p.length - 1] += 1) : H.endsBefore(f, n) && (H.equals(p, n) && (n[p.length - 1] += 1), n[f.length - 1] -= 1);
        break;
      }
    }
    return n;
  }
};
function Ct(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function uh(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ia(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? uh(Object(r), !0).forEach(function(n) {
      Ct(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : uh(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var D8 = (t, e, r) => {
  switch (r.type) {
    case "insert_node": {
      var {
        path: n,
        node: a
      } = r, i = Q.parent(t, n), s = n[n.length - 1];
      if (s > i.children.length)
        throw new Error('Cannot apply an "insert_node" operation at path ['.concat(n, "] because the destination is past the end of the node."));
      if (i.children.splice(s, 0, a), e)
        for (var [l, o] of G.points(e))
          e[o] = Ee.transform(l, r);
      break;
    }
    case "insert_text": {
      var {
        path: u,
        offset: c,
        text: f
      } = r;
      if (f.length === 0)
        break;
      var p = Q.leaf(t, u), g = p.text.slice(0, c), m = p.text.slice(c);
      if (p.text = g + f + m, e)
        for (var [d, w] of G.points(e))
          e[w] = Ee.transform(d, r);
      break;
    }
    case "merge_node": {
      var {
        path: b
      } = r, O = Q.get(t, b), S = H.previous(b), B = Q.get(t, S), T = Q.parent(t, b), A = b[b.length - 1];
      if (ie.isText(O) && ie.isText(B))
        B.text += O.text;
      else if (!ie.isText(O) && !ie.isText(B))
        B.children.push(...O.children);
      else
        throw new Error('Cannot apply a "merge_node" operation at path ['.concat(b, "] to nodes of different interfaces: ").concat(ot.stringify(O), " ").concat(ot.stringify(B)));
      if (T.children.splice(A, 1), e)
        for (var [D, h] of G.points(e))
          e[h] = Ee.transform(D, r);
      break;
    }
    case "move_node": {
      var {
        path: y,
        newPath: v
      } = r;
      if (H.isAncestor(y, v))
        throw new Error("Cannot move a path [".concat(y, "] to new path [").concat(v, "] because the destination is inside itself."));
      var E = Q.get(t, y), _ = Q.parent(t, y), C = y[y.length - 1];
      _.children.splice(C, 1);
      var P = H.transform(y, r), $ = Q.get(t, H.parent(P)), W = P[P.length - 1];
      if ($.children.splice(W, 0, E), e)
        for (var [j, I] of G.points(e))
          e[I] = Ee.transform(j, r);
      break;
    }
    case "remove_node": {
      var {
        path: F
      } = r, k = F[F.length - 1], N = Q.parent(t, F);
      if (N.children.splice(k, 1), e)
        for (var [U, Y] of G.points(e)) {
          var L = Ee.transform(U, r);
          if (e != null && L != null)
            e[Y] = L;
          else {
            var q = void 0, V = void 0;
            for (var [X, te] of Q.texts(t))
              if (H.compare(te, F) === -1)
                q = [X, te];
              else {
                V = [X, te];
                break;
              }
            var re = !1;
            q && V && (H.equals(V[1], F) ? re = !H.hasPrevious(V[1]) : re = H.common(q[1], F).length < H.common(V[1], F).length), q && !re ? (U.path = q[1], U.offset = q[0].text.length) : V ? (U.path = V[1], U.offset = 0) : e = null;
          }
        }
      break;
    }
    case "remove_text": {
      var {
        path: ue,
        offset: pe,
        text: ye
      } = r;
      if (ye.length === 0)
        break;
      var Ce = Q.leaf(t, ue), be = Ce.text.slice(0, pe), Ie = Ce.text.slice(pe + ye.length);
      if (Ce.text = be + Ie, e)
        for (var [Me, Ae] of G.points(e))
          e[Ae] = Ee.transform(Me, r);
      break;
    }
    case "set_node": {
      var {
        path: Be,
        properties: Ke,
        newProperties: st
      } = r;
      if (Be.length === 0)
        throw new Error("Cannot set properties on the root node!");
      var vt = Q.get(t, Be);
      for (var je in st) {
        if (je === "children" || je === "text")
          throw new Error('Cannot set the "'.concat(je, '" property of nodes!'));
        var lt = st[je];
        lt == null ? delete vt[je] : vt[je] = lt;
      }
      for (var Dt in Ke)
        st.hasOwnProperty(Dt) || delete vt[Dt];
      break;
    }
    case "set_selection": {
      var {
        newProperties: Se
      } = r;
      if (Se == null)
        e = Se;
      else {
        if (e == null) {
          if (!G.isRange(Se))
            throw new Error('Cannot apply an incomplete "set_selection" operation properties '.concat(ot.stringify(Se), " when there is no current selection."));
          e = Ia({}, Se);
        }
        for (var St in Se) {
          var nr = Se[St];
          if (nr == null) {
            if (St === "anchor" || St === "focus")
              throw new Error('Cannot remove the "'.concat(St, '" selection property'));
            delete e[St];
          } else
            e[St] = nr;
        }
      }
      break;
    }
    case "split_node": {
      var {
        path: Tt,
        position: ar,
        properties: Jr
      } = r;
      if (Tt.length === 0)
        throw new Error('Cannot apply a "split_node" operation at path ['.concat(Tt, "] because the root node cannot be split."));
      var Gt = Q.get(t, Tt), yo = Q.parent(t, Tt), bo = Tt[Tt.length - 1], Oa;
      if (ie.isText(Gt)) {
        var wo = Gt.text.slice(0, ar), xo = Gt.text.slice(ar);
        Gt.text = wo, Oa = Ia(Ia({}, Jr), {}, {
          text: xo
        });
      } else {
        var Eo = Gt.children.slice(0, ar), Co = Gt.children.slice(ar);
        Gt.children = Eo, Oa = Ia(Ia({}, Jr), {}, {
          children: Co
        });
      }
      if (yo.children.splice(bo + 1, 0, Oa), e)
        for (var [Pa, Ii] of G.points(e))
          e[Ii] = Ee.transform(Pa, r);
      break;
    }
  }
  return e;
}, S8 = {
  transform(t, e) {
    t.children = ah(t.children);
    var r = t.selection && ah(t.selection);
    try {
      r = D8(t, r, e);
    } finally {
      t.children = ih(t.children), r ? t.selection = dn(r) ? ih(r) : r : t.selection = null;
    }
  }
}, O8 = {
  insertNodes(t, e, r) {
    t.insertNodes(e, r);
  },
  liftNodes(t, e) {
    t.liftNodes(e);
  },
  mergeNodes(t, e) {
    t.mergeNodes(e);
  },
  moveNodes(t, e) {
    t.moveNodes(e);
  },
  removeNodes(t, e) {
    t.removeNodes(e);
  },
  setNodes(t, e, r) {
    t.setNodes(e, r);
  },
  splitNodes(t, e) {
    t.splitNodes(e);
  },
  unsetNodes(t, e, r) {
    t.unsetNodes(e, r);
  },
  unwrapNodes(t, e) {
    t.unwrapNodes(e);
  },
  wrapNodes(t, e, r) {
    t.wrapNodes(e, r);
  }
}, P8 = {
  collapse(t, e) {
    t.collapse(e);
  },
  deselect(t) {
    t.deselect();
  },
  move(t, e) {
    t.move(e);
  },
  select(t, e) {
    t.select(e);
  },
  setPoint(t, e, r) {
    t.setPoint(e, r);
  },
  setSelection(t, e) {
    t.setSelection(e);
  }
}, n0 = (t, e) => {
  for (var r in t) {
    var n = t[r], a = e[r];
    if (ct(n) && ct(a)) {
      if (!n0(n, a))
        return !1;
    } else if (Array.isArray(n) && Array.isArray(a)) {
      if (n.length !== a.length)
        return !1;
      for (var i = 0; i < n.length; i++)
        if (n[i] !== a[i])
          return !1;
    } else if (n !== a)
      return !1;
  }
  for (var s in e)
    if (t[s] === void 0 && e[s] !== void 0)
      return !1;
  return !0;
};
function _8(t, e) {
  if (t == null)
    return {};
  var r = {}, n = Object.keys(t), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(e.indexOf(a) >= 0) && (r[a] = t[a]);
  return r;
}
function Sr(t, e) {
  if (t == null)
    return {};
  var r = _8(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
var A8 = ["anchor", "focus"];
function ch(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function T8(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ch(Object(r), !0).forEach(function(n) {
      Ct(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ch(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var G = {
  edges(t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      reverse: r = !1
    } = e, {
      anchor: n,
      focus: a
    } = t;
    return G.isBackward(t) === r ? [n, a] : [a, n];
  },
  end(t) {
    var [, e] = G.edges(t);
    return e;
  },
  equals(t, e) {
    return Ee.equals(t.anchor, e.anchor) && Ee.equals(t.focus, e.focus);
  },
  includes(t, e) {
    if (G.isRange(e)) {
      if (G.includes(t, e.anchor) || G.includes(t, e.focus))
        return !0;
      var [r, n] = G.edges(t), [a, i] = G.edges(e);
      return Ee.isBefore(r, a) && Ee.isAfter(n, i);
    }
    var [s, l] = G.edges(t), o = !1, u = !1;
    return Ee.isPoint(e) ? (o = Ee.compare(e, s) >= 0, u = Ee.compare(e, l) <= 0) : (o = H.compare(e, s.path) >= 0, u = H.compare(e, l.path) <= 0), o && u;
  },
  intersection(t, e) {
    var r = Sr(t, A8), [n, a] = G.edges(t), [i, s] = G.edges(e), l = Ee.isBefore(n, i) ? i : n, o = Ee.isBefore(a, s) ? a : s;
    return Ee.isBefore(o, l) ? null : T8({
      anchor: l,
      focus: o
    }, r);
  },
  isBackward(t) {
    var {
      anchor: e,
      focus: r
    } = t;
    return Ee.isAfter(e, r);
  },
  isCollapsed(t) {
    var {
      anchor: e,
      focus: r
    } = t;
    return Ee.equals(e, r);
  },
  isExpanded(t) {
    return !G.isCollapsed(t);
  },
  isForward(t) {
    return !G.isBackward(t);
  },
  isRange(t) {
    return ct(t) && Ee.isPoint(t.anchor) && Ee.isPoint(t.focus);
  },
  *points(t) {
    yield [t.anchor, "anchor"], yield [t.focus, "focus"];
  },
  start(t) {
    var [e] = G.edges(t);
    return e;
  },
  transform(t, e) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return Lc(t, (n) => {
      if (n === null)
        return null;
      var {
        affinity: a = "inward"
      } = r, i, s;
      if (a === "inward") {
        var l = G.isCollapsed(n);
        G.isForward(n) ? (i = "forward", s = l ? i : "backward") : (i = "backward", s = l ? i : "forward");
      } else
        a === "outward" ? G.isForward(n) ? (i = "backward", s = "forward") : (i = "forward", s = "backward") : (i = a, s = a);
      var o = Ee.transform(n.anchor, e, {
        affinity: i
      }), u = Ee.transform(n.focus, e, {
        affinity: s
      });
      if (!o || !u)
        return null;
      n.anchor = o, n.focus = u;
    });
  }
}, fh = (t) => ct(t) && Q.isNodeList(t.children) && !R.isEditor(t), ae = {
  isAncestor(t) {
    return ct(t) && Q.isNodeList(t.children);
  },
  isElement: fh,
  isElementList(t) {
    return Array.isArray(t) && t.every((e) => ae.isElement(e));
  },
  isElementProps(t) {
    return t.children !== void 0;
  },
  isElementType: function(e, r) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "type";
    return fh(e) && e[n] === r;
  },
  matches(t, e) {
    for (var r in e)
      if (r !== "children" && t[r] !== e[r])
        return !1;
    return !0;
  }
}, B8 = ["children"], R8 = ["text"], dh = /* @__PURE__ */ new WeakMap(), Q = {
  ancestor(t, e) {
    var r = Q.get(t, e);
    if (ie.isText(r))
      throw new Error("Cannot get the ancestor node at path [".concat(e, "] because it refers to a text node instead: ").concat(ot.stringify(r)));
    return r;
  },
  *ancestors(t, e) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    for (var n of H.ancestors(e, r)) {
      var a = Q.ancestor(t, n), i = [a, n];
      yield i;
    }
  },
  child(t, e) {
    if (ie.isText(t))
      throw new Error("Cannot get the child of a text node: ".concat(ot.stringify(t)));
    var r = t.children[e];
    if (r == null)
      throw new Error("Cannot get child at index `".concat(e, "` in node: ").concat(ot.stringify(t)));
    return r;
  },
  *children(t, e) {
    for (var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      reverse: n = !1
    } = r, a = Q.ancestor(t, e), {
      children: i
    } = a, s = n ? i.length - 1 : 0; n ? s >= 0 : s < i.length; ) {
      var l = Q.child(a, s), o = e.concat(s);
      yield [l, o], s = n ? s - 1 : s + 1;
    }
  },
  common(t, e, r) {
    var n = H.common(e, r), a = Q.get(t, n);
    return [a, n];
  },
  descendant(t, e) {
    var r = Q.get(t, e);
    if (R.isEditor(r))
      throw new Error("Cannot get the descendant node at path [".concat(e, "] because it refers to the root editor node instead: ").concat(ot.stringify(r)));
    return r;
  },
  *descendants(t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    for (var [r, n] of Q.nodes(t, e))
      n.length !== 0 && (yield [r, n]);
  },
  *elements(t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    for (var [r, n] of Q.nodes(t, e))
      ae.isElement(r) && (yield [r, n]);
  },
  extractProps(t) {
    if (ae.isAncestor(t)) {
      var e = Sr(t, B8);
      return e;
    } else {
      var e = Sr(t, R8);
      return e;
    }
  },
  first(t, e) {
    for (var r = e.slice(), n = Q.get(t, r); n && !(ie.isText(n) || n.children.length === 0); )
      n = n.children[0], r.push(0);
    return [n, r];
  },
  fragment(t, e) {
    if (ie.isText(t))
      throw new Error("Cannot get a fragment starting from a root text node: ".concat(ot.stringify(t)));
    var r = Lc({
      children: t.children
    }, (n) => {
      var [a, i] = G.edges(e), s = Q.nodes(n, {
        reverse: !0,
        pass: (p) => {
          var [, g] = p;
          return !G.includes(e, g);
        }
      });
      for (var [, l] of s) {
        if (!G.includes(e, l)) {
          var o = Q.parent(n, l), u = l[l.length - 1];
          o.children.splice(u, 1);
        }
        if (H.equals(l, i.path)) {
          var c = Q.leaf(n, l);
          c.text = c.text.slice(0, i.offset);
        }
        if (H.equals(l, a.path)) {
          var f = Q.leaf(n, l);
          f.text = f.text.slice(a.offset);
        }
      }
      R.isEditor(n) && (n.selection = null);
    });
    return r.children;
  },
  get(t, e) {
    for (var r = t, n = 0; n < e.length; n++) {
      var a = e[n];
      if (ie.isText(r) || !r.children[a])
        throw new Error("Cannot find a descendant at path [".concat(e, "] in node: ").concat(ot.stringify(t)));
      r = r.children[a];
    }
    return r;
  },
  has(t, e) {
    for (var r = t, n = 0; n < e.length; n++) {
      var a = e[n];
      if (ie.isText(r) || !r.children[a])
        return !1;
      r = r.children[a];
    }
    return !0;
  },
  isNode(t) {
    return ie.isText(t) || ae.isElement(t) || R.isEditor(t);
  },
  isNodeList(t) {
    if (!Array.isArray(t))
      return !1;
    var e = dh.get(t);
    if (e !== void 0)
      return e;
    var r = t.every((n) => Q.isNode(n));
    return dh.set(t, r), r;
  },
  last(t, e) {
    for (var r = e.slice(), n = Q.get(t, r); n && !(ie.isText(n) || n.children.length === 0); ) {
      var a = n.children.length - 1;
      n = n.children[a], r.push(a);
    }
    return [n, r];
  },
  leaf(t, e) {
    var r = Q.get(t, e);
    if (!ie.isText(r))
      throw new Error("Cannot get the leaf node at path [".concat(e, "] because it refers to a non-leaf node: ").concat(ot.stringify(r)));
    return r;
  },
  *levels(t, e) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    for (var n of H.levels(e, r)) {
      var a = Q.get(t, n);
      yield [a, n];
    }
  },
  matches(t, e) {
    return ae.isElement(t) && ae.isElementProps(e) && ae.matches(t, e) || ie.isText(t) && ie.isTextProps(e) && ie.matches(t, e);
  },
  *nodes(t) {
    for (var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      pass: r,
      reverse: n = !1
    } = e, {
      from: a = [],
      to: i
    } = e, s = /* @__PURE__ */ new Set(), l = [], o = t; !(i && (n ? H.isBefore(l, i) : H.isAfter(l, i))); ) {
      if (s.has(o) || (yield [o, l]), !s.has(o) && !ie.isText(o) && o.children.length !== 0 && (r == null || r([o, l]) === !1)) {
        s.add(o);
        var u = n ? o.children.length - 1 : 0;
        H.isAncestor(l, a) && (u = a[l.length]), l = l.concat(u), o = Q.get(t, l);
        continue;
      }
      if (l.length === 0)
        break;
      if (!n) {
        var c = H.next(l);
        if (Q.has(t, c)) {
          l = c, o = Q.get(t, l);
          continue;
        }
      }
      if (n && l[l.length - 1] !== 0) {
        var f = H.previous(l);
        l = f, o = Q.get(t, l);
        continue;
      }
      l = H.parent(l), o = Q.get(t, l), s.add(o);
    }
  },
  parent(t, e) {
    var r = H.parent(e), n = Q.get(t, r);
    if (ie.isText(n))
      throw new Error("Cannot get the parent of path [".concat(e, "] because it does not exist in the root."));
    return n;
  },
  string(t) {
    return ie.isText(t) ? t.text : t.children.map(Q.string).join("");
  },
  *texts(t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    for (var [r, n] of Q.nodes(t, e))
      ie.isText(r) && (yield [r, n]);
  }
};
function ph(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function qe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ph(Object(r), !0).forEach(function(n) {
      Ct(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ph(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var kr = {
  isNodeOperation(t) {
    return kr.isOperation(t) && t.type.endsWith("_node");
  },
  isOperation(t) {
    if (!ct(t))
      return !1;
    switch (t.type) {
      case "insert_node":
        return H.isPath(t.path) && Q.isNode(t.node);
      case "insert_text":
        return typeof t.offset == "number" && typeof t.text == "string" && H.isPath(t.path);
      case "merge_node":
        return typeof t.position == "number" && H.isPath(t.path) && ct(t.properties);
      case "move_node":
        return H.isPath(t.path) && H.isPath(t.newPath);
      case "remove_node":
        return H.isPath(t.path) && Q.isNode(t.node);
      case "remove_text":
        return typeof t.offset == "number" && typeof t.text == "string" && H.isPath(t.path);
      case "set_node":
        return H.isPath(t.path) && ct(t.properties) && ct(t.newProperties);
      case "set_selection":
        return t.properties === null && G.isRange(t.newProperties) || t.newProperties === null && G.isRange(t.properties) || ct(t.properties) && ct(t.newProperties);
      case "split_node":
        return H.isPath(t.path) && typeof t.position == "number" && ct(t.properties);
      default:
        return !1;
    }
  },
  isOperationList(t) {
    return Array.isArray(t) && t.every((e) => kr.isOperation(e));
  },
  isSelectionOperation(t) {
    return kr.isOperation(t) && t.type.endsWith("_selection");
  },
  isTextOperation(t) {
    return kr.isOperation(t) && t.type.endsWith("_text");
  },
  inverse(t) {
    switch (t.type) {
      case "insert_node":
        return qe(qe({}, t), {}, {
          type: "remove_node"
        });
      case "insert_text":
        return qe(qe({}, t), {}, {
          type: "remove_text"
        });
      case "merge_node":
        return qe(qe({}, t), {}, {
          type: "split_node",
          path: H.previous(t.path)
        });
      case "move_node": {
        var {
          newPath: e,
          path: r
        } = t;
        if (H.equals(e, r))
          return t;
        if (H.isSibling(r, e))
          return qe(qe({}, t), {}, {
            path: e,
            newPath: r
          });
        var n = H.transform(r, t), a = H.transform(H.next(r), t);
        return qe(qe({}, t), {}, {
          path: n,
          newPath: a
        });
      }
      case "remove_node":
        return qe(qe({}, t), {}, {
          type: "insert_node"
        });
      case "remove_text":
        return qe(qe({}, t), {}, {
          type: "insert_text"
        });
      case "set_node": {
        var {
          properties: i,
          newProperties: s
        } = t;
        return qe(qe({}, t), {}, {
          properties: s,
          newProperties: i
        });
      }
      case "set_selection": {
        var {
          properties: l,
          newProperties: o
        } = t;
        return l == null ? qe(qe({}, t), {}, {
          properties: o,
          newProperties: null
        }) : o == null ? qe(qe({}, t), {}, {
          properties: null,
          newProperties: l
        }) : qe(qe({}, t), {}, {
          properties: o,
          newProperties: l
        });
      }
      case "split_node":
        return qe(qe({}, t), {}, {
          type: "merge_node",
          path: H.next(t.path)
        });
    }
  }
}, hh = /* @__PURE__ */ new WeakMap(), $8 = (t) => {
  var e = hh.get(t);
  if (e !== void 0)
    return e;
  if (!ct(t))
    return !1;
  var r = typeof t.addMark == "function" && typeof t.apply == "function" && typeof t.deleteFragment == "function" && typeof t.insertBreak == "function" && typeof t.insertSoftBreak == "function" && typeof t.insertFragment == "function" && typeof t.insertNode == "function" && typeof t.insertText == "function" && typeof t.isElementReadOnly == "function" && typeof t.isInline == "function" && typeof t.isSelectable == "function" && typeof t.isVoid == "function" && typeof t.normalizeNode == "function" && typeof t.onChange == "function" && typeof t.removeMark == "function" && typeof t.getDirtyPaths == "function" && (t.marks === null || ct(t.marks)) && (t.selection === null || G.isRange(t.selection)) && Q.isNodeList(t.children) && kr.isOperationList(t.operations);
  return hh.set(t, r), r;
}, R = {
  above(t, e) {
    return t.above(e);
  },
  addMark(t, e, r) {
    t.addMark(e, r);
  },
  after(t, e, r) {
    return t.after(e, r);
  },
  before(t, e, r) {
    return t.before(e, r);
  },
  deleteBackward(t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      unit: r = "character"
    } = e;
    t.deleteBackward(r);
  },
  deleteForward(t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      unit: r = "character"
    } = e;
    t.deleteForward(r);
  },
  deleteFragment(t, e) {
    t.deleteFragment(e);
  },
  edges(t, e) {
    return t.edges(e);
  },
  elementReadOnly(t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return t.elementReadOnly(e);
  },
  end(t, e) {
    return t.end(e);
  },
  first(t, e) {
    return t.first(e);
  },
  fragment(t, e) {
    return t.fragment(e);
  },
  hasBlocks(t, e) {
    return t.hasBlocks(e);
  },
  hasInlines(t, e) {
    return t.hasInlines(e);
  },
  hasPath(t, e) {
    return t.hasPath(e);
  },
  hasTexts(t, e) {
    return t.hasTexts(e);
  },
  insertBreak(t) {
    t.insertBreak();
  },
  insertFragment(t, e, r) {
    t.insertFragment(e, r);
  },
  insertNode(t, e) {
    t.insertNode(e);
  },
  insertSoftBreak(t) {
    t.insertSoftBreak();
  },
  insertText(t, e) {
    t.insertText(e);
  },
  isBlock(t, e) {
    return t.isBlock(e);
  },
  isEdge(t, e, r) {
    return t.isEdge(e, r);
  },
  isEditor(t) {
    return $8(t);
  },
  isElementReadOnly(t, e) {
    return t.isElementReadOnly(e);
  },
  isEmpty(t, e) {
    return t.isEmpty(e);
  },
  isEnd(t, e, r) {
    return t.isEnd(e, r);
  },
  isInline(t, e) {
    return t.isInline(e);
  },
  isNormalizing(t) {
    return t.isNormalizing();
  },
  isSelectable(t, e) {
    return t.isSelectable(e);
  },
  isStart(t, e, r) {
    return t.isStart(e, r);
  },
  isVoid(t, e) {
    return t.isVoid(e);
  },
  last(t, e) {
    return t.last(e);
  },
  leaf(t, e, r) {
    return t.leaf(e, r);
  },
  levels(t, e) {
    return t.levels(e);
  },
  marks(t) {
    return t.getMarks();
  },
  next(t, e) {
    return t.next(e);
  },
  node(t, e, r) {
    return t.node(e, r);
  },
  nodes(t, e) {
    return t.nodes(e);
  },
  normalize(t, e) {
    t.normalize(e);
  },
  parent(t, e, r) {
    return t.parent(e, r);
  },
  path(t, e, r) {
    return t.path(e, r);
  },
  pathRef(t, e, r) {
    return t.pathRef(e, r);
  },
  pathRefs(t) {
    return t.pathRefs();
  },
  point(t, e, r) {
    return t.point(e, r);
  },
  pointRef(t, e, r) {
    return t.pointRef(e, r);
  },
  pointRefs(t) {
    return t.pointRefs();
  },
  positions(t, e) {
    return t.positions(e);
  },
  previous(t, e) {
    return t.previous(e);
  },
  range(t, e, r) {
    return t.range(e, r);
  },
  rangeRef(t, e, r) {
    return t.rangeRef(e, r);
  },
  rangeRefs(t) {
    return t.rangeRefs();
  },
  removeMark(t, e) {
    t.removeMark(e);
  },
  setNormalizing(t, e) {
    t.setNormalizing(e);
  },
  start(t, e) {
    return t.start(e);
  },
  string(t, e, r) {
    return t.string(e, r);
  },
  unhangRange(t, e, r) {
    return t.unhangRange(e, r);
  },
  void(t, e) {
    return t.void(e);
  },
  withoutNormalizing(t, e) {
    t.withoutNormalizing(e);
  }
}, M8 = {
  isSpan(t) {
    return Array.isArray(t) && t.length === 2 && t.every(H.isPath);
  }
};
function gh(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function vh(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? gh(Object(r), !0).forEach(function(n) {
      Ct(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : gh(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var Ee = {
  compare(t, e) {
    var r = H.compare(t.path, e.path);
    return r === 0 ? t.offset < e.offset ? -1 : t.offset > e.offset ? 1 : 0 : r;
  },
  isAfter(t, e) {
    return Ee.compare(t, e) === 1;
  },
  isBefore(t, e) {
    return Ee.compare(t, e) === -1;
  },
  equals(t, e) {
    return t.offset === e.offset && H.equals(t.path, e.path);
  },
  isPoint(t) {
    return ct(t) && typeof t.offset == "number" && H.isPath(t.path);
  },
  transform(t, e) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return Lc(t, (n) => {
      if (n === null)
        return null;
      var {
        affinity: a = "forward"
      } = r, {
        path: i,
        offset: s
      } = n;
      switch (e.type) {
        case "insert_node":
        case "move_node": {
          n.path = H.transform(i, e, r);
          break;
        }
        case "insert_text": {
          H.equals(e.path, i) && (e.offset < s || e.offset === s && a === "forward") && (n.offset += e.text.length);
          break;
        }
        case "merge_node": {
          H.equals(e.path, i) && (n.offset += e.position), n.path = H.transform(i, e, r);
          break;
        }
        case "remove_text": {
          H.equals(e.path, i) && e.offset <= s && (n.offset -= Math.min(s - e.offset, e.text.length));
          break;
        }
        case "remove_node": {
          if (H.equals(e.path, i) || H.isAncestor(e.path, i))
            return null;
          n.path = H.transform(i, e, r);
          break;
        }
        case "split_node": {
          if (H.equals(e.path, i)) {
            if (e.position === s && a == null)
              return null;
            (e.position < s || e.position === s && a === "forward") && (n.offset -= e.position, n.path = H.transform(i, e, vh(vh({}, r), {}, {
              affinity: "forward"
            })));
          } else
            n.path = H.transform(i, e, r);
          break;
        }
      }
    });
  }
}, mh = void 0, ot = {
  setScrubber(t) {
    mh = t;
  },
  stringify(t) {
    return JSON.stringify(t, mh);
  }
}, F8 = ["text"], I8 = ["anchor", "focus"];
function yh(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function wr(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? yh(Object(r), !0).forEach(function(n) {
      Ct(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : yh(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var ie = {
  equals(t, e) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      loose: n = !1
    } = r;
    function a(i) {
      var s = Sr(i, F8);
      return s;
    }
    return n0(n ? a(t) : t, n ? a(e) : e);
  },
  isText(t) {
    return ct(t) && typeof t.text == "string";
  },
  isTextList(t) {
    return Array.isArray(t) && t.every((e) => ie.isText(e));
  },
  isTextProps(t) {
    return t.text !== void 0;
  },
  matches(t, e) {
    for (var r in e)
      if (r !== "text" && (!t.hasOwnProperty(r) || t[r] !== e[r]))
        return !1;
    return !0;
  },
  decorations(t, e) {
    var r = [wr({}, t)];
    for (var n of e) {
      var a = Sr(n, I8), [i, s] = G.edges(n), l = [], o = 0, u = i.offset, c = s.offset;
      for (var f of r) {
        var {
          length: p
        } = f.text, g = o;
        if (o += p, u <= g && o <= c) {
          Object.assign(f, a), l.push(f);
          continue;
        }
        if (u !== c && (u === o || c === g) || u > o || c < g || c === g && g !== 0) {
          l.push(f);
          continue;
        }
        var m = f, d = void 0, w = void 0;
        if (c < o) {
          var b = c - g;
          w = wr(wr({}, m), {}, {
            text: m.text.slice(b)
          }), m = wr(wr({}, m), {}, {
            text: m.text.slice(0, b)
          });
        }
        if (u > g) {
          var O = u - g;
          d = wr(wr({}, m), {}, {
            text: m.text.slice(0, O)
          }), m = wr(wr({}, m), {}, {
            text: m.text.slice(O)
          });
        }
        Object.assign(m, a), d && l.push(d), l.push(m), w && l.push(w);
      }
      r = l;
    }
    return r;
  }
}, kc = (t) => t.selection ? t.selection : t.children.length > 0 ? R.end(t, []) : [0], Ca = (t, e) => {
  var [r] = R.node(t, e);
  return (n) => n === r;
}, Nc = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = !r, a = r ? W8(e) : e, i = ve.None, s = ve.None, l = 0, o = null, u = null;
  for (var c of a) {
    var f = c.codePointAt(0);
    if (!f)
      break;
    var p = ek(c, f);
    if ([i, s] = n ? [s, p] : [p, i], ea(i, ve.ZWJ) && ea(s, ve.ExtPict) && (n ? o = bh(e.substring(0, l)) : o = bh(e.substring(0, e.length - l)), !o) || ea(i, ve.RI) && ea(s, ve.RI) && (u !== null ? u = !u : n ? u = !0 : u = ik(e.substring(0, e.length - l)), !u) || i !== ve.None && s !== ve.None && rk(i, s))
      break;
    l += c.length;
  }
  return l || 1;
}, j8 = /\s/, L8 = /[\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, k8 = /['\u2018\u2019]/, N8 = function(e) {
  for (var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = 0, a = !1; e.length > 0; ) {
    var i = Nc(e, r), [s, l] = zc(e, i, r);
    if (z8(s, l, r))
      a = !0, n += i;
    else if (!a)
      n += i;
    else
      break;
    e = l;
  }
  return n;
}, zc = (t, e, r) => {
  if (r) {
    var n = t.length - e;
    return [t.slice(n, t.length), t.slice(0, n)];
  }
  return [t.slice(0, e), t.slice(e)];
}, z8 = function t(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  if (j8.test(e))
    return !1;
  if (k8.test(e)) {
    var a = Nc(r, n), [i, s] = zc(r, a, n);
    if (t(i, s, n))
      return !0;
  }
  return !L8.test(e);
}, W8 = function* (e) {
  for (var r = e.length - 1, n = 0; n < e.length; n++) {
    var a = e.charAt(r - n);
    if (U8(a.charCodeAt(0))) {
      var i = e.charAt(r - n - 1);
      if (H8(i.charCodeAt(0))) {
        yield i + a, n++;
        continue;
      }
    }
    yield a;
  }
}, H8 = (t) => t >= 55296 && t <= 56319, U8 = (t) => t >= 56320 && t <= 57343, ve;
(function(t) {
  t[t.None = 0] = "None", t[t.Extend = 1] = "Extend", t[t.ZWJ = 2] = "ZWJ", t[t.RI = 4] = "RI", t[t.Prepend = 8] = "Prepend", t[t.SpacingMark = 16] = "SpacingMark", t[t.L = 32] = "L", t[t.V = 64] = "V", t[t.T = 128] = "T", t[t.LV = 256] = "LV", t[t.LVT = 512] = "LVT", t[t.ExtPict = 1024] = "ExtPict", t[t.Any = 2048] = "Any";
})(ve || (ve = {}));
var V8 = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])$/, q8 = /^(?:[\u0600-\u0605\u06DD\u070F\u0890\u0891\u08E2\u0D4E]|\uD804[\uDCBD\uDCCD\uDDC2\uDDC3]|\uD806[\uDD3F\uDD41\uDE3A\uDE84-\uDE89]|\uD807\uDD46)$/, G8 = /^(?:[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BF\u09C0\u09C7\u09C8\u09CB\u09CC\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0\u0CC1\u0CC3\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0D02\u0D03\u0D3F\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D82\u0D83\u0DD0\u0DD1\u0DD8-\u0DDE\u0DF2\u0DF3\u0E33\u0EB3\u0F3E\u0F3F\u0F7F\u1031\u103B\u103C\u1056\u1057\u1084\u1715\u1734\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A6D-\u1A72\u1B04\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB1\uDCB2\uDCB9\uDCBB\uDCBC\uDCBE\uDCC1\uDDB0\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD31-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD66\uDD6D])$/, Y8 = /^[\u1100-\u115F\uA960-\uA97C]$/, K8 = /^[\u1160-\u11A7\uD7B0-\uD7C6]$/, X8 = /^[\u11A8-\u11FF\uD7CB-\uD7FB]$/, Z8 = /^[\uAC00\uAC1C\uAC38\uAC54\uAC70\uAC8C\uACA8\uACC4\uACE0\uACFC\uAD18\uAD34\uAD50\uAD6C\uAD88\uADA4\uADC0\uADDC\uADF8\uAE14\uAE30\uAE4C\uAE68\uAE84\uAEA0\uAEBC\uAED8\uAEF4\uAF10\uAF2C\uAF48\uAF64\uAF80\uAF9C\uAFB8\uAFD4\uAFF0\uB00C\uB028\uB044\uB060\uB07C\uB098\uB0B4\uB0D0\uB0EC\uB108\uB124\uB140\uB15C\uB178\uB194\uB1B0\uB1CC\uB1E8\uB204\uB220\uB23C\uB258\uB274\uB290\uB2AC\uB2C8\uB2E4\uB300\uB31C\uB338\uB354\uB370\uB38C\uB3A8\uB3C4\uB3E0\uB3FC\uB418\uB434\uB450\uB46C\uB488\uB4A4\uB4C0\uB4DC\uB4F8\uB514\uB530\uB54C\uB568\uB584\uB5A0\uB5BC\uB5D8\uB5F4\uB610\uB62C\uB648\uB664\uB680\uB69C\uB6B8\uB6D4\uB6F0\uB70C\uB728\uB744\uB760\uB77C\uB798\uB7B4\uB7D0\uB7EC\uB808\uB824\uB840\uB85C\uB878\uB894\uB8B0\uB8CC\uB8E8\uB904\uB920\uB93C\uB958\uB974\uB990\uB9AC\uB9C8\uB9E4\uBA00\uBA1C\uBA38\uBA54\uBA70\uBA8C\uBAA8\uBAC4\uBAE0\uBAFC\uBB18\uBB34\uBB50\uBB6C\uBB88\uBBA4\uBBC0\uBBDC\uBBF8\uBC14\uBC30\uBC4C\uBC68\uBC84\uBCA0\uBCBC\uBCD8\uBCF4\uBD10\uBD2C\uBD48\uBD64\uBD80\uBD9C\uBDB8\uBDD4\uBDF0\uBE0C\uBE28\uBE44\uBE60\uBE7C\uBE98\uBEB4\uBED0\uBEEC\uBF08\uBF24\uBF40\uBF5C\uBF78\uBF94\uBFB0\uBFCC\uBFE8\uC004\uC020\uC03C\uC058\uC074\uC090\uC0AC\uC0C8\uC0E4\uC100\uC11C\uC138\uC154\uC170\uC18C\uC1A8\uC1C4\uC1E0\uC1FC\uC218\uC234\uC250\uC26C\uC288\uC2A4\uC2C0\uC2DC\uC2F8\uC314\uC330\uC34C\uC368\uC384\uC3A0\uC3BC\uC3D8\uC3F4\uC410\uC42C\uC448\uC464\uC480\uC49C\uC4B8\uC4D4\uC4F0\uC50C\uC528\uC544\uC560\uC57C\uC598\uC5B4\uC5D0\uC5EC\uC608\uC624\uC640\uC65C\uC678\uC694\uC6B0\uC6CC\uC6E8\uC704\uC720\uC73C\uC758\uC774\uC790\uC7AC\uC7C8\uC7E4\uC800\uC81C\uC838\uC854\uC870\uC88C\uC8A8\uC8C4\uC8E0\uC8FC\uC918\uC934\uC950\uC96C\uC988\uC9A4\uC9C0\uC9DC\uC9F8\uCA14\uCA30\uCA4C\uCA68\uCA84\uCAA0\uCABC\uCAD8\uCAF4\uCB10\uCB2C\uCB48\uCB64\uCB80\uCB9C\uCBB8\uCBD4\uCBF0\uCC0C\uCC28\uCC44\uCC60\uCC7C\uCC98\uCCB4\uCCD0\uCCEC\uCD08\uCD24\uCD40\uCD5C\uCD78\uCD94\uCDB0\uCDCC\uCDE8\uCE04\uCE20\uCE3C\uCE58\uCE74\uCE90\uCEAC\uCEC8\uCEE4\uCF00\uCF1C\uCF38\uCF54\uCF70\uCF8C\uCFA8\uCFC4\uCFE0\uCFFC\uD018\uD034\uD050\uD06C\uD088\uD0A4\uD0C0\uD0DC\uD0F8\uD114\uD130\uD14C\uD168\uD184\uD1A0\uD1BC\uD1D8\uD1F4\uD210\uD22C\uD248\uD264\uD280\uD29C\uD2B8\uD2D4\uD2F0\uD30C\uD328\uD344\uD360\uD37C\uD398\uD3B4\uD3D0\uD3EC\uD408\uD424\uD440\uD45C\uD478\uD494\uD4B0\uD4CC\uD4E8\uD504\uD520\uD53C\uD558\uD574\uD590\uD5AC\uD5C8\uD5E4\uD600\uD61C\uD638\uD654\uD670\uD68C\uD6A8\uD6C4\uD6E0\uD6FC\uD718\uD734\uD750\uD76C\uD788]$/, J8 = /^[\uAC01-\uAC1B\uAC1D-\uAC37\uAC39-\uAC53\uAC55-\uAC6F\uAC71-\uAC8B\uAC8D-\uACA7\uACA9-\uACC3\uACC5-\uACDF\uACE1-\uACFB\uACFD-\uAD17\uAD19-\uAD33\uAD35-\uAD4F\uAD51-\uAD6B\uAD6D-\uAD87\uAD89-\uADA3\uADA5-\uADBF\uADC1-\uADDB\uADDD-\uADF7\uADF9-\uAE13\uAE15-\uAE2F\uAE31-\uAE4B\uAE4D-\uAE67\uAE69-\uAE83\uAE85-\uAE9F\uAEA1-\uAEBB\uAEBD-\uAED7\uAED9-\uAEF3\uAEF5-\uAF0F\uAF11-\uAF2B\uAF2D-\uAF47\uAF49-\uAF63\uAF65-\uAF7F\uAF81-\uAF9B\uAF9D-\uAFB7\uAFB9-\uAFD3\uAFD5-\uAFEF\uAFF1-\uB00B\uB00D-\uB027\uB029-\uB043\uB045-\uB05F\uB061-\uB07B\uB07D-\uB097\uB099-\uB0B3\uB0B5-\uB0CF\uB0D1-\uB0EB\uB0ED-\uB107\uB109-\uB123\uB125-\uB13F\uB141-\uB15B\uB15D-\uB177\uB179-\uB193\uB195-\uB1AF\uB1B1-\uB1CB\uB1CD-\uB1E7\uB1E9-\uB203\uB205-\uB21F\uB221-\uB23B\uB23D-\uB257\uB259-\uB273\uB275-\uB28F\uB291-\uB2AB\uB2AD-\uB2C7\uB2C9-\uB2E3\uB2E5-\uB2FF\uB301-\uB31B\uB31D-\uB337\uB339-\uB353\uB355-\uB36F\uB371-\uB38B\uB38D-\uB3A7\uB3A9-\uB3C3\uB3C5-\uB3DF\uB3E1-\uB3FB\uB3FD-\uB417\uB419-\uB433\uB435-\uB44F\uB451-\uB46B\uB46D-\uB487\uB489-\uB4A3\uB4A5-\uB4BF\uB4C1-\uB4DB\uB4DD-\uB4F7\uB4F9-\uB513\uB515-\uB52F\uB531-\uB54B\uB54D-\uB567\uB569-\uB583\uB585-\uB59F\uB5A1-\uB5BB\uB5BD-\uB5D7\uB5D9-\uB5F3\uB5F5-\uB60F\uB611-\uB62B\uB62D-\uB647\uB649-\uB663\uB665-\uB67F\uB681-\uB69B\uB69D-\uB6B7\uB6B9-\uB6D3\uB6D5-\uB6EF\uB6F1-\uB70B\uB70D-\uB727\uB729-\uB743\uB745-\uB75F\uB761-\uB77B\uB77D-\uB797\uB799-\uB7B3\uB7B5-\uB7CF\uB7D1-\uB7EB\uB7ED-\uB807\uB809-\uB823\uB825-\uB83F\uB841-\uB85B\uB85D-\uB877\uB879-\uB893\uB895-\uB8AF\uB8B1-\uB8CB\uB8CD-\uB8E7\uB8E9-\uB903\uB905-\uB91F\uB921-\uB93B\uB93D-\uB957\uB959-\uB973\uB975-\uB98F\uB991-\uB9AB\uB9AD-\uB9C7\uB9C9-\uB9E3\uB9E5-\uB9FF\uBA01-\uBA1B\uBA1D-\uBA37\uBA39-\uBA53\uBA55-\uBA6F\uBA71-\uBA8B\uBA8D-\uBAA7\uBAA9-\uBAC3\uBAC5-\uBADF\uBAE1-\uBAFB\uBAFD-\uBB17\uBB19-\uBB33\uBB35-\uBB4F\uBB51-\uBB6B\uBB6D-\uBB87\uBB89-\uBBA3\uBBA5-\uBBBF\uBBC1-\uBBDB\uBBDD-\uBBF7\uBBF9-\uBC13\uBC15-\uBC2F\uBC31-\uBC4B\uBC4D-\uBC67\uBC69-\uBC83\uBC85-\uBC9F\uBCA1-\uBCBB\uBCBD-\uBCD7\uBCD9-\uBCF3\uBCF5-\uBD0F\uBD11-\uBD2B\uBD2D-\uBD47\uBD49-\uBD63\uBD65-\uBD7F\uBD81-\uBD9B\uBD9D-\uBDB7\uBDB9-\uBDD3\uBDD5-\uBDEF\uBDF1-\uBE0B\uBE0D-\uBE27\uBE29-\uBE43\uBE45-\uBE5F\uBE61-\uBE7B\uBE7D-\uBE97\uBE99-\uBEB3\uBEB5-\uBECF\uBED1-\uBEEB\uBEED-\uBF07\uBF09-\uBF23\uBF25-\uBF3F\uBF41-\uBF5B\uBF5D-\uBF77\uBF79-\uBF93\uBF95-\uBFAF\uBFB1-\uBFCB\uBFCD-\uBFE7\uBFE9-\uC003\uC005-\uC01F\uC021-\uC03B\uC03D-\uC057\uC059-\uC073\uC075-\uC08F\uC091-\uC0AB\uC0AD-\uC0C7\uC0C9-\uC0E3\uC0E5-\uC0FF\uC101-\uC11B\uC11D-\uC137\uC139-\uC153\uC155-\uC16F\uC171-\uC18B\uC18D-\uC1A7\uC1A9-\uC1C3\uC1C5-\uC1DF\uC1E1-\uC1FB\uC1FD-\uC217\uC219-\uC233\uC235-\uC24F\uC251-\uC26B\uC26D-\uC287\uC289-\uC2A3\uC2A5-\uC2BF\uC2C1-\uC2DB\uC2DD-\uC2F7\uC2F9-\uC313\uC315-\uC32F\uC331-\uC34B\uC34D-\uC367\uC369-\uC383\uC385-\uC39F\uC3A1-\uC3BB\uC3BD-\uC3D7\uC3D9-\uC3F3\uC3F5-\uC40F\uC411-\uC42B\uC42D-\uC447\uC449-\uC463\uC465-\uC47F\uC481-\uC49B\uC49D-\uC4B7\uC4B9-\uC4D3\uC4D5-\uC4EF\uC4F1-\uC50B\uC50D-\uC527\uC529-\uC543\uC545-\uC55F\uC561-\uC57B\uC57D-\uC597\uC599-\uC5B3\uC5B5-\uC5CF\uC5D1-\uC5EB\uC5ED-\uC607\uC609-\uC623\uC625-\uC63F\uC641-\uC65B\uC65D-\uC677\uC679-\uC693\uC695-\uC6AF\uC6B1-\uC6CB\uC6CD-\uC6E7\uC6E9-\uC703\uC705-\uC71F\uC721-\uC73B\uC73D-\uC757\uC759-\uC773\uC775-\uC78F\uC791-\uC7AB\uC7AD-\uC7C7\uC7C9-\uC7E3\uC7E5-\uC7FF\uC801-\uC81B\uC81D-\uC837\uC839-\uC853\uC855-\uC86F\uC871-\uC88B\uC88D-\uC8A7\uC8A9-\uC8C3\uC8C5-\uC8DF\uC8E1-\uC8FB\uC8FD-\uC917\uC919-\uC933\uC935-\uC94F\uC951-\uC96B\uC96D-\uC987\uC989-\uC9A3\uC9A5-\uC9BF\uC9C1-\uC9DB\uC9DD-\uC9F7\uC9F9-\uCA13\uCA15-\uCA2F\uCA31-\uCA4B\uCA4D-\uCA67\uCA69-\uCA83\uCA85-\uCA9F\uCAA1-\uCABB\uCABD-\uCAD7\uCAD9-\uCAF3\uCAF5-\uCB0F\uCB11-\uCB2B\uCB2D-\uCB47\uCB49-\uCB63\uCB65-\uCB7F\uCB81-\uCB9B\uCB9D-\uCBB7\uCBB9-\uCBD3\uCBD5-\uCBEF\uCBF1-\uCC0B\uCC0D-\uCC27\uCC29-\uCC43\uCC45-\uCC5F\uCC61-\uCC7B\uCC7D-\uCC97\uCC99-\uCCB3\uCCB5-\uCCCF\uCCD1-\uCCEB\uCCED-\uCD07\uCD09-\uCD23\uCD25-\uCD3F\uCD41-\uCD5B\uCD5D-\uCD77\uCD79-\uCD93\uCD95-\uCDAF\uCDB1-\uCDCB\uCDCD-\uCDE7\uCDE9-\uCE03\uCE05-\uCE1F\uCE21-\uCE3B\uCE3D-\uCE57\uCE59-\uCE73\uCE75-\uCE8F\uCE91-\uCEAB\uCEAD-\uCEC7\uCEC9-\uCEE3\uCEE5-\uCEFF\uCF01-\uCF1B\uCF1D-\uCF37\uCF39-\uCF53\uCF55-\uCF6F\uCF71-\uCF8B\uCF8D-\uCFA7\uCFA9-\uCFC3\uCFC5-\uCFDF\uCFE1-\uCFFB\uCFFD-\uD017\uD019-\uD033\uD035-\uD04F\uD051-\uD06B\uD06D-\uD087\uD089-\uD0A3\uD0A5-\uD0BF\uD0C1-\uD0DB\uD0DD-\uD0F7\uD0F9-\uD113\uD115-\uD12F\uD131-\uD14B\uD14D-\uD167\uD169-\uD183\uD185-\uD19F\uD1A1-\uD1BB\uD1BD-\uD1D7\uD1D9-\uD1F3\uD1F5-\uD20F\uD211-\uD22B\uD22D-\uD247\uD249-\uD263\uD265-\uD27F\uD281-\uD29B\uD29D-\uD2B7\uD2B9-\uD2D3\uD2D5-\uD2EF\uD2F1-\uD30B\uD30D-\uD327\uD329-\uD343\uD345-\uD35F\uD361-\uD37B\uD37D-\uD397\uD399-\uD3B3\uD3B5-\uD3CF\uD3D1-\uD3EB\uD3ED-\uD407\uD409-\uD423\uD425-\uD43F\uD441-\uD45B\uD45D-\uD477\uD479-\uD493\uD495-\uD4AF\uD4B1-\uD4CB\uD4CD-\uD4E7\uD4E9-\uD503\uD505-\uD51F\uD521-\uD53B\uD53D-\uD557\uD559-\uD573\uD575-\uD58F\uD591-\uD5AB\uD5AD-\uD5C7\uD5C9-\uD5E3\uD5E5-\uD5FF\uD601-\uD61B\uD61D-\uD637\uD639-\uD653\uD655-\uD66F\uD671-\uD68B\uD68D-\uD6A7\uD6A9-\uD6C3\uD6C5-\uD6DF\uD6E1-\uD6FB\uD6FD-\uD717\uD719-\uD733\uD735-\uD74F\uD751-\uD76B\uD76D-\uD787\uD789-\uD7A3]$/, Q8 = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])$/, ek = (t, e) => {
  var r = ve.Any;
  return t.search(V8) !== -1 && (r |= ve.Extend), e === 8205 && (r |= ve.ZWJ), e >= 127462 && e <= 127487 && (r |= ve.RI), t.search(q8) !== -1 && (r |= ve.Prepend), t.search(G8) !== -1 && (r |= ve.SpacingMark), t.search(Y8) !== -1 && (r |= ve.L), t.search(K8) !== -1 && (r |= ve.V), t.search(X8) !== -1 && (r |= ve.T), t.search(Z8) !== -1 && (r |= ve.LV), t.search(J8) !== -1 && (r |= ve.LVT), t.search(Q8) !== -1 && (r |= ve.ExtPict), r;
};
function ea(t, e) {
  return (t & e) !== 0;
}
var tk = [
  // GB6
  [ve.L, ve.L | ve.V | ve.LV | ve.LVT],
  // GB7
  [ve.LV | ve.V, ve.V | ve.T],
  // GB8
  [ve.LVT | ve.T, ve.T],
  // GB9
  [ve.Any, ve.Extend | ve.ZWJ],
  // GB9a
  [ve.Any, ve.SpacingMark],
  // GB9b
  [ve.Prepend, ve.Any],
  // GB11
  [ve.ZWJ, ve.ExtPict],
  // GB12 and GB13
  [ve.RI, ve.RI]
];
function rk(t, e) {
  return tk.findIndex((r) => ea(t, r[0]) && ea(e, r[1])) === -1;
}
var nk = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])*\u200D$/, bh = (t) => t.search(nk) !== -1, ak = /(?:\uD83C[\uDDE6-\uDDFF])+$/g, ik = (t) => {
  var e = t.match(ak);
  if (e === null)
    return !1;
  var r = e[0].length / 2;
  return r % 2 === 1;
}, sk = {
  delete(t, e) {
    t.delete(e);
  },
  insertFragment(t, e, r) {
    t.insertFragment(e, r);
  },
  insertText(t, e) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    R.withoutNormalizing(t, () => {
      var {
        voids: n = !1
      } = r, {
        at: a = kc(t)
      } = r;
      if (H.isPath(a) && (a = R.range(t, a)), G.isRange(a))
        if (G.isCollapsed(a))
          a = a.anchor;
        else {
          var i = G.end(a);
          if (!n && R.void(t, {
            at: i
          }))
            return;
          var s = G.start(a), l = R.pointRef(t, s), o = R.pointRef(t, i);
          Z.delete(t, {
            at: a,
            voids: n
          });
          var u = l.unref(), c = o.unref();
          a = u || c, Z.setSelection(t, {
            anchor: a,
            focus: a
          });
        }
      if (!(!n && R.void(t, {
        at: a
      }) || R.elementReadOnly(t, {
        at: a
      }))) {
        var {
          path: f,
          offset: p
        } = a;
        e.length > 0 && t.apply({
          type: "insert_text",
          path: f,
          offset: p,
          text: e
        });
      }
    });
  }
};
function wh(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Gi(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? wh(Object(r), !0).forEach(function(n) {
      Ct(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : wh(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var Z = Gi(Gi(Gi(Gi({}, S8), O8), P8), sk), ok = (t, e) => {
  for (var r of R.pathRefs(t))
    x8.transform(r, e);
  for (var n of R.pointRefs(t))
    E8.transform(n, e);
  for (var a of R.rangeRefs(t))
    C8.transform(a, e);
  var i = Rs.get(t) || [], s = $s.get(t) || /* @__PURE__ */ new Set(), l, o, u = (m) => {
    if (m) {
      var d = m.join(",");
      o.has(d) || (o.add(d), l.push(m));
    }
  };
  if (H.operationCanTransformPath(e)) {
    l = [], o = /* @__PURE__ */ new Set();
    for (var c of i) {
      var f = H.transform(c, e);
      u(f);
    }
  } else
    l = i, o = s;
  var p = t.getDirtyPaths(e);
  for (var g of p)
    u(g);
  Rs.set(t, l), $s.set(t, o), Z.transform(t, e), t.operations.push(e), R.normalize(t, {
    operation: e
  }), e.type === "set_selection" && (t.marks = null), Ja.get(t) || (Ja.set(t, !0), Promise.resolve().then(() => {
    Ja.set(t, !1), t.onChange({
      operation: e
    }), t.operations = [];
  }));
}, lk = (t, e) => {
  switch (e.type) {
    case "insert_text":
    case "remove_text":
    case "set_node": {
      var {
        path: r
      } = e;
      return H.levels(r);
    }
    case "insert_node": {
      var {
        node: n,
        path: a
      } = e, i = H.levels(a), s = ie.isText(n) ? [] : Array.from(Q.nodes(n), (v) => {
        var [, E] = v;
        return a.concat(E);
      });
      return [...i, ...s];
    }
    case "merge_node": {
      var {
        path: l
      } = e, o = H.ancestors(l), u = H.previous(l);
      return [...o, u];
    }
    case "move_node": {
      var {
        path: c,
        newPath: f
      } = e;
      if (H.equals(c, f))
        return [];
      var p = [], g = [];
      for (var m of H.ancestors(c)) {
        var d = H.transform(m, e);
        p.push(d);
      }
      for (var w of H.ancestors(f)) {
        var b = H.transform(w, e);
        g.push(b);
      }
      var O = g[g.length - 1], S = f[f.length - 1], B = O.concat(S);
      return [...p, ...g, B];
    }
    case "remove_node": {
      var {
        path: T
      } = e, A = H.ancestors(T);
      return [...A];
    }
    case "split_node": {
      var {
        path: D
      } = e, h = H.levels(D), y = H.next(D);
      return [...h, y];
    }
    default:
      return [];
  }
}, uk = (t) => {
  var {
    selection: e
  } = t;
  return e ? Q.fragment(t, e) : [];
}, ck = (t, e) => {
  var [r, n] = e;
  if (!ie.isText(r)) {
    if (ae.isElement(r) && r.children.length === 0) {
      var a = {
        text: ""
      };
      Z.insertNodes(t, a, {
        at: n.concat(0),
        voids: !0
      });
      return;
    }
    for (var i = R.isEditor(r) ? !1 : ae.isElement(r) && (t.isInline(r) || r.children.length === 0 || ie.isText(r.children[0]) || t.isInline(r.children[0])), s = 0, l = 0; l < r.children.length; l++, s++) {
      var o = Q.get(t, n);
      if (!ie.isText(o)) {
        var u = o.children[s], c = o.children[s - 1], f = l === r.children.length - 1, p = ie.isText(u) || ae.isElement(u) && t.isInline(u);
        if (p !== i)
          Z.removeNodes(t, {
            at: n.concat(s),
            voids: !0
          }), s--;
        else if (ae.isElement(u)) {
          if (t.isInline(u)) {
            if (c == null || !ie.isText(c)) {
              var g = {
                text: ""
              };
              Z.insertNodes(t, g, {
                at: n.concat(s),
                voids: !0
              }), s++;
            } else if (f) {
              var m = {
                text: ""
              };
              Z.insertNodes(t, m, {
                at: n.concat(s + 1),
                voids: !0
              }), s++;
            }
          }
        } else
          c != null && ie.isText(c) && (ie.equals(u, c, {
            loose: !0
          }) ? (Z.mergeNodes(t, {
            at: n.concat(s),
            voids: !0
          }), s--) : c.text === "" ? (Z.removeNodes(t, {
            at: n.concat(s - 1),
            voids: !0
          }), s--) : u.text === "" && (Z.removeNodes(t, {
            at: n.concat(s),
            voids: !0
          }), s--));
      }
    }
  }
}, fk = (t, e) => {
  var {
    iteration: r,
    initialDirtyPathsLength: n
  } = e, a = n * 42;
  if (r > a)
    throw new Error("Could not completely normalize the editor after ".concat(a, " iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state."));
  return !0;
}, dk = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    voids: n = !1,
    mode: a = "lowest",
    at: i = e.selection,
    match: s
  } = r;
  if (i) {
    var l = R.path(e, i), o = a === "lowest";
    for (var [u, c] of R.levels(e, {
      at: l,
      voids: n,
      match: s,
      reverse: o
    }))
      if (!ie.isText(u)) {
        if (G.isRange(i)) {
          if (H.isAncestor(c, i.anchor.path) && H.isAncestor(c, i.focus.path))
            return [u, c];
        } else if (!H.equals(l, c))
          return [u, c];
      }
  }
};
function xh(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Eh(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? xh(Object(r), !0).forEach(function(n) {
      Ct(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : xh(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var pk = (t, e, r) => {
  var {
    selection: n
  } = t;
  if (n) {
    var a = (f, p) => {
      if (!ie.isText(f))
        return !1;
      var [g, m] = R.parent(t, p);
      return !t.isVoid(g) || t.markableVoid(g);
    }, i = G.isExpanded(n), s = !1;
    if (!i) {
      var [l, o] = R.node(t, n);
      if (l && a(l, o)) {
        var [u] = R.parent(t, o);
        s = u && t.markableVoid(u);
      }
    }
    if (i || s)
      Z.setNodes(t, {
        [e]: r
      }, {
        match: a,
        split: !0,
        voids: !0
      });
    else {
      var c = Eh(Eh({}, R.marks(t) || {}), {}, {
        [e]: r
      });
      t.marks = c, Ja.get(t) || t.onChange();
    }
  }
};
function Ch(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Dh(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ch(Object(r), !0).forEach(function(n) {
      Ct(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ch(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var hk = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = R.point(e, r, {
    edge: "end"
  }), i = R.end(e, []), s = {
    anchor: a,
    focus: i
  }, {
    distance: l = 1
  } = n, o = 0, u;
  for (var c of R.positions(e, Dh(Dh({}, n), {}, {
    at: s
  }))) {
    if (o > l)
      break;
    o !== 0 && (u = c), o++;
  }
  return u;
};
function Sh(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Oh(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Sh(Object(r), !0).forEach(function(n) {
      Ct(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Sh(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var gk = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = R.start(e, []), i = R.point(e, r, {
    edge: "start"
  }), s = {
    anchor: a,
    focus: i
  }, {
    distance: l = 1
  } = n, o = 0, u;
  for (var c of R.positions(e, Oh(Oh({}, n), {}, {
    at: s,
    reverse: !0
  }))) {
    if (o > l)
      break;
    o !== 0 && (u = c), o++;
  }
  return u;
}, vk = (t, e) => {
  var {
    selection: r
  } = t;
  r && G.isCollapsed(r) && Z.delete(t, {
    unit: e,
    reverse: !0
  });
}, mk = (t, e) => {
  var {
    selection: r
  } = t;
  r && G.isCollapsed(r) && Z.delete(t, {
    unit: e
  });
}, yk = function(e) {
  var {
    direction: r = "forward"
  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    selection: n
  } = e;
  n && G.isExpanded(n) && Z.delete(e, {
    reverse: r === "backward"
  });
}, bk = (t, e) => [R.start(t, e), R.end(t, e)];
function Ph(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function _h(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ph(Object(r), !0).forEach(function(n) {
      Ct(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ph(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var wk = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return R.above(e, _h(_h({}, r), {}, {
    match: (n) => ae.isElement(n) && R.isElementReadOnly(e, n)
  }));
}, xk = (t, e) => R.point(t, e, {
  edge: "end"
}), Ek = (t, e) => {
  var r = R.path(t, e, {
    edge: "start"
  });
  return R.node(t, r);
}, Ck = (t, e) => {
  var r = R.range(t, e);
  return Q.fragment(t, r);
};
function Ah(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Th(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ah(Object(r), !0).forEach(function(n) {
      Ct(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ah(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var Dk = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return R.above(e, Th(Th({}, r), {}, {
    match: (n) => ae.isElement(n) && R.isVoid(e, n)
  }));
}, Sk = (t, e) => e.children.some((r) => ae.isElement(r) && R.isBlock(t, r)), Ok = (t, e) => e.children.some((r) => ie.isText(r) || R.isInline(t, r)), Pk = (t, e) => Q.has(t, e), _k = (t, e) => e.children.every((r) => ie.isText(r)), Ak = (t) => {
  Z.splitNodes(t, {
    always: !0
  });
}, Tk = (t, e, r) => {
  Z.insertNodes(t, e, r);
}, Bk = (t) => {
  Z.splitNodes(t, {
    always: !0
  });
};
function Bh(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Rk(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Bh(Object(r), !0).forEach(function(n) {
      Ct(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Bh(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var $k = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    selection: a,
    marks: i
  } = e;
  if (a) {
    if (i) {
      var s = Rk({
        text: r
      }, i);
      Z.insertNodes(e, s, {
        at: n.at,
        voids: n.voids
      });
    } else
      Z.insertText(e, r, n);
    e.marks = null;
  }
}, Mk = (t, e) => !t.isInline(e), Fk = (t, e, r) => R.isStart(t, e, r) || R.isEnd(t, e, r), Ik = (t, e) => {
  var {
    children: r
  } = e, [n] = r;
  return r.length === 0 || r.length === 1 && ie.isText(n) && n.text === "" && !t.isVoid(e);
}, jk = (t, e, r) => {
  var n = R.end(t, r);
  return Ee.equals(e, n);
}, Lk = (t) => {
  var e = r0.get(t);
  return e === void 0 ? !0 : e;
}, kk = (t, e, r) => {
  if (e.offset !== 0)
    return !1;
  var n = R.start(t, r);
  return Ee.equals(e, n);
}, Nk = (t, e) => {
  var r = R.path(t, e, {
    edge: "end"
  });
  return R.node(t, r);
}, zk = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = R.path(e, r, n), i = Q.leaf(e, a);
  return [i, a];
};
function* Wk(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    at: r = t.selection,
    reverse: n = !1,
    voids: a = !1
  } = e, {
    match: i
  } = e;
  if (i == null && (i = () => !0), !!r) {
    var s = [], l = R.path(t, r);
    for (var [o, u] of Q.levels(t, l))
      if (i(o, u) && (s.push([o, u]), !a && ae.isElement(o) && R.isVoid(t, o)))
        break;
    n && s.reverse(), yield* s;
  }
}
var Hk = ["text"], Uk = ["text"], Vk = function(e) {
  var {
    marks: r,
    selection: n
  } = e;
  if (!n)
    return null;
  if (r)
    return r;
  if (G.isExpanded(n)) {
    var [a] = R.nodes(e, {
      match: ie.isText
    });
    if (a) {
      var [i] = a, s = Sr(i, Hk);
      return s;
    } else
      return {};
  }
  var {
    anchor: l
  } = n, {
    path: o
  } = l, [u] = R.leaf(e, o);
  if (l.offset === 0) {
    var c = R.previous(e, {
      at: o,
      match: ie.isText
    }), f = R.above(e, {
      match: (b) => ae.isElement(b) && R.isVoid(e, b) && e.markableVoid(b)
    });
    if (!f) {
      var p = R.above(e, {
        match: (b) => ae.isElement(b) && R.isBlock(e, b)
      });
      if (c && p) {
        var [g, m] = c, [, d] = p;
        H.isAncestor(d, m) && (u = g);
      }
    }
  }
  var w = Sr(u, Uk);
  return w;
}, qk = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    mode: n = "lowest",
    voids: a = !1
  } = r, {
    match: i,
    at: s = e.selection
  } = r;
  if (s) {
    var l = R.after(e, s, {
      voids: a
    });
    if (l) {
      var [, o] = R.last(e, []), u = [l.path, o];
      if (H.isPath(s) && s.length === 0)
        throw new Error("Cannot get the next node from the root node!");
      if (i == null)
        if (H.isPath(s)) {
          var [c] = R.parent(e, s);
          i = (p) => c.children.includes(p);
        } else
          i = () => !0;
      var [f] = R.nodes(e, {
        at: u,
        match: i,
        mode: n,
        voids: a
      });
      return f;
    }
  }
}, Gk = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = R.path(e, r, n), i = Q.get(e, a);
  return [i, a];
};
function* Yk(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    at: r = t.selection,
    mode: n = "all",
    universal: a = !1,
    reverse: i = !1,
    voids: s = !1,
    ignoreNonSelectable: l = !1
  } = e, {
    match: o
  } = e;
  if (o || (o = () => !0), !!r) {
    var u, c;
    if (M8.isSpan(r))
      u = r[0], c = r[1];
    else {
      var f = R.path(t, r, {
        edge: "start"
      }), p = R.path(t, r, {
        edge: "end"
      });
      u = i ? p : f, c = i ? f : p;
    }
    var g = Q.nodes(t, {
      reverse: i,
      from: u,
      to: c,
      pass: (B) => {
        var [T] = B;
        return ae.isElement(T) ? !!(!s && (R.isVoid(t, T) || R.isElementReadOnly(t, T)) || l && !R.isSelectable(t, T)) : !1;
      }
    }), m = [], d;
    for (var [w, b] of g)
      if (!(l && ae.isElement(w) && !R.isSelectable(t, w))) {
        var O = d && H.compare(b, d[1]) === 0;
        if (!(n === "highest" && O)) {
          if (!o(w, b)) {
            if (a && !O && ie.isText(w))
              return;
            continue;
          }
          if (n === "lowest" && O) {
            d = [w, b];
            continue;
          }
          var S = n === "lowest" ? d : [w, b];
          S && (a ? m.push(S) : yield S), d = [w, b];
        }
      }
    n === "lowest" && d && (a ? m.push(d) : yield d), a && (yield* m);
  }
}
var Kk = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    force: n = !1,
    operation: a
  } = r, i = (c) => Rs.get(c) || [], s = (c) => $s.get(c) || /* @__PURE__ */ new Set(), l = (c) => {
    var f = i(c).pop(), p = f.join(",");
    return s(c).delete(p), f;
  };
  if (R.isNormalizing(e)) {
    if (n) {
      var o = Array.from(Q.nodes(e), (c) => {
        var [, f] = c;
        return f;
      }), u = new Set(o.map((c) => c.join(",")));
      Rs.set(e, o), $s.set(e, u);
    }
    i(e).length !== 0 && R.withoutNormalizing(e, () => {
      for (var c of i(e))
        if (Q.has(e, c)) {
          var f = R.node(e, c), [p, g] = f;
          ae.isElement(p) && p.children.length === 0 && e.normalizeNode(f, {
            operation: a
          });
        }
      for (var m = i(e), d = m.length, w = 0; m.length !== 0; ) {
        if (!e.shouldNormalize({
          dirtyPaths: m,
          iteration: w,
          initialDirtyPathsLength: d,
          operation: a
        }))
          return;
        var b = l(e);
        if (Q.has(e, b)) {
          var O = R.node(e, b);
          e.normalizeNode(O, {
            operation: a
          });
        }
        w++, m = i(e);
      }
    });
  }
}, Xk = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = R.path(e, r, n), i = H.parent(a), s = R.node(e, i);
  return s;
}, Zk = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    affinity: a = "forward"
  } = n, i = {
    current: r,
    affinity: a,
    unref() {
      var {
        current: l
      } = i, o = R.pathRefs(e);
      return o.delete(i), i.current = null, l;
    }
  }, s = R.pathRefs(e);
  return s.add(i), i;
}, Jk = (t) => {
  var e = sh.get(t);
  return e || (e = /* @__PURE__ */ new Set(), sh.set(t, e)), e;
}, Qk = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    depth: a,
    edge: i
  } = n;
  if (H.isPath(r)) {
    if (i === "start") {
      var [, s] = Q.first(e, r);
      r = s;
    } else if (i === "end") {
      var [, l] = Q.last(e, r);
      r = l;
    }
  }
  return G.isRange(r) && (i === "start" ? r = G.start(r) : i === "end" ? r = G.end(r) : r = H.common(r.anchor.path, r.focus.path)), Ee.isPoint(r) && (r = r.path), a != null && (r = r.slice(0, a)), r;
}, eN = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    affinity: a = "forward"
  } = n, i = {
    current: r,
    affinity: a,
    unref() {
      var {
        current: l
      } = i, o = R.pointRefs(e);
      return o.delete(i), i.current = null, l;
    }
  }, s = R.pointRefs(e);
  return s.add(i), i;
}, tN = (t) => {
  var e = oh.get(t);
  return e || (e = /* @__PURE__ */ new Set(), oh.set(t, e)), e;
}, rN = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    edge: a = "start"
  } = n;
  if (H.isPath(r)) {
    var i;
    if (a === "end") {
      var [, s] = Q.last(e, r);
      i = s;
    } else {
      var [, l] = Q.first(e, r);
      i = l;
    }
    var o = Q.get(e, i);
    if (!ie.isText(o))
      throw new Error("Cannot get the ".concat(a, " point in the node at path [").concat(r, "] because it has no ").concat(a, " text node."));
    return {
      path: i,
      offset: a === "end" ? o.text.length : 0
    };
  }
  if (G.isRange(r)) {
    var [u, c] = G.edges(r);
    return a === "start" ? u : c;
  }
  return r;
};
function* nN(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    at: r = t.selection,
    unit: n = "offset",
    reverse: a = !1,
    voids: i = !1,
    ignoreNonSelectable: s = !1
  } = e;
  if (!r)
    return;
  var l = R.range(t, r), [o, u] = G.edges(l), c = a ? u : o, f = !1, p = "", g = 0, m = 0, d = 0;
  for (var [w, b] of R.nodes(t, {
    at: r,
    reverse: a,
    voids: i,
    ignoreNonSelectable: s
  })) {
    if (ae.isElement(w)) {
      if (!i && (t.isVoid(w) || t.isElementReadOnly(w))) {
        yield R.start(t, b);
        continue;
      }
      if (t.isInline(w))
        continue;
      if (R.hasInlines(t, w)) {
        var O = H.isAncestor(b, u.path) ? u : R.end(t, b), S = H.isAncestor(b, o.path) ? o : R.start(t, b);
        p = R.string(t, {
          anchor: S,
          focus: O
        }, {
          voids: i
        }), f = !0;
      }
    }
    if (ie.isText(w)) {
      var B = H.equals(b, c.path);
      for (B ? (m = a ? c.offset : w.text.length - c.offset, d = c.offset) : (m = w.text.length, d = a ? m : 0), (B || f || n === "offset") && (yield {
        path: b,
        offset: d
      }, f = !1); ; ) {
        if (g === 0) {
          if (p === "")
            break;
          g = T(p, n, a), p = zc(p, g, a)[1];
        }
        if (d = a ? d - g : d + g, m = m - g, m < 0) {
          g = -m;
          break;
        }
        g = 0, yield {
          path: b,
          offset: d
        };
      }
    }
  }
  function T(A, D, h) {
    return D === "character" ? Nc(A, h) : D === "word" ? N8(A, h) : D === "line" || D === "block" ? A.length : 1;
  }
}
var aN = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    mode: n = "lowest",
    voids: a = !1
  } = r, {
    match: i,
    at: s = e.selection
  } = r;
  if (s) {
    var l = R.before(e, s, {
      voids: a
    });
    if (l) {
      var [, o] = R.first(e, []), u = [l.path, o];
      if (H.isPath(s) && s.length === 0)
        throw new Error("Cannot get the previous node from the root node!");
      if (i == null)
        if (H.isPath(s)) {
          var [c] = R.parent(e, s);
          i = (p) => c.children.includes(p);
        } else
          i = () => !0;
      var [f] = R.nodes(e, {
        reverse: !0,
        at: u,
        match: i,
        mode: n,
        voids: a
      });
      return f;
    }
  }
}, iN = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    affinity: a = "forward"
  } = n, i = {
    current: r,
    affinity: a,
    unref() {
      var {
        current: l
      } = i, o = R.rangeRefs(e);
      return o.delete(i), i.current = null, l;
    }
  }, s = R.rangeRefs(e);
  return s.add(i), i;
}, sN = (t) => {
  var e = lh.get(t);
  return e || (e = /* @__PURE__ */ new Set(), lh.set(t, e)), e;
}, oN = (t, e, r) => {
  if (G.isRange(e) && !r)
    return e;
  var n = R.start(t, e), a = R.end(t, r || e);
  return {
    anchor: n,
    focus: a
  };
};
function Rh(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function lN(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Rh(Object(r), !0).forEach(function(n) {
      Ct(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Rh(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var uN = (t, e) => {
  var {
    selection: r
  } = t;
  if (r) {
    var n = (c, f) => {
      if (!ie.isText(c))
        return !1;
      var [p, g] = R.parent(t, f);
      return !t.isVoid(p) || t.markableVoid(p);
    }, a = G.isExpanded(r), i = !1;
    if (!a) {
      var [s, l] = R.node(t, r);
      if (s && n(s, l)) {
        var [o] = R.parent(t, l);
        i = o && t.markableVoid(o);
      }
    }
    if (a || i)
      Z.unsetNodes(t, e, {
        match: n,
        split: !0,
        voids: !0
      });
    else {
      var u = lN({}, R.marks(t) || {});
      delete u[e], t.marks = u, Ja.get(t) || t.onChange();
    }
  }
}, cN = (t, e) => {
  r0.set(t, e);
}, fN = (t, e) => R.point(t, e, {
  edge: "start"
}), dN = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    voids: a = !1
  } = n, i = R.range(e, r), [s, l] = G.edges(i), o = "";
  for (var [u, c] of R.nodes(e, {
    at: i,
    match: ie.isText,
    voids: a
  })) {
    var f = u.text;
    H.equals(c, l.path) && (f = f.slice(0, l.offset)), H.equals(c, s.path) && (f = f.slice(s.offset)), o += f;
  }
  return o;
}, pN = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    voids: a = !1
  } = n, [i, s] = G.edges(r);
  if (i.offset !== 0 || s.offset !== 0 || G.isCollapsed(r) || H.hasPrevious(s.path))
    return r;
  var l = R.above(e, {
    at: s,
    match: (m) => ae.isElement(m) && R.isBlock(e, m),
    voids: a
  }), o = l ? l[1] : [], u = R.start(e, i), c = {
    anchor: u,
    focus: s
  }, f = !0;
  for (var [p, g] of R.nodes(e, {
    at: c,
    match: ie.isText,
    reverse: !0,
    voids: a
  })) {
    if (f) {
      f = !1;
      continue;
    }
    if (p.text !== "" || H.isBefore(g, o)) {
      s = {
        path: g,
        offset: p.text.length
      };
      break;
    }
  }
  return {
    anchor: i,
    focus: s
  };
}, hN = (t, e) => {
  var r = R.isNormalizing(t);
  R.setNormalizing(t, !1);
  try {
    e();
  } finally {
    R.setNormalizing(t, r);
  }
  R.normalize(t);
}, gN = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  R.withoutNormalizing(e, () => {
    var n, a, {
      reverse: i = !1,
      unit: s = "character",
      distance: l = 1,
      voids: o = !1
    } = r, {
      at: u = e.selection,
      hanging: c = !1
    } = r;
    if (u) {
      var f = !1;
      if (G.isRange(u) && G.isCollapsed(u) && (f = !0, u = u.anchor), Ee.isPoint(u)) {
        var p = R.void(e, {
          at: u,
          mode: "highest"
        });
        if (!o && p) {
          var [, g] = p;
          u = g;
        } else {
          var m = {
            unit: s,
            distance: l
          }, d = i ? R.before(e, u, m) || R.start(e, []) : R.after(e, u, m) || R.end(e, []);
          u = {
            anchor: u,
            focus: d
          }, c = !0;
        }
      }
      if (H.isPath(u)) {
        Z.removeNodes(e, {
          at: u,
          voids: o
        });
        return;
      }
      if (!G.isCollapsed(u)) {
        if (!c) {
          var [, w] = G.edges(u), b = R.end(e, []);
          Ee.equals(w, b) || (u = R.unhangRange(e, u, {
            voids: o
          }));
        }
        var [O, S] = G.edges(u), B = R.above(e, {
          match: (be) => ae.isElement(be) && R.isBlock(e, be),
          at: O,
          voids: o
        }), T = R.above(e, {
          match: (be) => ae.isElement(be) && R.isBlock(e, be),
          at: S,
          voids: o
        }), A = B && T && !H.equals(B[1], T[1]), D = H.equals(O.path, S.path), h = o ? null : (n = R.void(e, {
          at: O,
          mode: "highest"
        })) !== null && n !== void 0 ? n : R.elementReadOnly(e, {
          at: O,
          mode: "highest"
        }), y = o ? null : (a = R.void(e, {
          at: S,
          mode: "highest"
        })) !== null && a !== void 0 ? a : R.elementReadOnly(e, {
          at: S,
          mode: "highest"
        });
        if (h) {
          var v = R.before(e, O);
          v && B && H.isAncestor(B[1], v.path) && (O = v);
        }
        if (y) {
          var E = R.after(e, S);
          E && T && H.isAncestor(T[1], E.path) && (S = E);
        }
        var _ = [], C;
        for (var P of R.nodes(e, {
          at: u,
          voids: o
        })) {
          var [$, W] = P;
          C && H.compare(W, C) === 0 || (!o && ae.isElement($) && (R.isVoid(e, $) || R.isElementReadOnly(e, $)) || !H.isCommon(W, O.path) && !H.isCommon(W, S.path)) && (_.push(P), C = W);
        }
        var j = Array.from(_, (be) => {
          var [, Ie] = be;
          return R.pathRef(e, Ie);
        }), I = R.pointRef(e, O), F = R.pointRef(e, S), k = "";
        if (!D && !h) {
          var N = I.current, [U] = R.leaf(e, N), {
            path: Y
          } = N, {
            offset: L
          } = O, q = U.text.slice(L);
          q.length > 0 && (e.apply({
            type: "remove_text",
            path: Y,
            offset: L,
            text: q
          }), k = q);
        }
        if (j.reverse().map((be) => be.unref()).filter((be) => be !== null).forEach((be) => Z.removeNodes(e, {
          at: be,
          voids: o
        })), !y) {
          var V = F.current, [X] = R.leaf(e, V), {
            path: te
          } = V, re = D ? O.offset : 0, ue = X.text.slice(re, S.offset);
          ue.length > 0 && (e.apply({
            type: "remove_text",
            path: te,
            offset: re,
            text: ue
          }), k = ue);
        }
        !D && A && F.current && I.current && Z.mergeNodes(e, {
          at: F.current,
          hanging: !0,
          voids: o
        }), f && i && s === "character" && k.length > 1 && k.match(/[\u0E00-\u0E7F]+/) && Z.insertText(e, k.slice(0, k.length - l));
        var pe = I.unref(), ye = F.unref(), Ce = i ? pe || ye : ye || pe;
        r.at == null && Ce && Z.select(e, Ce);
      }
    }
  });
}, vN = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  R.withoutNormalizing(e, () => {
    var {
      hanging: a = !1,
      voids: i = !1
    } = n, {
      at: s = kc(e)
    } = n;
    if (r.length) {
      if (G.isRange(s))
        if (a || (s = R.unhangRange(e, s, {
          voids: i
        })), G.isCollapsed(s))
          s = s.anchor;
        else {
          var [, l] = G.edges(s);
          if (!i && R.void(e, {
            at: l
          }))
            return;
          var o = R.pointRef(e, l);
          Z.delete(e, {
            at: s
          }), s = o.unref();
        }
      else
        H.isPath(s) && (s = R.start(e, s));
      if (!(!i && R.void(e, {
        at: s
      }))) {
        var u = R.above(e, {
          at: s,
          match: (L) => ae.isElement(L) && R.isInline(e, L),
          mode: "highest",
          voids: i
        });
        if (u) {
          var [, c] = u;
          if (R.isEnd(e, s, c)) {
            var f = R.after(e, c);
            s = f;
          } else if (R.isStart(e, s, c)) {
            var p = R.before(e, c);
            s = p;
          }
        }
        var g = R.above(e, {
          match: (L) => ae.isElement(L) && R.isBlock(e, L),
          at: s,
          voids: i
        }), [, m] = g, d = R.isStart(e, s, m), w = R.isEnd(e, s, m), b = d && w, O = !d || d && w, S = !w, [, B] = Q.first({
          children: r
        }, []), [, T] = Q.last({
          children: r
        }, []), A = [], D = (L) => {
          var [q, V] = L, X = V.length === 0;
          return X ? !1 : b ? !0 : !(O && H.isAncestor(V, B) && ae.isElement(q) && !e.isVoid(q) && !e.isInline(q) || S && H.isAncestor(V, T) && ae.isElement(q) && !e.isVoid(q) && !e.isInline(q));
        };
        for (var h of Q.nodes({
          children: r
        }, {
          pass: D
        }))
          D(h) && A.push(h);
        var y = [], v = [], E = [], _ = !0, C = !1;
        for (var [P] of A)
          ae.isElement(P) && !e.isInline(P) ? (_ = !1, C = !0, v.push(P)) : _ ? y.push(P) : E.push(P);
        var [$] = R.nodes(e, {
          at: s,
          match: (L) => ie.isText(L) || R.isInline(e, L),
          mode: "highest",
          voids: i
        }), [, W] = $, j = R.isStart(e, s, W), I = R.isEnd(e, s, W), F = R.pathRef(e, w && !E.length ? H.next(m) : m), k = R.pathRef(e, I ? H.next(W) : W);
        Z.splitNodes(e, {
          at: s,
          match: (L) => C ? ae.isElement(L) && R.isBlock(e, L) : ie.isText(L) || R.isInline(e, L),
          mode: C ? "lowest" : "highest",
          always: C && (!d || y.length > 0) && (!w || E.length > 0),
          voids: i
        });
        var N = R.pathRef(e, !j || j && I ? H.next(W) : W);
        if (Z.insertNodes(e, y, {
          at: N.current,
          match: (L) => ie.isText(L) || R.isInline(e, L),
          mode: "highest",
          voids: i
        }), b && !y.length && v.length && !E.length && Z.delete(e, {
          at: m,
          voids: i
        }), Z.insertNodes(e, v, {
          at: F.current,
          match: (L) => ae.isElement(L) && R.isBlock(e, L),
          mode: "lowest",
          voids: i
        }), Z.insertNodes(e, E, {
          at: k.current,
          match: (L) => ie.isText(L) || R.isInline(e, L),
          mode: "highest",
          voids: i
        }), !n.at) {
          var U;
          if (E.length > 0 && k.current ? U = H.previous(k.current) : v.length > 0 && F.current ? U = H.previous(F.current) : N.current && (U = H.previous(N.current)), U) {
            var Y = R.end(e, U);
            Z.select(e, Y);
          }
        }
        N.unref(), F.unref(), k.unref();
      }
    }
  });
}, mN = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    edge: n = "anchor"
  } = r, {
    selection: a
  } = e;
  if (a) {
    if (n === "anchor")
      Z.select(e, a.anchor);
    else if (n === "focus")
      Z.select(e, a.focus);
    else if (n === "start") {
      var [i] = G.edges(a);
      Z.select(e, i);
    } else if (n === "end") {
      var [, s] = G.edges(a);
      Z.select(e, s);
    }
  } else
    return;
}, yN = (t) => {
  var {
    selection: e
  } = t;
  e && t.apply({
    type: "set_selection",
    properties: e,
    newProperties: null
  });
}, bN = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    selection: n
  } = e, {
    distance: a = 1,
    unit: i = "character",
    reverse: s = !1
  } = r, {
    edge: l = null
  } = r;
  if (n) {
    l === "start" && (l = G.isBackward(n) ? "focus" : "anchor"), l === "end" && (l = G.isBackward(n) ? "anchor" : "focus");
    var {
      anchor: o,
      focus: u
    } = n, c = {
      distance: a,
      unit: i,
      ignoreNonSelectable: !0
    }, f = {};
    if (l == null || l === "anchor") {
      var p = s ? R.before(e, o, c) : R.after(e, o, c);
      p && (f.anchor = p);
    }
    if (l == null || l === "focus") {
      var g = s ? R.before(e, u, c) : R.after(e, u, c);
      g && (f.focus = g);
    }
    Z.setSelection(e, f);
  }
}, wN = (t, e) => {
  var {
    selection: r
  } = t;
  if (e = R.range(t, e), r) {
    Z.setSelection(t, e);
    return;
  }
  if (!G.isRange(e))
    throw new Error("When setting the selection and the current selection is `null` you must provide at least an `anchor` and `focus`, but you passed: ".concat(ot.stringify(e)));
  t.apply({
    type: "set_selection",
    properties: r,
    newProperties: e
  });
};
function $h(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Mh(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? $h(Object(r), !0).forEach(function(n) {
      Ct(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : $h(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var xN = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    selection: a
  } = e, {
    edge: i = "both"
  } = n;
  if (a) {
    i === "start" && (i = G.isBackward(a) ? "focus" : "anchor"), i === "end" && (i = G.isBackward(a) ? "anchor" : "focus");
    var {
      anchor: s,
      focus: l
    } = a, o = i === "anchor" ? s : l;
    Z.setSelection(e, {
      [i === "anchor" ? "anchor" : "focus"]: Mh(Mh({}, o), r)
    });
  }
}, EN = (t, e) => {
  var {
    selection: r
  } = t, n = {}, a = {};
  if (r) {
    for (var i in e)
      (i === "anchor" && e.anchor != null && !Ee.equals(e.anchor, r.anchor) || i === "focus" && e.focus != null && !Ee.equals(e.focus, r.focus) || i !== "anchor" && i !== "focus" && e[i] !== r[i]) && (n[i] = r[i], a[i] = e[i]);
    Object.keys(n).length > 0 && t.apply({
      type: "set_selection",
      properties: n,
      newProperties: a
    });
  }
}, CN = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  R.withoutNormalizing(e, () => {
    var {
      hanging: a = !1,
      voids: i = !1,
      mode: s = "lowest"
    } = n, {
      at: l,
      match: o,
      select: u
    } = n;
    if (Q.isNode(r) && (r = [r]), r.length !== 0) {
      var [c] = r;
      if (l || (l = kc(e), u = !0), u == null && (u = !1), G.isRange(l))
        if (a || (l = R.unhangRange(e, l, {
          voids: i
        })), G.isCollapsed(l))
          l = l.anchor;
        else {
          var [, f] = G.edges(l), p = R.pointRef(e, f);
          Z.delete(e, {
            at: l
          }), l = p.unref();
        }
      if (Ee.isPoint(l)) {
        o == null && (ie.isText(c) ? o = (D) => ie.isText(D) : e.isInline(c) ? o = (D) => ie.isText(D) || R.isInline(e, D) : o = (D) => ae.isElement(D) && R.isBlock(e, D));
        var [g] = R.nodes(e, {
          at: l.path,
          match: o,
          mode: s,
          voids: i
        });
        if (g) {
          var [, m] = g, d = R.pathRef(e, m), w = R.isEnd(e, l, m);
          Z.splitNodes(e, {
            at: l,
            match: o,
            mode: s,
            voids: i
          });
          var b = d.unref();
          l = w ? H.next(b) : b;
        } else
          return;
      }
      var O = H.parent(l), S = l[l.length - 1];
      if (!(!i && R.void(e, {
        at: O
      }))) {
        for (var B of r) {
          var T = O.concat(S);
          S++, e.apply({
            type: "insert_node",
            path: T,
            node: B
          }), l = H.next(l);
        }
        if (l = H.previous(l), u) {
          var A = R.end(e, l);
          A && Z.select(e, A);
        }
      }
    }
  });
}, DN = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  R.withoutNormalizing(e, () => {
    var {
      at: n = e.selection,
      mode: a = "lowest",
      voids: i = !1
    } = r, {
      match: s
    } = r;
    if (s == null && (s = H.isPath(n) ? Ca(e, n) : (B) => ae.isElement(B) && R.isBlock(e, B)), !!n) {
      var l = R.nodes(e, {
        at: n,
        match: s,
        mode: a,
        voids: i
      }), o = Array.from(l, (B) => {
        var [, T] = B;
        return R.pathRef(e, T);
      });
      for (var u of o) {
        var c = u.unref();
        if (c.length < 2)
          throw new Error("Cannot lift node at a path [".concat(c, "] because it has a depth of less than `2`."));
        var f = R.node(e, H.parent(c)), [p, g] = f, m = c[c.length - 1], {
          length: d
        } = p.children;
        if (d === 1) {
          var w = H.next(g);
          Z.moveNodes(e, {
            at: c,
            to: w,
            voids: i
          }), Z.removeNodes(e, {
            at: g,
            voids: i
          });
        } else if (m === 0)
          Z.moveNodes(e, {
            at: c,
            to: g,
            voids: i
          });
        else if (m === d - 1) {
          var b = H.next(g);
          Z.moveNodes(e, {
            at: c,
            to: b,
            voids: i
          });
        } else {
          var O = H.next(c), S = H.next(g);
          Z.splitNodes(e, {
            at: O,
            voids: i
          }), Z.moveNodes(e, {
            at: c,
            to: S,
            voids: i
          });
        }
      }
    }
  });
}, SN = ["text"], ON = ["children"], a0 = (t, e) => {
  if (ae.isElement(e)) {
    var r = e;
    return R.isVoid(t, e) ? !0 : r.children.length === 1 ? a0(t, r.children[0]) : !1;
  } else
    return !R.isEditor(e);
}, PN = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  R.withoutNormalizing(e, () => {
    var {
      match: n,
      at: a = e.selection
    } = r, {
      hanging: i = !1,
      voids: s = !1,
      mode: l = "lowest"
    } = r;
    if (a) {
      if (n == null)
        if (H.isPath(a)) {
          var [o] = R.parent(e, a);
          n = (v) => o.children.includes(v);
        } else
          n = (v) => ae.isElement(v) && R.isBlock(e, v);
      if (!i && G.isRange(a) && (a = R.unhangRange(e, a, {
        voids: s
      })), G.isRange(a))
        if (G.isCollapsed(a))
          a = a.anchor;
        else {
          var [, u] = G.edges(a), c = R.pointRef(e, u);
          Z.delete(e, {
            at: a
          }), a = c.unref(), r.at == null && Z.select(e, a);
        }
      var [f] = R.nodes(e, {
        at: a,
        match: n,
        voids: s,
        mode: l
      }), p = R.previous(e, {
        at: a,
        match: n,
        voids: s,
        mode: l
      });
      if (!(!f || !p)) {
        var [g, m] = f, [d, w] = p;
        if (!(m.length === 0 || w.length === 0)) {
          var b = H.next(w), O = H.common(m, w), S = H.isSibling(m, w), B = Array.from(R.levels(e, {
            at: m
          }), (v) => {
            var [E] = v;
            return E;
          }).slice(O.length).slice(0, -1), T = R.above(e, {
            at: m,
            mode: "highest",
            match: (v) => B.includes(v) && a0(e, v)
          }), A = T && R.pathRef(e, T[1]), D, h;
          if (ie.isText(g) && ie.isText(d)) {
            var y = Sr(g, SN);
            h = d.text.length, D = y;
          } else if (ae.isElement(g) && ae.isElement(d)) {
            var y = Sr(g, ON);
            h = d.children.length, D = y;
          } else
            throw new Error("Cannot merge the node at path [".concat(m, "] with the previous sibling because it is not the same kind: ").concat(ot.stringify(g), " ").concat(ot.stringify(d)));
          S || Z.moveNodes(e, {
            at: m,
            to: b,
            voids: s
          }), A && Z.removeNodes(e, {
            at: A.current,
            voids: s
          }), ae.isElement(d) && R.isEmpty(e, d) || ie.isText(d) && d.text === "" && w[w.length - 1] !== 0 ? Z.removeNodes(e, {
            at: w,
            voids: s
          }) : e.apply({
            type: "merge_node",
            path: b,
            position: h,
            properties: D
          }), A && A.unref();
        }
      }
    }
  });
}, _N = (t, e) => {
  R.withoutNormalizing(t, () => {
    var {
      to: r,
      at: n = t.selection,
      mode: a = "lowest",
      voids: i = !1
    } = e, {
      match: s
    } = e;
    if (n) {
      s == null && (s = H.isPath(n) ? Ca(t, n) : (g) => ae.isElement(g) && R.isBlock(t, g));
      var l = R.pathRef(t, r), o = R.nodes(t, {
        at: n,
        match: s,
        mode: a,
        voids: i
      }), u = Array.from(o, (g) => {
        var [, m] = g;
        return R.pathRef(t, m);
      });
      for (var c of u) {
        var f = c.unref(), p = l.current;
        f.length !== 0 && t.apply({
          type: "move_node",
          path: f,
          newPath: p
        }), l.current && H.isSibling(p, f) && H.isAfter(p, f) && (l.current = H.next(l.current));
      }
      l.unref();
    }
  });
}, AN = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  R.withoutNormalizing(e, () => {
    var {
      hanging: n = !1,
      voids: a = !1,
      mode: i = "lowest"
    } = r, {
      at: s = e.selection,
      match: l
    } = r;
    if (s) {
      l == null && (l = H.isPath(s) ? Ca(e, s) : (g) => ae.isElement(g) && R.isBlock(e, g)), !n && G.isRange(s) && (s = R.unhangRange(e, s, {
        voids: a
      }));
      var o = R.nodes(e, {
        at: s,
        match: l,
        mode: i,
        voids: a
      }), u = Array.from(o, (g) => {
        var [, m] = g;
        return R.pathRef(e, m);
      });
      for (var c of u) {
        var f = c.unref();
        if (f) {
          var [p] = R.node(e, f);
          e.apply({
            type: "remove_node",
            path: f,
            node: p
          });
        }
      }
    }
  });
}, TN = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  R.withoutNormalizing(e, () => {
    var {
      match: a,
      at: i = e.selection,
      compare: s,
      merge: l
    } = n, {
      hanging: o = !1,
      mode: u = "lowest",
      split: c = !1,
      voids: f = !1
    } = n;
    if (i) {
      if (a == null && (a = H.isPath(i) ? Ca(e, i) : (h) => ae.isElement(h) && R.isBlock(e, h)), !o && G.isRange(i) && (i = R.unhangRange(e, i, {
        voids: f
      })), c && G.isRange(i)) {
        if (G.isCollapsed(i) && R.leaf(e, i.anchor)[0].text.length > 0)
          return;
        var p = R.rangeRef(e, i, {
          affinity: "inward"
        }), [g, m] = G.edges(i), d = u === "lowest" ? "lowest" : "highest", w = R.isEnd(e, m, m.path);
        Z.splitNodes(e, {
          at: m,
          match: a,
          mode: d,
          voids: f,
          always: !w
        });
        var b = R.isStart(e, g, g.path);
        Z.splitNodes(e, {
          at: g,
          match: a,
          mode: d,
          voids: f,
          always: !b
        }), i = p.unref(), n.at == null && Z.select(e, i);
      }
      s || (s = (h, y) => h !== y);
      for (var [O, S] of R.nodes(e, {
        at: i,
        match: a,
        mode: u,
        voids: f
      })) {
        var B = {}, T = {};
        if (S.length !== 0) {
          var A = !1;
          for (var D in r)
            D === "children" || D === "text" || s(r[D], O[D]) && (A = !0, O.hasOwnProperty(D) && (B[D] = O[D]), l ? r[D] != null && (T[D] = l(O[D], r[D])) : r[D] != null && (T[D] = r[D]));
          A && e.apply({
            type: "set_node",
            path: S,
            properties: B,
            newProperties: T
          });
        }
      }
    }
  });
}, BN = (t, e) => {
  if (G.isCollapsed(e))
    return e.anchor;
  var [, r] = G.edges(e), n = R.pointRef(t, r);
  return Z.delete(t, {
    at: e
  }), n.unref();
}, RN = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  R.withoutNormalizing(e, () => {
    var {
      mode: n = "lowest",
      voids: a = !1
    } = r, {
      match: i,
      at: s = e.selection,
      height: l = 0,
      always: o = !1
    } = r;
    if (i == null && (i = (F) => ae.isElement(F) && R.isBlock(e, F)), G.isRange(s) && (s = BN(e, s)), H.isPath(s)) {
      var u = s, c = R.point(e, u), [f] = R.parent(e, u);
      i = (F) => F === f, l = c.path.length - u.length + 1, s = c, o = !0;
    }
    if (s) {
      var p = R.pointRef(e, s, {
        affinity: "backward"
      }), g;
      try {
        var [m] = R.nodes(e, {
          at: s,
          match: i,
          mode: n,
          voids: a
        });
        if (!m)
          return;
        var d = R.void(e, {
          at: s,
          mode: "highest"
        }), w = 0;
        if (!a && d) {
          var [b, O] = d;
          if (ae.isElement(b) && e.isInline(b)) {
            var S = R.after(e, O);
            if (!S) {
              var B = {
                text: ""
              }, T = H.next(O);
              Z.insertNodes(e, B, {
                at: T,
                voids: a
              }), S = R.point(e, T);
            }
            s = S, o = !0;
          }
          var A = s.path.length - O.length;
          l = A + 1, o = !0;
        }
        g = R.pointRef(e, s);
        var D = s.path.length - l, [, h] = m, y = s.path.slice(0, D), v = l === 0 ? s.offset : s.path[D] + w;
        for (var [E, _] of R.levels(e, {
          at: y,
          reverse: !0,
          voids: a
        })) {
          var C = !1;
          if (_.length < h.length || _.length === 0 || !a && ae.isElement(E) && R.isVoid(e, E))
            break;
          var P = p.current, $ = R.isEnd(e, P, _);
          if (o || !p || !R.isEdge(e, P, _)) {
            C = !0;
            var W = Q.extractProps(E);
            e.apply({
              type: "split_node",
              path: _,
              position: v,
              properties: W
            });
          }
          v = _[_.length - 1] + (C || $ ? 1 : 0);
        }
        if (r.at == null) {
          var j = g.current || R.end(e, []);
          Z.select(e, j);
        }
      } finally {
        var I;
        p.unref(), (I = g) === null || I === void 0 || I.unref();
      }
    }
  });
}, $N = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Array.isArray(r) || (r = [r]);
  var a = {};
  for (var i of r)
    a[i] = null;
  Z.setNodes(e, a, n);
}, MN = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  R.withoutNormalizing(e, () => {
    var {
      mode: n = "lowest",
      split: a = !1,
      voids: i = !1
    } = r, {
      at: s = e.selection,
      match: l
    } = r;
    if (s) {
      l == null && (l = H.isPath(s) ? Ca(e, s) : (g) => ae.isElement(g) && R.isBlock(e, g)), H.isPath(s) && (s = R.range(e, s));
      var o = G.isRange(s) ? R.rangeRef(e, s) : null, u = R.nodes(e, {
        at: s,
        match: l,
        mode: n,
        voids: i
      }), c = Array.from(
        u,
        (g) => {
          var [, m] = g;
          return R.pathRef(e, m);
        }
        // unwrapNode will call liftNode which does not support splitting the node when nested.
        // If we do not reverse the order and call it from top to the bottom, it will remove all blocks
        // that wrap target node. So we reverse the order.
      ).reverse(), f = function(m) {
        var d = m.unref(), [w] = R.node(e, d), b = R.range(e, d);
        a && o && (b = G.intersection(o.current, b)), Z.liftNodes(e, {
          at: b,
          match: (O) => ae.isAncestor(w) && w.children.includes(O),
          voids: i
        });
      };
      for (var p of c)
        f(p);
      o && o.unref();
    }
  });
};
function Fh(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ih(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Fh(Object(r), !0).forEach(function(n) {
      Ct(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Fh(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var FN = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  R.withoutNormalizing(e, () => {
    var {
      mode: a = "lowest",
      split: i = !1,
      voids: s = !1
    } = n, {
      match: l,
      at: o = e.selection
    } = n;
    if (o) {
      if (l == null && (H.isPath(o) ? l = Ca(e, o) : e.isInline(r) ? l = (b) => ae.isElement(b) && R.isInline(e, b) || ie.isText(b) : l = (b) => ae.isElement(b) && R.isBlock(e, b)), i && G.isRange(o)) {
        var [u, c] = G.edges(o), f = R.rangeRef(e, o, {
          affinity: "inward"
        });
        Z.splitNodes(e, {
          at: c,
          match: l,
          voids: s
        }), Z.splitNodes(e, {
          at: u,
          match: l,
          voids: s
        }), o = f.unref(), n.at == null && Z.select(e, o);
      }
      var p = Array.from(R.nodes(e, {
        at: o,
        match: e.isInline(r) ? (b) => ae.isElement(b) && R.isBlock(e, b) : (b) => R.isEditor(b),
        mode: "lowest",
        voids: s
      }));
      for (var [, g] of p) {
        var m = G.isRange(o) ? G.intersection(o, R.range(e, g)) : o;
        if (m) {
          var d = Array.from(R.nodes(e, {
            at: m,
            match: l,
            mode: a,
            voids: s
          }));
          if (d.length > 0) {
            var w = function() {
              var [b] = d, O = d[d.length - 1], [, S] = b, [, B] = O;
              if (S.length === 0 && B.length === 0)
                return "continue";
              var T = H.equals(S, B) ? H.parent(S) : H.common(S, B), A = R.range(e, S, B), D = R.node(e, T), [h] = D, y = T.length + 1, v = H.next(B.slice(0, y)), E = Ih(Ih({}, r), {}, {
                children: []
              });
              Z.insertNodes(e, E, {
                at: v,
                voids: s
              }), Z.moveNodes(e, {
                at: A,
                match: (_) => ae.isAncestor(h) && h.children.includes(_),
                to: v.concat(0),
                voids: s
              });
            }();
            if (w === "continue")
              continue;
          }
        }
      }
    }
  });
}, IN = () => {
  var t = {
    children: [],
    operations: [],
    selection: null,
    marks: null,
    isElementReadOnly: () => !1,
    isInline: () => !1,
    isSelectable: () => !0,
    isVoid: () => !1,
    markableVoid: () => !1,
    onChange: () => {
    },
    // Core
    apply: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return ok(t, ...n);
    },
    // Editor
    addMark: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return pk(t, ...n);
    },
    deleteBackward: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return vk(t, ...n);
    },
    deleteForward: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return mk(t, ...n);
    },
    deleteFragment: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return yk(t, ...n);
    },
    getFragment: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return uk(t, ...n);
    },
    insertBreak: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Ak(t, ...n);
    },
    insertSoftBreak: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Bk(t, ...n);
    },
    insertFragment: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return vN(t, ...n);
    },
    insertNode: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Tk(t, ...n);
    },
    insertText: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return $k(t, ...n);
    },
    normalizeNode: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return ck(t, ...n);
    },
    removeMark: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return uN(t, ...n);
    },
    getDirtyPaths: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return lk(t, ...n);
    },
    shouldNormalize: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return fk(t, ...n);
    },
    // Editor interface
    above: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return dk(t, ...n);
    },
    after: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return hk(t, ...n);
    },
    before: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return gk(t, ...n);
    },
    collapse: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return mN(t, ...n);
    },
    delete: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return gN(t, ...n);
    },
    deselect: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return yN(t, ...n);
    },
    edges: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return bk(t, ...n);
    },
    elementReadOnly: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return wk(t, ...n);
    },
    end: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return xk(t, ...n);
    },
    first: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Ek(t, ...n);
    },
    fragment: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Ck(t, ...n);
    },
    getMarks: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Vk(t, ...n);
    },
    hasBlocks: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Sk(t, ...n);
    },
    hasInlines: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Ok(t, ...n);
    },
    hasPath: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Pk(t, ...n);
    },
    hasTexts: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return _k(t, ...n);
    },
    insertNodes: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return CN(t, ...n);
    },
    isBlock: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Mk(t, ...n);
    },
    isEdge: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Fk(t, ...n);
    },
    isEmpty: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Ik(t, ...n);
    },
    isEnd: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return jk(t, ...n);
    },
    isNormalizing: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Lk(t, ...n);
    },
    isStart: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return kk(t, ...n);
    },
    last: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Nk(t, ...n);
    },
    leaf: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return zk(t, ...n);
    },
    levels: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Wk(t, ...n);
    },
    liftNodes: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return DN(t, ...n);
    },
    mergeNodes: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return PN(t, ...n);
    },
    move: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return bN(t, ...n);
    },
    moveNodes: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return _N(t, ...n);
    },
    next: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return qk(t, ...n);
    },
    node: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Gk(t, ...n);
    },
    nodes: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Yk(t, ...n);
    },
    normalize: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Kk(t, ...n);
    },
    parent: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Xk(t, ...n);
    },
    path: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Qk(t, ...n);
    },
    pathRef: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Zk(t, ...n);
    },
    pathRefs: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Jk(t, ...n);
    },
    point: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return rN(t, ...n);
    },
    pointRef: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return eN(t, ...n);
    },
    pointRefs: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return tN(t, ...n);
    },
    positions: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return nN(t, ...n);
    },
    previous: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return aN(t, ...n);
    },
    range: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return oN(t, ...n);
    },
    rangeRef: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return iN(t, ...n);
    },
    rangeRefs: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return sN(t, ...n);
    },
    removeNodes: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return AN(t, ...n);
    },
    select: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return wN(t, ...n);
    },
    setNodes: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return TN(t, ...n);
    },
    setNormalizing: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return cN(t, ...n);
    },
    setPoint: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return xN(t, ...n);
    },
    setSelection: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return EN(t, ...n);
    },
    splitNodes: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return RN(t, ...n);
    },
    start: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return fN(t, ...n);
    },
    string: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return dN(t, ...n);
    },
    unhangRange: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return pN(t, ...n);
    },
    unsetNodes: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return $N(t, ...n);
    },
    unwrapNodes: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return MN(t, ...n);
    },
    void: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return Dk(t, ...n);
    },
    withoutNormalizing: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return hN(t, ...n);
    },
    wrapNodes: function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return FN(t, ...n);
    }
  };
  return t;
}, jN = {
  /**
   * Check if a value is a `History` object.
   */
  isHistory(t) {
    return ct(t) && Array.isArray(t.redos) && Array.isArray(t.undos) && (t.redos.length === 0 || kr.isOperationList(t.redos[0].operations)) && (t.undos.length === 0 || kr.isOperationList(t.undos[0].operations));
  }
}, Qo = /* @__PURE__ */ new WeakMap(), el = /* @__PURE__ */ new WeakMap(), ta = {
  /**
   * Check if a value is a `HistoryEditor` object.
   */
  isHistoryEditor(t) {
    return jN.isHistory(t.history) && R.isEditor(t);
  },
  /**
   * Get the merge flag's current value.
   */
  isMerging(t) {
    return el.get(t);
  },
  /**
   * Get the saving flag's current value.
   */
  isSaving(t) {
    return Qo.get(t);
  },
  /**
   * Redo to the previous saved state.
   */
  redo(t) {
    t.redo();
  },
  /**
   * Undo to the previous saved state.
   */
  undo(t) {
    t.undo();
  },
  /**
   * Apply a series of changes inside a synchronous `fn`, without merging any of
   * the new operations into previous save point in the history.
   */
  withoutMerging(t, e) {
    var r = ta.isMerging(t);
    el.set(t, !1), e(), el.set(t, r);
  },
  /**
   * Apply a series of changes inside a synchronous `fn`, without saving any of
   * their operations into the history.
   */
  withoutSaving(t, e) {
    var r = ta.isSaving(t);
    Qo.set(t, !1), e(), Qo.set(t, r);
  }
}, LN = (t) => {
  var e = t, {
    apply: r
  } = e;
  return e.history = {
    undos: [],
    redos: []
  }, e.redo = () => {
    var {
      history: n
    } = e, {
      redos: a
    } = n;
    if (a.length > 0) {
      var i = a[a.length - 1];
      i.selectionBefore && Z.setSelection(e, i.selectionBefore), ta.withoutSaving(e, () => {
        R.withoutNormalizing(e, () => {
          for (var s of i.operations)
            e.apply(s);
        });
      }), n.redos.pop(), e.writeHistory("undos", i);
    }
  }, e.undo = () => {
    var {
      history: n
    } = e, {
      undos: a
    } = n;
    if (a.length > 0) {
      var i = a[a.length - 1];
      ta.withoutSaving(e, () => {
        R.withoutNormalizing(e, () => {
          var s = i.operations.map(kr.inverse).reverse();
          for (var l of s)
            e.apply(l);
          i.selectionBefore && Z.setSelection(e, i.selectionBefore);
        });
      }), e.writeHistory("redos", i), n.undos.pop();
    }
  }, e.apply = (n) => {
    var {
      operations: a,
      history: i
    } = e, {
      undos: s
    } = i, l = s[s.length - 1], o = l && l.operations[l.operations.length - 1], u = ta.isSaving(e), c = ta.isMerging(e);
    if (u == null && (u = NN(n)), u) {
      if (c == null && (l == null ? c = !1 : a.length !== 0 ? c = !0 : c = kN(n, o)), l && c)
        l.operations.push(n);
      else {
        var f = {
          operations: [n],
          selectionBefore: e.selection
        };
        e.writeHistory("undos", f);
      }
      for (; s.length > 100; )
        s.shift();
      i.redos = [];
    }
    r(n);
  }, e.writeHistory = (n, a) => {
    e.history[n].push(a);
  }, e;
}, kN = (t, e) => !!(e && t.type === "insert_text" && e.type === "insert_text" && t.offset === e.offset + e.text.length && H.equals(t.path, e.path) || e && t.type === "remove_text" && e.type === "remove_text" && t.offset + t.text.length === e.offset && H.equals(t.path, e.path)), NN = (t, e) => t.type !== "set_selection", zN = UN, i0 = "֑-߿יִ-﷽ﹰ-ﻼ", s0 = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ࠀ-῿‎Ⰰ-﬜︀-﹯﻽-￿", WN = new RegExp("^[^" + s0 + "]*[" + i0 + "]"), HN = new RegExp("^[^" + i0 + "]*[" + s0 + "]");
function UN(t) {
  return t = String(t || ""), WN.test(t) ? "rtl" : HN.test(t) ? "ltr" : "neutral";
}
const o0 = /* @__PURE__ */ Ei(zN);
var VN = er, qN = function() {
  return VN.Date.now();
}, GN = qN, YN = /\s/;
function KN(t) {
  for (var e = t.length; e-- && YN.test(t.charAt(e)); )
    ;
  return e;
}
var XN = KN, ZN = XN, JN = /^\s+/;
function QN(t) {
  return t && t.slice(0, ZN(t) + 1).replace(JN, "");
}
var e9 = QN, t9 = e9, jh = _r, r9 = Gs, Lh = 0 / 0, n9 = /^[-+]0x[0-9a-f]+$/i, a9 = /^0b[01]+$/i, i9 = /^0o[0-7]+$/i, s9 = parseInt;
function o9(t) {
  if (typeof t == "number")
    return t;
  if (r9(t))
    return Lh;
  if (jh(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = jh(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = t9(t);
  var r = a9.test(t);
  return r || i9.test(t) ? s9(t.slice(2), r ? 2 : 8) : n9.test(t) ? Lh : +t;
}
var l9 = o9, u9 = _r, tl = GN, kh = l9, c9 = "Expected a function", f9 = Math.max, d9 = Math.min;
function p9(t, e, r) {
  var n, a, i, s, l, o, u = 0, c = !1, f = !1, p = !0;
  if (typeof t != "function")
    throw new TypeError(c9);
  e = kh(e) || 0, u9(r) && (c = !!r.leading, f = "maxWait" in r, i = f ? f9(kh(r.maxWait) || 0, e) : i, p = "trailing" in r ? !!r.trailing : p);
  function g(A) {
    var D = n, h = a;
    return n = a = void 0, u = A, s = t.apply(h, D), s;
  }
  function m(A) {
    return u = A, l = setTimeout(b, e), c ? g(A) : s;
  }
  function d(A) {
    var D = A - o, h = A - u, y = e - D;
    return f ? d9(y, i - h) : y;
  }
  function w(A) {
    var D = A - o, h = A - u;
    return o === void 0 || D >= e || D < 0 || f && h >= i;
  }
  function b() {
    var A = tl();
    if (w(A))
      return O(A);
    l = setTimeout(b, d(A));
  }
  function O(A) {
    return l = void 0, p && n ? g(A) : (n = a = void 0, s);
  }
  function S() {
    l !== void 0 && clearTimeout(l), u = 0, n = o = a = l = void 0;
  }
  function B() {
    return l === void 0 ? s : O(tl());
  }
  function T() {
    var A = tl(), D = w(A);
    if (n = arguments, a = this, o = A, D) {
      if (l === void 0)
        return m(o);
      if (f)
        return clearTimeout(l), l = setTimeout(b, e), g(o);
    }
    return l === void 0 && (l = setTimeout(b, e)), s;
  }
  return T.cancel = S, T.flush = B, T;
}
var l0 = p9;
const h9 = /* @__PURE__ */ Ei(l0);
var g9 = l0, v9 = _r, m9 = "Expected a function";
function y9(t, e, r) {
  var n = !0, a = !0;
  if (typeof t != "function")
    throw new TypeError(m9);
  return v9(r) && (n = "leading" in r ? !!r.leading : n, a = "trailing" in r ? !!r.trailing : a), g9(t, e, {
    leading: n,
    maxWait: e,
    trailing: a
  });
}
var b9 = y9;
const w9 = /* @__PURE__ */ Ei(b9);
function Nh(t) {
  return typeof t == "object" && t != null && t.nodeType === 1;
}
function zh(t, e) {
  return (!e || t !== "hidden") && t !== "visible" && t !== "clip";
}
function rl(t, e) {
  if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
    var r = getComputedStyle(t, null);
    return zh(r.overflowY, e) || zh(r.overflowX, e) || function(n) {
      var a = function(i) {
        if (!i.ownerDocument || !i.ownerDocument.defaultView)
          return null;
        try {
          return i.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      }(n);
      return !!a && (a.clientHeight < n.scrollHeight || a.clientWidth < n.scrollWidth);
    }(t);
  }
  return !1;
}
function Yi(t, e, r, n, a, i, s, l) {
  return i < t && s > e || i > t && s < e ? 0 : i <= t && l <= r || s >= e && l >= r ? i - t - n : s > e && l < r || i < t && l > r ? s - e + a : 0;
}
var Wh = function(t, e) {
  var r = window, n = e.scrollMode, a = e.block, i = e.inline, s = e.boundary, l = e.skipOverflowHiddenElements, o = typeof s == "function" ? s : function(be) {
    return be !== s;
  };
  if (!Nh(t))
    throw new TypeError("Invalid target");
  for (var u, c, f = document.scrollingElement || document.documentElement, p = [], g = t; Nh(g) && o(g); ) {
    if ((g = (c = (u = g).parentElement) == null ? u.getRootNode().host || null : c) === f) {
      p.push(g);
      break;
    }
    g != null && g === document.body && rl(g) && !rl(document.documentElement) || g != null && rl(g, l) && p.push(g);
  }
  for (var m = r.visualViewport ? r.visualViewport.width : innerWidth, d = r.visualViewport ? r.visualViewport.height : innerHeight, w = window.scrollX || pageXOffset, b = window.scrollY || pageYOffset, O = t.getBoundingClientRect(), S = O.height, B = O.width, T = O.top, A = O.right, D = O.bottom, h = O.left, y = a === "start" || a === "nearest" ? T : a === "end" ? D : T + S / 2, v = i === "center" ? h + B / 2 : i === "end" ? A : h, E = [], _ = 0; _ < p.length; _++) {
    var C = p[_], P = C.getBoundingClientRect(), $ = P.height, W = P.width, j = P.top, I = P.right, F = P.bottom, k = P.left;
    if (n === "if-needed" && T >= 0 && h >= 0 && D <= d && A <= m && T >= j && D <= F && h >= k && A <= I)
      return E;
    var N = getComputedStyle(C), U = parseInt(N.borderLeftWidth, 10), Y = parseInt(N.borderTopWidth, 10), L = parseInt(N.borderRightWidth, 10), q = parseInt(N.borderBottomWidth, 10), V = 0, X = 0, te = "offsetWidth" in C ? C.offsetWidth - C.clientWidth - U - L : 0, re = "offsetHeight" in C ? C.offsetHeight - C.clientHeight - Y - q : 0, ue = "offsetWidth" in C ? C.offsetWidth === 0 ? 0 : W / C.offsetWidth : 0, pe = "offsetHeight" in C ? C.offsetHeight === 0 ? 0 : $ / C.offsetHeight : 0;
    if (f === C)
      V = a === "start" ? y : a === "end" ? y - d : a === "nearest" ? Yi(b, b + d, d, Y, q, b + y, b + y + S, S) : y - d / 2, X = i === "start" ? v : i === "center" ? v - m / 2 : i === "end" ? v - m : Yi(w, w + m, m, U, L, w + v, w + v + B, B), V = Math.max(0, V + b), X = Math.max(0, X + w);
    else {
      V = a === "start" ? y - j - Y : a === "end" ? y - F + q + re : a === "nearest" ? Yi(j, F, $, Y, q + re, y, y + S, S) : y - (j + $ / 2) + re / 2, X = i === "start" ? v - k - U : i === "center" ? v - (k + W / 2) + te / 2 : i === "end" ? v - I + L + te : Yi(k, I, W, U, L + te, v, v + B, B);
      var ye = C.scrollLeft, Ce = C.scrollTop;
      y += Ce - (V = Math.max(0, Math.min(Ce + V / pe, C.scrollHeight - $ / pe + re))), v += ye - (X = Math.max(0, Math.min(ye + X / ue, C.scrollWidth - W / ue + te)));
    }
    E.push({ el: C, top: V, left: X });
  }
  return E;
};
function u0(t) {
  return t === Object(t) && Object.keys(t).length !== 0;
}
function x9(t, e) {
  e === void 0 && (e = "auto");
  var r = "scrollBehavior" in document.body.style;
  t.forEach(function(n) {
    var a = n.el, i = n.top, s = n.left;
    a.scroll && r ? a.scroll({
      top: i,
      left: s,
      behavior: e
    }) : (a.scrollTop = i, a.scrollLeft = s);
  });
}
function E9(t) {
  return t === !1 ? {
    block: "end",
    inline: "nearest"
  } : u0(t) ? t : {
    block: "start",
    inline: "nearest"
  };
}
function C9(t, e) {
  var r = t.isConnected || t.ownerDocument.documentElement.contains(t);
  if (u0(e) && typeof e.behavior == "function")
    return e.behavior(r ? Wh(t, e) : []);
  if (r) {
    var n = E9(e);
    return x9(Wh(t, n), n.behavior);
  }
}
var sn = [], D9 = function() {
  return sn.some(function(t) {
    return t.activeTargets.length > 0;
  });
}, S9 = function() {
  return sn.some(function(t) {
    return t.skippedTargets.length > 0;
  });
}, Hh = "ResizeObserver loop completed with undelivered notifications.", O9 = function() {
  var t;
  typeof ErrorEvent == "function" ? t = new ErrorEvent("error", {
    message: Hh
  }) : (t = document.createEvent("Event"), t.initEvent("error", !1, !1), t.message = Hh), window.dispatchEvent(t);
}, pi;
(function(t) {
  t.BORDER_BOX = "border-box", t.CONTENT_BOX = "content-box", t.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
})(pi || (pi = {}));
var on = function(t) {
  return Object.freeze(t);
}, P9 = function() {
  function t(e, r) {
    this.inlineSize = e, this.blockSize = r, on(this);
  }
  return t;
}(), c0 = function() {
  function t(e, r, n, a) {
    return this.x = e, this.y = r, this.width = n, this.height = a, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, on(this);
  }
  return t.prototype.toJSON = function() {
    var e = this, r = e.x, n = e.y, a = e.top, i = e.right, s = e.bottom, l = e.left, o = e.width, u = e.height;
    return { x: r, y: n, top: a, right: i, bottom: s, left: l, width: o, height: u };
  }, t.fromRect = function(e) {
    return new t(e.x, e.y, e.width, e.height);
  }, t;
}(), Wc = function(t) {
  return t instanceof SVGElement && "getBBox" in t;
}, f0 = function(t) {
  if (Wc(t)) {
    var e = t.getBBox(), r = e.width, n = e.height;
    return !r && !n;
  }
  var a = t, i = a.offsetWidth, s = a.offsetHeight;
  return !(i || s || t.getClientRects().length);
}, Uh = function(t) {
  var e;
  if (t instanceof Element)
    return !0;
  var r = (e = t == null ? void 0 : t.ownerDocument) === null || e === void 0 ? void 0 : e.defaultView;
  return !!(r && t instanceof r.Element);
}, _9 = function(t) {
  switch (t.tagName) {
    case "INPUT":
      if (t.type !== "image")
        break;
    case "VIDEO":
    case "AUDIO":
    case "EMBED":
    case "OBJECT":
    case "CANVAS":
    case "IFRAME":
    case "IMG":
      return !0;
  }
  return !1;
}, Qa = typeof window < "u" ? window : {}, Ki = /* @__PURE__ */ new WeakMap(), Vh = /auto|scroll/, A9 = /^tb|vertical/, T9 = /msie|trident/i.test(Qa.navigator && Qa.navigator.userAgent), ir = function(t) {
  return parseFloat(t || "0");
}, ia = function(t, e, r) {
  return t === void 0 && (t = 0), e === void 0 && (e = 0), r === void 0 && (r = !1), new P9((r ? e : t) || 0, (r ? t : e) || 0);
}, qh = on({
  devicePixelContentBoxSize: ia(),
  borderBoxSize: ia(),
  contentBoxSize: ia(),
  contentRect: new c0(0, 0, 0, 0)
}), d0 = function(t, e) {
  if (e === void 0 && (e = !1), Ki.has(t) && !e)
    return Ki.get(t);
  if (f0(t))
    return Ki.set(t, qh), qh;
  var r = getComputedStyle(t), n = Wc(t) && t.ownerSVGElement && t.getBBox(), a = !T9 && r.boxSizing === "border-box", i = A9.test(r.writingMode || ""), s = !n && Vh.test(r.overflowY || ""), l = !n && Vh.test(r.overflowX || ""), o = n ? 0 : ir(r.paddingTop), u = n ? 0 : ir(r.paddingRight), c = n ? 0 : ir(r.paddingBottom), f = n ? 0 : ir(r.paddingLeft), p = n ? 0 : ir(r.borderTopWidth), g = n ? 0 : ir(r.borderRightWidth), m = n ? 0 : ir(r.borderBottomWidth), d = n ? 0 : ir(r.borderLeftWidth), w = f + u, b = o + c, O = d + g, S = p + m, B = l ? t.offsetHeight - S - t.clientHeight : 0, T = s ? t.offsetWidth - O - t.clientWidth : 0, A = a ? w + O : 0, D = a ? b + S : 0, h = n ? n.width : ir(r.width) - A - T, y = n ? n.height : ir(r.height) - D - B, v = h + w + T + O, E = y + b + B + S, _ = on({
    devicePixelContentBoxSize: ia(Math.round(h * devicePixelRatio), Math.round(y * devicePixelRatio), i),
    borderBoxSize: ia(v, E, i),
    contentBoxSize: ia(h, y, i),
    contentRect: new c0(f, o, h, y)
  });
  return Ki.set(t, _), _;
}, p0 = function(t, e, r) {
  var n = d0(t, r), a = n.borderBoxSize, i = n.contentBoxSize, s = n.devicePixelContentBoxSize;
  switch (e) {
    case pi.DEVICE_PIXEL_CONTENT_BOX:
      return s;
    case pi.BORDER_BOX:
      return a;
    default:
      return i;
  }
}, B9 = function() {
  function t(e) {
    var r = d0(e);
    this.target = e, this.contentRect = r.contentRect, this.borderBoxSize = on([r.borderBoxSize]), this.contentBoxSize = on([r.contentBoxSize]), this.devicePixelContentBoxSize = on([r.devicePixelContentBoxSize]);
  }
  return t;
}(), h0 = function(t) {
  if (f0(t))
    return 1 / 0;
  for (var e = 0, r = t.parentNode; r; )
    e += 1, r = r.parentNode;
  return e;
}, R9 = function() {
  var t = 1 / 0, e = [];
  sn.forEach(function(s) {
    if (s.activeTargets.length !== 0) {
      var l = [];
      s.activeTargets.forEach(function(u) {
        var c = new B9(u.target), f = h0(u.target);
        l.push(c), u.lastReportedSize = p0(u.target, u.observedBox), f < t && (t = f);
      }), e.push(function() {
        s.callback.call(s.observer, l, s.observer);
      }), s.activeTargets.splice(0, s.activeTargets.length);
    }
  });
  for (var r = 0, n = e; r < n.length; r++) {
    var a = n[r];
    a();
  }
  return t;
}, Gh = function(t) {
  sn.forEach(function(r) {
    r.activeTargets.splice(0, r.activeTargets.length), r.skippedTargets.splice(0, r.skippedTargets.length), r.observationTargets.forEach(function(a) {
      a.isActive() && (h0(a.target) > t ? r.activeTargets.push(a) : r.skippedTargets.push(a));
    });
  });
}, $9 = function() {
  var t = 0;
  for (Gh(t); D9(); )
    t = R9(), Gh(t);
  return S9() && O9(), t > 0;
}, nl, g0 = [], M9 = function() {
  return g0.splice(0).forEach(function(t) {
    return t();
  });
}, F9 = function(t) {
  if (!nl) {
    var e = 0, r = document.createTextNode(""), n = { characterData: !0 };
    new MutationObserver(function() {
      return M9();
    }).observe(r, n), nl = function() {
      r.textContent = "".concat(e ? e-- : e++);
    };
  }
  g0.push(t), nl();
}, I9 = function(t) {
  F9(function() {
    requestAnimationFrame(t);
  });
}, is = 0, j9 = function() {
  return !!is;
}, L9 = 250, k9 = { attributes: !0, characterData: !0, childList: !0, subtree: !0 }, Yh = [
  "resize",
  "load",
  "transitionend",
  "animationend",
  "animationstart",
  "animationiteration",
  "keyup",
  "keydown",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout",
  "blur",
  "focus"
], Kh = function(t) {
  return t === void 0 && (t = 0), Date.now() + t;
}, al = !1, N9 = function() {
  function t() {
    var e = this;
    this.stopped = !0, this.listener = function() {
      return e.schedule();
    };
  }
  return t.prototype.run = function(e) {
    var r = this;
    if (e === void 0 && (e = L9), !al) {
      al = !0;
      var n = Kh(e);
      I9(function() {
        var a = !1;
        try {
          a = $9();
        } finally {
          if (al = !1, e = n - Kh(), !j9())
            return;
          a ? r.run(1e3) : e > 0 ? r.run(e) : r.start();
        }
      });
    }
  }, t.prototype.schedule = function() {
    this.stop(), this.run();
  }, t.prototype.observe = function() {
    var e = this, r = function() {
      return e.observer && e.observer.observe(document.body, k9);
    };
    document.body ? r() : Qa.addEventListener("DOMContentLoaded", r);
  }, t.prototype.start = function() {
    var e = this;
    this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), Yh.forEach(function(r) {
      return Qa.addEventListener(r, e.listener, !0);
    }));
  }, t.prototype.stop = function() {
    var e = this;
    this.stopped || (this.observer && this.observer.disconnect(), Yh.forEach(function(r) {
      return Qa.removeEventListener(r, e.listener, !0);
    }), this.stopped = !0);
  }, t;
}(), ru = new N9(), Xh = function(t) {
  !is && t > 0 && ru.start(), is += t, !is && ru.stop();
}, z9 = function(t) {
  return !Wc(t) && !_9(t) && getComputedStyle(t).display === "inline";
}, W9 = function() {
  function t(e, r) {
    this.target = e, this.observedBox = r || pi.CONTENT_BOX, this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }
  return t.prototype.isActive = function() {
    var e = p0(this.target, this.observedBox, !0);
    return z9(this.target) && (this.lastReportedSize = e), this.lastReportedSize.inlineSize !== e.inlineSize || this.lastReportedSize.blockSize !== e.blockSize;
  }, t;
}(), H9 = function() {
  function t(e, r) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = e, this.callback = r;
  }
  return t;
}(), Xi = /* @__PURE__ */ new WeakMap(), Zh = function(t, e) {
  for (var r = 0; r < t.length; r += 1)
    if (t[r].target === e)
      return r;
  return -1;
}, Zi = function() {
  function t() {
  }
  return t.connect = function(e, r) {
    var n = new H9(e, r);
    Xi.set(e, n);
  }, t.observe = function(e, r, n) {
    var a = Xi.get(e), i = a.observationTargets.length === 0;
    Zh(a.observationTargets, r) < 0 && (i && sn.push(a), a.observationTargets.push(new W9(r, n && n.box)), Xh(1), ru.schedule());
  }, t.unobserve = function(e, r) {
    var n = Xi.get(e), a = Zh(n.observationTargets, r), i = n.observationTargets.length === 1;
    a >= 0 && (i && sn.splice(sn.indexOf(n), 1), n.observationTargets.splice(a, 1), Xh(-1));
  }, t.disconnect = function(e) {
    var r = this, n = Xi.get(e);
    n.observationTargets.slice().forEach(function(a) {
      return r.unobserve(e, a.target);
    }), n.activeTargets.splice(0, n.activeTargets.length);
  }, t;
}(), U9 = function() {
  function t(e) {
    if (arguments.length === 0)
      throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    if (typeof e != "function")
      throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    Zi.connect(this, e);
  }
  return t.prototype.observe = function(e, r) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!Uh(e))
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    Zi.observe(this, e, r);
  }, t.prototype.unobserve = function(e) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!Uh(e))
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    Zi.unobserve(this, e);
  }, t.prototype.disconnect = function() {
    Zi.disconnect(this);
  }, t.toString = function() {
    return "function ResizeObserver () { [polyfill code] }";
  }, t;
}(), Br = {};
Object.defineProperty(Br, "__esModule", {
  value: !0
});
var V9 = typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), il = {
  alt: "altKey",
  control: "ctrlKey",
  meta: "metaKey",
  shift: "shiftKey"
}, q9 = {
  add: "+",
  break: "pause",
  cmd: "meta",
  command: "meta",
  ctl: "control",
  ctrl: "control",
  del: "delete",
  down: "arrowdown",
  esc: "escape",
  ins: "insert",
  left: "arrowleft",
  mod: V9 ? "meta" : "control",
  opt: "alt",
  option: "alt",
  return: "enter",
  right: "arrowright",
  space: " ",
  spacebar: " ",
  up: "arrowup",
  win: "meta",
  windows: "meta"
}, v0 = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  control: 17,
  alt: 18,
  pause: 19,
  capslock: 20,
  escape: 27,
  " ": 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  arrowleft: 37,
  arrowup: 38,
  arrowright: 39,
  arrowdown: 40,
  insert: 45,
  delete: 46,
  meta: 91,
  numlock: 144,
  scrolllock: 145,
  ";": 186,
  "=": 187,
  ",": 188,
  "-": 189,
  ".": 190,
  "/": 191,
  "`": 192,
  "[": 219,
  "\\": 220,
  "]": 221,
  "'": 222
};
for (var Ji = 1; Ji < 20; Ji++)
  v0["f" + Ji] = 111 + Ji;
function fo(t, e, r) {
  e && !("byKey" in e) && (r = e, e = null), Array.isArray(t) || (t = [t]);
  var n = t.map(function(s) {
    return m0(s, e);
  }), a = function(l) {
    return n.some(function(o) {
      return y0(o, l);
    });
  }, i = r == null ? a : a(r);
  return i;
}
function G9(t, e) {
  return fo(t, e);
}
function Y9(t, e) {
  return fo(t, { byKey: !0 }, e);
}
function m0(t, e) {
  var r = e && e.byKey, n = {};
  t = t.replace("++", "+add");
  var a = t.split("+"), i = a.length;
  for (var s in il)
    n[il[s]] = !1;
  var l = !0, o = !1, u = void 0;
  try {
    for (var c = a[Symbol.iterator](), f; !(l = (f = c.next()).done); l = !0) {
      var p = f.value, g = p.endsWith("?") && p.length > 1;
      g && (p = p.slice(0, -1));
      var m = Hc(p), d = il[m];
      (i === 1 || !d) && (r ? n.key = m : n.which = b0(p)), d && (n[d] = g ? null : !0);
    }
  } catch (w) {
    o = !0, u = w;
  } finally {
    try {
      !l && c.return && c.return();
    } finally {
      if (o)
        throw u;
    }
  }
  return n;
}
function y0(t, e) {
  for (var r in t) {
    var n = t[r], a = void 0;
    if (n != null && (r === "key" && e.key != null ? a = e.key.toLowerCase() : r === "which" ? a = n === 91 && e.which === 93 ? 91 : e.which : a = e[r], !(a == null && n === !1) && a !== n))
      return !1;
  }
  return !0;
}
function b0(t) {
  t = Hc(t);
  var e = v0[t] || t.toUpperCase().charCodeAt(0);
  return e;
}
function Hc(t) {
  return t = t.toLowerCase(), t = q9[t] || t, t;
}
Br.default = fo;
var sl = Br.isHotkey = fo;
Br.isCodeHotkey = G9;
Br.isKeyHotkey = Y9;
Br.parseHotkey = m0;
Br.compareHotkey = y0;
Br.toKeyCode = b0;
Br.toKeyName = Hc;
function po(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function K9(t, e) {
  if (t == null)
    return {};
  var r = {}, n = Object.keys(t), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(e.indexOf(a) >= 0) && (r[a] = t[a]);
  return r;
}
function la(t, e) {
  if (t == null)
    return {};
  var r = K9(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
var Uc = /* @__PURE__ */ Vt(null), Zr = () => {
  var t = Ht(Uc);
  if (!t)
    throw new Error("The `useSlateStatic` hook must be used inside the <Slate> component's context.");
  return t;
}, w0 = parseInt(M.version.split(".")[0], 10), X9 = typeof navigator < "u" && typeof window < "u" && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, Jh = typeof navigator < "u" && /Mac OS X/.test(navigator.userAgent), Pt = typeof navigator < "u" && /Android/.test(navigator.userAgent), ei = typeof navigator < "u" && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), qa = typeof navigator < "u" && /AppleWebKit(?!.*Chrome)/i.test(navigator.userAgent), Z9 = typeof navigator < "u" && /Edge?\/(?:[0-6][0-9]|[0-7][0-8])(?:\.)/i.test(navigator.userAgent), x0 = typeof navigator < "u" && /Chrome/i.test(navigator.userAgent), J9 = typeof navigator < "u" && /Chrome?\/(?:[0-7][0-5]|[0-6][0-9])(?:\.)/i.test(navigator.userAgent), Q9 = Pt && typeof navigator < "u" && /Chrome?\/(?:[0-5]?\d)(?:\.)/i.test(navigator.userAgent), e6 = typeof navigator < "u" && /^(?!.*Seamonkey)(?=.*Firefox\/(?:[0-7][0-9]|[0-8][0-6])(?:\.)).*/i.test(navigator.userAgent), t6 = typeof navigator < "u" && /.*UCBrowser/.test(navigator.userAgent), r6 = typeof navigator < "u" && /.*Wechat/.test(navigator.userAgent) && !/.*MacWechat/.test(navigator.userAgent), ss = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Mr = (!J9 || !Q9) && !Z9 && // globalThis is undefined in older browsers
typeof globalThis < "u" && globalThis.InputEvent && // @ts-ignore The `getTargetRanges` property isn't recognized.
typeof globalThis.InputEvent.prototype.getTargetRanges == "function", Vc = /* @__PURE__ */ new WeakMap(), qc = /* @__PURE__ */ new WeakMap(), E0 = /* @__PURE__ */ new WeakMap(), os = /* @__PURE__ */ new WeakMap(), nu = /* @__PURE__ */ new WeakMap(), hi = /* @__PURE__ */ new WeakMap(), ln = /* @__PURE__ */ new WeakMap(), au = /* @__PURE__ */ new WeakMap(), ho = /* @__PURE__ */ new WeakMap(), iu = /* @__PURE__ */ new WeakMap(), nn = /* @__PURE__ */ new WeakMap(), an = /* @__PURE__ */ new WeakMap(), ti = /* @__PURE__ */ new WeakMap(), su = /* @__PURE__ */ new WeakMap(), Gc = /* @__PURE__ */ new WeakMap(), Jt = /* @__PURE__ */ new WeakMap(), Cr = /* @__PURE__ */ new WeakMap(), Ot = /* @__PURE__ */ new WeakMap(), Ir = /* @__PURE__ */ new WeakMap(), jr = /* @__PURE__ */ new WeakMap(), C0 = /* @__PURE__ */ new WeakMap(), ua = Symbol("placeholder"), D0 = Symbol("mark-placeholder"), n6 = globalThis.Text, Yc = (t) => t && t.ownerDocument && t.ownerDocument.defaultView || null, a6 = (t) => qr(t) && t.nodeType === 8, Nt = (t) => qr(t) && t.nodeType === 1, qr = (t) => {
  var e = Yc(t);
  return !!e && t instanceof e.Node;
}, ou = (t) => {
  var e = t && t.anchorNode && Yc(t.anchorNode);
  return !!e && t instanceof e.Selection;
}, S0 = (t) => qr(t) && t.nodeType === 3, i6 = (t) => t.clipboardData && t.clipboardData.getData("text/plain") !== "" && t.clipboardData.types.length === 1, s6 = (t) => {
  var [e, r] = t;
  if (Nt(e) && e.childNodes.length) {
    var n = r === e.childNodes.length, a = n ? r - 1 : r;
    for ([e, a] = O0(e, a, n ? "backward" : "forward"), n = a < r; Nt(e) && e.childNodes.length; ) {
      var i = n ? e.childNodes.length - 1 : 0;
      e = l6(e, i, n ? "backward" : "forward");
    }
    r = n && e.textContent != null ? e.textContent.length : 0;
  }
  return [e, r];
}, o6 = (t) => {
  for (var e = t && t.parentNode; e; ) {
    if (e.toString() === "[object ShadowRoot]")
      return !0;
    e = e.parentNode;
  }
  return !1;
}, O0 = (t, e, r) => {
  for (var {
    childNodes: n
  } = t, a = n[e], i = e, s = !1, l = !1; (a6(a) || Nt(a) && a.childNodes.length === 0 || Nt(a) && a.getAttribute("contenteditable") === "false") && !(s && l); ) {
    if (i >= n.length) {
      s = !0, i = e - 1, r = "backward";
      continue;
    }
    if (i < 0) {
      l = !0, i = e + 1, r = "forward";
      continue;
    }
    a = n[i], e = i, i += r === "forward" ? 1 : -1;
  }
  return [a, e];
}, l6 = (t, e, r) => {
  var [n] = O0(t, e, r);
  return n;
}, P0 = (t) => {
  var e = "";
  if (S0(t) && t.nodeValue)
    return t.nodeValue;
  if (Nt(t)) {
    for (var r of Array.from(t.childNodes))
      e += P0(r);
    var n = getComputedStyle(t).getPropertyValue("display");
    (n === "block" || n === "list" || t.tagName === "BR") && (e += `
`);
  }
  return e;
}, u6 = /data-slate-fragment="(.+?)"/m, c6 = (t) => {
  var e = t.getData("text/html"), [, r] = e.match(u6) || [];
  return r;
}, Kc = (t, e, r) => {
  var {
    target: n
  } = e;
  if (Nt(n) && n.matches('[contentEditable="false"]'))
    return !1;
  var {
    document: a
  } = K.getWindow(t);
  if (a.contains(n))
    return K.hasDOMNode(t, n, {
      editable: !0
    });
  var i = r.find((s) => {
    var {
      addedNodes: l,
      removedNodes: o
    } = s;
    for (var u of l)
      if (u === n || u.contains(n))
        return !0;
    for (var c of o)
      if (c === n || c.contains(n))
        return !0;
  });
  return !i || i === e ? !1 : Kc(t, i, r);
}, f6 = 0;
class d6 {
  constructor() {
    this.id = "".concat(f6++);
  }
}
var K = {
  androidPendingDiffs: (t) => Ot.get(t),
  androidScheduleFlush: (t) => {
    var e;
    (e = Gc.get(t)) === null || e === void 0 || e();
  },
  blur: (t) => {
    var e = K.toDOMNode(t, t), r = K.findDocumentOrShadowRoot(t);
    nn.set(t, !1), r.activeElement === e && e.blur();
  },
  deselect: (t) => {
    var {
      selection: e
    } = t, r = K.findDocumentOrShadowRoot(t), n = r.getSelection();
    n && n.rangeCount > 0 && n.removeAllRanges(), e && Z.deselect(t);
  },
  findDocumentOrShadowRoot: (t) => {
    var e = K.toDOMNode(t, t), r = e.getRootNode();
    return (r instanceof Document || r instanceof ShadowRoot) && r.getSelection != null ? r : e.ownerDocument;
  },
  findEventRange: (t, e) => {
    "nativeEvent" in e && (e = e.nativeEvent);
    var {
      clientX: r,
      clientY: n,
      target: a
    } = e;
    if (r == null || n == null)
      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(e));
    var i = K.toSlateNode(t, e.target), s = K.findPath(t, i);
    if (ae.isElement(i) && R.isVoid(t, i)) {
      var l = a.getBoundingClientRect(), o = t.isInline(i) ? r - l.left < l.left + l.width - r : n - l.top < l.top + l.height - n, u = R.point(t, s, {
        edge: o ? "start" : "end"
      }), c = o ? R.before(t, u) : R.after(t, u);
      if (c) {
        var f = R.range(t, c);
        return f;
      }
    }
    var p, {
      document: g
    } = K.getWindow(t);
    if (g.caretRangeFromPoint)
      p = g.caretRangeFromPoint(r, n);
    else {
      var m = g.caretPositionFromPoint(r, n);
      m && (p = g.createRange(), p.setStart(m.offsetNode, m.offset), p.setEnd(m.offsetNode, m.offset));
    }
    if (!p)
      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(e));
    var d = K.toSlateRange(t, p, {
      exactMatch: !1,
      suppressThrow: !1
    });
    return d;
  },
  findKey: (t, e) => {
    var r = au.get(e);
    return r || (r = new d6(), au.set(e, r)), r;
  },
  findPath: (t, e) => {
    for (var r = [], n = e; ; ) {
      var a = qc.get(n);
      if (a == null) {
        if (R.isEditor(n))
          return r;
        break;
      }
      var i = Vc.get(n);
      if (i == null)
        break;
      r.unshift(i), n = a;
    }
    throw new Error("Unable to find the path for Slate node: ".concat(ot.stringify(e)));
  },
  focus: (t) => {
    var e = K.toDOMNode(t, t), r = K.findDocumentOrShadowRoot(t);
    nn.set(t, !0), r.activeElement !== e && e.focus({
      preventScroll: !0
    });
  },
  getWindow: (t) => {
    var e = E0.get(t);
    if (!e)
      throw new Error("Unable to find a host window element for this editor");
    return e;
  },
  hasDOMNode: function(e, r) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      editable: a = !1
    } = n, i = K.toDOMNode(e, e), s;
    try {
      s = Nt(r) ? r : r.parentElement;
    } catch (l) {
      if (!l.message.includes('Permission denied to access property "nodeType"'))
        throw l;
    }
    return s ? s.closest("[data-slate-editor]") === i && (!a || s.isContentEditable ? !0 : typeof s.isContentEditable == "boolean" && // isContentEditable exists only on HTMLElement, and on other nodes it will be undefined
    // this is the core logic that lets you know you got the right editor.selection instead of null when editor is contenteditable="false"(readOnly)
    s.closest('[contenteditable="false"]') === i || !!s.getAttribute("data-slate-zero-width")) : !1;
  },
  hasEditableTarget: (t, e) => qr(e) && K.hasDOMNode(t, e, {
    editable: !0
  }),
  hasRange: (t, e) => {
    var {
      anchor: r,
      focus: n
    } = e;
    return R.hasPath(t, r.path) && R.hasPath(t, n.path);
  },
  hasSelectableTarget: (t, e) => K.hasEditableTarget(t, e) || K.isTargetInsideNonReadonlyVoid(t, e),
  hasTarget: (t, e) => qr(e) && K.hasDOMNode(t, e),
  insertData: (t, e) => {
    t.insertData(e);
  },
  insertFragmentData: (t, e) => t.insertFragmentData(e),
  insertTextData: (t, e) => t.insertTextData(e),
  isComposing: (t) => !!an.get(t),
  isFocused: (t) => !!nn.get(t),
  isReadOnly: (t) => !!iu.get(t),
  isTargetInsideNonReadonlyVoid: (t, e) => {
    if (iu.get(t))
      return !1;
    var r = K.hasTarget(t, e) && K.toSlateNode(t, e);
    return ae.isElement(r) && R.isVoid(t, r);
  },
  setFragmentData: (t, e, r) => t.setFragmentData(e, r),
  toDOMNode: (t, e) => {
    var r = ho.get(t), n = R.isEditor(e) ? os.get(t) : r == null ? void 0 : r.get(K.findKey(t, e));
    if (!n)
      throw new Error("Cannot resolve a DOM node from Slate node: ".concat(ot.stringify(e)));
    return n;
  },
  toDOMPoint: (t, e) => {
    var [r] = R.node(t, e.path), n = K.toDOMNode(t, r), a;
    R.void(t, {
      at: e
    }) && (e = {
      path: e.path,
      offset: 0
    });
    for (var i = "[data-slate-string], [data-slate-zero-width]", s = Array.from(n.querySelectorAll(i)), l = 0, o = 0; o < s.length; o++) {
      var u = s[o], c = u.childNodes[0];
      if (!(c == null || c.textContent == null)) {
        var {
          length: f
        } = c.textContent, p = u.getAttribute("data-slate-length"), g = p == null ? f : parseInt(p, 10), m = l + g, d = s[o + 1];
        if (e.offset === m && d !== null && d !== void 0 && d.hasAttribute("data-slate-mark-placeholder")) {
          var w, b = d.childNodes[0];
          a = [
            // COMPAT: If we don't explicity set the dom point to be on the actual
            // dom text element, chrome will put the selection behind the actual dom
            // text element, causing domRange.getBoundingClientRect() calls on a collapsed
            // selection to return incorrect zero values (https://bugs.chromium.org/p/chromium/issues/detail?id=435438)
            // which will cause issues when scrolling to it.
            b instanceof n6 ? b : d,
            (w = d.textContent) !== null && w !== void 0 && w.startsWith("\uFEFF") ? 1 : 0
          ];
          break;
        }
        if (e.offset <= m) {
          var O = Math.min(f, Math.max(0, e.offset - l));
          a = [c, O];
          break;
        }
        l = m;
      }
    }
    if (!a)
      throw new Error("Cannot resolve a DOM point from Slate point: ".concat(ot.stringify(e)));
    return a;
  },
  toDOMRange: (t, e) => {
    var {
      anchor: r,
      focus: n
    } = e, a = G.isBackward(e), i = K.toDOMPoint(t, r), s = G.isCollapsed(e) ? i : K.toDOMPoint(t, n), l = K.getWindow(t), o = l.document.createRange(), [u, c] = a ? s : i, [f, p] = a ? i : s, g = Nt(u) ? u : u.parentElement, m = !!g.getAttribute("data-slate-zero-width"), d = Nt(f) ? f : f.parentElement, w = !!d.getAttribute("data-slate-zero-width");
    return o.setStart(u, m ? 1 : c), o.setEnd(f, w ? 1 : p), o;
  },
  toSlateNode: (t, e) => {
    var r = Nt(e) ? e : e.parentElement;
    r && !r.hasAttribute("data-slate-node") && (r = r.closest("[data-slate-node]"));
    var n = r ? hi.get(r) : null;
    if (!n)
      throw new Error("Cannot resolve a Slate node from DOM node: ".concat(r));
    return n;
  },
  toSlatePoint: (t, e, r) => {
    var {
      exactMatch: n,
      suppressThrow: a
    } = r, [i, s] = n ? e : s6(e), l = i.parentNode, o = null, u = 0;
    if (l) {
      var c, f, p = K.toDOMNode(t, t), g = l.closest('[data-slate-void="true"]'), m = g && p.contains(g) ? g : null, d = l.closest("[data-slate-leaf]"), w = null;
      if (d) {
        if (o = d.closest('[data-slate-node="text"]'), o) {
          var b = K.getWindow(t), O = b.document.createRange();
          O.setStart(o, 0), O.setEnd(i, s);
          var S = O.cloneContents(), B = [...Array.prototype.slice.call(S.querySelectorAll("[data-slate-zero-width]")), ...Array.prototype.slice.call(S.querySelectorAll("[contenteditable=false]"))];
          B.forEach((P) => {
            if (Pt && !n && P.hasAttribute("data-slate-zero-width") && P.textContent.length > 0 && P.textContext !== "\uFEFF") {
              P.textContent.startsWith("\uFEFF") && (P.textContent = P.textContent.slice(1));
              return;
            }
            P.parentNode.removeChild(P);
          }), u = S.textContent.length, w = o;
        }
      } else if (m) {
        for (var T = m.querySelectorAll("[data-slate-leaf]"), A = 0; A < T.length; A++) {
          var D = T[A];
          if (K.hasDOMNode(t, D)) {
            d = D;
            break;
          }
        }
        d ? (o = d.closest('[data-slate-node="text"]'), w = d, u = w.textContent.length, w.querySelectorAll("[data-slate-zero-width]").forEach((P) => {
          u -= P.textContent.length;
        })) : u = 1;
      }
      w && u === w.textContent.length && // COMPAT: Android IMEs might remove the zero width space while composing,
      // and we don't add it for line-breaks.
      Pt && w.getAttribute("data-slate-zero-width") === "z" && (c = w.textContent) !== null && c !== void 0 && c.startsWith("\uFEFF") && (l.hasAttribute("data-slate-zero-width") || ei && (f = w.textContent) !== null && f !== void 0 && f.endsWith(`

`)) && u--;
    }
    if (Pt && !o && !n) {
      var h = l.hasAttribute("data-slate-node") ? l : l.closest("[data-slate-node]");
      if (h && K.hasDOMNode(t, h, {
        editable: !0
      })) {
        var y = K.toSlateNode(t, h), {
          path: v,
          offset: E
        } = R.start(t, K.findPath(t, y));
        return h.querySelector("[data-slate-leaf]") || (E = s), {
          path: v,
          offset: E
        };
      }
    }
    if (!o) {
      if (a)
        return null;
      throw new Error("Cannot resolve a Slate point from DOM point: ".concat(e));
    }
    var _ = K.toSlateNode(t, o), C = K.findPath(t, _);
    return {
      path: C,
      offset: u
    };
  },
  toSlateRange: (t, e, r) => {
    var {
      exactMatch: n,
      suppressThrow: a
    } = r, i = ou(e) ? e.anchorNode : e.startContainer, s, l, o, u, c;
    if (i)
      if (ou(e)) {
        if (ei && e.rangeCount > 1) {
          o = e.focusNode;
          var f = e.getRangeAt(0), p = e.getRangeAt(e.rangeCount - 1);
          if (o instanceof HTMLTableRowElement && f.startContainer instanceof HTMLTableRowElement && p.startContainer instanceof HTMLTableRowElement) {
            let T = function(A) {
              return A.childElementCount > 0 ? T(A.children[0]) : A;
            };
            var g = f.startContainer, m = p.startContainer, d = T(g.children[f.startOffset]), w = T(m.children[p.startOffset]);
            u = 0, w.childNodes.length > 0 ? s = w.childNodes[0] : s = w, d.childNodes.length > 0 ? o = d.childNodes[0] : o = d, w instanceof HTMLElement ? l = w.innerHTML.length : l = 0;
          } else
            f.startContainer === o ? (s = p.endContainer, l = p.endOffset, u = f.startOffset) : (s = f.startContainer, l = f.endOffset, u = p.startOffset);
        } else
          s = e.anchorNode, l = e.anchorOffset, o = e.focusNode, u = e.focusOffset;
        x0 && o6(s) || ei ? c = e.anchorNode === e.focusNode && e.anchorOffset === e.focusOffset : c = e.isCollapsed;
      } else
        s = e.startContainer, l = e.startOffset, o = e.endContainer, u = e.endOffset, c = e.collapsed;
    if (s == null || o == null || l == null || u == null)
      throw new Error("Cannot resolve a Slate range from DOM range: ".concat(e));
    if ("getAttribute" in o && o.getAttribute("contenteditable") === "false" && o.getAttribute("data-slate-void") !== "true") {
      var b;
      o = s, u = ((b = s.textContent) === null || b === void 0 ? void 0 : b.length) || 0;
    }
    var O = K.toSlatePoint(t, [s, l], {
      exactMatch: n,
      suppressThrow: a
    });
    if (!O)
      return null;
    var S = c ? O : K.toSlatePoint(t, [o, u], {
      exactMatch: n,
      suppressThrow: a
    });
    if (!S)
      return null;
    var B = {
      anchor: O,
      focus: S
    };
    return G.isExpanded(B) && G.isForward(B) && Nt(o) && R.void(t, {
      at: B.focus,
      mode: "highest"
    }) && (B = R.unhangRange(t, B, {
      voids: !0
    })), B;
  }
};
function p6(t, e) {
  var {
    path: r,
    diff: n
  } = e;
  if (!R.hasPath(t, r))
    return !1;
  var a = Q.get(t, r);
  if (!ie.isText(a))
    return !1;
  if (n.start !== a.text.length || n.text.length === 0)
    return a.text.slice(n.start, n.start + n.text.length) === n.text;
  var i = H.next(r);
  if (!R.hasPath(t, i))
    return !1;
  var s = Q.get(t, i);
  return ie.isText(s) && s.text.startsWith(n.text);
}
function _0(t) {
  for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)
    r[n - 1] = arguments[n];
  return r.reduce((a, i) => a.slice(0, i.start) + i.text + a.slice(i.end), t);
}
function h6(t, e) {
  for (var r = Math.min(t.length, e.length), n = 0; n < r; n++)
    if (t.charAt(n) !== e.charAt(n))
      return n;
  return r;
}
function g6(t, e, r) {
  for (var n = Math.min(t.length, e.length, r), a = 0; a < n; a++)
    if (t.charAt(t.length - a - 1) !== e.charAt(e.length - a - 1))
      return a;
  return n;
}
function A0(t, e) {
  var {
    start: r,
    end: n,
    text: a
  } = e, i = t.slice(r, n), s = h6(i, a), l = Math.min(i.length - s, a.length - s), o = g6(i, a, l), u = {
    start: r + s,
    end: n - o,
    text: a.slice(s, a.length - o)
  };
  return u.start === u.end && u.text.length === 0 ? null : u;
}
function v6(t, e, r) {
  var n = Math.min(e.start, r.start), a = Math.max(0, Math.min(e.start + e.text.length, r.end) - r.start), i = _0(t, e, r), s = Math.max(r.start + r.text.length, e.start + e.text.length + (e.start + e.text.length > r.start ? r.text.length : 0) - a), l = i.slice(n, s), o = Math.max(e.end, r.end - e.text.length + (e.end - e.start));
  return A0(t, {
    start: n,
    end: o,
    text: l
  });
}
function m6(t) {
  var {
    path: e,
    diff: r
  } = t;
  return {
    anchor: {
      path: e,
      offset: r.start
    },
    focus: {
      path: e,
      offset: r.end
    }
  };
}
function lu(t, e) {
  var {
    path: r,
    offset: n
  } = e;
  if (!R.hasPath(t, r))
    return null;
  var a = Q.get(t, r);
  if (!ie.isText(a))
    return null;
  var i = R.above(t, {
    match: (l) => ae.isElement(l) && R.isBlock(t, l),
    at: r
  });
  if (!i)
    return null;
  for (; n > a.text.length; ) {
    var s = R.next(t, {
      at: r,
      match: ie.isText
    });
    if (!s || !H.isDescendant(s[1], i[1]))
      return null;
    n -= a.text.length, a = s[0], r = s[1];
  }
  return {
    path: r,
    offset: n
  };
}
function Qh(t, e) {
  var r = lu(t, e.anchor);
  if (!r)
    return null;
  if (G.isCollapsed(e))
    return {
      anchor: r,
      focus: r
    };
  var n = lu(t, e.focus);
  return n ? {
    anchor: r,
    focus: n
  } : null;
}
function uu(t, e, r) {
  var n = Ot.get(t), a = n == null ? void 0 : n.find((c) => {
    var {
      path: f
    } = c;
    return H.equals(f, e.path);
  });
  if (!a || e.offset <= a.diff.start)
    return Ee.transform(e, r, {
      affinity: "backward"
    });
  var {
    diff: i
  } = a;
  if (e.offset <= i.start + i.text.length) {
    var s = {
      path: e.path,
      offset: i.start
    }, l = Ee.transform(s, r, {
      affinity: "backward"
    });
    return l ? {
      path: l.path,
      offset: l.offset + e.offset - i.start
    } : null;
  }
  var o = {
    path: e.path,
    offset: e.offset - i.text.length + i.end - i.start
  }, u = Ee.transform(o, r, {
    affinity: "backward"
  });
  return u ? r.type === "split_node" && H.equals(r.path, e.path) && o.offset < r.position && i.start < r.position ? u : {
    path: u.path,
    offset: u.offset + i.text.length - i.end + i.start
  } : null;
}
function eg(t, e, r) {
  var n = uu(t, e.anchor, r);
  if (!n)
    return null;
  if (G.isCollapsed(e))
    return {
      anchor: n,
      focus: n
    };
  var a = uu(t, e.focus, r);
  return a ? {
    anchor: n,
    focus: a
  } : null;
}
function y6(t, e) {
  var {
    path: r,
    diff: n,
    id: a
  } = t;
  switch (e.type) {
    case "insert_text":
      return !H.equals(e.path, r) || e.offset >= n.end ? t : e.offset <= n.start ? {
        diff: {
          start: e.text.length + n.start,
          end: e.text.length + n.end,
          text: n.text
        },
        id: a,
        path: r
      } : {
        diff: {
          start: n.start,
          end: n.end + e.text.length,
          text: n.text
        },
        id: a,
        path: r
      };
    case "remove_text":
      return !H.equals(e.path, r) || e.offset >= n.end ? t : e.offset + e.text.length <= n.start ? {
        diff: {
          start: n.start - e.text.length,
          end: n.end - e.text.length,
          text: n.text
        },
        id: a,
        path: r
      } : {
        diff: {
          start: n.start,
          end: n.end - e.text.length,
          text: n.text
        },
        id: a,
        path: r
      };
    case "split_node":
      return !H.equals(e.path, r) || e.position >= n.end ? {
        diff: n,
        id: a,
        path: H.transform(r, e, {
          affinity: "backward"
        })
      } : e.position > n.start ? {
        diff: {
          start: n.start,
          end: Math.min(e.position, n.end),
          text: n.text
        },
        id: a,
        path: r
      } : {
        diff: {
          start: n.start - e.position,
          end: n.end - e.position,
          text: n.text
        },
        id: a,
        path: H.transform(r, e, {
          affinity: "forward"
        })
      };
    case "merge_node":
      return H.equals(e.path, r) ? {
        diff: {
          start: n.start + e.position,
          end: n.end + e.position,
          text: n.text
        },
        id: a,
        path: H.transform(r, e)
      } : {
        diff: n,
        id: a,
        path: H.transform(r, e)
      };
  }
  var i = H.transform(r, e);
  return i ? {
    diff: n,
    path: i,
    id: a
  } : null;
}
function tg(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Qi(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? tg(Object(r), !0).forEach(function(n) {
      po(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : tg(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var b6 = 25, w6 = 200, x6 = function() {
}, E6 = (t) => (t == null ? void 0 : t.constructor.name) === "DataTransfer";
function C6(t) {
  var {
    editor: e,
    scheduleOnDOMSelectionChange: r,
    onDOMSelectionChange: n
  } = t, a = !1, i = null, s = null, l = null, o = 0, u = !1, c = () => {
    var _ = jr.get(e);
    if (jr.delete(e), _) {
      var {
        selection: C
      } = e, P = Qh(e, _);
      P && (!C || !G.equals(P, C)) && Z.select(e, P);
    }
  }, f = () => {
    var _ = Ir.get(e);
    if (Ir.delete(e), !!_) {
      if (_.at) {
        var C = Ee.isPoint(_.at) ? lu(e, _.at) : Qh(e, _.at);
        if (!C)
          return;
        var P = R.range(e, C);
        (!e.selection || !G.equals(e.selection, P)) && Z.select(e, C);
      }
      _.run();
    }
  }, p = () => {
    if (s && (clearTimeout(s), s = null), l && (clearTimeout(l), l = null), !B() && !S()) {
      c();
      return;
    }
    a || (a = !0, setTimeout(() => a = !1)), S() && (a = "action");
    var _ = e.selection && R.rangeRef(e, e.selection, {
      affinity: "forward"
    });
    Cr.set(e, e.marks), x6("flush", Ir.get(e), Ot.get(e));
    for (var C = B(), P; P = ($ = Ot.get(e)) === null || $ === void 0 ? void 0 : $[0]; ) {
      var $, W, j = Jt.get(e);
      j !== void 0 && (Jt.delete(e), e.marks = j), j && u === !1 && (u = null);
      var I = m6(P);
      (!e.selection || !G.equals(e.selection, I)) && Z.select(e, I), P.diff.text ? R.insertText(e, P.diff.text) : R.deleteFragment(e), Ot.set(e, (W = Ot.get(e)) === null || W === void 0 ? void 0 : W.filter((N) => {
        var {
          id: U
        } = N;
        return U !== P.id;
      })), p6(e, P) || (C = !1, Ir.delete(e), Cr.delete(e), a = "action", jr.delete(e), r.cancel(), n.cancel(), _ == null || _.unref());
    }
    var F = _ == null ? void 0 : _.unref();
    if (F && !jr.get(e) && (!e.selection || !G.equals(F, e.selection)) && Z.select(e, F), S()) {
      f();
      return;
    }
    C && r(), r.flush(), n.flush(), c();
    var k = Cr.get(e);
    Cr.delete(e), k !== void 0 && (e.marks = k, e.onChange());
  }, g = (_) => {
    i && clearTimeout(i), i = setTimeout(() => {
      an.set(e, !1), p();
    }, b6);
  }, m = (_) => {
    an.set(e, !0), i && (clearTimeout(i), i = null);
  }, d = function() {
    var C = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, P = nu.get(e);
    if (P) {
      if (B() || C) {
        P.style.display = "none";
        return;
      }
      P.style.removeProperty("display");
    }
  }, w = (_, C) => {
    var P, $ = (P = Ot.get(e)) !== null && P !== void 0 ? P : [];
    Ot.set(e, $);
    var W = Q.leaf(e, _), j = $.findIndex((k) => H.equals(k.path, _));
    if (j < 0) {
      var I = A0(W.text, C);
      I && $.push({
        path: _,
        diff: C,
        id: o++
      }), d();
      return;
    }
    var F = v6(W.text, $[j].diff, C);
    if (!F) {
      $.splice(j, 1), d();
      return;
    }
    $[j] = Qi(Qi({}, $[j]), {}, {
      diff: F
    });
  }, b = function(C) {
    var {
      at: P
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    u = !1, jr.delete(e), r.cancel(), n.cancel(), S() && p(), Ir.set(e, {
      at: P,
      run: C
    }), l = setTimeout(p);
  }, O = (_) => {
    var C;
    s && (clearTimeout(s), s = null);
    var {
      inputType: P
    } = _, $ = null, W = _.dataTransfer || _.data || void 0;
    u !== !1 && P !== "insertText" && P !== "insertCompositionText" && (u = !1);
    var [j] = _.getTargetRanges();
    j && ($ = K.toSlateRange(e, j, {
      exactMatch: !1,
      suppressThrow: !0
    }));
    var I = K.getWindow(e), F = I.getSelection();
    if (!$ && F && (j = F, $ = K.toSlateRange(e, F, {
      exactMatch: !1,
      suppressThrow: !0
    })), $ = (C = $) !== null && C !== void 0 ? C : e.selection, !!$) {
      var k = !0;
      if (P.startsWith("delete")) {
        if (G.isExpanded($)) {
          var [N, U] = G.edges($), Y = Q.leaf(e, N.path);
          if (Y.text.length === N.offset && U.offset === 0) {
            var L = R.next(e, {
              at: N.path,
              match: ie.isText
            });
            L && H.equals(L[1], U.path) && ($ = {
              anchor: U,
              focus: U
            });
          }
        }
        var q = P.endsWith("Backward") ? "backward" : "forward", [V, X] = G.edges($), [te, re] = R.leaf(e, V.path), ue = {
          text: "",
          start: V.offset,
          end: X.offset
        }, pe = Ot.get(e), ye = pe == null ? void 0 : pe.find((Tt) => H.equals(Tt.path, re)), Ce = ye ? [ye.diff, ue] : [ue], be = _0(te.text, ...Ce);
        if (be.length === 0 && (k = !1), G.isExpanded($)) {
          if (k && H.equals($.anchor.path, $.focus.path)) {
            var Ie = {
              path: $.anchor.path,
              offset: V.offset
            }, Me = R.range(e, Ie, Ie);
            return D(Me), w($.anchor.path, {
              text: "",
              end: X.offset,
              start: V.offset
            });
          }
          return b(() => R.deleteFragment(e, {
            direction: q
          }), {
            at: $
          });
        }
      }
      switch (P) {
        case "deleteByComposition":
        case "deleteByCut":
        case "deleteByDrag":
          return b(() => R.deleteFragment(e), {
            at: $
          });
        case "deleteContent":
        case "deleteContentForward": {
          var {
            anchor: Ae
          } = $;
          if (k && G.isCollapsed($)) {
            var Be = Q.leaf(e, Ae.path);
            if (Ae.offset < Be.text.length)
              return w(Ae.path, {
                text: "",
                start: Ae.offset,
                end: Ae.offset + 1
              });
          }
          return b(() => R.deleteForward(e), {
            at: $
          });
        }
        case "deleteContentBackward": {
          var Ke, {
            anchor: st
          } = $, vt = ou(j) ? j.isCollapsed : !!((Ke = j) !== null && Ke !== void 0 && Ke.collapsed);
          return k && vt && G.isCollapsed($) && st.offset > 0 ? w(st.path, {
            text: "",
            start: st.offset - 1,
            end: st.offset
          }) : b(() => R.deleteBackward(e), {
            at: $
          });
        }
        case "deleteEntireSoftLine":
          return b(() => {
            R.deleteBackward(e, {
              unit: "line"
            }), R.deleteForward(e, {
              unit: "line"
            });
          }, {
            at: $
          });
        case "deleteHardLineBackward":
          return b(() => R.deleteBackward(e, {
            unit: "block"
          }), {
            at: $
          });
        case "deleteSoftLineBackward":
          return b(() => R.deleteBackward(e, {
            unit: "line"
          }), {
            at: $
          });
        case "deleteHardLineForward":
          return b(() => R.deleteForward(e, {
            unit: "block"
          }), {
            at: $
          });
        case "deleteSoftLineForward":
          return b(() => R.deleteForward(e, {
            unit: "line"
          }), {
            at: $
          });
        case "deleteWordBackward":
          return b(() => R.deleteBackward(e, {
            unit: "word"
          }), {
            at: $
          });
        case "deleteWordForward":
          return b(() => R.deleteForward(e, {
            unit: "word"
          }), {
            at: $
          });
        case "insertLineBreak":
          return b(() => R.insertSoftBreak(e), {
            at: $
          });
        case "insertParagraph":
          return b(() => R.insertBreak(e), {
            at: $
          });
        case "insertCompositionText":
        case "deleteCompositionText":
        case "insertFromComposition":
        case "insertFromDrop":
        case "insertFromPaste":
        case "insertFromYank":
        case "insertReplacementText":
        case "insertText": {
          if (E6(W))
            return b(() => K.insertData(e, W), {
              at: $
            });
          var je = W ?? "";
          if (Jt.get(e) && (je = je.replace("\uFEFF", "")), P === "insertText" && /.*\n.*\n$/.test(je) && (je = je.slice(0, -1)), je.includes(`
`))
            return b(() => {
              var Tt = je.split(`
`);
              Tt.forEach((ar, Jr) => {
                ar && R.insertText(e, ar), Jr !== Tt.length - 1 && R.insertSoftBreak(e);
              });
            }, {
              at: $
            });
          if (H.equals($.anchor.path, $.focus.path)) {
            var [lt, Dt] = G.edges($), Se = {
              start: lt.offset,
              end: Dt.offset,
              text: je
            };
            if (je && u && P === "insertCompositionText") {
              var St = u.start + u.text.search(/\S|$/), nr = Se.start + Se.text.search(/\S|$/);
              nr === St + 1 && Se.end === u.start + u.text.length ? (Se.start -= 1, u = null, v()) : u = !1;
            } else
              P === "insertText" ? u === null ? u = Se : u && G.isCollapsed($) && u.end + u.text.length === lt.offset ? u = Qi(Qi({}, u), {}, {
                text: u.text + je
              }) : u = !1 : u = !1;
            if (k) {
              w(lt.path, Se);
              return;
            }
          }
          return b(() => R.insertText(e, je), {
            at: $
          });
        }
      }
    }
  }, S = () => !!Ir.get(e), B = () => {
    var _;
    return !!((_ = Ot.get(e)) !== null && _ !== void 0 && _.length);
  }, T = () => S() || B(), A = () => a, D = (_) => {
    jr.set(e, _), s && (clearTimeout(s), s = null);
    var {
      selection: C
    } = e;
    if (_) {
      var P = !C || !H.equals(C.anchor.path, _.anchor.path), $ = !C || !H.equals(C.anchor.path.slice(0, -1), _.anchor.path.slice(0, -1));
      (P && u || $) && (u = !1), (P || B()) && (s = setTimeout(p, w6));
    }
  }, h = () => {
    (S() || !B()) && p();
  }, y = (_) => {
    B() || (d(!0), setTimeout(d));
  }, v = () => {
    S() || (l = setTimeout(p));
  }, E = (_) => {
    if (!(B() || S()) && _.some((P) => Kc(e, P, _))) {
      var C;
      (C = C0.get(e)) === null || C === void 0 || C();
    }
  };
  return {
    flush: p,
    scheduleFlush: v,
    hasPendingDiffs: B,
    hasPendingAction: S,
    hasPendingChanges: T,
    isFlushing: A,
    handleUserSelect: D,
    handleCompositionEnd: g,
    handleCompositionStart: m,
    handleDOMBeforeInput: O,
    handleKeyDown: y,
    handleDomMutations: E,
    handleInput: h
  };
}
function D6() {
  var t = de(!1);
  return xe(() => (t.current = !0, () => {
    t.current = !1;
  }), []), t.current;
}
var gi = ss ? rv : xe;
function S6(t, e, r) {
  var [n] = $e(() => new MutationObserver(e));
  gi(() => {
    n.takeRecords();
  }), xe(() => {
    if (!t.current)
      throw new Error("Failed to attach MutationObserver, `node` is undefined");
    return n.observe(t.current, r), () => n.disconnect();
  }, [n, t, r]);
}
var O6 = ["node"];
function rg(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function P6(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? rg(Object(r), !0).forEach(function(n) {
      po(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : rg(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var _6 = {
  subtree: !0,
  childList: !0,
  characterData: !0
}, A6 = Pt ? (t) => {
  var {
    node: e
  } = t, r = la(t, O6);
  if (!Pt)
    return null;
  var n = Zr(), a = D6(), [i] = $e(() => C6(P6({
    editor: n
  }, r)));
  return S6(e, i.handleDomMutations, _6), Gc.set(n, i.scheduleFlush), a && i.flush(), i;
} : () => null, T6 = ["anchor", "focus"], B6 = ["anchor", "focus"], R6 = (t, e) => Object.keys(t).length === Object.keys(e).length && Object.keys(t).every((r) => e.hasOwnProperty(r) && t[r] === e[r]), T0 = (t, e) => {
  var r = la(t, T6), n = la(e, B6);
  return t[ua] === e[ua] && R6(r, n);
}, $6 = (t, e) => {
  if (t.length !== e.length)
    return !1;
  for (var r = 0; r < t.length; r++) {
    var n = t[r], a = e[r];
    if (!G.equals(n, a) || !T0(n, a))
      return !1;
  }
  return !0;
}, M6 = (t, e) => {
  if (t.length !== e.length)
    return !1;
  for (var r = 0; r < t.length; r++) {
    var n = t[r], a = e[r];
    if (n.anchor.offset !== a.anchor.offset || n.focus.offset !== a.focus.offset || !T0(n, a))
      return !1;
  }
  return !0;
}, F6 = (t) => {
  var {
    isLast: e,
    leaf: r,
    parent: n,
    text: a
  } = t, i = Zr(), s = K.findPath(i, a), l = H.parent(s), o = r[D0] === !0;
  return i.isVoid(n) ? /* @__PURE__ */ M.createElement(ol, {
    length: Q.string(n).length
  }) : r.text === "" && n.children[n.children.length - 1] === a && !i.isInline(n) && R.string(i, l) === "" ? /* @__PURE__ */ M.createElement(ol, {
    isLineBreak: !0,
    isMarkPlaceholder: o
  }) : r.text === "" ? /* @__PURE__ */ M.createElement(ol, {
    isMarkPlaceholder: o
  }) : e && r.text.slice(-1) === `
` ? /* @__PURE__ */ M.createElement(ng, {
    isTrailing: !0,
    text: r.text
  }) : /* @__PURE__ */ M.createElement(ng, {
    text: r.text
  });
}, ng = (t) => {
  var {
    text: e,
    isTrailing: r = !1
  } = t, n = de(null), a = () => "".concat(e ?? "").concat(r ? `
` : ""), [i] = $e(a);
  return gi(() => {
    var s = a();
    n.current && n.current.textContent !== s && (n.current.textContent = s);
  }), /* @__PURE__ */ M.createElement(I6, {
    ref: n
  }, i);
}, I6 = /* @__PURE__ */ Gy(/* @__PURE__ */ hr((t, e) => /* @__PURE__ */ M.createElement("span", {
  "data-slate-string": !0,
  ref: e
}, t.children))), ol = (t) => {
  var {
    length: e = 0,
    isLineBreak: r = !1,
    isMarkPlaceholder: n = !1
  } = t, a = {
    "data-slate-zero-width": r ? "n" : "z",
    "data-slate-length": e
  };
  return n && (a["data-slate-mark-placeholder"] = !0), /* @__PURE__ */ M.createElement("span", Object.assign({}, a), !Pt || !r ? "\uFEFF" : null, r ? /* @__PURE__ */ M.createElement("br", null) : null);
};
function j6(t, e) {
  t.current && (t.current.disconnect(), e && (t.current = null));
}
function ag(t) {
  t.current && (clearTimeout(t.current), t.current = null);
}
var L6 = (t) => {
  var {
    leaf: e,
    isLast: r,
    text: n,
    parent: a,
    renderPlaceholder: i,
    renderLeaf: s = (O) => /* @__PURE__ */ M.createElement(N6, Object.assign({}, O))
  } = t, l = Zr(), o = de(null), u = de(null), [c, f] = $e(!1), p = de(null), g = oe((O) => {
    if (j6(o, O == null), O == null) {
      var S;
      nu.delete(l), (S = e.onPlaceholderResize) === null || S === void 0 || S.call(e, null);
    } else {
      if (nu.set(l, O), !o.current) {
        var B = window.ResizeObserver || U9;
        o.current = new B(() => {
          var T;
          (T = e.onPlaceholderResize) === null || T === void 0 || T.call(e, O);
        });
      }
      o.current.observe(O), u.current = O;
    }
  }, [u, e, l]), m = /* @__PURE__ */ M.createElement(F6, {
    isLast: r,
    leaf: e,
    parent: a,
    text: n
  }), d = e[ua];
  if (xe(() => (d ? p.current || (p.current = setTimeout(() => {
    f(!0), p.current = null;
  }, 300)) : (ag(p), f(!1)), () => ag(p)), [d, f]), d && c) {
    var w = {
      children: e.placeholder,
      attributes: {
        "data-slate-placeholder": !0,
        style: {
          position: "absolute",
          top: 0,
          pointerEvents: "none",
          width: "100%",
          maxWidth: "100%",
          display: "block",
          opacity: "0.333",
          userSelect: "none",
          textDecoration: "none",
          // Fixes https://github.com/udecode/plate/issues/2315
          WebkitUserModify: qa ? "inherit" : void 0
        },
        contentEditable: !1,
        ref: g
      }
    };
    m = /* @__PURE__ */ M.createElement(M.Fragment, null, i(w), m);
  }
  var b = {
    "data-slate-leaf": !0
  };
  return s({
    attributes: b,
    children: m,
    leaf: e,
    text: n
  });
}, k6 = /* @__PURE__ */ M.memo(L6, (t, e) => e.parent === t.parent && e.isLast === t.isLast && e.renderLeaf === t.renderLeaf && e.renderPlaceholder === t.renderPlaceholder && e.text === t.text && ie.equals(e.leaf, t.leaf) && e.leaf[ua] === t.leaf[ua]), N6 = (t) => {
  var {
    attributes: e,
    children: r
  } = t;
  return /* @__PURE__ */ M.createElement("span", Object.assign({}, e), r);
}, z6 = (t) => {
  for (var {
    decorations: e,
    isLast: r,
    parent: n,
    renderPlaceholder: a,
    renderLeaf: i,
    text: s
  } = t, l = Zr(), o = de(null), u = ie.decorations(s, e), c = K.findKey(l, s), f = [], p = 0; p < u.length; p++) {
    var g = u[p];
    f.push(/* @__PURE__ */ M.createElement(k6, {
      isLast: r && p === u.length - 1,
      key: "".concat(c.id, "-").concat(p),
      renderPlaceholder: a,
      leaf: g,
      text: s,
      parent: n,
      renderLeaf: i
    }));
  }
  var m = oe((d) => {
    var w = ho.get(l);
    d ? (w == null || w.set(c, d), ln.set(s, d), hi.set(d, s)) : (w == null || w.delete(c), ln.delete(s), o.current && hi.delete(o.current)), o.current = d;
  }, [o, l, c, s]);
  return /* @__PURE__ */ M.createElement("span", {
    "data-slate-node": "text",
    ref: m
  }, f);
}, B0 = /* @__PURE__ */ M.memo(z6, (t, e) => e.parent === t.parent && e.isLast === t.isLast && e.renderLeaf === t.renderLeaf && e.renderPlaceholder === t.renderPlaceholder && e.text === t.text && M6(e.decorations, t.decorations)), W6 = (t) => {
  var {
    decorations: e,
    element: r,
    renderElement: n = (O) => /* @__PURE__ */ M.createElement(U6, Object.assign({}, O)),
    renderPlaceholder: a,
    renderLeaf: i,
    selection: s
  } = t, l = Zr(), o = G6(), u = l.isInline(r), c = K.findKey(l, r), f = oe((O) => {
    var S = ho.get(l);
    O ? (S == null || S.set(c, O), ln.set(r, O), hi.set(O, r)) : (S == null || S.delete(c), ln.delete(r));
  }, [l, c, r]), p = $0({
    decorations: e,
    node: r,
    renderElement: n,
    renderPlaceholder: a,
    renderLeaf: i,
    selection: s
  }), g = {
    "data-slate-node": "element",
    ref: f
  };
  if (u && (g["data-slate-inline"] = !0), !u && R.hasInlines(l, r)) {
    var m = Q.string(r), d = o0(m);
    d === "rtl" && (g.dir = d);
  }
  if (R.isVoid(l, r)) {
    g["data-slate-void"] = !0, !o && u && (g.contentEditable = !1);
    var w = u ? "span" : "div", [[b]] = Q.texts(r);
    p = /* @__PURE__ */ M.createElement(w, {
      "data-slate-spacer": !0,
      style: {
        height: "0",
        color: "transparent",
        outline: "none",
        position: "absolute"
      }
    }, /* @__PURE__ */ M.createElement(B0, {
      renderPlaceholder: a,
      decorations: [],
      isLast: !1,
      parent: r,
      text: b
    })), Vc.set(b, 0), qc.set(b, r);
  }
  return n({
    attributes: g,
    children: p,
    element: r
  });
}, H6 = /* @__PURE__ */ M.memo(W6, (t, e) => t.element === e.element && t.renderElement === e.renderElement && t.renderLeaf === e.renderLeaf && t.renderPlaceholder === e.renderPlaceholder && $6(t.decorations, e.decorations) && (t.selection === e.selection || !!t.selection && !!e.selection && G.equals(t.selection, e.selection))), U6 = (t) => {
  var {
    attributes: e,
    children: r,
    element: n
  } = t, a = Zr(), i = a.isInline(n) ? "span" : "div";
  return /* @__PURE__ */ M.createElement(i, Object.assign({}, e, {
    style: {
      position: "relative"
    }
  }), r);
}, R0 = /* @__PURE__ */ Vt(() => []), V6 = () => Ht(R0), q6 = /* @__PURE__ */ Vt(!1), $0 = (t) => {
  for (var {
    decorations: e,
    node: r,
    renderElement: n,
    renderPlaceholder: a,
    renderLeaf: i,
    selection: s
  } = t, l = V6(), o = Zr(), u = K.findPath(o, r), c = [], f = ae.isElement(r) && !o.isInline(r) && R.hasInlines(o, r), p = 0; p < r.children.length; p++) {
    var g = u.concat(p), m = r.children[p], d = K.findKey(o, m), w = R.range(o, g), b = s && G.intersection(w, s), O = l([m, g]);
    for (var S of e) {
      var B = G.intersection(S, w);
      B && O.push(B);
    }
    ae.isElement(m) ? c.push(/* @__PURE__ */ M.createElement(q6.Provider, {
      key: "provider-".concat(d.id),
      value: !!b
    }, /* @__PURE__ */ M.createElement(H6, {
      decorations: O,
      element: m,
      key: d.id,
      renderElement: n,
      renderPlaceholder: a,
      renderLeaf: i,
      selection: b
    }))) : c.push(/* @__PURE__ */ M.createElement(B0, {
      decorations: O,
      key: d.id,
      isLast: f && p === r.children.length - 1,
      parent: r,
      renderPlaceholder: a,
      renderLeaf: i,
      text: m
    })), Vc.set(m, p), qc.set(m, r);
  }
  return c;
}, M0 = /* @__PURE__ */ Vt(!1), G6 = () => Ht(M0), F0 = /* @__PURE__ */ Vt(null), Dn = () => {
  var t = Ht(F0);
  if (!t)
    throw new Error("The `useSlate` hook must be used inside the <Slate> component's context.");
  var {
    editor: e
  } = t;
  return e;
};
function Y6() {
  var t = Zr(), e = de(!1), r = de(0), n = oe(() => {
    if (!e.current) {
      e.current = !0;
      var a = K.getWindow(t);
      a.cancelAnimationFrame(r.current), r.current = a.requestAnimationFrame(() => {
        e.current = !1;
      });
    }
  }, [t]);
  return xe(() => () => cancelAnimationFrame(r.current), []), {
    receivedUserInput: e,
    onUserInput: n
  };
}
var K6 = 3, X6 = {
  bold: "mod+b",
  compose: ["down", "left", "right", "up", "backspace", "enter"],
  moveBackward: "left",
  moveForward: "right",
  moveWordBackward: "ctrl+left",
  moveWordForward: "ctrl+right",
  deleteBackward: "shift?+backspace",
  deleteForward: "shift?+delete",
  extendBackward: "shift+left",
  extendForward: "shift+right",
  italic: "mod+i",
  insertSoftBreak: "shift+enter",
  splitBlock: "enter",
  undo: "mod+z"
}, Z6 = {
  moveLineBackward: "opt+up",
  moveLineForward: "opt+down",
  moveWordBackward: "opt+left",
  moveWordForward: "opt+right",
  deleteBackward: ["ctrl+backspace", "ctrl+h"],
  deleteForward: ["ctrl+delete", "ctrl+d"],
  deleteLineBackward: "cmd+shift?+backspace",
  deleteLineForward: ["cmd+shift?+delete", "ctrl+k"],
  deleteWordBackward: "opt+shift?+backspace",
  deleteWordForward: "opt+shift?+delete",
  extendLineBackward: "opt+shift+up",
  extendLineForward: "opt+shift+down",
  redo: "cmd+shift+z",
  transposeCharacter: "ctrl+t"
}, J6 = {
  deleteWordBackward: "ctrl+shift?+backspace",
  deleteWordForward: "ctrl+shift?+delete",
  redo: ["ctrl+y", "ctrl+shift+z"]
}, Ge = (t) => {
  var e = X6[t], r = Z6[t], n = J6[t], a = e && sl(e), i = r && sl(r), s = n && sl(n);
  return (l) => !!(a && a(l) || Jh && i && i(l) || !Jh && s && s(l));
}, Xe = {
  isBold: Ge("bold"),
  isCompose: Ge("compose"),
  isMoveBackward: Ge("moveBackward"),
  isMoveForward: Ge("moveForward"),
  isDeleteBackward: Ge("deleteBackward"),
  isDeleteForward: Ge("deleteForward"),
  isDeleteLineBackward: Ge("deleteLineBackward"),
  isDeleteLineForward: Ge("deleteLineForward"),
  isDeleteWordBackward: Ge("deleteWordBackward"),
  isDeleteWordForward: Ge("deleteWordForward"),
  isExtendBackward: Ge("extendBackward"),
  isExtendForward: Ge("extendForward"),
  isExtendLineBackward: Ge("extendLineBackward"),
  isExtendLineForward: Ge("extendLineForward"),
  isItalic: Ge("italic"),
  isMoveLineBackward: Ge("moveLineBackward"),
  isMoveLineForward: Ge("moveLineForward"),
  isMoveWordBackward: Ge("moveWordBackward"),
  isMoveWordForward: Ge("moveWordForward"),
  isRedo: Ge("redo"),
  isSoftBreak: Ge("insertSoftBreak"),
  isSplitBlock: Ge("splitBlock"),
  isTransposeCharacter: Ge("transposeCharacter"),
  isUndo: Ge("undo")
}, Q6 = (t, e) => {
  var r = [], n = () => {
    r = [];
  }, a = (s) => {
    if (e.current) {
      var l = s.filter((o) => Kc(t, o, s));
      r.push(...l);
    }
  };
  function i() {
    r.length > 0 && (r.reverse().forEach((s) => {
      s.type !== "characterData" && (s.removedNodes.forEach((l) => {
        s.target.insertBefore(l, s.nextSibling);
      }), s.addedNodes.forEach((l) => {
        s.target.removeChild(l);
      }));
    }), n());
  }
  return {
    registerMutations: a,
    restoreDOM: i,
    clear: n
  };
}, e7 = {
  subtree: !0,
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0
};
class I0 extends da {
  constructor() {
    super(...arguments), this.context = null, this.manager = null, this.mutationObserver = null;
  }
  observe() {
    var e, {
      node: r
    } = this.props;
    if (!r.current)
      throw new Error("Failed to attach MutationObserver, `node` is undefined");
    (e = this.mutationObserver) === null || e === void 0 || e.observe(r.current, e7);
  }
  componentDidMount() {
    var {
      receivedUserInput: e
    } = this.props, r = this.context;
    this.manager = Q6(r, e), this.mutationObserver = new MutationObserver(this.manager.registerMutations), this.observe();
  }
  getSnapshotBeforeUpdate() {
    var e, r, n, a = (e = this.mutationObserver) === null || e === void 0 ? void 0 : e.takeRecords();
    if (a != null && a.length) {
      var i;
      (i = this.manager) === null || i === void 0 || i.registerMutations(a);
    }
    return (r = this.mutationObserver) === null || r === void 0 || r.disconnect(), (n = this.manager) === null || n === void 0 || n.restoreDOM(), null;
  }
  componentDidUpdate() {
    var e;
    (e = this.manager) === null || e === void 0 || e.clear(), this.observe();
  }
  componentWillUnmount() {
    var e;
    (e = this.mutationObserver) === null || e === void 0 || e.disconnect();
  }
  render() {
    return this.props.children;
  }
}
I0.contextType = Uc;
var t7 = Pt ? I0 : (t) => {
  var {
    children: e
  } = t;
  return /* @__PURE__ */ M.createElement(M.Fragment, null, e);
}, r7 = ["autoFocus", "decorate", "onDOMBeforeInput", "placeholder", "readOnly", "renderElement", "renderLeaf", "renderPlaceholder", "scrollSelectionIntoView", "style", "as", "disableDefaultStyles"], n7 = ["text"];
function ig(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Bn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ig(Object(r), !0).forEach(function(n) {
      po(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ig(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var a7 = (t) => /* @__PURE__ */ M.createElement(M.Fragment, null, $0(t)), i7 = (t) => {
  var e = oe((L) => /* @__PURE__ */ M.createElement(s7, Object.assign({}, L)), []), {
    autoFocus: r,
    decorate: n = o7,
    onDOMBeforeInput: a,
    placeholder: i,
    readOnly: s = !1,
    renderElement: l,
    renderLeaf: o,
    renderPlaceholder: u = e,
    scrollSelectionIntoView: c = l7,
    style: f = {},
    as: p = "div",
    disableDefaultStyles: g = !1
  } = t, m = la(t, r7), d = Dn(), [w, b] = $e(!1), O = de(null), S = de([]), [B, T] = $e(), {
    onUserInput: A,
    receivedUserInput: D
  } = Y6(), [, h] = qy((L) => L + 1, 0);
  C0.set(d, h), iu.set(d, s);
  var y = gt(() => ({
    isDraggingInternally: !1,
    isUpdatingSelection: !1,
    latestElement: null,
    hasMarkPlaceholder: !1
  }), []);
  xe(() => {
    O.current && r && O.current.focus();
  }, [r]);
  var v = de(), E = gt(() => w9(() => {
    var L = v.current;
    if ((Pt || !K.isComposing(d)) && (!y.isUpdatingSelection || L != null && L.isFlushing()) && !y.isDraggingInternally) {
      var q = K.findDocumentOrShadowRoot(d), {
        activeElement: V
      } = q, X = K.toDOMNode(d, d), te = q.getSelection();
      if (V === X ? (y.latestElement = V, nn.set(d, !0)) : nn.delete(d), !te)
        return Z.deselect(d);
      var {
        anchorNode: re,
        focusNode: ue
      } = te, pe = K.hasEditableTarget(d, re) || K.isTargetInsideNonReadonlyVoid(d, re), ye = K.hasEditableTarget(d, ue) || K.isTargetInsideNonReadonlyVoid(d, ue);
      if (pe && ye) {
        var Ce = K.toSlateRange(d, te, {
          exactMatch: !1,
          suppressThrow: !0
        });
        Ce && (!K.isComposing(d) && !(L != null && L.hasPendingChanges()) && !(L != null && L.isFlushing()) ? Z.select(d, Ce) : L == null || L.handleUserSelect(Ce));
      }
      s && (!pe || !ye) && Z.deselect(d);
    }
  }, 100), [d, s, y]), _ = gt(() => h9(E, 0), [E]);
  v.current = A6({
    node: O,
    onDOMSelectionChange: E,
    scheduleOnDOMSelectionChange: _
  }), gi(() => {
    var L, q, V;
    O.current && (V = Yc(O.current)) ? (E0.set(d, V), os.set(d, O.current), ln.set(d, O.current), hi.set(O.current, d)) : ln.delete(d);
    var {
      selection: X
    } = d, te = K.findDocumentOrShadowRoot(d), re = te.getSelection();
    if (!(!re || !K.isFocused(d) || (L = v.current) !== null && L !== void 0 && L.hasPendingAction())) {
      var ue = (be) => {
        var Ie = re.type !== "None";
        if (!(!X && !Ie)) {
          var Me = re.focusNode, Ae;
          if (ei && re.rangeCount > 1) {
            var Be = re.getRangeAt(0), Ke = re.getRangeAt(re.rangeCount - 1);
            Be.startContainer === Me ? Ae = Ke.endContainer : Ae = Be.startContainer;
          } else
            Ae = re.anchorNode;
          var st = os.get(d), vt = !1;
          if (st.contains(Ae) && st.contains(Me) && (vt = !0), Ie && vt && X && !be) {
            var je = K.toSlateRange(d, re, {
              exactMatch: !0,
              // domSelection is not necessarily a valid Slate range
              // (e.g. when clicking on contentEditable:false element)
              suppressThrow: !0
            });
            if (je && G.equals(je, X)) {
              var lt, Dt;
              if (!y.hasMarkPlaceholder || (lt = Ae) !== null && lt !== void 0 && (Dt = lt.parentElement) !== null && Dt !== void 0 && Dt.hasAttribute("data-slate-mark-placeholder"))
                return;
            }
          }
          if (X && !K.hasRange(d, X)) {
            d.selection = K.toSlateRange(d, re, {
              exactMatch: !1,
              suppressThrow: !0
            });
            return;
          }
          y.isUpdatingSelection = !0;
          var Se = X && K.toDOMRange(d, X);
          return Se ? (K.isComposing(d) && !Pt ? re.collapseToEnd() : G.isBackward(X) ? re.setBaseAndExtent(Se.endContainer, Se.endOffset, Se.startContainer, Se.startOffset) : re.setBaseAndExtent(Se.startContainer, Se.startOffset, Se.endContainer, Se.endOffset), c(d, Se)) : re.removeAllRanges(), Se;
        }
      };
      re.rangeCount <= 1 && ue();
      var pe = ((q = v.current) === null || q === void 0 ? void 0 : q.isFlushing()) === "action";
      if (!Pt || !pe) {
        setTimeout(() => {
          y.isUpdatingSelection = !1;
        });
        return;
      }
      var ye = null, Ce = requestAnimationFrame(() => {
        if (pe) {
          var be = (Ie) => {
            try {
              var Me = K.toDOMNode(d, d);
              Me.focus(), ue(Ie);
            } catch {
            }
          };
          be(), ye = setTimeout(() => {
            be(!0), y.isUpdatingSelection = !1;
          });
        }
      });
      return () => {
        cancelAnimationFrame(Ce), ye && clearTimeout(ye);
      };
    }
  });
  var C = oe((L) => {
    if (A(), !s && K.hasEditableTarget(d, L.target) && !u7(L, a)) {
      var q;
      if (v.current)
        return v.current.handleDOMBeforeInput(L);
      _.flush(), E.flush();
      var {
        selection: V
      } = d, {
        inputType: X
      } = L, te = L.dataTransfer || L.data || void 0, re = X === "insertCompositionText" || X === "deleteCompositionText";
      if (re && K.isComposing(d))
        return;
      var ue = !1;
      if (X === "insertText" && V && G.isCollapsed(V) && // Only use native character insertion for single characters a-z or space for now.
      // Long-press events (hold a + press 4 = ä) to choose a special character otherwise
      // causes duplicate inserts.
      L.data && L.data.length === 1 && /[a-z ]/i.test(L.data) && // Chrome has issues correctly editing the start of nodes: https://bugs.chromium.org/p/chromium/issues/detail?id=1249405
      // When there is an inline element, e.g. a link, and you select
      // right after it (the start of the next node).
      V.anchor.offset !== 0) {
        var pe, ye;
        ue = !0, d.marks && (ue = !1);
        var {
          anchor: Ce
        } = V, [be, Ie] = K.toDOMPoint(d, Ce), Me = (pe = be.parentElement) === null || pe === void 0 ? void 0 : pe.closest("a"), Ae = K.getWindow(d);
        if (ue && Me && K.hasDOMNode(d, Me)) {
          var Be, Ke = Ae == null ? void 0 : Ae.document.createTreeWalker(Me, NodeFilter.SHOW_TEXT).lastChild();
          Ke === be && ((Be = Ke.textContent) === null || Be === void 0 ? void 0 : Be.length) === Ie && (ue = !1);
        }
        if (ue && be.parentElement && (Ae == null || (ye = Ae.getComputedStyle(be.parentElement)) === null || ye === void 0 ? void 0 : ye.whiteSpace) === "pre") {
          var st = R.above(d, {
            at: Ce.path,
            match: (St) => ae.isElement(St) && R.isBlock(d, St)
          });
          st && Q.string(st[0]).includes("	") && (ue = !1);
        }
      }
      if (!X.startsWith("delete") || X.startsWith("deleteBy")) {
        var [vt] = L.getTargetRanges();
        if (vt) {
          var je = K.toSlateRange(d, vt, {
            exactMatch: !1,
            suppressThrow: !1
          });
          if (!V || !G.equals(V, je)) {
            ue = !1;
            var lt = !re && d.selection && R.rangeRef(d, d.selection);
            Z.select(d, je), lt && ti.set(d, lt);
          }
        }
      }
      if (re)
        return;
      if (ue || L.preventDefault(), V && G.isExpanded(V) && X.startsWith("delete")) {
        var Dt = X.endsWith("Backward") ? "backward" : "forward";
        R.deleteFragment(d, {
          direction: Dt
        });
        return;
      }
      switch (X) {
        case "deleteByComposition":
        case "deleteByCut":
        case "deleteByDrag": {
          R.deleteFragment(d);
          break;
        }
        case "deleteContent":
        case "deleteContentForward": {
          R.deleteForward(d);
          break;
        }
        case "deleteContentBackward": {
          R.deleteBackward(d);
          break;
        }
        case "deleteEntireSoftLine": {
          R.deleteBackward(d, {
            unit: "line"
          }), R.deleteForward(d, {
            unit: "line"
          });
          break;
        }
        case "deleteHardLineBackward": {
          R.deleteBackward(d, {
            unit: "block"
          });
          break;
        }
        case "deleteSoftLineBackward": {
          R.deleteBackward(d, {
            unit: "line"
          });
          break;
        }
        case "deleteHardLineForward": {
          R.deleteForward(d, {
            unit: "block"
          });
          break;
        }
        case "deleteSoftLineForward": {
          R.deleteForward(d, {
            unit: "line"
          });
          break;
        }
        case "deleteWordBackward": {
          R.deleteBackward(d, {
            unit: "word"
          });
          break;
        }
        case "deleteWordForward": {
          R.deleteForward(d, {
            unit: "word"
          });
          break;
        }
        case "insertLineBreak":
          R.insertSoftBreak(d);
          break;
        case "insertParagraph": {
          R.insertBreak(d);
          break;
        }
        case "insertFromComposition":
        case "insertFromDrop":
        case "insertFromPaste":
        case "insertFromYank":
        case "insertReplacementText":
        case "insertText": {
          X === "insertFromComposition" && K.isComposing(d) && (b(!1), an.set(d, !1)), (te == null ? void 0 : te.constructor.name) === "DataTransfer" ? K.insertData(d, te) : typeof te == "string" && (ue ? S.current.push(() => R.insertText(d, te)) : R.insertText(d, te));
          break;
        }
      }
      var Se = (q = ti.get(d)) === null || q === void 0 ? void 0 : q.unref();
      ti.delete(d), Se && (!d.selection || !G.equals(d.selection, Se)) && Z.select(d, Se);
    }
  }, [d, E, A, a, s, _]), P = oe((L) => {
    L == null ? (E.cancel(), _.cancel(), os.delete(d), ln.delete(d), O.current && Mr && O.current.removeEventListener("beforeinput", C)) : Mr && L.addEventListener("beforeinput", C), O.current = L;
  }, [E, _, d, C]);
  gi(() => {
    var L = K.getWindow(d);
    return L.document.addEventListener("selectionchange", _), () => {
      L.document.removeEventListener("selectionchange", _);
    };
  }, [_]);
  var $ = n([d, []]), W = i && d.children.length === 1 && Array.from(Q.texts(d)).length === 1 && Q.string(d) === "" && !w, j = oe((L) => {
    if (L && W) {
      var q;
      T((q = L.getBoundingClientRect()) === null || q === void 0 ? void 0 : q.height);
    } else
      T(void 0);
  }, [W]);
  if (W) {
    var I = R.start(d, []);
    $.push({
      [ua]: !0,
      placeholder: i,
      onPlaceholderResize: j,
      anchor: I,
      focus: I
    });
  }
  var {
    marks: F
  } = d;
  if (y.hasMarkPlaceholder = !1, d.selection && G.isCollapsed(d.selection) && F) {
    var {
      anchor: k
    } = d.selection, N = Q.leaf(d, k.path), U = la(N, n7);
    if (!ie.equals(N, F, {
      loose: !0
    })) {
      y.hasMarkPlaceholder = !0;
      var Y = Object.fromEntries(Object.keys(U).map((L) => [L, null]));
      $.push(Bn(Bn(Bn({
        [D0]: !0
      }, Y), F), {}, {
        anchor: k,
        focus: k
      }));
    }
  }
  return xe(() => {
    setTimeout(() => {
      var {
        selection: L
      } = d;
      if (L) {
        var {
          anchor: q
        } = L, V = Q.leaf(d, q.path);
        if (F && !ie.equals(V, F, {
          loose: !0
        })) {
          Jt.set(d, F);
          return;
        }
      }
      Jt.delete(d);
    });
  }), /* @__PURE__ */ M.createElement(M0.Provider, {
    value: s
  }, /* @__PURE__ */ M.createElement(R0.Provider, {
    value: n
  }, /* @__PURE__ */ M.createElement(t7, {
    node: O,
    receivedUserInput: D
  }, /* @__PURE__ */ M.createElement(p, Object.assign({
    role: s ? void 0 : "textbox",
    "aria-multiline": s ? void 0 : !0
  }, m, {
    // COMPAT: Certain browsers don't support the `beforeinput` event, so we'd
    // have to use hacks to make these replacement-based features work.
    // For SSR situations HAS_BEFORE_INPUT_SUPPORT is false and results in prop
    // mismatch warning app moves to browser. Pass-through consumer props when
    // not CAN_USE_DOM (SSR) and default to falsy value
    spellCheck: Mr || !ss ? m.spellCheck : !1,
    autoCorrect: Mr || !ss ? m.autoCorrect : "false",
    autoCapitalize: Mr || !ss ? m.autoCapitalize : "false",
    "data-slate-editor": !0,
    "data-slate-node": "value",
    // explicitly set this
    contentEditable: !s,
    // in some cases, a decoration needs access to the range / selection to decorate a text node,
    // then you will select the whole text node when you select part the of text
    // this magic zIndex="-1" will fix it
    zindex: -1,
    suppressContentEditableWarning: !0,
    ref: P,
    style: Bn(Bn({}, g ? {} : Bn({
      // Allow positioning relative to the editable element.
      position: "relative",
      // Preserve adjacent whitespace and new lines.
      whiteSpace: "pre-wrap",
      // Allow words to break if they are too long.
      wordWrap: "break-word"
    }, B ? {
      minHeight: B
    } : {})), f),
    onBeforeInput: oe((L) => {
      if (!Mr && !s && !yt(L, m.onBeforeInput) && K.hasSelectableTarget(d, L.target) && (L.preventDefault(), !K.isComposing(d))) {
        var q = L.data;
        R.insertText(d, q);
      }
    }, [m.onBeforeInput, d, s]),
    onInput: oe((L) => {
      if (!yt(L, m.onInput)) {
        if (v.current) {
          v.current.handleInput();
          return;
        }
        for (var q of S.current)
          q();
        S.current = [];
      }
    }, [m.onInput]),
    onBlur: oe((L) => {
      if (!(s || y.isUpdatingSelection || !K.hasSelectableTarget(d, L.target) || yt(L, m.onBlur))) {
        var q = K.findDocumentOrShadowRoot(d);
        if (y.latestElement !== q.activeElement) {
          var {
            relatedTarget: V
          } = L, X = K.toDOMNode(d, d);
          if (V !== X && !(Nt(V) && V.hasAttribute("data-slate-spacer"))) {
            if (V != null && qr(V) && K.hasDOMNode(d, V)) {
              var te = K.toSlateNode(d, V);
              if (ae.isElement(te) && !d.isVoid(te))
                return;
            }
            if (qa) {
              var re = q.getSelection();
              re == null || re.removeAllRanges();
            }
            nn.delete(d);
          }
        }
      }
    }, [s, y.isUpdatingSelection, y.latestElement, d, m.onBlur]),
    onClick: oe((L) => {
      if (K.hasTarget(d, L.target) && !yt(L, m.onClick) && qr(L.target)) {
        var q = K.toSlateNode(d, L.target), V = K.findPath(d, q);
        if (!R.hasPath(d, V) || Q.get(d, V) !== q)
          return;
        if (L.detail === K6 && V.length >= 1) {
          var X = V;
          if (!(ae.isElement(q) && R.isBlock(d, q))) {
            var te, re = R.above(d, {
              match: (Me) => ae.isElement(Me) && R.isBlock(d, Me),
              at: V
            });
            X = (te = re == null ? void 0 : re[1]) !== null && te !== void 0 ? te : V.slice(0, 1);
          }
          var ue = R.range(d, X);
          Z.select(d, ue);
          return;
        }
        if (s)
          return;
        var pe = R.start(d, V), ye = R.end(d, V), Ce = R.void(d, {
          at: pe
        }), be = R.void(d, {
          at: ye
        });
        if (Ce && be && H.equals(Ce[1], be[1])) {
          var Ie = R.range(d, pe);
          Z.select(d, Ie);
        }
      }
    }, [d, m.onClick, s]),
    onCompositionEnd: oe((L) => {
      if (K.hasSelectableTarget(d, L.target)) {
        var q;
        if (K.isComposing(d) && (b(!1), an.set(d, !1)), (q = v.current) === null || q === void 0 || q.handleCompositionEnd(L), yt(L, m.onCompositionEnd) || Pt)
          return;
        if (!qa && !e6 && !X9 && !r6 && !t6 && L.data) {
          var V = Jt.get(d);
          Jt.delete(d), V !== void 0 && (Cr.set(d, d.marks), d.marks = V), R.insertText(d, L.data);
          var X = Cr.get(d);
          Cr.delete(d), X !== void 0 && (d.marks = X);
        }
      }
    }, [m.onCompositionEnd, d]),
    onCompositionUpdate: oe((L) => {
      K.hasSelectableTarget(d, L.target) && !yt(L, m.onCompositionUpdate) && (K.isComposing(d) || (b(!0), an.set(d, !0)));
    }, [m.onCompositionUpdate, d]),
    onCompositionStart: oe((L) => {
      if (K.hasSelectableTarget(d, L.target)) {
        var q;
        if ((q = v.current) === null || q === void 0 || q.handleCompositionStart(L), yt(L, m.onCompositionStart) || Pt)
          return;
        b(!0);
        var {
          selection: V
        } = d;
        if (V) {
          if (G.isExpanded(V)) {
            R.deleteFragment(d);
            return;
          }
          var X = R.above(d, {
            match: (ue) => ae.isElement(ue) && R.isInline(d, ue),
            mode: "highest"
          });
          if (X) {
            var [, te] = X;
            if (R.isEnd(d, V.anchor, te)) {
              var re = R.after(d, te);
              Z.setSelection(d, {
                anchor: re,
                focus: re
              });
            }
          }
        }
      }
    }, [m.onCompositionStart, d]),
    onCopy: oe((L) => {
      K.hasSelectableTarget(d, L.target) && !yt(L, m.onCopy) && !sg(L) && (L.preventDefault(), K.setFragmentData(d, L.clipboardData, "copy"));
    }, [m.onCopy, d]),
    onCut: oe((L) => {
      if (!s && K.hasSelectableTarget(d, L.target) && !yt(L, m.onCut) && !sg(L)) {
        L.preventDefault(), K.setFragmentData(d, L.clipboardData, "cut");
        var {
          selection: q
        } = d;
        if (q)
          if (G.isExpanded(q))
            R.deleteFragment(d);
          else {
            var V = Q.parent(d, q.anchor.path);
            R.isVoid(d, V) && Z.delete(d);
          }
      }
    }, [s, d, m.onCut]),
    onDragOver: oe((L) => {
      if (K.hasTarget(d, L.target) && !yt(L, m.onDragOver)) {
        var q = K.toSlateNode(d, L.target);
        ae.isElement(q) && R.isVoid(d, q) && L.preventDefault();
      }
    }, [m.onDragOver, d]),
    onDragStart: oe((L) => {
      if (!s && K.hasTarget(d, L.target) && !yt(L, m.onDragStart)) {
        var q = K.toSlateNode(d, L.target), V = K.findPath(d, q), X = ae.isElement(q) && R.isVoid(d, q) || R.void(d, {
          at: V,
          voids: !0
        });
        if (X) {
          var te = R.range(d, V);
          Z.select(d, te);
        }
        y.isDraggingInternally = !0, K.setFragmentData(d, L.dataTransfer, "drag");
      }
    }, [s, d, m.onDragStart, y]),
    onDrop: oe((L) => {
      if (!s && K.hasTarget(d, L.target) && !yt(L, m.onDrop)) {
        L.preventDefault();
        var q = d.selection, V = K.findEventRange(d, L), X = L.dataTransfer;
        Z.select(d, V), y.isDraggingInternally && q && !G.equals(q, V) && !R.void(d, {
          at: V,
          voids: !0
        }) && Z.delete(d, {
          at: q
        }), K.insertData(d, X), K.isFocused(d) || K.focus(d);
      }
      y.isDraggingInternally = !1;
    }, [s, d, m.onDrop, y]),
    onDragEnd: oe((L) => {
      !s && y.isDraggingInternally && m.onDragEnd && K.hasTarget(d, L.target) && m.onDragEnd(L), y.isDraggingInternally = !1;
    }, [s, y, m, d]),
    onFocus: oe((L) => {
      if (!s && !y.isUpdatingSelection && K.hasEditableTarget(d, L.target) && !yt(L, m.onFocus)) {
        var q = K.toDOMNode(d, d), V = K.findDocumentOrShadowRoot(d);
        if (y.latestElement = V.activeElement, ei && L.target !== q) {
          q.focus();
          return;
        }
        nn.set(d, !0);
      }
    }, [s, y, d, m.onFocus]),
    onKeyDown: oe((L) => {
      if (!s && K.hasEditableTarget(d, L.target)) {
        var q;
        (q = v.current) === null || q === void 0 || q.handleKeyDown(L);
        var {
          nativeEvent: V
        } = L;
        if (K.isComposing(d) && V.isComposing === !1 && (an.set(d, !1), b(!1)), yt(L, m.onKeyDown) || K.isComposing(d))
          return;
        var {
          selection: X
        } = d, te = d.children[X !== null ? X.focus.path[0] : 0], re = o0(Q.string(te)) === "rtl";
        if (Xe.isRedo(V)) {
          L.preventDefault();
          var ue = d;
          typeof ue.redo == "function" && ue.redo();
          return;
        }
        if (Xe.isUndo(V)) {
          L.preventDefault();
          var pe = d;
          typeof pe.undo == "function" && pe.undo();
          return;
        }
        if (Xe.isMoveLineBackward(V)) {
          L.preventDefault(), Z.move(d, {
            unit: "line",
            reverse: !0
          });
          return;
        }
        if (Xe.isMoveLineForward(V)) {
          L.preventDefault(), Z.move(d, {
            unit: "line"
          });
          return;
        }
        if (Xe.isExtendLineBackward(V)) {
          L.preventDefault(), Z.move(d, {
            unit: "line",
            edge: "focus",
            reverse: !0
          });
          return;
        }
        if (Xe.isExtendLineForward(V)) {
          L.preventDefault(), Z.move(d, {
            unit: "line",
            edge: "focus"
          });
          return;
        }
        if (Xe.isMoveBackward(V)) {
          L.preventDefault(), X && G.isCollapsed(X) ? Z.move(d, {
            reverse: !re
          }) : Z.collapse(d, {
            edge: "start"
          });
          return;
        }
        if (Xe.isMoveForward(V)) {
          L.preventDefault(), X && G.isCollapsed(X) ? Z.move(d, {
            reverse: re
          }) : Z.collapse(d, {
            edge: "end"
          });
          return;
        }
        if (Xe.isMoveWordBackward(V)) {
          L.preventDefault(), X && G.isExpanded(X) && Z.collapse(d, {
            edge: "focus"
          }), Z.move(d, {
            unit: "word",
            reverse: !re
          });
          return;
        }
        if (Xe.isMoveWordForward(V)) {
          L.preventDefault(), X && G.isExpanded(X) && Z.collapse(d, {
            edge: "focus"
          }), Z.move(d, {
            unit: "word",
            reverse: re
          });
          return;
        }
        if (Mr) {
          if ((x0 || qa) && X && (Xe.isDeleteBackward(V) || Xe.isDeleteForward(V)) && G.isCollapsed(X)) {
            var ye = Q.parent(d, X.anchor.path);
            if (ae.isElement(ye) && R.isVoid(d, ye) && (R.isInline(d, ye) || R.isBlock(d, ye))) {
              L.preventDefault(), R.deleteBackward(d, {
                unit: "block"
              });
              return;
            }
          }
        } else {
          if (Xe.isBold(V) || Xe.isItalic(V) || Xe.isTransposeCharacter(V)) {
            L.preventDefault();
            return;
          }
          if (Xe.isSoftBreak(V)) {
            L.preventDefault(), R.insertSoftBreak(d);
            return;
          }
          if (Xe.isSplitBlock(V)) {
            L.preventDefault(), R.insertBreak(d);
            return;
          }
          if (Xe.isDeleteBackward(V)) {
            L.preventDefault(), X && G.isExpanded(X) ? R.deleteFragment(d, {
              direction: "backward"
            }) : R.deleteBackward(d);
            return;
          }
          if (Xe.isDeleteForward(V)) {
            L.preventDefault(), X && G.isExpanded(X) ? R.deleteFragment(d, {
              direction: "forward"
            }) : R.deleteForward(d);
            return;
          }
          if (Xe.isDeleteLineBackward(V)) {
            L.preventDefault(), X && G.isExpanded(X) ? R.deleteFragment(d, {
              direction: "backward"
            }) : R.deleteBackward(d, {
              unit: "line"
            });
            return;
          }
          if (Xe.isDeleteLineForward(V)) {
            L.preventDefault(), X && G.isExpanded(X) ? R.deleteFragment(d, {
              direction: "forward"
            }) : R.deleteForward(d, {
              unit: "line"
            });
            return;
          }
          if (Xe.isDeleteWordBackward(V)) {
            L.preventDefault(), X && G.isExpanded(X) ? R.deleteFragment(d, {
              direction: "backward"
            }) : R.deleteBackward(d, {
              unit: "word"
            });
            return;
          }
          if (Xe.isDeleteWordForward(V)) {
            L.preventDefault(), X && G.isExpanded(X) ? R.deleteFragment(d, {
              direction: "forward"
            }) : R.deleteForward(d, {
              unit: "word"
            });
            return;
          }
        }
      }
    }, [s, d, m.onKeyDown]),
    onPaste: oe((L) => {
      !s && K.hasEditableTarget(d, L.target) && !yt(L, m.onPaste) && (!Mr || i6(L.nativeEvent) || qa) && (L.preventDefault(), K.insertData(d, L.clipboardData));
    }, [s, d, m.onPaste])
  }), /* @__PURE__ */ M.createElement(a7, {
    decorations: $,
    node: d,
    renderElement: l,
    renderPlaceholder: u,
    renderLeaf: o,
    selection: d.selection
  })))));
}, s7 = (t) => {
  var {
    attributes: e,
    children: r
  } = t;
  return (
    // COMPAT: Artificially add a line-break to the end on the placeholder element
    // to prevent Android IMEs to pick up its content in autocorrect and to auto-capitalize the first letter
    /* @__PURE__ */ M.createElement("span", Object.assign({}, e), r, Pt && /* @__PURE__ */ M.createElement("br", null))
  );
}, o7 = () => [], l7 = (t, e) => {
  if (e.getBoundingClientRect && (!t.selection || t.selection && G.isCollapsed(t.selection))) {
    var r = e.startContainer.parentElement;
    r.getBoundingClientRect = e.getBoundingClientRect.bind(e), C9(r, {
      scrollMode: "if-needed"
    }), delete r.getBoundingClientRect;
  }
}, yt = (t, e) => {
  if (!e)
    return !1;
  var r = e(t);
  return r ?? (t.isDefaultPrevented() || t.isPropagationStopped());
}, sg = (t) => qr(t.target) && (t.target instanceof HTMLInputElement || t.target instanceof HTMLTextAreaElement), u7 = (t, e) => {
  if (!e)
    return !1;
  var r = e(t);
  return r ?? t.defaultPrevented;
}, c7 = /* @__PURE__ */ Vt(!1), f7 = /* @__PURE__ */ Vt({});
function d7(t) {
  var e = de([]).current, r = de({
    editor: t
  }).current, n = oe((i) => {
    r.editor = i, e.forEach((s) => s(i));
  }, [e, r]), a = gt(() => ({
    getSlate: () => r.editor,
    addEventListener: (i) => (e.push(i), () => {
      e.splice(e.indexOf(i), 1);
    })
  }), [e, r]);
  return {
    selectorContext: a,
    onChange: n
  };
}
var p7 = ["editor", "children", "onChange", "initialValue"], h7 = (t) => {
  var {
    editor: e,
    children: r,
    onChange: n,
    initialValue: a
  } = t, i = la(t, p7), [s, l] = M.useState(() => {
    if (!Q.isNodeList(a))
      throw new Error("[Slate] initialValue is invalid! Expected a list of elements but got: ".concat(ot.stringify(a)));
    if (!R.isEditor(e))
      throw new Error("[Slate] editor is invalid! You passed: ".concat(ot.stringify(e)));
    return e.children = a, Object.assign(e, i), {
      v: 0,
      editor: e
    };
  }), {
    selectorContext: o,
    onChange: u
  } = d7(e), c = oe(() => {
    n && n(e.children), l((g) => ({
      v: g.v + 1,
      editor: e
    })), u(e);
  }, [e, u, n]);
  xe(() => (su.set(e, c), () => {
    su.set(e, () => {
    });
  }), [e, c]);
  var [f, p] = $e(K.isFocused(e));
  return xe(() => {
    p(K.isFocused(e));
  }, [e]), gi(() => {
    var g = () => p(K.isFocused(e));
    return w0 >= 17 ? (document.addEventListener("focusin", g), document.addEventListener("focusout", g), () => {
      document.removeEventListener("focusin", g), document.removeEventListener("focusout", g);
    }) : (document.addEventListener("focus", g, !0), document.addEventListener("blur", g, !0), () => {
      document.removeEventListener("focus", g, !0), document.removeEventListener("blur", g, !0);
    });
  }, []), /* @__PURE__ */ M.createElement(f7.Provider, {
    value: o
  }, /* @__PURE__ */ M.createElement(F0.Provider, {
    value: s
  }, /* @__PURE__ */ M.createElement(Uc.Provider, {
    value: s.editor
  }, /* @__PURE__ */ M.createElement(c7.Provider, {
    value: f
  }, r))));
}, og = (t, e) => {
  var r = (e.top + e.bottom) / 2;
  return t.top <= r && t.bottom >= r;
}, lg = (t, e, r) => {
  var n = K.toDOMRange(t, e).getBoundingClientRect(), a = K.toDOMRange(t, r).getBoundingClientRect();
  return og(n, a) && og(a, n);
}, g7 = (t, e) => {
  var r = R.range(t, G.end(e)), n = Array.from(R.positions(t, {
    at: e
  })), a = 0, i = n.length, s = Math.floor(i / 2);
  if (lg(t, R.range(t, n[a]), r))
    return R.range(t, n[a], r);
  if (n.length < 2)
    return R.range(t, n[n.length - 1], r);
  for (; s !== n.length && s !== a; )
    lg(t, R.range(t, n[s]), r) ? i = s : a = s, s = Math.floor((a + i) / 2);
  return R.range(t, n[i], r);
};
function ug(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function cg(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ug(Object(r), !0).forEach(function(n) {
      po(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ug(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var v7 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x-slate-fragment", n = e, {
    apply: a,
    onChange: i,
    deleteBackward: s,
    addMark: l,
    removeMark: o
  } = n;
  return ho.set(n, /* @__PURE__ */ new WeakMap()), n.addMark = (u, c) => {
    var f, p;
    (f = Gc.get(n)) === null || f === void 0 || f(), !Jt.get(n) && (p = Ot.get(n)) !== null && p !== void 0 && p.length && Jt.set(n, null), Cr.delete(n), l(u, c);
  }, n.removeMark = (u) => {
    var c;
    !Jt.get(n) && (c = Ot.get(n)) !== null && c !== void 0 && c.length && Jt.set(n, null), Cr.delete(n), o(u);
  }, n.deleteBackward = (u) => {
    if (u !== "line")
      return s(u);
    if (n.selection && G.isCollapsed(n.selection)) {
      var c = R.above(n, {
        match: (m) => ae.isElement(m) && R.isBlock(n, m),
        at: n.selection
      });
      if (c) {
        var [, f] = c, p = R.range(n, f, n.selection.anchor), g = g7(n, p);
        G.isCollapsed(g) || Z.delete(n, {
          at: g
        });
      }
    }
  }, n.apply = (u) => {
    var c = [], f = Ot.get(n);
    if (f != null && f.length) {
      var p = f.map((A) => y6(A, u)).filter(Boolean);
      Ot.set(n, p);
    }
    var g = jr.get(n);
    g && jr.set(n, eg(n, g, u));
    var m = Ir.get(n);
    if (m != null && m.at) {
      var d = Ee.isPoint(m == null ? void 0 : m.at) ? uu(n, m.at, u) : eg(n, m.at, u);
      Ir.set(n, d ? cg(cg({}, m), {}, {
        at: d
      }) : null);
    }
    switch (u.type) {
      case "insert_text":
      case "remove_text":
      case "set_node":
      case "split_node": {
        c.push(...es(n, u.path));
        break;
      }
      case "set_selection": {
        var w;
        (w = ti.get(n)) === null || w === void 0 || w.unref(), ti.delete(n);
        break;
      }
      case "insert_node":
      case "remove_node": {
        c.push(...es(n, H.parent(u.path)));
        break;
      }
      case "merge_node": {
        var b = H.previous(u.path);
        c.push(...es(n, b));
        break;
      }
      case "move_node": {
        var O = H.common(H.parent(u.path), H.parent(u.newPath));
        c.push(...es(n, O));
        break;
      }
    }
    a(u);
    for (var [S, B] of c) {
      var [T] = R.node(n, S);
      au.set(T, B);
    }
  }, n.setFragmentData = (u) => {
    var {
      selection: c
    } = n;
    if (c) {
      var [f, p] = G.edges(c), g = R.void(n, {
        at: f.path
      }), m = R.void(n, {
        at: p.path
      });
      if (!(G.isCollapsed(c) && !g)) {
        var d = K.toDOMRange(n, c), w = d.cloneContents(), b = w.childNodes[0];
        if (w.childNodes.forEach((v) => {
          v.textContent && v.textContent.trim() !== "" && (b = v);
        }), m) {
          var [O] = m, S = d.cloneRange(), B = K.toDOMNode(n, O);
          S.setEndAfter(B), w = S.cloneContents();
        }
        if (g && (b = w.querySelector("[data-slate-spacer]")), Array.from(w.querySelectorAll("[data-slate-zero-width]")).forEach((v) => {
          var E = v.getAttribute("data-slate-zero-width") === "n";
          v.textContent = E ? `
` : "";
        }), S0(b)) {
          var T = b.ownerDocument.createElement("span");
          T.style.whiteSpace = "pre", T.appendChild(b), w.appendChild(T), b = T;
        }
        var A = n.getFragment(), D = JSON.stringify(A), h = window.btoa(encodeURIComponent(D));
        b.setAttribute("data-slate-fragment", h), u.setData("application/".concat(r), h);
        var y = w.ownerDocument.createElement("div");
        return y.appendChild(w), y.setAttribute("hidden", "true"), w.ownerDocument.body.appendChild(y), u.setData("text/html", y.innerHTML), u.setData("text/plain", P0(y)), w.ownerDocument.body.removeChild(y), u;
      }
    }
  }, n.insertData = (u) => {
    n.insertFragmentData(u) || n.insertTextData(u);
  }, n.insertFragmentData = (u) => {
    var c = u.getData("application/".concat(r)) || c6(u);
    if (c) {
      var f = decodeURIComponent(window.atob(c)), p = JSON.parse(f);
      return n.insertFragment(p), !0;
    }
    return !1;
  }, n.insertTextData = (u) => {
    var c = u.getData("text/plain");
    if (c) {
      var f = c.split(/\r\n|\r|\n/), p = !1;
      for (var g of f)
        p && Z.splitNodes(n, {
          always: !0
        }), n.insertText(g), p = !0;
      return !0;
    }
    return !1;
  }, n.onChange = (u) => {
    var c = w0 < 18 ? Tb.unstable_batchedUpdates : (f) => f();
    c(() => {
      var f = su.get(n);
      f && f(), i(u);
    });
  }, n;
}, es = (t, e) => {
  var r = [];
  for (var [n, a] of R.levels(t, {
    at: e
  })) {
    var i = K.findKey(t, n);
    r.push([a, i]);
  }
  return r;
};
const ja = {
  "5xl": ["display"],
  "4xl": ["display"],
  "3xl": ["heading"],
  "2xl": ["heading"],
  xl: ["heading"],
  l: ["body", "midi", "strong"],
  m: ["body", "midi", "strong"],
  s: ["body", "midi", "strong"],
  xs: ["body", "midi", "strong"],
  "2xs": ["strong"]
}, vi = "m-body";
var ht = /* @__PURE__ */ ((t) => (t.TYPOGRAPHY = "typography", t.COLOR = "color", t.CURRENT_USER_NAME = "current_user_name", t))(ht || {});
const fg = ["ordered-list", "unordered-list"], ls = ["left", "center", "right", "justify"], m7 = "_richText_a60vq_199", y7 = "_toolbar_a60vq_228", b7 = "_button_a60vq_241", w7 = "_activeButton_a60vq_247", x7 = "_icon_a60vq_251", E7 = "_inlineBug_a60vq_255", hn = {
  "typography-5xl-display": "_typography-5xl-display_a60vq_1",
  "typography-4xl-display": "_typography-4xl-display_a60vq_12",
  "typography-3xl-heading": "_typography-3xl-heading_a60vq_23",
  "typography-2xl-heading": "_typography-2xl-heading_a60vq_34",
  "typography-xl-heading": "_typography-xl-heading_a60vq_45",
  "typography-l-strong": "_typography-l-strong_a60vq_56",
  "typography-l-midi": "_typography-l-midi_a60vq_67",
  "typography-l-body": "_typography-l-body_a60vq_78",
  "typography-m-strong": "_typography-m-strong_a60vq_89",
  "typography-m-midi": "_typography-m-midi_a60vq_100",
  "typography-m-body": "_typography-m-body_a60vq_111",
  "typography-s-strong": "_typography-s-strong_a60vq_122",
  "typography-s-midi": "_typography-s-midi_a60vq_133",
  "typography-s-body": "_typography-s-body_a60vq_144",
  "typography-xs-strong": "_typography-xs-strong_a60vq_155",
  "typography-xs-midi": "_typography-xs-midi_a60vq_166",
  "typography-xs-body": "_typography-xs-body_a60vq_177",
  "typography-2xs-strong": "_typography-2xs-strong_a60vq_188",
  richText: m7,
  toolbar: y7,
  button: b7,
  activeButton: w7,
  icon: x7,
  inlineBug: E7
}, mi = ({ active: t = !1, tooltip: e, disabled: r, ...n }) => /* @__PURE__ */ x.jsx(Gr, { text: e, children: /* @__PURE__ */ x.jsx(
  "button",
  {
    disabled: r,
    type: "button",
    className: ke(hn.button, { [hn.activeButton]: t }),
    ...n
  }
) }), C7 = (t, e) => {
  const r = j0(
    t,
    e,
    ls.includes(e) ? "align" : "type"
  ), n = fg.includes(e);
  Z.unwrapNodes(t, {
    match: (i) => !R.isEditor(i) && ae.isElement(i) && fg.includes(i.type) && !ls.includes(e),
    split: !0
  });
  let a;
  if (ls.includes(e) ? a = r ? {} : {
    align: e
  } : a = {
    type: r ? "paragraph" : n ? "list-item" : e
  }, Z.setNodes(t, a), !r && n) {
    const i = { type: e, children: [] };
    Z.wrapNodes(t, i);
  }
  K.focus(t);
}, j0 = (t, e, r = "type") => {
  const { selection: n } = t;
  if (!n)
    return !1;
  const [a] = Array.from(
    R.nodes(t, {
      at: R.unhangRange(t, n),
      match: (i) => !R.isEditor(i) && ae.isElement(i) && i[r] === e
    })
  );
  return !!a;
}, Xc = (t, e) => {
  const [r] = Array.from(
    R.nodes(t, {
      match: (n) => !R.isEditor(n) && ae.isElement(n) && n.type === e
    })
  );
  return !!r;
}, D7 = (t) => $b.string().url().safeParse(t).success, S7 = (t) => {
  const { insertData: e } = t;
  return t.insertData = (r) => {
    const n = r.getData("text/plain");
    try {
      JSON.parse(n).builderContent || e(r);
    } catch {
      e(r);
    }
  }, t;
}, Rn = ({ format: t, icon: e, tooltip: r }) => {
  const n = Dn(), a = oe(() => C7(n, t), [n, t]);
  return /* @__PURE__ */ x.jsx(
    mi,
    {
      tooltip: r,
      active: j0(
        n,
        t,
        ls.includes(t) ? "align" : "type"
      ),
      onClick: a,
      children: /* @__PURE__ */ x.jsx(e, { color: "inherit" })
    }
  );
}, O7 = "_wrapper_jq8fr_1", P7 = "_content_jq8fr_5", _7 = "_title_jq8fr_13", A7 = "_colorValue_jq8fr_20", T7 = "_palette_jq8fr_24", B7 = "_item_jq8fr_29", R7 = "_itemActive_jq8fr_29", Nr = {
  wrapper: O7,
  content: P7,
  title: _7,
  colorValue: A7,
  palette: T7,
  item: B7,
  itemActive: R7
}, $7 = /\.color|color\./g, M7 = (t, e) => /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
  t.path.replace($7, ""),
  e === "default" ? "" : "." + e,
  "  ",
  /* @__PURE__ */ x.jsx("span", { className: Nr.colorValue, children: t.palette[e] })
] }), cu = (t, e, r) => {
  if (typeof r == "object") {
    const n = Object.keys(r);
    typeof r[n[0]] == "string" ? t.push({
      path: e.join("."),
      palette: r
    }) : n.forEach((a) => cu(t, [...e, a], r[a]));
  }
  return t;
}, F7 = (t) => {
  const e = [];
  return cu(e, ["text", "color"], t.text.color), cu(e, ["color"], t.color), e;
};
function I7(t) {
  return t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
const j7 = (t) => {
  const e = t.split(".").filter((r) => r !== "default").map(I7);
  return e[0] === "color" && (e[0] = e[1], e[1] = "color"), `var(--wpp-${e.join("-")})`;
}, L7 = () => {
  const {
    loc: t,
    dependencies: { theme: e }
  } = se(), r = Dn(), n = r.getMarks() || {}, a = gt(() => F7(e), [e]), i = de(null), s = de(null), [l, o] = $e(""), u = oe((g) => {
    const m = g.target.dataset;
    o(""), m.role === "item" && o(m.value);
  }, []), c = oe(
    (g) => {
      var d;
      const m = g.target.dataset;
      m.role === "item" && (o(""), r.addMark(ht.COLOR, m.value), (d = i.current) == null || d.closePopover(), K.focus(r));
    },
    [r]
  );
  Ob(() => {
    var g, m;
    return (g = s.current) == null || g.addEventListener("mouseover", u), (m = s.current) == null || m.addEventListener("click", c), () => {
      var d, w;
      (d = s.current) == null || d.removeEventListener("mouseover", u), (w = s.current) == null || w.removeEventListener("click", c);
    };
  });
  const { nodeToolbarRef: f } = Ht(oo), p = {
    interactive: !0,
    appendTo: () => f == null ? void 0 : f.current,
    zIndex: 1e4
  };
  return /* @__PURE__ */ x.jsxs(lv, { config: p, className: hn.button, ref: i, children: [
    /* @__PURE__ */ x.jsx("div", { slot: "trigger-element", children: /* @__PURE__ */ x.jsx(mi, { active: !!(l || n.color), tooltip: t("textColor"), children: /* @__PURE__ */ x.jsx(uv, { color: "inherit" }) }) }),
    /* @__PURE__ */ x.jsx("div", { className: Nr.wrapper, ref: s, children: /* @__PURE__ */ x.jsxs("div", { className: Nr.content, children: [
      /* @__PURE__ */ x.jsx("div", { className: Nr.palette, children: /* @__PURE__ */ x.jsx(
        dg,
        {
          value: "",
          color: "linear-gradient(135deg, white 0 43%, #c00 43% 57%, white 57% 100%)",
          active: !n.color,
          children: t("default")
        }
      ) }),
      a.map(
        (g) => g.palette && /* @__PURE__ */ x.jsx("div", { className: Nr.palette, children: Object.keys(g.palette).map((m) => {
          const d = j7(`${g.path}.${m}`);
          return /* @__PURE__ */ x.jsx(dg, { value: d, color: d, active: n.color === d, children: M7(g, m) }, m);
        }) }, g.path)
      )
    ] }) })
  ] });
}, dg = ({ color: t, value: e, active: r = !1, children: n }) => /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
  /* @__PURE__ */ x.jsx(
    "div",
    {
      className: r ? Nr.itemActive : Nr.item,
      style: { background: t },
      "data-role": "item",
      "data-value": e
    }
  ),
  /* @__PURE__ */ x.jsx(_e, { className: Nr.title, type: "xs-midi", children: n })
] }), k7 = "_user_1f40w_199", pg = {
  "typography-5xl-display": "_typography-5xl-display_1f40w_1",
  "typography-4xl-display": "_typography-4xl-display_1f40w_12",
  "typography-3xl-heading": "_typography-3xl-heading_1f40w_23",
  "typography-2xl-heading": "_typography-2xl-heading_1f40w_34",
  "typography-xl-heading": "_typography-xl-heading_1f40w_45",
  "typography-l-strong": "_typography-l-strong_1f40w_56",
  "typography-l-midi": "_typography-l-midi_1f40w_67",
  "typography-l-body": "_typography-l-body_1f40w_78",
  "typography-m-strong": "_typography-m-strong_1f40w_89",
  "typography-m-midi": "_typography-m-midi_1f40w_100",
  "typography-m-body": "_typography-m-body_1f40w_111",
  "typography-s-strong": "_typography-s-strong_1f40w_122",
  "typography-s-midi": "_typography-s-midi_1f40w_133",
  "typography-s-body": "_typography-s-body_1f40w_144",
  "typography-xs-strong": "_typography-xs-strong_1f40w_155",
  "typography-xs-midi": "_typography-xs-midi_1f40w_166",
  "typography-xs-body": "_typography-xs-body_1f40w_177",
  "typography-2xs-strong": "_typography-2xs-strong_1f40w_188",
  user: k7
}, hg = () => /* @__PURE__ */ x.jsx(
  "span",
  {
    contentEditable: !1,
    style: {
      fontSize: 0
    },
    children: String.fromCodePoint(160)
  }
), N7 = () => {
  const { loc: t } = se(), e = Dn(), r = oe(() => {
    z7(e);
  }, [e]);
  return /* @__PURE__ */ x.jsx(Gr, { slot: "trigger-element", text: t("authUser"), children: /* @__PURE__ */ x.jsx(ub, { onClick: r }) });
}, z7 = (t) => {
  const r = { type: "current-user", children: [{ text: "", current_user_name: !0 }] };
  Z.insertNodes(t, r);
}, W7 = ({
  children: t,
  element: e,
  attributes: r,
  style: n
}) => {
  const {
    dependencies: { user: a }
  } = se(), i = e.children.reduce(
    (s, l) => (l[ht.COLOR] && (s[ht.COLOR] = l[ht.COLOR]), l[ht.TYPOGRAPHY] && (s[ht.TYPOGRAPHY] = l[ht.TYPOGRAPHY]), s),
    { [ht.COLOR]: "", [ht.TYPOGRAPHY]: vi }
  );
  return /* @__PURE__ */ x.jsxs(
    "span",
    {
      attributes: r,
      style: { ...n, color: i[ht.COLOR] },
      className: ke(pg.user, pg[`typography-${i[ht.TYPOGRAPHY] || vi}`]),
      children: [
        t,
        /* @__PURE__ */ x.jsx(hg, {}),
        a,
        /* @__PURE__ */ x.jsx(hg, {})
      ]
    }
  );
}, H7 = "_link_1i8qr_1", U7 = "_enabledEditor_1i8qr_5", gg = {
  link: H7,
  enabledEditor: U7
}, vg = () => /* @__PURE__ */ x.jsx("span", { contentEditable: !1, style: { fontSize: 0 }, children: " " }), V7 = ({ attributes: t, children: e, element: r }) => {
  const { enabled: n } = Le((s) => ({
    enabled: s.options.enabled
  })), {
    internals: { readOnly: a }
  } = se(), i = a ? "span" : "a";
  return /* @__PURE__ */ x.jsx(
    i,
    {
      ...t,
      href: r == null ? void 0 : r.url,
      ...(r == null ? void 0 : r.newTab) && { target: "_blank" },
      className: ke(gg.link, { [gg.enabledEditor]: n }),
      children: e
    }
  );
}, q7 = ({ attributes: t, children: e, element: r }) => {
  const n = { textAlign: r.align };
  switch (r.type) {
    case "current-user":
      return /* @__PURE__ */ x.jsx(W7, { attributes: t, element: r, style: n, children: e });
    case "ordered-list":
      return /* @__PURE__ */ x.jsx("ol", { style: n, ...t, children: e });
    case "unordered-list":
      return /* @__PURE__ */ x.jsx("ul", { style: n, ...t, children: e });
    case "list-item":
      return /* @__PURE__ */ x.jsx("li", { style: n, ...t, children: e });
    case "link":
      return /* @__PURE__ */ x.jsxs(V7, { element: r, attributes: t, children: [
        /* @__PURE__ */ x.jsx(vg, {}),
        e,
        /* @__PURE__ */ x.jsx(vg, {})
      ] });
    case "wrap-text":
      return /* @__PURE__ */ x.jsx("div", { style: { ...n, wordBreak: "break-word" }, ...t, children: e });
    default:
      return /* @__PURE__ */ x.jsx("p", { style: n, ...t, children: e });
  }
}, G7 = ({ attributes: t, children: e, leaf: r }) => /* @__PURE__ */ x.jsx(
  "span",
  {
    className: ke(hn[`typography-${r[ht.TYPOGRAPHY] || vi}`], {
      [hn.inlineBug]: r.text === ""
    }),
    style: { color: r[ht.COLOR] },
    ...t,
    children: e
  }
), Y7 = "_root_4dvzz_1", K7 = "_hint_4dvzz_7", mg = {
  root: Y7,
  hint: K7
}, L0 = ({ name: t, ...e }) => {
  const { setValue: r } = Mb(), n = Fb({ name: t, ...e }), {
    field: { value: a },
    fieldState: { error: i, isTouched: s }
  } = n;
  return xe(() => {
    i && !s && r(t, a, { shouldTouch: !0 });
  }, [t, a, i, s, r]), n;
}, k0 = ({ fieldRef: t, setFocus: e }) => {
  const r = Zm(e);
  xe(() => (t({ focus: r }), () => {
    t(null);
  }), [t, r]);
}, X7 = hr(
  ({ name: t, hint: e, onWppBlur: r, labelConfig: n, labelTooltipConfig: a, ...i }, s) => {
    const {
      field: { ref: l, value: o, onChange: u, onBlur: c }
    } = L0({ name: t }), f = de(null);
    k0({
      fieldRef: l,
      setFocus: () => {
        var g;
        return (g = f.current) == null ? void 0 : g.setFocus();
      }
    });
    const p = wc({ labelConfig: n, labelTooltipConfig: a });
    return /* @__PURE__ */ x.jsxs("div", { className: mg.root, children: [
      /* @__PURE__ */ x.jsx(
        ii,
        {
          ...i,
          ...p,
          ref: Cu([f, s]),
          name: t,
          checked: o,
          onWppChange: (g) => u(g.detail.checked),
          onWppBlur: (g) => {
            c(), r == null || r(g);
          }
        }
      ),
      !!e && /* @__PURE__ */ x.jsx(_e, { className: mg.hint, type: "xs-body", children: e })
    ] });
  }
), Z7 = "_tooltipError_9m6ly_1", J7 = "_input_9m6ly_5", yg = {
  tooltipError: Z7,
  input: J7
}, Q7 = hr(
  ({
    name: t,
    message: e,
    messageType: r,
    onWppBlur: n,
    labelConfig: a,
    labelTooltipConfig: i,
    withTooltipError: s = !1,
    className: l,
    ...o
  }, u) => {
    const c = de(null), {
      field: { ref: f, value: p, onChange: g, onBlur: m },
      fieldState: { isTouched: d, error: w }
    } = L0({ name: t });
    k0({
      fieldRef: f,
      setFocus: () => {
        var A;
        return (A = c.current) == null ? void 0 : A.setFocus();
      }
    });
    const b = w == null ? void 0 : w.message, O = d && !!b, S = d && !!b && !s, B = !!b && !!s, T = wc({ labelConfig: a, labelTooltipConfig: i });
    return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx(
        yu,
        {
          ...o,
          ...T,
          ref: Cu([c, u]),
          name: t,
          value: p,
          onWppChange: (A) => g(A.detail.value),
          onWppBlur: (A) => {
            m(), n == null || n(A);
          },
          className: ke(yg.input, l),
          message: S ? b : e,
          messageType: O ? "error" : r
        }
      ),
      B && /* @__PURE__ */ x.jsx(Gr, { className: yg.tooltipError, error: !0, text: b, children: /* @__PURE__ */ x.jsx(cb, {}) })
    ] });
  }
);
var ez = function(t, e) {
  for (var r = {}; t.length; ) {
    var n = t[0], a = n.code, i = n.message, s = n.path.join(".");
    if (!r[s])
      if ("unionErrors" in n) {
        var l = n.unionErrors[0].errors[0];
        r[s] = { message: l.message, type: l.code };
      } else
        r[s] = { message: i, type: a };
    if ("unionErrors" in n && n.unionErrors.forEach(function(c) {
      return c.errors.forEach(function(f) {
        return t.push(f);
      });
    }), e) {
      var o = r[s].types, u = o && o[n.code];
      r[s] = Ib(s, e, r, a, u ? [].concat(u, n.message) : n.message);
    }
    t.shift();
  }
  return r;
}, tz = function(t, e, r) {
  return r === void 0 && (r = {}), function(n, a, i) {
    try {
      return Promise.resolve(function(s, l) {
        try {
          var o = Promise.resolve(t[r.mode === "sync" ? "parse" : "parseAsync"](n, e)).then(function(u) {
            return i.shouldUseNativeValidation && kb({}, i), { errors: {}, values: r.raw ? n : u };
          });
        } catch (u) {
          return l(u);
        }
        return o && o.then ? o.then(void 0, l) : o;
      }(0, function(s) {
        if (function(l) {
          return l.errors != null;
        }(s))
          return { values: {}, errors: Nb(ez(s.errors, !i.shouldUseNativeValidation && i.criteriaMode === "all"), i) };
        throw s;
      }));
    } catch (s) {
      return Promise.reject(s);
    }
  };
};
const bg = {
  keepErrors: !1,
  keepDirty: !1,
  keepIsSubmitted: !1,
  keepTouched: !1,
  keepIsValid: !1,
  keepSubmitCount: !1
}, rz = ({
  validationSchema: t,
  defaultValues: e,
  ...r
}) => {
  const n = jb({
    ...r,
    defaultValues: e,
    mode: "onTouched",
    reValidateMode: "onChange",
    ...!!t && {
      resolver: tz(t)
    }
  }), { reset: a, setError: i, setValue: s } = n, [l, o] = $e(!1), u = de([]), c = oe((...m) => {
    u.current = m, o(!0);
  }, []);
  xe(() => {
    if (l) {
      const [m, d] = u.current;
      a(m, {
        ...bg,
        ...d
      }), o(!1);
    }
  }, [l, a]);
  const f = Rl(e) || e;
  xe(() => {
    Xm(f, e) || a(e, bg);
  }, [f, e, a]);
  const p = oe(
    (m) => {
      Object.entries(m).forEach(([d, w], b) => {
        i(d, { message: w }, { shouldFocus: b === 0 });
      });
    },
    [i]
  ), g = oe(
    (m, d) => {
      Object.entries(m).forEach(([w, b]) => {
        s(w, b, d);
      });
    },
    [s]
  );
  return { ...n, reset: c, setErrors: p, setValues: g };
}, nz = ({ isOpen: t, onSubmit: e, onClose: r, onCloseComplete: n }) => {
  const { loc: a } = se(), i = rz({ defaultValues: { link: "", newTab: !1 } }), { handleSubmit: s } = i, l = s((o) => {
    e(o), r();
  });
  return /* @__PURE__ */ x.jsx(Lb, { ...i, children: /* @__PURE__ */ x.jsxs(
    Vm,
    {
      formConfig: { onSubmit: l },
      open: t,
      onWppModalClose: r,
      onWppModalCloseComplete: n,
      "data-testid": "add-link-modal",
      children: [
        /* @__PURE__ */ x.jsx(_e, { slot: "header", type: "2xl-heading", children: a("addLinkDialogTitle") }),
        /* @__PURE__ */ x.jsxs(fe, { slot: "body", direction: "column", gap: 24, children: [
          /* @__PURE__ */ x.jsx(
            Q7,
            {
              required: !0,
              labelConfig: { text: a("addLinkDialogLink") },
              name: "link",
              "data-testid": "access-request-reason-input"
            }
          ),
          /* @__PURE__ */ x.jsx(X7, { labelConfig: { text: a("addLinkDialogNewTab") }, name: "newTab", required: !0 })
        ] }),
        /* @__PURE__ */ x.jsxs(fe, { slot: "actions", gap: 12, justify: "end", children: [
          /* @__PURE__ */ x.jsx(si, { variant: "secondary", size: "s", onClick: r, "data-testid": "cancel", children: a("cancel") }),
          /* @__PURE__ */ x.jsx(si, { type: "submit", variant: "primary", size: "s", "data-testid": "apply", children: a("insertButton") })
        ] })
      ]
    }
  ) });
}, az = (t) => {
  const { insertText: e, isInline: r, isElementReadOnly: n } = t;
  return t.isInline = (a) => ["link", "current-user"].includes(a.type) || r(a), t.isElementReadOnly = (a) => a.type === "current-user" || n(a), t.insertText = (a) => {
    a && D7(a) ? N0(t, a, !1) : e(a, {});
  }, t;
}, N0 = (t, e, r) => {
  Xc(t, "link") && z0(t);
  const { selection: n } = t, a = n && G.isCollapsed(n), i = {
    type: "link",
    url: e,
    newTab: r,
    children: a ? [{ text: e }] : []
  };
  a ? Z.insertNodes(t, i) : (Z.wrapNodes(t, i, { split: !0 }), Z.collapse(t, { edge: "end" }));
}, z0 = (t) => {
  Z.unwrapNodes(t, {
    match: (e) => !R.isEditor(e) && ae.isElement(e) && (e == null ? void 0 : e.type) === "link"
  });
}, iz = (t, e, r) => {
  t.selection && N0(t, e, r);
}, sz = () => {
  const t = Dn(), { loc: e } = se(), { isOpen: r, onOpen: n, onClose: a } = xc(), i = Xc(t, "link"), s = () => {
    n();
  };
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(
      mi,
      {
        tooltip: e("insertLink"),
        active: !i,
        disabled: i,
        onMouseDown: s,
        children: /* @__PURE__ */ x.jsx(xu, { color: "inherit" })
      }
    ),
    /* @__PURE__ */ x.jsx(
      mi,
      {
        tooltip: e("removeLink"),
        active: i,
        onMouseDown: (l) => {
          l.preventDefault(), i && z0(t);
        },
        children: /* @__PURE__ */ x.jsx(fb, { color: "inherit" })
      }
    ),
    /* @__PURE__ */ x.jsx(
      nz,
      {
        onClose: a,
        isOpen: r,
        onSubmit: (l) => {
          iz(t, l.link, l.newTab);
        }
      }
    )
  ] });
}, oz = () => {
  const t = Dn(), { loc: e } = se(), { typography: r } = t.getMarks() || {}, [n, a] = (r || vi).split("-"), i = oe(
    (s) => {
      var p, g;
      const l = (p = s.target) == null ? void 0 : p.value, o = (g = s.target) == null ? void 0 : g.name;
      let u = "", c = "";
      o === "size" && (u = l, c = ja[u].includes(a) ? a : ja[u][0]), o === "weight" && (u = n, c = l);
      const f = `${u}-${c}`;
      f === vi ? t.removeMark(ht.TYPOGRAPHY) : t.addMark(ht.TYPOGRAPHY, f), K.focus(t);
    },
    [t, n, a]
  );
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx("select", { title: e("size"), name: "size", value: n, onChange: i, children: Object.keys(ja).map((s) => /* @__PURE__ */ x.jsx("option", { value: s, children: s }, s)) }),
    /* @__PURE__ */ x.jsx(
      "select",
      {
        title: e("weight"),
        name: "weight",
        value: a,
        disabled: ja[n].length <= 1,
        onChange: i,
        children: ja[n].map((s) => /* @__PURE__ */ x.jsx("option", { value: s, children: s }, s))
      }
    )
  ] });
}, lz = () => {
  const t = Dn(), { loc: e } = se(), r = Xc(t, "wrap-text"), n = () => {
    r ? Z.unwrapNodes(t, {
      match: (a) => !R.isEditor(a) && ae.isElement(a) && a.type === "wrap-text"
    }) : (Z.select(t, {
      anchor: R.start(t, []),
      focus: R.end(t, [])
    }), Z.wrapNodes(
      t,
      { type: "wrap-text" },
      {
        at: R.unhangRange(t, t.selection),
        split: !0
      }
    ));
  };
  return /* @__PURE__ */ x.jsx(mi, { tooltip: e("wrapText"), active: r, onClick: n, children: /* @__PURE__ */ x.jsx(db, { color: "inherit" }) });
}, Zc = ({ value: t = W0, margin: e, padding: r }) => {
  const { nodeToolbarRef: n } = Ht(oo), { loc: a } = se(), i = S7(az(LN(v7(IN())))), [s] = $e(i), {
    connectors: { connect: l },
    actions: { setProp: o }
  } = me(), { enabled: u } = Le((f) => ({
    enabled: f.options.enabled
  })), c = oe(
    (f) => {
      s.operations.some((g) => g.type !== "set_selection") && o((g) => {
        g.value = f;
      });
    },
    [o, s]
  );
  return xe(() => {
    s.children !== t && (s.selection = null, s.children = t, s.onChange());
  }, [s, t]), /* @__PURE__ */ x.jsx(
    "div",
    {
      ref: (f) => l(f),
      className: hn.richText,
      style: {
        margin: Ze(gr(e)),
        padding: Ze(r)
      },
      children: /* @__PURE__ */ x.jsxs(h7, { editor: s, initialValue: t, onChange: c, children: [
        (n == null ? void 0 : n.current) && /* @__PURE__ */ x.jsx(bc, { target: n.current, children: /* @__PURE__ */ x.jsxs("div", { className: hn.toolbar, children: [
          /* @__PURE__ */ x.jsx(oz, {}),
          /* @__PURE__ */ x.jsx(L7, {}),
          /* @__PURE__ */ x.jsx(N7, {}),
          /* @__PURE__ */ x.jsx(Rn, { format: "ordered-list", icon: pb, tooltip: a("numberedList") }),
          /* @__PURE__ */ x.jsx(Rn, { format: "unordered-list", icon: hb, tooltip: a("bulletedList") }),
          /* @__PURE__ */ x.jsx(Rn, { format: "left", icon: gb, tooltip: a("leftAlign") }),
          /* @__PURE__ */ x.jsx(Rn, { format: "center", icon: vb, tooltip: a("centerAlign") }),
          /* @__PURE__ */ x.jsx(Rn, { format: "right", icon: mb, tooltip: a("rightAlign") }),
          /* @__PURE__ */ x.jsx(Rn, { format: "justify", icon: yb, tooltip: a("justify") }),
          /* @__PURE__ */ x.jsx(lz, {}),
          /* @__PURE__ */ x.jsx(sz, {})
        ] }) }),
        /* @__PURE__ */ x.jsx(
          i7,
          {
            readOnly: !u,
            renderElement: q7,
            renderLeaf: G7,
            spellCheck: !0,
            autoFocus: !0,
            style: { minWidth: u ? "1.5em" : "unset" }
          }
        )
      ] })
    }
  );
}, W0 = [
  {
    type: "wrap-text",
    children: [{ type: "paragraph", children: [{ text: "Text" }] }]
  }
], uz = () => /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
  /* @__PURE__ */ x.jsx(qt, {}),
  /* @__PURE__ */ x.jsx(We, {}),
  /* @__PURE__ */ x.jsx(Xr, {})
] });
Zc.craft = {
  displayName: "richText",
  props: {
    value: W0,
    margin: [0, 0, dr, 0],
    padding: [0, 0, 0, 0]
  },
  related: {
    toolbar: uz
  },
  custom: {
    toolbox: {
      icon: /* @__PURE__ */ x.jsx(uv, { width: 30, color: "black" }),
      dataTestId: "rich-text-thumbnail"
    }
  }
};
const cz = "_head_bvoa6_1", fz = "_tabActions_bvoa6_5", dz = "_moveButton_bvoa6_9", pz = "_addButton_bvoa6_13", hz = "_removeButton_bvoa6_18", Jn = {
  head: cz,
  tabActions: fz,
  moveButton: dz,
  addButton: pz,
  removeButton: hz
}, gz = "_container_133rv_1", vz = "_containerDragging_133rv_1", wg = {
  container: gz,
  containerDragging: vz
}, fr = ({ children: t, className: e, selectedClassName: r }) => {
  const {
    selected: n,
    connectors: { connect: a }
  } = me((s) => ({
    selected: s.events.selected
  })), i = Fm();
  return /* @__PURE__ */ x.jsx(
    "div",
    {
      ref: (s) => a(s),
      className: ke(i ? wg.containerDragging : wg.container, e, {
        ...r && {
          [r]: n
        }
      }),
      "data-testid": "editor-node-container",
      children: t
    }
  );
};
fr.craft = {
  displayName: "container",
  isCanvas: !0
};
const H0 = {
  minWidth: 10
}, $i = (t) => ({
  id: crypto.randomUUID(),
  title: `Title ${t}`
}), Jc = {
  items: [$i(1)],
  size: "m",
  margin: [0, 0, dr, 0],
  padding: [0, 0, 0, 0]
}, U0 = (t) => {
  const {
    actions: { setProp: e },
    isActive: r
  } = me((g) => ({ isActive: g.events.selected })), [n, a] = $e(t[0].id), i = gt(() => t.find((g) => g.id === n), [t, n]), s = oe(
    (g) => {
      a(g.detail.value);
    },
    [a]
  ), l = oe(() => {
    e((g) => {
      g.items = [...g.items, $i(g.items.length + 1)];
      const m = g.items[g.items.length - 1].id;
      setTimeout(() => a(m), 0);
    });
  }, [e, a]), o = oe(
    (g) => () => {
      e((m) => {
        const d = m.items.findIndex((b) => b.id === g), w = m.items[d].id === n;
        m.items.splice(d, 1), w && a(m.items[Math.min(d, m.items.length - 1)].id);
      });
    },
    [e, n, a]
  ), u = oe(
    (g, m) => () => {
      e((d) => {
        const w = d.items.findIndex((B) => B.id === g), b = m === "forward" ? w - 1 : w + 1, O = [...d.items], S = O[w];
        O[w] = O[b], O[b] = S, d.items = O;
      });
    },
    [e]
  ), c = oe(
    (g) => (m) => {
      e(
        (d) => d.items = d.items.map((w) => w.id === g ? { ...w, title: m.target.value } : w)
      );
    },
    [e]
  ), f = gt(
    () => (g) => r ? /* @__PURE__ */ x.jsx(ji, { size: "s", onClick: l, className: Jn.addButton, ...g, children: /* @__PURE__ */ x.jsx(cv, { size: "s", color: "var(--wpp-text-color-success)" }) }) : null,
    [r, l]
  ), p = gt(
    () => ({
      id: g,
      i: m,
      length: d,
      direction: w = "horizontal"
    }) => r ? /* @__PURE__ */ x.jsxs("div", { className: Jn.tabActions, children: [
      /* @__PURE__ */ x.jsx(ji, { size: "s", className: Jn.moveButton, disabled: m === 0, onClick: u(g, "forward"), children: /* @__PURE__ */ x.jsx(Sf, { size: "s", direction: w === "horizontal" ? "left" : "top" }) }),
      /* @__PURE__ */ x.jsx(
        ji,
        {
          size: "s",
          className: Jn.moveButton,
          disabled: m === d - 1,
          onClick: u(g, "backward"),
          children: /* @__PURE__ */ x.jsx(Sf, { size: "s", direction: w === "horizontal" ? "right" : "down" })
        }
      ),
      /* @__PURE__ */ x.jsx(ji, { size: "s", className: Jn.removeButton, disabled: d === 1, onClick: o(g), children: /* @__PURE__ */ x.jsx(bu, { size: "s", color: "var(--wpp-text-color-danger)" }) })
    ] }) : null,
    [r, u, o]
  );
  return {
    AddItem: f,
    ItemActions: p,
    value: n,
    selectedItem: i,
    selectItem: s,
    changeTitle: c
  };
}, V0 = ({
  items: t = [],
  margin: e,
  padding: r,
  components: n,
  ...a
}) => {
  const {
    connectors: { connect: i }
  } = me(), { enabled: s } = Le((g) => ({
    enabled: g.options.enabled
  })), { AddItem: l, ItemActions: o, value: u, selectedItem: c, selectItem: f, changeTitle: p } = U0(t);
  return /* @__PURE__ */ x.jsxs(
    "div",
    {
      ref: (g) => i(g),
      style: {
        margin: Ze(gr(e)),
        padding: Ze(r)
      },
      children: [
        /* @__PURE__ */ x.jsxs(n.container, { value: u, onWppChange: f, className: Jn.head, ...a, children: [
          t.map((g, m) => /* @__PURE__ */ x.jsxs(n.item, { value: g.id, children: [
            /* @__PURE__ */ x.jsx(
              Sc,
              {
                html: g.title,
                disabled: !s,
                onChange: p(g.id),
                style: H0
              }
            ),
            s && /* @__PURE__ */ x.jsx(o, { id: g.id, i: m, length: t.length })
          ] }, g.id)),
          s ? /* @__PURE__ */ x.jsx(l, { style: { marginLeft: 5 } }) : null
        ] }),
        /* @__PURE__ */ x.jsx(Wr, { id: c.id, is: fr, canvas: !0 }, c.id)
      ]
    }
  );
}, mz = {
  container: bb,
  item: wb
}, yz = ["s", "m"], Qc = (t) => /* @__PURE__ */ x.jsx(V0, { components: mz, ...t }), bz = () => {
  const { loc: t } = se();
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(at, { children: /* @__PURE__ */ x.jsx(Re, { full: !0, propKey: "size", type: "select", label: t("size"), children: yz.map((e) => /* @__PURE__ */ x.jsx(Qt, { value: e, label: e }, e)) }) }),
    /* @__PURE__ */ x.jsx(We, {}),
    /* @__PURE__ */ x.jsx(qt, {}),
    /* @__PURE__ */ x.jsx(We, {}),
    /* @__PURE__ */ x.jsx(Xr, {})
  ] });
};
Qc.craft = {
  displayName: "tabs",
  props: {
    ...Jc
  },
  related: {
    toolbar: bz
  },
  custom: {
    toolbox: {
      icon: /* @__PURE__ */ x.jsx(Eu, { width: 30, color: "black" }),
      dataTestId: "tabs-thumbnail"
    }
  }
};
const wz = {
  container: wu,
  item: oi
}, xz = ["s", "m"], ef = (t) => /* @__PURE__ */ x.jsx(V0, { components: wz, ...t }), Ez = () => {
  const { loc: t } = se();
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(at, { children: /* @__PURE__ */ x.jsx(Re, { full: !0, propKey: "size", type: "select", label: t("size"), children: xz.map((e) => /* @__PURE__ */ x.jsx(Qt, { value: e, label: e }, e)) }) }),
    /* @__PURE__ */ x.jsx(We, {}),
    /* @__PURE__ */ x.jsx(qt, {}),
    /* @__PURE__ */ x.jsx(We, {}),
    /* @__PURE__ */ x.jsx(Xr, {})
  ] });
};
ef.craft = {
  displayName: "segments",
  props: {
    ...Jc
  },
  related: {
    toolbar: Ez
  },
  custom: {
    toolbox: {
      icon: /* @__PURE__ */ x.jsx(Eu, { width: 30, color: "black" }),
      dataTestId: "segmments-thumbnail"
    }
  }
};
const Cz = ["s", "m", "l", "xl", "2xl"], Dz = {
  s: "s-strong",
  m: "m-strong",
  l: "l-strong",
  xl: "xl-heading",
  "2xl": "2xl-heading"
}, tf = ({
  items: t = [],
  size: e,
  margin: r,
  padding: n,
  expanded: a = !0,
  withDivider: i = !0
}) => {
  const {
    connectors: { connect: s }
  } = me(), { enabled: l } = Le((f) => ({
    enabled: f.options.enabled
  })), { AddItem: o, ItemActions: u, changeTitle: c } = U0(t);
  return /* @__PURE__ */ x.jsxs(
    "div",
    {
      ref: (f) => s(f),
      style: {
        margin: Ze(gr(r)),
        padding: Ze(n)
      },
      children: [
        t.map((f, p) => /* @__PURE__ */ x.jsxs(xb, { size: e, expanded: a, withDivider: i, children: [
          /* @__PURE__ */ x.jsxs(fe, { slot: "header", align: "center", children: [
            /* @__PURE__ */ x.jsx(_e, { type: Dz[e], children: /* @__PURE__ */ x.jsx(
              Sc,
              {
                html: f.title,
                disabled: !l,
                onChange: c(f.id),
                style: H0
              }
            ) }),
            l && /* @__PURE__ */ x.jsx(u, { id: f.id, i: p, length: t.length, direction: "vertical" })
          ] }),
          /* @__PURE__ */ x.jsx(Wr, { id: f.id, is: fr }, f.id)
        ] }, f.id)),
        l ? /* @__PURE__ */ x.jsx(o, { style: { marginTop: 10 } }) : null
      ]
    }
  );
}, Sz = () => {
  const { loc: t } = se();
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs(at, { children: [
      /* @__PURE__ */ x.jsx(Re, { full: !0, propKey: "size", type: "select", label: t("size"), children: Cz.map((e) => /* @__PURE__ */ x.jsx(Qt, { value: e, label: e }, e)) }),
      /* @__PURE__ */ x.jsx(Re, { propKey: "expanded", type: "checkbox", label: t("expanded") }),
      /* @__PURE__ */ x.jsx(Re, { propKey: "withDivider", type: "checkbox", label: t("withDivider") })
    ] }),
    /* @__PURE__ */ x.jsx(We, {}),
    /* @__PURE__ */ x.jsx(qt, {}),
    /* @__PURE__ */ x.jsx(We, {}),
    /* @__PURE__ */ x.jsx(Xr, {})
  ] });
};
tf.craft = {
  displayName: "accordion",
  props: {
    ...Jc,
    expanded: !0,
    withDivider: !0,
    items: [$i(1)]
  },
  related: {
    toolbar: Sz
  },
  custom: {
    toolbox: {
      icon: /* @__PURE__ */ x.jsx(Eu, { width: 30, color: "black" }),
      dataTestId: "accordion-thumbnail"
    }
  }
};
const Oz = "_box_1uqqm_1", Pz = {
  box: Oz
}, _z = (t) => /* @__PURE__ */ we.createElement("svg", { width: 45, height: 33, viewBox: "0 0 45 33", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ we.createElement("rect", { x: 2, y: 0, width: 11, height: 33, rx: 4, fill: "var(--wpp-grey-color-1000)" }), /* @__PURE__ */ we.createElement("rect", { x: 18, y: 0, width: 11, height: 33, rx: 4, fill: "var(--wpp-grey-color-1000)" }), /* @__PURE__ */ we.createElement("rect", { x: 34, y: 0, width: 11, height: 33, rx: 4, fill: "var(--wpp-grey-color-1000)" })), rf = ({ margin: t, padding: e }) => {
  const {
    connectors: { connect: r }
  } = me();
  return /* @__PURE__ */ x.jsxs(
    "div",
    {
      ref: (n) => r(n),
      className: Pz.box,
      style: {
        margin: Ze(gr(t)),
        padding: Ze(e)
      },
      children: [
        /* @__PURE__ */ x.jsx(Wr, { id: "first", is: fr }),
        /* @__PURE__ */ x.jsx(Wr, { id: "second", is: fr }),
        /* @__PURE__ */ x.jsx(Wr, { id: "third", is: fr })
      ]
    }
  );
}, Az = () => /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
  /* @__PURE__ */ x.jsx(qt, {}),
  /* @__PURE__ */ x.jsx(We, {}),
  /* @__PURE__ */ x.jsx(Xr, {})
] });
rf.craft = {
  displayName: "threeColumns",
  props: {
    margin: [0, 0, dr, 0],
    padding: [0, 0, 0, 0]
  },
  related: {
    toolbar: Az
  },
  custom: {
    toolbox: {
      icon: /* @__PURE__ */ x.jsx(_z, {}),
      dataTestId: "three-columns-thumbnail"
    }
  }
};
const Tz = (t) => /* @__PURE__ */ we.createElement("svg", { width: 45, height: 33, viewBox: "0 0 45 33", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ we.createElement("rect", { width: 19, height: 33, rx: 4, fill: "var(--wpp-grey-color-1000)" }), /* @__PURE__ */ we.createElement("rect", { x: 24, width: 19, height: 33, rx: 4, fill: "var(--wpp-grey-color-1000)" })), Bz = "_box_136te_1", Rz = "_oneOne_136te_8", $z = "_twoOne_136te_12", Mz = "_oneTwo_136te_16", Fz = "_settings_136te_20", us = {
  box: Bz,
  oneOne: Rz,
  twoOne: $z,
  oneTwo: Mz,
  settings: Fz
}, Iz = (t) => /* @__PURE__ */ we.createElement("svg", { width: 126, height: 98, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ we.createElement("rect", { width: 59, height: 98, rx: 4, fill: "#F4F5F7" }), /* @__PURE__ */ we.createElement("rect", { x: 67, width: 59, height: 98, rx: 4, fill: "#F4F5F7" })), jz = (t) => /* @__PURE__ */ we.createElement("svg", { width: 126, height: 98, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ we.createElement("rect", { width: 34, height: 98, rx: 4, fill: "#F4F5F7" }), /* @__PURE__ */ we.createElement("rect", { x: 42, width: 84, height: 98, rx: 4, fill: "#F4F5F7" })), nf = ({ columnLayout: t, margin: e, padding: r }) => {
  const {
    connectors: { connect: n }
  } = me();
  return /* @__PURE__ */ x.jsxs(
    "div",
    {
      ref: (a) => n(a),
      className: ke(us.box, {
        [us.oneOne]: t === "1-1",
        [us.oneTwo]: t === "1-2"
      }),
      style: {
        margin: Ze(gr(e)),
        padding: Ze(r)
      },
      children: [
        /* @__PURE__ */ x.jsx(Wr, { id: "left", is: fr }),
        /* @__PURE__ */ x.jsx(Wr, { id: "right", is: fr })
      ]
    }
  );
}, Lz = () => {
  const { loc: t } = se(), {
    actions: { setProp: e },
    columnLayout: r
  } = me((a) => ({
    columnLayout: a.data.props.columnLayout
  })), n = (a) => {
    e((i) => i.columnLayout = a.detail.value);
  };
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(at, { children: /* @__PURE__ */ x.jsxs(iv, { className: us.settings, value: r, onWppChange: n, children: [
      /* @__PURE__ */ x.jsxs(ps, { size: "s", value: "1-1", children: [
        /* @__PURE__ */ x.jsx(Iz, {}),
        /* @__PURE__ */ x.jsx(_e, { type: "xs-strong", slot: "header", children: t("twoColumn") })
      ] }),
      /* @__PURE__ */ x.jsxs(ps, { size: "s", value: "1-2", children: [
        /* @__PURE__ */ x.jsx(jz, {}),
        /* @__PURE__ */ x.jsx(_e, { type: "xs-strong", slot: "header", children: t("twoColumn37") })
      ] })
    ] }) }),
    /* @__PURE__ */ x.jsx(We, {}),
    /* @__PURE__ */ x.jsx(qt, {}),
    /* @__PURE__ */ x.jsx(We, {}),
    /* @__PURE__ */ x.jsx(Xr, {})
  ] });
};
nf.craft = {
  displayName: "twoColumns",
  props: {
    columnLayout: "1-1",
    margin: [0, 0, dr, 0],
    padding: [0, 0, 0, 0]
  },
  related: {
    toolbar: Lz
  },
  custom: {
    toolbox: { icon: /* @__PURE__ */ x.jsx(Tz, {}), dataTestId: "two-columns-thumbnail" }
  }
};
var q0 = {}, G0 = {}, Ne = {}, kz = function(e, r, n) {
  var a = document.head || document.getElementsByTagName("head")[0], i = document.createElement("script");
  typeof r == "function" && (n = r, r = {}), r = r || {}, n = n || function() {
  }, i.type = r.type || "text/javascript", i.charset = r.charset || "utf8", i.async = "async" in r ? !!r.async : !0, i.src = e, r.attrs && Nz(i, r.attrs), r.text && (i.text = "" + r.text);
  var s = "onload" in i ? xg : zz;
  s(i, n), i.onload || xg(i, n), a.appendChild(i);
};
function Nz(t, e) {
  for (var r in e)
    t.setAttribute(r, e[r]);
}
function xg(t, e) {
  t.onload = function() {
    this.onerror = this.onload = null, e(null, t);
  }, t.onerror = function() {
    this.onerror = this.onload = null, e(new Error("Failed to load " + this.src), t);
  };
}
function zz(t, e) {
  t.onreadystatechange = function() {
    this.readyState != "complete" && this.readyState != "loaded" || (this.onreadystatechange = null, e(null, t));
  };
}
var Wz = function(e) {
  return Hz(e) && !Uz(e);
};
function Hz(t) {
  return !!t && typeof t == "object";
}
function Uz(t) {
  var e = Object.prototype.toString.call(t);
  return e === "[object RegExp]" || e === "[object Date]" || Gz(t);
}
var Vz = typeof Symbol == "function" && Symbol.for, qz = Vz ? Symbol.for("react.element") : 60103;
function Gz(t) {
  return t.$$typeof === qz;
}
function Yz(t) {
  return Array.isArray(t) ? [] : {};
}
function yi(t, e) {
  return e.clone !== !1 && e.isMergeableObject(t) ? ca(Yz(t), t, e) : t;
}
function Kz(t, e, r) {
  return t.concat(e).map(function(n) {
    return yi(n, r);
  });
}
function Xz(t, e) {
  if (!e.customMerge)
    return ca;
  var r = e.customMerge(t);
  return typeof r == "function" ? r : ca;
}
function Zz(t) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(t).filter(function(e) {
    return Object.propertyIsEnumerable.call(t, e);
  }) : [];
}
function Eg(t) {
  return Object.keys(t).concat(Zz(t));
}
function Y0(t, e) {
  try {
    return e in t;
  } catch {
    return !1;
  }
}
function Jz(t, e) {
  return Y0(t, e) && !(Object.hasOwnProperty.call(t, e) && Object.propertyIsEnumerable.call(t, e));
}
function Qz(t, e, r) {
  var n = {};
  return r.isMergeableObject(t) && Eg(t).forEach(function(a) {
    n[a] = yi(t[a], r);
  }), Eg(e).forEach(function(a) {
    Jz(t, a) || (Y0(t, a) && r.isMergeableObject(e[a]) ? n[a] = Xz(a, r)(t[a], e[a], r) : n[a] = yi(e[a], r));
  }), n;
}
function ca(t, e, r) {
  r = r || {}, r.arrayMerge = r.arrayMerge || Kz, r.isMergeableObject = r.isMergeableObject || Wz, r.cloneUnlessOtherwiseSpecified = yi;
  var n = Array.isArray(e), a = Array.isArray(t), i = n === a;
  return i ? n ? r.arrayMerge(t, e, r) : Qz(t, e, r) : yi(e, r);
}
ca.all = function(e, r) {
  if (!Array.isArray(e))
    throw new Error("first argument should be an array");
  return e.reduce(function(n, a) {
    return ca(n, a, r);
  }, {});
};
var eW = ca, K0 = eW;
Object.defineProperty(Ne, "__esModule", {
  value: !0
});
Ne.parseStartTime = dW;
Ne.parseEndTime = pW;
Ne.randomString = hW;
Ne.queryString = gW;
Ne.getSDK = vW;
Ne.getConfig = mW;
Ne.omit = yW;
Ne.callPlayer = bW;
Ne.isMediaStream = wW;
Ne.isBlobUrl = xW;
Ne.supportsWebKitPresentationMode = EW;
var tW = X0(kz), rW = X0(K0);
function X0(t) {
  return t && t.__esModule ? t : { default: t };
}
function nW(t, e) {
  return oW(t) || sW(t, e) || iW(t, e) || aW();
}
function aW() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function iW(t, e) {
  if (t) {
    if (typeof t == "string")
      return Cg(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
      return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Cg(t, e);
  }
}
function Cg(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function sW(t, e) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(t)))) {
    var r = [], n = !0, a = !1, i = void 0;
    try {
      for (var s = t[Symbol.iterator](), l; !(n = (l = s.next()).done) && (r.push(l.value), !(e && r.length === e)); n = !0)
        ;
    } catch (o) {
      a = !0, i = o;
    } finally {
      try {
        !n && s.return != null && s.return();
      } finally {
        if (a)
          throw i;
      }
    }
    return r;
  }
}
function oW(t) {
  if (Array.isArray(t))
    return t;
}
var lW = /[?&#](?:start|t)=([0-9hms]+)/, uW = /[?&#]end=([0-9hms]+)/, fu = /(\d+)(h|m|s)/g, cW = /^\d+$/;
function Z0(t, e) {
  if (!(t instanceof Array)) {
    var r = t.match(e);
    if (r) {
      var n = r[1];
      if (n.match(fu))
        return fW(n);
      if (cW.test(n))
        return parseInt(n);
    }
  }
}
function fW(t) {
  for (var e = 0, r = fu.exec(t); r !== null; ) {
    var n = r, a = nW(n, 3), i = a[1], s = a[2];
    s === "h" && (e += parseInt(i, 10) * 60 * 60), s === "m" && (e += parseInt(i, 10) * 60), s === "s" && (e += parseInt(i, 10)), r = fu.exec(t);
  }
  return e;
}
function dW(t) {
  return Z0(t, lW);
}
function pW(t) {
  return Z0(t, uW);
}
function hW() {
  return Math.random().toString(36).substr(2, 5);
}
function gW(t) {
  return Object.keys(t).map(function(e) {
    return "".concat(e, "=").concat(t[e]);
  }).join("&");
}
function ll(t) {
  return window[t] ? window[t] : window.exports && window.exports[t] ? window.exports[t] : window.module && window.module.exports && window.module.exports[t] ? window.module.exports[t] : null;
}
var $n = {};
function vW(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function() {
    return !0;
  }, a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : tW.default, i = ll(e);
  return i && n(i) ? Promise.resolve(i) : new Promise(function(s, l) {
    if ($n[t]) {
      $n[t].push({
        resolve: s,
        reject: l
      });
      return;
    }
    $n[t] = [{
      resolve: s,
      reject: l
    }];
    var o = function(f) {
      $n[t].forEach(function(p) {
        return p.resolve(f);
      });
    };
    if (r) {
      var u = window[r];
      window[r] = function() {
        u && u(), o(ll(e));
      };
    }
    a(t, function(c) {
      c ? ($n[t].forEach(function(f) {
        return f.reject(c);
      }), $n[t] = null) : r || o(ll(e));
    });
  });
}
function mW(t, e) {
  return (0, rW.default)(e.config, t.config);
}
function yW(t) {
  for (var e, r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
    n[a - 1] = arguments[a];
  for (var i = (e = []).concat.apply(e, n), s = {}, l = Object.keys(t), o = 0, u = l; o < u.length; o++) {
    var c = u[o];
    i.indexOf(c) === -1 && (s[c] = t[c]);
  }
  return s;
}
function bW(t) {
  var e;
  if (!this.player || !this.player[t]) {
    var r = "ReactPlayer: ".concat(this.constructor.displayName, " player could not call %c").concat(t, "%c – ");
    return this.player ? this.player[t] || (r += "The method was not available") : r += "The player was not available", console.warn(r, "font-weight: bold", ""), null;
  }
  for (var n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    a[i - 1] = arguments[i];
  return (e = this.player)[t].apply(e, a);
}
function wW(t) {
  return typeof window < "u" && typeof window.MediaStream < "u" && t instanceof window.MediaStream;
}
function xW(t) {
  return /^blob:/.test(t);
}
function EW() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document.createElement("video"), e = /iPhone|iPod/.test(navigator.userAgent) === !1;
  return t.webkitSupportsPresentationMode && typeof t.webkitSetPresentationMode == "function" && e;
}
var ce = {};
Object.defineProperty(ce, "__esModule", {
  value: !0
});
ce.canPlay = ce.FLV_EXTENSIONS = ce.DASH_EXTENSIONS = ce.HLS_EXTENSIONS = ce.VIDEO_EXTENSIONS = ce.AUDIO_EXTENSIONS = ce.MATCH_URL_KALTURA = ce.MATCH_URL_VIDYARD = ce.MATCH_URL_MIXCLOUD = ce.MATCH_URL_DAILYMOTION = ce.MATCH_URL_TWITCH_CHANNEL = ce.MATCH_URL_TWITCH_VIDEO = ce.MATCH_URL_WISTIA = ce.MATCH_URL_STREAMABLE = ce.MATCH_URL_FACEBOOK_WATCH = ce.MATCH_URL_FACEBOOK = ce.MATCH_URL_VIMEO = ce.MATCH_URL_SOUNDCLOUD = ce.MATCH_URL_YOUTUBE = void 0;
var Dg = Ne;
function CW(t, e) {
  var r;
  if (typeof Symbol > "u" || t[Symbol.iterator] == null) {
    if (Array.isArray(t) || (r = DW(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var n = 0, a = function() {
      };
      return { s: a, n: function() {
        return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
      }, e: function(u) {
        throw u;
      }, f: a };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i = !0, s = !1, l;
  return { s: function() {
    r = t[Symbol.iterator]();
  }, n: function() {
    var u = r.next();
    return i = u.done, u;
  }, e: function(u) {
    s = !0, l = u;
  }, f: function() {
    try {
      !i && r.return != null && r.return();
    } finally {
      if (s)
        throw l;
    }
  } };
}
function DW(t, e) {
  if (t) {
    if (typeof t == "string")
      return Sg(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
      return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Sg(t, e);
  }
}
function Sg(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
var du = /(?:youtu\.be\/|youtube(?:-nocookie|education)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=|shorts\/|live\/))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//;
ce.MATCH_URL_YOUTUBE = du;
var J0 = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/;
ce.MATCH_URL_SOUNDCLOUD = J0;
var Q0 = /vimeo\.com\/(?!progressive_redirect).+/;
ce.MATCH_URL_VIMEO = Q0;
var ey = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/;
ce.MATCH_URL_FACEBOOK = ey;
var ty = /^https?:\/\/fb\.watch\/.+$/;
ce.MATCH_URL_FACEBOOK_WATCH = ty;
var ry = /streamable\.com\/([a-z0-9]+)$/;
ce.MATCH_URL_STREAMABLE = ry;
var ny = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?([^?]+)/;
ce.MATCH_URL_WISTIA = ny;
var ay = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
ce.MATCH_URL_TWITCH_VIDEO = ay;
var iy = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+)($|\?)/;
ce.MATCH_URL_TWITCH_CHANNEL = iy;
var sy = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?(?:[\w.#_-]+)?/;
ce.MATCH_URL_DAILYMOTION = sy;
var oy = /mixcloud\.com\/([^/]+\/[^/]+)/;
ce.MATCH_URL_MIXCLOUD = oy;
var ly = /vidyard.com\/(?:watch\/)?([a-zA-Z0-9-_]+)/;
ce.MATCH_URL_VIDYARD = ly;
var uy = /^https?:\/\/[a-zA-Z]+\.kaltura.(com|org)\/p\/([0-9]+)\/sp\/([0-9]+)00\/embedIframeJs\/uiconf_id\/([0-9]+)\/partner_id\/([0-9]+)(.*)entry_id.([a-zA-Z0-9-_].*)$/;
ce.MATCH_URL_KALTURA = uy;
var af = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
ce.AUDIO_EXTENSIONS = af;
var sf = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i;
ce.VIDEO_EXTENSIONS = sf;
var of = /\.(m3u8)($|\?)/i;
ce.HLS_EXTENSIONS = of;
var cy = /\.(mpd)($|\?)/i;
ce.DASH_EXTENSIONS = cy;
var fy = /\.(flv)($|\?)/i;
ce.FLV_EXTENSIONS = fy;
var SW = function t(e) {
  if (e instanceof Array) {
    var r = CW(e), n;
    try {
      for (r.s(); !(n = r.n()).done; ) {
        var a = n.value;
        if (typeof a == "string" && t(a) || t(a.src))
          return !0;
      }
    } catch (i) {
      r.e(i);
    } finally {
      r.f();
    }
    return !1;
  }
  return (0, Dg.isMediaStream)(e) || (0, Dg.isBlobUrl)(e) ? !0 : af.test(e) || sf.test(e) || of.test(e) || cy.test(e) || fy.test(e);
}, OW = {
  youtube: function(e) {
    return e instanceof Array ? e.every(function(r) {
      return du.test(r);
    }) : du.test(e);
  },
  soundcloud: function(e) {
    return J0.test(e) && !af.test(e);
  },
  vimeo: function(e) {
    return Q0.test(e) && !sf.test(e) && !of.test(e);
  },
  facebook: function(e) {
    return ey.test(e) || ty.test(e);
  },
  streamable: function(e) {
    return ry.test(e);
  },
  wistia: function(e) {
    return ny.test(e);
  },
  twitch: function(e) {
    return ay.test(e) || iy.test(e);
  },
  dailymotion: function(e) {
    return sy.test(e);
  },
  mixcloud: function(e) {
    return oy.test(e);
  },
  vidyard: function(e) {
    return ly.test(e);
  },
  kaltura: function(e) {
    return uy.test(e);
  },
  file: SW
};
ce.canPlay = OW;
var ul = {}, Og;
function PW() {
  return Og || (Og = 1, function(t) {
    function e(I) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(k) {
        return typeof k;
      } : e = function(k) {
        return k && typeof Symbol == "function" && k.constructor === Symbol && k !== Symbol.prototype ? "symbol" : typeof k;
      }, e(I);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = s(M), n = Ne, a = ce;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var I = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return I;
      }, I;
    }
    function s(I) {
      if (I && I.__esModule)
        return I;
      if (I === null || e(I) !== "object" && typeof I != "function")
        return { default: I };
      var F = i();
      if (F && F.has(I))
        return F.get(I);
      var k = {}, N = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var U in I)
        if (Object.prototype.hasOwnProperty.call(I, U)) {
          var Y = N ? Object.getOwnPropertyDescriptor(I, U) : null;
          Y && (Y.get || Y.set) ? Object.defineProperty(k, U, Y) : k[U] = I[U];
        }
      return k.default = I, F && F.set(I, k), k;
    }
    function l(I, F) {
      var k = Object.keys(I);
      if (Object.getOwnPropertySymbols) {
        var N = Object.getOwnPropertySymbols(I);
        F && (N = N.filter(function(U) {
          return Object.getOwnPropertyDescriptor(I, U).enumerable;
        })), k.push.apply(k, N);
      }
      return k;
    }
    function o(I) {
      for (var F = 1; F < arguments.length; F++) {
        var k = arguments[F] != null ? arguments[F] : {};
        F % 2 ? l(Object(k), !0).forEach(function(N) {
          y(I, N, k[N]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(I, Object.getOwnPropertyDescriptors(k)) : l(Object(k)).forEach(function(N) {
          Object.defineProperty(I, N, Object.getOwnPropertyDescriptor(k, N));
        });
      }
      return I;
    }
    function u(I, F) {
      return m(I) || g(I, F) || f(I, F) || c();
    }
    function c() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function f(I, F) {
      if (I) {
        if (typeof I == "string")
          return p(I, F);
        var k = Object.prototype.toString.call(I).slice(8, -1);
        if (k === "Object" && I.constructor && (k = I.constructor.name), k === "Map" || k === "Set")
          return Array.from(I);
        if (k === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(k))
          return p(I, F);
      }
    }
    function p(I, F) {
      (F == null || F > I.length) && (F = I.length);
      for (var k = 0, N = new Array(F); k < F; k++)
        N[k] = I[k];
      return N;
    }
    function g(I, F) {
      if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(I)))) {
        var k = [], N = !0, U = !1, Y = void 0;
        try {
          for (var L = I[Symbol.iterator](), q; !(N = (q = L.next()).done) && (k.push(q.value), !(F && k.length === F)); N = !0)
            ;
        } catch (V) {
          U = !0, Y = V;
        } finally {
          try {
            !N && L.return != null && L.return();
          } finally {
            if (U)
              throw Y;
          }
        }
        return k;
      }
    }
    function m(I) {
      if (Array.isArray(I))
        return I;
    }
    function d(I, F) {
      if (!(I instanceof F))
        throw new TypeError("Cannot call a class as a function");
    }
    function w(I, F) {
      for (var k = 0; k < F.length; k++) {
        var N = F[k];
        N.enumerable = N.enumerable || !1, N.configurable = !0, "value" in N && (N.writable = !0), Object.defineProperty(I, N.key, N);
      }
    }
    function b(I, F, k) {
      return F && w(I.prototype, F), k && w(I, k), I;
    }
    function O(I, F) {
      if (typeof F != "function" && F !== null)
        throw new TypeError("Super expression must either be null or a function");
      I.prototype = Object.create(F && F.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), F && S(I, F);
    }
    function S(I, F) {
      return S = Object.setPrototypeOf || function(N, U) {
        return N.__proto__ = U, N;
      }, S(I, F);
    }
    function B(I) {
      var F = D();
      return function() {
        var N = h(I), U;
        if (F) {
          var Y = h(this).constructor;
          U = Reflect.construct(N, arguments, Y);
        } else
          U = N.apply(this, arguments);
        return T(this, U);
      };
    }
    function T(I, F) {
      return F && (e(F) === "object" || typeof F == "function") ? F : A(I);
    }
    function A(I) {
      if (I === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return I;
    }
    function D() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function h(I) {
      return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(k) {
        return k.__proto__ || Object.getPrototypeOf(k);
      }, h(I);
    }
    function y(I, F, k) {
      return F in I ? Object.defineProperty(I, F, { value: k, enumerable: !0, configurable: !0, writable: !0 }) : I[F] = k, I;
    }
    var v = "https://www.youtube.com/iframe_api", E = "YT", _ = "onYouTubeIframeAPIReady", C = /[?&](?:list|channel)=([a-zA-Z0-9_-]+)/, P = /user\/([a-zA-Z0-9_-]+)\/?/, $ = /youtube-nocookie\.com/, W = "https://www.youtube-nocookie.com", j = /* @__PURE__ */ function(I) {
      O(k, I);
      var F = B(k);
      function k() {
        var N;
        d(this, k);
        for (var U = arguments.length, Y = new Array(U), L = 0; L < U; L++)
          Y[L] = arguments[L];
        return N = F.call.apply(F, [this].concat(Y)), y(A(N), "callPlayer", n.callPlayer), y(A(N), "parsePlaylist", function(q) {
          if (q instanceof Array)
            return {
              listType: "playlist",
              playlist: q.map(N.getID).join(",")
            };
          if (C.test(q)) {
            var V = q.match(C), X = u(V, 2), te = X[1];
            return {
              listType: "playlist",
              list: te.replace(/^UC/, "UU")
            };
          }
          if (P.test(q)) {
            var re = q.match(P), ue = u(re, 2), pe = ue[1];
            return {
              listType: "user_uploads",
              list: pe
            };
          }
          return {};
        }), y(A(N), "onStateChange", function(q) {
          var V = q.data, X = N.props, te = X.onPlay, re = X.onPause, ue = X.onBuffer, pe = X.onBufferEnd, ye = X.onEnded, Ce = X.onReady, be = X.loop, Ie = X.config, Me = Ie.playerVars, Ae = Ie.onUnstarted, Be = window[E].PlayerState, Ke = Be.UNSTARTED, st = Be.PLAYING, vt = Be.PAUSED, je = Be.BUFFERING, lt = Be.ENDED, Dt = Be.CUED;
          if (V === Ke && Ae(), V === st && (te(), pe()), V === vt && re(), V === je && ue(), V === lt) {
            var Se = !!N.callPlayer("getPlaylist");
            be && !Se && (Me.start ? N.seekTo(Me.start) : N.play()), ye();
          }
          V === Dt && Ce();
        }), y(A(N), "mute", function() {
          N.callPlayer("mute");
        }), y(A(N), "unmute", function() {
          N.callPlayer("unMute");
        }), y(A(N), "ref", function(q) {
          N.container = q;
        }), N;
      }
      return b(k, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "getID",
        value: function(U) {
          return !U || U instanceof Array || C.test(U) ? null : U.match(a.MATCH_URL_YOUTUBE)[1];
        }
      }, {
        key: "load",
        value: function(U, Y) {
          var L = this, q = this.props, V = q.playing, X = q.muted, te = q.playsinline, re = q.controls, ue = q.loop, pe = q.config, ye = q.onError, Ce = pe.playerVars, be = pe.embedOptions, Ie = this.getID(U);
          if (Y) {
            if (C.test(U) || P.test(U) || U instanceof Array) {
              this.player.loadPlaylist(this.parsePlaylist(U));
              return;
            }
            this.player.cueVideoById({
              videoId: Ie,
              startSeconds: (0, n.parseStartTime)(U) || Ce.start,
              endSeconds: (0, n.parseEndTime)(U) || Ce.end
            });
            return;
          }
          (0, n.getSDK)(v, E, _, function(Me) {
            return Me.loaded;
          }).then(function(Me) {
            L.container && (L.player = new Me.Player(L.container, o({
              width: "100%",
              height: "100%",
              videoId: Ie,
              playerVars: o(o({
                autoplay: V ? 1 : 0,
                mute: X ? 1 : 0,
                controls: re ? 1 : 0,
                start: (0, n.parseStartTime)(U),
                end: (0, n.parseEndTime)(U),
                origin: window.location.origin,
                playsinline: te ? 1 : 0
              }, L.parsePlaylist(U)), Ce),
              events: {
                onReady: function() {
                  ue && L.player.setLoop(!0), L.props.onReady();
                },
                onPlaybackRateChange: function(Be) {
                  return L.props.onPlaybackRateChange(Be.data);
                },
                onPlaybackQualityChange: function(Be) {
                  return L.props.onPlaybackQualityChange(Be);
                },
                onStateChange: L.onStateChange,
                onError: function(Be) {
                  return ye(Be.data);
                }
              },
              host: $.test(U) ? W : void 0
            }, be)));
          }, ye), be.events && console.warn("Using `embedOptions.events` will likely break things. Use ReactPlayer’s callback props instead, eg onReady, onPlay, onPause");
        }
      }, {
        key: "play",
        value: function() {
          this.callPlayer("playVideo");
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pauseVideo");
        }
      }, {
        key: "stop",
        value: function() {
          document.body.contains(this.callPlayer("getIframe")) && this.callPlayer("stopVideo");
        }
      }, {
        key: "seekTo",
        value: function(U) {
          var Y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
          this.callPlayer("seekTo", U), !Y && !this.props.playing && this.pause();
        }
      }, {
        key: "setVolume",
        value: function(U) {
          this.callPlayer("setVolume", U * 100);
        }
      }, {
        key: "setPlaybackRate",
        value: function(U) {
          this.callPlayer("setPlaybackRate", U);
        }
      }, {
        key: "setLoop",
        value: function(U) {
          this.callPlayer("setLoop", U);
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.callPlayer("getDuration");
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.callPlayer("getCurrentTime");
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return this.callPlayer("getVideoLoadedFraction") * this.getDuration();
        }
      }, {
        key: "render",
        value: function() {
          var U = this.props.display, Y = {
            width: "100%",
            height: "100%",
            display: U
          };
          return /* @__PURE__ */ r.default.createElement("div", {
            style: Y
          }, /* @__PURE__ */ r.default.createElement("div", {
            ref: this.ref
          }));
        }
      }]), k;
    }(r.Component);
    t.default = j, y(j, "displayName", "YouTube"), y(j, "canPlay", a.canPlay.youtube);
  }(ul)), ul;
}
var cl = {}, Pg;
function _W() {
  return Pg || (Pg = 1, function(t) {
    function e(D) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(y) {
        return typeof y;
      } : e = function(y) {
        return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
      }, e(D);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = s(M), n = Ne, a = ce;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var D = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return D;
      }, D;
    }
    function s(D) {
      if (D && D.__esModule)
        return D;
      if (D === null || e(D) !== "object" && typeof D != "function")
        return { default: D };
      var h = i();
      if (h && h.has(D))
        return h.get(D);
      var y = {}, v = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var E in D)
        if (Object.prototype.hasOwnProperty.call(D, E)) {
          var _ = v ? Object.getOwnPropertyDescriptor(D, E) : null;
          _ && (_.get || _.set) ? Object.defineProperty(y, E, _) : y[E] = D[E];
        }
      return y.default = D, h && h.set(D, y), y;
    }
    function l(D, h) {
      var y = Object.keys(D);
      if (Object.getOwnPropertySymbols) {
        var v = Object.getOwnPropertySymbols(D);
        h && (v = v.filter(function(E) {
          return Object.getOwnPropertyDescriptor(D, E).enumerable;
        })), y.push.apply(y, v);
      }
      return y;
    }
    function o(D) {
      for (var h = 1; h < arguments.length; h++) {
        var y = arguments[h] != null ? arguments[h] : {};
        h % 2 ? l(Object(y), !0).forEach(function(v) {
          S(D, v, y[v]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(D, Object.getOwnPropertyDescriptors(y)) : l(Object(y)).forEach(function(v) {
          Object.defineProperty(D, v, Object.getOwnPropertyDescriptor(y, v));
        });
      }
      return D;
    }
    function u(D, h) {
      if (!(D instanceof h))
        throw new TypeError("Cannot call a class as a function");
    }
    function c(D, h) {
      for (var y = 0; y < h.length; y++) {
        var v = h[y];
        v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(D, v.key, v);
      }
    }
    function f(D, h, y) {
      return h && c(D.prototype, h), y && c(D, y), D;
    }
    function p(D, h) {
      if (typeof h != "function" && h !== null)
        throw new TypeError("Super expression must either be null or a function");
      D.prototype = Object.create(h && h.prototype, { constructor: { value: D, writable: !0, configurable: !0 } }), h && g(D, h);
    }
    function g(D, h) {
      return g = Object.setPrototypeOf || function(v, E) {
        return v.__proto__ = E, v;
      }, g(D, h);
    }
    function m(D) {
      var h = b();
      return function() {
        var v = O(D), E;
        if (h) {
          var _ = O(this).constructor;
          E = Reflect.construct(v, arguments, _);
        } else
          E = v.apply(this, arguments);
        return d(this, E);
      };
    }
    function d(D, h) {
      return h && (e(h) === "object" || typeof h == "function") ? h : w(D);
    }
    function w(D) {
      if (D === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return D;
    }
    function b() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function O(D) {
      return O = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
        return y.__proto__ || Object.getPrototypeOf(y);
      }, O(D);
    }
    function S(D, h, y) {
      return h in D ? Object.defineProperty(D, h, { value: y, enumerable: !0, configurable: !0, writable: !0 }) : D[h] = y, D;
    }
    var B = "https://w.soundcloud.com/player/api.js", T = "SC", A = /* @__PURE__ */ function(D) {
      p(y, D);
      var h = m(y);
      function y() {
        var v;
        u(this, y);
        for (var E = arguments.length, _ = new Array(E), C = 0; C < E; C++)
          _[C] = arguments[C];
        return v = h.call.apply(h, [this].concat(_)), S(w(v), "callPlayer", n.callPlayer), S(w(v), "duration", null), S(w(v), "currentTime", null), S(w(v), "fractionLoaded", null), S(w(v), "mute", function() {
          v.setVolume(0);
        }), S(w(v), "unmute", function() {
          v.props.volume !== null && v.setVolume(v.props.volume);
        }), S(w(v), "ref", function(P) {
          v.iframe = P;
        }), v;
      }
      return f(y, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "load",
        value: function(E, _) {
          var C = this;
          (0, n.getSDK)(B, T).then(function(P) {
            if (C.iframe) {
              var $ = P.Widget.Events, W = $.PLAY, j = $.PLAY_PROGRESS, I = $.PAUSE, F = $.FINISH, k = $.ERROR;
              _ || (C.player = P.Widget(C.iframe), C.player.bind(W, C.props.onPlay), C.player.bind(I, function() {
                var N = C.duration - C.currentTime;
                N < 0.05 || C.props.onPause();
              }), C.player.bind(j, function(N) {
                C.currentTime = N.currentPosition / 1e3, C.fractionLoaded = N.loadedProgress;
              }), C.player.bind(F, function() {
                return C.props.onEnded();
              }), C.player.bind(k, function(N) {
                return C.props.onError(N);
              })), C.player.load(E, o(o({}, C.props.config.options), {}, {
                callback: function() {
                  C.player.getDuration(function(U) {
                    C.duration = U / 1e3, C.props.onReady();
                  });
                }
              }));
            }
          });
        }
      }, {
        key: "play",
        value: function() {
          this.callPlayer("play");
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "stop",
        value: function() {
        }
      }, {
        key: "seekTo",
        value: function(E) {
          var _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.callPlayer("seekTo", E * 1e3), _ || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(E) {
          this.callPlayer("setVolume", E * 100);
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.duration;
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.currentTime;
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return this.fractionLoaded * this.duration;
        }
      }, {
        key: "render",
        value: function() {
          var E = this.props.display, _ = {
            width: "100%",
            height: "100%",
            display: E
          };
          return /* @__PURE__ */ r.default.createElement("iframe", {
            ref: this.ref,
            src: "https://w.soundcloud.com/player/?url=".concat(encodeURIComponent(this.props.url)),
            style: _,
            frameBorder: 0,
            allow: "autoplay"
          });
        }
      }]), y;
    }(r.Component);
    t.default = A, S(A, "displayName", "SoundCloud"), S(A, "canPlay", a.canPlay.soundcloud), S(A, "loopOnEnded", !0);
  }(cl)), cl;
}
var fl = {}, _g;
function AW() {
  return _g || (_g = 1, function(t) {
    function e(h) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(v) {
        return typeof v;
      } : e = function(v) {
        return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
      }, e(h);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = s(M), n = Ne, a = ce;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var h = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return h;
      }, h;
    }
    function s(h) {
      if (h && h.__esModule)
        return h;
      if (h === null || e(h) !== "object" && typeof h != "function")
        return { default: h };
      var y = i();
      if (y && y.has(h))
        return y.get(h);
      var v = {}, E = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var _ in h)
        if (Object.prototype.hasOwnProperty.call(h, _)) {
          var C = E ? Object.getOwnPropertyDescriptor(h, _) : null;
          C && (C.get || C.set) ? Object.defineProperty(v, _, C) : v[_] = h[_];
        }
      return v.default = h, y && y.set(h, v), v;
    }
    function l(h, y) {
      var v = Object.keys(h);
      if (Object.getOwnPropertySymbols) {
        var E = Object.getOwnPropertySymbols(h);
        y && (E = E.filter(function(_) {
          return Object.getOwnPropertyDescriptor(h, _).enumerable;
        })), v.push.apply(v, E);
      }
      return v;
    }
    function o(h) {
      for (var y = 1; y < arguments.length; y++) {
        var v = arguments[y] != null ? arguments[y] : {};
        y % 2 ? l(Object(v), !0).forEach(function(E) {
          S(h, E, v[E]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(h, Object.getOwnPropertyDescriptors(v)) : l(Object(v)).forEach(function(E) {
          Object.defineProperty(h, E, Object.getOwnPropertyDescriptor(v, E));
        });
      }
      return h;
    }
    function u(h, y) {
      if (!(h instanceof y))
        throw new TypeError("Cannot call a class as a function");
    }
    function c(h, y) {
      for (var v = 0; v < y.length; v++) {
        var E = y[v];
        E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(h, E.key, E);
      }
    }
    function f(h, y, v) {
      return y && c(h.prototype, y), v && c(h, v), h;
    }
    function p(h, y) {
      if (typeof y != "function" && y !== null)
        throw new TypeError("Super expression must either be null or a function");
      h.prototype = Object.create(y && y.prototype, { constructor: { value: h, writable: !0, configurable: !0 } }), y && g(h, y);
    }
    function g(h, y) {
      return g = Object.setPrototypeOf || function(E, _) {
        return E.__proto__ = _, E;
      }, g(h, y);
    }
    function m(h) {
      var y = b();
      return function() {
        var E = O(h), _;
        if (y) {
          var C = O(this).constructor;
          _ = Reflect.construct(E, arguments, C);
        } else
          _ = E.apply(this, arguments);
        return d(this, _);
      };
    }
    function d(h, y) {
      return y && (e(y) === "object" || typeof y == "function") ? y : w(h);
    }
    function w(h) {
      if (h === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return h;
    }
    function b() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function O(h) {
      return O = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
        return v.__proto__ || Object.getPrototypeOf(v);
      }, O(h);
    }
    function S(h, y, v) {
      return y in h ? Object.defineProperty(h, y, { value: v, enumerable: !0, configurable: !0, writable: !0 }) : h[y] = v, h;
    }
    var B = "https://player.vimeo.com/api/player.js", T = "Vimeo", A = function(y) {
      return y.replace("/manage/videos", "");
    }, D = /* @__PURE__ */ function(h) {
      p(v, h);
      var y = m(v);
      function v() {
        var E;
        u(this, v);
        for (var _ = arguments.length, C = new Array(_), P = 0; P < _; P++)
          C[P] = arguments[P];
        return E = y.call.apply(y, [this].concat(C)), S(w(E), "callPlayer", n.callPlayer), S(w(E), "duration", null), S(w(E), "currentTime", null), S(w(E), "secondsLoaded", null), S(w(E), "mute", function() {
          E.setMuted(!0);
        }), S(w(E), "unmute", function() {
          E.setMuted(!1);
        }), S(w(E), "ref", function($) {
          E.container = $;
        }), E;
      }
      return f(v, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "load",
        value: function(_) {
          var C = this;
          this.duration = null, (0, n.getSDK)(B, T).then(function(P) {
            if (C.container) {
              var $ = C.props.config, W = $.playerOptions, j = $.title;
              C.player = new P.Player(C.container, o({
                url: A(_),
                autoplay: C.props.playing,
                muted: C.props.muted,
                loop: C.props.loop,
                playsinline: C.props.playsinline,
                controls: C.props.controls
              }, W)), C.player.ready().then(function() {
                var I = C.container.querySelector("iframe");
                I.style.width = "100%", I.style.height = "100%", j && (I.title = j);
              }).catch(C.props.onError), C.player.on("loaded", function() {
                C.props.onReady(), C.refreshDuration();
              }), C.player.on("play", function() {
                C.props.onPlay(), C.refreshDuration();
              }), C.player.on("pause", C.props.onPause), C.player.on("seeked", function(I) {
                return C.props.onSeek(I.seconds);
              }), C.player.on("ended", C.props.onEnded), C.player.on("error", C.props.onError), C.player.on("timeupdate", function(I) {
                var F = I.seconds;
                C.currentTime = F;
              }), C.player.on("progress", function(I) {
                var F = I.seconds;
                C.secondsLoaded = F;
              }), C.player.on("bufferstart", C.props.onBuffer), C.player.on("bufferend", C.props.onBufferEnd), C.player.on("playbackratechange", function(I) {
                return C.props.onPlaybackRateChange(I.playbackRate);
              });
            }
          }, this.props.onError);
        }
      }, {
        key: "refreshDuration",
        value: function() {
          var _ = this;
          this.player.getDuration().then(function(C) {
            _.duration = C;
          });
        }
      }, {
        key: "play",
        value: function() {
          var _ = this.callPlayer("play");
          _ && _.catch(this.props.onError);
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "stop",
        value: function() {
          this.callPlayer("unload");
        }
      }, {
        key: "seekTo",
        value: function(_) {
          var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.callPlayer("setCurrentTime", _), C || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(_) {
          this.callPlayer("setVolume", _);
        }
      }, {
        key: "setMuted",
        value: function(_) {
          this.callPlayer("setMuted", _);
        }
      }, {
        key: "setLoop",
        value: function(_) {
          this.callPlayer("setLoop", _);
        }
      }, {
        key: "setPlaybackRate",
        value: function(_) {
          this.callPlayer("setPlaybackRate", _);
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.duration;
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.currentTime;
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return this.secondsLoaded;
        }
      }, {
        key: "render",
        value: function() {
          var _ = this.props.display, C = {
            width: "100%",
            height: "100%",
            overflow: "hidden",
            display: _
          };
          return /* @__PURE__ */ r.default.createElement("div", {
            key: this.props.url,
            ref: this.ref,
            style: C
          });
        }
      }]), v;
    }(r.Component);
    t.default = D, S(D, "displayName", "Vimeo"), S(D, "canPlay", a.canPlay.vimeo), S(D, "forceLoad", !0);
  }(fl)), fl;
}
var dl = {}, Ag;
function TW() {
  return Ag || (Ag = 1, function(t) {
    function e(h) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(v) {
        return typeof v;
      } : e = function(v) {
        return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
      }, e(h);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = s(M), n = Ne, a = ce;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var h = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return h;
      }, h;
    }
    function s(h) {
      if (h && h.__esModule)
        return h;
      if (h === null || e(h) !== "object" && typeof h != "function")
        return { default: h };
      var y = i();
      if (y && y.has(h))
        return y.get(h);
      var v = {}, E = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var _ in h)
        if (Object.prototype.hasOwnProperty.call(h, _)) {
          var C = E ? Object.getOwnPropertyDescriptor(h, _) : null;
          C && (C.get || C.set) ? Object.defineProperty(v, _, C) : v[_] = h[_];
        }
      return v.default = h, y && y.set(h, v), v;
    }
    function l() {
      return l = Object.assign || function(h) {
        for (var y = 1; y < arguments.length; y++) {
          var v = arguments[y];
          for (var E in v)
            Object.prototype.hasOwnProperty.call(v, E) && (h[E] = v[E]);
        }
        return h;
      }, l.apply(this, arguments);
    }
    function o(h, y) {
      if (!(h instanceof y))
        throw new TypeError("Cannot call a class as a function");
    }
    function u(h, y) {
      for (var v = 0; v < y.length; v++) {
        var E = y[v];
        E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(h, E.key, E);
      }
    }
    function c(h, y, v) {
      return y && u(h.prototype, y), v && u(h, v), h;
    }
    function f(h, y) {
      if (typeof y != "function" && y !== null)
        throw new TypeError("Super expression must either be null or a function");
      h.prototype = Object.create(y && y.prototype, { constructor: { value: h, writable: !0, configurable: !0 } }), y && p(h, y);
    }
    function p(h, y) {
      return p = Object.setPrototypeOf || function(E, _) {
        return E.__proto__ = _, E;
      }, p(h, y);
    }
    function g(h) {
      var y = w();
      return function() {
        var E = b(h), _;
        if (y) {
          var C = b(this).constructor;
          _ = Reflect.construct(E, arguments, C);
        } else
          _ = E.apply(this, arguments);
        return m(this, _);
      };
    }
    function m(h, y) {
      return y && (e(y) === "object" || typeof y == "function") ? y : d(h);
    }
    function d(h) {
      if (h === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return h;
    }
    function w() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function b(h) {
      return b = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
        return v.__proto__ || Object.getPrototypeOf(v);
      }, b(h);
    }
    function O(h, y, v) {
      return y in h ? Object.defineProperty(h, y, { value: v, enumerable: !0, configurable: !0, writable: !0 }) : h[y] = v, h;
    }
    var S = "https://connect.facebook.net/en_US/sdk.js", B = "FB", T = "fbAsyncInit", A = "facebook-player-", D = /* @__PURE__ */ function(h) {
      f(v, h);
      var y = g(v);
      function v() {
        var E;
        o(this, v);
        for (var _ = arguments.length, C = new Array(_), P = 0; P < _; P++)
          C[P] = arguments[P];
        return E = y.call.apply(y, [this].concat(C)), O(d(E), "callPlayer", n.callPlayer), O(d(E), "playerID", E.props.config.playerId || "".concat(A).concat((0, n.randomString)())), O(d(E), "mute", function() {
          E.callPlayer("mute");
        }), O(d(E), "unmute", function() {
          E.callPlayer("unmute");
        }), E;
      }
      return c(v, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "load",
        value: function(_, C) {
          var P = this;
          if (C) {
            (0, n.getSDK)(S, B, T).then(function($) {
              return $.XFBML.parse();
            });
            return;
          }
          (0, n.getSDK)(S, B, T).then(function($) {
            $.init({
              appId: P.props.config.appId,
              xfbml: !0,
              version: P.props.config.version
            }), $.Event.subscribe("xfbml.render", function(W) {
              P.props.onLoaded();
            }), $.Event.subscribe("xfbml.ready", function(W) {
              W.type === "video" && W.id === P.playerID && (P.player = W.instance, P.player.subscribe("startedPlaying", P.props.onPlay), P.player.subscribe("paused", P.props.onPause), P.player.subscribe("finishedPlaying", P.props.onEnded), P.player.subscribe("startedBuffering", P.props.onBuffer), P.player.subscribe("finishedBuffering", P.props.onBufferEnd), P.player.subscribe("error", P.props.onError), P.props.muted ? P.callPlayer("mute") : P.callPlayer("unmute"), P.props.onReady(), document.getElementById(P.playerID).querySelector("iframe").style.visibility = "visible");
            });
          });
        }
      }, {
        key: "play",
        value: function() {
          this.callPlayer("play");
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "stop",
        value: function() {
        }
      }, {
        key: "seekTo",
        value: function(_) {
          var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.callPlayer("seek", _), C || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(_) {
          this.callPlayer("setVolume", _);
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.callPlayer("getDuration");
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.callPlayer("getCurrentPosition");
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return null;
        }
      }, {
        key: "render",
        value: function() {
          var _ = this.props.config.attributes, C = {
            width: "100%",
            height: "100%"
          };
          return /* @__PURE__ */ r.default.createElement("div", l({
            style: C,
            id: this.playerID,
            className: "fb-video",
            "data-href": this.props.url,
            "data-autoplay": this.props.playing ? "true" : "false",
            "data-allowfullscreen": "true",
            "data-controls": this.props.controls ? "true" : "false"
          }, _));
        }
      }]), v;
    }(r.Component);
    t.default = D, O(D, "displayName", "Facebook"), O(D, "canPlay", a.canPlay.facebook), O(D, "loopOnEnded", !0);
  }(dl)), dl;
}
var pl = {}, Tg;
function BW() {
  return Tg || (Tg = 1, function(t) {
    function e(T) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(D) {
        return typeof D;
      } : e = function(D) {
        return D && typeof Symbol == "function" && D.constructor === Symbol && D !== Symbol.prototype ? "symbol" : typeof D;
      }, e(T);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = s(M), n = Ne, a = ce;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var T = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return T;
      }, T;
    }
    function s(T) {
      if (T && T.__esModule)
        return T;
      if (T === null || e(T) !== "object" && typeof T != "function")
        return { default: T };
      var A = i();
      if (A && A.has(T))
        return A.get(T);
      var D = {}, h = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var y in T)
        if (Object.prototype.hasOwnProperty.call(T, y)) {
          var v = h ? Object.getOwnPropertyDescriptor(T, y) : null;
          v && (v.get || v.set) ? Object.defineProperty(D, y, v) : D[y] = T[y];
        }
      return D.default = T, A && A.set(T, D), D;
    }
    function l(T, A) {
      if (!(T instanceof A))
        throw new TypeError("Cannot call a class as a function");
    }
    function o(T, A) {
      for (var D = 0; D < A.length; D++) {
        var h = A[D];
        h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(T, h.key, h);
      }
    }
    function u(T, A, D) {
      return A && o(T.prototype, A), D && o(T, D), T;
    }
    function c(T, A) {
      if (typeof A != "function" && A !== null)
        throw new TypeError("Super expression must either be null or a function");
      T.prototype = Object.create(A && A.prototype, { constructor: { value: T, writable: !0, configurable: !0 } }), A && f(T, A);
    }
    function f(T, A) {
      return f = Object.setPrototypeOf || function(h, y) {
        return h.__proto__ = y, h;
      }, f(T, A);
    }
    function p(T) {
      var A = d();
      return function() {
        var h = w(T), y;
        if (A) {
          var v = w(this).constructor;
          y = Reflect.construct(h, arguments, v);
        } else
          y = h.apply(this, arguments);
        return g(this, y);
      };
    }
    function g(T, A) {
      return A && (e(A) === "object" || typeof A == "function") ? A : m(T);
    }
    function m(T) {
      if (T === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return T;
    }
    function d() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function w(T) {
      return w = Object.setPrototypeOf ? Object.getPrototypeOf : function(D) {
        return D.__proto__ || Object.getPrototypeOf(D);
      }, w(T);
    }
    function b(T, A, D) {
      return A in T ? Object.defineProperty(T, A, { value: D, enumerable: !0, configurable: !0, writable: !0 }) : T[A] = D, T;
    }
    var O = "https://cdn.embed.ly/player-0.1.0.min.js", S = "playerjs", B = /* @__PURE__ */ function(T) {
      c(D, T);
      var A = p(D);
      function D() {
        var h;
        l(this, D);
        for (var y = arguments.length, v = new Array(y), E = 0; E < y; E++)
          v[E] = arguments[E];
        return h = A.call.apply(A, [this].concat(v)), b(m(h), "callPlayer", n.callPlayer), b(m(h), "duration", null), b(m(h), "currentTime", null), b(m(h), "secondsLoaded", null), b(m(h), "mute", function() {
          h.callPlayer("mute");
        }), b(m(h), "unmute", function() {
          h.callPlayer("unmute");
        }), b(m(h), "ref", function(_) {
          h.iframe = _;
        }), h;
      }
      return u(D, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "load",
        value: function(y) {
          var v = this;
          (0, n.getSDK)(O, S).then(function(E) {
            v.iframe && (v.player = new E.Player(v.iframe), v.player.setLoop(v.props.loop), v.player.on("ready", v.props.onReady), v.player.on("play", v.props.onPlay), v.player.on("pause", v.props.onPause), v.player.on("seeked", v.props.onSeek), v.player.on("ended", v.props.onEnded), v.player.on("error", v.props.onError), v.player.on("timeupdate", function(_) {
              var C = _.duration, P = _.seconds;
              v.duration = C, v.currentTime = P;
            }), v.player.on("buffered", function(_) {
              var C = _.percent;
              v.duration && (v.secondsLoaded = v.duration * C);
            }), v.props.muted && v.player.mute());
          }, this.props.onError);
        }
      }, {
        key: "play",
        value: function() {
          this.callPlayer("play");
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "stop",
        value: function() {
        }
      }, {
        key: "seekTo",
        value: function(y) {
          var v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.callPlayer("setCurrentTime", y), v || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(y) {
          this.callPlayer("setVolume", y * 100);
        }
      }, {
        key: "setLoop",
        value: function(y) {
          this.callPlayer("setLoop", y);
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.duration;
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.currentTime;
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return this.secondsLoaded;
        }
      }, {
        key: "render",
        value: function() {
          var y = this.props.url.match(a.MATCH_URL_STREAMABLE)[1], v = {
            width: "100%",
            height: "100%"
          };
          return /* @__PURE__ */ r.default.createElement("iframe", {
            ref: this.ref,
            src: "https://streamable.com/o/".concat(y),
            frameBorder: "0",
            scrolling: "no",
            style: v,
            allow: "encrypted-media; autoplay; fullscreen;"
          });
        }
      }]), D;
    }(r.Component);
    t.default = B, b(B, "displayName", "Streamable"), b(B, "canPlay", a.canPlay.streamable);
  }(pl)), pl;
}
var hl = {}, Bg;
function RW() {
  return Bg || (Bg = 1, function(t) {
    function e(h) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(v) {
        return typeof v;
      } : e = function(v) {
        return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
      }, e(h);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = s(M), n = Ne, a = ce;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var h = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return h;
      }, h;
    }
    function s(h) {
      if (h && h.__esModule)
        return h;
      if (h === null || e(h) !== "object" && typeof h != "function")
        return { default: h };
      var y = i();
      if (y && y.has(h))
        return y.get(h);
      var v = {}, E = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var _ in h)
        if (Object.prototype.hasOwnProperty.call(h, _)) {
          var C = E ? Object.getOwnPropertyDescriptor(h, _) : null;
          C && (C.get || C.set) ? Object.defineProperty(v, _, C) : v[_] = h[_];
        }
      return v.default = h, y && y.set(h, v), v;
    }
    function l(h, y) {
      var v = Object.keys(h);
      if (Object.getOwnPropertySymbols) {
        var E = Object.getOwnPropertySymbols(h);
        y && (E = E.filter(function(_) {
          return Object.getOwnPropertyDescriptor(h, _).enumerable;
        })), v.push.apply(v, E);
      }
      return v;
    }
    function o(h) {
      for (var y = 1; y < arguments.length; y++) {
        var v = arguments[y] != null ? arguments[y] : {};
        y % 2 ? l(Object(v), !0).forEach(function(E) {
          S(h, E, v[E]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(h, Object.getOwnPropertyDescriptors(v)) : l(Object(v)).forEach(function(E) {
          Object.defineProperty(h, E, Object.getOwnPropertyDescriptor(v, E));
        });
      }
      return h;
    }
    function u(h, y) {
      if (!(h instanceof y))
        throw new TypeError("Cannot call a class as a function");
    }
    function c(h, y) {
      for (var v = 0; v < y.length; v++) {
        var E = y[v];
        E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(h, E.key, E);
      }
    }
    function f(h, y, v) {
      return y && c(h.prototype, y), v && c(h, v), h;
    }
    function p(h, y) {
      if (typeof y != "function" && y !== null)
        throw new TypeError("Super expression must either be null or a function");
      h.prototype = Object.create(y && y.prototype, { constructor: { value: h, writable: !0, configurable: !0 } }), y && g(h, y);
    }
    function g(h, y) {
      return g = Object.setPrototypeOf || function(E, _) {
        return E.__proto__ = _, E;
      }, g(h, y);
    }
    function m(h) {
      var y = b();
      return function() {
        var E = O(h), _;
        if (y) {
          var C = O(this).constructor;
          _ = Reflect.construct(E, arguments, C);
        } else
          _ = E.apply(this, arguments);
        return d(this, _);
      };
    }
    function d(h, y) {
      return y && (e(y) === "object" || typeof y == "function") ? y : w(h);
    }
    function w(h) {
      if (h === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return h;
    }
    function b() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function O(h) {
      return O = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
        return v.__proto__ || Object.getPrototypeOf(v);
      }, O(h);
    }
    function S(h, y, v) {
      return y in h ? Object.defineProperty(h, y, { value: v, enumerable: !0, configurable: !0, writable: !0 }) : h[y] = v, h;
    }
    var B = "https://fast.wistia.com/assets/external/E-v1.js", T = "Wistia", A = "wistia-player-", D = /* @__PURE__ */ function(h) {
      p(v, h);
      var y = m(v);
      function v() {
        var E;
        u(this, v);
        for (var _ = arguments.length, C = new Array(_), P = 0; P < _; P++)
          C[P] = arguments[P];
        return E = y.call.apply(y, [this].concat(C)), S(w(E), "callPlayer", n.callPlayer), S(w(E), "playerID", E.props.config.playerId || "".concat(A).concat((0, n.randomString)())), S(w(E), "onPlay", function() {
          var $;
          return ($ = E.props).onPlay.apply($, arguments);
        }), S(w(E), "onPause", function() {
          var $;
          return ($ = E.props).onPause.apply($, arguments);
        }), S(w(E), "onSeek", function() {
          var $;
          return ($ = E.props).onSeek.apply($, arguments);
        }), S(w(E), "onEnded", function() {
          var $;
          return ($ = E.props).onEnded.apply($, arguments);
        }), S(w(E), "onPlaybackRateChange", function() {
          var $;
          return ($ = E.props).onPlaybackRateChange.apply($, arguments);
        }), S(w(E), "mute", function() {
          E.callPlayer("mute");
        }), S(w(E), "unmute", function() {
          E.callPlayer("unmute");
        }), E;
      }
      return f(v, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "load",
        value: function(_) {
          var C = this, P = this.props, $ = P.playing, W = P.muted, j = P.controls, I = P.onReady, F = P.config, k = P.onError;
          (0, n.getSDK)(B, T).then(function(N) {
            F.customControls && F.customControls.forEach(function(U) {
              return N.defineControl(U);
            }), window._wq = window._wq || [], window._wq.push({
              id: C.playerID,
              options: o({
                autoPlay: $,
                silentAutoPlay: "allow",
                muted: W,
                controlsVisibleOnLoad: j,
                fullscreenButton: j,
                playbar: j,
                playbackRateControl: j,
                qualityControl: j,
                volumeControl: j,
                settingsControl: j,
                smallPlayButton: j
              }, F.options),
              onReady: function(Y) {
                C.player = Y, C.unbind(), C.player.bind("play", C.onPlay), C.player.bind("pause", C.onPause), C.player.bind("seek", C.onSeek), C.player.bind("end", C.onEnded), C.player.bind("playbackratechange", C.onPlaybackRateChange), I();
              }
            });
          }, k);
        }
      }, {
        key: "unbind",
        value: function() {
          this.player.unbind("play", this.onPlay), this.player.unbind("pause", this.onPause), this.player.unbind("seek", this.onSeek), this.player.unbind("end", this.onEnded), this.player.unbind("playbackratechange", this.onPlaybackRateChange);
        }
        // Proxy methods to prevent listener leaks
      }, {
        key: "play",
        value: function() {
          this.callPlayer("play");
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "stop",
        value: function() {
          this.unbind(), this.callPlayer("remove");
        }
      }, {
        key: "seekTo",
        value: function(_) {
          var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.callPlayer("time", _), C || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(_) {
          this.callPlayer("volume", _);
        }
      }, {
        key: "setPlaybackRate",
        value: function(_) {
          this.callPlayer("playbackRate", _);
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.callPlayer("duration");
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.callPlayer("time");
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return null;
        }
      }, {
        key: "render",
        value: function() {
          var _ = this.props.url, C = _ && _.match(a.MATCH_URL_WISTIA)[1], P = "wistia_embed wistia_async_".concat(C), $ = {
            width: "100%",
            height: "100%"
          };
          return /* @__PURE__ */ r.default.createElement("div", {
            id: this.playerID,
            key: C,
            className: P,
            style: $
          });
        }
      }]), v;
    }(r.Component);
    t.default = D, S(D, "displayName", "Wistia"), S(D, "canPlay", a.canPlay.wistia), S(D, "loopOnEnded", !0);
  }(hl)), hl;
}
var gl = {}, Rg;
function $W() {
  return Rg || (Rg = 1, function(t) {
    function e(h) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(v) {
        return typeof v;
      } : e = function(v) {
        return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
      }, e(h);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = s(M), n = Ne, a = ce;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var h = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return h;
      }, h;
    }
    function s(h) {
      if (h && h.__esModule)
        return h;
      if (h === null || e(h) !== "object" && typeof h != "function")
        return { default: h };
      var y = i();
      if (y && y.has(h))
        return y.get(h);
      var v = {}, E = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var _ in h)
        if (Object.prototype.hasOwnProperty.call(h, _)) {
          var C = E ? Object.getOwnPropertyDescriptor(h, _) : null;
          C && (C.get || C.set) ? Object.defineProperty(v, _, C) : v[_] = h[_];
        }
      return v.default = h, y && y.set(h, v), v;
    }
    function l(h, y) {
      var v = Object.keys(h);
      if (Object.getOwnPropertySymbols) {
        var E = Object.getOwnPropertySymbols(h);
        y && (E = E.filter(function(_) {
          return Object.getOwnPropertyDescriptor(h, _).enumerable;
        })), v.push.apply(v, E);
      }
      return v;
    }
    function o(h) {
      for (var y = 1; y < arguments.length; y++) {
        var v = arguments[y] != null ? arguments[y] : {};
        y % 2 ? l(Object(v), !0).forEach(function(E) {
          S(h, E, v[E]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(h, Object.getOwnPropertyDescriptors(v)) : l(Object(v)).forEach(function(E) {
          Object.defineProperty(h, E, Object.getOwnPropertyDescriptor(v, E));
        });
      }
      return h;
    }
    function u(h, y) {
      if (!(h instanceof y))
        throw new TypeError("Cannot call a class as a function");
    }
    function c(h, y) {
      for (var v = 0; v < y.length; v++) {
        var E = y[v];
        E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(h, E.key, E);
      }
    }
    function f(h, y, v) {
      return y && c(h.prototype, y), v && c(h, v), h;
    }
    function p(h, y) {
      if (typeof y != "function" && y !== null)
        throw new TypeError("Super expression must either be null or a function");
      h.prototype = Object.create(y && y.prototype, { constructor: { value: h, writable: !0, configurable: !0 } }), y && g(h, y);
    }
    function g(h, y) {
      return g = Object.setPrototypeOf || function(E, _) {
        return E.__proto__ = _, E;
      }, g(h, y);
    }
    function m(h) {
      var y = b();
      return function() {
        var E = O(h), _;
        if (y) {
          var C = O(this).constructor;
          _ = Reflect.construct(E, arguments, C);
        } else
          _ = E.apply(this, arguments);
        return d(this, _);
      };
    }
    function d(h, y) {
      return y && (e(y) === "object" || typeof y == "function") ? y : w(h);
    }
    function w(h) {
      if (h === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return h;
    }
    function b() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function O(h) {
      return O = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
        return v.__proto__ || Object.getPrototypeOf(v);
      }, O(h);
    }
    function S(h, y, v) {
      return y in h ? Object.defineProperty(h, y, { value: v, enumerable: !0, configurable: !0, writable: !0 }) : h[y] = v, h;
    }
    var B = "https://player.twitch.tv/js/embed/v1.js", T = "Twitch", A = "twitch-player-", D = /* @__PURE__ */ function(h) {
      p(v, h);
      var y = m(v);
      function v() {
        var E;
        u(this, v);
        for (var _ = arguments.length, C = new Array(_), P = 0; P < _; P++)
          C[P] = arguments[P];
        return E = y.call.apply(y, [this].concat(C)), S(w(E), "callPlayer", n.callPlayer), S(w(E), "playerID", E.props.config.playerId || "".concat(A).concat((0, n.randomString)())), S(w(E), "mute", function() {
          E.callPlayer("setMuted", !0);
        }), S(w(E), "unmute", function() {
          E.callPlayer("setMuted", !1);
        }), E;
      }
      return f(v, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "load",
        value: function(_, C) {
          var P = this, $ = this.props, W = $.playsinline, j = $.onError, I = $.config, F = $.controls, k = a.MATCH_URL_TWITCH_CHANNEL.test(_), N = k ? _.match(a.MATCH_URL_TWITCH_CHANNEL)[1] : _.match(a.MATCH_URL_TWITCH_VIDEO)[1];
          if (C) {
            k ? this.player.setChannel(N) : this.player.setVideo("v" + N);
            return;
          }
          (0, n.getSDK)(B, T).then(function(U) {
            P.player = new U.Player(P.playerID, o({
              video: k ? "" : N,
              channel: k ? N : "",
              height: "100%",
              width: "100%",
              playsinline: W,
              autoplay: P.props.playing,
              muted: P.props.muted,
              // https://github.com/CookPete/react-player/issues/733#issuecomment-549085859
              controls: k ? !0 : F,
              time: (0, n.parseStartTime)(_)
            }, I.options));
            var Y = U.Player, L = Y.READY, q = Y.PLAYING, V = Y.PAUSE, X = Y.ENDED, te = Y.ONLINE, re = Y.OFFLINE, ue = Y.SEEK;
            P.player.addEventListener(L, P.props.onReady), P.player.addEventListener(q, P.props.onPlay), P.player.addEventListener(V, P.props.onPause), P.player.addEventListener(X, P.props.onEnded), P.player.addEventListener(ue, P.props.onSeek), P.player.addEventListener(te, P.props.onLoaded), P.player.addEventListener(re, P.props.onLoaded);
          }, j);
        }
      }, {
        key: "play",
        value: function() {
          this.callPlayer("play");
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "stop",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "seekTo",
        value: function(_) {
          var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.callPlayer("seek", _), C || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(_) {
          this.callPlayer("setVolume", _);
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.callPlayer("getDuration");
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.callPlayer("getCurrentTime");
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return null;
        }
      }, {
        key: "render",
        value: function() {
          var _ = {
            width: "100%",
            height: "100%"
          };
          return /* @__PURE__ */ r.default.createElement("div", {
            style: _,
            id: this.playerID
          });
        }
      }]), v;
    }(r.Component);
    t.default = D, S(D, "displayName", "Twitch"), S(D, "canPlay", a.canPlay.twitch), S(D, "loopOnEnded", !0);
  }(gl)), gl;
}
var vl = {}, $g;
function MW() {
  return $g || ($g = 1, function(t) {
    function e(P) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(W) {
        return typeof W;
      } : e = function(W) {
        return W && typeof Symbol == "function" && W.constructor === Symbol && W !== Symbol.prototype ? "symbol" : typeof W;
      }, e(P);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = s(M), n = Ne, a = ce;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var P = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return P;
      }, P;
    }
    function s(P) {
      if (P && P.__esModule)
        return P;
      if (P === null || e(P) !== "object" && typeof P != "function")
        return { default: P };
      var $ = i();
      if ($ && $.has(P))
        return $.get(P);
      var W = {}, j = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var I in P)
        if (Object.prototype.hasOwnProperty.call(P, I)) {
          var F = j ? Object.getOwnPropertyDescriptor(P, I) : null;
          F && (F.get || F.set) ? Object.defineProperty(W, I, F) : W[I] = P[I];
        }
      return W.default = P, $ && $.set(P, W), W;
    }
    function l(P, $) {
      var W = Object.keys(P);
      if (Object.getOwnPropertySymbols) {
        var j = Object.getOwnPropertySymbols(P);
        $ && (j = j.filter(function(I) {
          return Object.getOwnPropertyDescriptor(P, I).enumerable;
        })), W.push.apply(W, j);
      }
      return W;
    }
    function o(P) {
      for (var $ = 1; $ < arguments.length; $++) {
        var W = arguments[$] != null ? arguments[$] : {};
        $ % 2 ? l(Object(W), !0).forEach(function(j) {
          y(P, j, W[j]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(P, Object.getOwnPropertyDescriptors(W)) : l(Object(W)).forEach(function(j) {
          Object.defineProperty(P, j, Object.getOwnPropertyDescriptor(W, j));
        });
      }
      return P;
    }
    function u(P, $) {
      return m(P) || g(P, $) || f(P, $) || c();
    }
    function c() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function f(P, $) {
      if (P) {
        if (typeof P == "string")
          return p(P, $);
        var W = Object.prototype.toString.call(P).slice(8, -1);
        if (W === "Object" && P.constructor && (W = P.constructor.name), W === "Map" || W === "Set")
          return Array.from(P);
        if (W === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(W))
          return p(P, $);
      }
    }
    function p(P, $) {
      ($ == null || $ > P.length) && ($ = P.length);
      for (var W = 0, j = new Array($); W < $; W++)
        j[W] = P[W];
      return j;
    }
    function g(P, $) {
      if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(P)))) {
        var W = [], j = !0, I = !1, F = void 0;
        try {
          for (var k = P[Symbol.iterator](), N; !(j = (N = k.next()).done) && (W.push(N.value), !($ && W.length === $)); j = !0)
            ;
        } catch (U) {
          I = !0, F = U;
        } finally {
          try {
            !j && k.return != null && k.return();
          } finally {
            if (I)
              throw F;
          }
        }
        return W;
      }
    }
    function m(P) {
      if (Array.isArray(P))
        return P;
    }
    function d(P, $) {
      if (!(P instanceof $))
        throw new TypeError("Cannot call a class as a function");
    }
    function w(P, $) {
      for (var W = 0; W < $.length; W++) {
        var j = $[W];
        j.enumerable = j.enumerable || !1, j.configurable = !0, "value" in j && (j.writable = !0), Object.defineProperty(P, j.key, j);
      }
    }
    function b(P, $, W) {
      return $ && w(P.prototype, $), W && w(P, W), P;
    }
    function O(P, $) {
      if (typeof $ != "function" && $ !== null)
        throw new TypeError("Super expression must either be null or a function");
      P.prototype = Object.create($ && $.prototype, { constructor: { value: P, writable: !0, configurable: !0 } }), $ && S(P, $);
    }
    function S(P, $) {
      return S = Object.setPrototypeOf || function(j, I) {
        return j.__proto__ = I, j;
      }, S(P, $);
    }
    function B(P) {
      var $ = D();
      return function() {
        var j = h(P), I;
        if ($) {
          var F = h(this).constructor;
          I = Reflect.construct(j, arguments, F);
        } else
          I = j.apply(this, arguments);
        return T(this, I);
      };
    }
    function T(P, $) {
      return $ && (e($) === "object" || typeof $ == "function") ? $ : A(P);
    }
    function A(P) {
      if (P === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return P;
    }
    function D() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function h(P) {
      return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(W) {
        return W.__proto__ || Object.getPrototypeOf(W);
      }, h(P);
    }
    function y(P, $, W) {
      return $ in P ? Object.defineProperty(P, $, { value: W, enumerable: !0, configurable: !0, writable: !0 }) : P[$] = W, P;
    }
    var v = "https://api.dmcdn.net/all.js", E = "DM", _ = "dmAsyncInit", C = /* @__PURE__ */ function(P) {
      O(W, P);
      var $ = B(W);
      function W() {
        var j;
        d(this, W);
        for (var I = arguments.length, F = new Array(I), k = 0; k < I; k++)
          F[k] = arguments[k];
        return j = $.call.apply($, [this].concat(F)), y(A(j), "callPlayer", n.callPlayer), y(A(j), "onDurationChange", function() {
          var N = j.getDuration();
          j.props.onDuration(N);
        }), y(A(j), "mute", function() {
          j.callPlayer("setMuted", !0);
        }), y(A(j), "unmute", function() {
          j.callPlayer("setMuted", !1);
        }), y(A(j), "ref", function(N) {
          j.container = N;
        }), j;
      }
      return b(W, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "load",
        value: function(I) {
          var F = this, k = this.props, N = k.controls, U = k.config, Y = k.onError, L = k.playing, q = I.match(a.MATCH_URL_DAILYMOTION), V = u(q, 2), X = V[1];
          if (this.player) {
            this.player.load(X, {
              start: (0, n.parseStartTime)(I),
              autoplay: L
            });
            return;
          }
          (0, n.getSDK)(v, E, _, function(te) {
            return te.player;
          }).then(function(te) {
            if (F.container) {
              var re = te.player;
              F.player = new re(F.container, {
                width: "100%",
                height: "100%",
                video: X,
                params: o({
                  controls: N,
                  autoplay: F.props.playing,
                  mute: F.props.muted,
                  start: (0, n.parseStartTime)(I),
                  origin: window.location.origin
                }, U.params),
                events: {
                  apiready: F.props.onReady,
                  seeked: function() {
                    return F.props.onSeek(F.player.currentTime);
                  },
                  video_end: F.props.onEnded,
                  durationchange: F.onDurationChange,
                  pause: F.props.onPause,
                  playing: F.props.onPlay,
                  waiting: F.props.onBuffer,
                  error: function(pe) {
                    return Y(pe);
                  }
                }
              });
            }
          }, Y);
        }
      }, {
        key: "play",
        value: function() {
          this.callPlayer("play");
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "stop",
        value: function() {
        }
      }, {
        key: "seekTo",
        value: function(I) {
          var F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.callPlayer("seek", I), F || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(I) {
          this.callPlayer("setVolume", I);
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.player.duration || null;
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.player.currentTime;
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return this.player.bufferedTime;
        }
      }, {
        key: "render",
        value: function() {
          var I = this.props.display, F = {
            width: "100%",
            height: "100%",
            display: I
          };
          return /* @__PURE__ */ r.default.createElement("div", {
            style: F
          }, /* @__PURE__ */ r.default.createElement("div", {
            ref: this.ref
          }));
        }
      }]), W;
    }(r.Component);
    t.default = C, y(C, "displayName", "DailyMotion"), y(C, "canPlay", a.canPlay.dailymotion), y(C, "loopOnEnded", !0);
  }(vl)), vl;
}
var ml = {}, Mg;
function FW() {
  return Mg || (Mg = 1, function(t) {
    function e(D) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(y) {
        return typeof y;
      } : e = function(y) {
        return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
      }, e(D);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = s(M), n = Ne, a = ce;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var D = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return D;
      }, D;
    }
    function s(D) {
      if (D && D.__esModule)
        return D;
      if (D === null || e(D) !== "object" && typeof D != "function")
        return { default: D };
      var h = i();
      if (h && h.has(D))
        return h.get(D);
      var y = {}, v = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var E in D)
        if (Object.prototype.hasOwnProperty.call(D, E)) {
          var _ = v ? Object.getOwnPropertyDescriptor(D, E) : null;
          _ && (_.get || _.set) ? Object.defineProperty(y, E, _) : y[E] = D[E];
        }
      return y.default = D, h && h.set(D, y), y;
    }
    function l(D, h) {
      var y = Object.keys(D);
      if (Object.getOwnPropertySymbols) {
        var v = Object.getOwnPropertySymbols(D);
        h && (v = v.filter(function(E) {
          return Object.getOwnPropertyDescriptor(D, E).enumerable;
        })), y.push.apply(y, v);
      }
      return y;
    }
    function o(D) {
      for (var h = 1; h < arguments.length; h++) {
        var y = arguments[h] != null ? arguments[h] : {};
        h % 2 ? l(Object(y), !0).forEach(function(v) {
          S(D, v, y[v]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(D, Object.getOwnPropertyDescriptors(y)) : l(Object(y)).forEach(function(v) {
          Object.defineProperty(D, v, Object.getOwnPropertyDescriptor(y, v));
        });
      }
      return D;
    }
    function u(D, h) {
      if (!(D instanceof h))
        throw new TypeError("Cannot call a class as a function");
    }
    function c(D, h) {
      for (var y = 0; y < h.length; y++) {
        var v = h[y];
        v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(D, v.key, v);
      }
    }
    function f(D, h, y) {
      return h && c(D.prototype, h), y && c(D, y), D;
    }
    function p(D, h) {
      if (typeof h != "function" && h !== null)
        throw new TypeError("Super expression must either be null or a function");
      D.prototype = Object.create(h && h.prototype, { constructor: { value: D, writable: !0, configurable: !0 } }), h && g(D, h);
    }
    function g(D, h) {
      return g = Object.setPrototypeOf || function(v, E) {
        return v.__proto__ = E, v;
      }, g(D, h);
    }
    function m(D) {
      var h = b();
      return function() {
        var v = O(D), E;
        if (h) {
          var _ = O(this).constructor;
          E = Reflect.construct(v, arguments, _);
        } else
          E = v.apply(this, arguments);
        return d(this, E);
      };
    }
    function d(D, h) {
      return h && (e(h) === "object" || typeof h == "function") ? h : w(D);
    }
    function w(D) {
      if (D === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return D;
    }
    function b() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function O(D) {
      return O = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
        return y.__proto__ || Object.getPrototypeOf(y);
      }, O(D);
    }
    function S(D, h, y) {
      return h in D ? Object.defineProperty(D, h, { value: y, enumerable: !0, configurable: !0, writable: !0 }) : D[h] = y, D;
    }
    var B = "https://widget.mixcloud.com/media/js/widgetApi.js", T = "Mixcloud", A = /* @__PURE__ */ function(D) {
      p(y, D);
      var h = m(y);
      function y() {
        var v;
        u(this, y);
        for (var E = arguments.length, _ = new Array(E), C = 0; C < E; C++)
          _[C] = arguments[C];
        return v = h.call.apply(h, [this].concat(_)), S(w(v), "callPlayer", n.callPlayer), S(w(v), "duration", null), S(w(v), "currentTime", null), S(w(v), "secondsLoaded", null), S(w(v), "mute", function() {
        }), S(w(v), "unmute", function() {
        }), S(w(v), "ref", function(P) {
          v.iframe = P;
        }), v;
      }
      return f(y, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "load",
        value: function(E) {
          var _ = this;
          (0, n.getSDK)(B, T).then(function(C) {
            _.player = C.PlayerWidget(_.iframe), _.player.ready.then(function() {
              _.player.events.play.on(_.props.onPlay), _.player.events.pause.on(_.props.onPause), _.player.events.ended.on(_.props.onEnded), _.player.events.error.on(_.props.error), _.player.events.progress.on(function(P, $) {
                _.currentTime = P, _.duration = $;
              }), _.props.onReady();
            });
          }, this.props.onError);
        }
      }, {
        key: "play",
        value: function() {
          this.callPlayer("play");
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "stop",
        value: function() {
        }
      }, {
        key: "seekTo",
        value: function(E) {
          var _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.callPlayer("seek", E), _ || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(E) {
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.duration;
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.currentTime;
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return null;
        }
      }, {
        key: "render",
        value: function() {
          var E = this.props, _ = E.url, C = E.config, P = _.match(a.MATCH_URL_MIXCLOUD)[1], $ = {
            width: "100%",
            height: "100%"
          }, W = (0, n.queryString)(o(o({}, C.options), {}, {
            feed: "/".concat(P, "/")
          }));
          return /* @__PURE__ */ r.default.createElement("iframe", {
            key: P,
            ref: this.ref,
            style: $,
            src: "https://www.mixcloud.com/widget/iframe/?".concat(W),
            frameBorder: "0",
            allow: "autoplay"
          });
        }
      }]), y;
    }(r.Component);
    t.default = A, S(A, "displayName", "Mixcloud"), S(A, "canPlay", a.canPlay.mixcloud), S(A, "loopOnEnded", !0);
  }(ml)), ml;
}
var yl = {}, Fg;
function IW() {
  return Fg || (Fg = 1, function(t) {
    function e(h) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(v) {
        return typeof v;
      } : e = function(v) {
        return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
      }, e(h);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = s(M), n = Ne, a = ce;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var h = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return h;
      }, h;
    }
    function s(h) {
      if (h && h.__esModule)
        return h;
      if (h === null || e(h) !== "object" && typeof h != "function")
        return { default: h };
      var y = i();
      if (y && y.has(h))
        return y.get(h);
      var v = {}, E = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var _ in h)
        if (Object.prototype.hasOwnProperty.call(h, _)) {
          var C = E ? Object.getOwnPropertyDescriptor(h, _) : null;
          C && (C.get || C.set) ? Object.defineProperty(v, _, C) : v[_] = h[_];
        }
      return v.default = h, y && y.set(h, v), v;
    }
    function l(h, y) {
      var v = Object.keys(h);
      if (Object.getOwnPropertySymbols) {
        var E = Object.getOwnPropertySymbols(h);
        y && (E = E.filter(function(_) {
          return Object.getOwnPropertyDescriptor(h, _).enumerable;
        })), v.push.apply(v, E);
      }
      return v;
    }
    function o(h) {
      for (var y = 1; y < arguments.length; y++) {
        var v = arguments[y] != null ? arguments[y] : {};
        y % 2 ? l(Object(v), !0).forEach(function(E) {
          S(h, E, v[E]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(h, Object.getOwnPropertyDescriptors(v)) : l(Object(v)).forEach(function(E) {
          Object.defineProperty(h, E, Object.getOwnPropertyDescriptor(v, E));
        });
      }
      return h;
    }
    function u(h, y) {
      if (!(h instanceof y))
        throw new TypeError("Cannot call a class as a function");
    }
    function c(h, y) {
      for (var v = 0; v < y.length; v++) {
        var E = y[v];
        E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(h, E.key, E);
      }
    }
    function f(h, y, v) {
      return y && c(h.prototype, y), v && c(h, v), h;
    }
    function p(h, y) {
      if (typeof y != "function" && y !== null)
        throw new TypeError("Super expression must either be null or a function");
      h.prototype = Object.create(y && y.prototype, { constructor: { value: h, writable: !0, configurable: !0 } }), y && g(h, y);
    }
    function g(h, y) {
      return g = Object.setPrototypeOf || function(E, _) {
        return E.__proto__ = _, E;
      }, g(h, y);
    }
    function m(h) {
      var y = b();
      return function() {
        var E = O(h), _;
        if (y) {
          var C = O(this).constructor;
          _ = Reflect.construct(E, arguments, C);
        } else
          _ = E.apply(this, arguments);
        return d(this, _);
      };
    }
    function d(h, y) {
      return y && (e(y) === "object" || typeof y == "function") ? y : w(h);
    }
    function w(h) {
      if (h === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return h;
    }
    function b() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function O(h) {
      return O = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
        return v.__proto__ || Object.getPrototypeOf(v);
      }, O(h);
    }
    function S(h, y, v) {
      return y in h ? Object.defineProperty(h, y, { value: v, enumerable: !0, configurable: !0, writable: !0 }) : h[y] = v, h;
    }
    var B = "https://play.vidyard.com/embed/v4.js", T = "VidyardV4", A = "onVidyardAPI", D = /* @__PURE__ */ function(h) {
      p(v, h);
      var y = m(v);
      function v() {
        var E;
        u(this, v);
        for (var _ = arguments.length, C = new Array(_), P = 0; P < _; P++)
          C[P] = arguments[P];
        return E = y.call.apply(y, [this].concat(C)), S(w(E), "callPlayer", n.callPlayer), S(w(E), "mute", function() {
          E.setVolume(0);
        }), S(w(E), "unmute", function() {
          E.props.volume !== null && E.setVolume(E.props.volume);
        }), S(w(E), "ref", function($) {
          E.container = $;
        }), E;
      }
      return f(v, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "load",
        value: function(_) {
          var C = this, P = this.props, $ = P.playing, W = P.config, j = P.onError, I = P.onDuration, F = _ && _.match(a.MATCH_URL_VIDYARD)[1];
          this.player && this.stop(), (0, n.getSDK)(B, T, A).then(function(k) {
            C.container && (k.api.addReadyListener(function(N, U) {
              C.player || (C.player = U, C.player.on("ready", C.props.onReady), C.player.on("play", C.props.onPlay), C.player.on("pause", C.props.onPause), C.player.on("seek", C.props.onSeek), C.player.on("playerComplete", C.props.onEnded));
            }, F), k.api.renderPlayer(o({
              uuid: F,
              container: C.container,
              autoplay: $ ? 1 : 0
            }, W.options)), k.api.getPlayerMetadata(F).then(function(N) {
              C.duration = N.length_in_seconds, I(N.length_in_seconds);
            }));
          }, j);
        }
      }, {
        key: "play",
        value: function() {
          this.callPlayer("play");
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "stop",
        value: function() {
          window.VidyardV4.api.destroyPlayer(this.player);
        }
      }, {
        key: "seekTo",
        value: function(_) {
          var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.callPlayer("seek", _), C || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(_) {
          this.callPlayer("setVolume", _);
        }
      }, {
        key: "setPlaybackRate",
        value: function(_) {
          this.callPlayer("setPlaybackSpeed", _);
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.duration;
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.callPlayer("currentTime");
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return null;
        }
      }, {
        key: "render",
        value: function() {
          var _ = this.props.display, C = {
            width: "100%",
            height: "100%",
            display: _
          };
          return /* @__PURE__ */ r.default.createElement("div", {
            style: C
          }, /* @__PURE__ */ r.default.createElement("div", {
            ref: this.ref
          }));
        }
      }]), v;
    }(r.Component);
    t.default = D, S(D, "displayName", "Vidyard"), S(D, "canPlay", a.canPlay.vidyard);
  }(yl)), yl;
}
var bl = {}, Ig;
function jW() {
  return Ig || (Ig = 1, function(t) {
    function e(T) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(D) {
        return typeof D;
      } : e = function(D) {
        return D && typeof Symbol == "function" && D.constructor === Symbol && D !== Symbol.prototype ? "symbol" : typeof D;
      }, e(T);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = s(M), n = Ne, a = ce;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var T = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return T;
      }, T;
    }
    function s(T) {
      if (T && T.__esModule)
        return T;
      if (T === null || e(T) !== "object" && typeof T != "function")
        return { default: T };
      var A = i();
      if (A && A.has(T))
        return A.get(T);
      var D = {}, h = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var y in T)
        if (Object.prototype.hasOwnProperty.call(T, y)) {
          var v = h ? Object.getOwnPropertyDescriptor(T, y) : null;
          v && (v.get || v.set) ? Object.defineProperty(D, y, v) : D[y] = T[y];
        }
      return D.default = T, A && A.set(T, D), D;
    }
    function l(T, A) {
      if (!(T instanceof A))
        throw new TypeError("Cannot call a class as a function");
    }
    function o(T, A) {
      for (var D = 0; D < A.length; D++) {
        var h = A[D];
        h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(T, h.key, h);
      }
    }
    function u(T, A, D) {
      return A && o(T.prototype, A), D && o(T, D), T;
    }
    function c(T, A) {
      if (typeof A != "function" && A !== null)
        throw new TypeError("Super expression must either be null or a function");
      T.prototype = Object.create(A && A.prototype, { constructor: { value: T, writable: !0, configurable: !0 } }), A && f(T, A);
    }
    function f(T, A) {
      return f = Object.setPrototypeOf || function(h, y) {
        return h.__proto__ = y, h;
      }, f(T, A);
    }
    function p(T) {
      var A = d();
      return function() {
        var h = w(T), y;
        if (A) {
          var v = w(this).constructor;
          y = Reflect.construct(h, arguments, v);
        } else
          y = h.apply(this, arguments);
        return g(this, y);
      };
    }
    function g(T, A) {
      return A && (e(A) === "object" || typeof A == "function") ? A : m(T);
    }
    function m(T) {
      if (T === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return T;
    }
    function d() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function w(T) {
      return w = Object.setPrototypeOf ? Object.getPrototypeOf : function(D) {
        return D.__proto__ || Object.getPrototypeOf(D);
      }, w(T);
    }
    function b(T, A, D) {
      return A in T ? Object.defineProperty(T, A, { value: D, enumerable: !0, configurable: !0, writable: !0 }) : T[A] = D, T;
    }
    var O = "https://cdn.embed.ly/player-0.1.0.min.js", S = "playerjs", B = /* @__PURE__ */ function(T) {
      c(D, T);
      var A = p(D);
      function D() {
        var h;
        l(this, D);
        for (var y = arguments.length, v = new Array(y), E = 0; E < y; E++)
          v[E] = arguments[E];
        return h = A.call.apply(A, [this].concat(v)), b(m(h), "callPlayer", n.callPlayer), b(m(h), "duration", null), b(m(h), "currentTime", null), b(m(h), "secondsLoaded", null), b(m(h), "mute", function() {
          h.callPlayer("mute");
        }), b(m(h), "unmute", function() {
          h.callPlayer("unmute");
        }), b(m(h), "ref", function(_) {
          h.iframe = _;
        }), h;
      }
      return u(D, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "load",
        value: function(y) {
          var v = this;
          (0, n.getSDK)(O, S).then(function(E) {
            v.iframe && (v.player = new E.Player(v.iframe), v.player.on("ready", function() {
              setTimeout(function() {
                v.player.isReady = !0, v.player.setLoop(v.props.loop), v.props.muted && v.player.mute(), v.addListeners(v.player, v.props), v.props.onReady();
              }, 500);
            }));
          }, this.props.onError);
        }
      }, {
        key: "addListeners",
        value: function(y, v) {
          var E = this;
          y.on("play", v.onPlay), y.on("pause", v.onPause), y.on("ended", v.onEnded), y.on("error", v.onError), y.on("timeupdate", function(_) {
            var C = _.duration, P = _.seconds;
            E.duration = C, E.currentTime = P;
          });
        }
      }, {
        key: "play",
        value: function() {
          this.callPlayer("play");
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "stop",
        value: function() {
        }
      }, {
        key: "seekTo",
        value: function(y) {
          var v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.callPlayer("setCurrentTime", y), v || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(y) {
          this.callPlayer("setVolume", y);
        }
      }, {
        key: "setLoop",
        value: function(y) {
          this.callPlayer("setLoop", y);
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.duration;
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.currentTime;
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return this.secondsLoaded;
        }
      }, {
        key: "render",
        value: function() {
          var y = {
            width: "100%",
            height: "100%"
          };
          return /* @__PURE__ */ r.default.createElement("iframe", {
            ref: this.ref,
            src: this.props.url,
            frameBorder: "0",
            scrolling: "no",
            style: y,
            allow: "encrypted-media; autoplay; fullscreen;",
            referrerPolicy: "no-referrer-when-downgrade"
          });
        }
      }]), D;
    }(r.Component);
    t.default = B, b(B, "displayName", "Kaltura"), b(B, "canPlay", a.canPlay.kaltura);
  }(bl)), bl;
}
var wl = {}, jg;
function LW() {
  return jg || (jg = 1, function(t) {
    function e(j) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(F) {
        return typeof F;
      } : e = function(F) {
        return F && typeof Symbol == "function" && F.constructor === Symbol && F !== Symbol.prototype ? "symbol" : typeof F;
      }, e(j);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = s(M), n = Ne, a = ce;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var j = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return j;
      }, j;
    }
    function s(j) {
      if (j && j.__esModule)
        return j;
      if (j === null || e(j) !== "object" && typeof j != "function")
        return { default: j };
      var I = i();
      if (I && I.has(j))
        return I.get(j);
      var F = {}, k = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var N in j)
        if (Object.prototype.hasOwnProperty.call(j, N)) {
          var U = k ? Object.getOwnPropertyDescriptor(j, N) : null;
          U && (U.get || U.set) ? Object.defineProperty(F, N, U) : F[N] = j[N];
        }
      return F.default = j, I && I.set(j, F), F;
    }
    function l() {
      return l = Object.assign || function(j) {
        for (var I = 1; I < arguments.length; I++) {
          var F = arguments[I];
          for (var k in F)
            Object.prototype.hasOwnProperty.call(F, k) && (j[k] = F[k]);
        }
        return j;
      }, l.apply(this, arguments);
    }
    function o(j, I) {
      if (!(j instanceof I))
        throw new TypeError("Cannot call a class as a function");
    }
    function u(j, I) {
      for (var F = 0; F < I.length; F++) {
        var k = I[F];
        k.enumerable = k.enumerable || !1, k.configurable = !0, "value" in k && (k.writable = !0), Object.defineProperty(j, k.key, k);
      }
    }
    function c(j, I, F) {
      return I && u(j.prototype, I), F && u(j, F), j;
    }
    function f(j, I) {
      if (typeof I != "function" && I !== null)
        throw new TypeError("Super expression must either be null or a function");
      j.prototype = Object.create(I && I.prototype, { constructor: { value: j, writable: !0, configurable: !0 } }), I && p(j, I);
    }
    function p(j, I) {
      return p = Object.setPrototypeOf || function(k, N) {
        return k.__proto__ = N, k;
      }, p(j, I);
    }
    function g(j) {
      var I = w();
      return function() {
        var k = b(j), N;
        if (I) {
          var U = b(this).constructor;
          N = Reflect.construct(k, arguments, U);
        } else
          N = k.apply(this, arguments);
        return m(this, N);
      };
    }
    function m(j, I) {
      return I && (e(I) === "object" || typeof I == "function") ? I : d(j);
    }
    function d(j) {
      if (j === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return j;
    }
    function w() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function b(j) {
      return b = Object.setPrototypeOf ? Object.getPrototypeOf : function(F) {
        return F.__proto__ || Object.getPrototypeOf(F);
      }, b(j);
    }
    function O(j, I, F) {
      return I in j ? Object.defineProperty(j, I, { value: F, enumerable: !0, configurable: !0, writable: !0 }) : j[I] = F, j;
    }
    var S = typeof navigator < "u", B = S && navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1, T = S && (/iPad|iPhone|iPod/.test(navigator.userAgent) || B) && !window.MSStream, A = S && /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && !window.MSStream, D = "https://cdn.jsdelivr.net/npm/hls.js@VERSION/dist/hls.min.js", h = "Hls", y = "https://cdnjs.cloudflare.com/ajax/libs/dashjs/VERSION/dash.all.min.js", v = "dashjs", E = "https://cdn.jsdelivr.net/npm/flv.js@VERSION/dist/flv.min.js", _ = "flvjs", C = /www\.dropbox\.com\/.+/, P = /https:\/\/watch\.cloudflarestream\.com\/([a-z0-9]+)/, $ = "https://videodelivery.net/{id}/manifest/video.m3u8", W = /* @__PURE__ */ function(j) {
      f(F, j);
      var I = g(F);
      function F() {
        var k;
        o(this, F);
        for (var N = arguments.length, U = new Array(N), Y = 0; Y < N; Y++)
          U[Y] = arguments[Y];
        return k = I.call.apply(I, [this].concat(U)), O(d(k), "onReady", function() {
          var L;
          return (L = k.props).onReady.apply(L, arguments);
        }), O(d(k), "onPlay", function() {
          var L;
          return (L = k.props).onPlay.apply(L, arguments);
        }), O(d(k), "onBuffer", function() {
          var L;
          return (L = k.props).onBuffer.apply(L, arguments);
        }), O(d(k), "onBufferEnd", function() {
          var L;
          return (L = k.props).onBufferEnd.apply(L, arguments);
        }), O(d(k), "onPause", function() {
          var L;
          return (L = k.props).onPause.apply(L, arguments);
        }), O(d(k), "onEnded", function() {
          var L;
          return (L = k.props).onEnded.apply(L, arguments);
        }), O(d(k), "onError", function() {
          var L;
          return (L = k.props).onError.apply(L, arguments);
        }), O(d(k), "onPlayBackRateChange", function(L) {
          return k.props.onPlaybackRateChange(L.target.playbackRate);
        }), O(d(k), "onEnablePIP", function() {
          var L;
          return (L = k.props).onEnablePIP.apply(L, arguments);
        }), O(d(k), "onDisablePIP", function(L) {
          var q = k.props, V = q.onDisablePIP, X = q.playing;
          V(L), X && k.play();
        }), O(d(k), "onPresentationModeChange", function(L) {
          if (k.player && (0, n.supportsWebKitPresentationMode)(k.player)) {
            var q = k.player.webkitPresentationMode;
            q === "picture-in-picture" ? k.onEnablePIP(L) : q === "inline" && k.onDisablePIP(L);
          }
        }), O(d(k), "onSeek", function(L) {
          k.props.onSeek(L.target.currentTime);
        }), O(d(k), "mute", function() {
          k.player.muted = !0;
        }), O(d(k), "unmute", function() {
          k.player.muted = !1;
        }), O(d(k), "renderSourceElement", function(L, q) {
          return typeof L == "string" ? /* @__PURE__ */ r.default.createElement("source", {
            key: q,
            src: L
          }) : /* @__PURE__ */ r.default.createElement("source", l({
            key: q
          }, L));
        }), O(d(k), "renderTrack", function(L, q) {
          return /* @__PURE__ */ r.default.createElement("track", l({
            key: q
          }, L));
        }), O(d(k), "ref", function(L) {
          k.player && (k.prevPlayer = k.player), k.player = L;
        }), k;
      }
      return c(F, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this), this.addListeners(this.player);
          var N = this.getSource(this.props.url);
          N && (this.player.src = N), (T || this.props.config.forceDisableHls) && this.player.load();
        }
      }, {
        key: "componentDidUpdate",
        value: function(N) {
          this.shouldUseAudio(this.props) !== this.shouldUseAudio(N) && (this.removeListeners(this.prevPlayer, N.url), this.addListeners(this.player)), this.props.url !== N.url && !(0, n.isMediaStream)(this.props.url) && !(this.props.url instanceof Array) && (this.player.srcObject = null);
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          this.player.removeAttribute("src"), this.removeListeners(this.player), this.hls && this.hls.destroy();
        }
      }, {
        key: "addListeners",
        value: function(N) {
          var U = this.props, Y = U.url, L = U.playsinline;
          N.addEventListener("play", this.onPlay), N.addEventListener("waiting", this.onBuffer), N.addEventListener("playing", this.onBufferEnd), N.addEventListener("pause", this.onPause), N.addEventListener("seeked", this.onSeek), N.addEventListener("ended", this.onEnded), N.addEventListener("error", this.onError), N.addEventListener("ratechange", this.onPlayBackRateChange), N.addEventListener("enterpictureinpicture", this.onEnablePIP), N.addEventListener("leavepictureinpicture", this.onDisablePIP), N.addEventListener("webkitpresentationmodechanged", this.onPresentationModeChange), this.shouldUseHLS(Y) || N.addEventListener("canplay", this.onReady), L && (N.setAttribute("playsinline", ""), N.setAttribute("webkit-playsinline", ""), N.setAttribute("x5-playsinline", ""));
        }
      }, {
        key: "removeListeners",
        value: function(N, U) {
          N.removeEventListener("canplay", this.onReady), N.removeEventListener("play", this.onPlay), N.removeEventListener("waiting", this.onBuffer), N.removeEventListener("playing", this.onBufferEnd), N.removeEventListener("pause", this.onPause), N.removeEventListener("seeked", this.onSeek), N.removeEventListener("ended", this.onEnded), N.removeEventListener("error", this.onError), N.removeEventListener("ratechange", this.onPlayBackRateChange), N.removeEventListener("enterpictureinpicture", this.onEnablePIP), N.removeEventListener("leavepictureinpicture", this.onDisablePIP), N.removeEventListener("webkitpresentationmodechanged", this.onPresentationModeChange), this.shouldUseHLS(U) || N.removeEventListener("canplay", this.onReady);
        }
        // Proxy methods to prevent listener leaks
      }, {
        key: "shouldUseAudio",
        value: function(N) {
          return N.config.forceVideo || N.config.attributes.poster ? !1 : a.AUDIO_EXTENSIONS.test(N.url) || N.config.forceAudio;
        }
      }, {
        key: "shouldUseHLS",
        value: function(N) {
          return A && this.props.config.forceSafariHLS || this.props.config.forceHLS ? !0 : T || this.props.config.forceDisableHls ? !1 : a.HLS_EXTENSIONS.test(N) || P.test(N);
        }
      }, {
        key: "shouldUseDASH",
        value: function(N) {
          return a.DASH_EXTENSIONS.test(N) || this.props.config.forceDASH;
        }
      }, {
        key: "shouldUseFLV",
        value: function(N) {
          return a.FLV_EXTENSIONS.test(N) || this.props.config.forceFLV;
        }
      }, {
        key: "load",
        value: function(N) {
          var U = this, Y = this.props.config, L = Y.hlsVersion, q = Y.hlsOptions, V = Y.dashVersion, X = Y.flvVersion;
          if (this.hls && this.hls.destroy(), this.dash && this.dash.reset(), this.shouldUseHLS(N) && (0, n.getSDK)(D.replace("VERSION", L), h).then(function(te) {
            if (U.hls = new te(q), U.hls.on(te.Events.MANIFEST_PARSED, function() {
              U.props.onReady();
            }), U.hls.on(te.Events.ERROR, function(ue, pe) {
              U.props.onError(ue, pe, U.hls, te);
            }), P.test(N)) {
              var re = N.match(P)[1];
              U.hls.loadSource($.replace("{id}", re));
            } else
              U.hls.loadSource(N);
            U.hls.attachMedia(U.player), U.props.onLoaded();
          }), this.shouldUseDASH(N) && (0, n.getSDK)(y.replace("VERSION", V), v).then(function(te) {
            U.dash = te.MediaPlayer().create(), U.dash.initialize(U.player, N, U.props.playing), U.dash.on("error", U.props.onError), parseInt(V) < 3 ? U.dash.getDebug().setLogToBrowserConsole(!1) : U.dash.updateSettings({
              debug: {
                logLevel: te.Debug.LOG_LEVEL_NONE
              }
            }), U.props.onLoaded();
          }), this.shouldUseFLV(N) && (0, n.getSDK)(E.replace("VERSION", X), _).then(function(te) {
            U.flv = te.createPlayer({
              type: "flv",
              url: N
            }), U.flv.attachMediaElement(U.player), U.flv.on(te.Events.ERROR, function(re, ue) {
              U.props.onError(re, ue, U.flv, te);
            }), U.flv.load(), U.props.onLoaded();
          }), N instanceof Array)
            this.player.load();
          else if ((0, n.isMediaStream)(N))
            try {
              this.player.srcObject = N;
            } catch {
              this.player.src = window.URL.createObjectURL(N);
            }
        }
      }, {
        key: "play",
        value: function() {
          var N = this.player.play();
          N && N.catch(this.props.onError);
        }
      }, {
        key: "pause",
        value: function() {
          this.player.pause();
        }
      }, {
        key: "stop",
        value: function() {
          this.player.removeAttribute("src"), this.dash && this.dash.reset();
        }
      }, {
        key: "seekTo",
        value: function(N) {
          var U = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.player.currentTime = N, U || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(N) {
          this.player.volume = N;
        }
      }, {
        key: "enablePIP",
        value: function() {
          this.player.requestPictureInPicture && document.pictureInPictureElement !== this.player ? this.player.requestPictureInPicture() : (0, n.supportsWebKitPresentationMode)(this.player) && this.player.webkitPresentationMode !== "picture-in-picture" && this.player.webkitSetPresentationMode("picture-in-picture");
        }
      }, {
        key: "disablePIP",
        value: function() {
          document.exitPictureInPicture && document.pictureInPictureElement === this.player ? document.exitPictureInPicture() : (0, n.supportsWebKitPresentationMode)(this.player) && this.player.webkitPresentationMode !== "inline" && this.player.webkitSetPresentationMode("inline");
        }
      }, {
        key: "setPlaybackRate",
        value: function(N) {
          try {
            this.player.playbackRate = N;
          } catch (U) {
            this.props.onError(U);
          }
        }
      }, {
        key: "getDuration",
        value: function() {
          if (!this.player)
            return null;
          var N = this.player, U = N.duration, Y = N.seekable;
          return U === 1 / 0 && Y.length > 0 ? Y.end(Y.length - 1) : U;
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.player ? this.player.currentTime : null;
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          if (!this.player)
            return null;
          var N = this.player.buffered;
          if (N.length === 0)
            return 0;
          var U = N.end(N.length - 1), Y = this.getDuration();
          return U > Y ? Y : U;
        }
      }, {
        key: "getSource",
        value: function(N) {
          var U = this.shouldUseHLS(N), Y = this.shouldUseDASH(N), L = this.shouldUseFLV(N);
          if (!(N instanceof Array || (0, n.isMediaStream)(N) || U || Y || L))
            return C.test(N) ? N.replace("www.dropbox.com", "dl.dropboxusercontent.com") : N;
        }
      }, {
        key: "render",
        value: function() {
          var N = this.props, U = N.url, Y = N.playing, L = N.loop, q = N.controls, V = N.muted, X = N.config, te = N.width, re = N.height, ue = this.shouldUseAudio(this.props), pe = ue ? "audio" : "video", ye = {
            width: te === "auto" ? te : "100%",
            height: re === "auto" ? re : "100%"
          };
          return /* @__PURE__ */ r.default.createElement(pe, l({
            ref: this.ref,
            src: this.getSource(U),
            style: ye,
            preload: "auto",
            autoPlay: Y || void 0,
            controls: q,
            muted: V,
            loop: L
          }, X.attributes), U instanceof Array && U.map(this.renderSourceElement), X.tracks.map(this.renderTrack));
        }
      }]), F;
    }(r.Component);
    t.default = W, O(W, "displayName", "FilePlayer"), O(W, "canPlay", a.canPlay.file);
  }(wl)), wl;
}
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = M, r = Ne, n = ce;
  function a(o) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? a = function(c) {
      return typeof c;
    } : a = function(c) {
      return c && typeof Symbol == "function" && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
    }, a(o);
  }
  function i() {
    if (typeof WeakMap != "function")
      return null;
    var o = /* @__PURE__ */ new WeakMap();
    return i = function() {
      return o;
    }, o;
  }
  function s(o) {
    if (o && o.__esModule)
      return o;
    if (o === null || a(o) !== "object" && typeof o != "function")
      return { default: o };
    var u = i();
    if (u && u.has(o))
      return u.get(o);
    var c = {}, f = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var p in o)
      if (Object.prototype.hasOwnProperty.call(o, p)) {
        var g = f ? Object.getOwnPropertyDescriptor(o, p) : null;
        g && (g.get || g.set) ? Object.defineProperty(c, p, g) : c[p] = o[p];
      }
    return c.default = o, u && u.set(o, c), c;
  }
  var l = [{
    key: "youtube",
    name: "YouTube",
    canPlay: n.canPlay.youtube,
    lazyPlayer: /* @__PURE__ */ (0, e.lazy)(function() {
      return Promise.resolve().then(function() {
        return s(PW());
      });
    })
  }, {
    key: "soundcloud",
    name: "SoundCloud",
    canPlay: n.canPlay.soundcloud,
    lazyPlayer: /* @__PURE__ */ (0, e.lazy)(function() {
      return Promise.resolve().then(function() {
        return s(_W());
      });
    })
  }, {
    key: "vimeo",
    name: "Vimeo",
    canPlay: n.canPlay.vimeo,
    lazyPlayer: /* @__PURE__ */ (0, e.lazy)(function() {
      return Promise.resolve().then(function() {
        return s(AW());
      });
    })
  }, {
    key: "facebook",
    name: "Facebook",
    canPlay: n.canPlay.facebook,
    lazyPlayer: /* @__PURE__ */ (0, e.lazy)(function() {
      return Promise.resolve().then(function() {
        return s(TW());
      });
    })
  }, {
    key: "streamable",
    name: "Streamable",
    canPlay: n.canPlay.streamable,
    lazyPlayer: /* @__PURE__ */ (0, e.lazy)(function() {
      return Promise.resolve().then(function() {
        return s(BW());
      });
    })
  }, {
    key: "wistia",
    name: "Wistia",
    canPlay: n.canPlay.wistia,
    lazyPlayer: /* @__PURE__ */ (0, e.lazy)(function() {
      return Promise.resolve().then(function() {
        return s(RW());
      });
    })
  }, {
    key: "twitch",
    name: "Twitch",
    canPlay: n.canPlay.twitch,
    lazyPlayer: /* @__PURE__ */ (0, e.lazy)(function() {
      return Promise.resolve().then(function() {
        return s($W());
      });
    })
  }, {
    key: "dailymotion",
    name: "DailyMotion",
    canPlay: n.canPlay.dailymotion,
    lazyPlayer: /* @__PURE__ */ (0, e.lazy)(function() {
      return Promise.resolve().then(function() {
        return s(MW());
      });
    })
  }, {
    key: "mixcloud",
    name: "Mixcloud",
    canPlay: n.canPlay.mixcloud,
    lazyPlayer: /* @__PURE__ */ (0, e.lazy)(function() {
      return Promise.resolve().then(function() {
        return s(FW());
      });
    })
  }, {
    key: "vidyard",
    name: "Vidyard",
    canPlay: n.canPlay.vidyard,
    lazyPlayer: /* @__PURE__ */ (0, e.lazy)(function() {
      return Promise.resolve().then(function() {
        return s(IW());
      });
    })
  }, {
    key: "kaltura",
    name: "Kaltura",
    canPlay: n.canPlay.kaltura,
    lazyPlayer: /* @__PURE__ */ (0, e.lazy)(function() {
      return Promise.resolve().then(function() {
        return s(jW());
      });
    })
  }, {
    key: "file",
    name: "FilePlayer",
    canPlay: n.canPlay.file,
    canEnablePIP: function(u) {
      return n.canPlay.file(u) && (document.pictureInPictureEnabled || (0, r.supportsWebKitPresentationMode)()) && !n.AUDIO_EXTENSIONS.test(u);
    },
    lazyPlayer: /* @__PURE__ */ (0, e.lazy)(function() {
      return Promise.resolve().then(function() {
        return s(LW());
      });
    })
  }];
  t.default = l;
})(G0);
var go = {}, Lg = Number.isNaN || function(e) {
  return typeof e == "number" && e !== e;
};
function kW(t, e) {
  return !!(t === e || Lg(t) && Lg(e));
}
function NW(t, e) {
  if (t.length !== e.length)
    return !1;
  for (var r = 0; r < t.length; r++)
    if (!kW(t[r], e[r]))
      return !1;
  return !0;
}
function zW(t, e) {
  e === void 0 && (e = NW);
  var r, n = [], a, i = !1;
  function s() {
    for (var l = [], o = 0; o < arguments.length; o++)
      l[o] = arguments[o];
    return i && r === this && e(l, n) || (a = t.apply(this, l), i = !0, r = this, n = l), a;
  }
  return s;
}
const WW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zW
}, Symbol.toStringTag, { value: "Module" })), HW = /* @__PURE__ */ zb(WW);
var UW = typeof Element < "u", VW = typeof Map == "function", qW = typeof Set == "function", GW = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function cs(t, e) {
  if (t === e)
    return !0;
  if (t && e && typeof t == "object" && typeof e == "object") {
    if (t.constructor !== e.constructor)
      return !1;
    var r, n, a;
    if (Array.isArray(t)) {
      if (r = t.length, r != e.length)
        return !1;
      for (n = r; n-- !== 0; )
        if (!cs(t[n], e[n]))
          return !1;
      return !0;
    }
    var i;
    if (VW && t instanceof Map && e instanceof Map) {
      if (t.size !== e.size)
        return !1;
      for (i = t.entries(); !(n = i.next()).done; )
        if (!e.has(n.value[0]))
          return !1;
      for (i = t.entries(); !(n = i.next()).done; )
        if (!cs(n.value[1], e.get(n.value[0])))
          return !1;
      return !0;
    }
    if (qW && t instanceof Set && e instanceof Set) {
      if (t.size !== e.size)
        return !1;
      for (i = t.entries(); !(n = i.next()).done; )
        if (!e.has(n.value[0]))
          return !1;
      return !0;
    }
    if (GW && ArrayBuffer.isView(t) && ArrayBuffer.isView(e)) {
      if (r = t.length, r != e.length)
        return !1;
      for (n = r; n-- !== 0; )
        if (t[n] !== e[n])
          return !1;
      return !0;
    }
    if (t.constructor === RegExp)
      return t.source === e.source && t.flags === e.flags;
    if (t.valueOf !== Object.prototype.valueOf && typeof t.valueOf == "function" && typeof e.valueOf == "function")
      return t.valueOf() === e.valueOf();
    if (t.toString !== Object.prototype.toString && typeof t.toString == "function" && typeof e.toString == "function")
      return t.toString() === e.toString();
    if (a = Object.keys(t), r = a.length, r !== Object.keys(e).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(e, a[n]))
        return !1;
    if (UW && t instanceof Element)
      return !1;
    for (n = r; n-- !== 0; )
      if (!((a[n] === "_owner" || a[n] === "__v" || a[n] === "__o") && t.$$typeof) && !cs(t[a[n]], e[a[n]]))
        return !1;
    return !0;
  }
  return t !== t && e !== e;
}
var dy = function(e, r) {
  try {
    return cs(e, r);
  } catch (n) {
    if ((n.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw n;
  }
}, gn = {};
Object.defineProperty(gn, "__esModule", {
  value: !0
});
gn.defaultProps = gn.propTypes = void 0;
var Rr = YW(ee);
function YW(t) {
  return t && t.__esModule ? t : { default: t };
}
var bt = Rr.default.string, wt = Rr.default.bool, Mn = Rr.default.number, xl = Rr.default.array, La = Rr.default.oneOfType, Lt = Rr.default.shape, xt = Rr.default.object, it = Rr.default.func, kg = Rr.default.node, KW = {
  url: La([bt, xl, xt]),
  playing: wt,
  loop: wt,
  controls: wt,
  volume: Mn,
  muted: wt,
  playbackRate: Mn,
  width: La([bt, Mn]),
  height: La([bt, Mn]),
  style: xt,
  progressInterval: Mn,
  playsinline: wt,
  pip: wt,
  stopOnUnmount: wt,
  light: La([wt, bt, xt]),
  playIcon: kg,
  previewTabIndex: Mn,
  fallback: kg,
  oEmbedUrl: bt,
  wrapper: La([bt, it, Lt({
    render: it.isRequired
  })]),
  config: Lt({
    soundcloud: Lt({
      options: xt
    }),
    youtube: Lt({
      playerVars: xt,
      embedOptions: xt,
      onUnstarted: it
    }),
    facebook: Lt({
      appId: bt,
      version: bt,
      playerId: bt,
      attributes: xt
    }),
    dailymotion: Lt({
      params: xt
    }),
    vimeo: Lt({
      playerOptions: xt,
      title: bt
    }),
    file: Lt({
      attributes: xt,
      tracks: xl,
      forceVideo: wt,
      forceAudio: wt,
      forceHLS: wt,
      forceSafariHLS: wt,
      forceDisableHls: wt,
      forceDASH: wt,
      forceFLV: wt,
      hlsOptions: xt,
      hlsVersion: bt,
      dashVersion: bt,
      flvVersion: bt
    }),
    wistia: Lt({
      options: xt,
      playerId: bt,
      customControls: xl
    }),
    mixcloud: Lt({
      options: xt
    }),
    twitch: Lt({
      options: xt,
      playerId: bt
    }),
    vidyard: Lt({
      options: xt
    })
  }),
  onReady: it,
  onStart: it,
  onPlay: it,
  onPause: it,
  onBuffer: it,
  onBufferEnd: it,
  onEnded: it,
  onError: it,
  onDuration: it,
  onSeek: it,
  onPlaybackRateChange: it,
  onPlaybackQualityChange: it,
  onProgress: it,
  onClickPreview: it,
  onEnablePIP: it,
  onDisablePIP: it
};
gn.propTypes = KW;
var ut = function() {
}, XW = {
  playing: !1,
  loop: !1,
  controls: !1,
  volume: null,
  muted: !1,
  playbackRate: 1,
  width: "640px",
  height: "360px",
  style: {},
  progressInterval: 1e3,
  playsinline: !1,
  pip: !1,
  stopOnUnmount: !0,
  light: !1,
  fallback: null,
  wrapper: "div",
  previewTabIndex: 0,
  oEmbedUrl: "https://noembed.com/embed?url={url}",
  config: {
    soundcloud: {
      options: {
        visual: !0,
        // Undocumented, but makes player fill container and look better
        buying: !1,
        liking: !1,
        download: !1,
        sharing: !1,
        show_comments: !1,
        show_playcount: !1
      }
    },
    youtube: {
      playerVars: {
        playsinline: 1,
        showinfo: 0,
        rel: 0,
        iv_load_policy: 3,
        modestbranding: 1
      },
      embedOptions: {},
      onUnstarted: ut
    },
    facebook: {
      appId: "1309697205772819",
      version: "v3.3",
      playerId: null,
      attributes: {}
    },
    dailymotion: {
      params: {
        api: 1,
        "endscreen-enable": !1
      }
    },
    vimeo: {
      playerOptions: {
        autopause: !1,
        byline: !1,
        portrait: !1,
        title: !1
      },
      title: null
    },
    file: {
      attributes: {},
      tracks: [],
      forceVideo: !1,
      forceAudio: !1,
      forceHLS: !1,
      forceDASH: !1,
      forceFLV: !1,
      hlsOptions: {},
      hlsVersion: "1.1.4",
      dashVersion: "3.1.3",
      flvVersion: "1.5.0",
      forceDisableHls: !1
    },
    wistia: {
      options: {},
      playerId: null,
      customControls: null
    },
    mixcloud: {
      options: {
        hide_cover: 1
      }
    },
    twitch: {
      options: {},
      playerId: null
    },
    vidyard: {
      options: {}
    }
  },
  onReady: ut,
  onStart: ut,
  onPlay: ut,
  onPause: ut,
  onBuffer: ut,
  onBufferEnd: ut,
  onEnded: ut,
  onError: ut,
  onDuration: ut,
  onSeek: ut,
  onPlaybackRateChange: ut,
  onPlaybackQualityChange: ut,
  onProgress: ut,
  onClickPreview: ut,
  onEnablePIP: ut,
  onDisablePIP: ut
};
gn.defaultProps = XW;
var py = {};
(function(t) {
  function e(D) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(y) {
      return typeof y;
    } : e = function(y) {
      return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
    }, e(D);
  }
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = o(M), n = s(dy), a = gn, i = Ne;
  function s(D) {
    return D && D.__esModule ? D : { default: D };
  }
  function l() {
    if (typeof WeakMap != "function")
      return null;
    var D = /* @__PURE__ */ new WeakMap();
    return l = function() {
      return D;
    }, D;
  }
  function o(D) {
    if (D && D.__esModule)
      return D;
    if (D === null || e(D) !== "object" && typeof D != "function")
      return { default: D };
    var h = l();
    if (h && h.has(D))
      return h.get(D);
    var y = {}, v = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var E in D)
      if (Object.prototype.hasOwnProperty.call(D, E)) {
        var _ = v ? Object.getOwnPropertyDescriptor(D, E) : null;
        _ && (_.get || _.set) ? Object.defineProperty(y, E, _) : y[E] = D[E];
      }
    return y.default = D, h && h.set(D, y), y;
  }
  function u() {
    return u = Object.assign || function(D) {
      for (var h = 1; h < arguments.length; h++) {
        var y = arguments[h];
        for (var v in y)
          Object.prototype.hasOwnProperty.call(y, v) && (D[v] = y[v]);
      }
      return D;
    }, u.apply(this, arguments);
  }
  function c(D, h) {
    if (!(D instanceof h))
      throw new TypeError("Cannot call a class as a function");
  }
  function f(D, h) {
    for (var y = 0; y < h.length; y++) {
      var v = h[y];
      v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(D, v.key, v);
    }
  }
  function p(D, h, y) {
    return h && f(D.prototype, h), y && f(D, y), D;
  }
  function g(D, h) {
    if (typeof h != "function" && h !== null)
      throw new TypeError("Super expression must either be null or a function");
    D.prototype = Object.create(h && h.prototype, { constructor: { value: D, writable: !0, configurable: !0 } }), h && m(D, h);
  }
  function m(D, h) {
    return m = Object.setPrototypeOf || function(v, E) {
      return v.__proto__ = E, v;
    }, m(D, h);
  }
  function d(D) {
    var h = O();
    return function() {
      var v = S(D), E;
      if (h) {
        var _ = S(this).constructor;
        E = Reflect.construct(v, arguments, _);
      } else
        E = v.apply(this, arguments);
      return w(this, E);
    };
  }
  function w(D, h) {
    return h && (e(h) === "object" || typeof h == "function") ? h : b(D);
  }
  function b(D) {
    if (D === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return D;
  }
  function O() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function S(D) {
    return S = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
      return y.__proto__ || Object.getPrototypeOf(y);
    }, S(D);
  }
  function B(D, h, y) {
    return h in D ? Object.defineProperty(D, h, { value: y, enumerable: !0, configurable: !0, writable: !0 }) : D[h] = y, D;
  }
  var T = 5e3, A = /* @__PURE__ */ function(D) {
    g(y, D);
    var h = d(y);
    function y() {
      var v;
      c(this, y);
      for (var E = arguments.length, _ = new Array(E), C = 0; C < E; C++)
        _[C] = arguments[C];
      return v = h.call.apply(h, [this].concat(_)), B(b(v), "mounted", !1), B(b(v), "isReady", !1), B(b(v), "isPlaying", !1), B(b(v), "isLoading", !0), B(b(v), "loadOnReady", null), B(b(v), "startOnPlay", !0), B(b(v), "seekOnPlay", null), B(b(v), "onDurationCalled", !1), B(b(v), "handlePlayerMount", function(P) {
        if (v.player) {
          v.progress();
          return;
        }
        v.player = P, v.player.load(v.props.url), v.progress();
      }), B(b(v), "getInternalPlayer", function(P) {
        return v.player ? v.player[P] : null;
      }), B(b(v), "progress", function() {
        if (v.props.url && v.player && v.isReady) {
          var P = v.getCurrentTime() || 0, $ = v.getSecondsLoaded(), W = v.getDuration();
          if (W) {
            var j = {
              playedSeconds: P,
              played: P / W
            };
            $ !== null && (j.loadedSeconds = $, j.loaded = $ / W), (j.playedSeconds !== v.prevPlayed || j.loadedSeconds !== v.prevLoaded) && v.props.onProgress(j), v.prevPlayed = j.playedSeconds, v.prevLoaded = j.loadedSeconds;
          }
        }
        v.progressTimeout = setTimeout(v.progress, v.props.progressFrequency || v.props.progressInterval);
      }), B(b(v), "handleReady", function() {
        if (v.mounted) {
          v.isReady = !0, v.isLoading = !1;
          var P = v.props, $ = P.onReady, W = P.playing, j = P.volume, I = P.muted;
          $(), !I && j !== null && v.player.setVolume(j), v.loadOnReady ? (v.player.load(v.loadOnReady, !0), v.loadOnReady = null) : W && v.player.play(), v.handleDurationCheck();
        }
      }), B(b(v), "handlePlay", function() {
        v.isPlaying = !0, v.isLoading = !1;
        var P = v.props, $ = P.onStart, W = P.onPlay, j = P.playbackRate;
        v.startOnPlay && (v.player.setPlaybackRate && j !== 1 && v.player.setPlaybackRate(j), $(), v.startOnPlay = !1), W(), v.seekOnPlay && (v.seekTo(v.seekOnPlay), v.seekOnPlay = null), v.handleDurationCheck();
      }), B(b(v), "handlePause", function(P) {
        v.isPlaying = !1, v.isLoading || v.props.onPause(P);
      }), B(b(v), "handleEnded", function() {
        var P = v.props, $ = P.activePlayer, W = P.loop, j = P.onEnded;
        $.loopOnEnded && W && v.seekTo(0), W || (v.isPlaying = !1, j());
      }), B(b(v), "handleError", function() {
        var P;
        v.isLoading = !1, (P = v.props).onError.apply(P, arguments);
      }), B(b(v), "handleDurationCheck", function() {
        clearTimeout(v.durationCheckTimeout);
        var P = v.getDuration();
        P ? v.onDurationCalled || (v.props.onDuration(P), v.onDurationCalled = !0) : v.durationCheckTimeout = setTimeout(v.handleDurationCheck, 100);
      }), B(b(v), "handleLoaded", function() {
        v.isLoading = !1;
      }), v;
    }
    return p(y, [{
      key: "componentDidMount",
      value: function() {
        this.mounted = !0;
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        clearTimeout(this.progressTimeout), clearTimeout(this.durationCheckTimeout), this.isReady && this.props.stopOnUnmount && (this.player.stop(), this.player.disablePIP && this.player.disablePIP()), this.mounted = !1;
      }
    }, {
      key: "componentDidUpdate",
      value: function(E) {
        var _ = this;
        if (this.player) {
          var C = this.props, P = C.url, $ = C.playing, W = C.volume, j = C.muted, I = C.playbackRate, F = C.pip, k = C.loop, N = C.activePlayer, U = C.disableDeferredLoading;
          if (!(0, n.default)(E.url, P)) {
            if (this.isLoading && !N.forceLoad && !U && !(0, i.isMediaStream)(P)) {
              console.warn("ReactPlayer: the attempt to load ".concat(P, " is being deferred until the player has loaded")), this.loadOnReady = P;
              return;
            }
            this.isLoading = !0, this.startOnPlay = !0, this.onDurationCalled = !1, this.player.load(P, this.isReady);
          }
          !E.playing && $ && !this.isPlaying && this.player.play(), E.playing && !$ && this.isPlaying && this.player.pause(), !E.pip && F && this.player.enablePIP && this.player.enablePIP(), E.pip && !F && this.player.disablePIP && this.player.disablePIP(), E.volume !== W && W !== null && this.player.setVolume(W), E.muted !== j && (j ? this.player.mute() : (this.player.unmute(), W !== null && setTimeout(function() {
            return _.player.setVolume(W);
          }))), E.playbackRate !== I && this.player.setPlaybackRate && this.player.setPlaybackRate(I), E.loop !== k && this.player.setLoop && this.player.setLoop(k);
        }
      }
    }, {
      key: "getDuration",
      value: function() {
        return this.isReady ? this.player.getDuration() : null;
      }
    }, {
      key: "getCurrentTime",
      value: function() {
        return this.isReady ? this.player.getCurrentTime() : null;
      }
    }, {
      key: "getSecondsLoaded",
      value: function() {
        return this.isReady ? this.player.getSecondsLoaded() : null;
      }
    }, {
      key: "seekTo",
      value: function(E, _, C) {
        var P = this;
        if (!this.isReady) {
          E !== 0 && (this.seekOnPlay = E, setTimeout(function() {
            P.seekOnPlay = null;
          }, T));
          return;
        }
        var $ = _ ? _ === "fraction" : E > 0 && E < 1;
        if ($) {
          var W = this.player.getDuration();
          if (!W) {
            console.warn("ReactPlayer: could not seek using fraction – duration not yet available");
            return;
          }
          this.player.seekTo(W * E, C);
          return;
        }
        this.player.seekTo(E, C);
      }
    }, {
      key: "render",
      value: function() {
        var E = this.props.activePlayer;
        return E ? /* @__PURE__ */ r.default.createElement(E, u({}, this.props, {
          onMount: this.handlePlayerMount,
          onReady: this.handleReady,
          onPlay: this.handlePlay,
          onPause: this.handlePause,
          onEnded: this.handleEnded,
          onLoaded: this.handleLoaded,
          onError: this.handleError
        })) : null;
      }
    }]), y;
  }(r.Component);
  t.default = A, B(A, "displayName", "Player"), B(A, "propTypes", a.propTypes), B(A, "defaultProps", a.defaultProps);
})(py);
var El = {}, Ng;
function ZW() {
  return Ng || (Ng = 1, function(t) {
    function e(T) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(D) {
        return typeof D;
      } : e = function(D) {
        return D && typeof Symbol == "function" && D.constructor === Symbol && D !== Symbol.prototype ? "symbol" : typeof D;
      }, e(T);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = a(M);
    function n() {
      if (typeof WeakMap != "function")
        return null;
      var T = /* @__PURE__ */ new WeakMap();
      return n = function() {
        return T;
      }, T;
    }
    function a(T) {
      if (T && T.__esModule)
        return T;
      if (T === null || e(T) !== "object" && typeof T != "function")
        return { default: T };
      var A = n();
      if (A && A.has(T))
        return A.get(T);
      var D = {}, h = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var y in T)
        if (Object.prototype.hasOwnProperty.call(T, y)) {
          var v = h ? Object.getOwnPropertyDescriptor(T, y) : null;
          v && (v.get || v.set) ? Object.defineProperty(D, y, v) : D[y] = T[y];
        }
      return D.default = T, A && A.set(T, D), D;
    }
    function i(T, A) {
      var D = Object.keys(T);
      if (Object.getOwnPropertySymbols) {
        var h = Object.getOwnPropertySymbols(T);
        A && (h = h.filter(function(y) {
          return Object.getOwnPropertyDescriptor(T, y).enumerable;
        })), D.push.apply(D, h);
      }
      return D;
    }
    function s(T) {
      for (var A = 1; A < arguments.length; A++) {
        var D = arguments[A] != null ? arguments[A] : {};
        A % 2 ? i(Object(D), !0).forEach(function(h) {
          b(T, h, D[h]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(T, Object.getOwnPropertyDescriptors(D)) : i(Object(D)).forEach(function(h) {
          Object.defineProperty(T, h, Object.getOwnPropertyDescriptor(D, h));
        });
      }
      return T;
    }
    function l(T, A) {
      if (!(T instanceof A))
        throw new TypeError("Cannot call a class as a function");
    }
    function o(T, A) {
      for (var D = 0; D < A.length; D++) {
        var h = A[D];
        h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(T, h.key, h);
      }
    }
    function u(T, A, D) {
      return A && o(T.prototype, A), D && o(T, D), T;
    }
    function c(T, A) {
      if (typeof A != "function" && A !== null)
        throw new TypeError("Super expression must either be null or a function");
      T.prototype = Object.create(A && A.prototype, { constructor: { value: T, writable: !0, configurable: !0 } }), A && f(T, A);
    }
    function f(T, A) {
      return f = Object.setPrototypeOf || function(h, y) {
        return h.__proto__ = y, h;
      }, f(T, A);
    }
    function p(T) {
      var A = d();
      return function() {
        var h = w(T), y;
        if (A) {
          var v = w(this).constructor;
          y = Reflect.construct(h, arguments, v);
        } else
          y = h.apply(this, arguments);
        return g(this, y);
      };
    }
    function g(T, A) {
      return A && (e(A) === "object" || typeof A == "function") ? A : m(T);
    }
    function m(T) {
      if (T === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return T;
    }
    function d() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function w(T) {
      return w = Object.setPrototypeOf ? Object.getPrototypeOf : function(D) {
        return D.__proto__ || Object.getPrototypeOf(D);
      }, w(T);
    }
    function b(T, A, D) {
      return A in T ? Object.defineProperty(T, A, { value: D, enumerable: !0, configurable: !0, writable: !0 }) : T[A] = D, T;
    }
    var O = "64px", S = {}, B = /* @__PURE__ */ function(T) {
      c(D, T);
      var A = p(D);
      function D() {
        var h;
        l(this, D);
        for (var y = arguments.length, v = new Array(y), E = 0; E < y; E++)
          v[E] = arguments[E];
        return h = A.call.apply(A, [this].concat(v)), b(m(h), "mounted", !1), b(m(h), "state", {
          image: null
        }), b(m(h), "handleKeyPress", function(_) {
          (_.key === "Enter" || _.key === " ") && h.props.onClick();
        }), h;
      }
      return u(D, [{
        key: "componentDidMount",
        value: function() {
          this.mounted = !0, this.fetchImage(this.props);
        }
      }, {
        key: "componentDidUpdate",
        value: function(y) {
          var v = this.props, E = v.url, _ = v.light;
          (y.url !== E || y.light !== _) && this.fetchImage(this.props);
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          this.mounted = !1;
        }
      }, {
        key: "fetchImage",
        value: function(y) {
          var v = this, E = y.url, _ = y.light, C = y.oEmbedUrl;
          if (!/* @__PURE__ */ r.default.isValidElement(_)) {
            if (typeof _ == "string") {
              this.setState({
                image: _
              });
              return;
            }
            if (S[E]) {
              this.setState({
                image: S[E]
              });
              return;
            }
            return this.setState({
              image: null
            }), window.fetch(C.replace("{url}", E)).then(function(P) {
              return P.json();
            }).then(function(P) {
              if (P.thumbnail_url && v.mounted) {
                var $ = P.thumbnail_url.replace("height=100", "height=480").replace("-d_295x166", "-d_640");
                v.setState({
                  image: $
                }), S[E] = $;
              }
            });
          }
        }
      }, {
        key: "render",
        value: function() {
          var y = this.props, v = y.light, E = y.onClick, _ = y.playIcon, C = y.previewTabIndex, P = this.state.image, $ = /* @__PURE__ */ r.default.isValidElement(v), W = {
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }, j = {
            preview: s({
              width: "100%",
              height: "100%",
              backgroundImage: P && !$ ? "url(".concat(P, ")") : void 0,
              backgroundSize: "cover",
              backgroundPosition: "center",
              cursor: "pointer"
            }, W),
            shadow: s({
              background: "radial-gradient(rgb(0, 0, 0, 0.3), rgba(0, 0, 0, 0) 60%)",
              borderRadius: O,
              width: O,
              height: O,
              position: $ ? "absolute" : void 0
            }, W),
            playIcon: {
              borderStyle: "solid",
              borderWidth: "16px 0 16px 26px",
              borderColor: "transparent transparent transparent white",
              marginLeft: "7px"
            }
          }, I = /* @__PURE__ */ r.default.createElement("div", {
            style: j.shadow,
            className: "react-player__shadow"
          }, /* @__PURE__ */ r.default.createElement("div", {
            style: j.playIcon,
            className: "react-player__play-icon"
          }));
          return /* @__PURE__ */ r.default.createElement("div", {
            style: j.preview,
            className: "react-player__preview",
            onClick: E,
            tabIndex: C,
            onKeyPress: this.handleKeyPress
          }, $ ? v : null, _ || I);
        }
      }]), D;
    }(r.Component);
    t.default = B;
  }(El)), El;
}
Object.defineProperty(go, "__esModule", {
  value: !0
});
go.createReactPlayer = void 0;
var rn = gy(M), JW = vo(K0), Cl = vo(HW), zg = vo(dy), Ga = gn, QW = Ne, eH = vo(py);
function vo(t) {
  return t && t.__esModule ? t : { default: t };
}
function ri(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ri = function(r) {
    return typeof r;
  } : ri = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, ri(t);
}
function Wg(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Hg(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Wg(Object(r), !0).forEach(function(n) {
      Je(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Wg(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Ms() {
  return Ms = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Ms.apply(this, arguments);
}
function Dl(t) {
  return aH(t) || nH(t) || rH(t) || tH();
}
function tH() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rH(t, e) {
  if (t) {
    if (typeof t == "string")
      return pu(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
      return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return pu(t, e);
  }
}
function nH(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function aH(t) {
  if (Array.isArray(t))
    return pu(t);
}
function pu(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function iH(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Ug(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
  }
}
function sH(t, e, r) {
  return e && Ug(t.prototype, e), r && Ug(t, r), t;
}
function oH(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && hu(t, e);
}
function hu(t, e) {
  return hu = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, hu(t, e);
}
function lH(t) {
  var e = cH();
  return function() {
    var n = Fs(t), a;
    if (e) {
      var i = Fs(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return uH(this, a);
  };
}
function uH(t, e) {
  return e && (ri(e) === "object" || typeof e == "function") ? e : pt(t);
}
function pt(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function cH() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Fs(t) {
  return Fs = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Fs(t);
}
function Je(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function hy() {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap();
  return hy = function() {
    return t;
  }, t;
}
function gy(t) {
  if (t && t.__esModule)
    return t;
  if (t === null || ri(t) !== "object" && typeof t != "function")
    return { default: t };
  var e = hy();
  if (e && e.has(t))
    return e.get(t);
  var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var a in t)
    if (Object.prototype.hasOwnProperty.call(t, a)) {
      var i = n ? Object.getOwnPropertyDescriptor(t, a) : null;
      i && (i.get || i.set) ? Object.defineProperty(r, a, i) : r[a] = t[a];
    }
  return r.default = t, e && e.set(t, r), r;
}
var fH = /* @__PURE__ */ (0, rn.lazy)(function() {
  return Promise.resolve().then(function() {
    return gy(ZW());
  });
}), dH = typeof window < "u" && window.document, pH = typeof tt < "u" && tt.window && tt.window.document, hH = Object.keys(Ga.propTypes), gH = dH || pH ? rn.Suspense : function() {
  return null;
}, ka = [], vH = function(e, r) {
  var n, a;
  return a = n = /* @__PURE__ */ function(i) {
    oH(l, i);
    var s = lH(l);
    function l() {
      var o;
      iH(this, l);
      for (var u = arguments.length, c = new Array(u), f = 0; f < u; f++)
        c[f] = arguments[f];
      return o = s.call.apply(s, [this].concat(c)), Je(pt(o), "state", {
        showPreview: !!o.props.light
      }), Je(pt(o), "references", {
        wrapper: function(g) {
          o.wrapper = g;
        },
        player: function(g) {
          o.player = g;
        }
      }), Je(pt(o), "handleClickPreview", function(p) {
        o.setState({
          showPreview: !1
        }), o.props.onClickPreview(p);
      }), Je(pt(o), "showPreview", function() {
        o.setState({
          showPreview: !0
        });
      }), Je(pt(o), "getDuration", function() {
        return o.player ? o.player.getDuration() : null;
      }), Je(pt(o), "getCurrentTime", function() {
        return o.player ? o.player.getCurrentTime() : null;
      }), Je(pt(o), "getSecondsLoaded", function() {
        return o.player ? o.player.getSecondsLoaded() : null;
      }), Je(pt(o), "getInternalPlayer", function() {
        var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "player";
        return o.player ? o.player.getInternalPlayer(p) : null;
      }), Je(pt(o), "seekTo", function(p, g, m) {
        if (!o.player)
          return null;
        o.player.seekTo(p, g, m);
      }), Je(pt(o), "handleReady", function() {
        o.props.onReady(pt(o));
      }), Je(pt(o), "getActivePlayer", (0, Cl.default)(function(p) {
        for (var g = 0, m = [].concat(ka, Dl(e)); g < m.length; g++) {
          var d = m[g];
          if (d.canPlay(p))
            return d;
        }
        return r || null;
      })), Je(pt(o), "getConfig", (0, Cl.default)(function(p, g) {
        var m = o.props.config;
        return JW.default.all([Ga.defaultProps.config, Ga.defaultProps.config[g] || {}, m, m[g] || {}]);
      })), Je(pt(o), "getAttributes", (0, Cl.default)(function(p) {
        return (0, QW.omit)(o.props, hH);
      })), Je(pt(o), "renderActivePlayer", function(p) {
        if (!p)
          return null;
        var g = o.getActivePlayer(p);
        if (!g)
          return null;
        var m = o.getConfig(p, g.key);
        return /* @__PURE__ */ rn.default.createElement(eH.default, Ms({}, o.props, {
          key: g.key,
          ref: o.references.player,
          config: m,
          activePlayer: g.lazyPlayer || g,
          onReady: o.handleReady
        }));
      }), o;
    }
    return sH(l, [{
      key: "shouldComponentUpdate",
      value: function(u, c) {
        return !(0, zg.default)(this.props, u) || !(0, zg.default)(this.state, c);
      }
    }, {
      key: "componentDidUpdate",
      value: function(u) {
        var c = this.props.light;
        !u.light && c && this.setState({
          showPreview: !0
        }), u.light && !c && this.setState({
          showPreview: !1
        });
      }
    }, {
      key: "renderPreview",
      value: function(u) {
        if (!u)
          return null;
        var c = this.props, f = c.light, p = c.playIcon, g = c.previewTabIndex, m = c.oEmbedUrl;
        return /* @__PURE__ */ rn.default.createElement(fH, {
          url: u,
          light: f,
          playIcon: p,
          previewTabIndex: g,
          oEmbedUrl: m,
          onClick: this.handleClickPreview
        });
      }
    }, {
      key: "render",
      value: function() {
        var u = this.props, c = u.url, f = u.style, p = u.width, g = u.height, m = u.fallback, d = u.wrapper, w = this.state.showPreview, b = this.getAttributes(c), O = typeof d == "string" ? this.references.wrapper : void 0;
        return /* @__PURE__ */ rn.default.createElement(d, Ms({
          ref: O,
          style: Hg(Hg({}, f), {}, {
            width: p,
            height: g
          })
        }, b), /* @__PURE__ */ rn.default.createElement(gH, {
          fallback: m
        }, w ? this.renderPreview(c) : this.renderActivePlayer(c)));
      }
    }]), l;
  }(rn.Component), Je(n, "displayName", "ReactPlayer"), Je(n, "propTypes", Ga.propTypes), Je(n, "defaultProps", Ga.defaultProps), Je(n, "addCustomPlayer", function(i) {
    ka.push(i);
  }), Je(n, "removeCustomPlayers", function() {
    ka.length = 0;
  }), Je(n, "canPlay", function(i) {
    for (var s = 0, l = [].concat(ka, Dl(e)); s < l.length; s++) {
      var o = l[s];
      if (o.canPlay(i))
        return !0;
    }
    return !1;
  }), Je(n, "canEnablePIP", function(i) {
    for (var s = 0, l = [].concat(ka, Dl(e)); s < l.length; s++) {
      var o = l[s];
      if (o.canEnablePIP && o.canEnablePIP(i))
        return !0;
    }
    return !1;
  }), a;
};
go.createReactPlayer = vH;
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = n(G0), r = go;
  function n(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var a = e.default[e.default.length - 1], i = (0, r.createReactPlayer)(e.default, a);
  t.default = i;
})(q0);
const vy = /* @__PURE__ */ Ei(q0), mH = ({ videoId: t, platform: e }) => {
  if (e === "youtube") {
    const a = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    return t.match(a) ? t : `https://youtu.be/${t}`;
  }
  const r = /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/i;
  return t.match(r) ? t : `https://vimeo.com/${t}`;
}, yH = "_settingsWrapper_u7y81_1", bH = "_modal_u7y81_5", wH = "_modalHeader_u7y81_16", xH = "_closeIcon_u7y81_21", EH = "_modalBody_u7y81_25", CH = "_uploadCoverImage_u7y81_31", ts = {
  settingsWrapper: yH,
  modal: bH,
  modalHeader: wH,
  closeIcon: xH,
  modalBody: EH,
  uploadCoverImage: CH
}, my = (t) => /* @__PURE__ */ we.createElement("svg", { width: 200, height: 200, viewBox: "0 0 200 200", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ we.createElement("path", { d: "M90.845 69.2398C84.1799 65.5484 76 70.3687 76 77.9877V122.013C76 129.632 84.18 134.452 90.845 130.76L136.907 105.249C138.816 104.192 140 102.182 140 100C140 97.8184 138.816 95.8085 136.907 94.7514L90.845 69.2398ZM100 20C55.8172 20 20 55.8172 20 100C20 144.183 55.8172 180 100 180C144.183 180 180 144.183 180 100C180 55.8172 144.183 20 100 20ZM32 100C32 62.4446 62.4446 32 100 32C137.555 32 168 62.4446 168 100C168 137.555 137.555 168 100 168C62.4446 168 32 137.555 32 100Z", fill: "#E7EAEE" })), DH = ({ isOpen: t, onClose: e, url: r, onCloseComplete: n }) => /* @__PURE__ */ x.jsx(
  Vm,
  {
    className: ts.modal,
    size: "m",
    "data-testid": "video-modal",
    open: t,
    onWppModalClose: e,
    onWppModalCloseComplete: n,
    children: /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx("div", { slot: "header", className: ts.modalHeader, children: /* @__PURE__ */ x.jsx(ov, { color: "red", onClick: e, className: ts.closeIcon }) }),
      /* @__PURE__ */ x.jsx("div", { className: ts.modalBody, slot: "body", children: /* @__PURE__ */ x.jsx(vy, { width: "100%", height: "100%", playIcon: /* @__PURE__ */ x.jsx(my, {}), playing: !0, controls: !0, url: r }) })
    ] })
  }
), SH = () => {
  const { loc: t } = se(), {
    actions: { setProp: e },
    videoId: r,
    platform: n
  } = me((a) => ({
    videoId: a.data.props.videoId,
    platform: a.data.props.platform
  }));
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(_e, { type: "xl-heading", children: t("videoSettings") }),
    /* @__PURE__ */ x.jsxs(at, { children: [
      /* @__PURE__ */ x.jsxs(
        mv,
        {
          label: t("platform"),
          value: n,
          onChange: (a) => {
            e((i) => {
              i.platform = a, i.videoId = "", i.popover = !1;
            });
          },
          "data-testid": "platform-select",
          children: [
            /* @__PURE__ */ x.jsx(Qt, { value: "youtube", label: t("youtube") }),
            /* @__PURE__ */ x.jsx(Qt, { value: "vimeo", label: t("vimeo") })
          ]
        }
      ),
      /* @__PURE__ */ x.jsx(
        Rm,
        {
          "data-testid": "url-or-id-text",
          label: t("videoId"),
          type: "text",
          value: r,
          onChange: (a) => {
            e((i) => {
              i.videoId = a, i.popover = !1;
            }, 200);
          }
        }
      ),
      /* @__PURE__ */ x.jsx(Re, { type: "checkbox", label: t("popover"), propKey: "popover" })
    ] }),
    /* @__PURE__ */ x.jsx(We, {}),
    /* @__PURE__ */ x.jsx(Ec, { withSummary: !0 }),
    /* @__PURE__ */ x.jsx(We, {}),
    /* @__PURE__ */ x.jsx(at, { title: t("videoCover"), children: /* @__PURE__ */ x.jsx(Cc, { selector: (a) => a.cover }) }),
    /* @__PURE__ */ x.jsx(We, {}),
    /* @__PURE__ */ x.jsx(qt, {}),
    /* @__PURE__ */ x.jsx(We, {}),
    /* @__PURE__ */ x.jsx(Xr, {})
  ] });
}, lf = ({ margin: t, padding: e, cover: r, ...n }) => {
  var B, T;
  const {
    connectors: { connect: a },
    setProp: i
  } = me(), s = de(null), [l, o] = $e(!1), { enabled: u } = Le((A) => ({
    enabled: A.options.enabled
  })), {
    internals: { readOnly: c }
  } = se(), f = () => {
    var A;
    return (A = s.current) == null ? void 0 : A.showPreview();
  }, p = mH({
    videoId: n.videoId,
    platform: n.platform
  }), { imageUrl: g } = uo((B = r == null ? void 0 : r.imageMetaData) == null ? void 0 : B.assetId), m = (T = r == null ? void 0 : r.imageMetaData) == null ? void 0 : T.assetId, { isOpen: d, onOpen: w, onClose: b } = xc(), O = n.videoId && (!m || g) ? /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(
      vy,
      {
        ref: s,
        playIcon: /* @__PURE__ */ x.jsx(my, { style: { maxHeight: `calc(${n.height} / 2)` } }),
        playing: l,
        controls: !0,
        onPlay: () => {
          n.popover && w(), n.popover && o(!1);
        },
        onClickPreview: () => {
          c || (n.popover && w(), !n.popover && o(!0));
        },
        style: {
          pointerEvents: u || c ? "none" : "auto"
        },
        width: n.width,
        height: n.height,
        light: g || !0,
        url: p
      }
    ),
    n.popover && d && /* @__PURE__ */ x.jsx(
      DH,
      {
        url: p,
        isOpen: d,
        onClose: () => {
          b(), f();
        }
      }
    )
  ] }) : /* @__PURE__ */ x.jsx(xi, { width: "100%", height: "100%" }), S = Ze(gr(t));
  return u ? /* @__PURE__ */ x.jsx(
    Ri,
    {
      resizeRatio: 16 / 9,
      ref: (A) => {
        A != null && A.resizable && a(A == null ? void 0 : A.resizable);
      },
      onResize: ({ height: A, width: D }) => {
        i((h) => {
          h.width = D, h.height = A;
        }, 500);
      },
      width: n.width,
      height: n.height,
      style: {
        margin: S,
        padding: Ze(e)
      },
      children: O
    }
  ) : /* @__PURE__ */ x.jsx(
    "div",
    {
      style: {
        padding: Ze(e),
        margin: S,
        width: pr(n.width),
        height: pr(n.height)
      },
      children: O
    }
  );
};
lf.craft = {
  displayName: "video",
  props: {
    width: "640px",
    height: "360px",
    margin: [0, 0, dr, 0],
    padding: [0, 0, 0, 0],
    platform: "youtube",
    popover: !1,
    videoId: "",
    cover: {}
  },
  related: {
    toolbar: SH
  },
  custom: {
    toolbox: {
      icon: /* @__PURE__ */ x.jsx(Eb, { width: 30, color: "black" }),
      dataTestId: "video-thumbnail"
    }
  }
};
const OH = "_lockItem_ikicb_1", PH = "_lockItemLocked_ikicb_6", Vg = {
  lockItem: OH,
  lockItemLocked: PH
}, yy = ({ selector: t }) => {
  const { loc: e } = se(), {
    actions: { setProp: r },
    width: n,
    height: a,
    lockedRatio: i
  } = me((l) => {
    const o = t(l.data.props);
    return {
      width: o == null ? void 0 : o.width,
      height: o == null ? void 0 : o.height,
      lockedRatio: o == null ? void 0 : o.lockedRatio
    };
  }), s = (l, o) => {
    r((u) => {
      const c = t(u);
      c && (c[l] = o);
    }, 200);
  };
  return /* @__PURE__ */ x.jsxs(fe, { gap: 0, align: "end", children: [
    /* @__PURE__ */ x.jsx(
      fi,
      {
        value: n,
        label: e("width"),
        onChange: (l) => {
          const o = (l || "").trim();
          o !== n && s("width", o);
        },
        dataTestId: "size-width"
      }
    ),
    /* @__PURE__ */ x.jsx(
      xu,
      {
        className: ke(Vg.lockItem, {
          [Vg.lockItemLocked]: i
        }),
        onClick: () => {
          r((l) => {
            const o = t(l);
            o && (o.lockedRatio = !i);
          });
        }
      }
    ),
    /* @__PURE__ */ x.jsx(
      fi,
      {
        value: a,
        label: e("height"),
        onChange: (l) => {
          const o = (l || "").trim();
          o !== a && s("height", o);
        },
        dataTestId: "size-height"
      }
    )
  ] });
}, _H = () => {
  const { loc: t } = se();
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(at, { children: /* @__PURE__ */ x.jsx(yy, { selector: (e) => e.size }) }),
    /* @__PURE__ */ x.jsx(at, { children: /* @__PURE__ */ x.jsx(Re, { propKey: "content", type: "textarea", label: t("embedCode") }) })
  ] });
}, AH = "https://public-assets.os.wpp.com/iframe/embedded-code-renderer.html", uf = ({ content: t, size: e }) => {
  const {
    connectors: { connect: r },
    actions: { setProp: n }
  } = me((o) => ({ events: o })), a = de(null), { enabled: i } = Le((o) => ({
    enabled: o.options.enabled
  })), s = gt(() => ij(t || ""), [t]);
  xe(() => {
    var c, f;
    if (!t)
      return;
    const o = a.current;
    (f = (c = a == null ? void 0 : a.current) == null ? void 0 : c.contentWindow) == null || f.postMessage(t, "*");
    const u = () => {
      var p;
      (p = o.contentWindow) == null || p.postMessage(t, "*");
    };
    return o.addEventListener("load", u), () => {
      o.removeEventListener("load", u);
    };
  }, [t, i]);
  const l = t ? /* @__PURE__ */ x.jsx(
    "iframe",
    {
      ref: a,
      "data-testId": "embeded-code-widget",
      allow: "clipboard-write",
      src: AH,
      style: { width: "100%", height: "100%" }
    },
    s
  ) : /* @__PURE__ */ x.jsx(xi, { width: "100%", height: "100%" });
  return i ? /* @__PURE__ */ x.jsx(
    Ri,
    {
      ref: (o) => {
        o != null && o.resizable && r(o == null ? void 0 : o.resizable);
      },
      onResize: ({ height: o, width: u }) => {
        n((c) => {
          c.size.width = u, c.size.height = o;
        }, 500);
      },
      width: e == null ? void 0 : e.width,
      height: e == null ? void 0 : e.height,
      lockAspectRatio: e == null ? void 0 : e.lockedRatio,
      resizeRatio: e == null ? void 0 : e.ratio,
      children: l
    }
  ) : /* @__PURE__ */ x.jsx(
    "div",
    {
      style: {
        width: pr(e == null ? void 0 : e.width),
        height: pr(e == null ? void 0 : e.height)
      },
      children: l
    }
  );
};
uf.craft = {
  displayName: "embedCode",
  props: {
    content: "",
    size: {
      width: "260px",
      height: "200px",
      lockedRatio: !1
    }
  },
  related: {
    toolbar: _H
  },
  custom: {
    toolbox: { icon: /* @__PURE__ */ x.jsx(fv, { width: 30, color: "black" }), dataTestId: "embeded-thumbnail" }
  }
};
const TH = () => {
  const { loc: t } = se();
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(at, { children: /* @__PURE__ */ x.jsx(yy, { selector: (e) => e.size }) }),
    /* @__PURE__ */ x.jsx(at, { children: /* @__PURE__ */ x.jsx(Re, { propKey: "url", type: "text", label: t("linkUrl") }) })
  ] });
}, cf = ({ url: t, size: e }) => {
  const {
    connectors: { connect: r },
    actions: { setProp: n }
  } = me((s) => ({ events: s })), { enabled: a } = Le((s) => ({
    enabled: s.options.enabled
  })), i = t ? /* @__PURE__ */ x.jsx(
    "iframe",
    {
      "data-testId": "embeded-code-widget",
      allow: "clipboard-write",
      src: t,
      style: { width: "100%", height: "100%" }
    }
  ) : /* @__PURE__ */ x.jsx(xi, { width: "100%", height: "100%" });
  return a ? /* @__PURE__ */ x.jsx(
    Ri,
    {
      ref: (s) => {
        s != null && s.resizable && r(s == null ? void 0 : s.resizable);
      },
      onResize: ({ height: s, width: l }) => {
        n((o) => {
          o.size.width = l, o.size.height = s;
        }, 500);
      },
      width: e == null ? void 0 : e.width,
      height: e == null ? void 0 : e.height,
      lockAspectRatio: e == null ? void 0 : e.lockedRatio,
      resizeRatio: e == null ? void 0 : e.ratio,
      children: i
    }
  ) : /* @__PURE__ */ x.jsx(
    "div",
    {
      style: {
        width: pr(e == null ? void 0 : e.width),
        height: pr(e == null ? void 0 : e.height)
      },
      children: i
    }
  );
};
cf.craft = {
  displayName: "iframe",
  props: {
    content: "",
    size: {
      width: "260px",
      height: "200px",
      lockedRatio: !1
    }
  },
  related: {
    toolbar: TH
  },
  custom: {
    toolbox: { icon: /* @__PURE__ */ x.jsx(fv, { width: 30, color: "black" }), dataTestId: "iframe-thumbnail" }
  }
};
function qg(t) {
  return t !== null && typeof t == "object" && "constructor" in t && t.constructor === Object;
}
function ff(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = {}), Object.keys(e).forEach((r) => {
    typeof t[r] > "u" ? t[r] = e[r] : qg(e[r]) && qg(t[r]) && Object.keys(e[r]).length > 0 && ff(t[r], e[r]);
  });
}
const by = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function Et() {
  const t = typeof document < "u" ? document : {};
  return ff(t, by), t;
}
const BH = {
  document: by,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(t) {
    return typeof setTimeout > "u" ? (t(), null) : setTimeout(t, 0);
  },
  cancelAnimationFrame(t) {
    typeof setTimeout > "u" || clearTimeout(t);
  }
};
function Qe() {
  const t = typeof window < "u" ? window : {};
  return ff(t, BH), t;
}
function Fr(t) {
  return t === void 0 && (t = ""), t.trim().split(" ").filter((e) => !!e.trim());
}
function RH(t) {
  const e = t;
  Object.keys(e).forEach((r) => {
    try {
      e[r] = null;
    } catch {
    }
    try {
      delete e[r];
    } catch {
    }
  });
}
function vn(t, e) {
  return e === void 0 && (e = 0), setTimeout(t, e);
}
function zt() {
  return Date.now();
}
function $H(t) {
  const e = Qe();
  let r;
  return e.getComputedStyle && (r = e.getComputedStyle(t, null)), !r && t.currentStyle && (r = t.currentStyle), r || (r = t.style), r;
}
function gu(t, e) {
  e === void 0 && (e = "x");
  const r = Qe();
  let n, a, i;
  const s = $H(t);
  return r.WebKitCSSMatrix ? (a = s.transform || s.webkitTransform, a.split(",").length > 6 && (a = a.split(", ").map((l) => l.replace(",", ".")).join(", ")), i = new r.WebKitCSSMatrix(a === "none" ? "" : a)) : (i = s.MozTransform || s.OTransform || s.MsTransform || s.msTransform || s.transform || s.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), n = i.toString().split(",")), e === "x" && (r.WebKitCSSMatrix ? a = i.m41 : n.length === 16 ? a = parseFloat(n[12]) : a = parseFloat(n[4])), e === "y" && (r.WebKitCSSMatrix ? a = i.m42 : n.length === 16 ? a = parseFloat(n[13]) : a = parseFloat(n[5])), a || 0;
}
function Ya(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object";
}
function MH(t) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? t instanceof HTMLElement : t && (t.nodeType === 1 || t.nodeType === 11);
}
function Rt() {
  const t = Object(arguments.length <= 0 ? void 0 : arguments[0]), e = ["__proto__", "constructor", "prototype"];
  for (let r = 1; r < arguments.length; r += 1) {
    const n = r < 0 || arguments.length <= r ? void 0 : arguments[r];
    if (n != null && !MH(n)) {
      const a = Object.keys(Object(n)).filter((i) => e.indexOf(i) < 0);
      for (let i = 0, s = a.length; i < s; i += 1) {
        const l = a[i], o = Object.getOwnPropertyDescriptor(n, l);
        o !== void 0 && o.enumerable && (Ya(t[l]) && Ya(n[l]) ? n[l].__swiper__ ? t[l] = n[l] : Rt(t[l], n[l]) : !Ya(t[l]) && Ya(n[l]) ? (t[l] = {}, n[l].__swiper__ ? t[l] = n[l] : Rt(t[l], n[l])) : t[l] = n[l]);
      }
    }
  }
  return t;
}
function Ka(t, e, r) {
  t.style.setProperty(e, r);
}
function wy(t) {
  let {
    swiper: e,
    targetPosition: r,
    side: n
  } = t;
  const a = Qe(), i = -e.translate;
  let s = null, l;
  const o = e.params.speed;
  e.wrapperEl.style.scrollSnapType = "none", a.cancelAnimationFrame(e.cssModeFrameID);
  const u = r > i ? "next" : "prev", c = (p, g) => u === "next" && p >= g || u === "prev" && p <= g, f = () => {
    l = (/* @__PURE__ */ new Date()).getTime(), s === null && (s = l);
    const p = Math.max(Math.min((l - s) / o, 1), 0), g = 0.5 - Math.cos(p * Math.PI) / 2;
    let m = i + g * (r - i);
    if (c(m, r) && (m = r), e.wrapperEl.scrollTo({
      [n]: m
    }), c(m, r)) {
      e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
          [n]: m
        });
      }), a.cancelAnimationFrame(e.cssModeFrameID);
      return;
    }
    e.cssModeFrameID = a.requestAnimationFrame(f);
  };
  f();
}
function Sn(t) {
  return t.querySelector(".swiper-slide-transform") || t.shadowRoot && t.shadowRoot.querySelector(".swiper-slide-transform") || t;
}
function dt(t, e) {
  return e === void 0 && (e = ""), [...t.children].filter((r) => r.matches(e));
}
function Is(t) {
  try {
    console.warn(t);
    return;
  } catch {
  }
}
function $t(t, e) {
  e === void 0 && (e = []);
  const r = document.createElement(t);
  return r.classList.add(...Array.isArray(e) ? e : Fr(e)), r;
}
function js(t) {
  const e = Qe(), r = Et(), n = t.getBoundingClientRect(), a = r.body, i = t.clientTop || a.clientTop || 0, s = t.clientLeft || a.clientLeft || 0, l = t === e ? e.scrollY : t.scrollTop, o = t === e ? e.scrollX : t.scrollLeft;
  return {
    top: n.top + l - i,
    left: n.left + o - s
  };
}
function FH(t, e) {
  const r = [];
  for (; t.previousElementSibling; ) {
    const n = t.previousElementSibling;
    e ? n.matches(e) && r.push(n) : r.push(n), t = n;
  }
  return r;
}
function IH(t, e) {
  const r = [];
  for (; t.nextElementSibling; ) {
    const n = t.nextElementSibling;
    e ? n.matches(e) && r.push(n) : r.push(n), t = n;
  }
  return r;
}
function zr(t, e) {
  return Qe().getComputedStyle(t, null).getPropertyValue(e);
}
function bi(t) {
  let e = t, r;
  if (e) {
    for (r = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (r += 1);
    return r;
  }
}
function un(t, e) {
  const r = [];
  let n = t.parentElement;
  for (; n; )
    e ? n.matches(e) && r.push(n) : r.push(n), n = n.parentElement;
  return r;
}
function ni(t, e) {
  function r(n) {
    n.target === t && (e.call(t, n), t.removeEventListener("transitionend", r));
  }
  e && t.addEventListener("transitionend", r);
}
function vu(t, e, r) {
  const n = Qe();
  return r ? t[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(n.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(n.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom")) : t.offsetWidth;
}
function Oe(t) {
  return (Array.isArray(t) ? t : [t]).filter((e) => !!e);
}
let Sl;
function jH() {
  const t = Qe(), e = Et();
  return {
    smoothScroll: e.documentElement && e.documentElement.style && "scrollBehavior" in e.documentElement.style,
    touch: !!("ontouchstart" in t || t.DocumentTouch && e instanceof t.DocumentTouch)
  };
}
function xy() {
  return Sl || (Sl = jH()), Sl;
}
let Ol;
function LH(t) {
  let {
    userAgent: e
  } = t === void 0 ? {} : t;
  const r = xy(), n = Qe(), a = n.navigator.platform, i = e || n.navigator.userAgent, s = {
    ios: !1,
    android: !1
  }, l = n.screen.width, o = n.screen.height, u = i.match(/(Android);?[\s\/]+([\d.]+)?/);
  let c = i.match(/(iPad).*OS\s([\d_]+)/);
  const f = i.match(/(iPod)(.*OS\s([\d_]+))?/), p = !c && i.match(/(iPhone\sOS|iOS)\s([\d_]+)/), g = a === "Win32";
  let m = a === "MacIntel";
  const d = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !c && m && r.touch && d.indexOf(`${l}x${o}`) >= 0 && (c = i.match(/(Version)\/([\d.]+)/), c || (c = [0, 1, "13_0_0"]), m = !1), u && !g && (s.os = "android", s.android = !0), (c || p || f) && (s.os = "ios", s.ios = !0), s;
}
function Ey(t) {
  return t === void 0 && (t = {}), Ol || (Ol = LH(t)), Ol;
}
let Pl;
function kH() {
  const t = Qe(), e = Ey();
  let r = !1;
  function n() {
    const l = t.navigator.userAgent.toLowerCase();
    return l.indexOf("safari") >= 0 && l.indexOf("chrome") < 0 && l.indexOf("android") < 0;
  }
  if (n()) {
    const l = String(t.navigator.userAgent);
    if (l.includes("Version/")) {
      const [o, u] = l.split("Version/")[1].split(" ")[0].split(".").map((c) => Number(c));
      r = o < 16 || o === 16 && u < 2;
    }
  }
  const a = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent), i = n(), s = i || a && e.ios;
  return {
    isSafari: r || i,
    needPerspectiveFix: r,
    need3dFix: s,
    isWebView: a
  };
}
function NH() {
  return Pl || (Pl = kH()), Pl;
}
function zH(t) {
  let {
    swiper: e,
    on: r,
    emit: n
  } = t;
  const a = Qe();
  let i = null, s = null;
  const l = () => {
    !e || e.destroyed || !e.initialized || (n("beforeResize"), n("resize"));
  }, o = () => {
    !e || e.destroyed || !e.initialized || (i = new ResizeObserver((f) => {
      s = a.requestAnimationFrame(() => {
        const {
          width: p,
          height: g
        } = e;
        let m = p, d = g;
        f.forEach((w) => {
          let {
            contentBoxSize: b,
            contentRect: O,
            target: S
          } = w;
          S && S !== e.el || (m = O ? O.width : (b[0] || b).inlineSize, d = O ? O.height : (b[0] || b).blockSize);
        }), (m !== p || d !== g) && l();
      });
    }), i.observe(e.el));
  }, u = () => {
    s && a.cancelAnimationFrame(s), i && i.unobserve && e.el && (i.unobserve(e.el), i = null);
  }, c = () => {
    !e || e.destroyed || !e.initialized || n("orientationchange");
  };
  r("init", () => {
    if (e.params.resizeObserver && typeof a.ResizeObserver < "u") {
      o();
      return;
    }
    a.addEventListener("resize", l), a.addEventListener("orientationchange", c);
  }), r("destroy", () => {
    u(), a.removeEventListener("resize", l), a.removeEventListener("orientationchange", c);
  });
}
function WH(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n,
    emit: a
  } = t;
  const i = [], s = Qe(), l = function(c, f) {
    f === void 0 && (f = {});
    const p = s.MutationObserver || s.WebkitMutationObserver, g = new p((m) => {
      if (e.__preventObserver__)
        return;
      if (m.length === 1) {
        a("observerUpdate", m[0]);
        return;
      }
      const d = function() {
        a("observerUpdate", m[0]);
      };
      s.requestAnimationFrame ? s.requestAnimationFrame(d) : s.setTimeout(d, 0);
    });
    g.observe(c, {
      attributes: typeof f.attributes > "u" ? !0 : f.attributes,
      childList: typeof f.childList > "u" ? !0 : f.childList,
      characterData: typeof f.characterData > "u" ? !0 : f.characterData
    }), i.push(g);
  }, o = () => {
    if (e.params.observer) {
      if (e.params.observeParents) {
        const c = un(e.hostEl);
        for (let f = 0; f < c.length; f += 1)
          l(c[f]);
      }
      l(e.hostEl, {
        childList: e.params.observeSlideChildren
      }), l(e.wrapperEl, {
        attributes: !1
      });
    }
  }, u = () => {
    i.forEach((c) => {
      c.disconnect();
    }), i.splice(0, i.length);
  };
  r({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), n("init", o), n("destroy", u);
}
var HH = {
  on(t, e, r) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function")
      return n;
    const a = r ? "unshift" : "push";
    return t.split(" ").forEach((i) => {
      n.eventsListeners[i] || (n.eventsListeners[i] = []), n.eventsListeners[i][a](e);
    }), n;
  },
  once(t, e, r) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function")
      return n;
    function a() {
      n.off(t, a), a.__emitterProxy && delete a.__emitterProxy;
      for (var i = arguments.length, s = new Array(i), l = 0; l < i; l++)
        s[l] = arguments[l];
      e.apply(n, s);
    }
    return a.__emitterProxy = e, n.on(t, a, r);
  },
  onAny(t, e) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || typeof t != "function")
      return r;
    const n = e ? "unshift" : "push";
    return r.eventsAnyListeners.indexOf(t) < 0 && r.eventsAnyListeners[n](t), r;
  },
  offAny(t) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners)
      return e;
    const r = e.eventsAnyListeners.indexOf(t);
    return r >= 0 && e.eventsAnyListeners.splice(r, 1), e;
  },
  off(t, e) {
    const r = this;
    return !r.eventsListeners || r.destroyed || !r.eventsListeners || t.split(" ").forEach((n) => {
      typeof e > "u" ? r.eventsListeners[n] = [] : r.eventsListeners[n] && r.eventsListeners[n].forEach((a, i) => {
        (a === e || a.__emitterProxy && a.__emitterProxy === e) && r.eventsListeners[n].splice(i, 1);
      });
    }), r;
  },
  emit() {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsListeners)
      return t;
    let e, r, n;
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return typeof i[0] == "string" || Array.isArray(i[0]) ? (e = i[0], r = i.slice(1, i.length), n = t) : (e = i[0].events, r = i[0].data, n = i[0].context || t), r.unshift(n), (Array.isArray(e) ? e : e.split(" ")).forEach((o) => {
      t.eventsAnyListeners && t.eventsAnyListeners.length && t.eventsAnyListeners.forEach((u) => {
        u.apply(n, [o, ...r]);
      }), t.eventsListeners && t.eventsListeners[o] && t.eventsListeners[o].forEach((u) => {
        u.apply(n, r);
      });
    }), t;
  }
};
function UH() {
  const t = this;
  let e, r;
  const n = t.el;
  typeof t.params.width < "u" && t.params.width !== null ? e = t.params.width : e = n.clientWidth, typeof t.params.height < "u" && t.params.height !== null ? r = t.params.height : r = n.clientHeight, !(e === 0 && t.isHorizontal() || r === 0 && t.isVertical()) && (e = e - parseInt(zr(n, "padding-left") || 0, 10) - parseInt(zr(n, "padding-right") || 0, 10), r = r - parseInt(zr(n, "padding-top") || 0, 10) - parseInt(zr(n, "padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(r) && (r = 0), Object.assign(t, {
    width: e,
    height: r,
    size: t.isHorizontal() ? e : r
  }));
}
function VH() {
  const t = this;
  function e(v, E) {
    return parseFloat(v.getPropertyValue(t.getDirectionLabel(E)) || 0);
  }
  const r = t.params, {
    wrapperEl: n,
    slidesEl: a,
    size: i,
    rtlTranslate: s,
    wrongRTL: l
  } = t, o = t.virtual && r.virtual.enabled, u = o ? t.virtual.slides.length : t.slides.length, c = dt(a, `.${t.params.slideClass}, swiper-slide`), f = o ? t.virtual.slides.length : c.length;
  let p = [];
  const g = [], m = [];
  let d = r.slidesOffsetBefore;
  typeof d == "function" && (d = r.slidesOffsetBefore.call(t));
  let w = r.slidesOffsetAfter;
  typeof w == "function" && (w = r.slidesOffsetAfter.call(t));
  const b = t.snapGrid.length, O = t.slidesGrid.length;
  let S = r.spaceBetween, B = -d, T = 0, A = 0;
  if (typeof i > "u")
    return;
  typeof S == "string" && S.indexOf("%") >= 0 ? S = parseFloat(S.replace("%", "")) / 100 * i : typeof S == "string" && (S = parseFloat(S)), t.virtualSize = -S, c.forEach((v) => {
    s ? v.style.marginLeft = "" : v.style.marginRight = "", v.style.marginBottom = "", v.style.marginTop = "";
  }), r.centeredSlides && r.cssMode && (Ka(n, "--swiper-centered-offset-before", ""), Ka(n, "--swiper-centered-offset-after", ""));
  const D = r.grid && r.grid.rows > 1 && t.grid;
  D ? t.grid.initSlides(c) : t.grid && t.grid.unsetSlides();
  let h;
  const y = r.slidesPerView === "auto" && r.breakpoints && Object.keys(r.breakpoints).filter((v) => typeof r.breakpoints[v].slidesPerView < "u").length > 0;
  for (let v = 0; v < f; v += 1) {
    h = 0;
    let E;
    if (c[v] && (E = c[v]), D && t.grid.updateSlide(v, E, c), !(c[v] && zr(E, "display") === "none")) {
      if (r.slidesPerView === "auto") {
        y && (c[v].style[t.getDirectionLabel("width")] = "");
        const _ = getComputedStyle(E), C = E.style.transform, P = E.style.webkitTransform;
        if (C && (E.style.transform = "none"), P && (E.style.webkitTransform = "none"), r.roundLengths)
          h = t.isHorizontal() ? vu(E, "width", !0) : vu(E, "height", !0);
        else {
          const $ = e(_, "width"), W = e(_, "padding-left"), j = e(_, "padding-right"), I = e(_, "margin-left"), F = e(_, "margin-right"), k = _.getPropertyValue("box-sizing");
          if (k && k === "border-box")
            h = $ + I + F;
          else {
            const {
              clientWidth: N,
              offsetWidth: U
            } = E;
            h = $ + W + j + I + F + (U - N);
          }
        }
        C && (E.style.transform = C), P && (E.style.webkitTransform = P), r.roundLengths && (h = Math.floor(h));
      } else
        h = (i - (r.slidesPerView - 1) * S) / r.slidesPerView, r.roundLengths && (h = Math.floor(h)), c[v] && (c[v].style[t.getDirectionLabel("width")] = `${h}px`);
      c[v] && (c[v].swiperSlideSize = h), m.push(h), r.centeredSlides ? (B = B + h / 2 + T / 2 + S, T === 0 && v !== 0 && (B = B - i / 2 - S), v === 0 && (B = B - i / 2 - S), Math.abs(B) < 1 / 1e3 && (B = 0), r.roundLengths && (B = Math.floor(B)), A % r.slidesPerGroup === 0 && p.push(B), g.push(B)) : (r.roundLengths && (B = Math.floor(B)), (A - Math.min(t.params.slidesPerGroupSkip, A)) % t.params.slidesPerGroup === 0 && p.push(B), g.push(B), B = B + h + S), t.virtualSize += h + S, T = h, A += 1;
    }
  }
  if (t.virtualSize = Math.max(t.virtualSize, i) + w, s && l && (r.effect === "slide" || r.effect === "coverflow") && (n.style.width = `${t.virtualSize + S}px`), r.setWrapperSize && (n.style[t.getDirectionLabel("width")] = `${t.virtualSize + S}px`), D && t.grid.updateWrapperSize(h, p), !r.centeredSlides) {
    const v = [];
    for (let E = 0; E < p.length; E += 1) {
      let _ = p[E];
      r.roundLengths && (_ = Math.floor(_)), p[E] <= t.virtualSize - i && v.push(_);
    }
    p = v, Math.floor(t.virtualSize - i) - Math.floor(p[p.length - 1]) > 1 && p.push(t.virtualSize - i);
  }
  if (o && r.loop) {
    const v = m[0] + S;
    if (r.slidesPerGroup > 1) {
      const E = Math.ceil((t.virtual.slidesBefore + t.virtual.slidesAfter) / r.slidesPerGroup), _ = v * r.slidesPerGroup;
      for (let C = 0; C < E; C += 1)
        p.push(p[p.length - 1] + _);
    }
    for (let E = 0; E < t.virtual.slidesBefore + t.virtual.slidesAfter; E += 1)
      r.slidesPerGroup === 1 && p.push(p[p.length - 1] + v), g.push(g[g.length - 1] + v), t.virtualSize += v;
  }
  if (p.length === 0 && (p = [0]), S !== 0) {
    const v = t.isHorizontal() && s ? "marginLeft" : t.getDirectionLabel("marginRight");
    c.filter((E, _) => !r.cssMode || r.loop ? !0 : _ !== c.length - 1).forEach((E) => {
      E.style[v] = `${S}px`;
    });
  }
  if (r.centeredSlides && r.centeredSlidesBounds) {
    let v = 0;
    m.forEach((_) => {
      v += _ + (S || 0);
    }), v -= S;
    const E = v - i;
    p = p.map((_) => _ <= 0 ? -d : _ > E ? E + w : _);
  }
  if (r.centerInsufficientSlides) {
    let v = 0;
    if (m.forEach((E) => {
      v += E + (S || 0);
    }), v -= S, v < i) {
      const E = (i - v) / 2;
      p.forEach((_, C) => {
        p[C] = _ - E;
      }), g.forEach((_, C) => {
        g[C] = _ + E;
      });
    }
  }
  if (Object.assign(t, {
    slides: c,
    snapGrid: p,
    slidesGrid: g,
    slidesSizesGrid: m
  }), r.centeredSlides && r.cssMode && !r.centeredSlidesBounds) {
    Ka(n, "--swiper-centered-offset-before", `${-p[0]}px`), Ka(n, "--swiper-centered-offset-after", `${t.size / 2 - m[m.length - 1] / 2}px`);
    const v = -t.snapGrid[0], E = -t.slidesGrid[0];
    t.snapGrid = t.snapGrid.map((_) => _ + v), t.slidesGrid = t.slidesGrid.map((_) => _ + E);
  }
  if (f !== u && t.emit("slidesLengthChange"), p.length !== b && (t.params.watchOverflow && t.checkOverflow(), t.emit("snapGridLengthChange")), g.length !== O && t.emit("slidesGridLengthChange"), r.watchSlidesProgress && t.updateSlidesOffset(), t.emit("slidesUpdated"), !o && !r.cssMode && (r.effect === "slide" || r.effect === "fade")) {
    const v = `${r.containerModifierClass}backface-hidden`, E = t.el.classList.contains(v);
    f <= r.maxBackfaceHiddenSlides ? E || t.el.classList.add(v) : E && t.el.classList.remove(v);
  }
}
function qH(t) {
  const e = this, r = [], n = e.virtual && e.params.virtual.enabled;
  let a = 0, i;
  typeof t == "number" ? e.setTransition(t) : t === !0 && e.setTransition(e.params.speed);
  const s = (l) => n ? e.slides[e.getSlideIndexByData(l)] : e.slides[l];
  if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1)
    if (e.params.centeredSlides)
      (e.visibleSlides || []).forEach((l) => {
        r.push(l);
      });
    else
      for (i = 0; i < Math.ceil(e.params.slidesPerView); i += 1) {
        const l = e.activeIndex + i;
        if (l > e.slides.length && !n)
          break;
        r.push(s(l));
      }
  else
    r.push(s(e.activeIndex));
  for (i = 0; i < r.length; i += 1)
    if (typeof r[i] < "u") {
      const l = r[i].offsetHeight;
      a = l > a ? l : a;
    }
  (a || a === 0) && (e.wrapperEl.style.height = `${a}px`);
}
function GH() {
  const t = this, e = t.slides, r = t.isElement ? t.isHorizontal() ? t.wrapperEl.offsetLeft : t.wrapperEl.offsetTop : 0;
  for (let n = 0; n < e.length; n += 1)
    e[n].swiperSlideOffset = (t.isHorizontal() ? e[n].offsetLeft : e[n].offsetTop) - r - t.cssOverflowAdjustment();
}
function YH(t) {
  t === void 0 && (t = this && this.translate || 0);
  const e = this, r = e.params, {
    slides: n,
    rtlTranslate: a,
    snapGrid: i
  } = e;
  if (n.length === 0)
    return;
  typeof n[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
  let s = -t;
  a && (s = t), n.forEach((o) => {
    o.classList.remove(r.slideVisibleClass, r.slideFullyVisibleClass);
  }), e.visibleSlidesIndexes = [], e.visibleSlides = [];
  let l = r.spaceBetween;
  typeof l == "string" && l.indexOf("%") >= 0 ? l = parseFloat(l.replace("%", "")) / 100 * e.size : typeof l == "string" && (l = parseFloat(l));
  for (let o = 0; o < n.length; o += 1) {
    const u = n[o];
    let c = u.swiperSlideOffset;
    r.cssMode && r.centeredSlides && (c -= n[0].swiperSlideOffset);
    const f = (s + (r.centeredSlides ? e.minTranslate() : 0) - c) / (u.swiperSlideSize + l), p = (s - i[0] + (r.centeredSlides ? e.minTranslate() : 0) - c) / (u.swiperSlideSize + l), g = -(s - c), m = g + e.slidesSizesGrid[o], d = g >= 0 && g <= e.size - e.slidesSizesGrid[o];
    (g >= 0 && g < e.size - 1 || m > 1 && m <= e.size || g <= 0 && m >= e.size) && (e.visibleSlides.push(u), e.visibleSlidesIndexes.push(o), n[o].classList.add(r.slideVisibleClass)), d && n[o].classList.add(r.slideFullyVisibleClass), u.progress = a ? -f : f, u.originalProgress = a ? -p : p;
  }
}
function KH(t) {
  const e = this;
  if (typeof t > "u") {
    const c = e.rtlTranslate ? -1 : 1;
    t = e && e.translate && e.translate * c || 0;
  }
  const r = e.params, n = e.maxTranslate() - e.minTranslate();
  let {
    progress: a,
    isBeginning: i,
    isEnd: s,
    progressLoop: l
  } = e;
  const o = i, u = s;
  if (n === 0)
    a = 0, i = !0, s = !0;
  else {
    a = (t - e.minTranslate()) / n;
    const c = Math.abs(t - e.minTranslate()) < 1, f = Math.abs(t - e.maxTranslate()) < 1;
    i = c || a <= 0, s = f || a >= 1, c && (a = 0), f && (a = 1);
  }
  if (r.loop) {
    const c = e.getSlideIndexByData(0), f = e.getSlideIndexByData(e.slides.length - 1), p = e.slidesGrid[c], g = e.slidesGrid[f], m = e.slidesGrid[e.slidesGrid.length - 1], d = Math.abs(t);
    d >= p ? l = (d - p) / m : l = (d + m - g) / m, l > 1 && (l -= 1);
  }
  Object.assign(e, {
    progress: a,
    progressLoop: l,
    isBeginning: i,
    isEnd: s
  }), (r.watchSlidesProgress || r.centeredSlides && r.autoHeight) && e.updateSlidesProgress(t), i && !o && e.emit("reachBeginning toEdge"), s && !u && e.emit("reachEnd toEdge"), (o && !i || u && !s) && e.emit("fromEdge"), e.emit("progress", a);
}
function XH() {
  const t = this, {
    slides: e,
    params: r,
    slidesEl: n,
    activeIndex: a
  } = t, i = t.virtual && r.virtual.enabled, s = t.grid && r.grid && r.grid.rows > 1, l = (f) => dt(n, `.${r.slideClass}${f}, swiper-slide${f}`)[0];
  e.forEach((f) => {
    f.classList.remove(r.slideActiveClass, r.slideNextClass, r.slidePrevClass);
  });
  let o, u, c;
  if (i)
    if (r.loop) {
      let f = a - t.virtual.slidesBefore;
      f < 0 && (f = t.virtual.slides.length + f), f >= t.virtual.slides.length && (f -= t.virtual.slides.length), o = l(`[data-swiper-slide-index="${f}"]`);
    } else
      o = l(`[data-swiper-slide-index="${a}"]`);
  else
    s ? (o = e.filter((f) => f.column === a)[0], c = e.filter((f) => f.column === a + 1)[0], u = e.filter((f) => f.column === a - 1)[0]) : o = e[a];
  o && (o.classList.add(r.slideActiveClass), s ? (c && c.classList.add(r.slideNextClass), u && u.classList.add(r.slidePrevClass)) : (c = IH(o, `.${r.slideClass}, swiper-slide`)[0], r.loop && !c && (c = e[0]), c && c.classList.add(r.slideNextClass), u = FH(o, `.${r.slideClass}, swiper-slide`)[0], r.loop && !u === 0 && (u = e[e.length - 1]), u && u.classList.add(r.slidePrevClass))), t.emitSlidesClasses();
}
const fs = (t, e) => {
  if (!t || t.destroyed || !t.params)
    return;
  const r = () => t.isElement ? "swiper-slide" : `.${t.params.slideClass}`, n = e.closest(r());
  if (n) {
    let a = n.querySelector(`.${t.params.lazyPreloaderClass}`);
    !a && t.isElement && (n.shadowRoot ? a = n.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
      n.shadowRoot && (a = n.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`), a && a.remove());
    })), a && a.remove();
  }
}, _l = (t, e) => {
  if (!t.slides[e])
    return;
  const r = t.slides[e].querySelector('[loading="lazy"]');
  r && r.removeAttribute("loading");
}, mu = (t) => {
  if (!t || t.destroyed || !t.params)
    return;
  let e = t.params.lazyPreloadPrevNext;
  const r = t.slides.length;
  if (!r || !e || e < 0)
    return;
  e = Math.min(e, r);
  const n = t.params.slidesPerView === "auto" ? t.slidesPerViewDynamic() : Math.ceil(t.params.slidesPerView), a = t.activeIndex;
  if (t.params.grid && t.params.grid.rows > 1) {
    const s = a, l = [s - e];
    l.push(...Array.from({
      length: e
    }).map((o, u) => s + n + u)), t.slides.forEach((o, u) => {
      l.includes(o.column) && _l(t, u);
    });
    return;
  }
  const i = a + n - 1;
  if (t.params.rewind || t.params.loop)
    for (let s = a - e; s <= i + e; s += 1) {
      const l = (s % r + r) % r;
      (l < a || l > i) && _l(t, l);
    }
  else
    for (let s = Math.max(a - e, 0); s <= Math.min(i + e, r - 1); s += 1)
      s !== a && (s > i || s < a) && _l(t, s);
};
function ZH(t) {
  const {
    slidesGrid: e,
    params: r
  } = t, n = t.rtlTranslate ? t.translate : -t.translate;
  let a;
  for (let i = 0; i < e.length; i += 1)
    typeof e[i + 1] < "u" ? n >= e[i] && n < e[i + 1] - (e[i + 1] - e[i]) / 2 ? a = i : n >= e[i] && n < e[i + 1] && (a = i + 1) : n >= e[i] && (a = i);
  return r.normalizeSlideIndex && (a < 0 || typeof a > "u") && (a = 0), a;
}
function JH(t) {
  const e = this, r = e.rtlTranslate ? e.translate : -e.translate, {
    snapGrid: n,
    params: a,
    activeIndex: i,
    realIndex: s,
    snapIndex: l
  } = e;
  let o = t, u;
  const c = (g) => {
    let m = g - e.virtual.slidesBefore;
    return m < 0 && (m = e.virtual.slides.length + m), m >= e.virtual.slides.length && (m -= e.virtual.slides.length), m;
  };
  if (typeof o > "u" && (o = ZH(e)), n.indexOf(r) >= 0)
    u = n.indexOf(r);
  else {
    const g = Math.min(a.slidesPerGroupSkip, o);
    u = g + Math.floor((o - g) / a.slidesPerGroup);
  }
  if (u >= n.length && (u = n.length - 1), o === i && !e.params.loop) {
    u !== l && (e.snapIndex = u, e.emit("snapIndexChange"));
    return;
  }
  if (o === i && e.params.loop && e.virtual && e.params.virtual.enabled) {
    e.realIndex = c(o);
    return;
  }
  const f = e.grid && a.grid && a.grid.rows > 1;
  let p;
  if (e.virtual && a.virtual.enabled && a.loop)
    p = c(o);
  else if (f) {
    const g = e.slides.filter((d) => d.column === o)[0];
    let m = parseInt(g.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(m) && (m = Math.max(e.slides.indexOf(g), 0)), p = Math.floor(m / a.grid.rows);
  } else if (e.slides[o]) {
    const g = e.slides[o].getAttribute("data-swiper-slide-index");
    g ? p = parseInt(g, 10) : p = o;
  } else
    p = o;
  Object.assign(e, {
    previousSnapIndex: l,
    snapIndex: u,
    previousRealIndex: s,
    realIndex: p,
    previousIndex: i,
    activeIndex: o
  }), e.initialized && mu(e), e.emit("activeIndexChange"), e.emit("snapIndexChange"), (e.initialized || e.params.runCallbacksOnInit) && (s !== p && e.emit("realIndexChange"), e.emit("slideChange"));
}
function QH(t, e) {
  const r = this, n = r.params;
  let a = t.closest(`.${n.slideClass}, swiper-slide`);
  !a && r.isElement && e && e.length > 1 && e.includes(t) && [...e.slice(e.indexOf(t) + 1, e.length)].forEach((l) => {
    !a && l.matches && l.matches(`.${n.slideClass}, swiper-slide`) && (a = l);
  });
  let i = !1, s;
  if (a) {
    for (let l = 0; l < r.slides.length; l += 1)
      if (r.slides[l] === a) {
        i = !0, s = l;
        break;
      }
  }
  if (a && i)
    r.clickedSlide = a, r.virtual && r.params.virtual.enabled ? r.clickedIndex = parseInt(a.getAttribute("data-swiper-slide-index"), 10) : r.clickedIndex = s;
  else {
    r.clickedSlide = void 0, r.clickedIndex = void 0;
    return;
  }
  n.slideToClickedSlide && r.clickedIndex !== void 0 && r.clickedIndex !== r.activeIndex && r.slideToClickedSlide();
}
var eU = {
  updateSize: UH,
  updateSlides: VH,
  updateAutoHeight: qH,
  updateSlidesOffset: GH,
  updateSlidesProgress: YH,
  updateProgress: KH,
  updateSlidesClasses: XH,
  updateActiveIndex: JH,
  updateClickedSlide: QH
};
function tU(t) {
  t === void 0 && (t = this.isHorizontal() ? "x" : "y");
  const e = this, {
    params: r,
    rtlTranslate: n,
    translate: a,
    wrapperEl: i
  } = e;
  if (r.virtualTranslate)
    return n ? -a : a;
  if (r.cssMode)
    return a;
  let s = gu(i, t);
  return s += e.cssOverflowAdjustment(), n && (s = -s), s || 0;
}
function rU(t, e) {
  const r = this, {
    rtlTranslate: n,
    params: a,
    wrapperEl: i,
    progress: s
  } = r;
  let l = 0, o = 0;
  const u = 0;
  r.isHorizontal() ? l = n ? -t : t : o = t, a.roundLengths && (l = Math.floor(l), o = Math.floor(o)), r.previousTranslate = r.translate, r.translate = r.isHorizontal() ? l : o, a.cssMode ? i[r.isHorizontal() ? "scrollLeft" : "scrollTop"] = r.isHorizontal() ? -l : -o : a.virtualTranslate || (r.isHorizontal() ? l -= r.cssOverflowAdjustment() : o -= r.cssOverflowAdjustment(), i.style.transform = `translate3d(${l}px, ${o}px, ${u}px)`);
  let c;
  const f = r.maxTranslate() - r.minTranslate();
  f === 0 ? c = 0 : c = (t - r.minTranslate()) / f, c !== s && r.updateProgress(t), r.emit("setTranslate", r.translate, e);
}
function nU() {
  return -this.snapGrid[0];
}
function aU() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function iU(t, e, r, n, a) {
  t === void 0 && (t = 0), e === void 0 && (e = this.params.speed), r === void 0 && (r = !0), n === void 0 && (n = !0);
  const i = this, {
    params: s,
    wrapperEl: l
  } = i;
  if (i.animating && s.preventInteractionOnTransition)
    return !1;
  const o = i.minTranslate(), u = i.maxTranslate();
  let c;
  if (n && t > o ? c = o : n && t < u ? c = u : c = t, i.updateProgress(c), s.cssMode) {
    const f = i.isHorizontal();
    if (e === 0)
      l[f ? "scrollLeft" : "scrollTop"] = -c;
    else {
      if (!i.support.smoothScroll)
        return wy({
          swiper: i,
          targetPosition: -c,
          side: f ? "left" : "top"
        }), !0;
      l.scrollTo({
        [f ? "left" : "top"]: -c,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return e === 0 ? (i.setTransition(0), i.setTranslate(c), r && (i.emit("beforeTransitionStart", e, a), i.emit("transitionEnd"))) : (i.setTransition(e), i.setTranslate(c), r && (i.emit("beforeTransitionStart", e, a), i.emit("transitionStart")), i.animating || (i.animating = !0, i.onTranslateToWrapperTransitionEnd || (i.onTranslateToWrapperTransitionEnd = function(p) {
    !i || i.destroyed || p.target === this && (i.wrapperEl.removeEventListener("transitionend", i.onTranslateToWrapperTransitionEnd), i.onTranslateToWrapperTransitionEnd = null, delete i.onTranslateToWrapperTransitionEnd, r && i.emit("transitionEnd"));
  }), i.wrapperEl.addEventListener("transitionend", i.onTranslateToWrapperTransitionEnd))), !0;
}
var sU = {
  getTranslate: tU,
  setTranslate: rU,
  minTranslate: nU,
  maxTranslate: aU,
  translateTo: iU
};
function oU(t, e) {
  const r = this;
  r.params.cssMode || (r.wrapperEl.style.transitionDuration = `${t}ms`, r.wrapperEl.style.transitionDelay = t === 0 ? "0ms" : ""), r.emit("setTransition", t, e);
}
function Cy(t) {
  let {
    swiper: e,
    runCallbacks: r,
    direction: n,
    step: a
  } = t;
  const {
    activeIndex: i,
    previousIndex: s
  } = e;
  let l = n;
  if (l || (i > s ? l = "next" : i < s ? l = "prev" : l = "reset"), e.emit(`transition${a}`), r && i !== s) {
    if (l === "reset") {
      e.emit(`slideResetTransition${a}`);
      return;
    }
    e.emit(`slideChangeTransition${a}`), l === "next" ? e.emit(`slideNextTransition${a}`) : e.emit(`slidePrevTransition${a}`);
  }
}
function lU(t, e) {
  t === void 0 && (t = !0);
  const r = this, {
    params: n
  } = r;
  n.cssMode || (n.autoHeight && r.updateAutoHeight(), Cy({
    swiper: r,
    runCallbacks: t,
    direction: e,
    step: "Start"
  }));
}
function uU(t, e) {
  t === void 0 && (t = !0);
  const r = this, {
    params: n
  } = r;
  r.animating = !1, !n.cssMode && (r.setTransition(0), Cy({
    swiper: r,
    runCallbacks: t,
    direction: e,
    step: "End"
  }));
}
var cU = {
  setTransition: oU,
  transitionStart: lU,
  transitionEnd: uU
};
function fU(t, e, r, n, a) {
  t === void 0 && (t = 0), e === void 0 && (e = this.params.speed), r === void 0 && (r = !0), typeof t == "string" && (t = parseInt(t, 10));
  const i = this;
  let s = t;
  s < 0 && (s = 0);
  const {
    params: l,
    snapGrid: o,
    slidesGrid: u,
    previousIndex: c,
    activeIndex: f,
    rtlTranslate: p,
    wrapperEl: g,
    enabled: m
  } = i;
  if (i.animating && l.preventInteractionOnTransition || !m && !n && !a || i.destroyed)
    return !1;
  const d = Math.min(i.params.slidesPerGroupSkip, s);
  let w = d + Math.floor((s - d) / i.params.slidesPerGroup);
  w >= o.length && (w = o.length - 1);
  const b = -o[w];
  if (l.normalizeSlideIndex)
    for (let S = 0; S < u.length; S += 1) {
      const B = -Math.floor(b * 100), T = Math.floor(u[S] * 100), A = Math.floor(u[S + 1] * 100);
      typeof u[S + 1] < "u" ? B >= T && B < A - (A - T) / 2 ? s = S : B >= T && B < A && (s = S + 1) : B >= T && (s = S);
    }
  if (i.initialized && s !== f && (!i.allowSlideNext && (p ? b > i.translate && b > i.minTranslate() : b < i.translate && b < i.minTranslate()) || !i.allowSlidePrev && b > i.translate && b > i.maxTranslate() && (f || 0) !== s))
    return !1;
  s !== (c || 0) && r && i.emit("beforeSlideChangeStart"), i.updateProgress(b);
  let O;
  if (s > f ? O = "next" : s < f ? O = "prev" : O = "reset", p && -b === i.translate || !p && b === i.translate)
    return i.updateActiveIndex(s), l.autoHeight && i.updateAutoHeight(), i.updateSlidesClasses(), l.effect !== "slide" && i.setTranslate(b), O !== "reset" && (i.transitionStart(r, O), i.transitionEnd(r, O)), !1;
  if (l.cssMode) {
    const S = i.isHorizontal(), B = p ? b : -b;
    if (e === 0) {
      const T = i.virtual && i.params.virtual.enabled;
      T && (i.wrapperEl.style.scrollSnapType = "none", i._immediateVirtual = !0), T && !i._cssModeVirtualInitialSet && i.params.initialSlide > 0 ? (i._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        g[S ? "scrollLeft" : "scrollTop"] = B;
      })) : g[S ? "scrollLeft" : "scrollTop"] = B, T && requestAnimationFrame(() => {
        i.wrapperEl.style.scrollSnapType = "", i._immediateVirtual = !1;
      });
    } else {
      if (!i.support.smoothScroll)
        return wy({
          swiper: i,
          targetPosition: B,
          side: S ? "left" : "top"
        }), !0;
      g.scrollTo({
        [S ? "left" : "top"]: B,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return i.setTransition(e), i.setTranslate(b), i.updateActiveIndex(s), i.updateSlidesClasses(), i.emit("beforeTransitionStart", e, n), i.transitionStart(r, O), e === 0 ? i.transitionEnd(r, O) : i.animating || (i.animating = !0, i.onSlideToWrapperTransitionEnd || (i.onSlideToWrapperTransitionEnd = function(B) {
    !i || i.destroyed || B.target === this && (i.wrapperEl.removeEventListener("transitionend", i.onSlideToWrapperTransitionEnd), i.onSlideToWrapperTransitionEnd = null, delete i.onSlideToWrapperTransitionEnd, i.transitionEnd(r, O));
  }), i.wrapperEl.addEventListener("transitionend", i.onSlideToWrapperTransitionEnd)), !0;
}
function dU(t, e, r, n) {
  t === void 0 && (t = 0), e === void 0 && (e = this.params.speed), r === void 0 && (r = !0), typeof t == "string" && (t = parseInt(t, 10));
  const a = this;
  if (a.destroyed)
    return;
  const i = a.grid && a.params.grid && a.params.grid.rows > 1;
  let s = t;
  if (a.params.loop)
    if (a.virtual && a.params.virtual.enabled)
      s = s + a.virtual.slidesBefore;
    else {
      let l;
      if (i) {
        const p = s * a.params.grid.rows;
        l = a.slides.filter((g) => g.getAttribute("data-swiper-slide-index") * 1 === p)[0].column;
      } else
        l = a.getSlideIndexByData(s);
      const o = i ? Math.ceil(a.slides.length / a.params.grid.rows) : a.slides.length, {
        centeredSlides: u
      } = a.params;
      let c = a.params.slidesPerView;
      c === "auto" ? c = a.slidesPerViewDynamic() : (c = Math.ceil(parseFloat(a.params.slidesPerView, 10)), u && c % 2 === 0 && (c = c + 1));
      let f = o - l < c;
      if (u && (f = f || l < Math.ceil(c / 2)), f) {
        const p = u ? l < a.activeIndex ? "prev" : "next" : l - a.activeIndex - 1 < a.params.slidesPerView ? "next" : "prev";
        a.loopFix({
          direction: p,
          slideTo: !0,
          activeSlideIndex: p === "next" ? l + 1 : l - o + 1,
          slideRealIndex: p === "next" ? a.realIndex : void 0
        });
      }
      if (i) {
        const p = s * a.params.grid.rows;
        s = a.slides.filter((g) => g.getAttribute("data-swiper-slide-index") * 1 === p)[0].column;
      } else
        s = a.getSlideIndexByData(s);
    }
  return requestAnimationFrame(() => {
    a.slideTo(s, e, r, n);
  }), a;
}
function pU(t, e, r) {
  t === void 0 && (t = this.params.speed), e === void 0 && (e = !0);
  const n = this, {
    enabled: a,
    params: i,
    animating: s
  } = n;
  if (!a || n.destroyed)
    return n;
  let l = i.slidesPerGroup;
  i.slidesPerView === "auto" && i.slidesPerGroup === 1 && i.slidesPerGroupAuto && (l = Math.max(n.slidesPerViewDynamic("current", !0), 1));
  const o = n.activeIndex < i.slidesPerGroupSkip ? 1 : l, u = n.virtual && i.virtual.enabled;
  if (i.loop) {
    if (s && !u && i.loopPreventsSliding)
      return !1;
    if (n.loopFix({
      direction: "next"
    }), n._clientLeft = n.wrapperEl.clientLeft, n.activeIndex === n.slides.length - 1 && i.cssMode)
      return requestAnimationFrame(() => {
        n.slideTo(n.activeIndex + o, t, e, r);
      }), !0;
  }
  return i.rewind && n.isEnd ? n.slideTo(0, t, e, r) : n.slideTo(n.activeIndex + o, t, e, r);
}
function hU(t, e, r) {
  t === void 0 && (t = this.params.speed), e === void 0 && (e = !0);
  const n = this, {
    params: a,
    snapGrid: i,
    slidesGrid: s,
    rtlTranslate: l,
    enabled: o,
    animating: u
  } = n;
  if (!o || n.destroyed)
    return n;
  const c = n.virtual && a.virtual.enabled;
  if (a.loop) {
    if (u && !c && a.loopPreventsSliding)
      return !1;
    n.loopFix({
      direction: "prev"
    }), n._clientLeft = n.wrapperEl.clientLeft;
  }
  const f = l ? n.translate : -n.translate;
  function p(b) {
    return b < 0 ? -Math.floor(Math.abs(b)) : Math.floor(b);
  }
  const g = p(f), m = i.map((b) => p(b));
  let d = i[m.indexOf(g) - 1];
  if (typeof d > "u" && a.cssMode) {
    let b;
    i.forEach((O, S) => {
      g >= O && (b = S);
    }), typeof b < "u" && (d = i[b > 0 ? b - 1 : b]);
  }
  let w = 0;
  if (typeof d < "u" && (w = s.indexOf(d), w < 0 && (w = n.activeIndex - 1), a.slidesPerView === "auto" && a.slidesPerGroup === 1 && a.slidesPerGroupAuto && (w = w - n.slidesPerViewDynamic("previous", !0) + 1, w = Math.max(w, 0))), a.rewind && n.isBeginning) {
    const b = n.params.virtual && n.params.virtual.enabled && n.virtual ? n.virtual.slides.length - 1 : n.slides.length - 1;
    return n.slideTo(b, t, e, r);
  } else if (a.loop && n.activeIndex === 0 && a.cssMode)
    return requestAnimationFrame(() => {
      n.slideTo(w, t, e, r);
    }), !0;
  return n.slideTo(w, t, e, r);
}
function gU(t, e, r) {
  t === void 0 && (t = this.params.speed), e === void 0 && (e = !0);
  const n = this;
  if (!n.destroyed)
    return n.slideTo(n.activeIndex, t, e, r);
}
function vU(t, e, r, n) {
  t === void 0 && (t = this.params.speed), e === void 0 && (e = !0), n === void 0 && (n = 0.5);
  const a = this;
  if (a.destroyed)
    return;
  let i = a.activeIndex;
  const s = Math.min(a.params.slidesPerGroupSkip, i), l = s + Math.floor((i - s) / a.params.slidesPerGroup), o = a.rtlTranslate ? a.translate : -a.translate;
  if (o >= a.snapGrid[l]) {
    const u = a.snapGrid[l], c = a.snapGrid[l + 1];
    o - u > (c - u) * n && (i += a.params.slidesPerGroup);
  } else {
    const u = a.snapGrid[l - 1], c = a.snapGrid[l];
    o - u <= (c - u) * n && (i -= a.params.slidesPerGroup);
  }
  return i = Math.max(i, 0), i = Math.min(i, a.slidesGrid.length - 1), a.slideTo(i, t, e, r);
}
function mU() {
  const t = this;
  if (t.destroyed)
    return;
  const {
    params: e,
    slidesEl: r
  } = t, n = e.slidesPerView === "auto" ? t.slidesPerViewDynamic() : e.slidesPerView;
  let a = t.clickedIndex, i;
  const s = t.isElement ? "swiper-slide" : `.${e.slideClass}`;
  if (e.loop) {
    if (t.animating)
      return;
    i = parseInt(t.clickedSlide.getAttribute("data-swiper-slide-index"), 10), e.centeredSlides ? a < t.loopedSlides - n / 2 || a > t.slides.length - t.loopedSlides + n / 2 ? (t.loopFix(), a = t.getSlideIndex(dt(r, `${s}[data-swiper-slide-index="${i}"]`)[0]), vn(() => {
      t.slideTo(a);
    })) : t.slideTo(a) : a > t.slides.length - n ? (t.loopFix(), a = t.getSlideIndex(dt(r, `${s}[data-swiper-slide-index="${i}"]`)[0]), vn(() => {
      t.slideTo(a);
    })) : t.slideTo(a);
  } else
    t.slideTo(a);
}
var yU = {
  slideTo: fU,
  slideToLoop: dU,
  slideNext: pU,
  slidePrev: hU,
  slideReset: gU,
  slideToClosest: vU,
  slideToClickedSlide: mU
};
function bU(t) {
  const e = this, {
    params: r,
    slidesEl: n
  } = e;
  if (!r.loop || e.virtual && e.params.virtual.enabled)
    return;
  const a = () => {
    dt(n, `.${r.slideClass}, swiper-slide`).forEach((f, p) => {
      f.setAttribute("data-swiper-slide-index", p);
    });
  }, i = e.grid && r.grid && r.grid.rows > 1, s = r.slidesPerGroup * (i ? r.grid.rows : 1), l = e.slides.length % s !== 0, o = i && e.slides.length % r.grid.rows !== 0, u = (c) => {
    for (let f = 0; f < c; f += 1) {
      const p = e.isElement ? $t("swiper-slide", [r.slideBlankClass]) : $t("div", [r.slideClass, r.slideBlankClass]);
      e.slidesEl.append(p);
    }
  };
  if (l) {
    if (r.loopAddBlankSlides) {
      const c = s - e.slides.length % s;
      u(c), e.recalcSlides(), e.updateSlides();
    } else
      Is("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    a();
  } else if (o) {
    if (r.loopAddBlankSlides) {
      const c = r.grid.rows - e.slides.length % r.grid.rows;
      u(c), e.recalcSlides(), e.updateSlides();
    } else
      Is("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    a();
  } else
    a();
  e.loopFix({
    slideRealIndex: t,
    direction: r.centeredSlides ? void 0 : "next"
  });
}
function wU(t) {
  let {
    slideRealIndex: e,
    slideTo: r = !0,
    direction: n,
    setTranslate: a,
    activeSlideIndex: i,
    byController: s,
    byMousewheel: l
  } = t === void 0 ? {} : t;
  const o = this;
  if (!o.params.loop)
    return;
  o.emit("beforeLoopFix");
  const {
    slides: u,
    allowSlidePrev: c,
    allowSlideNext: f,
    slidesEl: p,
    params: g
  } = o, {
    centeredSlides: m
  } = g;
  if (o.allowSlidePrev = !0, o.allowSlideNext = !0, o.virtual && g.virtual.enabled) {
    r && (!g.centeredSlides && o.snapIndex === 0 ? o.slideTo(o.virtual.slides.length, 0, !1, !0) : g.centeredSlides && o.snapIndex < g.slidesPerView ? o.slideTo(o.virtual.slides.length + o.snapIndex, 0, !1, !0) : o.snapIndex === o.snapGrid.length - 1 && o.slideTo(o.virtual.slidesBefore, 0, !1, !0)), o.allowSlidePrev = c, o.allowSlideNext = f, o.emit("loopFix");
    return;
  }
  let d = g.slidesPerView;
  d === "auto" ? d = o.slidesPerViewDynamic() : (d = Math.ceil(parseFloat(g.slidesPerView, 10)), m && d % 2 === 0 && (d = d + 1));
  const w = g.slidesPerGroupAuto ? d : g.slidesPerGroup;
  let b = w;
  b % w !== 0 && (b += w - b % w), b += g.loopAdditionalSlides, o.loopedSlides = b;
  const O = o.grid && g.grid && g.grid.rows > 1;
  u.length < d + b ? Is("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : O && g.grid.fill === "row" && Is("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const S = [], B = [];
  let T = o.activeIndex;
  typeof i > "u" ? i = o.getSlideIndex(u.filter((C) => C.classList.contains(g.slideActiveClass))[0]) : T = i;
  const A = n === "next" || !n, D = n === "prev" || !n;
  let h = 0, y = 0;
  const v = O ? Math.ceil(u.length / g.grid.rows) : u.length, _ = (O ? u[i].column : i) + (m && typeof a > "u" ? -d / 2 + 0.5 : 0);
  if (_ < b) {
    h = Math.max(b - _, w);
    for (let C = 0; C < b - _; C += 1) {
      const P = C - Math.floor(C / v) * v;
      if (O) {
        const $ = v - P - 1;
        for (let W = u.length - 1; W >= 0; W -= 1)
          u[W].column === $ && S.push(W);
      } else
        S.push(v - P - 1);
    }
  } else if (_ + d > v - b) {
    y = Math.max(_ - (v - b * 2), w);
    for (let C = 0; C < y; C += 1) {
      const P = C - Math.floor(C / v) * v;
      O ? u.forEach(($, W) => {
        $.column === P && B.push(W);
      }) : B.push(P);
    }
  }
  if (o.__preventObserver__ = !0, requestAnimationFrame(() => {
    o.__preventObserver__ = !1;
  }), D && S.forEach((C) => {
    u[C].swiperLoopMoveDOM = !0, p.prepend(u[C]), u[C].swiperLoopMoveDOM = !1;
  }), A && B.forEach((C) => {
    u[C].swiperLoopMoveDOM = !0, p.append(u[C]), u[C].swiperLoopMoveDOM = !1;
  }), o.recalcSlides(), g.slidesPerView === "auto" ? o.updateSlides() : O && (S.length > 0 && D || B.length > 0 && A) && o.slides.forEach((C, P) => {
    o.grid.updateSlide(P, C, o.slides);
  }), g.watchSlidesProgress && o.updateSlidesOffset(), r) {
    if (S.length > 0 && D) {
      if (typeof e > "u") {
        const C = o.slidesGrid[T], $ = o.slidesGrid[T + h] - C;
        l ? o.setTranslate(o.translate - $) : (o.slideTo(T + h, 0, !1, !0), a && (o.touchEventsData.startTranslate = o.touchEventsData.startTranslate - $, o.touchEventsData.currentTranslate = o.touchEventsData.currentTranslate - $));
      } else if (a) {
        const C = O ? S.length / g.grid.rows : S.length;
        o.slideTo(o.activeIndex + C, 0, !1, !0), o.touchEventsData.currentTranslate = o.translate;
      }
    } else if (B.length > 0 && A)
      if (typeof e > "u") {
        const C = o.slidesGrid[T], $ = o.slidesGrid[T - y] - C;
        l ? o.setTranslate(o.translate - $) : (o.slideTo(T - y, 0, !1, !0), a && (o.touchEventsData.startTranslate = o.touchEventsData.startTranslate - $, o.touchEventsData.currentTranslate = o.touchEventsData.currentTranslate - $));
      } else {
        const C = O ? B.length / g.grid.rows : B.length;
        o.slideTo(o.activeIndex - C, 0, !1, !0);
      }
  }
  if (o.allowSlidePrev = c, o.allowSlideNext = f, o.controller && o.controller.control && !s) {
    const C = {
      slideRealIndex: e,
      direction: n,
      setTranslate: a,
      activeSlideIndex: i,
      byController: !0
    };
    Array.isArray(o.controller.control) ? o.controller.control.forEach((P) => {
      !P.destroyed && P.params.loop && P.loopFix({
        ...C,
        slideTo: P.params.slidesPerView === g.slidesPerView ? r : !1
      });
    }) : o.controller.control instanceof o.constructor && o.controller.control.params.loop && o.controller.control.loopFix({
      ...C,
      slideTo: o.controller.control.params.slidesPerView === g.slidesPerView ? r : !1
    });
  }
  o.emit("loopFix");
}
function xU() {
  const t = this, {
    params: e,
    slidesEl: r
  } = t;
  if (!e.loop || t.virtual && t.params.virtual.enabled)
    return;
  t.recalcSlides();
  const n = [];
  t.slides.forEach((a) => {
    const i = typeof a.swiperSlideIndex > "u" ? a.getAttribute("data-swiper-slide-index") * 1 : a.swiperSlideIndex;
    n[i] = a;
  }), t.slides.forEach((a) => {
    a.removeAttribute("data-swiper-slide-index");
  }), n.forEach((a) => {
    r.append(a);
  }), t.recalcSlides(), t.slideTo(t.realIndex, 0);
}
var EU = {
  loopCreate: bU,
  loopFix: wU,
  loopDestroy: xU
};
function CU(t) {
  const e = this;
  if (!e.params.simulateTouch || e.params.watchOverflow && e.isLocked || e.params.cssMode)
    return;
  const r = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
  e.isElement && (e.__preventObserver__ = !0), r.style.cursor = "move", r.style.cursor = t ? "grabbing" : "grab", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  });
}
function DU() {
  const t = this;
  t.params.watchOverflow && t.isLocked || t.params.cssMode || (t.isElement && (t.__preventObserver__ = !0), t[t.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", t.isElement && requestAnimationFrame(() => {
    t.__preventObserver__ = !1;
  }));
}
var SU = {
  setGrabCursor: CU,
  unsetGrabCursor: DU
};
function OU(t, e) {
  e === void 0 && (e = this);
  function r(n) {
    if (!n || n === Et() || n === Qe())
      return null;
    n.assignedSlot && (n = n.assignedSlot);
    const a = n.closest(t);
    return !a && !n.getRootNode ? null : a || r(n.getRootNode().host);
  }
  return r(e);
}
function Gg(t, e, r) {
  const n = Qe(), {
    params: a
  } = t, i = a.edgeSwipeDetection, s = a.edgeSwipeThreshold;
  return i && (r <= s || r >= n.innerWidth - s) ? i === "prevent" ? (e.preventDefault(), !0) : !1 : !0;
}
function PU(t) {
  const e = this, r = Et();
  let n = t;
  n.originalEvent && (n = n.originalEvent);
  const a = e.touchEventsData;
  if (n.type === "pointerdown") {
    if (a.pointerId !== null && a.pointerId !== n.pointerId)
      return;
    a.pointerId = n.pointerId;
  } else
    n.type === "touchstart" && n.targetTouches.length === 1 && (a.touchId = n.targetTouches[0].identifier);
  if (n.type === "touchstart") {
    Gg(e, n, n.targetTouches[0].pageX);
    return;
  }
  const {
    params: i,
    touches: s,
    enabled: l
  } = e;
  if (!l || !i.simulateTouch && n.pointerType === "mouse" || e.animating && i.preventInteractionOnTransition)
    return;
  !e.animating && i.cssMode && i.loop && e.loopFix();
  let o = n.target;
  if (i.touchEventsTarget === "wrapper" && !e.wrapperEl.contains(o) || "which" in n && n.which === 3 || "button" in n && n.button > 0 || a.isTouched && a.isMoved)
    return;
  const u = !!i.noSwipingClass && i.noSwipingClass !== "", c = n.composedPath ? n.composedPath() : n.path;
  u && n.target && n.target.shadowRoot && c && (o = c[0]);
  const f = i.noSwipingSelector ? i.noSwipingSelector : `.${i.noSwipingClass}`, p = !!(n.target && n.target.shadowRoot);
  if (i.noSwiping && (p ? OU(f, o) : o.closest(f))) {
    e.allowClick = !0;
    return;
  }
  if (i.swipeHandler && !o.closest(i.swipeHandler))
    return;
  s.currentX = n.pageX, s.currentY = n.pageY;
  const g = s.currentX, m = s.currentY;
  if (!Gg(e, n, g))
    return;
  Object.assign(a, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), s.startX = g, s.startY = m, a.touchStartTime = zt(), e.allowClick = !0, e.updateSize(), e.swipeDirection = void 0, i.threshold > 0 && (a.allowThresholdMove = !1);
  let d = !0;
  o.matches(a.focusableElements) && (d = !1, o.nodeName === "SELECT" && (a.isTouched = !1)), r.activeElement && r.activeElement.matches(a.focusableElements) && r.activeElement !== o && r.activeElement.blur();
  const w = d && e.allowTouchMove && i.touchStartPreventDefault;
  (i.touchStartForcePreventDefault || w) && !o.isContentEditable && n.preventDefault(), i.freeMode && i.freeMode.enabled && e.freeMode && e.animating && !i.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", n);
}
function _U(t) {
  const e = Et(), r = this, n = r.touchEventsData, {
    params: a,
    touches: i,
    rtlTranslate: s,
    enabled: l
  } = r;
  if (!l || !a.simulateTouch && t.pointerType === "mouse")
    return;
  let o = t;
  if (o.originalEvent && (o = o.originalEvent), o.type === "pointermove" && (n.touchId !== null || o.pointerId !== n.pointerId))
    return;
  let u;
  if (o.type === "touchmove") {
    if (u = [...o.changedTouches].filter((A) => A.identifier === n.touchId)[0], !u || u.identifier !== n.touchId)
      return;
  } else
    u = o;
  if (!n.isTouched) {
    n.startMoving && n.isScrolling && r.emit("touchMoveOpposite", o);
    return;
  }
  const c = u.pageX, f = u.pageY;
  if (o.preventedByNestedSwiper) {
    i.startX = c, i.startY = f;
    return;
  }
  if (!r.allowTouchMove) {
    o.target.matches(n.focusableElements) || (r.allowClick = !1), n.isTouched && (Object.assign(i, {
      startX: c,
      startY: f,
      currentX: c,
      currentY: f
    }), n.touchStartTime = zt());
    return;
  }
  if (a.touchReleaseOnEdges && !a.loop) {
    if (r.isVertical()) {
      if (f < i.startY && r.translate <= r.maxTranslate() || f > i.startY && r.translate >= r.minTranslate()) {
        n.isTouched = !1, n.isMoved = !1;
        return;
      }
    } else if (c < i.startX && r.translate <= r.maxTranslate() || c > i.startX && r.translate >= r.minTranslate())
      return;
  }
  if (e.activeElement && o.target === e.activeElement && o.target.matches(n.focusableElements)) {
    n.isMoved = !0, r.allowClick = !1;
    return;
  }
  n.allowTouchCallbacks && r.emit("touchMove", o), i.previousX = i.currentX, i.previousY = i.currentY, i.currentX = c, i.currentY = f;
  const p = i.currentX - i.startX, g = i.currentY - i.startY;
  if (r.params.threshold && Math.sqrt(p ** 2 + g ** 2) < r.params.threshold)
    return;
  if (typeof n.isScrolling > "u") {
    let A;
    r.isHorizontal() && i.currentY === i.startY || r.isVertical() && i.currentX === i.startX ? n.isScrolling = !1 : p * p + g * g >= 25 && (A = Math.atan2(Math.abs(g), Math.abs(p)) * 180 / Math.PI, n.isScrolling = r.isHorizontal() ? A > a.touchAngle : 90 - A > a.touchAngle);
  }
  if (n.isScrolling && r.emit("touchMoveOpposite", o), typeof n.startMoving > "u" && (i.currentX !== i.startX || i.currentY !== i.startY) && (n.startMoving = !0), n.isScrolling) {
    n.isTouched = !1;
    return;
  }
  if (!n.startMoving)
    return;
  r.allowClick = !1, !a.cssMode && o.cancelable && o.preventDefault(), a.touchMoveStopPropagation && !a.nested && o.stopPropagation();
  let m = r.isHorizontal() ? p : g, d = r.isHorizontal() ? i.currentX - i.previousX : i.currentY - i.previousY;
  a.oneWayMovement && (m = Math.abs(m) * (s ? 1 : -1), d = Math.abs(d) * (s ? 1 : -1)), i.diff = m, m *= a.touchRatio, s && (m = -m, d = -d);
  const w = r.touchesDirection;
  r.swipeDirection = m > 0 ? "prev" : "next", r.touchesDirection = d > 0 ? "prev" : "next";
  const b = r.params.loop && !a.cssMode, O = r.touchesDirection === "next" && r.allowSlideNext || r.touchesDirection === "prev" && r.allowSlidePrev;
  if (!n.isMoved) {
    if (b && O && r.loopFix({
      direction: r.swipeDirection
    }), n.startTranslate = r.getTranslate(), r.setTransition(0), r.animating) {
      const A = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0
      });
      r.wrapperEl.dispatchEvent(A);
    }
    n.allowMomentumBounce = !1, a.grabCursor && (r.allowSlideNext === !0 || r.allowSlidePrev === !0) && r.setGrabCursor(!0), r.emit("sliderFirstMove", o);
  }
  let S;
  if ((/* @__PURE__ */ new Date()).getTime(), n.isMoved && n.allowThresholdMove && w !== r.touchesDirection && b && O && Math.abs(m) >= 1) {
    Object.assign(i, {
      startX: c,
      startY: f,
      currentX: c,
      currentY: f,
      startTranslate: n.currentTranslate
    }), n.loopSwapReset = !0, n.startTranslate = n.currentTranslate;
    return;
  }
  r.emit("sliderMove", o), n.isMoved = !0, n.currentTranslate = m + n.startTranslate;
  let B = !0, T = a.resistanceRatio;
  if (a.touchReleaseOnEdges && (T = 0), m > 0 ? (b && O && !S && n.allowThresholdMove && n.currentTranslate > (a.centeredSlides ? r.minTranslate() - r.slidesSizesGrid[r.activeIndex + 1] : r.minTranslate()) && r.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), n.currentTranslate > r.minTranslate() && (B = !1, a.resistance && (n.currentTranslate = r.minTranslate() - 1 + (-r.minTranslate() + n.startTranslate + m) ** T))) : m < 0 && (b && O && !S && n.allowThresholdMove && n.currentTranslate < (a.centeredSlides ? r.maxTranslate() + r.slidesSizesGrid[r.slidesSizesGrid.length - 1] : r.maxTranslate()) && r.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: r.slides.length - (a.slidesPerView === "auto" ? r.slidesPerViewDynamic() : Math.ceil(parseFloat(a.slidesPerView, 10)))
  }), n.currentTranslate < r.maxTranslate() && (B = !1, a.resistance && (n.currentTranslate = r.maxTranslate() + 1 - (r.maxTranslate() - n.startTranslate - m) ** T))), B && (o.preventedByNestedSwiper = !0), !r.allowSlideNext && r.swipeDirection === "next" && n.currentTranslate < n.startTranslate && (n.currentTranslate = n.startTranslate), !r.allowSlidePrev && r.swipeDirection === "prev" && n.currentTranslate > n.startTranslate && (n.currentTranslate = n.startTranslate), !r.allowSlidePrev && !r.allowSlideNext && (n.currentTranslate = n.startTranslate), a.threshold > 0)
    if (Math.abs(m) > a.threshold || n.allowThresholdMove) {
      if (!n.allowThresholdMove) {
        n.allowThresholdMove = !0, i.startX = i.currentX, i.startY = i.currentY, n.currentTranslate = n.startTranslate, i.diff = r.isHorizontal() ? i.currentX - i.startX : i.currentY - i.startY;
        return;
      }
    } else {
      n.currentTranslate = n.startTranslate;
      return;
    }
  !a.followFinger || a.cssMode || ((a.freeMode && a.freeMode.enabled && r.freeMode || a.watchSlidesProgress) && (r.updateActiveIndex(), r.updateSlidesClasses()), a.freeMode && a.freeMode.enabled && r.freeMode && r.freeMode.onTouchMove(), r.updateProgress(n.currentTranslate), r.setTranslate(n.currentTranslate));
}
function AU(t) {
  const e = this, r = e.touchEventsData;
  let n = t;
  n.originalEvent && (n = n.originalEvent);
  let a;
  if (n.type === "touchend" || n.type === "touchcancel") {
    if (a = [...n.changedTouches].filter((T) => T.identifier === r.touchId)[0], !a || a.identifier !== r.touchId)
      return;
  } else {
    if (r.touchId !== null || n.pointerId !== r.pointerId)
      return;
    a = n;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(n.type) && !(["pointercancel", "contextmenu"].includes(n.type) && (e.browser.isSafari || e.browser.isWebView)))
    return;
  r.pointerId = null, r.touchId = null;
  const {
    params: s,
    touches: l,
    rtlTranslate: o,
    slidesGrid: u,
    enabled: c
  } = e;
  if (!c || !s.simulateTouch && n.pointerType === "mouse")
    return;
  if (r.allowTouchCallbacks && e.emit("touchEnd", n), r.allowTouchCallbacks = !1, !r.isTouched) {
    r.isMoved && s.grabCursor && e.setGrabCursor(!1), r.isMoved = !1, r.startMoving = !1;
    return;
  }
  s.grabCursor && r.isMoved && r.isTouched && (e.allowSlideNext === !0 || e.allowSlidePrev === !0) && e.setGrabCursor(!1);
  const f = zt(), p = f - r.touchStartTime;
  if (e.allowClick) {
    const T = n.path || n.composedPath && n.composedPath();
    e.updateClickedSlide(T && T[0] || n.target, T), e.emit("tap click", n), p < 300 && f - r.lastClickTime < 300 && e.emit("doubleTap doubleClick", n);
  }
  if (r.lastClickTime = zt(), vn(() => {
    e.destroyed || (e.allowClick = !0);
  }), !r.isTouched || !r.isMoved || !e.swipeDirection || l.diff === 0 && !r.loopSwapReset || r.currentTranslate === r.startTranslate && !r.loopSwapReset) {
    r.isTouched = !1, r.isMoved = !1, r.startMoving = !1;
    return;
  }
  r.isTouched = !1, r.isMoved = !1, r.startMoving = !1;
  let g;
  if (s.followFinger ? g = o ? e.translate : -e.translate : g = -r.currentTranslate, s.cssMode)
    return;
  if (s.freeMode && s.freeMode.enabled) {
    e.freeMode.onTouchEnd({
      currentPos: g
    });
    return;
  }
  const m = g >= -e.maxTranslate() && !e.params.loop;
  let d = 0, w = e.slidesSizesGrid[0];
  for (let T = 0; T < u.length; T += T < s.slidesPerGroupSkip ? 1 : s.slidesPerGroup) {
    const A = T < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
    typeof u[T + A] < "u" ? (m || g >= u[T] && g < u[T + A]) && (d = T, w = u[T + A] - u[T]) : (m || g >= u[T]) && (d = T, w = u[u.length - 1] - u[u.length - 2]);
  }
  let b = null, O = null;
  s.rewind && (e.isBeginning ? O = s.virtual && s.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1 : e.isEnd && (b = 0));
  const S = (g - u[d]) / w, B = d < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
  if (p > s.longSwipesMs) {
    if (!s.longSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.swipeDirection === "next" && (S >= s.longSwipesRatio ? e.slideTo(s.rewind && e.isEnd ? b : d + B) : e.slideTo(d)), e.swipeDirection === "prev" && (S > 1 - s.longSwipesRatio ? e.slideTo(d + B) : O !== null && S < 0 && Math.abs(S) > s.longSwipesRatio ? e.slideTo(O) : e.slideTo(d));
  } else {
    if (!s.shortSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.navigation && (n.target === e.navigation.nextEl || n.target === e.navigation.prevEl) ? n.target === e.navigation.nextEl ? e.slideTo(d + B) : e.slideTo(d) : (e.swipeDirection === "next" && e.slideTo(b !== null ? b : d + B), e.swipeDirection === "prev" && e.slideTo(O !== null ? O : d));
  }
}
function Yg() {
  const t = this, {
    params: e,
    el: r
  } = t;
  if (r && r.offsetWidth === 0)
    return;
  e.breakpoints && t.setBreakpoint();
  const {
    allowSlideNext: n,
    allowSlidePrev: a,
    snapGrid: i
  } = t, s = t.virtual && t.params.virtual.enabled;
  t.allowSlideNext = !0, t.allowSlidePrev = !0, t.updateSize(), t.updateSlides(), t.updateSlidesClasses();
  const l = s && e.loop;
  (e.slidesPerView === "auto" || e.slidesPerView > 1) && t.isEnd && !t.isBeginning && !t.params.centeredSlides && !l ? t.slideTo(t.slides.length - 1, 0, !1, !0) : t.params.loop && !s ? t.slideToLoop(t.realIndex, 0, !1, !0) : t.slideTo(t.activeIndex, 0, !1, !0), t.autoplay && t.autoplay.running && t.autoplay.paused && (clearTimeout(t.autoplay.resizeTimeout), t.autoplay.resizeTimeout = setTimeout(() => {
    t.autoplay && t.autoplay.running && t.autoplay.paused && t.autoplay.resume();
  }, 500)), t.allowSlidePrev = a, t.allowSlideNext = n, t.params.watchOverflow && i !== t.snapGrid && t.checkOverflow();
}
function TU(t) {
  const e = this;
  e.enabled && (e.allowClick || (e.params.preventClicks && t.preventDefault(), e.params.preventClicksPropagation && e.animating && (t.stopPropagation(), t.stopImmediatePropagation())));
}
function BU() {
  const t = this, {
    wrapperEl: e,
    rtlTranslate: r,
    enabled: n
  } = t;
  if (!n)
    return;
  t.previousTranslate = t.translate, t.isHorizontal() ? t.translate = -e.scrollLeft : t.translate = -e.scrollTop, t.translate === 0 && (t.translate = 0), t.updateActiveIndex(), t.updateSlidesClasses();
  let a;
  const i = t.maxTranslate() - t.minTranslate();
  i === 0 ? a = 0 : a = (t.translate - t.minTranslate()) / i, a !== t.progress && t.updateProgress(r ? -t.translate : t.translate), t.emit("setTranslate", t.translate, !1);
}
function RU(t) {
  const e = this;
  fs(e, t.target), !(e.params.cssMode || e.params.slidesPerView !== "auto" && !e.params.autoHeight) && e.update();
}
function $U() {
  const t = this;
  t.documentTouchHandlerProceeded || (t.documentTouchHandlerProceeded = !0, t.params.touchReleaseOnEdges && (t.el.style.touchAction = "auto"));
}
const Dy = (t, e) => {
  const r = Et(), {
    params: n,
    el: a,
    wrapperEl: i,
    device: s
  } = t, l = !!n.nested, o = e === "on" ? "addEventListener" : "removeEventListener", u = e;
  r[o]("touchstart", t.onDocumentTouchStart, {
    passive: !1,
    capture: l
  }), a[o]("touchstart", t.onTouchStart, {
    passive: !1
  }), a[o]("pointerdown", t.onTouchStart, {
    passive: !1
  }), r[o]("touchmove", t.onTouchMove, {
    passive: !1,
    capture: l
  }), r[o]("pointermove", t.onTouchMove, {
    passive: !1,
    capture: l
  }), r[o]("touchend", t.onTouchEnd, {
    passive: !0
  }), r[o]("pointerup", t.onTouchEnd, {
    passive: !0
  }), r[o]("pointercancel", t.onTouchEnd, {
    passive: !0
  }), r[o]("touchcancel", t.onTouchEnd, {
    passive: !0
  }), r[o]("pointerout", t.onTouchEnd, {
    passive: !0
  }), r[o]("pointerleave", t.onTouchEnd, {
    passive: !0
  }), r[o]("contextmenu", t.onTouchEnd, {
    passive: !0
  }), (n.preventClicks || n.preventClicksPropagation) && a[o]("click", t.onClick, !0), n.cssMode && i[o]("scroll", t.onScroll), n.updateOnWindowResize ? t[u](s.ios || s.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Yg, !0) : t[u]("observerUpdate", Yg, !0), a[o]("load", t.onLoad, {
    capture: !0
  });
};
function MU() {
  const t = this, {
    params: e
  } = t;
  t.onTouchStart = PU.bind(t), t.onTouchMove = _U.bind(t), t.onTouchEnd = AU.bind(t), t.onDocumentTouchStart = $U.bind(t), e.cssMode && (t.onScroll = BU.bind(t)), t.onClick = TU.bind(t), t.onLoad = RU.bind(t), Dy(t, "on");
}
function FU() {
  Dy(this, "off");
}
var IU = {
  attachEvents: MU,
  detachEvents: FU
};
const Kg = (t, e) => t.grid && e.grid && e.grid.rows > 1;
function jU() {
  const t = this, {
    realIndex: e,
    initialized: r,
    params: n,
    el: a
  } = t, i = n.breakpoints;
  if (!i || i && Object.keys(i).length === 0)
    return;
  const s = t.getBreakpoint(i, t.params.breakpointsBase, t.el);
  if (!s || t.currentBreakpoint === s)
    return;
  const o = (s in i ? i[s] : void 0) || t.originalParams, u = Kg(t, n), c = Kg(t, o), f = n.enabled;
  u && !c ? (a.classList.remove(`${n.containerModifierClass}grid`, `${n.containerModifierClass}grid-column`), t.emitContainerClasses()) : !u && c && (a.classList.add(`${n.containerModifierClass}grid`), (o.grid.fill && o.grid.fill === "column" || !o.grid.fill && n.grid.fill === "column") && a.classList.add(`${n.containerModifierClass}grid-column`), t.emitContainerClasses()), ["navigation", "pagination", "scrollbar"].forEach((b) => {
    if (typeof o[b] > "u")
      return;
    const O = n[b] && n[b].enabled, S = o[b] && o[b].enabled;
    O && !S && t[b].disable(), !O && S && t[b].enable();
  });
  const p = o.direction && o.direction !== n.direction, g = n.loop && (o.slidesPerView !== n.slidesPerView || p), m = n.loop;
  p && r && t.changeDirection(), Rt(t.params, o);
  const d = t.params.enabled, w = t.params.loop;
  Object.assign(t, {
    allowTouchMove: t.params.allowTouchMove,
    allowSlideNext: t.params.allowSlideNext,
    allowSlidePrev: t.params.allowSlidePrev
  }), f && !d ? t.disable() : !f && d && t.enable(), t.currentBreakpoint = s, t.emit("_beforeBreakpoint", o), r && (g ? (t.loopDestroy(), t.loopCreate(e), t.updateSlides()) : !m && w ? (t.loopCreate(e), t.updateSlides()) : m && !w && t.loopDestroy()), t.emit("breakpoint", o);
}
function LU(t, e, r) {
  if (e === void 0 && (e = "window"), !t || e === "container" && !r)
    return;
  let n = !1;
  const a = Qe(), i = e === "window" ? a.innerHeight : r.clientHeight, s = Object.keys(t).map((l) => {
    if (typeof l == "string" && l.indexOf("@") === 0) {
      const o = parseFloat(l.substr(1));
      return {
        value: i * o,
        point: l
      };
    }
    return {
      value: l,
      point: l
    };
  });
  s.sort((l, o) => parseInt(l.value, 10) - parseInt(o.value, 10));
  for (let l = 0; l < s.length; l += 1) {
    const {
      point: o,
      value: u
    } = s[l];
    e === "window" ? a.matchMedia(`(min-width: ${u}px)`).matches && (n = o) : u <= r.clientWidth && (n = o);
  }
  return n || "max";
}
var kU = {
  setBreakpoint: jU,
  getBreakpoint: LU
};
function NU(t, e) {
  const r = [];
  return t.forEach((n) => {
    typeof n == "object" ? Object.keys(n).forEach((a) => {
      n[a] && r.push(e + a);
    }) : typeof n == "string" && r.push(e + n);
  }), r;
}
function zU() {
  const t = this, {
    classNames: e,
    params: r,
    rtl: n,
    el: a,
    device: i
  } = t, s = NU(["initialized", r.direction, {
    "free-mode": t.params.freeMode && r.freeMode.enabled
  }, {
    autoheight: r.autoHeight
  }, {
    rtl: n
  }, {
    grid: r.grid && r.grid.rows > 1
  }, {
    "grid-column": r.grid && r.grid.rows > 1 && r.grid.fill === "column"
  }, {
    android: i.android
  }, {
    ios: i.ios
  }, {
    "css-mode": r.cssMode
  }, {
    centered: r.cssMode && r.centeredSlides
  }, {
    "watch-progress": r.watchSlidesProgress
  }], r.containerModifierClass);
  e.push(...s), a.classList.add(...e), t.emitContainerClasses();
}
function WU() {
  const t = this, {
    el: e,
    classNames: r
  } = t;
  e.classList.remove(...r), t.emitContainerClasses();
}
var HU = {
  addClasses: zU,
  removeClasses: WU
};
function UU() {
  const t = this, {
    isLocked: e,
    params: r
  } = t, {
    slidesOffsetBefore: n
  } = r;
  if (n) {
    const a = t.slides.length - 1, i = t.slidesGrid[a] + t.slidesSizesGrid[a] + n * 2;
    t.isLocked = t.size > i;
  } else
    t.isLocked = t.snapGrid.length === 1;
  r.allowSlideNext === !0 && (t.allowSlideNext = !t.isLocked), r.allowSlidePrev === !0 && (t.allowSlidePrev = !t.isLocked), e && e !== t.isLocked && (t.isEnd = !1), e !== t.isLocked && t.emit(t.isLocked ? "lock" : "unlock");
}
var VU = {
  checkOverflow: UU
}, Ls = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function qU(t, e) {
  return function(n) {
    n === void 0 && (n = {});
    const a = Object.keys(n)[0], i = n[a];
    if (typeof i != "object" || i === null) {
      Rt(e, n);
      return;
    }
    if (t[a] === !0 && (t[a] = {
      enabled: !0
    }), a === "navigation" && t[a] && t[a].enabled && !t[a].prevEl && !t[a].nextEl && (t[a].auto = !0), ["pagination", "scrollbar"].indexOf(a) >= 0 && t[a] && t[a].enabled && !t[a].el && (t[a].auto = !0), !(a in t && "enabled" in i)) {
      Rt(e, n);
      return;
    }
    typeof t[a] == "object" && !("enabled" in t[a]) && (t[a].enabled = !0), t[a] || (t[a] = {
      enabled: !1
    }), Rt(e, n);
  };
}
const Al = {
  eventsEmitter: HH,
  update: eU,
  translate: sU,
  transition: cU,
  slide: yU,
  loop: EU,
  grabCursor: SU,
  events: IU,
  breakpoints: kU,
  checkOverflow: VU,
  classes: HU
}, Tl = {};
let Mi = class xr {
  constructor() {
    let e, r;
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    a.length === 1 && a[0].constructor && Object.prototype.toString.call(a[0]).slice(8, -1) === "Object" ? r = a[0] : [e, r] = a, r || (r = {}), r = Rt({}, r), e && !r.el && (r.el = e);
    const s = Et();
    if (r.el && typeof r.el == "string" && s.querySelectorAll(r.el).length > 1) {
      const c = [];
      return s.querySelectorAll(r.el).forEach((f) => {
        const p = Rt({}, r, {
          el: f
        });
        c.push(new xr(p));
      }), c;
    }
    const l = this;
    l.__swiper__ = !0, l.support = xy(), l.device = Ey({
      userAgent: r.userAgent
    }), l.browser = NH(), l.eventsListeners = {}, l.eventsAnyListeners = [], l.modules = [...l.__modules__], r.modules && Array.isArray(r.modules) && l.modules.push(...r.modules);
    const o = {};
    l.modules.forEach((c) => {
      c({
        params: r,
        swiper: l,
        extendParams: qU(r, o),
        on: l.on.bind(l),
        once: l.once.bind(l),
        off: l.off.bind(l),
        emit: l.emit.bind(l)
      });
    });
    const u = Rt({}, Ls, o);
    return l.params = Rt({}, u, Tl, r), l.originalParams = Rt({}, l.params), l.passedParams = Rt({}, r), l.params && l.params.on && Object.keys(l.params.on).forEach((c) => {
      l.on(c, l.params.on[c]);
    }), l.params && l.params.onAny && l.onAny(l.params.onAny), Object.assign(l, {
      enabled: l.params.enabled,
      el: e,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return l.params.direction === "horizontal";
      },
      isVertical() {
        return l.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: l.params.allowSlideNext,
      allowSlidePrev: l.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: l.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: l.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), l.emit("_swiper"), l.params.init && l.init(), l;
  }
  getDirectionLabel(e) {
    return this.isHorizontal() ? e : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[e];
  }
  getSlideIndex(e) {
    const {
      slidesEl: r,
      params: n
    } = this, a = dt(r, `.${n.slideClass}, swiper-slide`), i = bi(a[0]);
    return bi(e) - i;
  }
  getSlideIndexByData(e) {
    return this.getSlideIndex(this.slides.filter((r) => r.getAttribute("data-swiper-slide-index") * 1 === e)[0]);
  }
  recalcSlides() {
    const e = this, {
      slidesEl: r,
      params: n
    } = e;
    e.slides = dt(r, `.${n.slideClass}, swiper-slide`);
  }
  enable() {
    const e = this;
    e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
  }
  disable() {
    const e = this;
    e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
  }
  setProgress(e, r) {
    const n = this;
    e = Math.min(Math.max(e, 0), 1);
    const a = n.minTranslate(), s = (n.maxTranslate() - a) * e + a;
    n.translateTo(s, typeof r > "u" ? 0 : r), n.updateActiveIndex(), n.updateSlidesClasses();
  }
  emitContainerClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el)
      return;
    const r = e.el.className.split(" ").filter((n) => n.indexOf("swiper") === 0 || n.indexOf(e.params.containerModifierClass) === 0);
    e.emit("_containerClasses", r.join(" "));
  }
  getSlideClasses(e) {
    const r = this;
    return r.destroyed ? "" : e.className.split(" ").filter((n) => n.indexOf("swiper-slide") === 0 || n.indexOf(r.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el)
      return;
    const r = [];
    e.slides.forEach((n) => {
      const a = e.getSlideClasses(n);
      r.push({
        slideEl: n,
        classNames: a
      }), e.emit("_slideClass", n, a);
    }), e.emit("_slideClasses", r);
  }
  slidesPerViewDynamic(e, r) {
    e === void 0 && (e = "current"), r === void 0 && (r = !1);
    const n = this, {
      params: a,
      slides: i,
      slidesGrid: s,
      slidesSizesGrid: l,
      size: o,
      activeIndex: u
    } = n;
    let c = 1;
    if (typeof a.slidesPerView == "number")
      return a.slidesPerView;
    if (a.centeredSlides) {
      let f = i[u] ? Math.ceil(i[u].swiperSlideSize) : 0, p;
      for (let g = u + 1; g < i.length; g += 1)
        i[g] && !p && (f += Math.ceil(i[g].swiperSlideSize), c += 1, f > o && (p = !0));
      for (let g = u - 1; g >= 0; g -= 1)
        i[g] && !p && (f += i[g].swiperSlideSize, c += 1, f > o && (p = !0));
    } else if (e === "current")
      for (let f = u + 1; f < i.length; f += 1)
        (r ? s[f] + l[f] - s[u] < o : s[f] - s[u] < o) && (c += 1);
    else
      for (let f = u - 1; f >= 0; f -= 1)
        s[u] - s[f] < o && (c += 1);
    return c;
  }
  update() {
    const e = this;
    if (!e || e.destroyed)
      return;
    const {
      snapGrid: r,
      params: n
    } = e;
    n.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll('[loading="lazy"]')].forEach((s) => {
      s.complete && fs(e, s);
    }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
    function a() {
      const s = e.rtlTranslate ? e.translate * -1 : e.translate, l = Math.min(Math.max(s, e.maxTranslate()), e.minTranslate());
      e.setTranslate(l), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    let i;
    if (n.freeMode && n.freeMode.enabled && !n.cssMode)
      a(), n.autoHeight && e.updateAutoHeight();
    else {
      if ((n.slidesPerView === "auto" || n.slidesPerView > 1) && e.isEnd && !n.centeredSlides) {
        const s = e.virtual && n.virtual.enabled ? e.virtual.slides : e.slides;
        i = e.slideTo(s.length - 1, 0, !1, !0);
      } else
        i = e.slideTo(e.activeIndex, 0, !1, !0);
      i || a();
    }
    n.watchOverflow && r !== e.snapGrid && e.checkOverflow(), e.emit("update");
  }
  changeDirection(e, r) {
    r === void 0 && (r = !0);
    const n = this, a = n.params.direction;
    return e || (e = a === "horizontal" ? "vertical" : "horizontal"), e === a || e !== "horizontal" && e !== "vertical" || (n.el.classList.remove(`${n.params.containerModifierClass}${a}`), n.el.classList.add(`${n.params.containerModifierClass}${e}`), n.emitContainerClasses(), n.params.direction = e, n.slides.forEach((i) => {
      e === "vertical" ? i.style.width = "" : i.style.height = "";
    }), n.emit("changeDirection"), r && n.update()), n;
  }
  changeLanguageDirection(e) {
    const r = this;
    r.rtl && e === "rtl" || !r.rtl && e === "ltr" || (r.rtl = e === "rtl", r.rtlTranslate = r.params.direction === "horizontal" && r.rtl, r.rtl ? (r.el.classList.add(`${r.params.containerModifierClass}rtl`), r.el.dir = "rtl") : (r.el.classList.remove(`${r.params.containerModifierClass}rtl`), r.el.dir = "ltr"), r.update());
  }
  mount(e) {
    const r = this;
    if (r.mounted)
      return !0;
    let n = e || r.params.el;
    if (typeof n == "string" && (n = document.querySelector(n)), !n)
      return !1;
    n.swiper = r, n.parentNode && n.parentNode.host && n.parentNode.host.nodeName === r.params.swiperElementNodeName.toUpperCase() && (r.isElement = !0);
    const a = () => `.${(r.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let s = (() => n && n.shadowRoot && n.shadowRoot.querySelector ? n.shadowRoot.querySelector(a()) : dt(n, a())[0])();
    return !s && r.params.createElements && (s = $t("div", r.params.wrapperClass), n.append(s), dt(n, `.${r.params.slideClass}`).forEach((l) => {
      s.append(l);
    })), Object.assign(r, {
      el: n,
      wrapperEl: s,
      slidesEl: r.isElement && !n.parentNode.host.slideSlots ? n.parentNode.host : s,
      hostEl: r.isElement ? n.parentNode.host : n,
      mounted: !0,
      // RTL
      rtl: n.dir.toLowerCase() === "rtl" || zr(n, "direction") === "rtl",
      rtlTranslate: r.params.direction === "horizontal" && (n.dir.toLowerCase() === "rtl" || zr(n, "direction") === "rtl"),
      wrongRTL: zr(s, "display") === "-webkit-box"
    }), !0;
  }
  init(e) {
    const r = this;
    if (r.initialized || r.mount(e) === !1)
      return r;
    r.emit("beforeInit"), r.params.breakpoints && r.setBreakpoint(), r.addClasses(), r.updateSize(), r.updateSlides(), r.params.watchOverflow && r.checkOverflow(), r.params.grabCursor && r.enabled && r.setGrabCursor(), r.params.loop && r.virtual && r.params.virtual.enabled ? r.slideTo(r.params.initialSlide + r.virtual.slidesBefore, 0, r.params.runCallbacksOnInit, !1, !0) : r.slideTo(r.params.initialSlide, 0, r.params.runCallbacksOnInit, !1, !0), r.params.loop && r.loopCreate(), r.attachEvents();
    const a = [...r.el.querySelectorAll('[loading="lazy"]')];
    return r.isElement && a.push(...r.hostEl.querySelectorAll('[loading="lazy"]')), a.forEach((i) => {
      i.complete ? fs(r, i) : i.addEventListener("load", (s) => {
        fs(r, s.target);
      });
    }), mu(r), r.initialized = !0, mu(r), r.emit("init"), r.emit("afterInit"), r;
  }
  destroy(e, r) {
    e === void 0 && (e = !0), r === void 0 && (r = !0);
    const n = this, {
      params: a,
      el: i,
      wrapperEl: s,
      slides: l
    } = n;
    return typeof n.params > "u" || n.destroyed || (n.emit("beforeDestroy"), n.initialized = !1, n.detachEvents(), a.loop && n.loopDestroy(), r && (n.removeClasses(), i.removeAttribute("style"), s.removeAttribute("style"), l && l.length && l.forEach((o) => {
      o.classList.remove(a.slideVisibleClass, a.slideFullyVisibleClass, a.slideActiveClass, a.slideNextClass, a.slidePrevClass), o.removeAttribute("style"), o.removeAttribute("data-swiper-slide-index");
    })), n.emit("destroy"), Object.keys(n.eventsListeners).forEach((o) => {
      n.off(o);
    }), e !== !1 && (n.el.swiper = null, RH(n)), n.destroyed = !0), null;
  }
  static extendDefaults(e) {
    Rt(Tl, e);
  }
  static get extendedDefaults() {
    return Tl;
  }
  static get defaults() {
    return Ls;
  }
  static installModule(e) {
    xr.prototype.__modules__ || (xr.prototype.__modules__ = []);
    const r = xr.prototype.__modules__;
    typeof e == "function" && r.indexOf(e) < 0 && r.push(e);
  }
  static use(e) {
    return Array.isArray(e) ? (e.forEach((r) => xr.installModule(r)), xr) : (xr.installModule(e), xr);
  }
};
Object.keys(Al).forEach((t) => {
  Object.keys(Al[t]).forEach((e) => {
    Mi.prototype[e] = Al[t][e];
  });
});
Mi.use([zH, WH]);
function GU(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n,
    emit: a
  } = t;
  r({
    virtual: {
      enabled: !1,
      slides: [],
      cache: !0,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: !0,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  let i;
  const s = Et();
  e.virtual = {
    cache: {},
    from: void 0,
    to: void 0,
    slides: [],
    offset: 0,
    slidesGrid: []
  };
  const l = s.createElement("div");
  function o(m, d) {
    const w = e.params.virtual;
    if (w.cache && e.virtual.cache[d])
      return e.virtual.cache[d];
    let b;
    return w.renderSlide ? (b = w.renderSlide.call(e, m, d), typeof b == "string" && (l.innerHTML = b, b = l.children[0])) : e.isElement ? b = $t("swiper-slide") : b = $t("div", e.params.slideClass), b.setAttribute("data-swiper-slide-index", d), w.renderSlide || (b.innerHTML = m), w.cache && (e.virtual.cache[d] = b), b;
  }
  function u(m) {
    const {
      slidesPerView: d,
      slidesPerGroup: w,
      centeredSlides: b,
      loop: O
    } = e.params, {
      addSlidesBefore: S,
      addSlidesAfter: B
    } = e.params.virtual, {
      from: T,
      to: A,
      slides: D,
      slidesGrid: h,
      offset: y
    } = e.virtual;
    e.params.cssMode || e.updateActiveIndex();
    const v = e.activeIndex || 0;
    let E;
    e.rtlTranslate ? E = "right" : E = e.isHorizontal() ? "left" : "top";
    let _, C;
    b ? (_ = Math.floor(d / 2) + w + B, C = Math.floor(d / 2) + w + S) : (_ = d + (w - 1) + B, C = (O ? d : w) + S);
    let P = v - C, $ = v + _;
    O || (P = Math.max(P, 0), $ = Math.min($, D.length - 1));
    let W = (e.slidesGrid[P] || 0) - (e.slidesGrid[0] || 0);
    O && v >= C ? (P -= C, b || (W += e.slidesGrid[0])) : O && v < C && (P = -C, b && (W += e.slidesGrid[0])), Object.assign(e.virtual, {
      from: P,
      to: $,
      offset: W,
      slidesGrid: e.slidesGrid,
      slidesBefore: C,
      slidesAfter: _
    });
    function j() {
      e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), a("virtualUpdate");
    }
    if (T === P && A === $ && !m) {
      e.slidesGrid !== h && W !== y && e.slides.forEach((Y) => {
        Y.style[E] = `${W - Math.abs(e.cssOverflowAdjustment())}px`;
      }), e.updateProgress(), a("virtualUpdate");
      return;
    }
    if (e.params.virtual.renderExternal) {
      e.params.virtual.renderExternal.call(e, {
        offset: W,
        from: P,
        to: $,
        slides: function() {
          const L = [];
          for (let q = P; q <= $; q += 1)
            L.push(D[q]);
          return L;
        }()
      }), e.params.virtual.renderExternalUpdate ? j() : a("virtualUpdate");
      return;
    }
    const I = [], F = [], k = (Y) => {
      let L = Y;
      return Y < 0 ? L = D.length + Y : L >= D.length && (L = L - D.length), L;
    };
    if (m)
      e.slides.filter((Y) => Y.matches(`.${e.params.slideClass}, swiper-slide`)).forEach((Y) => {
        Y.remove();
      });
    else
      for (let Y = T; Y <= A; Y += 1)
        if (Y < P || Y > $) {
          const L = k(Y);
          e.slides.filter((q) => q.matches(`.${e.params.slideClass}[data-swiper-slide-index="${L}"], swiper-slide[data-swiper-slide-index="${L}"]`)).forEach((q) => {
            q.remove();
          });
        }
    const N = O ? -D.length : 0, U = O ? D.length * 2 : D.length;
    for (let Y = N; Y < U; Y += 1)
      if (Y >= P && Y <= $) {
        const L = k(Y);
        typeof A > "u" || m ? F.push(L) : (Y > A && F.push(L), Y < T && I.push(L));
      }
    if (F.forEach((Y) => {
      e.slidesEl.append(o(D[Y], Y));
    }), O)
      for (let Y = I.length - 1; Y >= 0; Y -= 1) {
        const L = I[Y];
        e.slidesEl.prepend(o(D[L], L));
      }
    else
      I.sort((Y, L) => L - Y), I.forEach((Y) => {
        e.slidesEl.prepend(o(D[Y], Y));
      });
    dt(e.slidesEl, ".swiper-slide, swiper-slide").forEach((Y) => {
      Y.style[E] = `${W - Math.abs(e.cssOverflowAdjustment())}px`;
    }), j();
  }
  function c(m) {
    if (typeof m == "object" && "length" in m)
      for (let d = 0; d < m.length; d += 1)
        m[d] && e.virtual.slides.push(m[d]);
    else
      e.virtual.slides.push(m);
    u(!0);
  }
  function f(m) {
    const d = e.activeIndex;
    let w = d + 1, b = 1;
    if (Array.isArray(m)) {
      for (let O = 0; O < m.length; O += 1)
        m[O] && e.virtual.slides.unshift(m[O]);
      w = d + m.length, b = m.length;
    } else
      e.virtual.slides.unshift(m);
    if (e.params.virtual.cache) {
      const O = e.virtual.cache, S = {};
      Object.keys(O).forEach((B) => {
        const T = O[B], A = T.getAttribute("data-swiper-slide-index");
        A && T.setAttribute("data-swiper-slide-index", parseInt(A, 10) + b), S[parseInt(B, 10) + b] = T;
      }), e.virtual.cache = S;
    }
    u(!0), e.slideTo(w, 0);
  }
  function p(m) {
    if (typeof m > "u" || m === null)
      return;
    let d = e.activeIndex;
    if (Array.isArray(m))
      for (let w = m.length - 1; w >= 0; w -= 1)
        e.params.virtual.cache && (delete e.virtual.cache[m[w]], Object.keys(e.virtual.cache).forEach((b) => {
          b > m && (e.virtual.cache[b - 1] = e.virtual.cache[b], e.virtual.cache[b - 1].setAttribute("data-swiper-slide-index", b - 1), delete e.virtual.cache[b]);
        })), e.virtual.slides.splice(m[w], 1), m[w] < d && (d -= 1), d = Math.max(d, 0);
    else
      e.params.virtual.cache && (delete e.virtual.cache[m], Object.keys(e.virtual.cache).forEach((w) => {
        w > m && (e.virtual.cache[w - 1] = e.virtual.cache[w], e.virtual.cache[w - 1].setAttribute("data-swiper-slide-index", w - 1), delete e.virtual.cache[w]);
      })), e.virtual.slides.splice(m, 1), m < d && (d -= 1), d = Math.max(d, 0);
    u(!0), e.slideTo(d, 0);
  }
  function g() {
    e.virtual.slides = [], e.params.virtual.cache && (e.virtual.cache = {}), u(!0), e.slideTo(0, 0);
  }
  n("beforeInit", () => {
    if (!e.params.virtual.enabled)
      return;
    let m;
    if (typeof e.passedParams.virtual.slides > "u") {
      const d = [...e.slidesEl.children].filter((w) => w.matches(`.${e.params.slideClass}, swiper-slide`));
      d && d.length && (e.virtual.slides = [...d], m = !0, d.forEach((w, b) => {
        w.setAttribute("data-swiper-slide-index", b), e.virtual.cache[b] = w, w.remove();
      }));
    }
    m || (e.virtual.slides = e.params.virtual.slides), e.classNames.push(`${e.params.containerModifierClass}virtual`), e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0, u();
  }), n("setTranslate", () => {
    e.params.virtual.enabled && (e.params.cssMode && !e._immediateVirtual ? (clearTimeout(i), i = setTimeout(() => {
      u();
    }, 100)) : u());
  }), n("init update resize", () => {
    e.params.virtual.enabled && e.params.cssMode && Ka(e.wrapperEl, "--swiper-virtual-size", `${e.virtualSize}px`);
  }), Object.assign(e.virtual, {
    appendSlide: c,
    prependSlide: f,
    removeSlide: p,
    removeAllSlides: g,
    update: u
  });
}
function YU(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n,
    emit: a
  } = t;
  const i = Et(), s = Qe();
  e.keyboard = {
    enabled: !1
  }, r({
    keyboard: {
      enabled: !1,
      onlyInViewport: !0,
      pageUpDown: !0
    }
  });
  function l(c) {
    if (!e.enabled)
      return;
    const {
      rtlTranslate: f
    } = e;
    let p = c;
    p.originalEvent && (p = p.originalEvent);
    const g = p.keyCode || p.charCode, m = e.params.keyboard.pageUpDown, d = m && g === 33, w = m && g === 34, b = g === 37, O = g === 39, S = g === 38, B = g === 40;
    if (!e.allowSlideNext && (e.isHorizontal() && O || e.isVertical() && B || w) || !e.allowSlidePrev && (e.isHorizontal() && b || e.isVertical() && S || d))
      return !1;
    if (!(p.shiftKey || p.altKey || p.ctrlKey || p.metaKey) && !(i.activeElement && i.activeElement.nodeName && (i.activeElement.nodeName.toLowerCase() === "input" || i.activeElement.nodeName.toLowerCase() === "textarea"))) {
      if (e.params.keyboard.onlyInViewport && (d || w || b || O || S || B)) {
        let T = !1;
        if (un(e.el, `.${e.params.slideClass}, swiper-slide`).length > 0 && un(e.el, `.${e.params.slideActiveClass}`).length === 0)
          return;
        const A = e.el, D = A.clientWidth, h = A.clientHeight, y = s.innerWidth, v = s.innerHeight, E = js(A);
        f && (E.left -= A.scrollLeft);
        const _ = [[E.left, E.top], [E.left + D, E.top], [E.left, E.top + h], [E.left + D, E.top + h]];
        for (let C = 0; C < _.length; C += 1) {
          const P = _[C];
          if (P[0] >= 0 && P[0] <= y && P[1] >= 0 && P[1] <= v) {
            if (P[0] === 0 && P[1] === 0)
              continue;
            T = !0;
          }
        }
        if (!T)
          return;
      }
      e.isHorizontal() ? ((d || w || b || O) && (p.preventDefault ? p.preventDefault() : p.returnValue = !1), ((w || O) && !f || (d || b) && f) && e.slideNext(), ((d || b) && !f || (w || O) && f) && e.slidePrev()) : ((d || w || S || B) && (p.preventDefault ? p.preventDefault() : p.returnValue = !1), (w || B) && e.slideNext(), (d || S) && e.slidePrev()), a("keyPress", g);
    }
  }
  function o() {
    e.keyboard.enabled || (i.addEventListener("keydown", l), e.keyboard.enabled = !0);
  }
  function u() {
    e.keyboard.enabled && (i.removeEventListener("keydown", l), e.keyboard.enabled = !1);
  }
  n("init", () => {
    e.params.keyboard.enabled && o();
  }), n("destroy", () => {
    e.keyboard.enabled && u();
  }), Object.assign(e.keyboard, {
    enable: o,
    disable: u
  });
}
function KU(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n,
    emit: a
  } = t;
  const i = Qe();
  r({
    mousewheel: {
      enabled: !1,
      releaseOnEdges: !1,
      invert: !1,
      forceToAxis: !1,
      sensitivity: 1,
      eventsTarget: "container",
      thresholdDelta: null,
      thresholdTime: null,
      noMousewheelClass: "swiper-no-mousewheel"
    }
  }), e.mousewheel = {
    enabled: !1
  };
  let s, l = zt(), o;
  const u = [];
  function c(S) {
    let D = 0, h = 0, y = 0, v = 0;
    return "detail" in S && (h = S.detail), "wheelDelta" in S && (h = -S.wheelDelta / 120), "wheelDeltaY" in S && (h = -S.wheelDeltaY / 120), "wheelDeltaX" in S && (D = -S.wheelDeltaX / 120), "axis" in S && S.axis === S.HORIZONTAL_AXIS && (D = h, h = 0), y = D * 10, v = h * 10, "deltaY" in S && (v = S.deltaY), "deltaX" in S && (y = S.deltaX), S.shiftKey && !y && (y = v, v = 0), (y || v) && S.deltaMode && (S.deltaMode === 1 ? (y *= 40, v *= 40) : (y *= 800, v *= 800)), y && !D && (D = y < 1 ? -1 : 1), v && !h && (h = v < 1 ? -1 : 1), {
      spinX: D,
      spinY: h,
      pixelX: y,
      pixelY: v
    };
  }
  function f() {
    e.enabled && (e.mouseEntered = !0);
  }
  function p() {
    e.enabled && (e.mouseEntered = !1);
  }
  function g(S) {
    return e.params.mousewheel.thresholdDelta && S.delta < e.params.mousewheel.thresholdDelta || e.params.mousewheel.thresholdTime && zt() - l < e.params.mousewheel.thresholdTime ? !1 : S.delta >= 6 && zt() - l < 60 ? !0 : (S.direction < 0 ? (!e.isEnd || e.params.loop) && !e.animating && (e.slideNext(), a("scroll", S.raw)) : (!e.isBeginning || e.params.loop) && !e.animating && (e.slidePrev(), a("scroll", S.raw)), l = new i.Date().getTime(), !1);
  }
  function m(S) {
    const B = e.params.mousewheel;
    if (S.direction < 0) {
      if (e.isEnd && !e.params.loop && B.releaseOnEdges)
        return !0;
    } else if (e.isBeginning && !e.params.loop && B.releaseOnEdges)
      return !0;
    return !1;
  }
  function d(S) {
    let B = S, T = !0;
    if (!e.enabled || S.target.closest(`.${e.params.mousewheel.noMousewheelClass}`))
      return;
    const A = e.params.mousewheel;
    e.params.cssMode && B.preventDefault();
    let D = e.el;
    e.params.mousewheel.eventsTarget !== "container" && (D = document.querySelector(e.params.mousewheel.eventsTarget));
    const h = D && D.contains(B.target);
    if (!e.mouseEntered && !h && !A.releaseOnEdges)
      return !0;
    B.originalEvent && (B = B.originalEvent);
    let y = 0;
    const v = e.rtlTranslate ? -1 : 1, E = c(B);
    if (A.forceToAxis)
      if (e.isHorizontal())
        if (Math.abs(E.pixelX) > Math.abs(E.pixelY))
          y = -E.pixelX * v;
        else
          return !0;
      else if (Math.abs(E.pixelY) > Math.abs(E.pixelX))
        y = -E.pixelY;
      else
        return !0;
    else
      y = Math.abs(E.pixelX) > Math.abs(E.pixelY) ? -E.pixelX * v : -E.pixelY;
    if (y === 0)
      return !0;
    A.invert && (y = -y);
    let _ = e.getTranslate() + y * A.sensitivity;
    if (_ >= e.minTranslate() && (_ = e.minTranslate()), _ <= e.maxTranslate() && (_ = e.maxTranslate()), T = e.params.loop ? !0 : !(_ === e.minTranslate() || _ === e.maxTranslate()), T && e.params.nested && B.stopPropagation(), !e.params.freeMode || !e.params.freeMode.enabled) {
      const C = {
        time: zt(),
        delta: Math.abs(y),
        direction: Math.sign(y),
        raw: S
      };
      u.length >= 2 && u.shift();
      const P = u.length ? u[u.length - 1] : void 0;
      if (u.push(C), P ? (C.direction !== P.direction || C.delta > P.delta || C.time > P.time + 150) && g(C) : g(C), m(C))
        return !0;
    } else {
      const C = {
        time: zt(),
        delta: Math.abs(y),
        direction: Math.sign(y)
      }, P = o && C.time < o.time + 500 && C.delta <= o.delta && C.direction === o.direction;
      if (!P) {
        o = void 0;
        let $ = e.getTranslate() + y * A.sensitivity;
        const W = e.isBeginning, j = e.isEnd;
        if ($ >= e.minTranslate() && ($ = e.minTranslate()), $ <= e.maxTranslate() && ($ = e.maxTranslate()), e.setTransition(0), e.setTranslate($), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses(), (!W && e.isBeginning || !j && e.isEnd) && e.updateSlidesClasses(), e.params.loop && e.loopFix({
          direction: C.direction < 0 ? "next" : "prev",
          byMousewheel: !0
        }), e.params.freeMode.sticky) {
          clearTimeout(s), s = void 0, u.length >= 15 && u.shift();
          const I = u.length ? u[u.length - 1] : void 0, F = u[0];
          if (u.push(C), I && (C.delta > I.delta || C.direction !== I.direction))
            u.splice(0);
          else if (u.length >= 15 && C.time - F.time < 500 && F.delta - C.delta >= 1 && C.delta <= 6) {
            const k = y > 0 ? 0.8 : 0.2;
            o = C, u.splice(0), s = vn(() => {
              e.slideToClosest(e.params.speed, !0, void 0, k);
            }, 0);
          }
          s || (s = vn(() => {
            o = C, u.splice(0), e.slideToClosest(e.params.speed, !0, void 0, 0.5);
          }, 500));
        }
        if (P || a("scroll", B), e.params.autoplay && e.params.autoplayDisableOnInteraction && e.autoplay.stop(), A.releaseOnEdges && ($ === e.minTranslate() || $ === e.maxTranslate()))
          return !0;
      }
    }
    return B.preventDefault ? B.preventDefault() : B.returnValue = !1, !1;
  }
  function w(S) {
    let B = e.el;
    e.params.mousewheel.eventsTarget !== "container" && (B = document.querySelector(e.params.mousewheel.eventsTarget)), B[S]("mouseenter", f), B[S]("mouseleave", p), B[S]("wheel", d);
  }
  function b() {
    return e.params.cssMode ? (e.wrapperEl.removeEventListener("wheel", d), !0) : e.mousewheel.enabled ? !1 : (w("addEventListener"), e.mousewheel.enabled = !0, !0);
  }
  function O() {
    return e.params.cssMode ? (e.wrapperEl.addEventListener(event, d), !0) : e.mousewheel.enabled ? (w("removeEventListener"), e.mousewheel.enabled = !1, !0) : !1;
  }
  n("init", () => {
    !e.params.mousewheel.enabled && e.params.cssMode && O(), e.params.mousewheel.enabled && b();
  }), n("destroy", () => {
    e.params.cssMode && b(), e.mousewheel.enabled && O();
  }), Object.assign(e.mousewheel, {
    enable: b,
    disable: O
  });
}
function df(t, e, r, n) {
  return t.params.createElements && Object.keys(n).forEach((a) => {
    if (!r[a] && r.auto === !0) {
      let i = dt(t.el, `.${n[a]}`)[0];
      i || (i = $t("div", n[a]), i.className = n[a], t.el.append(i)), r[a] = i, e[a] = i;
    }
  }), r;
}
function XU(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n,
    emit: a
  } = t;
  r({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), e.navigation = {
    nextEl: null,
    prevEl: null
  };
  function i(m) {
    let d;
    return m && typeof m == "string" && e.isElement && (d = e.el.querySelector(m), d) ? d : (m && (typeof m == "string" && (d = [...document.querySelectorAll(m)]), e.params.uniqueNavElements && typeof m == "string" && d.length > 1 && e.el.querySelectorAll(m).length === 1 && (d = e.el.querySelector(m))), m && !d ? m : d);
  }
  function s(m, d) {
    const w = e.params.navigation;
    m = Oe(m), m.forEach((b) => {
      b && (b.classList[d ? "add" : "remove"](...w.disabledClass.split(" ")), b.tagName === "BUTTON" && (b.disabled = d), e.params.watchOverflow && e.enabled && b.classList[e.isLocked ? "add" : "remove"](w.lockClass));
    });
  }
  function l() {
    const {
      nextEl: m,
      prevEl: d
    } = e.navigation;
    if (e.params.loop) {
      s(d, !1), s(m, !1);
      return;
    }
    s(d, e.isBeginning && !e.params.rewind), s(m, e.isEnd && !e.params.rewind);
  }
  function o(m) {
    m.preventDefault(), !(e.isBeginning && !e.params.loop && !e.params.rewind) && (e.slidePrev(), a("navigationPrev"));
  }
  function u(m) {
    m.preventDefault(), !(e.isEnd && !e.params.loop && !e.params.rewind) && (e.slideNext(), a("navigationNext"));
  }
  function c() {
    const m = e.params.navigation;
    if (e.params.navigation = df(e, e.originalParams.navigation, e.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(m.nextEl || m.prevEl))
      return;
    let d = i(m.nextEl), w = i(m.prevEl);
    Object.assign(e.navigation, {
      nextEl: d,
      prevEl: w
    }), d = Oe(d), w = Oe(w);
    const b = (O, S) => {
      O && O.addEventListener("click", S === "next" ? u : o), !e.enabled && O && O.classList.add(...m.lockClass.split(" "));
    };
    d.forEach((O) => b(O, "next")), w.forEach((O) => b(O, "prev"));
  }
  function f() {
    let {
      nextEl: m,
      prevEl: d
    } = e.navigation;
    m = Oe(m), d = Oe(d);
    const w = (b, O) => {
      b.removeEventListener("click", O === "next" ? u : o), b.classList.remove(...e.params.navigation.disabledClass.split(" "));
    };
    m.forEach((b) => w(b, "next")), d.forEach((b) => w(b, "prev"));
  }
  n("init", () => {
    e.params.navigation.enabled === !1 ? g() : (c(), l());
  }), n("toEdge fromEdge lock unlock", () => {
    l();
  }), n("destroy", () => {
    f();
  }), n("enable disable", () => {
    let {
      nextEl: m,
      prevEl: d
    } = e.navigation;
    if (m = Oe(m), d = Oe(d), e.enabled) {
      l();
      return;
    }
    [...m, ...d].filter((w) => !!w).forEach((w) => w.classList.add(e.params.navigation.lockClass));
  }), n("click", (m, d) => {
    let {
      nextEl: w,
      prevEl: b
    } = e.navigation;
    w = Oe(w), b = Oe(b);
    const O = d.target;
    if (e.params.navigation.hideOnClick && !b.includes(O) && !w.includes(O)) {
      if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === O || e.pagination.el.contains(O)))
        return;
      let S;
      w.length ? S = w[0].classList.contains(e.params.navigation.hiddenClass) : b.length && (S = b[0].classList.contains(e.params.navigation.hiddenClass)), a(S === !0 ? "navigationShow" : "navigationHide"), [...w, ...b].filter((B) => !!B).forEach((B) => B.classList.toggle(e.params.navigation.hiddenClass));
    }
  });
  const p = () => {
    e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")), c(), l();
  }, g = () => {
    e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")), f();
  };
  Object.assign(e.navigation, {
    enable: p,
    disable: g,
    update: l,
    init: c,
    destroy: f
  });
}
function Er(t) {
  return t === void 0 && (t = ""), `.${t.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function ZU(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n,
    emit: a
  } = t;
  const i = "swiper-pagination";
  r({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (b) => b,
      formatFractionTotal: (b) => b,
      bulletClass: `${i}-bullet`,
      bulletActiveClass: `${i}-bullet-active`,
      modifierClass: `${i}-`,
      currentClass: `${i}-current`,
      totalClass: `${i}-total`,
      hiddenClass: `${i}-hidden`,
      progressbarFillClass: `${i}-progressbar-fill`,
      progressbarOppositeClass: `${i}-progressbar-opposite`,
      clickableClass: `${i}-clickable`,
      lockClass: `${i}-lock`,
      horizontalClass: `${i}-horizontal`,
      verticalClass: `${i}-vertical`,
      paginationDisabledClass: `${i}-disabled`
    }
  }), e.pagination = {
    el: null,
    bullets: []
  };
  let s, l = 0;
  function o() {
    return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && e.pagination.el.length === 0;
  }
  function u(b, O) {
    const {
      bulletActiveClass: S
    } = e.params.pagination;
    b && (b = b[`${O === "prev" ? "previous" : "next"}ElementSibling`], b && (b.classList.add(`${S}-${O}`), b = b[`${O === "prev" ? "previous" : "next"}ElementSibling`], b && b.classList.add(`${S}-${O}-${O}`)));
  }
  function c(b) {
    const O = b.target.closest(Er(e.params.pagination.bulletClass));
    if (!O)
      return;
    b.preventDefault();
    const S = bi(O) * e.params.slidesPerGroup;
    if (e.params.loop) {
      if (e.realIndex === S)
        return;
      e.slideToLoop(S);
    } else
      e.slideTo(S);
  }
  function f() {
    const b = e.rtl, O = e.params.pagination;
    if (o())
      return;
    let S = e.pagination.el;
    S = Oe(S);
    let B, T;
    const A = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, D = e.params.loop ? Math.ceil(A / e.params.slidesPerGroup) : e.snapGrid.length;
    if (e.params.loop ? (T = e.previousRealIndex || 0, B = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex) : typeof e.snapIndex < "u" ? (B = e.snapIndex, T = e.previousSnapIndex) : (T = e.previousIndex || 0, B = e.activeIndex || 0), O.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
      const h = e.pagination.bullets;
      let y, v, E;
      if (O.dynamicBullets && (s = vu(h[0], e.isHorizontal() ? "width" : "height", !0), S.forEach((_) => {
        _.style[e.isHorizontal() ? "width" : "height"] = `${s * (O.dynamicMainBullets + 4)}px`;
      }), O.dynamicMainBullets > 1 && T !== void 0 && (l += B - (T || 0), l > O.dynamicMainBullets - 1 ? l = O.dynamicMainBullets - 1 : l < 0 && (l = 0)), y = Math.max(B - l, 0), v = y + (Math.min(h.length, O.dynamicMainBullets) - 1), E = (v + y) / 2), h.forEach((_) => {
        const C = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((P) => `${O.bulletActiveClass}${P}`)].map((P) => typeof P == "string" && P.includes(" ") ? P.split(" ") : P).flat();
        _.classList.remove(...C);
      }), S.length > 1)
        h.forEach((_) => {
          const C = bi(_);
          C === B ? _.classList.add(...O.bulletActiveClass.split(" ")) : e.isElement && _.setAttribute("part", "bullet"), O.dynamicBullets && (C >= y && C <= v && _.classList.add(...`${O.bulletActiveClass}-main`.split(" ")), C === y && u(_, "prev"), C === v && u(_, "next"));
        });
      else {
        const _ = h[B];
        if (_ && _.classList.add(...O.bulletActiveClass.split(" ")), e.isElement && h.forEach((C, P) => {
          C.setAttribute("part", P === B ? "bullet-active" : "bullet");
        }), O.dynamicBullets) {
          const C = h[y], P = h[v];
          for (let $ = y; $ <= v; $ += 1)
            h[$] && h[$].classList.add(...`${O.bulletActiveClass}-main`.split(" "));
          u(C, "prev"), u(P, "next");
        }
      }
      if (O.dynamicBullets) {
        const _ = Math.min(h.length, O.dynamicMainBullets + 4), C = (s * _ - s) / 2 - E * s, P = b ? "right" : "left";
        h.forEach(($) => {
          $.style[e.isHorizontal() ? P : "top"] = `${C}px`;
        });
      }
    }
    S.forEach((h, y) => {
      if (O.type === "fraction" && (h.querySelectorAll(Er(O.currentClass)).forEach((v) => {
        v.textContent = O.formatFractionCurrent(B + 1);
      }), h.querySelectorAll(Er(O.totalClass)).forEach((v) => {
        v.textContent = O.formatFractionTotal(D);
      })), O.type === "progressbar") {
        let v;
        O.progressbarOpposite ? v = e.isHorizontal() ? "vertical" : "horizontal" : v = e.isHorizontal() ? "horizontal" : "vertical";
        const E = (B + 1) / D;
        let _ = 1, C = 1;
        v === "horizontal" ? _ = E : C = E, h.querySelectorAll(Er(O.progressbarFillClass)).forEach((P) => {
          P.style.transform = `translate3d(0,0,0) scaleX(${_}) scaleY(${C})`, P.style.transitionDuration = `${e.params.speed}ms`;
        });
      }
      O.type === "custom" && O.renderCustom ? (h.innerHTML = O.renderCustom(e, B + 1, D), y === 0 && a("paginationRender", h)) : (y === 0 && a("paginationRender", h), a("paginationUpdate", h)), e.params.watchOverflow && e.enabled && h.classList[e.isLocked ? "add" : "remove"](O.lockClass);
    });
  }
  function p() {
    const b = e.params.pagination;
    if (o())
      return;
    const O = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.grid && e.params.grid.rows > 1 ? e.slides.length / Math.ceil(e.params.grid.rows) : e.slides.length;
    let S = e.pagination.el;
    S = Oe(S);
    let B = "";
    if (b.type === "bullets") {
      let T = e.params.loop ? Math.ceil(O / e.params.slidesPerGroup) : e.snapGrid.length;
      e.params.freeMode && e.params.freeMode.enabled && T > O && (T = O);
      for (let A = 0; A < T; A += 1)
        b.renderBullet ? B += b.renderBullet.call(e, A, b.bulletClass) : B += `<${b.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${b.bulletClass}"></${b.bulletElement}>`;
    }
    b.type === "fraction" && (b.renderFraction ? B = b.renderFraction.call(e, b.currentClass, b.totalClass) : B = `<span class="${b.currentClass}"></span> / <span class="${b.totalClass}"></span>`), b.type === "progressbar" && (b.renderProgressbar ? B = b.renderProgressbar.call(e, b.progressbarFillClass) : B = `<span class="${b.progressbarFillClass}"></span>`), e.pagination.bullets = [], S.forEach((T) => {
      b.type !== "custom" && (T.innerHTML = B || ""), b.type === "bullets" && e.pagination.bullets.push(...T.querySelectorAll(Er(b.bulletClass)));
    }), b.type !== "custom" && a("paginationRender", S[0]);
  }
  function g() {
    e.params.pagination = df(e, e.originalParams.pagination, e.params.pagination, {
      el: "swiper-pagination"
    });
    const b = e.params.pagination;
    if (!b.el)
      return;
    let O;
    typeof b.el == "string" && e.isElement && (O = e.el.querySelector(b.el)), !O && typeof b.el == "string" && (O = [...document.querySelectorAll(b.el)]), O || (O = b.el), !(!O || O.length === 0) && (e.params.uniqueNavElements && typeof b.el == "string" && Array.isArray(O) && O.length > 1 && (O = [...e.el.querySelectorAll(b.el)], O.length > 1 && (O = O.filter((S) => un(S, ".swiper")[0] === e.el)[0])), Array.isArray(O) && O.length === 1 && (O = O[0]), Object.assign(e.pagination, {
      el: O
    }), O = Oe(O), O.forEach((S) => {
      b.type === "bullets" && b.clickable && S.classList.add(...(b.clickableClass || "").split(" ")), S.classList.add(b.modifierClass + b.type), S.classList.add(e.isHorizontal() ? b.horizontalClass : b.verticalClass), b.type === "bullets" && b.dynamicBullets && (S.classList.add(`${b.modifierClass}${b.type}-dynamic`), l = 0, b.dynamicMainBullets < 1 && (b.dynamicMainBullets = 1)), b.type === "progressbar" && b.progressbarOpposite && S.classList.add(b.progressbarOppositeClass), b.clickable && S.addEventListener("click", c), e.enabled || S.classList.add(b.lockClass);
    }));
  }
  function m() {
    const b = e.params.pagination;
    if (o())
      return;
    let O = e.pagination.el;
    O && (O = Oe(O), O.forEach((S) => {
      S.classList.remove(b.hiddenClass), S.classList.remove(b.modifierClass + b.type), S.classList.remove(e.isHorizontal() ? b.horizontalClass : b.verticalClass), b.clickable && (S.classList.remove(...(b.clickableClass || "").split(" ")), S.removeEventListener("click", c));
    })), e.pagination.bullets && e.pagination.bullets.forEach((S) => S.classList.remove(...b.bulletActiveClass.split(" ")));
  }
  n("changeDirection", () => {
    if (!e.pagination || !e.pagination.el)
      return;
    const b = e.params.pagination;
    let {
      el: O
    } = e.pagination;
    O = Oe(O), O.forEach((S) => {
      S.classList.remove(b.horizontalClass, b.verticalClass), S.classList.add(e.isHorizontal() ? b.horizontalClass : b.verticalClass);
    });
  }), n("init", () => {
    e.params.pagination.enabled === !1 ? w() : (g(), p(), f());
  }), n("activeIndexChange", () => {
    typeof e.snapIndex > "u" && f();
  }), n("snapIndexChange", () => {
    f();
  }), n("snapGridLengthChange", () => {
    p(), f();
  }), n("destroy", () => {
    m();
  }), n("enable disable", () => {
    let {
      el: b
    } = e.pagination;
    b && (b = Oe(b), b.forEach((O) => O.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)));
  }), n("lock unlock", () => {
    f();
  }), n("click", (b, O) => {
    const S = O.target, B = Oe(e.pagination.el);
    if (e.params.pagination.el && e.params.pagination.hideOnClick && B && B.length > 0 && !S.classList.contains(e.params.pagination.bulletClass)) {
      if (e.navigation && (e.navigation.nextEl && S === e.navigation.nextEl || e.navigation.prevEl && S === e.navigation.prevEl))
        return;
      const T = B[0].classList.contains(e.params.pagination.hiddenClass);
      a(T === !0 ? "paginationShow" : "paginationHide"), B.forEach((A) => A.classList.toggle(e.params.pagination.hiddenClass));
    }
  });
  const d = () => {
    e.el.classList.remove(e.params.pagination.paginationDisabledClass);
    let {
      el: b
    } = e.pagination;
    b && (b = Oe(b), b.forEach((O) => O.classList.remove(e.params.pagination.paginationDisabledClass))), g(), p(), f();
  }, w = () => {
    e.el.classList.add(e.params.pagination.paginationDisabledClass);
    let {
      el: b
    } = e.pagination;
    b && (b = Oe(b), b.forEach((O) => O.classList.add(e.params.pagination.paginationDisabledClass))), m();
  };
  Object.assign(e.pagination, {
    enable: d,
    disable: w,
    render: p,
    update: f,
    init: g,
    destroy: m
  });
}
function JU(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n,
    emit: a
  } = t;
  const i = Et();
  let s = !1, l = null, o = null, u, c, f, p;
  r({
    scrollbar: {
      el: null,
      dragSize: "auto",
      hide: !1,
      draggable: !1,
      snapOnRelease: !0,
      lockClass: "swiper-scrollbar-lock",
      dragClass: "swiper-scrollbar-drag",
      scrollbarDisabledClass: "swiper-scrollbar-disabled",
      horizontalClass: "swiper-scrollbar-horizontal",
      verticalClass: "swiper-scrollbar-vertical"
    }
  }), e.scrollbar = {
    el: null,
    dragEl: null
  };
  function g() {
    if (!e.params.scrollbar.el || !e.scrollbar.el)
      return;
    const {
      scrollbar: _,
      rtlTranslate: C
    } = e, {
      dragEl: P,
      el: $
    } = _, W = e.params.scrollbar, j = e.params.loop ? e.progressLoop : e.progress;
    let I = c, F = (f - c) * j;
    C ? (F = -F, F > 0 ? (I = c - F, F = 0) : -F + c > f && (I = f + F)) : F < 0 ? (I = c + F, F = 0) : F + c > f && (I = f - F), e.isHorizontal() ? (P.style.transform = `translate3d(${F}px, 0, 0)`, P.style.width = `${I}px`) : (P.style.transform = `translate3d(0px, ${F}px, 0)`, P.style.height = `${I}px`), W.hide && (clearTimeout(l), $.style.opacity = 1, l = setTimeout(() => {
      $.style.opacity = 0, $.style.transitionDuration = "400ms";
    }, 1e3));
  }
  function m(_) {
    !e.params.scrollbar.el || !e.scrollbar.el || (e.scrollbar.dragEl.style.transitionDuration = `${_}ms`);
  }
  function d() {
    if (!e.params.scrollbar.el || !e.scrollbar.el)
      return;
    const {
      scrollbar: _
    } = e, {
      dragEl: C,
      el: P
    } = _;
    C.style.width = "", C.style.height = "", f = e.isHorizontal() ? P.offsetWidth : P.offsetHeight, p = e.size / (e.virtualSize + e.params.slidesOffsetBefore - (e.params.centeredSlides ? e.snapGrid[0] : 0)), e.params.scrollbar.dragSize === "auto" ? c = f * p : c = parseInt(e.params.scrollbar.dragSize, 10), e.isHorizontal() ? C.style.width = `${c}px` : C.style.height = `${c}px`, p >= 1 ? P.style.display = "none" : P.style.display = "", e.params.scrollbar.hide && (P.style.opacity = 0), e.params.watchOverflow && e.enabled && _.el.classList[e.isLocked ? "add" : "remove"](e.params.scrollbar.lockClass);
  }
  function w(_) {
    return e.isHorizontal() ? _.clientX : _.clientY;
  }
  function b(_) {
    const {
      scrollbar: C,
      rtlTranslate: P
    } = e, {
      el: $
    } = C;
    let W;
    W = (w(_) - js($)[e.isHorizontal() ? "left" : "top"] - (u !== null ? u : c / 2)) / (f - c), W = Math.max(Math.min(W, 1), 0), P && (W = 1 - W);
    const j = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * W;
    e.updateProgress(j), e.setTranslate(j), e.updateActiveIndex(), e.updateSlidesClasses();
  }
  function O(_) {
    const C = e.params.scrollbar, {
      scrollbar: P,
      wrapperEl: $
    } = e, {
      el: W,
      dragEl: j
    } = P;
    s = !0, u = _.target === j ? w(_) - _.target.getBoundingClientRect()[e.isHorizontal() ? "left" : "top"] : null, _.preventDefault(), _.stopPropagation(), $.style.transitionDuration = "100ms", j.style.transitionDuration = "100ms", b(_), clearTimeout(o), W.style.transitionDuration = "0ms", C.hide && (W.style.opacity = 1), e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "none"), a("scrollbarDragStart", _);
  }
  function S(_) {
    const {
      scrollbar: C,
      wrapperEl: P
    } = e, {
      el: $,
      dragEl: W
    } = C;
    s && (_.preventDefault ? _.preventDefault() : _.returnValue = !1, b(_), P.style.transitionDuration = "0ms", $.style.transitionDuration = "0ms", W.style.transitionDuration = "0ms", a("scrollbarDragMove", _));
  }
  function B(_) {
    const C = e.params.scrollbar, {
      scrollbar: P,
      wrapperEl: $
    } = e, {
      el: W
    } = P;
    s && (s = !1, e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "", $.style.transitionDuration = ""), C.hide && (clearTimeout(o), o = vn(() => {
      W.style.opacity = 0, W.style.transitionDuration = "400ms";
    }, 1e3)), a("scrollbarDragEnd", _), C.snapOnRelease && e.slideToClosest());
  }
  function T(_) {
    const {
      scrollbar: C,
      params: P
    } = e, $ = C.el;
    if (!$)
      return;
    const W = $, j = P.passiveListeners ? {
      passive: !1,
      capture: !1
    } : !1, I = P.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1;
    if (!W)
      return;
    const F = _ === "on" ? "addEventListener" : "removeEventListener";
    W[F]("pointerdown", O, j), i[F]("pointermove", S, j), i[F]("pointerup", B, I);
  }
  function A() {
    !e.params.scrollbar.el || !e.scrollbar.el || T("on");
  }
  function D() {
    !e.params.scrollbar.el || !e.scrollbar.el || T("off");
  }
  function h() {
    const {
      scrollbar: _,
      el: C
    } = e;
    e.params.scrollbar = df(e, e.originalParams.scrollbar, e.params.scrollbar, {
      el: "swiper-scrollbar"
    });
    const P = e.params.scrollbar;
    if (!P.el)
      return;
    let $;
    if (typeof P.el == "string" && e.isElement && ($ = e.el.querySelector(P.el)), !$ && typeof P.el == "string") {
      if ($ = i.querySelectorAll(P.el), !$.length)
        return;
    } else
      $ || ($ = P.el);
    e.params.uniqueNavElements && typeof P.el == "string" && $.length > 1 && C.querySelectorAll(P.el).length === 1 && ($ = C.querySelector(P.el)), $.length > 0 && ($ = $[0]), $.classList.add(e.isHorizontal() ? P.horizontalClass : P.verticalClass);
    let W;
    $ && (W = $.querySelector(Er(e.params.scrollbar.dragClass)), W || (W = $t("div", e.params.scrollbar.dragClass), $.append(W))), Object.assign(_, {
      el: $,
      dragEl: W
    }), P.draggable && A(), $ && $.classList[e.enabled ? "remove" : "add"](...Fr(e.params.scrollbar.lockClass));
  }
  function y() {
    const _ = e.params.scrollbar, C = e.scrollbar.el;
    C && C.classList.remove(...Fr(e.isHorizontal() ? _.horizontalClass : _.verticalClass)), D();
  }
  n("changeDirection", () => {
    if (!e.scrollbar || !e.scrollbar.el)
      return;
    const _ = e.params.scrollbar;
    let {
      el: C
    } = e.scrollbar;
    C = Oe(C), C.forEach((P) => {
      P.classList.remove(_.horizontalClass, _.verticalClass), P.classList.add(e.isHorizontal() ? _.horizontalClass : _.verticalClass);
    });
  }), n("init", () => {
    e.params.scrollbar.enabled === !1 ? E() : (h(), d(), g());
  }), n("update resize observerUpdate lock unlock changeDirection", () => {
    d();
  }), n("setTranslate", () => {
    g();
  }), n("setTransition", (_, C) => {
    m(C);
  }), n("enable disable", () => {
    const {
      el: _
    } = e.scrollbar;
    _ && _.classList[e.enabled ? "remove" : "add"](...Fr(e.params.scrollbar.lockClass));
  }), n("destroy", () => {
    y();
  });
  const v = () => {
    e.el.classList.remove(...Fr(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.remove(...Fr(e.params.scrollbar.scrollbarDisabledClass)), h(), d(), g();
  }, E = () => {
    e.el.classList.add(...Fr(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.add(...Fr(e.params.scrollbar.scrollbarDisabledClass)), y();
  };
  Object.assign(e.scrollbar, {
    enable: v,
    disable: E,
    updateSize: d,
    setTranslate: g,
    init: h,
    destroy: y
  });
}
function QU(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    parallax: {
      enabled: !1
    }
  });
  const a = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]", i = (o, u) => {
    const {
      rtl: c
    } = e, f = c ? -1 : 1, p = o.getAttribute("data-swiper-parallax") || "0";
    let g = o.getAttribute("data-swiper-parallax-x"), m = o.getAttribute("data-swiper-parallax-y");
    const d = o.getAttribute("data-swiper-parallax-scale"), w = o.getAttribute("data-swiper-parallax-opacity"), b = o.getAttribute("data-swiper-parallax-rotate");
    if (g || m ? (g = g || "0", m = m || "0") : e.isHorizontal() ? (g = p, m = "0") : (m = p, g = "0"), g.indexOf("%") >= 0 ? g = `${parseInt(g, 10) * u * f}%` : g = `${g * u * f}px`, m.indexOf("%") >= 0 ? m = `${parseInt(m, 10) * u}%` : m = `${m * u}px`, typeof w < "u" && w !== null) {
      const S = w - (w - 1) * (1 - Math.abs(u));
      o.style.opacity = S;
    }
    let O = `translate3d(${g}, ${m}, 0px)`;
    if (typeof d < "u" && d !== null) {
      const S = d - (d - 1) * (1 - Math.abs(u));
      O += ` scale(${S})`;
    }
    if (b && typeof b < "u" && b !== null) {
      const S = b * u * -1;
      O += ` rotate(${S}deg)`;
    }
    o.style.transform = O;
  }, s = () => {
    const {
      el: o,
      slides: u,
      progress: c,
      snapGrid: f,
      isElement: p
    } = e, g = dt(o, a);
    e.isElement && g.push(...dt(e.hostEl, a)), g.forEach((m) => {
      i(m, c);
    }), u.forEach((m, d) => {
      let w = m.progress;
      e.params.slidesPerGroup > 1 && e.params.slidesPerView !== "auto" && (w += Math.ceil(d / 2) - c * (f.length - 1)), w = Math.min(Math.max(w, -1), 1), m.querySelectorAll(`${a}, [data-swiper-parallax-rotate]`).forEach((b) => {
        i(b, w);
      });
    });
  }, l = function(o) {
    o === void 0 && (o = e.params.speed);
    const {
      el: u,
      hostEl: c
    } = e, f = [...u.querySelectorAll(a)];
    e.isElement && f.push(...c.querySelectorAll(a)), f.forEach((p) => {
      let g = parseInt(p.getAttribute("data-swiper-parallax-duration"), 10) || o;
      o === 0 && (g = 0), p.style.transitionDuration = `${g}ms`;
    });
  };
  n("beforeInit", () => {
    e.params.parallax.enabled && (e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0);
  }), n("init", () => {
    e.params.parallax.enabled && s();
  }), n("setTranslate", () => {
    e.params.parallax.enabled && s();
  }), n("setTransition", (o, u) => {
    e.params.parallax.enabled && l(u);
  });
}
function eV(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n,
    emit: a
  } = t;
  const i = Qe();
  r({
    zoom: {
      enabled: !1,
      maxRatio: 3,
      minRatio: 1,
      toggle: !0,
      containerClass: "swiper-zoom-container",
      zoomedSlideClass: "swiper-slide-zoomed"
    }
  }), e.zoom = {
    enabled: !1
  };
  let s = 1, l = !1, o, u;
  const c = [], f = {
    originX: 0,
    originY: 0,
    slideEl: void 0,
    slideWidth: void 0,
    slideHeight: void 0,
    imageEl: void 0,
    imageWrapEl: void 0,
    maxRatio: 3
  }, p = {
    isTouched: void 0,
    isMoved: void 0,
    currentX: void 0,
    currentY: void 0,
    minX: void 0,
    minY: void 0,
    maxX: void 0,
    maxY: void 0,
    width: void 0,
    height: void 0,
    startX: void 0,
    startY: void 0,
    touchesStart: {},
    touchesCurrent: {}
  }, g = {
    x: void 0,
    y: void 0,
    prevPositionX: void 0,
    prevPositionY: void 0,
    prevTime: void 0
  };
  let m = 1;
  Object.defineProperty(e.zoom, "scale", {
    get() {
      return m;
    },
    set(j) {
      if (m !== j) {
        const I = f.imageEl, F = f.slideEl;
        a("zoomChange", j, I, F);
      }
      m = j;
    }
  });
  function d() {
    if (c.length < 2)
      return 1;
    const j = c[0].pageX, I = c[0].pageY, F = c[1].pageX, k = c[1].pageY;
    return Math.sqrt((F - j) ** 2 + (k - I) ** 2);
  }
  function w() {
    if (c.length < 2)
      return {
        x: null,
        y: null
      };
    const j = f.imageEl.getBoundingClientRect();
    return [(c[0].pageX + (c[1].pageX - c[0].pageX) / 2 - j.x - i.scrollX) / s, (c[0].pageY + (c[1].pageY - c[0].pageY) / 2 - j.y - i.scrollY) / s];
  }
  function b() {
    return e.isElement ? "swiper-slide" : `.${e.params.slideClass}`;
  }
  function O(j) {
    const I = b();
    return !!(j.target.matches(I) || e.slides.filter((F) => F.contains(j.target)).length > 0);
  }
  function S(j) {
    const I = `.${e.params.zoom.containerClass}`;
    return !!(j.target.matches(I) || [...e.hostEl.querySelectorAll(I)].filter((F) => F.contains(j.target)).length > 0);
  }
  function B(j) {
    if (j.pointerType === "mouse" && c.splice(0, c.length), !O(j))
      return;
    const I = e.params.zoom;
    if (o = !1, u = !1, c.push(j), !(c.length < 2)) {
      if (o = !0, f.scaleStart = d(), !f.slideEl) {
        f.slideEl = j.target.closest(`.${e.params.slideClass}, swiper-slide`), f.slideEl || (f.slideEl = e.slides[e.activeIndex]);
        let F = f.slideEl.querySelector(`.${I.containerClass}`);
        if (F && (F = F.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), f.imageEl = F, F ? f.imageWrapEl = un(f.imageEl, `.${I.containerClass}`)[0] : f.imageWrapEl = void 0, !f.imageWrapEl) {
          f.imageEl = void 0;
          return;
        }
        f.maxRatio = f.imageWrapEl.getAttribute("data-swiper-zoom") || I.maxRatio;
      }
      if (f.imageEl) {
        const [F, k] = w();
        f.originX = F, f.originY = k, f.imageEl.style.transitionDuration = "0ms";
      }
      l = !0;
    }
  }
  function T(j) {
    if (!O(j))
      return;
    const I = e.params.zoom, F = e.zoom, k = c.findIndex((N) => N.pointerId === j.pointerId);
    k >= 0 && (c[k] = j), !(c.length < 2) && (u = !0, f.scaleMove = d(), f.imageEl && (F.scale = f.scaleMove / f.scaleStart * s, F.scale > f.maxRatio && (F.scale = f.maxRatio - 1 + (F.scale - f.maxRatio + 1) ** 0.5), F.scale < I.minRatio && (F.scale = I.minRatio + 1 - (I.minRatio - F.scale + 1) ** 0.5), f.imageEl.style.transform = `translate3d(0,0,0) scale(${F.scale})`));
  }
  function A(j) {
    if (!O(j) || j.pointerType === "mouse" && j.type === "pointerout")
      return;
    const I = e.params.zoom, F = e.zoom, k = c.findIndex((N) => N.pointerId === j.pointerId);
    k >= 0 && c.splice(k, 1), !(!o || !u) && (o = !1, u = !1, f.imageEl && (F.scale = Math.max(Math.min(F.scale, f.maxRatio), I.minRatio), f.imageEl.style.transitionDuration = `${e.params.speed}ms`, f.imageEl.style.transform = `translate3d(0,0,0) scale(${F.scale})`, s = F.scale, l = !1, F.scale > 1 && f.slideEl ? f.slideEl.classList.add(`${I.zoomedSlideClass}`) : F.scale <= 1 && f.slideEl && f.slideEl.classList.remove(`${I.zoomedSlideClass}`), F.scale === 1 && (f.originX = 0, f.originY = 0, f.slideEl = void 0)));
  }
  function D(j) {
    const I = e.device;
    if (!f.imageEl || p.isTouched)
      return;
    I.android && j.cancelable && j.preventDefault(), p.isTouched = !0;
    const F = c.length > 0 ? c[0] : j;
    p.touchesStart.x = F.pageX, p.touchesStart.y = F.pageY;
  }
  function h(j) {
    if (!O(j) || !S(j))
      return;
    const I = e.zoom;
    if (!f.imageEl || !p.isTouched || !f.slideEl)
      return;
    p.isMoved || (p.width = f.imageEl.offsetWidth, p.height = f.imageEl.offsetHeight, p.startX = gu(f.imageWrapEl, "x") || 0, p.startY = gu(f.imageWrapEl, "y") || 0, f.slideWidth = f.slideEl.offsetWidth, f.slideHeight = f.slideEl.offsetHeight, f.imageWrapEl.style.transitionDuration = "0ms");
    const F = p.width * I.scale, k = p.height * I.scale;
    if (F < f.slideWidth && k < f.slideHeight)
      return;
    if (p.minX = Math.min(f.slideWidth / 2 - F / 2, 0), p.maxX = -p.minX, p.minY = Math.min(f.slideHeight / 2 - k / 2, 0), p.maxY = -p.minY, p.touchesCurrent.x = c.length > 0 ? c[0].pageX : j.pageX, p.touchesCurrent.y = c.length > 0 ? c[0].pageY : j.pageY, Math.max(Math.abs(p.touchesCurrent.x - p.touchesStart.x), Math.abs(p.touchesCurrent.y - p.touchesStart.y)) > 5 && (e.allowClick = !1), !p.isMoved && !l) {
      if (e.isHorizontal() && (Math.floor(p.minX) === Math.floor(p.startX) && p.touchesCurrent.x < p.touchesStart.x || Math.floor(p.maxX) === Math.floor(p.startX) && p.touchesCurrent.x > p.touchesStart.x)) {
        p.isTouched = !1;
        return;
      }
      if (!e.isHorizontal() && (Math.floor(p.minY) === Math.floor(p.startY) && p.touchesCurrent.y < p.touchesStart.y || Math.floor(p.maxY) === Math.floor(p.startY) && p.touchesCurrent.y > p.touchesStart.y)) {
        p.isTouched = !1;
        return;
      }
    }
    j.cancelable && j.preventDefault(), j.stopPropagation(), p.isMoved = !0;
    const U = (I.scale - s) / (f.maxRatio - e.params.zoom.minRatio), {
      originX: Y,
      originY: L
    } = f;
    p.currentX = p.touchesCurrent.x - p.touchesStart.x + p.startX + U * (p.width - Y * 2), p.currentY = p.touchesCurrent.y - p.touchesStart.y + p.startY + U * (p.height - L * 2), p.currentX < p.minX && (p.currentX = p.minX + 1 - (p.minX - p.currentX + 1) ** 0.8), p.currentX > p.maxX && (p.currentX = p.maxX - 1 + (p.currentX - p.maxX + 1) ** 0.8), p.currentY < p.minY && (p.currentY = p.minY + 1 - (p.minY - p.currentY + 1) ** 0.8), p.currentY > p.maxY && (p.currentY = p.maxY - 1 + (p.currentY - p.maxY + 1) ** 0.8), g.prevPositionX || (g.prevPositionX = p.touchesCurrent.x), g.prevPositionY || (g.prevPositionY = p.touchesCurrent.y), g.prevTime || (g.prevTime = Date.now()), g.x = (p.touchesCurrent.x - g.prevPositionX) / (Date.now() - g.prevTime) / 2, g.y = (p.touchesCurrent.y - g.prevPositionY) / (Date.now() - g.prevTime) / 2, Math.abs(p.touchesCurrent.x - g.prevPositionX) < 2 && (g.x = 0), Math.abs(p.touchesCurrent.y - g.prevPositionY) < 2 && (g.y = 0), g.prevPositionX = p.touchesCurrent.x, g.prevPositionY = p.touchesCurrent.y, g.prevTime = Date.now(), f.imageWrapEl.style.transform = `translate3d(${p.currentX}px, ${p.currentY}px,0)`;
  }
  function y() {
    const j = e.zoom;
    if (!f.imageEl)
      return;
    if (!p.isTouched || !p.isMoved) {
      p.isTouched = !1, p.isMoved = !1;
      return;
    }
    p.isTouched = !1, p.isMoved = !1;
    let I = 300, F = 300;
    const k = g.x * I, N = p.currentX + k, U = g.y * F, Y = p.currentY + U;
    g.x !== 0 && (I = Math.abs((N - p.currentX) / g.x)), g.y !== 0 && (F = Math.abs((Y - p.currentY) / g.y));
    const L = Math.max(I, F);
    p.currentX = N, p.currentY = Y;
    const q = p.width * j.scale, V = p.height * j.scale;
    p.minX = Math.min(f.slideWidth / 2 - q / 2, 0), p.maxX = -p.minX, p.minY = Math.min(f.slideHeight / 2 - V / 2, 0), p.maxY = -p.minY, p.currentX = Math.max(Math.min(p.currentX, p.maxX), p.minX), p.currentY = Math.max(Math.min(p.currentY, p.maxY), p.minY), f.imageWrapEl.style.transitionDuration = `${L}ms`, f.imageWrapEl.style.transform = `translate3d(${p.currentX}px, ${p.currentY}px,0)`;
  }
  function v() {
    const j = e.zoom;
    f.slideEl && e.activeIndex !== e.slides.indexOf(f.slideEl) && (f.imageEl && (f.imageEl.style.transform = "translate3d(0,0,0) scale(1)"), f.imageWrapEl && (f.imageWrapEl.style.transform = "translate3d(0,0,0)"), f.slideEl.classList.remove(`${e.params.zoom.zoomedSlideClass}`), j.scale = 1, s = 1, f.slideEl = void 0, f.imageEl = void 0, f.imageWrapEl = void 0, f.originX = 0, f.originY = 0);
  }
  function E(j) {
    const I = e.zoom, F = e.params.zoom;
    if (!f.slideEl) {
      j && j.target && (f.slideEl = j.target.closest(`.${e.params.slideClass}, swiper-slide`)), f.slideEl || (e.params.virtual && e.params.virtual.enabled && e.virtual ? f.slideEl = dt(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : f.slideEl = e.slides[e.activeIndex]);
      let Ke = f.slideEl.querySelector(`.${F.containerClass}`);
      Ke && (Ke = Ke.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), f.imageEl = Ke, Ke ? f.imageWrapEl = un(f.imageEl, `.${F.containerClass}`)[0] : f.imageWrapEl = void 0;
    }
    if (!f.imageEl || !f.imageWrapEl)
      return;
    e.params.cssMode && (e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.touchAction = "none"), f.slideEl.classList.add(`${F.zoomedSlideClass}`);
    let k, N, U, Y, L, q, V, X, te, re, ue, pe, ye, Ce, be, Ie, Me, Ae;
    typeof p.touchesStart.x > "u" && j ? (k = j.pageX, N = j.pageY) : (k = p.touchesStart.x, N = p.touchesStart.y);
    const Be = typeof j == "number" ? j : null;
    s === 1 && Be && (k = void 0, N = void 0), I.scale = Be || f.imageWrapEl.getAttribute("data-swiper-zoom") || F.maxRatio, s = Be || f.imageWrapEl.getAttribute("data-swiper-zoom") || F.maxRatio, j && !(s === 1 && Be) ? (Me = f.slideEl.offsetWidth, Ae = f.slideEl.offsetHeight, U = js(f.slideEl).left + i.scrollX, Y = js(f.slideEl).top + i.scrollY, L = U + Me / 2 - k, q = Y + Ae / 2 - N, te = f.imageEl.offsetWidth, re = f.imageEl.offsetHeight, ue = te * I.scale, pe = re * I.scale, ye = Math.min(Me / 2 - ue / 2, 0), Ce = Math.min(Ae / 2 - pe / 2, 0), be = -ye, Ie = -Ce, V = L * I.scale, X = q * I.scale, V < ye && (V = ye), V > be && (V = be), X < Ce && (X = Ce), X > Ie && (X = Ie)) : (V = 0, X = 0), Be && I.scale === 1 && (f.originX = 0, f.originY = 0), f.imageWrapEl.style.transitionDuration = "300ms", f.imageWrapEl.style.transform = `translate3d(${V}px, ${X}px,0)`, f.imageEl.style.transitionDuration = "300ms", f.imageEl.style.transform = `translate3d(0,0,0) scale(${I.scale})`;
  }
  function _() {
    const j = e.zoom, I = e.params.zoom;
    if (!f.slideEl) {
      e.params.virtual && e.params.virtual.enabled && e.virtual ? f.slideEl = dt(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : f.slideEl = e.slides[e.activeIndex];
      let F = f.slideEl.querySelector(`.${I.containerClass}`);
      F && (F = F.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), f.imageEl = F, F ? f.imageWrapEl = un(f.imageEl, `.${I.containerClass}`)[0] : f.imageWrapEl = void 0;
    }
    !f.imageEl || !f.imageWrapEl || (e.params.cssMode && (e.wrapperEl.style.overflow = "", e.wrapperEl.style.touchAction = ""), j.scale = 1, s = 1, f.imageWrapEl.style.transitionDuration = "300ms", f.imageWrapEl.style.transform = "translate3d(0,0,0)", f.imageEl.style.transitionDuration = "300ms", f.imageEl.style.transform = "translate3d(0,0,0) scale(1)", f.slideEl.classList.remove(`${I.zoomedSlideClass}`), f.slideEl = void 0, f.originX = 0, f.originY = 0);
  }
  function C(j) {
    const I = e.zoom;
    I.scale && I.scale !== 1 ? _() : E(j);
  }
  function P() {
    const j = e.params.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1, I = e.params.passiveListeners ? {
      passive: !1,
      capture: !0
    } : !0;
    return {
      passiveListener: j,
      activeListenerWithCapture: I
    };
  }
  function $() {
    const j = e.zoom;
    if (j.enabled)
      return;
    j.enabled = !0;
    const {
      passiveListener: I,
      activeListenerWithCapture: F
    } = P();
    e.wrapperEl.addEventListener("pointerdown", B, I), e.wrapperEl.addEventListener("pointermove", T, F), ["pointerup", "pointercancel", "pointerout"].forEach((k) => {
      e.wrapperEl.addEventListener(k, A, I);
    }), e.wrapperEl.addEventListener("pointermove", h, F);
  }
  function W() {
    const j = e.zoom;
    if (!j.enabled)
      return;
    j.enabled = !1;
    const {
      passiveListener: I,
      activeListenerWithCapture: F
    } = P();
    e.wrapperEl.removeEventListener("pointerdown", B, I), e.wrapperEl.removeEventListener("pointermove", T, F), ["pointerup", "pointercancel", "pointerout"].forEach((k) => {
      e.wrapperEl.removeEventListener(k, A, I);
    }), e.wrapperEl.removeEventListener("pointermove", h, F);
  }
  n("init", () => {
    e.params.zoom.enabled && $();
  }), n("destroy", () => {
    W();
  }), n("touchStart", (j, I) => {
    e.zoom.enabled && D(I);
  }), n("touchEnd", (j, I) => {
    e.zoom.enabled && y();
  }), n("doubleTap", (j, I) => {
    !e.animating && e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && C(I);
  }), n("transitionEnd", () => {
    e.zoom.enabled && e.params.zoom.enabled && v();
  }), n("slideChange", () => {
    e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && v();
  }), Object.assign(e.zoom, {
    enable: $,
    disable: W,
    in: E,
    out: _,
    toggle: C
  });
}
function tV(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    controller: {
      control: void 0,
      inverse: !1,
      by: "slide"
      // or 'container'
    }
  }), e.controller = {
    control: void 0
  };
  function a(u, c) {
    const f = function() {
      let d, w, b;
      return (O, S) => {
        for (w = -1, d = O.length; d - w > 1; )
          b = d + w >> 1, O[b] <= S ? w = b : d = b;
        return d;
      };
    }();
    this.x = u, this.y = c, this.lastIndex = u.length - 1;
    let p, g;
    return this.interpolate = function(d) {
      return d ? (g = f(this.x, d), p = g - 1, (d - this.x[p]) * (this.y[g] - this.y[p]) / (this.x[g] - this.x[p]) + this.y[p]) : 0;
    }, this;
  }
  function i(u) {
    e.controller.spline = e.params.loop ? new a(e.slidesGrid, u.slidesGrid) : new a(e.snapGrid, u.snapGrid);
  }
  function s(u, c) {
    const f = e.controller.control;
    let p, g;
    const m = e.constructor;
    function d(w) {
      if (w.destroyed)
        return;
      const b = e.rtlTranslate ? -e.translate : e.translate;
      e.params.controller.by === "slide" && (i(w), g = -e.controller.spline.interpolate(-b)), (!g || e.params.controller.by === "container") && (p = (w.maxTranslate() - w.minTranslate()) / (e.maxTranslate() - e.minTranslate()), (Number.isNaN(p) || !Number.isFinite(p)) && (p = 1), g = (b - e.minTranslate()) * p + w.minTranslate()), e.params.controller.inverse && (g = w.maxTranslate() - g), w.updateProgress(g), w.setTranslate(g, e), w.updateActiveIndex(), w.updateSlidesClasses();
    }
    if (Array.isArray(f))
      for (let w = 0; w < f.length; w += 1)
        f[w] !== c && f[w] instanceof m && d(f[w]);
    else
      f instanceof m && c !== f && d(f);
  }
  function l(u, c) {
    const f = e.constructor, p = e.controller.control;
    let g;
    function m(d) {
      d.destroyed || (d.setTransition(u, e), u !== 0 && (d.transitionStart(), d.params.autoHeight && vn(() => {
        d.updateAutoHeight();
      }), ni(d.wrapperEl, () => {
        p && d.transitionEnd();
      })));
    }
    if (Array.isArray(p))
      for (g = 0; g < p.length; g += 1)
        p[g] !== c && p[g] instanceof f && m(p[g]);
    else
      p instanceof f && c !== p && m(p);
  }
  function o() {
    e.controller.control && e.controller.spline && (e.controller.spline = void 0, delete e.controller.spline);
  }
  n("beforeInit", () => {
    if (typeof window < "u" && // eslint-disable-line
    (typeof e.params.controller.control == "string" || e.params.controller.control instanceof HTMLElement)) {
      const u = document.querySelector(e.params.controller.control);
      if (u && u.swiper)
        e.controller.control = u.swiper;
      else if (u) {
        const c = (f) => {
          e.controller.control = f.detail[0], e.update(), u.removeEventListener("init", c);
        };
        u.addEventListener("init", c);
      }
      return;
    }
    e.controller.control = e.params.controller.control;
  }), n("update", () => {
    o();
  }), n("resize", () => {
    o();
  }), n("observerUpdate", () => {
    o();
  }), n("setTranslate", (u, c, f) => {
    !e.controller.control || e.controller.control.destroyed || e.controller.setTranslate(c, f);
  }), n("setTransition", (u, c, f) => {
    !e.controller.control || e.controller.control.destroyed || e.controller.setTransition(c, f);
  }), Object.assign(e.controller, {
    setTranslate: s,
    setTransition: l
  });
}
function rV(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    a11y: {
      enabled: !0,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null
    }
  }), e.a11y = {
    clicked: !1
  };
  let a = null;
  function i(C) {
    const P = a;
    P.length !== 0 && (P.innerHTML = "", P.innerHTML = C);
  }
  function s(C) {
    C === void 0 && (C = 16);
    const P = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(C).replace(/x/g, P);
  }
  function l(C) {
    C = Oe(C), C.forEach((P) => {
      P.setAttribute("tabIndex", "0");
    });
  }
  function o(C) {
    C = Oe(C), C.forEach((P) => {
      P.setAttribute("tabIndex", "-1");
    });
  }
  function u(C, P) {
    C = Oe(C), C.forEach(($) => {
      $.setAttribute("role", P);
    });
  }
  function c(C, P) {
    C = Oe(C), C.forEach(($) => {
      $.setAttribute("aria-roledescription", P);
    });
  }
  function f(C, P) {
    C = Oe(C), C.forEach(($) => {
      $.setAttribute("aria-controls", P);
    });
  }
  function p(C, P) {
    C = Oe(C), C.forEach(($) => {
      $.setAttribute("aria-label", P);
    });
  }
  function g(C, P) {
    C = Oe(C), C.forEach(($) => {
      $.setAttribute("id", P);
    });
  }
  function m(C, P) {
    C = Oe(C), C.forEach(($) => {
      $.setAttribute("aria-live", P);
    });
  }
  function d(C) {
    C = Oe(C), C.forEach((P) => {
      P.setAttribute("aria-disabled", !0);
    });
  }
  function w(C) {
    C = Oe(C), C.forEach((P) => {
      P.setAttribute("aria-disabled", !1);
    });
  }
  function b(C) {
    if (C.keyCode !== 13 && C.keyCode !== 32)
      return;
    const P = e.params.a11y, $ = C.target;
    e.pagination && e.pagination.el && ($ === e.pagination.el || e.pagination.el.contains(C.target)) && !C.target.matches(Er(e.params.pagination.bulletClass)) || (e.navigation && e.navigation.nextEl && $ === e.navigation.nextEl && (e.isEnd && !e.params.loop || e.slideNext(), e.isEnd ? i(P.lastSlideMessage) : i(P.nextSlideMessage)), e.navigation && e.navigation.prevEl && $ === e.navigation.prevEl && (e.isBeginning && !e.params.loop || e.slidePrev(), e.isBeginning ? i(P.firstSlideMessage) : i(P.prevSlideMessage)), e.pagination && $.matches(Er(e.params.pagination.bulletClass)) && $.click());
  }
  function O() {
    if (e.params.loop || e.params.rewind || !e.navigation)
      return;
    const {
      nextEl: C,
      prevEl: P
    } = e.navigation;
    P && (e.isBeginning ? (d(P), o(P)) : (w(P), l(P))), C && (e.isEnd ? (d(C), o(C)) : (w(C), l(C)));
  }
  function S() {
    return e.pagination && e.pagination.bullets && e.pagination.bullets.length;
  }
  function B() {
    return S() && e.params.pagination.clickable;
  }
  function T() {
    const C = e.params.a11y;
    S() && e.pagination.bullets.forEach((P) => {
      e.params.pagination.clickable && (l(P), e.params.pagination.renderBullet || (u(P, "button"), p(P, C.paginationBulletMessage.replace(/\{\{index\}\}/, bi(P) + 1)))), P.matches(Er(e.params.pagination.bulletActiveClass)) ? P.setAttribute("aria-current", "true") : P.removeAttribute("aria-current");
    });
  }
  const A = (C, P, $) => {
    l(C), C.tagName !== "BUTTON" && (u(C, "button"), C.addEventListener("keydown", b)), p(C, $), f(C, P);
  }, D = () => {
    e.a11y.clicked = !0;
  }, h = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        e.destroyed || (e.a11y.clicked = !1);
      });
    });
  }, y = (C) => {
    if (e.a11y.clicked)
      return;
    const P = C.target.closest(`.${e.params.slideClass}, swiper-slide`);
    if (!P || !e.slides.includes(P))
      return;
    const $ = e.slides.indexOf(P) === e.activeIndex, W = e.params.watchSlidesProgress && e.visibleSlides && e.visibleSlides.includes(P);
    $ || W || C.sourceCapabilities && C.sourceCapabilities.firesTouchEvents || (e.isHorizontal() ? e.el.scrollLeft = 0 : e.el.scrollTop = 0, e.slideTo(e.slides.indexOf(P), 0));
  }, v = () => {
    const C = e.params.a11y;
    C.itemRoleDescriptionMessage && c(e.slides, C.itemRoleDescriptionMessage), C.slideRole && u(e.slides, C.slideRole);
    const P = e.slides.length;
    C.slideLabelMessage && e.slides.forEach(($, W) => {
      const j = e.params.loop ? parseInt($.getAttribute("data-swiper-slide-index"), 10) : W, I = C.slideLabelMessage.replace(/\{\{index\}\}/, j + 1).replace(/\{\{slidesLength\}\}/, P);
      p($, I);
    });
  }, E = () => {
    const C = e.params.a11y;
    e.el.append(a);
    const P = e.el;
    C.containerRoleDescriptionMessage && c(P, C.containerRoleDescriptionMessage), C.containerMessage && p(P, C.containerMessage);
    const $ = e.wrapperEl, W = C.id || $.getAttribute("id") || `swiper-wrapper-${s(16)}`, j = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
    g($, W), m($, j), v();
    let {
      nextEl: I,
      prevEl: F
    } = e.navigation ? e.navigation : {};
    I = Oe(I), F = Oe(F), I && I.forEach((k) => A(k, W, C.nextSlideMessage)), F && F.forEach((k) => A(k, W, C.prevSlideMessage)), B() && Oe(e.pagination.el).forEach((N) => {
      N.addEventListener("keydown", b);
    }), e.el.addEventListener("focus", y, !0), e.el.addEventListener("pointerdown", D, !0), e.el.addEventListener("pointerup", h, !0);
  };
  function _() {
    a && a.remove();
    let {
      nextEl: C,
      prevEl: P
    } = e.navigation ? e.navigation : {};
    C = Oe(C), P = Oe(P), C && C.forEach(($) => $.removeEventListener("keydown", b)), P && P.forEach(($) => $.removeEventListener("keydown", b)), B() && Oe(e.pagination.el).forEach((W) => {
      W.removeEventListener("keydown", b);
    }), e.el.removeEventListener("focus", y, !0), e.el.removeEventListener("pointerdown", D, !0), e.el.removeEventListener("pointerup", h, !0);
  }
  n("beforeInit", () => {
    a = $t("span", e.params.a11y.notificationClass), a.setAttribute("aria-live", "assertive"), a.setAttribute("aria-atomic", "true");
  }), n("afterInit", () => {
    e.params.a11y.enabled && E();
  }), n("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    e.params.a11y.enabled && v();
  }), n("fromEdge toEdge afterInit lock unlock", () => {
    e.params.a11y.enabled && O();
  }), n("paginationUpdate", () => {
    e.params.a11y.enabled && T();
  }), n("destroy", () => {
    e.params.a11y.enabled && _();
  });
}
function nV(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    history: {
      enabled: !1,
      root: "",
      replaceState: !1,
      key: "slides",
      keepQuery: !1
    }
  });
  let a = !1, i = {};
  const s = (g) => g.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, ""), l = (g) => {
    const m = Qe();
    let d;
    g ? d = new URL(g) : d = m.location;
    const w = d.pathname.slice(1).split("/").filter((B) => B !== ""), b = w.length, O = w[b - 2], S = w[b - 1];
    return {
      key: O,
      value: S
    };
  }, o = (g, m) => {
    const d = Qe();
    if (!a || !e.params.history.enabled)
      return;
    let w;
    e.params.url ? w = new URL(e.params.url) : w = d.location;
    const b = e.slides[m];
    let O = s(b.getAttribute("data-history"));
    if (e.params.history.root.length > 0) {
      let B = e.params.history.root;
      B[B.length - 1] === "/" && (B = B.slice(0, B.length - 1)), O = `${B}/${g ? `${g}/` : ""}${O}`;
    } else
      w.pathname.includes(g) || (O = `${g ? `${g}/` : ""}${O}`);
    e.params.history.keepQuery && (O += w.search);
    const S = d.history.state;
    S && S.value === O || (e.params.history.replaceState ? d.history.replaceState({
      value: O
    }, null, O) : d.history.pushState({
      value: O
    }, null, O));
  }, u = (g, m, d) => {
    if (m)
      for (let w = 0, b = e.slides.length; w < b; w += 1) {
        const O = e.slides[w];
        if (s(O.getAttribute("data-history")) === m) {
          const B = e.getSlideIndex(O);
          e.slideTo(B, g, d);
        }
      }
    else
      e.slideTo(0, g, d);
  }, c = () => {
    i = l(e.params.url), u(e.params.speed, i.value, !1);
  }, f = () => {
    const g = Qe();
    if (e.params.history) {
      if (!g.history || !g.history.pushState) {
        e.params.history.enabled = !1, e.params.hashNavigation.enabled = !0;
        return;
      }
      if (a = !0, i = l(e.params.url), !i.key && !i.value) {
        e.params.history.replaceState || g.addEventListener("popstate", c);
        return;
      }
      u(0, i.value, e.params.runCallbacksOnInit), e.params.history.replaceState || g.addEventListener("popstate", c);
    }
  }, p = () => {
    const g = Qe();
    e.params.history.replaceState || g.removeEventListener("popstate", c);
  };
  n("init", () => {
    e.params.history.enabled && f();
  }), n("destroy", () => {
    e.params.history.enabled && p();
  }), n("transitionEnd _freeModeNoMomentumRelease", () => {
    a && o(e.params.history.key, e.activeIndex);
  }), n("slideChange", () => {
    a && e.params.cssMode && o(e.params.history.key, e.activeIndex);
  });
}
function aV(t) {
  let {
    swiper: e,
    extendParams: r,
    emit: n,
    on: a
  } = t, i = !1;
  const s = Et(), l = Qe();
  r({
    hashNavigation: {
      enabled: !1,
      replaceState: !1,
      watchState: !1,
      getSlideIndex(p, g) {
        if (e.virtual && e.params.virtual.enabled) {
          const m = e.slides.filter((w) => w.getAttribute("data-hash") === g)[0];
          return m ? parseInt(m.getAttribute("data-swiper-slide-index"), 10) : 0;
        }
        return e.getSlideIndex(dt(e.slidesEl, `.${e.params.slideClass}[data-hash="${g}"], swiper-slide[data-hash="${g}"]`)[0]);
      }
    }
  });
  const o = () => {
    n("hashChange");
    const p = s.location.hash.replace("#", ""), g = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex], m = g ? g.getAttribute("data-hash") : "";
    if (p !== m) {
      const d = e.params.hashNavigation.getSlideIndex(e, p);
      if (typeof d > "u" || Number.isNaN(d))
        return;
      e.slideTo(d);
    }
  }, u = () => {
    if (!i || !e.params.hashNavigation.enabled)
      return;
    const p = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex], g = p ? p.getAttribute("data-hash") || p.getAttribute("data-history") : "";
    e.params.hashNavigation.replaceState && l.history && l.history.replaceState ? (l.history.replaceState(null, null, `#${g}` || ""), n("hashSet")) : (s.location.hash = g || "", n("hashSet"));
  }, c = () => {
    if (!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled)
      return;
    i = !0;
    const p = s.location.hash.replace("#", "");
    if (p) {
      const m = e.params.hashNavigation.getSlideIndex(e, p);
      e.slideTo(m || 0, 0, e.params.runCallbacksOnInit, !0);
    }
    e.params.hashNavigation.watchState && l.addEventListener("hashchange", o);
  }, f = () => {
    e.params.hashNavigation.watchState && l.removeEventListener("hashchange", o);
  };
  a("init", () => {
    e.params.hashNavigation.enabled && c();
  }), a("destroy", () => {
    e.params.hashNavigation.enabled && f();
  }), a("transitionEnd _freeModeNoMomentumRelease", () => {
    i && u();
  }), a("slideChange", () => {
    i && e.params.cssMode && u();
  });
}
function iV(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n,
    emit: a,
    params: i
  } = t;
  e.autoplay = {
    running: !1,
    paused: !1,
    timeLeft: 0
  }, r({
    autoplay: {
      enabled: !1,
      delay: 3e3,
      waitForTransition: !0,
      disableOnInteraction: !1,
      stopOnLastSlide: !1,
      reverseDirection: !1,
      pauseOnMouseEnter: !1
    }
  });
  let s, l, o = i && i.autoplay ? i.autoplay.delay : 3e3, u = i && i.autoplay ? i.autoplay.delay : 3e3, c, f = (/* @__PURE__ */ new Date()).getTime(), p, g, m, d, w, b, O;
  function S(I) {
    !e || e.destroyed || !e.wrapperEl || I.target === e.wrapperEl && (e.wrapperEl.removeEventListener("transitionend", S), !O && v());
  }
  const B = () => {
    if (e.destroyed || !e.autoplay.running)
      return;
    e.autoplay.paused ? p = !0 : p && (u = c, p = !1);
    const I = e.autoplay.paused ? c : f + u - (/* @__PURE__ */ new Date()).getTime();
    e.autoplay.timeLeft = I, a("autoplayTimeLeft", I, I / o), l = requestAnimationFrame(() => {
      B();
    });
  }, T = () => {
    let I;
    return e.virtual && e.params.virtual.enabled ? I = e.slides.filter((k) => k.classList.contains("swiper-slide-active"))[0] : I = e.slides[e.activeIndex], I ? parseInt(I.getAttribute("data-swiper-autoplay"), 10) : void 0;
  }, A = (I) => {
    if (e.destroyed || !e.autoplay.running)
      return;
    cancelAnimationFrame(l), B();
    let F = typeof I > "u" ? e.params.autoplay.delay : I;
    o = e.params.autoplay.delay, u = e.params.autoplay.delay;
    const k = T();
    !Number.isNaN(k) && k > 0 && typeof I > "u" && (F = k, o = k, u = k), c = F;
    const N = e.params.speed, U = () => {
      !e || e.destroyed || (e.params.autoplay.reverseDirection ? !e.isBeginning || e.params.loop || e.params.rewind ? (e.slidePrev(N, !0, !0), a("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(e.slides.length - 1, N, !0, !0), a("autoplay")) : !e.isEnd || e.params.loop || e.params.rewind ? (e.slideNext(N, !0, !0), a("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(0, N, !0, !0), a("autoplay")), e.params.cssMode && (f = (/* @__PURE__ */ new Date()).getTime(), requestAnimationFrame(() => {
        A();
      })));
    };
    return F > 0 ? (clearTimeout(s), s = setTimeout(() => {
      U();
    }, F)) : requestAnimationFrame(() => {
      U();
    }), F;
  }, D = () => {
    f = (/* @__PURE__ */ new Date()).getTime(), e.autoplay.running = !0, A(), a("autoplayStart");
  }, h = () => {
    e.autoplay.running = !1, clearTimeout(s), cancelAnimationFrame(l), a("autoplayStop");
  }, y = (I, F) => {
    if (e.destroyed || !e.autoplay.running)
      return;
    clearTimeout(s), I || (b = !0);
    const k = () => {
      a("autoplayPause"), e.params.autoplay.waitForTransition ? e.wrapperEl.addEventListener("transitionend", S) : v();
    };
    if (e.autoplay.paused = !0, F) {
      w && (c = e.params.autoplay.delay), w = !1, k();
      return;
    }
    c = (c || e.params.autoplay.delay) - ((/* @__PURE__ */ new Date()).getTime() - f), !(e.isEnd && c < 0 && !e.params.loop) && (c < 0 && (c = 0), k());
  }, v = () => {
    e.isEnd && c < 0 && !e.params.loop || e.destroyed || !e.autoplay.running || (f = (/* @__PURE__ */ new Date()).getTime(), b ? (b = !1, A(c)) : A(), e.autoplay.paused = !1, a("autoplayResume"));
  }, E = () => {
    if (e.destroyed || !e.autoplay.running)
      return;
    const I = Et();
    I.visibilityState === "hidden" && (b = !0, y(!0)), I.visibilityState === "visible" && v();
  }, _ = (I) => {
    I.pointerType === "mouse" && (b = !0, O = !0, !(e.animating || e.autoplay.paused) && y(!0));
  }, C = (I) => {
    I.pointerType === "mouse" && (O = !1, e.autoplay.paused && v());
  }, P = () => {
    e.params.autoplay.pauseOnMouseEnter && (e.el.addEventListener("pointerenter", _), e.el.addEventListener("pointerleave", C));
  }, $ = () => {
    e.el.removeEventListener("pointerenter", _), e.el.removeEventListener("pointerleave", C);
  }, W = () => {
    Et().addEventListener("visibilitychange", E);
  }, j = () => {
    Et().removeEventListener("visibilitychange", E);
  };
  n("init", () => {
    e.params.autoplay.enabled && (P(), W(), D());
  }), n("destroy", () => {
    $(), j(), e.autoplay.running && h();
  }), n("_freeModeStaticRelease", () => {
    (m || b) && v();
  }), n("_freeModeNoMomentumRelease", () => {
    e.params.autoplay.disableOnInteraction ? h() : y(!0, !0);
  }), n("beforeTransitionStart", (I, F, k) => {
    e.destroyed || !e.autoplay.running || (k || !e.params.autoplay.disableOnInteraction ? y(!0, !0) : h());
  }), n("sliderFirstMove", () => {
    if (!(e.destroyed || !e.autoplay.running)) {
      if (e.params.autoplay.disableOnInteraction) {
        h();
        return;
      }
      g = !0, m = !1, b = !1, d = setTimeout(() => {
        b = !0, m = !0, y(!0);
      }, 200);
    }
  }), n("touchEnd", () => {
    if (!(e.destroyed || !e.autoplay.running || !g)) {
      if (clearTimeout(d), clearTimeout(s), e.params.autoplay.disableOnInteraction) {
        m = !1, g = !1;
        return;
      }
      m && e.params.cssMode && v(), m = !1, g = !1;
    }
  }), n("slideChange", () => {
    e.destroyed || !e.autoplay.running || (w = !0);
  }), Object.assign(e.autoplay, {
    start: D,
    stop: h,
    pause: y,
    resume: v
  });
}
function sV(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: !0,
      autoScrollOffset: 0,
      slideThumbActiveClass: "swiper-slide-thumb-active",
      thumbsContainerClass: "swiper-thumbs"
    }
  });
  let a = !1, i = !1;
  e.thumbs = {
    swiper: null
  };
  function s() {
    const u = e.thumbs.swiper;
    if (!u || u.destroyed)
      return;
    const c = u.clickedIndex, f = u.clickedSlide;
    if (f && f.classList.contains(e.params.thumbs.slideThumbActiveClass) || typeof c > "u" || c === null)
      return;
    let p;
    u.params.loop ? p = parseInt(u.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : p = c, e.params.loop ? e.slideToLoop(p) : e.slideTo(p);
  }
  function l() {
    const {
      thumbs: u
    } = e.params;
    if (a)
      return !1;
    a = !0;
    const c = e.constructor;
    if (u.swiper instanceof c)
      e.thumbs.swiper = u.swiper, Object.assign(e.thumbs.swiper.originalParams, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), Object.assign(e.thumbs.swiper.params, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), e.thumbs.swiper.update();
    else if (Ya(u.swiper)) {
      const f = Object.assign({}, u.swiper);
      Object.assign(f, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), e.thumbs.swiper = new c(f), i = !0;
    }
    return e.thumbs.swiper.el.classList.add(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on("tap", s), !0;
  }
  function o(u) {
    const c = e.thumbs.swiper;
    if (!c || c.destroyed)
      return;
    const f = c.params.slidesPerView === "auto" ? c.slidesPerViewDynamic() : c.params.slidesPerView;
    let p = 1;
    const g = e.params.thumbs.slideThumbActiveClass;
    if (e.params.slidesPerView > 1 && !e.params.centeredSlides && (p = e.params.slidesPerView), e.params.thumbs.multipleActiveThumbs || (p = 1), p = Math.floor(p), c.slides.forEach((w) => w.classList.remove(g)), c.params.loop || c.params.virtual && c.params.virtual.enabled)
      for (let w = 0; w < p; w += 1)
        dt(c.slidesEl, `[data-swiper-slide-index="${e.realIndex + w}"]`).forEach((b) => {
          b.classList.add(g);
        });
    else
      for (let w = 0; w < p; w += 1)
        c.slides[e.realIndex + w] && c.slides[e.realIndex + w].classList.add(g);
    const m = e.params.thumbs.autoScrollOffset, d = m && !c.params.loop;
    if (e.realIndex !== c.realIndex || d) {
      const w = c.activeIndex;
      let b, O;
      if (c.params.loop) {
        const S = c.slides.filter((B) => B.getAttribute("data-swiper-slide-index") === `${e.realIndex}`)[0];
        b = c.slides.indexOf(S), O = e.activeIndex > e.previousIndex ? "next" : "prev";
      } else
        b = e.realIndex, O = b > e.previousIndex ? "next" : "prev";
      d && (b += O === "next" ? m : -1 * m), c.visibleSlidesIndexes && c.visibleSlidesIndexes.indexOf(b) < 0 && (c.params.centeredSlides ? b > w ? b = b - Math.floor(f / 2) + 1 : b = b + Math.floor(f / 2) - 1 : b > w && c.params.slidesPerGroup, c.slideTo(b, u ? 0 : void 0));
    }
  }
  n("beforeInit", () => {
    const {
      thumbs: u
    } = e.params;
    if (!(!u || !u.swiper))
      if (typeof u.swiper == "string" || u.swiper instanceof HTMLElement) {
        const c = Et(), f = () => {
          const g = typeof u.swiper == "string" ? c.querySelector(u.swiper) : u.swiper;
          if (g && g.swiper)
            u.swiper = g.swiper, l(), o(!0);
          else if (g) {
            const m = (d) => {
              u.swiper = d.detail[0], g.removeEventListener("init", m), l(), o(!0), u.swiper.update(), e.update();
            };
            g.addEventListener("init", m);
          }
          return g;
        }, p = () => {
          if (e.destroyed)
            return;
          f() || requestAnimationFrame(p);
        };
        requestAnimationFrame(p);
      } else
        l(), o(!0);
  }), n("slideChange update resize observerUpdate", () => {
    o();
  }), n("setTransition", (u, c) => {
    const f = e.thumbs.swiper;
    !f || f.destroyed || f.setTransition(c);
  }), n("beforeDestroy", () => {
    const u = e.thumbs.swiper;
    !u || u.destroyed || i && u.destroy();
  }), Object.assign(e.thumbs, {
    init: l,
    update: o
  });
}
function oV(t) {
  let {
    swiper: e,
    extendParams: r,
    emit: n,
    once: a
  } = t;
  r({
    freeMode: {
      enabled: !1,
      momentum: !0,
      momentumRatio: 1,
      momentumBounce: !0,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: !1,
      minimumVelocity: 0.02
    }
  });
  function i() {
    if (e.params.cssMode)
      return;
    const o = e.getTranslate();
    e.setTranslate(o), e.setTransition(0), e.touchEventsData.velocities.length = 0, e.freeMode.onTouchEnd({
      currentPos: e.rtl ? e.translate : -e.translate
    });
  }
  function s() {
    if (e.params.cssMode)
      return;
    const {
      touchEventsData: o,
      touches: u
    } = e;
    o.velocities.length === 0 && o.velocities.push({
      position: u[e.isHorizontal() ? "startX" : "startY"],
      time: o.touchStartTime
    }), o.velocities.push({
      position: u[e.isHorizontal() ? "currentX" : "currentY"],
      time: zt()
    });
  }
  function l(o) {
    let {
      currentPos: u
    } = o;
    if (e.params.cssMode)
      return;
    const {
      params: c,
      wrapperEl: f,
      rtlTranslate: p,
      snapGrid: g,
      touchEventsData: m
    } = e, w = zt() - m.touchStartTime;
    if (u < -e.minTranslate()) {
      e.slideTo(e.activeIndex);
      return;
    }
    if (u > -e.maxTranslate()) {
      e.slides.length < g.length ? e.slideTo(g.length - 1) : e.slideTo(e.slides.length - 1);
      return;
    }
    if (c.freeMode.momentum) {
      if (m.velocities.length > 1) {
        const h = m.velocities.pop(), y = m.velocities.pop(), v = h.position - y.position, E = h.time - y.time;
        e.velocity = v / E, e.velocity /= 2, Math.abs(e.velocity) < c.freeMode.minimumVelocity && (e.velocity = 0), (E > 150 || zt() - h.time > 300) && (e.velocity = 0);
      } else
        e.velocity = 0;
      e.velocity *= c.freeMode.momentumVelocityRatio, m.velocities.length = 0;
      let b = 1e3 * c.freeMode.momentumRatio;
      const O = e.velocity * b;
      let S = e.translate + O;
      p && (S = -S);
      let B = !1, T;
      const A = Math.abs(e.velocity) * 20 * c.freeMode.momentumBounceRatio;
      let D;
      if (S < e.maxTranslate())
        c.freeMode.momentumBounce ? (S + e.maxTranslate() < -A && (S = e.maxTranslate() - A), T = e.maxTranslate(), B = !0, m.allowMomentumBounce = !0) : S = e.maxTranslate(), c.loop && c.centeredSlides && (D = !0);
      else if (S > e.minTranslate())
        c.freeMode.momentumBounce ? (S - e.minTranslate() > A && (S = e.minTranslate() + A), T = e.minTranslate(), B = !0, m.allowMomentumBounce = !0) : S = e.minTranslate(), c.loop && c.centeredSlides && (D = !0);
      else if (c.freeMode.sticky) {
        let h;
        for (let y = 0; y < g.length; y += 1)
          if (g[y] > -S) {
            h = y;
            break;
          }
        Math.abs(g[h] - S) < Math.abs(g[h - 1] - S) || e.swipeDirection === "next" ? S = g[h] : S = g[h - 1], S = -S;
      }
      if (D && a("transitionEnd", () => {
        e.loopFix();
      }), e.velocity !== 0) {
        if (p ? b = Math.abs((-S - e.translate) / e.velocity) : b = Math.abs((S - e.translate) / e.velocity), c.freeMode.sticky) {
          const h = Math.abs((p ? -S : S) - e.translate), y = e.slidesSizesGrid[e.activeIndex];
          h < y ? b = c.speed : h < 2 * y ? b = c.speed * 1.5 : b = c.speed * 2.5;
        }
      } else if (c.freeMode.sticky) {
        e.slideToClosest();
        return;
      }
      c.freeMode.momentumBounce && B ? (e.updateProgress(T), e.setTransition(b), e.setTranslate(S), e.transitionStart(!0, e.swipeDirection), e.animating = !0, ni(f, () => {
        !e || e.destroyed || !m.allowMomentumBounce || (n("momentumBounce"), e.setTransition(c.speed), setTimeout(() => {
          e.setTranslate(T), ni(f, () => {
            !e || e.destroyed || e.transitionEnd();
          });
        }, 0));
      })) : e.velocity ? (n("_freeModeNoMomentumRelease"), e.updateProgress(S), e.setTransition(b), e.setTranslate(S), e.transitionStart(!0, e.swipeDirection), e.animating || (e.animating = !0, ni(f, () => {
        !e || e.destroyed || e.transitionEnd();
      }))) : e.updateProgress(S), e.updateActiveIndex(), e.updateSlidesClasses();
    } else if (c.freeMode.sticky) {
      e.slideToClosest();
      return;
    } else
      c.freeMode && n("_freeModeNoMomentumRelease");
    (!c.freeMode.momentum || w >= c.longSwipesMs) && (n("_freeModeStaticRelease"), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses());
  }
  Object.assign(e, {
    freeMode: {
      onTouchStart: i,
      onTouchMove: s,
      onTouchEnd: l
    }
  });
}
function lV(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    grid: {
      rows: 1,
      fill: "column"
    }
  });
  let a, i, s, l;
  const o = () => {
    let d = e.params.spaceBetween;
    return typeof d == "string" && d.indexOf("%") >= 0 ? d = parseFloat(d.replace("%", "")) / 100 * e.size : typeof d == "string" && (d = parseFloat(d)), d;
  }, u = (d) => {
    const {
      slidesPerView: w
    } = e.params, {
      rows: b,
      fill: O
    } = e.params.grid, S = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : d.length;
    s = Math.floor(S / b), Math.floor(S / b) === S / b ? a = S : a = Math.ceil(S / b) * b, w !== "auto" && O === "row" && (a = Math.max(a, w * b)), i = a / b;
  }, c = () => {
    e.slides && e.slides.forEach((d) => {
      d.swiperSlideGridSet && (d.style.height = "", d.style[e.getDirectionLabel("margin-top")] = "");
    });
  }, f = (d, w, b) => {
    const {
      slidesPerGroup: O
    } = e.params, S = o(), {
      rows: B,
      fill: T
    } = e.params.grid, A = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : b.length;
    let D, h, y;
    if (T === "row" && O > 1) {
      const v = Math.floor(d / (O * B)), E = d - B * O * v, _ = v === 0 ? O : Math.min(Math.ceil((A - v * B * O) / B), O);
      y = Math.floor(E / _), h = E - y * _ + v * O, D = h + y * a / B, w.style.order = D;
    } else
      T === "column" ? (h = Math.floor(d / B), y = d - h * B, (h > s || h === s && y === B - 1) && (y += 1, y >= B && (y = 0, h += 1))) : (y = Math.floor(d / i), h = d - y * i);
    w.row = y, w.column = h, w.style.height = `calc((100% - ${(B - 1) * S}px) / ${B})`, w.style[e.getDirectionLabel("margin-top")] = y !== 0 ? S && `${S}px` : "", w.swiperSlideGridSet = !0;
  }, p = (d, w) => {
    const {
      centeredSlides: b,
      roundLengths: O
    } = e.params, S = o(), {
      rows: B
    } = e.params.grid;
    if (e.virtualSize = (d + S) * a, e.virtualSize = Math.ceil(e.virtualSize / B) - S, e.params.cssMode || (e.wrapperEl.style[e.getDirectionLabel("width")] = `${e.virtualSize + S}px`), b) {
      const T = [];
      for (let A = 0; A < w.length; A += 1) {
        let D = w[A];
        O && (D = Math.floor(D)), w[A] < e.virtualSize + w[0] && T.push(D);
      }
      w.splice(0, w.length), w.push(...T);
    }
  }, g = () => {
    l = e.params.grid && e.params.grid.rows > 1;
  }, m = () => {
    const {
      params: d,
      el: w
    } = e, b = d.grid && d.grid.rows > 1;
    l && !b ? (w.classList.remove(`${d.containerModifierClass}grid`, `${d.containerModifierClass}grid-column`), s = 1, e.emitContainerClasses()) : !l && b && (w.classList.add(`${d.containerModifierClass}grid`), d.grid.fill === "column" && w.classList.add(`${d.containerModifierClass}grid-column`), e.emitContainerClasses()), l = b;
  };
  n("init", g), n("update", m), e.grid = {
    initSlides: u,
    unsetSlides: c,
    updateSlide: f,
    updateWrapperSize: p
  };
}
function uV(t) {
  const e = this, {
    params: r,
    slidesEl: n
  } = e;
  r.loop && e.loopDestroy();
  const a = (i) => {
    if (typeof i == "string") {
      const s = document.createElement("div");
      s.innerHTML = i, n.append(s.children[0]), s.innerHTML = "";
    } else
      n.append(i);
  };
  if (typeof t == "object" && "length" in t)
    for (let i = 0; i < t.length; i += 1)
      t[i] && a(t[i]);
  else
    a(t);
  e.recalcSlides(), r.loop && e.loopCreate(), (!r.observer || e.isElement) && e.update();
}
function cV(t) {
  const e = this, {
    params: r,
    activeIndex: n,
    slidesEl: a
  } = e;
  r.loop && e.loopDestroy();
  let i = n + 1;
  const s = (l) => {
    if (typeof l == "string") {
      const o = document.createElement("div");
      o.innerHTML = l, a.prepend(o.children[0]), o.innerHTML = "";
    } else
      a.prepend(l);
  };
  if (typeof t == "object" && "length" in t) {
    for (let l = 0; l < t.length; l += 1)
      t[l] && s(t[l]);
    i = n + t.length;
  } else
    s(t);
  e.recalcSlides(), r.loop && e.loopCreate(), (!r.observer || e.isElement) && e.update(), e.slideTo(i, 0, !1);
}
function fV(t, e) {
  const r = this, {
    params: n,
    activeIndex: a,
    slidesEl: i
  } = r;
  let s = a;
  n.loop && (s -= r.loopedSlides, r.loopDestroy(), r.recalcSlides());
  const l = r.slides.length;
  if (t <= 0) {
    r.prependSlide(e);
    return;
  }
  if (t >= l) {
    r.appendSlide(e);
    return;
  }
  let o = s > t ? s + 1 : s;
  const u = [];
  for (let c = l - 1; c >= t; c -= 1) {
    const f = r.slides[c];
    f.remove(), u.unshift(f);
  }
  if (typeof e == "object" && "length" in e) {
    for (let c = 0; c < e.length; c += 1)
      e[c] && i.append(e[c]);
    o = s > t ? s + e.length : s;
  } else
    i.append(e);
  for (let c = 0; c < u.length; c += 1)
    i.append(u[c]);
  r.recalcSlides(), n.loop && r.loopCreate(), (!n.observer || r.isElement) && r.update(), n.loop ? r.slideTo(o + r.loopedSlides, 0, !1) : r.slideTo(o, 0, !1);
}
function dV(t) {
  const e = this, {
    params: r,
    activeIndex: n
  } = e;
  let a = n;
  r.loop && (a -= e.loopedSlides, e.loopDestroy());
  let i = a, s;
  if (typeof t == "object" && "length" in t) {
    for (let l = 0; l < t.length; l += 1)
      s = t[l], e.slides[s] && e.slides[s].remove(), s < i && (i -= 1);
    i = Math.max(i, 0);
  } else
    s = t, e.slides[s] && e.slides[s].remove(), s < i && (i -= 1), i = Math.max(i, 0);
  e.recalcSlides(), r.loop && e.loopCreate(), (!r.observer || e.isElement) && e.update(), r.loop ? e.slideTo(i + e.loopedSlides, 0, !1) : e.slideTo(i, 0, !1);
}
function pV() {
  const t = this, e = [];
  for (let r = 0; r < t.slides.length; r += 1)
    e.push(r);
  t.removeSlide(e);
}
function hV(t) {
  let {
    swiper: e
  } = t;
  Object.assign(e, {
    appendSlide: uV.bind(e),
    prependSlide: cV.bind(e),
    addSlide: fV.bind(e),
    removeSlide: dV.bind(e),
    removeAllSlides: pV.bind(e)
  });
}
function Da(t) {
  const {
    effect: e,
    swiper: r,
    on: n,
    setTranslate: a,
    setTransition: i,
    overwriteParams: s,
    perspective: l,
    recreateShadows: o,
    getEffectParams: u
  } = t;
  n("beforeInit", () => {
    if (r.params.effect !== e)
      return;
    r.classNames.push(`${r.params.containerModifierClass}${e}`), l && l() && r.classNames.push(`${r.params.containerModifierClass}3d`);
    const f = s ? s() : {};
    Object.assign(r.params, f), Object.assign(r.originalParams, f);
  }), n("setTranslate", () => {
    r.params.effect === e && a();
  }), n("setTransition", (f, p) => {
    r.params.effect === e && i(p);
  }), n("transitionEnd", () => {
    if (r.params.effect === e && o) {
      if (!u || !u().slideShadows)
        return;
      r.slides.forEach((f) => {
        f.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((p) => p.remove());
      }), o();
    }
  });
  let c;
  n("virtualUpdate", () => {
    r.params.effect === e && (r.slides.length || (c = !0), requestAnimationFrame(() => {
      c && r.slides && r.slides.length && (a(), c = !1);
    }));
  });
}
function Fi(t, e) {
  const r = Sn(e);
  return r !== e && (r.style.backfaceVisibility = "hidden", r.style["-webkit-backface-visibility"] = "hidden"), r;
}
function mo(t) {
  let {
    swiper: e,
    duration: r,
    transformElements: n,
    allSlides: a
  } = t;
  const {
    activeIndex: i
  } = e, s = (l) => l.parentElement ? l.parentElement : e.slides.filter((u) => u.shadowRoot && u.shadowRoot === l.parentNode)[0];
  if (e.params.virtualTranslate && r !== 0) {
    let l = !1, o;
    a ? o = n : o = n.filter((u) => {
      const c = u.classList.contains("swiper-slide-transform") ? s(u) : u;
      return e.getSlideIndex(c) === i;
    }), o.forEach((u) => {
      ni(u, () => {
        if (l || !e || e.destroyed)
          return;
        l = !0, e.animating = !1;
        const c = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0
        });
        e.wrapperEl.dispatchEvent(c);
      });
    });
  }
}
function gV(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    fadeEffect: {
      crossFade: !1
    }
  }), Da({
    effect: "fade",
    swiper: e,
    on: n,
    setTranslate: () => {
      const {
        slides: s
      } = e, l = e.params.fadeEffect;
      for (let o = 0; o < s.length; o += 1) {
        const u = e.slides[o];
        let f = -u.swiperSlideOffset;
        e.params.virtualTranslate || (f -= e.translate);
        let p = 0;
        e.isHorizontal() || (p = f, f = 0);
        const g = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(u.progress), 0) : 1 + Math.min(Math.max(u.progress, -1), 0), m = Fi(l, u);
        m.style.opacity = g, m.style.transform = `translate3d(${f}px, ${p}px, 0px)`;
      }
    },
    setTransition: (s) => {
      const l = e.slides.map((o) => Sn(o));
      l.forEach((o) => {
        o.style.transitionDuration = `${s}ms`;
      }), mo({
        swiper: e,
        duration: s,
        transformElements: l,
        allSlides: !0
      });
    },
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function vV(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    cubeEffect: {
      slideShadows: !0,
      shadow: !0,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  });
  const a = (o, u, c) => {
    let f = c ? o.querySelector(".swiper-slide-shadow-left") : o.querySelector(".swiper-slide-shadow-top"), p = c ? o.querySelector(".swiper-slide-shadow-right") : o.querySelector(".swiper-slide-shadow-bottom");
    f || (f = $t("div", `swiper-slide-shadow-cube swiper-slide-shadow-${c ? "left" : "top"}`.split(" ")), o.append(f)), p || (p = $t("div", `swiper-slide-shadow-cube swiper-slide-shadow-${c ? "right" : "bottom"}`.split(" ")), o.append(p)), f && (f.style.opacity = Math.max(-u, 0)), p && (p.style.opacity = Math.max(u, 0));
  };
  Da({
    effect: "cube",
    swiper: e,
    on: n,
    setTranslate: () => {
      const {
        el: o,
        wrapperEl: u,
        slides: c,
        width: f,
        height: p,
        rtlTranslate: g,
        size: m,
        browser: d
      } = e, w = e.params.cubeEffect, b = e.isHorizontal(), O = e.virtual && e.params.virtual.enabled;
      let S = 0, B;
      w.shadow && (b ? (B = e.wrapperEl.querySelector(".swiper-cube-shadow"), B || (B = $t("div", "swiper-cube-shadow"), e.wrapperEl.append(B)), B.style.height = `${f}px`) : (B = o.querySelector(".swiper-cube-shadow"), B || (B = $t("div", "swiper-cube-shadow"), o.append(B))));
      for (let A = 0; A < c.length; A += 1) {
        const D = c[A];
        let h = A;
        O && (h = parseInt(D.getAttribute("data-swiper-slide-index"), 10));
        let y = h * 90, v = Math.floor(y / 360);
        g && (y = -y, v = Math.floor(-y / 360));
        const E = Math.max(Math.min(D.progress, 1), -1);
        let _ = 0, C = 0, P = 0;
        h % 4 === 0 ? (_ = -v * 4 * m, P = 0) : (h - 1) % 4 === 0 ? (_ = 0, P = -v * 4 * m) : (h - 2) % 4 === 0 ? (_ = m + v * 4 * m, P = m) : (h - 3) % 4 === 0 && (_ = -m, P = 3 * m + m * 4 * v), g && (_ = -_), b || (C = _, _ = 0);
        const $ = `rotateX(${b ? 0 : -y}deg) rotateY(${b ? y : 0}deg) translate3d(${_}px, ${C}px, ${P}px)`;
        E <= 1 && E > -1 && (S = h * 90 + E * 90, g && (S = -h * 90 - E * 90), e.browser && e.browser.need3dFix && Math.abs(S) / 90 % 2 === 1 && (S += 1e-3)), D.style.transform = $, w.slideShadows && a(D, E, b);
      }
      if (u.style.transformOrigin = `50% 50% -${m / 2}px`, u.style["-webkit-transform-origin"] = `50% 50% -${m / 2}px`, w.shadow)
        if (b)
          B.style.transform = `translate3d(0px, ${f / 2 + w.shadowOffset}px, ${-f / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${w.shadowScale})`;
        else {
          const A = Math.abs(S) - Math.floor(Math.abs(S) / 90) * 90, D = 1.5 - (Math.sin(A * 2 * Math.PI / 360) / 2 + Math.cos(A * 2 * Math.PI / 360) / 2), h = w.shadowScale, y = w.shadowScale / D, v = w.shadowOffset;
          B.style.transform = `scale3d(${h}, 1, ${y}) translate3d(0px, ${p / 2 + v}px, ${-p / 2 / y}px) rotateX(-89.99deg)`;
        }
      const T = (d.isSafari || d.isWebView) && d.needPerspectiveFix ? -m / 2 : 0;
      u.style.transform = `translate3d(0px,0,${T}px) rotateX(${e.isHorizontal() ? 0 : S}deg) rotateY(${e.isHorizontal() ? -S : 0}deg)`, u.style.setProperty("--swiper-cube-translate-z", `${T}px`);
    },
    setTransition: (o) => {
      const {
        el: u,
        slides: c
      } = e;
      if (c.forEach((f) => {
        f.style.transitionDuration = `${o}ms`, f.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((p) => {
          p.style.transitionDuration = `${o}ms`;
        });
      }), e.params.cubeEffect.shadow && !e.isHorizontal()) {
        const f = u.querySelector(".swiper-cube-shadow");
        f && (f.style.transitionDuration = `${o}ms`);
      }
    },
    recreateShadows: () => {
      const o = e.isHorizontal();
      e.slides.forEach((u) => {
        const c = Math.max(Math.min(u.progress, 1), -1);
        a(u, c, o);
      });
    },
    getEffectParams: () => e.params.cubeEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      resistanceRatio: 0,
      spaceBetween: 0,
      centeredSlides: !1,
      virtualTranslate: !0
    })
  });
}
function fa(t, e, r) {
  const n = `swiper-slide-shadow${r ? `-${r}` : ""}${t ? ` swiper-slide-shadow-${t}` : ""}`, a = Sn(e);
  let i = a.querySelector(`.${n.split(" ").join(".")}`);
  return i || (i = $t("div", n.split(" ")), a.append(i)), i;
}
function mV(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    flipEffect: {
      slideShadows: !0,
      limitRotation: !0
    }
  });
  const a = (o, u) => {
    let c = e.isHorizontal() ? o.querySelector(".swiper-slide-shadow-left") : o.querySelector(".swiper-slide-shadow-top"), f = e.isHorizontal() ? o.querySelector(".swiper-slide-shadow-right") : o.querySelector(".swiper-slide-shadow-bottom");
    c || (c = fa("flip", o, e.isHorizontal() ? "left" : "top")), f || (f = fa("flip", o, e.isHorizontal() ? "right" : "bottom")), c && (c.style.opacity = Math.max(-u, 0)), f && (f.style.opacity = Math.max(u, 0));
  };
  Da({
    effect: "flip",
    swiper: e,
    on: n,
    setTranslate: () => {
      const {
        slides: o,
        rtlTranslate: u
      } = e, c = e.params.flipEffect;
      for (let f = 0; f < o.length; f += 1) {
        const p = o[f];
        let g = p.progress;
        e.params.flipEffect.limitRotation && (g = Math.max(Math.min(p.progress, 1), -1));
        const m = p.swiperSlideOffset;
        let w = -180 * g, b = 0, O = e.params.cssMode ? -m - e.translate : -m, S = 0;
        e.isHorizontal() ? u && (w = -w) : (S = O, O = 0, b = -w, w = 0), e.browser && e.browser.need3dFix && (Math.abs(w) / 90 % 2 === 1 && (w += 1e-3), Math.abs(b) / 90 % 2 === 1 && (b += 1e-3)), p.style.zIndex = -Math.abs(Math.round(g)) + o.length, c.slideShadows && a(p, g);
        const B = `translate3d(${O}px, ${S}px, 0px) rotateX(${b}deg) rotateY(${w}deg)`, T = Fi(c, p);
        T.style.transform = B;
      }
    },
    setTransition: (o) => {
      const u = e.slides.map((c) => Sn(c));
      u.forEach((c) => {
        c.style.transitionDuration = `${o}ms`, c.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((f) => {
          f.style.transitionDuration = `${o}ms`;
        });
      }), mo({
        swiper: e,
        duration: o,
        transformElements: u
      });
    },
    recreateShadows: () => {
      e.params.flipEffect, e.slides.forEach((o) => {
        let u = o.progress;
        e.params.flipEffect.limitRotation && (u = Math.max(Math.min(o.progress, 1), -1)), a(o, u);
      });
    },
    getEffectParams: () => e.params.flipEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function yV(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: !0
    }
  }), Da({
    effect: "coverflow",
    swiper: e,
    on: n,
    setTranslate: () => {
      const {
        width: s,
        height: l,
        slides: o,
        slidesSizesGrid: u
      } = e, c = e.params.coverflowEffect, f = e.isHorizontal(), p = e.translate, g = f ? -p + s / 2 : -p + l / 2, m = f ? c.rotate : -c.rotate, d = c.depth;
      for (let w = 0, b = o.length; w < b; w += 1) {
        const O = o[w], S = u[w], B = O.swiperSlideOffset, T = (g - B - S / 2) / S, A = typeof c.modifier == "function" ? c.modifier(T) : T * c.modifier;
        let D = f ? m * A : 0, h = f ? 0 : m * A, y = -d * Math.abs(A), v = c.stretch;
        typeof v == "string" && v.indexOf("%") !== -1 && (v = parseFloat(c.stretch) / 100 * S);
        let E = f ? 0 : v * A, _ = f ? v * A : 0, C = 1 - (1 - c.scale) * Math.abs(A);
        Math.abs(_) < 1e-3 && (_ = 0), Math.abs(E) < 1e-3 && (E = 0), Math.abs(y) < 1e-3 && (y = 0), Math.abs(D) < 1e-3 && (D = 0), Math.abs(h) < 1e-3 && (h = 0), Math.abs(C) < 1e-3 && (C = 0), e.browser && e.browser.need3dFix && (Math.abs(D) / 90 % 2 === 1 && (D += 1e-3), Math.abs(h) / 90 % 2 === 1 && (h += 1e-3));
        const P = `translate3d(${_}px,${E}px,${y}px)  rotateX(${h}deg) rotateY(${D}deg) scale(${C})`, $ = Fi(c, O);
        if ($.style.transform = P, O.style.zIndex = -Math.abs(Math.round(A)) + 1, c.slideShadows) {
          let W = f ? O.querySelector(".swiper-slide-shadow-left") : O.querySelector(".swiper-slide-shadow-top"), j = f ? O.querySelector(".swiper-slide-shadow-right") : O.querySelector(".swiper-slide-shadow-bottom");
          W || (W = fa("coverflow", O, f ? "left" : "top")), j || (j = fa("coverflow", O, f ? "right" : "bottom")), W && (W.style.opacity = A > 0 ? A : 0), j && (j.style.opacity = -A > 0 ? -A : 0);
        }
      }
    },
    setTransition: (s) => {
      e.slides.map((o) => Sn(o)).forEach((o) => {
        o.style.transitionDuration = `${s}ms`, o.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((u) => {
          u.style.transitionDuration = `${s}ms`;
        });
      });
    },
    perspective: () => !0,
    overwriteParams: () => ({
      watchSlidesProgress: !0
    })
  });
}
function bV(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    creativeEffect: {
      limitProgress: 1,
      shadowPerProgress: !1,
      progressMultiplier: 1,
      perspective: !0,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });
  const a = (l) => typeof l == "string" ? l : `${l}px`;
  Da({
    effect: "creative",
    swiper: e,
    on: n,
    setTranslate: () => {
      const {
        slides: l,
        wrapperEl: o,
        slidesSizesGrid: u
      } = e, c = e.params.creativeEffect, {
        progressMultiplier: f
      } = c, p = e.params.centeredSlides;
      if (p) {
        const g = u[0] / 2 - e.params.slidesOffsetBefore || 0;
        o.style.transform = `translateX(calc(50% - ${g}px))`;
      }
      for (let g = 0; g < l.length; g += 1) {
        const m = l[g], d = m.progress, w = Math.min(Math.max(m.progress, -c.limitProgress), c.limitProgress);
        let b = w;
        p || (b = Math.min(Math.max(m.originalProgress, -c.limitProgress), c.limitProgress));
        const O = m.swiperSlideOffset, S = [e.params.cssMode ? -O - e.translate : -O, 0, 0], B = [0, 0, 0];
        let T = !1;
        e.isHorizontal() || (S[1] = S[0], S[0] = 0);
        let A = {
          translate: [0, 0, 0],
          rotate: [0, 0, 0],
          scale: 1,
          opacity: 1
        };
        w < 0 ? (A = c.next, T = !0) : w > 0 && (A = c.prev, T = !0), S.forEach((C, P) => {
          S[P] = `calc(${C}px + (${a(A.translate[P])} * ${Math.abs(w * f)}))`;
        }), B.forEach((C, P) => {
          let $ = A.rotate[P] * Math.abs(w * f);
          e.browser && e.browser.need3dFix && Math.abs($) / 90 % 2 === 1 && ($ += 1e-3), B[P] = $;
        }), m.style.zIndex = -Math.abs(Math.round(d)) + l.length;
        const D = S.join(", "), h = `rotateX(${B[0]}deg) rotateY(${B[1]}deg) rotateZ(${B[2]}deg)`, y = b < 0 ? `scale(${1 + (1 - A.scale) * b * f})` : `scale(${1 - (1 - A.scale) * b * f})`, v = b < 0 ? 1 + (1 - A.opacity) * b * f : 1 - (1 - A.opacity) * b * f, E = `translate3d(${D}) ${h} ${y}`;
        if (T && A.shadow || !T) {
          let C = m.querySelector(".swiper-slide-shadow");
          if (!C && A.shadow && (C = fa("creative", m)), C) {
            const P = c.shadowPerProgress ? w * (1 / c.limitProgress) : w;
            C.style.opacity = Math.min(Math.max(Math.abs(P), 0), 1);
          }
        }
        const _ = Fi(c, m);
        _.style.transform = E, _.style.opacity = v, A.origin && (_.style.transformOrigin = A.origin);
      }
    },
    setTransition: (l) => {
      const o = e.slides.map((u) => Sn(u));
      o.forEach((u) => {
        u.style.transitionDuration = `${l}ms`, u.querySelectorAll(".swiper-slide-shadow").forEach((c) => {
          c.style.transitionDuration = `${l}ms`;
        });
      }), mo({
        swiper: e,
        duration: l,
        transformElements: o,
        allSlides: !0
      });
    },
    perspective: () => e.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: !0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function wV(t) {
  let {
    swiper: e,
    extendParams: r,
    on: n
  } = t;
  r({
    cardsEffect: {
      slideShadows: !0,
      rotate: !0,
      perSlideRotate: 2,
      perSlideOffset: 8
    }
  }), Da({
    effect: "cards",
    swiper: e,
    on: n,
    setTranslate: () => {
      const {
        slides: s,
        activeIndex: l,
        rtlTranslate: o
      } = e, u = e.params.cardsEffect, {
        startTranslate: c,
        isTouched: f
      } = e.touchEventsData, p = o ? -e.translate : e.translate;
      for (let g = 0; g < s.length; g += 1) {
        const m = s[g], d = m.progress, w = Math.min(Math.max(d, -4), 4);
        let b = m.swiperSlideOffset;
        e.params.centeredSlides && !e.params.cssMode && (e.wrapperEl.style.transform = `translateX(${e.minTranslate()}px)`), e.params.centeredSlides && e.params.cssMode && (b -= s[0].swiperSlideOffset);
        let O = e.params.cssMode ? -b - e.translate : -b, S = 0;
        const B = -100 * Math.abs(w);
        let T = 1, A = -u.perSlideRotate * w, D = u.perSlideOffset - Math.abs(w) * 0.75;
        const h = e.virtual && e.params.virtual.enabled ? e.virtual.from + g : g, y = (h === l || h === l - 1) && w > 0 && w < 1 && (f || e.params.cssMode) && p < c, v = (h === l || h === l + 1) && w < 0 && w > -1 && (f || e.params.cssMode) && p > c;
        if (y || v) {
          const P = (1 - Math.abs((Math.abs(w) - 0.5) / 0.5)) ** 0.5;
          A += -28 * w * P, T += -0.5 * P, D += 96 * P, S = `${-25 * P * Math.abs(w)}%`;
        }
        if (w < 0 ? O = `calc(${O}px ${o ? "-" : "+"} (${D * Math.abs(w)}%))` : w > 0 ? O = `calc(${O}px ${o ? "-" : "+"} (-${D * Math.abs(w)}%))` : O = `${O}px`, !e.isHorizontal()) {
          const P = S;
          S = O, O = P;
        }
        const E = w < 0 ? `${1 + (1 - T) * w}` : `${1 - (1 - T) * w}`, _ = `
        translate3d(${O}, ${S}, ${B}px)
        rotateZ(${u.rotate ? o ? -A : A : 0}deg)
        scale(${E})
      `;
        if (u.slideShadows) {
          let P = m.querySelector(".swiper-slide-shadow");
          P || (P = fa("cards", m)), P && (P.style.opacity = Math.min(Math.max((Math.abs(w) - 0.5) / 0.5, 0), 1));
        }
        m.style.zIndex = -Math.abs(Math.round(d)) + s.length;
        const C = Fi(u, m);
        C.style.transform = _;
      }
    },
    setTransition: (s) => {
      const l = e.slides.map((o) => Sn(o));
      l.forEach((o) => {
        o.style.transitionDuration = `${s}ms`, o.querySelectorAll(".swiper-slide-shadow").forEach((u) => {
          u.style.transitionDuration = `${s}ms`;
        });
      }), mo({
        swiper: e,
        duration: s,
        transformElements: l
      });
    },
    perspective: () => !0,
    overwriteParams: () => ({
      watchSlidesProgress: !0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
const xV = [GU, YU, KU, XU, ZU, JU, QU, eV, tV, rV, nV, aV, iV, sV, oV, lV, hV, gV, vV, mV, yV, bV, wV];
Mi.use(xV);
const Sa = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "swiperElementNodeName",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "breakpointsBase",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopAdditionalSlides",
  "loopAddBlankSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideFullyVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "slideBlankClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function Or(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object" && !t.__swiper__;
}
function Hr(t, e) {
  const r = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter((n) => r.indexOf(n) < 0).forEach((n) => {
    typeof t[n] > "u" ? t[n] = e[n] : Or(e[n]) && Or(t[n]) && Object.keys(e[n]).length > 0 ? e[n].__swiper__ ? t[n] = e[n] : Hr(t[n], e[n]) : t[n] = e[n];
  });
}
function pf(t) {
  return t === void 0 && (t = {}), t.navigation && typeof t.navigation.nextEl > "u" && typeof t.navigation.prevEl > "u";
}
function hf(t) {
  return t === void 0 && (t = {}), t.pagination && typeof t.pagination.el > "u";
}
function gf(t) {
  return t === void 0 && (t = {}), t.scrollbar && typeof t.scrollbar.el > "u";
}
function Sy(t) {
  t === void 0 && (t = "");
  const e = t.split(" ").map((n) => n.trim()).filter((n) => !!n), r = [];
  return e.forEach((n) => {
    r.indexOf(n) < 0 && r.push(n);
  }), r.join(" ");
}
function ds(t) {
  return t === void 0 && (t = ""), t.replace(/-[a-z]/g, (e) => e.toUpperCase().replace("-", ""));
}
function EV(t) {
  return t === void 0 && (t = ""), t ? t.includes("swiper-wrapper") ? t : `swiper-wrapper ${t}` : "swiper-wrapper";
}
function Oy(t) {
  let {
    swiper: e,
    slides: r,
    passedParams: n,
    changedParams: a,
    nextEl: i,
    prevEl: s,
    scrollbarEl: l,
    paginationEl: o
  } = t;
  const u = a.filter((y) => y !== "children" && y !== "direction" && y !== "wrapperClass"), {
    params: c,
    pagination: f,
    navigation: p,
    scrollbar: g,
    virtual: m,
    thumbs: d
  } = e;
  let w, b, O, S, B, T, A, D;
  a.includes("thumbs") && n.thumbs && n.thumbs.swiper && c.thumbs && !c.thumbs.swiper && (w = !0), a.includes("controller") && n.controller && n.controller.control && c.controller && !c.controller.control && (b = !0), a.includes("pagination") && n.pagination && (n.pagination.el || o) && (c.pagination || c.pagination === !1) && f && !f.el && (O = !0), a.includes("scrollbar") && n.scrollbar && (n.scrollbar.el || l) && (c.scrollbar || c.scrollbar === !1) && g && !g.el && (S = !0), a.includes("navigation") && n.navigation && (n.navigation.prevEl || s) && (n.navigation.nextEl || i) && (c.navigation || c.navigation === !1) && p && !p.prevEl && !p.nextEl && (B = !0);
  const h = (y) => {
    e[y] && (e[y].destroy(), y === "navigation" ? (e.isElement && (e[y].prevEl.remove(), e[y].nextEl.remove()), c[y].prevEl = void 0, c[y].nextEl = void 0, e[y].prevEl = void 0, e[y].nextEl = void 0) : (e.isElement && e[y].el.remove(), c[y].el = void 0, e[y].el = void 0));
  };
  a.includes("loop") && e.isElement && (c.loop && !n.loop ? T = !0 : !c.loop && n.loop ? A = !0 : D = !0), u.forEach((y) => {
    if (Or(c[y]) && Or(n[y]))
      Object.assign(c[y], n[y]), (y === "navigation" || y === "pagination" || y === "scrollbar") && "enabled" in n[y] && !n[y].enabled && h(y);
    else {
      const v = n[y];
      (v === !0 || v === !1) && (y === "navigation" || y === "pagination" || y === "scrollbar") ? v === !1 && h(y) : c[y] = n[y];
    }
  }), u.includes("controller") && !b && e.controller && e.controller.control && c.controller && c.controller.control && (e.controller.control = c.controller.control), a.includes("children") && r && m && c.virtual.enabled ? (m.slides = r, m.update(!0)) : a.includes("virtual") && m && c.virtual.enabled && (r && (m.slides = r), m.update(!0)), a.includes("children") && r && c.loop && (D = !0), w && d.init() && d.update(!0), b && (e.controller.control = c.controller.control), O && (e.isElement && (!o || typeof o == "string") && (o = document.createElement("div"), o.classList.add("swiper-pagination"), o.part.add("pagination"), e.el.appendChild(o)), o && (c.pagination.el = o), f.init(), f.render(), f.update()), S && (e.isElement && (!l || typeof l == "string") && (l = document.createElement("div"), l.classList.add("swiper-scrollbar"), l.part.add("scrollbar"), e.el.appendChild(l)), l && (c.scrollbar.el = l), g.init(), g.updateSize(), g.setTranslate()), B && (e.isElement && ((!i || typeof i == "string") && (i = document.createElement("div"), i.classList.add("swiper-button-next"), i.innerHTML = e.hostEl.constructor.nextButtonSvg, i.part.add("button-next"), e.el.appendChild(i)), (!s || typeof s == "string") && (s = document.createElement("div"), s.classList.add("swiper-button-prev"), s.innerHTML = e.hostEl.constructor.prevButtonSvg, s.part.add("button-prev"), e.el.appendChild(s))), i && (c.navigation.nextEl = i), s && (c.navigation.prevEl = s), p.init(), p.update()), a.includes("allowSlideNext") && (e.allowSlideNext = n.allowSlideNext), a.includes("allowSlidePrev") && (e.allowSlidePrev = n.allowSlidePrev), a.includes("direction") && e.changeDirection(n.direction, !1), (T || D) && e.loopDestroy(), (A || D) && e.loopCreate(), e.update();
}
const Xg = (t) => {
  if (parseFloat(t) === Number(t))
    return Number(t);
  if (t === "true" || t === "")
    return !0;
  if (t === "false")
    return !1;
  if (t === "null")
    return null;
  if (t !== "undefined") {
    if (typeof t == "string" && t.includes("{") && t.includes("}") && t.includes('"')) {
      let e;
      try {
        e = JSON.parse(t);
      } catch {
        e = t;
      }
      return e;
    }
    return t;
  }
}, Zg = ["a11y", "autoplay", "controller", "cards-effect", "coverflow-effect", "creative-effect", "cube-effect", "fade-effect", "flip-effect", "free-mode", "grid", "hash-navigation", "history", "keyboard", "mousewheel", "navigation", "pagination", "parallax", "scrollbar", "thumbs", "virtual", "zoom"];
function Jg(t, e, r) {
  const n = {}, a = {};
  Hr(n, Ls);
  const i = [...Sa, "on"], s = i.map((o) => o.replace(/_/, ""));
  i.forEach((o) => {
    o = o.replace("_", ""), typeof t[o] < "u" && (a[o] = t[o]);
  });
  const l = [...t.attributes];
  return typeof e == "string" && typeof r < "u" && l.push({
    name: e,
    value: Or(r) ? {
      ...r
    } : r
  }), l.forEach((o) => {
    const u = Zg.filter((c) => o.name.indexOf(`${c}-`) === 0)[0];
    if (u) {
      const c = ds(u), f = ds(o.name.split(`${u}-`)[1]);
      typeof a[c] > "u" && (a[c] = {}), a[c] === !0 && (a[c] = {
        enabled: !0
      }), a[c][f] = Xg(o.value);
    } else {
      const c = ds(o.name);
      if (!s.includes(c))
        return;
      const f = Xg(o.value);
      a[c] && Zg.includes(o.name) && !Or(f) ? (a[c].constructor !== Object && (a[c] = {}), a[c].enabled = !!f) : a[c] = f;
    }
  }), Hr(n, a), n.navigation ? n.navigation = {
    prevEl: ".swiper-button-prev",
    nextEl: ".swiper-button-next",
    ...n.navigation !== !0 ? n.navigation : {}
  } : n.navigation === !1 && delete n.navigation, n.scrollbar ? n.scrollbar = {
    el: ".swiper-scrollbar",
    ...n.scrollbar !== !0 ? n.scrollbar : {}
  } : n.scrollbar === !1 && delete n.scrollbar, n.pagination ? n.pagination = {
    el: ".swiper-pagination",
    ...n.pagination !== !0 ? n.pagination : {}
  } : n.pagination === !1 && delete n.pagination, {
    params: n,
    passedParams: a
  };
}
const CV = ":host{--swiper-theme-color:#007aff}:host{position:relative;display:block;margin-left:auto;margin-right:auto;z-index:1}.swiper{width:100%;height:100%;margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1;display:block}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;transition-timing-function:var(--swiper-wrapper-transition-timing-function,initial);box-sizing:content-box}.swiper-android ::slotted(swiper-slide),.swiper-ios ::slotted(swiper-slide),.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-horizontal{touch-action:pan-y}.swiper-vertical{touch-action:pan-x}::slotted(swiper-slide){flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform;display:block}::slotted(.swiper-slide-invisible-blank){visibility:hidden}.swiper-autoheight,.swiper-autoheight ::slotted(swiper-slide){height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden ::slotted(swiper-slide){transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d ::slotted(swiper-slide){transform-style:preserve-3d}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode ::slotted(swiper-slide){scroll-snap-align:start start}.swiper-css-mode.swiper-horizontal>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-css-mode.swiper-vertical>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-css-mode.swiper-free-mode>.swiper-wrapper{scroll-snap-type:none}.swiper-css-mode.swiper-free-mode ::slotted(swiper-slide){scroll-snap-align:none}.swiper-css-mode.swiper-centered>.swiper-wrapper::before{content:'';flex-shrink:0;order:9999}.swiper-css-mode.swiper-centered ::slotted(swiper-slide){scroll-snap-align:center center;scroll-snap-stop:always}.swiper-css-mode.swiper-centered.swiper-horizontal ::slotted(swiper-slide):first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-horizontal>.swiper-wrapper::before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-css-mode.swiper-centered.swiper-vertical ::slotted(swiper-slide):first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-vertical>.swiper-wrapper::before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-virtual ::slotted(swiper-slide){-webkit-backface-visibility:hidden;transform:translateZ(0)}.swiper-virtual.swiper-css-mode .swiper-wrapper::after{content:'';position:absolute;left:0;top:0;pointer-events:none}.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after{height:1px;width:var(--swiper-virtual-size)}.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after{width:1px;height:var(--swiper-virtual-size)}:host{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:var(--swiper-navigation-top-offset,50%);width:calc(var(--swiper-navigation-size)/ 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size)/ 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next.swiper-button-hidden,.swiper-button-prev.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-next,.swiper-navigation-disabled .swiper-button-prev{display:none!important}.swiper-button-next svg,.swiper-button-prev svg{width:100%;height:100%;object-fit:contain;transform-origin:center}.swiper-rtl .swiper-button-next svg,.swiper-rtl .swiper-button-prev svg{transform:rotate(180deg)}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:var(--swiper-navigation-sides-offset,10px);right:auto}.swiper-button-next,.swiper-rtl .swiper-button-prev{right:var(--swiper-navigation-sides-offset,10px);left:auto}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:var(--swiper-pagination-bottom,8px);top:var(--swiper-pagination-top,auto);left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width,var(--swiper-pagination-bullet-size,8px));height:var(--swiper-pagination-bullet-height,var(--swiper-pagination-bullet-size,8px));display:inline-block;border-radius:var(--swiper-pagination-bullet-border-radius,50%);background:var(--swiper-pagination-bullet-inactive-color,#000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:var(--swiper-pagination-right,8px);left:var(--swiper-pagination-left,auto);top:50%;transform:translate3d(0px,-50%,0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap,6px) 0;display:block}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap,4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-fraction{color:var(--swiper-pagination-fraction-color,inherit)}.swiper-pagination-progressbar{background:var(--swiper-pagination-progressbar-bg-color,rgba(0,0,0,.25));position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:var(--swiper-pagination-progressbar-size,4px);left:0;top:0}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{width:var(--swiper-pagination-progressbar-size,4px);height:100%;left:0;top:0}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:var(--swiper-scrollbar-border-radius,10px);position:relative;touch-action:none;background:var(--swiper-scrollbar-bg-color,rgba(0,0,0,.1))}.swiper-scrollbar-disabled>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-disabled{display:none!important}.swiper-horizontal>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-horizontal{position:absolute;left:var(--swiper-scrollbar-sides-offset,1%);bottom:var(--swiper-scrollbar-bottom,4px);top:var(--swiper-scrollbar-top,auto);z-index:50;height:var(--swiper-scrollbar-size,4px);width:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar.swiper-scrollbar-vertical,.swiper-vertical>.swiper-scrollbar{position:absolute;left:var(--swiper-scrollbar-left,auto);right:var(--swiper-scrollbar-right,4px);top:var(--swiper-scrollbar-sides-offset,1%);z-index:50;width:var(--swiper-scrollbar-size,4px);height:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:var(--swiper-scrollbar-drag-bg-color,rgba(0,0,0,.5));border-radius:var(--swiper-scrollbar-border-radius,10px);left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}::slotted(.swiper-slide-zoomed){cursor:move;touch-action:none}.swiper .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-grid>.swiper-wrapper{flex-wrap:wrap}.swiper-grid-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-fade.swiper-free-mode ::slotted(swiper-slide){transition-timing-function:ease-out}.swiper-fade ::slotted(swiper-slide){pointer-events:none;transition-property:opacity}.swiper-fade ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-fade ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-fade ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-cube{overflow:visible}.swiper-cube ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-cube ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-cube.swiper-rtl ::slotted(swiper-slide){transform-origin:100% 0}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-next),.swiper-cube ::slotted(.swiper-slide-prev){pointer-events:auto;visibility:visible}.swiper-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0px;width:100%;height:100%;opacity:.6;z-index:0}.swiper-cube .swiper-cube-shadow:before{content:'';background:#000;position:absolute;left:0;top:0;bottom:0;right:0;filter:blur(50px)}.swiper-cube ::slotted(.swiper-slide-next)+::slotted(swiper-slide){pointer-events:auto;visibility:visible}.swiper-flip{overflow:visible}.swiper-flip ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-flip ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-flip ::slotted(.swiper-slide-active),.swiper-flip ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-creative ::slotted(swiper-slide){-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden;transition-property:transform,opacity,height}.swiper-cards{overflow:visible}.swiper-cards ::slotted(swiper-slide){transform-origin:center bottom;-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden}", DV = "::slotted(.swiper-slide-shadow),::slotted(.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-top){position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}::slotted(.swiper-slide-shadow){background:rgba(0,0,0,.15)}::slotted(.swiper-slide-shadow-left){background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-right){background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-top){background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-bottom){background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear;width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}@keyframes swiper-preloader-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-zoom-container){width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}::slotted(.swiper-zoom-container)>canvas,::slotted(.swiper-zoom-container)>img,::slotted(.swiper-zoom-container)>svg{max-width:100%;max-height:100%;object-fit:contain}";
class SV {
}
const Py = typeof window > "u" || typeof HTMLElement > "u" ? SV : HTMLElement, Qg = `<svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>
    `, _y = (t, e) => {
  if (typeof CSSStyleSheet < "u" && t.adoptedStyleSheets) {
    const r = new CSSStyleSheet();
    r.replaceSync(e), t.adoptedStyleSheets = [r];
  } else {
    const r = document.createElement("style");
    r.rel = "stylesheet", r.textContent = e, t.appendChild(r);
  }
};
class Ay extends Py {
  constructor() {
    super(), this.attachShadow({
      mode: "open"
    });
  }
  static get nextButtonSvg() {
    return Qg;
  }
  static get prevButtonSvg() {
    return Qg.replace("/></svg>", ' transform-origin="center" transform="rotate(180)"/></svg>');
  }
  cssStyles() {
    return [
      CV,
      // eslint-disable-line
      ...this.injectStyles && Array.isArray(this.injectStyles) ? this.injectStyles : []
    ].join(`
`);
  }
  cssLinks() {
    return this.injectStylesUrls || [];
  }
  calcSlideSlots() {
    const e = this.slideSlots || 0, r = [...this.querySelectorAll("[slot^=slide-]")].map((n) => parseInt(n.getAttribute("slot").split("slide-")[1], 10));
    if (this.slideSlots = r.length ? Math.max(...r) + 1 : 0, !!this.rendered) {
      if (this.slideSlots > e)
        for (let n = e; n < this.slideSlots; n += 1) {
          const a = document.createElement("swiper-slide");
          a.setAttribute("part", `slide slide-${n + 1}`);
          const i = document.createElement("slot");
          i.setAttribute("name", `slide-${n + 1}`), a.appendChild(i), this.shadowRoot.querySelector(".swiper-wrapper").appendChild(a);
        }
      else if (this.slideSlots < e) {
        const n = this.swiper.slides;
        for (let a = n.length - 1; a >= 0; a -= 1)
          a > this.slideSlots && n[a].remove();
      }
    }
  }
  render() {
    if (this.rendered)
      return;
    this.calcSlideSlots();
    let e = this.cssStyles();
    this.slideSlots > 0 && (e = e.replace(/::slotted\(([a-z-0-9.]*)\)/g, "$1")), e.length && _y(this.shadowRoot, e), this.cssLinks().forEach((n) => {
      if (this.shadowRoot.querySelector(`link[href="${n}"]`))
        return;
      const i = document.createElement("link");
      i.rel = "stylesheet", i.href = n, this.shadowRoot.appendChild(i);
    });
    const r = document.createElement("div");
    r.classList.add("swiper"), r.part = "container", r.innerHTML = `
      <slot name="container-start"></slot>
      <div class="swiper-wrapper" part="wrapper">
        <slot></slot>
        ${Array.from({
      length: this.slideSlots
    }).map((n, a) => `
        <swiper-slide part="slide slide-${a}">
          <slot name="slide-${a}"></slot>
        </swiper-slide>
        `).join("")}
      </div>
      <slot name="container-end"></slot>
      ${pf(this.passedParams) ? `
        <div part="button-prev" class="swiper-button-prev">${this.constructor.prevButtonSvg}</div>
        <div part="button-next" class="swiper-button-next">${this.constructor.nextButtonSvg}</div>
      ` : ""}
      ${hf(this.passedParams) ? `
        <div part="pagination" class="swiper-pagination"></div>
      ` : ""}
      ${gf(this.passedParams) ? `
        <div part="scrollbar" class="swiper-scrollbar"></div>
      ` : ""}
    `, this.shadowRoot.appendChild(r), this.rendered = !0;
  }
  initialize() {
    var e = this;
    if (this.initialized)
      return;
    this.initialized = !0;
    const {
      params: r,
      passedParams: n
    } = Jg(this);
    this.swiperParams = r, this.passedParams = n, delete this.swiperParams.init, this.render(), this.swiper = new Mi(this.shadowRoot.querySelector(".swiper"), {
      ...r.virtual ? {} : {
        observer: !0,
        observeSlideChildren: this.slideSlots > 0
      },
      ...r,
      touchEventsTarget: "container",
      onAny: function(a) {
        a === "observerUpdate" && e.calcSlideSlots();
        const i = r.eventsPrefix ? `${r.eventsPrefix}${a.toLowerCase()}` : a.toLowerCase();
        for (var s = arguments.length, l = new Array(s > 1 ? s - 1 : 0), o = 1; o < s; o++)
          l[o - 1] = arguments[o];
        const u = new CustomEvent(i, {
          detail: l,
          bubbles: a !== "hashChange",
          cancelable: !0
        });
        e.dispatchEvent(u);
      }
    });
  }
  connectedCallback() {
    this.initialized && this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM || this.init === !1 || this.getAttribute("init") === "false" || this.initialize();
  }
  disconnectedCallback() {
    this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM || (this.swiper && this.swiper.destroy && this.swiper.destroy(), this.initialized = !1);
  }
  updateSwiperOnPropChange(e, r) {
    const {
      params: n,
      passedParams: a
    } = Jg(this, e, r);
    this.passedParams = a, this.swiperParams = n, !(this.swiper && this.swiper.params[e] === r) && Oy({
      swiper: this.swiper,
      passedParams: this.passedParams,
      changedParams: [ds(e)],
      ...e === "navigation" && a[e] ? {
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next"
      } : {},
      ...e === "pagination" && a[e] ? {
        paginationEl: ".swiper-pagination"
      } : {},
      ...e === "scrollbar" && a[e] ? {
        scrollbarEl: ".swiper-scrollbar"
      } : {}
    });
  }
  attributeChangedCallback(e, r, n) {
    this.initialized && (r === "true" && n === null && (n = !1), this.updateSwiperOnPropChange(e, n));
  }
  static get observedAttributes() {
    return Sa.filter((r) => r.includes("_")).map((r) => r.replace(/[A-Z]/g, (n) => `-${n}`).replace("_", "").toLowerCase());
  }
}
Sa.forEach((t) => {
  t !== "init" && (t = t.replace("_", ""), Object.defineProperty(Ay.prototype, t, {
    configurable: !0,
    get() {
      return (this.passedParams || {})[t];
    },
    set(e) {
      this.passedParams || (this.passedParams = {}), this.passedParams[t] = e, this.initialized && this.updateSwiperOnPropChange(t, e);
    }
  }));
});
let OV = class extends Py {
  constructor() {
    super(), this.attachShadow({
      mode: "open"
    });
  }
  render() {
    const e = this.lazy || this.getAttribute("lazy") === "" || this.getAttribute("lazy") === "true";
    if (_y(this.shadowRoot, DV), this.shadowRoot.appendChild(document.createElement("slot")), e) {
      const r = document.createElement("div");
      r.classList.add("swiper-lazy-preloader"), r.part.add("preloader"), this.shadowRoot.appendChild(r);
    }
  }
  initialize() {
    this.render();
  }
  connectedCallback() {
    this.initialize();
  }
};
const PV = () => {
  typeof window > "u" || (window.customElements.get("swiper-container") || window.customElements.define("swiper-container", Ay), window.customElements.get("swiper-slide") || window.customElements.define("swiper-slide", OV));
};
typeof window < "u" && (window.SwiperElementRegisterParams = (t) => {
  Sa.push(...t);
});
function _V(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = !0);
  const r = {
    on: {}
  }, n = {}, a = {};
  Hr(r, Ls), r._emitClasses = !0, r.init = !1;
  const i = {}, s = Sa.map((o) => o.replace(/_/, "")), l = Object.assign({}, t);
  return Object.keys(l).forEach((o) => {
    typeof t[o] > "u" || (s.indexOf(o) >= 0 ? Or(t[o]) ? (r[o] = {}, a[o] = {}, Hr(r[o], t[o]), Hr(a[o], t[o])) : (r[o] = t[o], a[o] = t[o]) : o.search(/on[A-Z]/) === 0 && typeof t[o] == "function" ? e ? n[`${o[2].toLowerCase()}${o.substr(3)}`] = t[o] : r.on[`${o[2].toLowerCase()}${o.substr(3)}`] = t[o] : i[o] = t[o]);
  }), ["navigation", "pagination", "scrollbar"].forEach((o) => {
    r[o] === !0 && (r[o] = {}), r[o] === !1 && delete r[o];
  }), {
    params: r,
    passedParams: a,
    rest: i,
    events: n
  };
}
function AV(t, e) {
  let {
    el: r,
    nextEl: n,
    prevEl: a,
    paginationEl: i,
    scrollbarEl: s,
    swiper: l
  } = t;
  pf(e) && n && a && (l.params.navigation.nextEl = n, l.originalParams.navigation.nextEl = n, l.params.navigation.prevEl = a, l.originalParams.navigation.prevEl = a), hf(e) && i && (l.params.pagination.el = i, l.originalParams.pagination.el = i), gf(e) && s && (l.params.scrollbar.el = s, l.originalParams.scrollbar.el = s), l.init(r);
}
function TV(t, e, r, n, a) {
  const i = [];
  if (!e)
    return i;
  const s = (o) => {
    i.indexOf(o) < 0 && i.push(o);
  };
  if (r && n) {
    const o = n.map(a), u = r.map(a);
    o.join("") !== u.join("") && s("children"), n.length !== r.length && s("children");
  }
  return Sa.filter((o) => o[0] === "_").map((o) => o.replace(/_/, "")).forEach((o) => {
    if (o in t && o in e)
      if (Or(t[o]) && Or(e[o])) {
        const u = Object.keys(t[o]), c = Object.keys(e[o]);
        u.length !== c.length ? s(o) : (u.forEach((f) => {
          t[o][f] !== e[o][f] && s(o);
        }), c.forEach((f) => {
          t[o][f] !== e[o][f] && s(o);
        }));
      } else
        t[o] !== e[o] && s(o);
  }), i;
}
const BV = (t) => {
  !t || t.destroyed || !t.params.virtual || t.params.virtual && !t.params.virtual.enabled || (t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), t.parallax && t.params.parallax && t.params.parallax.enabled && t.parallax.setTranslate());
};
function ks() {
  return ks = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, ks.apply(this, arguments);
}
function Ty(t) {
  return t.type && t.type.displayName && t.type.displayName.includes("SwiperSlide");
}
function By(t) {
  const e = [];
  return M.Children.toArray(t).forEach((r) => {
    Ty(r) ? e.push(r) : r.props && r.props.children && By(r.props.children).forEach((n) => e.push(n));
  }), e;
}
function RV(t) {
  const e = [], r = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  };
  return M.Children.toArray(t).forEach((n) => {
    if (Ty(n))
      e.push(n);
    else if (n.props && n.props.slot && r[n.props.slot])
      r[n.props.slot].push(n);
    else if (n.props && n.props.children) {
      const a = By(n.props.children);
      a.length > 0 ? a.forEach((i) => e.push(i)) : r["container-end"].push(n);
    } else
      r["container-end"].push(n);
  }), {
    slides: e,
    slots: r
  };
}
function $V(t, e, r) {
  if (!r)
    return null;
  const n = (c) => {
    let f = c;
    return c < 0 ? f = e.length + c : f >= e.length && (f = f - e.length), f;
  }, a = t.isHorizontal() ? {
    [t.rtlTranslate ? "right" : "left"]: `${r.offset}px`
  } : {
    top: `${r.offset}px`
  }, {
    from: i,
    to: s
  } = r, l = t.params.loop ? -e.length : 0, o = t.params.loop ? e.length * 2 : e.length, u = [];
  for (let c = l; c < o; c += 1)
    c >= i && c <= s && u.push(e[n(c)]);
  return u.map((c, f) => /* @__PURE__ */ M.cloneElement(c, {
    swiper: t,
    style: a,
    key: `slide-${f}`
  }));
}
function ai(t, e) {
  return typeof window > "u" ? xe(t, e) : rv(t, e);
}
const ev = /* @__PURE__ */ Vt(null), Ry = /* @__PURE__ */ Vt(null), vf = () => Ht(Ry), $y = /* @__PURE__ */ hr(function(t, e) {
  let {
    className: r,
    tag: n = "div",
    wrapperTag: a = "div",
    children: i,
    onSwiper: s,
    ...l
  } = t === void 0 ? {} : t, o = !1;
  const [u, c] = $e("swiper"), [f, p] = $e(null), [g, m] = $e(!1), d = de(!1), w = de(null), b = de(null), O = de(null), S = de(null), B = de(null), T = de(null), A = de(null), D = de(null), {
    params: h,
    passedParams: y,
    rest: v,
    events: E
  } = _V(l), {
    slides: _,
    slots: C
  } = RV(i), P = () => {
    m(!g);
  };
  Object.assign(h.on, {
    _containerClasses(F, k) {
      c(k);
    }
  });
  const $ = () => {
    Object.assign(h.on, E), o = !0;
    const F = {
      ...h
    };
    if (delete F.wrapperClass, b.current = new Mi(F), b.current.virtual && b.current.params.virtual.enabled) {
      b.current.virtual.slides = _;
      const k = {
        cache: !1,
        slides: _,
        renderExternal: p,
        renderExternalUpdate: !1
      };
      Hr(b.current.params.virtual, k), Hr(b.current.originalParams.virtual, k);
    }
  };
  w.current || $(), b.current && b.current.on("_beforeBreakpoint", P);
  const W = () => {
    o || !E || !b.current || Object.keys(E).forEach((F) => {
      b.current.on(F, E[F]);
    });
  }, j = () => {
    !E || !b.current || Object.keys(E).forEach((F) => {
      b.current.off(F, E[F]);
    });
  };
  xe(() => () => {
    b.current && b.current.off("_beforeBreakpoint", P);
  }), xe(() => {
    !d.current && b.current && (b.current.emitSlidesClasses(), d.current = !0);
  }), ai(() => {
    if (e && (e.current = w.current), !!w.current)
      return b.current.destroyed && $(), AV({
        el: w.current,
        nextEl: B.current,
        prevEl: T.current,
        paginationEl: A.current,
        scrollbarEl: D.current,
        swiper: b.current
      }, h), s && !b.current.destroyed && s(b.current), () => {
        b.current && !b.current.destroyed && b.current.destroy(!0, !1);
      };
  }, []), ai(() => {
    W();
    const F = TV(y, O.current, _, S.current, (k) => k.key);
    return O.current = y, S.current = _, F.length && b.current && !b.current.destroyed && Oy({
      swiper: b.current,
      slides: _,
      passedParams: y,
      changedParams: F,
      nextEl: B.current,
      prevEl: T.current,
      scrollbarEl: D.current,
      paginationEl: A.current
    }), () => {
      j();
    };
  }), ai(() => {
    BV(b.current);
  }, [f]);
  function I() {
    return h.virtual ? $V(b.current, _, f) : _.map((F, k) => /* @__PURE__ */ M.cloneElement(F, {
      swiper: b.current,
      swiperSlideIndex: k
    }));
  }
  return /* @__PURE__ */ M.createElement(n, ks({
    ref: w,
    className: Sy(`${u}${r ? ` ${r}` : ""}`)
  }, v), /* @__PURE__ */ M.createElement(Ry.Provider, {
    value: b.current
  }, C["container-start"], /* @__PURE__ */ M.createElement(a, {
    className: EV(h.wrapperClass)
  }, C["wrapper-start"], I(), C["wrapper-end"]), pf(h) && /* @__PURE__ */ M.createElement(M.Fragment, null, /* @__PURE__ */ M.createElement("div", {
    ref: T,
    className: "swiper-button-prev"
  }), /* @__PURE__ */ M.createElement("div", {
    ref: B,
    className: "swiper-button-next"
  })), gf(h) && /* @__PURE__ */ M.createElement("div", {
    ref: D,
    className: "swiper-scrollbar"
  }), hf(h) && /* @__PURE__ */ M.createElement("div", {
    ref: A,
    className: "swiper-pagination"
  }), C["container-end"]));
});
$y.displayName = "Swiper";
const My = /* @__PURE__ */ hr(function(t, e) {
  let {
    tag: r = "div",
    children: n,
    className: a = "",
    swiper: i,
    zoom: s,
    lazy: l,
    virtualIndex: o,
    swiperSlideIndex: u,
    ...c
  } = t === void 0 ? {} : t;
  const f = de(null), [p, g] = $e("swiper-slide"), [m, d] = $e(!1);
  function w(B, T, A) {
    T === f.current && g(A);
  }
  ai(() => {
    if (typeof u < "u" && (f.current.swiperSlideIndex = u), e && (e.current = f.current), !(!f.current || !i)) {
      if (i.destroyed) {
        p !== "swiper-slide" && g("swiper-slide");
        return;
      }
      return i.on("_slideClass", w), () => {
        i && i.off("_slideClass", w);
      };
    }
  }), ai(() => {
    i && f.current && !i.destroyed && g(i.getSlideClasses(f.current));
  }, [i]);
  const b = {
    isActive: p.indexOf("swiper-slide-active") >= 0,
    isVisible: p.indexOf("swiper-slide-visible") >= 0,
    isPrev: p.indexOf("swiper-slide-prev") >= 0,
    isNext: p.indexOf("swiper-slide-next") >= 0
  }, O = () => typeof n == "function" ? n(b) : n, S = () => {
    d(!0);
  };
  return /* @__PURE__ */ M.createElement(r, ks({
    ref: f,
    className: Sy(`${p}${a ? ` ${a}` : ""}`),
    "data-swiper-slide-index": o,
    onLoad: S
  }, c), s && /* @__PURE__ */ M.createElement(ev.Provider, {
    value: b
  }, /* @__PURE__ */ M.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof s == "number" ? s : void 0
  }, O(), l && !m && /* @__PURE__ */ M.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !s && /* @__PURE__ */ M.createElement(ev.Provider, {
    value: b
  }, O(), l && !m && /* @__PURE__ */ M.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
My.displayName = "SwiperSlide";
var cn = /* @__PURE__ */ ((t) => (t.light = "LIGHT", t.dark = "DARK", t))(cn || {});
const MV = () => {
  const { loc: t } = se(), {
    actions: { setProp: e },
    appearance: r
  } = me((n) => ({
    appearance: n.data.props.appearance
  }));
  return /* @__PURE__ */ x.jsxs(
    wu,
    {
      hugContentOff: !0,
      width: "100%",
      className: Kl.segment,
      value: r,
      onWppChange: ({ detail: n }) => {
        e((a) => {
          a && (a.appearance = n.value);
        });
      },
      children: [
        /* @__PURE__ */ x.jsx(oi, { value: "LIGHT", children: t("light") }),
        /* @__PURE__ */ x.jsx(oi, { value: "DARK", children: t("dark") })
      ]
    }
  );
}, FV = "_right_i6sen_1", IV = "_left_i6sen_6", jV = "_arrow_i6sen_11", LV = "_dark_i6sen_26", sa = {
  right: FV,
  left: IV,
  arrow: jV,
  dark: LV
}, kV = (t) => /* @__PURE__ */ we.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ we.createElement("g", { id: "Chevron" }, /* @__PURE__ */ we.createElement("path", { id: "Shape", fillRule: "evenodd", clipRule: "evenodd", d: "M12.7071 3.29289C13.0976 3.68342 13.0976 4.31658 12.7071 4.70711L7.41421 10L12.7071 15.2929C13.0976 15.6834 13.0976 16.3166 12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L5.29289 10.7071C4.90237 10.3166 4.90237 9.68342 5.29289 9.29289L11.2929 3.29289C11.6834 2.90237 12.3166 2.90237 12.7071 3.29289Z", fill: "white" }))), NV = (t) => /* @__PURE__ */ we.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...t }, /* @__PURE__ */ we.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.29289 16.7071C6.90237 16.3166 6.90237 15.6834 7.29289 15.2929L12.5858 10L7.29289 4.70711C6.90237 4.31658 6.90237 3.68342 7.29289 3.29289C7.68342 2.90237 8.31658 2.90237 8.70711 3.29289L14.7071 9.29289C15.0976 9.68342 15.0976 10.3166 14.7071 10.7071L8.70711 16.7071C8.31658 17.0976 7.68342 17.0976 7.29289 16.7071Z", fill: "white" })), zV = () => {
  const { withArrows: t, appearance: e } = me((n) => ({
    withArrows: n.data.props.withArrows,
    appearance: n.data.props.appearance
  })), r = vf();
  return t && /* @__PURE__ */ x.jsx(
    "button",
    {
      type: "button",
      onClick: () => r.slidePrev(),
      className: ke(sa.arrow, sa.left, { [sa.dark]: e === cn.dark }),
      "aria-label": "Previous slide",
      children: /* @__PURE__ */ x.jsx(kV, {})
    }
  );
}, WV = () => {
  const { withArrows: t, appearance: e } = me((n) => ({
    withArrows: n.data.props.withArrows,
    appearance: n.data.props.appearance
  })), r = vf();
  return t && /* @__PURE__ */ x.jsx(
    "button",
    {
      type: "button",
      onClick: () => r.slideNext(),
      className: ke(sa.arrow, sa.right, { [sa.dark]: e === cn.dark }),
      "aria-label": "Previous slide",
      children: /* @__PURE__ */ x.jsx(NV, {})
    }
  );
}, HV = "_container_1mcd7_1", UV = "_slidesWrapper_1mcd7_16", VV = "_animation_1mcd7_27", qV = "_slideWrapper_1mcd7_32", GV = "_isReversing_1mcd7_37", YV = "_carousel_1mcd7_41", KV = "_containerLight_1mcd7_46", XV = "_selectedContainerLight_1mcd7_56", rs = {
  container: HV,
  slidesWrapper: UV,
  animation: VV,
  slideWrapper: qV,
  isReversing: GV,
  carousel: YV,
  containerLight: KV,
  selectedContainerLight: XV
}, ZV = "_section_t8jci_1", Bl = {
  section: ZV
}, Fy = () => {
  const {
    actions: { setProp: t },
    value: e,
    items: r
  } = me((s) => ({ value: s.data.props.selected, items: s.data.props.items })), n = oe(
    (s) => t((l) => {
      l.selected = s;
    }),
    [t]
  );
  xe(() => {
    var s;
    e || n((s = r[0]) == null ? void 0 : s.id);
  }, [n]);
  const a = oe(() => {
    t((s) => {
      s.items = [...s.items, $i(s.items.length + 1)];
      const l = s.items[s.items.length - 1].id;
      setTimeout(() => n(l), 0);
    });
  }, [t, n]), i = oe(
    (s) => () => {
      t((l) => {
        const o = l.items.findIndex((f) => f.id === s), u = l.items[o].id === e;
        l.items.splice(o, 1);
        const c = l.items[Math.min(o, l.items.length - 1)].id;
        u && setTimeout(() => n(c), 0);
      });
    },
    [t, e, n]
  );
  return {
    value: e,
    selectItemById: n,
    addItem: a,
    removeItem: i
  };
}, JV = "_select_1b7yg_1", QV = "_buttons_1b7yg_5", tv = {
  select: JV,
  buttons: QV
}, eq = () => {
  var p;
  const { loc: t } = se(), {
    slides: e,
    autoPlay: r,
    withArrows: n,
    getSwiper: a,
    actions: { setProp: i }
  } = me((g) => ({
    withArrows: g.data.props.withArrows,
    slides: g.data.props.items,
    autoPlay: g.data.props.autoPlay,
    getSwiper: g.data.props.getSwiper
  })), [s, l] = $e(), o = de(), { addItem: u, removeItem: c } = Fy();
  xe(() => {
    let g;
    if (a()) {
      const m = a();
      g = (d) => {
        d === "activeIndexChange" && l(m.realIndex);
      }, m.onAny(g), l(m.realIndex), o.current = m;
    }
    return () => {
      var m;
      o.current && g && ((m = o.current) == null || m.offAny(g));
    };
  }, [a]);
  const f = (p = e[s]) == null ? void 0 : p.id;
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(fe, { gap: 8, children: /* @__PURE__ */ x.jsx(
      Ns,
      {
        className: tv.select,
        onWppChange: (g) => {
          var m;
          (m = o == null ? void 0 : o.current) == null || m.slideToLoop(e.findIndex((d) => d.id === g.detail.value));
        },
        value: f,
        children: e.map((g, m) => /* @__PURE__ */ x.jsx(ra, { value: g.id, children: /* @__PURE__ */ x.jsxs(_e, { slot: "label", children: [
          " ",
          `Slide ${m + 1}`
        ] }) }, g.id))
      }
    ) }),
    /* @__PURE__ */ x.jsxs(fe, { gap: 8, className: tv.buttons, children: [
      /* @__PURE__ */ x.jsxs(Dr, { onClick: u, children: [
        t("addSlide"),
        /* @__PURE__ */ x.jsx(Cb, { slot: "icon-start" })
      ] }),
      /* @__PURE__ */ x.jsxs(Dr, { disabled: e.length === 1, onClick: c(f), children: [
        t("deleteSlide"),
        /* @__PURE__ */ x.jsx(bu, { slot: "icon-start" })
      ] })
    ] }),
    /* @__PURE__ */ x.jsx(fe, { gap: 16, children: /* @__PURE__ */ x.jsxs(fe, { direction: "column", children: [
      /* @__PURE__ */ x.jsx(
        ii,
        {
          required: !0,
          checked: r,
          labelConfig: { text: t("autoPlay") },
          name: "options",
          onWppChange: ({ detail: { checked: g } }) => i((m) => {
            m.autoPlay = g;
          })
        }
      ),
      r && /* @__PURE__ */ x.jsx(Re, { type: "text", label: t("duration"), propKey: "autoPlayDuration" })
    ] }) }),
    /* @__PURE__ */ x.jsx(
      ii,
      {
        required: !0,
        checked: n,
        labelConfig: { text: t("withArrows") },
        name: "options",
        onWppChange: ({ detail: { checked: g } }) => i((m) => {
          m.withArrows = g;
        })
      }
    )
  ] });
}, tq = () => {
  const { loc: t } = se();
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(_e, { type: "xl-heading", children: t("carouselSettings") }),
    /* @__PURE__ */ x.jsxs(fe, { direction: "column", gap: 16, className: Bl.section, children: [
      /* @__PURE__ */ x.jsx(_e, { type: "m-strong", children: t("slides") }),
      /* @__PURE__ */ x.jsx(eq, {})
    ] }),
    /* @__PURE__ */ x.jsx(We, {}),
    /* @__PURE__ */ x.jsxs(fe, { direction: "column", gap: 16, className: Bl.section, children: [
      /* @__PURE__ */ x.jsx(_e, { type: "m-strong", children: t("layout") }),
      /* @__PURE__ */ x.jsx(Ec, { withTitle: !1, withPaddings: !1 }),
      /* @__PURE__ */ x.jsx(qt, { withPaddings: !1 })
    ] }),
    /* @__PURE__ */ x.jsx(We, {}),
    /* @__PURE__ */ x.jsxs(fe, { direction: "column", gap: 16, className: Bl.section, children: [
      /* @__PURE__ */ x.jsx(_e, { type: "m-strong", children: t("appearance") }),
      /* @__PURE__ */ x.jsx(MV, {}),
      /* @__PURE__ */ x.jsx(Dc, { withImage: !0, backgroundSelector: (e) => e == null ? void 0 : e.background, withPaddings: !1 })
    ] })
  ] });
}, rq = "_controls_1k4qp_1", nq = "_control_1k4qp_1", aq = "_activeControl_1k4qp_17", iq = "_controlDark_1k4qp_21", sq = "_activeControlDark_1k4qp_25", Na = {
  controls: rq,
  control: nq,
  activeControl: aq,
  controlDark: iq,
  activeControlDark: sq
}, oq = () => {
  const { enabled: t } = Le((l) => ({
    enabled: l.options.enabled
  })), { items: e, appearance: r } = me((l) => ({
    items: l.data.props.items,
    appearance: l.data.props.appearance
  })), { addItem: n } = Fy(), [a, i] = $e(), s = vf();
  return xe(() => {
    s.onAny((l) => {
      l === "activeIndexChange" && i(s.realIndex);
    });
  }), /* @__PURE__ */ x.jsxs(fe, { className: Na.controls, gap: 8, align: "center", children: [
    e.map((l, o) => /* @__PURE__ */ x.jsx(
      "div",
      {
        className: ke(
          Na.control,
          {
            ...a === o && {
              [Na.activeControl]: r === cn.light,
              [Na.activeControlDark]: r === cn.dark
            }
          },
          { [Na.controlDark]: r === cn.dark }
        ),
        onClick: () => s.slideToLoop(o)
      },
      l.id
    )),
    t && /* @__PURE__ */ x.jsx(cv, { onClick: n, size: "s" })
  ] });
};
PV();
const lq = ({ children: t, ...e }) => {
  const {
    connectors: { connect: r },
    setProp: n
  } = me(), { enabled: a } = Le((s) => ({
    enabled: s.options.enabled
  })), i = Ze(gr(e.margin));
  return a ? /* @__PURE__ */ x.jsx(
    Ri,
    {
      ref: (s) => {
        s != null && s.resizable && r(s == null ? void 0 : s.resizable);
      },
      onResize: ({ height: s, width: l }) => {
        n((o) => {
          o.width = l, o.height = s;
        }, 500);
      },
      width: e.width,
      height: e.height,
      style: {
        margin: i,
        padding: Ze(e.padding)
      },
      children: t
    }
  ) : /* @__PURE__ */ x.jsx(
    "div",
    {
      style: {
        padding: Ze(e.padding),
        margin: i,
        width: pr(e.width),
        height: pr(e.height)
      },
      children: t
    }
  );
}, mf = ({
  items: t,
  withArrows: e,
  selected: r,
  autoPlay: n,
  background: a,
  appearance: i,
  autoPlayDuration: s,
  ...l
}) => {
  var c, f, p;
  const { imageUrl: o } = uo((p = (f = (c = a == null ? void 0 : a.image) == null ? void 0 : c.image) == null ? void 0 : f.imageMetaData) == null ? void 0 : p.assetId), {
    actions: { setProp: u }
  } = me();
  return /* @__PURE__ */ x.jsx(lq, { ...l, children: /* @__PURE__ */ x.jsx("div", { className: rs.container, style: { ...$m({ backgroundData: a, imageUrl: o }) }, children: /* @__PURE__ */ x.jsxs(
    $y,
    {
      allowTouchMove: !1,
      className: rs.carousel,
      spaceBetween: 20,
      loop: !0,
      autoplay: n ? { delay: s } : !1,
      slidesPerView: 1,
      onInit: (g) => {
        u((m) => {
          m.getSwiper = () => g;
        });
      },
      children: [
        t.map((g) => /* @__PURE__ */ x.jsx(My, { children: /* @__PURE__ */ x.jsx(
          Wr,
          {
            className: rs.containerLight,
            selectedClassName: rs.selectedContainerLight,
            id: g.id,
            is: fr,
            canvas: !0
          }
        ) }, g.id)),
        /* @__PURE__ */ x.jsx(oq, {}),
        /* @__PURE__ */ x.jsx(zV, {}),
        /* @__PURE__ */ x.jsx(WV, {})
      ]
    }
  ) }) });
};
mf.craft = {
  displayName: "carousel",
  props: {
    background: {
      type: "color",
      color: ao,
      image: vc,
      gradient: io
    },
    width: "100%",
    height: "100px",
    margin: [0, 0, dr, 0],
    padding: [0, 0, 0, 0],
    items: [$i(1)],
    withArrows: !0,
    autoPlay: !1,
    autoPlayDuration: 1500,
    appearance: cn.light,
    slidesPerView: 1,
    getSwiper: () => null
  },
  rules: {
    canDrop: (t) => t.id === Yy
  },
  related: {
    toolbar: tq
  },
  custom: {
    toolbox: { icon: /* @__PURE__ */ x.jsx(Db, { width: 30, color: "black" }), dataTestId: "carousel-thumbnail" }
  }
};
const Mq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Accordion: tf,
  Button: Oc,
  Card: _c,
  Carousel: mf,
  EmbedCode: uf,
  Iframe: cf,
  Image: Ac,
  Resizable: Tc,
  RichText: Zc,
  Segments: ef,
  Tabs: Qc,
  ThreeColumn: rf,
  TwoColumn: nf,
  Video: lf
}, Symbol.toStringTag, { value: "Module" })), uq = {
  noScale: "No scale",
  fill: "Fill",
  fit: "Fit",
  tile: "Tile",
  leftTop: "Left Top",
  centerTop: "Center Top",
  rightTop: "Right Top",
  leftCenter: "Left Center",
  centerCenter: "Center Center",
  rightCenter: "Right Center",
  leftBottom: "Left Bottom",
  centerBottom: "Center Bottom",
  rightBottom: "Right Bottom",
  videoSettings: "Video settings",
  video: "Video",
  iframe: "Iframe",
  embedCode: "Embed code",
  carousel: "Carousel",
  platform: "Platform",
  youtube: "YouTube",
  vimeo: "Vimeo",
  videoId: "Video ID or URL",
  popover: "Play in popover",
  videoCover: "Cover",
  twoColumn: "2 column",
  twoColumn37: "2 column, 3/7",
  size: "Size",
  expanded: "Expanded",
  withDivider: "With divider",
  title: "Corners radius",
  numberedList: "Numbered list",
  bulletedList: "Bulleted list",
  leftAlign: "Left align",
  centerAlign: "Center align",
  rightAlign: "Right align",
  justify: "Justify",
  weight: "Weight",
  insertLink: "Insert link",
  removeLink: "Remove link",
  textColor: "Text color",
  authUser: "Authorized user",
  default: "Default",
  cancel: "Cancel",
  insertButton: "Insert link",
  background: "Background",
  padding: "Padding",
  top: "Top",
  right: "Right",
  bottom: "Bottom",
  left: "Left",
  margin: "Margin",
  dimensions: "Dimensions",
  width: "Width",
  height: "Height",
  alignment: "Alignment",
  gap: "Gap",
  flexDirection: "Flex Direction",
  alignItems: "Align Items",
  justifyContent: "Justify Content",
  linkUrl: "Link URL",
  original: "Original",
  uploadFormatError: "The image must be in the following formats: .jpeg, .jpg, .png, .webp",
  general: "Something went wrong, please try again.",
  scale: "Scale",
  position: "Position",
  borderRadius: "Corners radius",
  reset: "Reset",
  color: "Color",
  gradient: "Gradient",
  header: "Header",
  url: "URL",
  variant: "Variant",
  preview: "Preview",
  save: "Save",
  clickToEdit: "Click on a component to start editing.",
  addLinkDialogTitle: "Enter link",
  addLinkDialogLink: "Link url",
  addLinkDialogNewTab: "Open in new tab",
  fileUploadLabel: "Choose a file",
  fileUploadText: "to upload or drag it here",
  fileUploadInfo: "Only {{accept}} file at {{size}} MB or less",
  uploadSizeError: "File size exceeds {{fileSize}} MB",
  generalError: "Something went wrong, please try again.",
  cardHeader: "Header",
  buttonText: "Text",
  buttonUrl: "URL",
  buttonNewTab: "Open in a new tab",
  buttonVariant: "Variant",
  buttonSize: "Size",
  button: "Button",
  card: "Card",
  row: "Row",
  column: "Column",
  start: "Start",
  center: "Center",
  end: "End",
  spaceBetween: "Space between",
  spaceAround: "Space around",
  container: "Container",
  image: "Image",
  resizable: "Resizable",
  richText: "Rich text",
  accordion: "Accordion",
  segments: "Segments",
  tabs: "Tabs",
  text: "Text",
  threeColumns: "Three Columns",
  twoColumns: "Two Columns",
  typography: "Typography",
  option: "Optional",
  brandPalette: "Brand",
  categoricalPalette: "Categorical palette",
  sequentialPalette: "Sequential palette",
  opacity: "Opacity",
  optional: "optional",
  delete: "Delete",
  move: "Move",
  selectParent: "Select parent",
  copyWidgetTitle: "Component contents is copied to clipboard",
  copyWidgetMessage: "Paste the contents of the clipboard into the parent component using {{pasteHotkey}}.",
  insertingContent: "Insertion process from clipboard has started. Please wait while we retrieve and process the data.",
  insertingContentDone: "Insertion from clipboard is complete. The data has been successfully inserted.",
  carouselSettings: "Settings",
  addSlide: "Add slide",
  deleteSlide: "Delete slide",
  autoPlay: "Auto-play",
  withArrows: "With navigation arrows",
  slides: "Slides",
  layout: "Layout",
  appearance: "Appearance",
  light: "Light",
  dark: "Dark",
  duration: "Duration, ms",
  sidePerView: "Number of slides displayed at once",
  copy: "Copy",
  clickable: "Clickable block",
  wrapText: "Wrap text",
  templates: "Templates",
  addToPage: "Add to page",
  fixedSize: "Fixed size",
  emptyTemplatesTooltip: "There are no templates added yet."
}, Fq = (t) => {
  const { children: e, locales: r = uq, dependencies: n, readOnly: a, ...i } = t;
  return xe(() => {
    const s = (l) => {
      const { type: o, payload: u } = l.data;
      o === "openApp" && window.openApp(u.appId, void 0, u.query);
    };
    return window.addEventListener("message", s), () => {
      window.removeEventListener("message", s);
    };
  }, []), /* @__PURE__ */ x.jsx(Vb, { locales: r, dependencies: n, readOnly: a, children: /* @__PURE__ */ x.jsx(Ky, { ...i, children: e }) });
}, cq = {
  Container: fr,
  Text: co,
  Typography: Pc
}, fq = {
  RichText: Zc,
  Resizable: Tc,
  Video: lf,
  Carousel: mf,
  ImageWidget: Ac,
  Tabs: Qc,
  Segments: ef,
  Accordion: tf,
  TwoColumn: nf,
  ThreeColumn: rf,
  Card: _c,
  Button: Oc,
  EmbedCode: uf,
  Iframe: cf
}, Iq = {
  ...cq,
  ...fq
};
export {
  Km as AlignmentSettings,
  WI as BRIGHTNESS_DEGREE,
  zI as B_DEGREE,
  f5 as BackgroundImagePropertiesSettings,
  Dc as BackgroundSettings,
  Ua as BackgroundTypeSegment,
  Xl as ColorInput,
  J5 as ColorSettings,
  dr as DEFAULT_DISTANCE,
  vv as DependencyContext,
  Vb as DependencyProvider,
  Ec as DimensionsSettings,
  Qt as DropDownItem,
  Oq as EDITOR_INDICATOR_OPTIONS,
  so as EditorContext,
  NI as G_DEGREE,
  Bq as HeaderContainer,
  Rq as HeaderPreviewButton,
  Tq as HeaderUndoRedo,
  Cc as ImageFileSettings,
  u5 as ImageOriginalSize,
  k5 as ImageUrlSettings,
  Mm as LAYOUT_CHANGE_EVENT,
  _q as Layout,
  f4 as LinkSettings,
  UI as MATCH_REGEX,
  qt as MarginSettings,
  Pq as Node,
  oo as NodeContext,
  Xr as PaddingSettings,
  Fq as PageBuilder,
  kI as R_DEGREE,
  Ri as ResizableWrapper,
  qb as Toolbar,
  mv as ToolbarDropdown,
  Re as ToolbarItem,
  at as ToolbarSection,
  Rm as ToolbarTextInput,
  Aq as Toolbox,
  HI as VALIDATE_REGEX,
  Ze as arrayToPixelsString,
  pr as convertToNumber,
  Ym as defaultAlignmentProps,
  vc as defaultBackgroundImageValues,
  ao as defaultColorValue,
  io as defaultGradientValue,
  c4 as defaultLink,
  Iq as defaultWidgets,
  Im as excludeFalsy,
  cq as functionalWidgets,
  $m as getBackgroundStyles,
  na as getElementDimensions,
  Ds as getLinearGradientCss,
  fp as getPxValue,
  ij as hashStringToKey,
  qI as hexToRgb,
  aj as isJSON,
  nj as isMacOS,
  Lr as isPercentage,
  tj as join,
  KI as lightOrDarkColor,
  hc as mapColor,
  gc as mapGradient,
  Ss as percentToPx,
  Os as pxToPercent,
  GI as rgbaToRgb,
  rj as splitArray,
  gr as useAdjustedMargin,
  ej as useAdjustedPadding,
  JI as useBackgroundImagePositionOptions,
  ZI as useBackgroundImageScaleOptions,
  se as useDeps,
  Fm as useDragging,
  uo as useImageAsset,
  mc as useNotifyLayoutChange,
  fq as userWidgets,
  Mq as widgets
};
//# sourceMappingURL=content-builder.mjs.map
